var Hr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ks(i) {
  return i && i.__esModule && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i;
}
function jc(i) {
  if (i.__esModule) return i;
  var e = i.default;
  if (typeof e == "function") {
    var t = function s() {
      return this instanceof s ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(i).forEach(function(s) {
    var r = Object.getOwnPropertyDescriptor(i, s);
    Object.defineProperty(t, s, r.get ? r : {
      enumerable: !0,
      get: function() {
        return i[s];
      }
    });
  }), t;
}
var ws;
typeof window < "u" ? ws = window : typeof Hr < "u" ? ws = Hr : typeof self < "u" ? ws = self : ws = {};
var yn = ws;
const S = /* @__PURE__ */ Ks(yn), Eg = {}, Cg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Eg
}, Symbol.toStringTag, { value: "Module" })), Ag = /* @__PURE__ */ jc(Cg);
var cl = typeof Hr < "u" ? Hr : typeof window < "u" ? window : {}, Dg = Ag, Is;
typeof document < "u" ? Is = document : (Is = cl["__GLOBAL_DOCUMENT_CACHE@4"], Is || (Is = cl["__GLOBAL_DOCUMENT_CACHE@4"] = Dg));
var Hc = Is;
const U = /* @__PURE__ */ Ks(Hc);
var co = { exports: {} };
function ye() {
  return ye = Object.assign ? Object.assign.bind() : function(i) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && (i[s] = t[s]);
    }
    return i;
  }, ye.apply(this, arguments);
}
const wg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ye
}, Symbol.toStringTag, { value: "Module" })), Ig = /* @__PURE__ */ jc(wg);
var kg = Og, Pg = Object.prototype.toString;
function Og(i) {
  if (!i)
    return !1;
  var e = Pg.call(i);
  return e === "[object Function]" || typeof i == "function" && e !== "[object RegExp]" || typeof window < "u" && // IE8 and below
  (i === window.setTimeout || i === window.alert || i === window.confirm || i === window.prompt);
}
function Lg(i, e) {
  var t = typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
  if (t) return (t = t.call(i)).next.bind(t);
  if (Array.isArray(i) || (t = Rg(i)) || e) {
    t && (i = t);
    var s = 0;
    return function() {
      return s >= i.length ? { done: !0 } : { done: !1, value: i[s++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Rg(i, e) {
  if (i) {
    if (typeof i == "string") return dl(i, e);
    var t = Object.prototype.toString.call(i).slice(8, -1);
    if (t === "Object" && i.constructor && (t = i.constructor.name), t === "Map" || t === "Set") return Array.from(i);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return dl(i, e);
  }
}
function dl(i, e) {
  (e == null || e > i.length) && (e = i.length);
  for (var t = 0, s = new Array(e); t < e; t++)
    s[t] = i[t];
  return s;
}
var Ng = /* @__PURE__ */ function() {
  function i() {
    this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
  }
  var e = i.prototype;
  return e.getIsEnabled = function() {
    return this.enabled_;
  }, e.enable = function() {
    this.enabled_ = !0;
  }, e.disable = function() {
    this.enabled_ = !1;
  }, e.reset = function() {
    this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), this.enabled_ = !1;
  }, e.addInterceptor = function(s, r) {
    this.typeToInterceptorsMap_.has(s) || this.typeToInterceptorsMap_.set(s, /* @__PURE__ */ new Set());
    var n = this.typeToInterceptorsMap_.get(s);
    return n.has(r) ? !1 : (n.add(r), !0);
  }, e.removeInterceptor = function(s, r) {
    var n = this.typeToInterceptorsMap_.get(s);
    return n && n.has(r) ? (n.delete(r), !0) : !1;
  }, e.clearInterceptorsByType = function(s) {
    var r = this.typeToInterceptorsMap_.get(s);
    return r ? (this.typeToInterceptorsMap_.delete(s), this.typeToInterceptorsMap_.set(s, /* @__PURE__ */ new Set()), !0) : !1;
  }, e.clear = function() {
    return this.typeToInterceptorsMap_.size ? (this.typeToInterceptorsMap_ = /* @__PURE__ */ new Map(), !0) : !1;
  }, e.getForType = function(s) {
    return this.typeToInterceptorsMap_.get(s) || /* @__PURE__ */ new Set();
  }, e.execute = function(s, r) {
    for (var n = this.getForType(s), a = Lg(n), o; !(o = a()).done; ) {
      var l = o.value;
      try {
        r = l(r);
      } catch {
      }
    }
    return r;
  }, i;
}(), Mg = Ng, Bg = /* @__PURE__ */ function() {
  function i() {
    this.maxAttempts_ = 1, this.delayFactor_ = 0.1, this.fuzzFactor_ = 0.1, this.initialDelay_ = 1e3, this.enabled_ = !1;
  }
  var e = i.prototype;
  return e.getIsEnabled = function() {
    return this.enabled_;
  }, e.enable = function() {
    this.enabled_ = !0;
  }, e.disable = function() {
    this.enabled_ = !1;
  }, e.reset = function() {
    this.maxAttempts_ = 1, this.delayFactor_ = 0.1, this.fuzzFactor_ = 0.1, this.initialDelay_ = 1e3, this.enabled_ = !1;
  }, e.getMaxAttempts = function() {
    return this.maxAttempts_;
  }, e.setMaxAttempts = function(s) {
    this.maxAttempts_ = s;
  }, e.getDelayFactor = function() {
    return this.delayFactor_;
  }, e.setDelayFactor = function(s) {
    this.delayFactor_ = s;
  }, e.getFuzzFactor = function() {
    return this.fuzzFactor_;
  }, e.setFuzzFactor = function(s) {
    this.fuzzFactor_ = s;
  }, e.getInitialDelay = function() {
    return this.initialDelay_;
  }, e.setInitialDelay = function(s) {
    this.initialDelay_ = s;
  }, e.createRetry = function(s) {
    var r = s === void 0 ? {} : s, n = r.maxAttempts, a = r.delayFactor, o = r.fuzzFactor, l = r.initialDelay;
    return new Fg({
      maxAttempts: n || this.maxAttempts_,
      delayFactor: a || this.delayFactor_,
      fuzzFactor: o || this.fuzzFactor_,
      initialDelay: l || this.initialDelay_
    });
  }, i;
}(), Fg = /* @__PURE__ */ function() {
  function i(t) {
    this.maxAttempts_ = t.maxAttempts, this.delayFactor_ = t.delayFactor, this.fuzzFactor_ = t.fuzzFactor, this.currentDelay_ = t.initialDelay, this.currentAttempt_ = 1;
  }
  var e = i.prototype;
  return e.moveToNextAttempt = function() {
    this.currentAttempt_++;
    var s = this.currentDelay_ * this.delayFactor_;
    this.currentDelay_ = this.currentDelay_ + s;
  }, e.shouldRetry = function() {
    return this.currentAttempt_ < this.maxAttempts_;
  }, e.getCurrentDelay = function() {
    return this.currentDelay_;
  }, e.getCurrentMinPossibleDelay = function() {
    return (1 - this.fuzzFactor_) * this.currentDelay_;
  }, e.getCurrentMaxPossibleDelay = function() {
    return (1 + this.fuzzFactor_) * this.currentDelay_;
  }, e.getCurrentFuzzedDelay = function() {
    var s = this.getCurrentMinPossibleDelay(), r = this.getCurrentMaxPossibleDelay();
    return s + Math.random() * (r - s);
  }, i;
}(), Ug = Bg, $g = yn, qg = function(e, t) {
  return t === void 0 && (t = !1), function(s, r, n) {
    if (s) {
      e(s);
      return;
    }
    if (r.statusCode >= 400 && r.statusCode <= 599) {
      var a = n;
      if (t)
        if ($g.TextDecoder) {
          var o = jg(r.headers && r.headers["content-type"]);
          try {
            a = new TextDecoder(o).decode(n);
          } catch {
          }
        } else
          a = String.fromCharCode.apply(null, new Uint8Array(n));
      e({
        cause: a
      });
      return;
    }
    e(null, n);
  };
};
function jg(i) {
  return i === void 0 && (i = ""), i.toLowerCase().split(";").reduce(function(e, t) {
    var s = t.split("="), r = s[0], n = s[1];
    return r.trim() === "charset" ? n.trim() : e;
  }, "utf-8");
}
var Hg = qg, Vc = yn, Vg = Ig, zg = kg, zc = Mg, Gg = Ug;
xe.httpHandler = Hg;
xe.requestInterceptorsStorage = new zc();
xe.responseInterceptorsStorage = new zc();
xe.retryManager = new Gg();
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */
var Wg = function(e) {
  var t = {};
  return e && e.trim().split(`
`).forEach(function(s) {
    var r = s.indexOf(":"), n = s.slice(0, r).trim().toLowerCase(), a = s.slice(r + 1).trim();
    typeof t[n] > "u" ? t[n] = a : Array.isArray(t[n]) ? t[n].push(a) : t[n] = [t[n], a];
  }), t;
};
co.exports = xe;
co.exports.default = xe;
xe.XMLHttpRequest = Vc.XMLHttpRequest || Qg;
xe.XDomainRequest = "withCredentials" in new xe.XMLHttpRequest() ? xe.XMLHttpRequest : Vc.XDomainRequest;
Xg(["get", "put", "post", "patch", "head", "delete"], function(i) {
  xe[i === "delete" ? "del" : i] = function(e, t, s) {
    return t = Gc(e, t, s), t.method = i.toUpperCase(), ho(t);
  };
});
function Xg(i, e) {
  for (var t = 0; t < i.length; t++)
    e(i[t]);
}
function Kg(i) {
  for (var e in i)
    if (i.hasOwnProperty(e)) return !1;
  return !0;
}
function Gc(i, e, t) {
  var s = i;
  return zg(e) ? (t = e, typeof i == "string" && (s = {
    uri: i
  })) : s = Vg({}, e, {
    uri: i
  }), s.callback = t, s;
}
function xe(i, e, t) {
  return e = Gc(i, e, t), ho(e);
}
function ho(i) {
  if (typeof i.callback > "u")
    throw new Error("callback argument missing");
  if (i.requestType && xe.requestInterceptorsStorage.getIsEnabled()) {
    var e = {
      uri: i.uri || i.url,
      headers: i.headers || {},
      body: i.body,
      metadata: i.metadata || {},
      retry: i.retry,
      timeout: i.timeout
    }, t = xe.requestInterceptorsStorage.execute(i.requestType, e);
    i.uri = t.uri, i.headers = t.headers, i.body = t.body, i.metadata = t.metadata, i.retry = t.retry, i.timeout = t.timeout;
  }
  var s = !1, r = function(I, B, H) {
    s || (s = !0, i.callback(I, B, H));
  };
  function n() {
    h.readyState === 4 && !xe.responseInterceptorsStorage.getIsEnabled() && setTimeout(l, 0);
  }
  function a() {
    var R = void 0;
    if (h.response ? R = h.response : R = h.responseText || Yg(h), w)
      try {
        R = JSON.parse(R);
      } catch {
      }
    return R;
  }
  function o(R) {
    if (clearTimeout(O), clearTimeout(i.retryTimeout), R instanceof Error || (R = new Error("" + (R || "Unknown XMLHttpRequest Error"))), R.statusCode = 0, !_ && xe.retryManager.getIsEnabled() && i.retry && i.retry.shouldRetry()) {
      i.retryTimeout = setTimeout(function() {
        i.retry.moveToNextAttempt(), i.xhr = h, ho(i);
      }, i.retry.getCurrentFuzzedDelay());
      return;
    }
    if (i.requestType && xe.responseInterceptorsStorage.getIsEnabled()) {
      var I = {
        headers: P.headers || {},
        body: P.body,
        responseUrl: h.responseURL,
        responseType: h.responseType
      }, B = xe.responseInterceptorsStorage.execute(i.requestType, I);
      P.body = B.body, P.headers = B.headers;
    }
    return r(R, P);
  }
  function l() {
    if (!_) {
      var R;
      clearTimeout(O), clearTimeout(i.retryTimeout), i.useXDR && h.status === void 0 ? R = 200 : R = h.status === 1223 ? 204 : h.status;
      var I = P, B = null;
      if (R !== 0 ? (I = {
        body: a(),
        statusCode: R,
        method: C,
        headers: {},
        url: v,
        rawRequest: h
      }, h.getAllResponseHeaders && (I.headers = Wg(h.getAllResponseHeaders()))) : B = new Error("Internal XMLHttpRequest Error"), i.requestType && xe.responseInterceptorsStorage.getIsEnabled()) {
        var H = {
          headers: I.headers || {},
          body: I.body,
          responseUrl: h.responseURL,
          responseType: h.responseType
        }, $ = xe.responseInterceptorsStorage.execute(i.requestType, H);
        I.body = $.body, I.headers = $.headers;
      }
      return r(B, I, I.body);
    }
  }
  var h = i.xhr || null;
  h || (i.cors || i.useXDR ? h = new xe.XDomainRequest() : h = new xe.XMLHttpRequest());
  var m, _, v = h.url = i.uri || i.url, C = h.method = i.method || "GET", A = i.body || i.data, y = h.headers = i.headers || {}, D = !!i.sync, w = !1, O, P = {
    body: void 0,
    headers: {},
    statusCode: 0,
    method: C,
    url: v,
    rawRequest: h
  };
  if ("json" in i && i.json !== !1 && (w = !0, y.accept || y.Accept || (y.Accept = "application/json"), C !== "GET" && C !== "HEAD" && (y["content-type"] || y["Content-Type"] || (y["Content-Type"] = "application/json"), A = JSON.stringify(i.json === !0 ? A : i.json))), h.onreadystatechange = n, h.onload = l, h.onerror = o, h.onprogress = function() {
  }, h.onabort = function() {
    _ = !0, clearTimeout(i.retryTimeout);
  }, h.ontimeout = o, h.open(C, v, !D, i.username, i.password), D || (h.withCredentials = !!i.withCredentials), !D && i.timeout > 0 && (O = setTimeout(function() {
    if (!_) {
      _ = !0, h.abort("timeout");
      var R = new Error("XMLHttpRequest timeout");
      R.code = "ETIMEDOUT", o(R);
    }
  }, i.timeout)), h.setRequestHeader)
    for (m in y)
      y.hasOwnProperty(m) && h.setRequestHeader(m, y[m]);
  else if (i.headers && !Kg(i.headers))
    throw new Error("Headers cannot be set on an XDomainRequest object");
  return "responseType" in i && (h.responseType = i.responseType), "beforeSend" in i && typeof i.beforeSend == "function" && i.beforeSend(h), h.send(A || null), h;
}
function Yg(i) {
  try {
    if (i.responseType === "document")
      return i.responseXML;
    var e = i.responseXML && i.responseXML.documentElement.nodeName === "parsererror";
    if (i.responseType === "" && !e)
      return i.responseXML;
  } catch {
  }
  return null;
}
function Qg() {
}
var Jg = co.exports;
const Wc = /* @__PURE__ */ Ks(Jg);
var Xc = { exports: {} }, hl = Hc, fo = Object.create || /* @__PURE__ */ function() {
  function i() {
  }
  return function(e) {
    if (arguments.length !== 1)
      throw new Error("Object.create shim only accepts one parameter.");
    return i.prototype = e, new i();
  };
}();
function Ze(i, e) {
  this.name = "ParsingError", this.code = i.code, this.message = e || i.message;
}
Ze.prototype = fo(Error.prototype);
Ze.prototype.constructor = Ze;
Ze.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};
function po(i) {
  function e(s, r, n, a) {
    return (s | 0) * 3600 + (r | 0) * 60 + (n | 0) + (a | 0) / 1e3;
  }
  var t = i.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
  return t ? t[3] ? e(t[1], t[2], t[3].replace(":", ""), t[4]) : t[1] > 59 ? e(t[1], t[2], 0, t[4]) : e(0, t[1], t[2], t[4]) : null;
}
function Rs() {
  this.values = fo(null);
}
Rs.prototype = {
  // Only accept the first assignment to any key.
  set: function(i, e) {
    !this.get(i) && e !== "" && (this.values[i] = e);
  },
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get: function(i, e, t) {
    return t ? this.has(i) ? this.values[i] : e[t] : this.has(i) ? this.values[i] : e;
  },
  // Check whether we have a value for a key.
  has: function(i) {
    return i in this.values;
  },
  // Accept a setting if its one of the given alternatives.
  alt: function(i, e, t) {
    for (var s = 0; s < t.length; ++s)
      if (e === t[s]) {
        this.set(i, e);
        break;
      }
  },
  // Accept a setting if its a valid (signed) integer.
  integer: function(i, e) {
    /^-?\d+$/.test(e) && this.set(i, parseInt(e, 10));
  },
  // Accept a setting if its a valid percentage.
  percent: function(i, e) {
    return e.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (e = parseFloat(e), e >= 0 && e <= 100) ? (this.set(i, e), !0) : !1;
  }
};
function ks(i, e, t, s) {
  var r = s ? i.split(s) : [i];
  for (var n in r)
    if (typeof r[n] == "string") {
      var a = r[n].split(t);
      if (a.length === 2) {
        var o = a[0].trim(), l = a[1].trim();
        e(o, l);
      }
    }
}
function Zg(i, e, t) {
  var s = i;
  function r() {
    var o = po(i);
    if (o === null)
      throw new Ze(
        Ze.Errors.BadTimeStamp,
        "Malformed timestamp: " + s
      );
    return i = i.replace(/^[^\sa-zA-Z-]+/, ""), o;
  }
  function n(o, l) {
    var h = new Rs();
    ks(o, function(m, _) {
      switch (m) {
        case "region":
          for (var v = t.length - 1; v >= 0; v--)
            if (t[v].id === _) {
              h.set(m, t[v].region);
              break;
            }
          break;
        case "vertical":
          h.alt(m, _, ["rl", "lr"]);
          break;
        case "line":
          var C = _.split(","), A = C[0];
          h.integer(m, A), h.percent(m, A) && h.set("snapToLines", !1), h.alt(m, A, ["auto"]), C.length === 2 && h.alt("lineAlign", C[1], ["start", "center", "end"]);
          break;
        case "position":
          C = _.split(","), h.percent(m, C[0]), C.length === 2 && h.alt("positionAlign", C[1], ["start", "center", "end"]);
          break;
        case "size":
          h.percent(m, _);
          break;
        case "align":
          h.alt(m, _, ["start", "center", "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = h.get("region", null), l.vertical = h.get("vertical", "");
    try {
      l.line = h.get("line", "auto");
    } catch {
    }
    l.lineAlign = h.get("lineAlign", "start"), l.snapToLines = h.get("snapToLines", !0), l.size = h.get("size", 100);
    try {
      l.align = h.get("align", "center");
    } catch {
      l.align = h.get("align", "middle");
    }
    try {
      l.position = h.get("position", "auto");
    } catch {
      l.position = h.get("position", {
        start: 0,
        left: 0,
        center: 50,
        middle: 50,
        end: 100,
        right: 100
      }, l.align);
    }
    l.positionAlign = h.get("positionAlign", {
      start: "start",
      left: "start",
      center: "center",
      middle: "center",
      end: "end",
      right: "end"
    }, l.align);
  }
  function a() {
    i = i.replace(/^\s+/, "");
  }
  if (a(), e.startTime = r(), a(), i.substr(0, 3) !== "-->")
    throw new Ze(
      Ze.Errors.BadTimeStamp,
      "Malformed time stamp (time stamps must be separated by '-->'): " + s
    );
  i = i.substr(3), a(), e.endTime = r(), a(), n(i, e);
}
var fa = hl.createElement && hl.createElement("textarea"), e0 = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
}, fl = {
  white: "rgba(255,255,255,1)",
  lime: "rgba(0,255,0,1)",
  cyan: "rgba(0,255,255,1)",
  red: "rgba(255,0,0,1)",
  yellow: "rgba(255,255,0,1)",
  magenta: "rgba(255,0,255,1)",
  blue: "rgba(0,0,255,1)",
  black: "rgba(0,0,0,1)"
}, t0 = {
  v: "title",
  lang: "lang"
}, pl = {
  rt: "ruby"
};
function Kc(i, e) {
  function t() {
    if (!e)
      return null;
    function A(D) {
      return e = e.substr(D.length), D;
    }
    var y = e.match(/^([^<]*)(<[^>]*>?)?/);
    return A(y[1] ? y[1] : y[2]);
  }
  function s(A) {
    return fa.innerHTML = A, A = fa.textContent, fa.textContent = "", A;
  }
  function r(A, y) {
    return !pl[y.localName] || pl[y.localName] === A.localName;
  }
  function n(A, y) {
    var D = e0[A];
    if (!D)
      return null;
    var w = i.document.createElement(D), O = t0[A];
    return O && y && (w[O] = y.trim()), w;
  }
  for (var a = i.document.createElement("div"), o = a, l, h = []; (l = t()) !== null; ) {
    if (l[0] === "<") {
      if (l[1] === "/") {
        h.length && h[h.length - 1] === l.substr(2).replace(">", "") && (h.pop(), o = o.parentNode);
        continue;
      }
      var m = po(l.substr(1, l.length - 2)), _;
      if (m) {
        _ = i.document.createProcessingInstruction("timestamp", m), o.appendChild(_);
        continue;
      }
      var v = l.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      if (!v || (_ = n(v[1], v[3]), !_) || !r(o, _))
        continue;
      if (v[2]) {
        var C = v[2].split(".");
        C.forEach(function(A) {
          var y = /^bg_/.test(A), D = y ? A.slice(3) : A;
          if (fl.hasOwnProperty(D)) {
            var w = y ? "background-color" : "color", O = fl[D];
            _.style[w] = O;
          }
        }), _.className = C.join(" ");
      }
      h.push(v[1]), o.appendChild(_), o = _;
      continue;
    }
    o.appendChild(i.document.createTextNode(s(l)));
  }
  return a;
}
var ml = [
  [1470, 1470],
  [1472, 1472],
  [1475, 1475],
  [1478, 1478],
  [1488, 1514],
  [1520, 1524],
  [1544, 1544],
  [1547, 1547],
  [1549, 1549],
  [1563, 1563],
  [1566, 1610],
  [1645, 1647],
  [1649, 1749],
  [1765, 1766],
  [1774, 1775],
  [1786, 1805],
  [1807, 1808],
  [1810, 1839],
  [1869, 1957],
  [1969, 1969],
  [1984, 2026],
  [2036, 2037],
  [2042, 2042],
  [2048, 2069],
  [2074, 2074],
  [2084, 2084],
  [2088, 2088],
  [2096, 2110],
  [2112, 2136],
  [2142, 2142],
  [2208, 2208],
  [2210, 2220],
  [8207, 8207],
  [64285, 64285],
  [64287, 64296],
  [64298, 64310],
  [64312, 64316],
  [64318, 64318],
  [64320, 64321],
  [64323, 64324],
  [64326, 64449],
  [64467, 64829],
  [64848, 64911],
  [64914, 64967],
  [65008, 65020],
  [65136, 65140],
  [65142, 65276],
  [67584, 67589],
  [67592, 67592],
  [67594, 67637],
  [67639, 67640],
  [67644, 67644],
  [67647, 67669],
  [67671, 67679],
  [67840, 67867],
  [67872, 67897],
  [67903, 67903],
  [67968, 68023],
  [68030, 68031],
  [68096, 68096],
  [68112, 68115],
  [68117, 68119],
  [68121, 68147],
  [68160, 68167],
  [68176, 68184],
  [68192, 68223],
  [68352, 68405],
  [68416, 68437],
  [68440, 68466],
  [68472, 68479],
  [68608, 68680],
  [126464, 126467],
  [126469, 126495],
  [126497, 126498],
  [126500, 126500],
  [126503, 126503],
  [126505, 126514],
  [126516, 126519],
  [126521, 126521],
  [126523, 126523],
  [126530, 126530],
  [126535, 126535],
  [126537, 126537],
  [126539, 126539],
  [126541, 126543],
  [126545, 126546],
  [126548, 126548],
  [126551, 126551],
  [126553, 126553],
  [126555, 126555],
  [126557, 126557],
  [126559, 126559],
  [126561, 126562],
  [126564, 126564],
  [126567, 126570],
  [126572, 126578],
  [126580, 126583],
  [126585, 126588],
  [126590, 126590],
  [126592, 126601],
  [126603, 126619],
  [126625, 126627],
  [126629, 126633],
  [126635, 126651],
  [1114109, 1114109]
];
function i0(i) {
  for (var e = 0; e < ml.length; e++) {
    var t = ml[e];
    if (i >= t[0] && i <= t[1])
      return !0;
  }
  return !1;
}
function s0(i) {
  var e = [], t = "", s;
  if (!i || !i.childNodes)
    return "ltr";
  function r(o, l) {
    for (var h = l.childNodes.length - 1; h >= 0; h--)
      o.push(l.childNodes[h]);
  }
  function n(o) {
    if (!o || !o.length)
      return null;
    var l = o.pop(), h = l.textContent || l.innerText;
    if (h) {
      var m = h.match(/^.*(\n|\r)/);
      return m ? (o.length = 0, m[0]) : h;
    }
    if (l.tagName === "ruby")
      return n(o);
    if (l.childNodes)
      return r(o, l), n(o);
  }
  for (r(e, i); t = n(e); )
    for (var a = 0; a < t.length; a++)
      if (s = t.charCodeAt(a), i0(s))
        return "rtl";
  return "ltr";
}
function r0(i) {
  if (typeof i.line == "number" && (i.snapToLines || i.line >= 0 && i.line <= 100))
    return i.line;
  if (!i.track || !i.track.textTrackList || !i.track.textTrackList.mediaElement)
    return -1;
  for (var e = i.track, t = e.textTrackList, s = 0, r = 0; r < t.length && t[r] !== e; r++)
    t[r].mode === "showing" && s++;
  return ++s * -1;
}
function Tn() {
}
Tn.prototype.applyStyles = function(i, e) {
  e = e || this.div;
  for (var t in i)
    i.hasOwnProperty(t) && (e.style[t] = i[t]);
};
Tn.prototype.formatStyle = function(i, e) {
  return i === 0 ? 0 : i + e;
};
function Vr(i, e, t) {
  Tn.call(this), this.cue = e, this.cueDiv = Kc(i, e.text);
  var s = {
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "inline",
    writingMode: e.vertical === "" ? "horizontal-tb" : e.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext"
  };
  this.applyStyles(s, this.cueDiv), this.div = i.document.createElement("div"), s = {
    direction: s0(this.cueDiv),
    writingMode: e.vertical === "" ? "horizontal-tb" : e.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext",
    textAlign: e.align === "middle" ? "center" : e.align,
    font: t.font,
    whiteSpace: "pre-line",
    position: "absolute"
  }, this.applyStyles(s), this.div.appendChild(this.cueDiv);
  var r = 0;
  switch (e.positionAlign) {
    case "start":
    case "line-left":
      r = e.position;
      break;
    case "center":
      r = e.position - e.size / 2;
      break;
    case "end":
    case "line-right":
      r = e.position - e.size;
      break;
  }
  e.vertical === "" ? this.applyStyles({
    left: this.formatStyle(r, "%"),
    width: this.formatStyle(e.size, "%")
  }) : this.applyStyles({
    top: this.formatStyle(r, "%"),
    height: this.formatStyle(e.size, "%")
  }), this.move = function(n) {
    this.applyStyles({
      top: this.formatStyle(n.top, "px"),
      bottom: this.formatStyle(n.bottom, "px"),
      left: this.formatStyle(n.left, "px"),
      right: this.formatStyle(n.right, "px"),
      height: this.formatStyle(n.height, "px"),
      width: this.formatStyle(n.width, "px")
    });
  };
}
Vr.prototype = fo(Tn.prototype);
Vr.prototype.constructor = Vr;
function $e(i) {
  var e, t, s, r;
  if (i.div) {
    t = i.div.offsetHeight, s = i.div.offsetWidth, r = i.div.offsetTop;
    var n = (n = i.div.childNodes) && (n = n[0]) && n.getClientRects && n.getClientRects();
    i = i.div.getBoundingClientRect(), e = n ? Math.max(n[0] && n[0].height || 0, i.height / n.length) : 0;
  }
  this.left = i.left, this.right = i.right, this.top = i.top || r, this.height = i.height || t, this.bottom = i.bottom || r + (i.height || t), this.width = i.width || s, this.lineHeight = e !== void 0 ? e : i.lineHeight;
}
$e.prototype.move = function(i, e) {
  switch (e = e !== void 0 ? e : this.lineHeight, i) {
    case "+x":
      this.left += e, this.right += e;
      break;
    case "-x":
      this.left -= e, this.right -= e;
      break;
    case "+y":
      this.top += e, this.bottom += e;
      break;
    case "-y":
      this.top -= e, this.bottom -= e;
      break;
  }
};
$e.prototype.overlaps = function(i) {
  return this.left < i.right && this.right > i.left && this.top < i.bottom && this.bottom > i.top;
};
$e.prototype.overlapsAny = function(i) {
  for (var e = 0; e < i.length; e++)
    if (this.overlaps(i[e]))
      return !0;
  return !1;
};
$e.prototype.within = function(i) {
  return this.top >= i.top && this.bottom <= i.bottom && this.left >= i.left && this.right <= i.right;
};
$e.prototype.overlapsOppositeAxis = function(i, e) {
  switch (e) {
    case "+x":
      return this.left < i.left;
    case "-x":
      return this.right > i.right;
    case "+y":
      return this.top < i.top;
    case "-y":
      return this.bottom > i.bottom;
  }
};
$e.prototype.intersectPercentage = function(i) {
  var e = Math.max(0, Math.min(this.right, i.right) - Math.max(this.left, i.left)), t = Math.max(0, Math.min(this.bottom, i.bottom) - Math.max(this.top, i.top)), s = e * t;
  return s / (this.height * this.width);
};
$e.prototype.toCSSCompatValues = function(i) {
  return {
    top: this.top - i.top,
    bottom: i.bottom - this.bottom,
    left: this.left - i.left,
    right: i.right - this.right,
    height: this.height,
    width: this.width
  };
};
$e.getSimpleBoxPosition = function(i) {
  var e = i.div ? i.div.offsetHeight : i.tagName ? i.offsetHeight : 0, t = i.div ? i.div.offsetWidth : i.tagName ? i.offsetWidth : 0, s = i.div ? i.div.offsetTop : i.tagName ? i.offsetTop : 0;
  i = i.div ? i.div.getBoundingClientRect() : i.tagName ? i.getBoundingClientRect() : i;
  var r = {
    left: i.left,
    right: i.right,
    top: i.top || s,
    height: i.height || e,
    bottom: i.bottom || s + (i.height || e),
    width: i.width || t
  };
  return r;
};
function n0(i, e, t, s) {
  function r(D, w) {
    for (var O, P = new $e(D), R = 1, I = 0; I < w.length; I++) {
      for (; D.overlapsOppositeAxis(t, w[I]) || D.within(t) && D.overlapsAny(s); )
        D.move(w[I]);
      if (D.within(t))
        return D;
      var B = D.intersectPercentage(t);
      R > B && (O = new $e(D), R = B), D = new $e(P);
    }
    return O || P;
  }
  var n = new $e(e), a = e.cue, o = r0(a), l = [];
  if (a.snapToLines) {
    var h;
    switch (a.vertical) {
      case "":
        l = ["+y", "-y"], h = "height";
        break;
      case "rl":
        l = ["+x", "-x"], h = "width";
        break;
      case "lr":
        l = ["-x", "+x"], h = "width";
        break;
    }
    var m = n.lineHeight, _ = m * Math.round(o), v = t[h] + m, C = l[0];
    Math.abs(_) > v && (_ = _ < 0 ? -1 : 1, _ *= Math.ceil(v / m) * m), o < 0 && (_ += a.vertical === "" ? t.height : t.width, l = l.reverse()), n.move(C, _);
  } else {
    var A = n.lineHeight / t.height * 100;
    switch (a.lineAlign) {
      case "center":
        o -= A / 2;
        break;
      case "end":
        o -= A;
        break;
    }
    switch (a.vertical) {
      case "":
        e.applyStyles({
          top: e.formatStyle(o, "%")
        });
        break;
      case "rl":
        e.applyStyles({
          left: e.formatStyle(o, "%")
        });
        break;
      case "lr":
        e.applyStyles({
          right: e.formatStyle(o, "%")
        });
        break;
    }
    l = ["+y", "-x", "+x", "-y"], n = new $e(e);
  }
  var y = r(n, l);
  e.move(y.toCSSCompatValues(t));
}
function ts() {
}
ts.StringDecoder = function() {
  return {
    decode: function(i) {
      if (!i)
        return "";
      if (typeof i != "string")
        throw new Error("Error - expected string data.");
      return decodeURIComponent(encodeURIComponent(i));
    }
  };
};
ts.convertCueToDOMTree = function(i, e) {
  return !i || !e ? null : Kc(i, e);
};
var a0 = 0.05, o0 = "sans-serif", u0 = "1.5%";
ts.processCues = function(i, e, t) {
  if (!i || !e || !t)
    return null;
  for (; t.firstChild; )
    t.removeChild(t.firstChild);
  var s = i.document.createElement("div");
  s.style.position = "absolute", s.style.left = "0", s.style.right = "0", s.style.top = "0", s.style.bottom = "0", s.style.margin = u0, t.appendChild(s);
  function r(m) {
    for (var _ = 0; _ < m.length; _++)
      if (m[_].hasBeenReset || !m[_].displayState)
        return !0;
    return !1;
  }
  if (!r(e)) {
    for (var n = 0; n < e.length; n++)
      s.appendChild(e[n].displayState);
    return;
  }
  var a = [], o = $e.getSimpleBoxPosition(s), l = Math.round(o.height * a0 * 100) / 100, h = {
    font: l + "px " + o0
  };
  (function() {
    for (var m, _, v = 0; v < e.length; v++)
      _ = e[v], m = new Vr(i, _, h), s.appendChild(m.div), n0(i, m, o, a), _.displayState = m.div, a.push($e.getSimpleBoxPosition(m));
  })();
};
ts.Parser = function(i, e, t) {
  t || (t = e, e = {}), e || (e = {}), this.window = i, this.vttjs = e, this.state = "INITIAL", this.buffer = "", this.decoder = t || new TextDecoder("utf8"), this.regionList = [];
};
ts.Parser.prototype = {
  // If the error is a ParsingError then report it to the consumer if
  // possible. If it's not a ParsingError then throw it like normal.
  reportOrThrowError: function(i) {
    if (i instanceof Ze)
      this.onparsingerror && this.onparsingerror(i);
    else
      throw i;
  },
  parse: function(i) {
    var e = this;
    i && (e.buffer += e.decoder.decode(i, { stream: !0 }));
    function t() {
      for (var m = e.buffer, _ = 0; _ < m.length && m[_] !== "\r" && m[_] !== `
`; )
        ++_;
      var v = m.substr(0, _);
      return m[_] === "\r" && ++_, m[_] === `
` && ++_, e.buffer = m.substr(_), v;
    }
    function s(m) {
      var _ = new Rs();
      if (ks(m, function(C, A) {
        switch (C) {
          case "id":
            _.set(C, A);
            break;
          case "width":
            _.percent(C, A);
            break;
          case "lines":
            _.integer(C, A);
            break;
          case "regionanchor":
          case "viewportanchor":
            var y = A.split(",");
            if (y.length !== 2)
              break;
            var D = new Rs();
            if (D.percent("x", y[0]), D.percent("y", y[1]), !D.has("x") || !D.has("y"))
              break;
            _.set(C + "X", D.get("x")), _.set(C + "Y", D.get("y"));
            break;
          case "scroll":
            _.alt(C, A, ["up"]);
            break;
        }
      }, /=/, /\s/), _.has("id")) {
        var v = new (e.vttjs.VTTRegion || e.window.VTTRegion)();
        v.width = _.get("width", 100), v.lines = _.get("lines", 3), v.regionAnchorX = _.get("regionanchorX", 0), v.regionAnchorY = _.get("regionanchorY", 100), v.viewportAnchorX = _.get("viewportanchorX", 0), v.viewportAnchorY = _.get("viewportanchorY", 100), v.scroll = _.get("scroll", ""), e.onregion && e.onregion(v), e.regionList.push({
          id: _.get("id"),
          region: v
        });
      }
    }
    function r(m) {
      var _ = new Rs();
      ks(m, function(v, C) {
        switch (v) {
          case "MPEGT":
            _.integer(v + "S", C);
            break;
          case "LOCA":
            _.set(v + "L", po(C));
            break;
        }
      }, /[^\d]:/, /,/), e.ontimestampmap && e.ontimestampmap({
        MPEGTS: _.get("MPEGTS"),
        LOCAL: _.get("LOCAL")
      });
    }
    function n(m) {
      m.match(/X-TIMESTAMP-MAP/) ? ks(m, function(_, v) {
        switch (_) {
          case "X-TIMESTAMP-MAP":
            r(v);
            break;
        }
      }, /=/) : ks(m, function(_, v) {
        switch (_) {
          case "Region":
            s(v);
            break;
        }
      }, /:/);
    }
    try {
      var a;
      if (e.state === "INITIAL") {
        if (!/\r\n|\n/.test(e.buffer))
          return this;
        a = t();
        var o = a.match(/^WEBVTT([ \t].*)?$/);
        if (!o || !o[0])
          throw new Ze(Ze.Errors.BadSignature);
        e.state = "HEADER";
      }
      for (var l = !1; e.buffer; ) {
        if (!/\r\n|\n/.test(e.buffer))
          return this;
        switch (l ? l = !1 : a = t(), e.state) {
          case "HEADER":
            /:/.test(a) ? n(a) : a || (e.state = "ID");
            continue;
          case "NOTE":
            a || (e.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(a)) {
              e.state = "NOTE";
              break;
            }
            if (!a)
              continue;
            e.cue = new (e.vttjs.VTTCue || e.window.VTTCue)(0, 0, "");
            try {
              e.cue.align = "center";
            } catch {
              e.cue.align = "middle";
            }
            if (e.state = "CUE", a.indexOf("-->") === -1) {
              e.cue.id = a;
              continue;
            }
          case "CUE":
            try {
              Zg(a, e.cue, e.regionList);
            } catch (m) {
              e.reportOrThrowError(m), e.cue = null, e.state = "BADCUE";
              continue;
            }
            e.state = "CUETEXT";
            continue;
          case "CUETEXT":
            var h = a.indexOf("-->") !== -1;
            if (!a || h && (l = !0)) {
              e.oncue && e.oncue(e.cue), e.cue = null, e.state = "ID";
              continue;
            }
            e.cue.text && (e.cue.text += `
`), e.cue.text += a.replace(/\u2028/g, `
`).replace(/u2029/g, `
`);
            continue;
          case "BADCUE":
            a || (e.state = "ID");
            continue;
        }
      }
    } catch (m) {
      e.reportOrThrowError(m), e.state === "CUETEXT" && e.cue && e.oncue && e.oncue(e.cue), e.cue = null, e.state = e.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  },
  flush: function() {
    var i = this;
    try {
      if (i.buffer += i.decoder.decode(), (i.cue || i.state === "HEADER") && (i.buffer += `

`, i.parse()), i.state === "INITIAL")
        throw new Ze(Ze.Errors.BadSignature);
    } catch (e) {
      i.reportOrThrowError(e);
    }
    return i.onflush && i.onflush(), this;
  }
};
var l0 = ts, c0 = "auto", d0 = {
  "": 1,
  lr: 1,
  rl: 1
}, h0 = {
  start: 1,
  center: 1,
  end: 1,
  left: 1,
  right: 1,
  auto: 1,
  "line-left": 1,
  "line-right": 1
};
function f0(i) {
  if (typeof i != "string")
    return !1;
  var e = d0[i.toLowerCase()];
  return e ? i.toLowerCase() : !1;
}
function pa(i) {
  if (typeof i != "string")
    return !1;
  var e = h0[i.toLowerCase()];
  return e ? i.toLowerCase() : !1;
}
function Yc(i, e, t) {
  this.hasBeenReset = !1;
  var s = "", r = !1, n = i, a = e, o = t, l = null, h = "", m = !0, _ = "auto", v = "start", C = "auto", A = "auto", y = 100, D = "center";
  Object.defineProperties(this, {
    id: {
      enumerable: !0,
      get: function() {
        return s;
      },
      set: function(w) {
        s = "" + w;
      }
    },
    pauseOnExit: {
      enumerable: !0,
      get: function() {
        return r;
      },
      set: function(w) {
        r = !!w;
      }
    },
    startTime: {
      enumerable: !0,
      get: function() {
        return n;
      },
      set: function(w) {
        if (typeof w != "number")
          throw new TypeError("Start time must be set to a number.");
        n = w, this.hasBeenReset = !0;
      }
    },
    endTime: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(w) {
        if (typeof w != "number")
          throw new TypeError("End time must be set to a number.");
        a = w, this.hasBeenReset = !0;
      }
    },
    text: {
      enumerable: !0,
      get: function() {
        return o;
      },
      set: function(w) {
        o = "" + w, this.hasBeenReset = !0;
      }
    },
    region: {
      enumerable: !0,
      get: function() {
        return l;
      },
      set: function(w) {
        l = w, this.hasBeenReset = !0;
      }
    },
    vertical: {
      enumerable: !0,
      get: function() {
        return h;
      },
      set: function(w) {
        var O = f0(w);
        if (O === !1)
          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
        h = O, this.hasBeenReset = !0;
      }
    },
    snapToLines: {
      enumerable: !0,
      get: function() {
        return m;
      },
      set: function(w) {
        m = !!w, this.hasBeenReset = !0;
      }
    },
    line: {
      enumerable: !0,
      get: function() {
        return _;
      },
      set: function(w) {
        if (typeof w != "number" && w !== c0)
          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
        _ = w, this.hasBeenReset = !0;
      }
    },
    lineAlign: {
      enumerable: !0,
      get: function() {
        return v;
      },
      set: function(w) {
        var O = pa(w);
        O ? (v = O, this.hasBeenReset = !0) : console.warn("lineAlign: an invalid or illegal string was specified.");
      }
    },
    position: {
      enumerable: !0,
      get: function() {
        return C;
      },
      set: function(w) {
        if (w < 0 || w > 100)
          throw new Error("Position must be between 0 and 100.");
        C = w, this.hasBeenReset = !0;
      }
    },
    positionAlign: {
      enumerable: !0,
      get: function() {
        return A;
      },
      set: function(w) {
        var O = pa(w);
        O ? (A = O, this.hasBeenReset = !0) : console.warn("positionAlign: an invalid or illegal string was specified.");
      }
    },
    size: {
      enumerable: !0,
      get: function() {
        return y;
      },
      set: function(w) {
        if (w < 0 || w > 100)
          throw new Error("Size must be between 0 and 100.");
        y = w, this.hasBeenReset = !0;
      }
    },
    align: {
      enumerable: !0,
      get: function() {
        return D;
      },
      set: function(w) {
        var O = pa(w);
        if (!O)
          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
        D = O, this.hasBeenReset = !0;
      }
    }
  }), this.displayState = void 0;
}
Yc.prototype.getCueAsHTML = function() {
  return WebVTT.convertCueToDOMTree(window, this.text);
};
var p0 = Yc, m0 = {
  "": !0,
  up: !0
};
function g0(i) {
  if (typeof i != "string")
    return !1;
  var e = m0[i.toLowerCase()];
  return e ? i.toLowerCase() : !1;
}
function bs(i) {
  return typeof i == "number" && i >= 0 && i <= 100;
}
function _0() {
  var i = 100, e = 3, t = 0, s = 100, r = 0, n = 100, a = "";
  Object.defineProperties(this, {
    width: {
      enumerable: !0,
      get: function() {
        return i;
      },
      set: function(o) {
        if (!bs(o))
          throw new Error("Width must be between 0 and 100.");
        i = o;
      }
    },
    lines: {
      enumerable: !0,
      get: function() {
        return e;
      },
      set: function(o) {
        if (typeof o != "number")
          throw new TypeError("Lines must be set to a number.");
        e = o;
      }
    },
    regionAnchorY: {
      enumerable: !0,
      get: function() {
        return s;
      },
      set: function(o) {
        if (!bs(o))
          throw new Error("RegionAnchorX must be between 0 and 100.");
        s = o;
      }
    },
    regionAnchorX: {
      enumerable: !0,
      get: function() {
        return t;
      },
      set: function(o) {
        if (!bs(o))
          throw new Error("RegionAnchorY must be between 0 and 100.");
        t = o;
      }
    },
    viewportAnchorY: {
      enumerable: !0,
      get: function() {
        return n;
      },
      set: function(o) {
        if (!bs(o))
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        n = o;
      }
    },
    viewportAnchorX: {
      enumerable: !0,
      get: function() {
        return r;
      },
      set: function(o) {
        if (!bs(o))
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        r = o;
      }
    },
    scroll: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(o) {
        var l = g0(o);
        l === !1 ? console.warn("Scroll: an invalid or illegal string was specified.") : a = l;
      }
    }
  });
}
var y0 = _0, Nt = yn, Ti = Xc.exports = {
  WebVTT: l0,
  VTTCue: p0,
  VTTRegion: y0
};
Nt.vttjs = Ti;
Nt.WebVTT = Ti.WebVTT;
var T0 = Ti.VTTCue, v0 = Ti.VTTRegion, b0 = Nt.VTTCue, x0 = Nt.VTTRegion;
Ti.shim = function() {
  Nt.VTTCue = T0, Nt.VTTRegion = v0;
};
Ti.restore = function() {
  Nt.VTTCue = b0, Nt.VTTRegion = x0;
};
Nt.VTTCue || Ti.shim();
var S0 = Xc.exports;
const gl = /* @__PURE__ */ Ks(S0);
var _l = "https://example.com", vn = function(e, t) {
  if (/^[a-z]+:/i.test(t))
    return t;
  /^data:/.test(e) && (e = S.location && S.location.href || "");
  var s = /^\/\//.test(e), r = !S.location && !/\/\//i.test(e);
  e = new S.URL(e, S.location || _l);
  var n = new URL(t, e);
  return r ? n.href.slice(_l.length) : s ? n.href.slice(n.protocol.length) : n.href;
}, mo = /* @__PURE__ */ function() {
  function i() {
    this.listeners = {};
  }
  var e = i.prototype;
  return e.on = function(s, r) {
    this.listeners[s] || (this.listeners[s] = []), this.listeners[s].push(r);
  }, e.off = function(s, r) {
    if (!this.listeners[s])
      return !1;
    var n = this.listeners[s].indexOf(r);
    return this.listeners[s] = this.listeners[s].slice(0), this.listeners[s].splice(n, 1), n > -1;
  }, e.trigger = function(s) {
    var r = this.listeners[s];
    if (r)
      if (arguments.length === 2)
        for (var n = r.length, a = 0; a < n; ++a)
          r[a].call(this, arguments[1]);
      else
        for (var o = Array.prototype.slice.call(arguments, 1), l = r.length, h = 0; h < l; ++h)
          r[h].apply(this, o);
  }, e.dispose = function() {
    this.listeners = {};
  }, e.pipe = function(s) {
    this.on("data", function(r) {
      s.push(r);
    });
  }, i;
}(), E0 = function(e) {
  return S.atob ? S.atob(e) : Buffer.from(e, "base64").toString("binary");
};
function Qc(i) {
  for (var e = E0(i), t = new Uint8Array(e.length), s = 0; s < e.length; s++)
    t[s] = e.charCodeAt(s);
  return t;
}
/*! @name m3u8-parser @version 7.2.0 @license Apache-2.0 */
class C0 extends mo {
  constructor() {
    super(), this.buffer = "";
  }
  /**
   * Add new data to be parsed.
   *
   * @param {string} data the text to process
   */
  push(e) {
    let t;
    for (this.buffer += e, t = this.buffer.indexOf(`
`); t > -1; t = this.buffer.indexOf(`
`))
      this.trigger("data", this.buffer.substring(0, t)), this.buffer = this.buffer.substring(t + 1);
  }
}
const A0 = "	", ma = function(i) {
  const e = /([0-9.]*)?@?([0-9.]*)?/.exec(i || ""), t = {};
  return e[1] && (t.length = parseInt(e[1], 10)), e[2] && (t.offset = parseInt(e[2], 10)), t;
}, D0 = function() {
  const t = "(?:" + "[^=]*" + ")=(?:" + '"[^"]*"|[^,]*' + ")";
  return new RegExp("(?:^|,)(" + t + ")");
}, Me = function(i) {
  const e = {};
  if (!i)
    return e;
  const t = i.split(D0());
  let s = t.length, r;
  for (; s--; )
    t[s] !== "" && (r = /([^=]*)=(.*)/.exec(t[s]).slice(1), r[0] = r[0].replace(/^\s+|\s+$/g, ""), r[1] = r[1].replace(/^\s+|\s+$/g, ""), r[1] = r[1].replace(/^['"](.*)['"]$/g, "$1"), e[r[0]] = r[1]);
  return e;
}, yl = (i) => {
  const e = i.split("x"), t = {};
  return e[0] && (t.width = parseInt(e[0], 10)), e[1] && (t.height = parseInt(e[1], 10)), t;
};
class w0 extends mo {
  constructor() {
    super(), this.customParsers = [], this.tagMappers = [];
  }
  /**
   * Parses an additional line of input.
   *
   * @param {string} line a single line of an M3U8 file to parse
   */
  push(e) {
    let t, s;
    if (e = e.trim(), e.length === 0)
      return;
    if (e[0] !== "#") {
      this.trigger("data", {
        type: "uri",
        uri: e
      });
      return;
    }
    this.tagMappers.reduce((n, a) => {
      const o = a(e);
      return o === e ? n : n.concat([o]);
    }, [e]).forEach((n) => {
      for (let a = 0; a < this.customParsers.length; a++)
        if (this.customParsers[a].call(this, n))
          return;
      if (n.indexOf("#EXT") !== 0) {
        this.trigger("data", {
          type: "comment",
          text: n.slice(1)
        });
        return;
      }
      if (n = n.replace("\r", ""), t = /^#EXTM3U/.exec(n), t) {
        this.trigger("data", {
          type: "tag",
          tagType: "m3u"
        });
        return;
      }
      if (t = /^#EXTINF:([0-9\.]*)?,?(.*)?$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "inf"
        }, t[1] && (s.duration = parseFloat(t[1])), t[2] && (s.title = t[2]), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-TARGETDURATION:([0-9.]*)?/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "targetduration"
        }, t[1] && (s.duration = parseInt(t[1], 10)), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-VERSION:([0-9.]*)?/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "version"
        }, t[1] && (s.version = parseInt(t[1], 10)), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-MEDIA-SEQUENCE:(\-?[0-9.]*)?/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "media-sequence"
        }, t[1] && (s.number = parseInt(t[1], 10)), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-DISCONTINUITY-SEQUENCE:(\-?[0-9.]*)?/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "discontinuity-sequence"
        }, t[1] && (s.number = parseInt(t[1], 10)), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-PLAYLIST-TYPE:(.*)?$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "playlist-type"
        }, t[1] && (s.playlistType = t[1]), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-BYTERANGE:(.*)?$/.exec(n), t) {
        s = ye(ma(t[1]), {
          type: "tag",
          tagType: "byterange"
        }), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-ALLOW-CACHE:(YES|NO)?/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "allow-cache"
        }, t[1] && (s.allowed = !/NO/.test(t[1])), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-MAP:(.*)$/.exec(n), t) {
        if (s = {
          type: "tag",
          tagType: "map"
        }, t[1]) {
          const a = Me(t[1]);
          a.URI && (s.uri = a.URI), a.BYTERANGE && (s.byterange = ma(a.BYTERANGE));
        }
        this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-STREAM-INF:(.*)$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "stream-inf"
        }, t[1] && (s.attributes = Me(t[1]), s.attributes.RESOLUTION && (s.attributes.RESOLUTION = yl(s.attributes.RESOLUTION)), s.attributes.BANDWIDTH && (s.attributes.BANDWIDTH = parseInt(s.attributes.BANDWIDTH, 10)), s.attributes["FRAME-RATE"] && (s.attributes["FRAME-RATE"] = parseFloat(s.attributes["FRAME-RATE"])), s.attributes["PROGRAM-ID"] && (s.attributes["PROGRAM-ID"] = parseInt(s.attributes["PROGRAM-ID"], 10))), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-MEDIA:(.*)$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "media"
        }, t[1] && (s.attributes = Me(t[1])), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-ENDLIST/.exec(n), t) {
        this.trigger("data", {
          type: "tag",
          tagType: "endlist"
        });
        return;
      }
      if (t = /^#EXT-X-DISCONTINUITY/.exec(n), t) {
        this.trigger("data", {
          type: "tag",
          tagType: "discontinuity"
        });
        return;
      }
      if (t = /^#EXT-X-PROGRAM-DATE-TIME:(.*)$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "program-date-time"
        }, t[1] && (s.dateTimeString = t[1], s.dateTimeObject = new Date(t[1])), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-KEY:(.*)$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "key"
        }, t[1] && (s.attributes = Me(t[1]), s.attributes.IV && (s.attributes.IV.substring(0, 2).toLowerCase() === "0x" && (s.attributes.IV = s.attributes.IV.substring(2)), s.attributes.IV = s.attributes.IV.match(/.{8}/g), s.attributes.IV[0] = parseInt(s.attributes.IV[0], 16), s.attributes.IV[1] = parseInt(s.attributes.IV[1], 16), s.attributes.IV[2] = parseInt(s.attributes.IV[2], 16), s.attributes.IV[3] = parseInt(s.attributes.IV[3], 16), s.attributes.IV = new Uint32Array(s.attributes.IV))), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-START:(.*)$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "start"
        }, t[1] && (s.attributes = Me(t[1]), s.attributes["TIME-OFFSET"] = parseFloat(s.attributes["TIME-OFFSET"]), s.attributes.PRECISE = /YES/.test(s.attributes.PRECISE)), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-CUE-OUT-CONT:(.*)?$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "cue-out-cont"
        }, t[1] ? s.data = t[1] : s.data = "", this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-CUE-OUT:(.*)?$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "cue-out"
        }, t[1] ? s.data = t[1] : s.data = "", this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-CUE-IN:?(.*)?$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "cue-in"
        }, t[1] ? s.data = t[1] : s.data = "", this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-SKIP:(.*)$/.exec(n), t && t[1]) {
        s = {
          type: "tag",
          tagType: "skip"
        }, s.attributes = Me(t[1]), s.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (s.attributes["SKIPPED-SEGMENTS"] = parseInt(s.attributes["SKIPPED-SEGMENTS"], 10)), s.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (s.attributes["RECENTLY-REMOVED-DATERANGES"] = s.attributes["RECENTLY-REMOVED-DATERANGES"].split(A0)), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-PART:(.*)$/.exec(n), t && t[1]) {
        s = {
          type: "tag",
          tagType: "part"
        }, s.attributes = Me(t[1]), ["DURATION"].forEach(function(a) {
          s.attributes.hasOwnProperty(a) && (s.attributes[a] = parseFloat(s.attributes[a]));
        }), ["INDEPENDENT", "GAP"].forEach(function(a) {
          s.attributes.hasOwnProperty(a) && (s.attributes[a] = /YES/.test(s.attributes[a]));
        }), s.attributes.hasOwnProperty("BYTERANGE") && (s.attributes.byterange = ma(s.attributes.BYTERANGE)), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(n), t && t[1]) {
        s = {
          type: "tag",
          tagType: "server-control"
        }, s.attributes = Me(t[1]), ["CAN-SKIP-UNTIL", "PART-HOLD-BACK", "HOLD-BACK"].forEach(function(a) {
          s.attributes.hasOwnProperty(a) && (s.attributes[a] = parseFloat(s.attributes[a]));
        }), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(a) {
          s.attributes.hasOwnProperty(a) && (s.attributes[a] = /YES/.test(s.attributes[a]));
        }), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-PART-INF:(.*)$/.exec(n), t && t[1]) {
        s = {
          type: "tag",
          tagType: "part-inf"
        }, s.attributes = Me(t[1]), ["PART-TARGET"].forEach(function(a) {
          s.attributes.hasOwnProperty(a) && (s.attributes[a] = parseFloat(s.attributes[a]));
        }), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(n), t && t[1]) {
        s = {
          type: "tag",
          tagType: "preload-hint"
        }, s.attributes = Me(t[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(a) {
          if (s.attributes.hasOwnProperty(a)) {
            s.attributes[a] = parseInt(s.attributes[a], 10);
            const o = a === "BYTERANGE-LENGTH" ? "length" : "offset";
            s.attributes.byterange = s.attributes.byterange || {}, s.attributes.byterange[o] = s.attributes[a], delete s.attributes[a];
          }
        }), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(n), t && t[1]) {
        s = {
          type: "tag",
          tagType: "rendition-report"
        }, s.attributes = Me(t[1]), ["LAST-MSN", "LAST-PART"].forEach(function(a) {
          s.attributes.hasOwnProperty(a) && (s.attributes[a] = parseInt(s.attributes[a], 10));
        }), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-DATERANGE:(.*)$/.exec(n), t && t[1]) {
        s = {
          type: "tag",
          tagType: "daterange"
        }, s.attributes = Me(t[1]), ["ID", "CLASS"].forEach(function(o) {
          s.attributes.hasOwnProperty(o) && (s.attributes[o] = String(s.attributes[o]));
        }), ["START-DATE", "END-DATE"].forEach(function(o) {
          s.attributes.hasOwnProperty(o) && (s.attributes[o] = new Date(s.attributes[o]));
        }), ["DURATION", "PLANNED-DURATION"].forEach(function(o) {
          s.attributes.hasOwnProperty(o) && (s.attributes[o] = parseFloat(s.attributes[o]));
        }), ["END-ON-NEXT"].forEach(function(o) {
          s.attributes.hasOwnProperty(o) && (s.attributes[o] = /YES/i.test(s.attributes[o]));
        }), ["SCTE35-CMD", " SCTE35-OUT", "SCTE35-IN"].forEach(function(o) {
          s.attributes.hasOwnProperty(o) && (s.attributes[o] = s.attributes[o].toString(16));
        });
        const a = /^X-([A-Z]+-)+[A-Z]+$/;
        for (const o in s.attributes) {
          if (!a.test(o))
            continue;
          const l = /[0-9A-Fa-f]{6}/g.test(s.attributes[o]), h = /^\d+(\.\d+)?$/.test(s.attributes[o]);
          s.attributes[o] = l ? s.attributes[o].toString(16) : h ? parseFloat(s.attributes[o]) : String(s.attributes[o]);
        }
        this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-INDEPENDENT-SEGMENTS/.exec(n), t) {
        this.trigger("data", {
          type: "tag",
          tagType: "independent-segments"
        });
        return;
      }
      if (t = /^#EXT-X-I-FRAMES-ONLY/.exec(n), t) {
        this.trigger("data", {
          type: "tag",
          tagType: "i-frames-only"
        });
        return;
      }
      if (t = /^#EXT-X-CONTENT-STEERING:(.*)$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "content-steering"
        }, s.attributes = Me(t[1]), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-I-FRAME-STREAM-INF:(.*)$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "i-frame-playlist"
        }, s.attributes = Me(t[1]), s.attributes.URI && (s.uri = s.attributes.URI), s.attributes.BANDWIDTH && (s.attributes.BANDWIDTH = parseInt(s.attributes.BANDWIDTH, 10)), s.attributes.RESOLUTION && (s.attributes.RESOLUTION = yl(s.attributes.RESOLUTION)), s.attributes["AVERAGE-BANDWIDTH"] && (s.attributes["AVERAGE-BANDWIDTH"] = parseInt(s.attributes["AVERAGE-BANDWIDTH"], 10)), s.attributes["FRAME-RATE"] && (s.attributes["FRAME-RATE"] = parseFloat(s.attributes["FRAME-RATE"])), this.trigger("data", s);
        return;
      }
      if (t = /^#EXT-X-DEFINE:(.*)$/.exec(n), t) {
        s = {
          type: "tag",
          tagType: "define"
        }, s.attributes = Me(t[1]), this.trigger("data", s);
        return;
      }
      this.trigger("data", {
        type: "tag",
        data: n.slice(4)
      });
    });
  }
  /**
   * Add a parser for custom headers
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */
  addParser({
    expression: e,
    customType: t,
    dataParser: s,
    segment: r
  }) {
    typeof s != "function" && (s = (n) => n), this.customParsers.push((n) => {
      if (e.exec(n))
        return this.trigger("data", {
          type: "custom",
          data: s(n),
          customType: t,
          segment: r
        }), !0;
    });
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */
  addTagMapper({
    expression: e,
    map: t
  }) {
    const s = (r) => e.test(r) ? t(r) : r;
    this.tagMappers.push(s);
  }
}
const I0 = (i) => i.toLowerCase().replace(/-(\w)/g, (e) => e[1].toUpperCase()), jt = function(i) {
  const e = {};
  return Object.keys(i).forEach(function(t) {
    e[I0(t)] = i[t];
  }), e;
}, ga = function(i) {
  const {
    serverControl: e,
    targetDuration: t,
    partTargetDuration: s
  } = i;
  if (!e)
    return;
  const r = "#EXT-X-SERVER-CONTROL", n = "holdBack", a = "partHoldBack", o = t && t * 3, l = s && s * 2;
  t && !e.hasOwnProperty(n) && (e[n] = o, this.trigger("info", {
    message: `${r} defaulting HOLD-BACK to targetDuration * 3 (${o}).`
  })), o && e[n] < o && (this.trigger("warn", {
    message: `${r} clamping HOLD-BACK (${e[n]}) to targetDuration * 3 (${o})`
  }), e[n] = o), s && !e.hasOwnProperty(a) && (e[a] = s * 3, this.trigger("info", {
    message: `${r} defaulting PART-HOLD-BACK to partTargetDuration * 3 (${e[a]}).`
  })), s && e[a] < l && (this.trigger("warn", {
    message: `${r} clamping PART-HOLD-BACK (${e[a]}) to partTargetDuration * 2 (${l}).`
  }), e[a] = l);
};
class k0 extends mo {
  constructor(e = {}) {
    super(), this.lineStream = new C0(), this.parseStream = new w0(), this.lineStream.pipe(this.parseStream), this.mainDefinitions = e.mainDefinitions || {}, this.params = new URL(e.uri, "https://a.com").searchParams, this.lastProgramDateTime = null;
    const t = this, s = [];
    let r = {}, n, a, o = !1;
    const l = function() {
    }, h = {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    }, m = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed";
    let _ = 0;
    this.manifest = {
      allowCache: !0,
      discontinuityStarts: [],
      dateRanges: [],
      iFramePlaylists: [],
      segments: []
    };
    let v = 0, C = 0;
    const A = {};
    this.on("end", () => {
      r.uri || !r.parts && !r.preloadHints || (!r.map && n && (r.map = n), !r.key && a && (r.key = a), !r.timeline && typeof _ == "number" && (r.timeline = _), this.manifest.preloadSegment = r);
    }), this.parseStream.on("data", function(y) {
      let D, w;
      if (t.manifest.definitions) {
        for (const O in t.manifest.definitions)
          if (y.uri && (y.uri = y.uri.replace(`{$${O}}`, t.manifest.definitions[O])), y.attributes)
            for (const P in y.attributes)
              typeof y.attributes[P] == "string" && (y.attributes[P] = y.attributes[P].replace(`{$${O}}`, t.manifest.definitions[O]));
      }
      ({
        tag() {
          ({
            version() {
              y.version && (this.manifest.version = y.version);
            },
            "allow-cache"() {
              this.manifest.allowCache = y.allowed, "allowed" in y || (this.trigger("info", {
                message: "defaulting allowCache to YES"
              }), this.manifest.allowCache = !0);
            },
            byterange() {
              const O = {};
              "length" in y && (r.byterange = O, O.length = y.length, "offset" in y || (y.offset = v)), "offset" in y && (r.byterange = O, O.offset = y.offset), v = O.offset + O.length;
            },
            endlist() {
              this.manifest.endList = !0;
            },
            inf() {
              "mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", {
                message: "defaulting media sequence to zero"
              })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", {
                message: "defaulting discontinuity sequence to zero"
              })), y.title && (r.title = y.title), y.duration > 0 && (r.duration = y.duration), y.duration === 0 && (r.duration = 0.01, this.trigger("info", {
                message: "updating zero segment duration to a small value"
              })), this.manifest.segments = s;
            },
            key() {
              if (!y.attributes) {
                this.trigger("warn", {
                  message: "ignoring key declaration without attribute list"
                });
                return;
              }
              if (y.attributes.METHOD === "NONE") {
                a = null;
                return;
              }
              if (!y.attributes.URI) {
                this.trigger("warn", {
                  message: "ignoring key declaration without URI"
                });
                return;
              }
              if (y.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.apple.fps.1_0"] = {
                  attributes: y.attributes
                };
                return;
              }
              if (y.attributes.KEYFORMAT === "com.microsoft.playready") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.microsoft.playready"] = {
                  uri: y.attributes.URI
                };
                return;
              }
              if (y.attributes.KEYFORMAT === m) {
                if (["SAMPLE-AES", "SAMPLE-AES-CTR", "SAMPLE-AES-CENC"].indexOf(y.attributes.METHOD) === -1) {
                  this.trigger("warn", {
                    message: "invalid key method provided for Widevine"
                  });
                  return;
                }
                if (y.attributes.METHOD === "SAMPLE-AES-CENC" && this.trigger("warn", {
                  message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                }), y.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
                  this.trigger("warn", {
                    message: "invalid key URI provided for Widevine"
                  });
                  return;
                }
                if (!(y.attributes.KEYID && y.attributes.KEYID.substring(0, 2) === "0x")) {
                  this.trigger("warn", {
                    message: "invalid key ID provided for Widevine"
                  });
                  return;
                }
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.widevine.alpha"] = {
                  attributes: {
                    schemeIdUri: y.attributes.KEYFORMAT,
                    // remove '0x' from the key id string
                    keyId: y.attributes.KEYID.substring(2)
                  },
                  // decode the base64-encoded PSSH box
                  pssh: Qc(y.attributes.URI.split(",")[1])
                };
                return;
              }
              y.attributes.METHOD || this.trigger("warn", {
                message: "defaulting key method to AES-128"
              }), a = {
                method: y.attributes.METHOD || "AES-128",
                uri: y.attributes.URI
              }, typeof y.attributes.IV < "u" && (a.iv = y.attributes.IV);
            },
            "media-sequence"() {
              if (!isFinite(y.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid media sequence: " + y.number
                });
                return;
              }
              this.manifest.mediaSequence = y.number;
            },
            "discontinuity-sequence"() {
              if (!isFinite(y.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid discontinuity sequence: " + y.number
                });
                return;
              }
              this.manifest.discontinuitySequence = y.number, _ = y.number;
            },
            "playlist-type"() {
              if (!/VOD|EVENT/.test(y.playlistType)) {
                this.trigger("warn", {
                  message: "ignoring unknown playlist type: " + y.playlist
                });
                return;
              }
              this.manifest.playlistType = y.playlistType;
            },
            map() {
              n = {}, y.uri && (n.uri = y.uri), y.byterange && (n.byterange = y.byterange), a && (n.key = a);
            },
            "stream-inf"() {
              if (this.manifest.playlists = s, this.manifest.mediaGroups = this.manifest.mediaGroups || h, !y.attributes) {
                this.trigger("warn", {
                  message: "ignoring empty stream-inf attributes"
                });
                return;
              }
              r.attributes || (r.attributes = {}), ye(r.attributes, y.attributes);
            },
            media() {
              if (this.manifest.mediaGroups = this.manifest.mediaGroups || h, !(y.attributes && y.attributes.TYPE && y.attributes["GROUP-ID"] && y.attributes.NAME)) {
                this.trigger("warn", {
                  message: "ignoring incomplete or missing media group"
                });
                return;
              }
              const O = this.manifest.mediaGroups[y.attributes.TYPE];
              O[y.attributes["GROUP-ID"]] = O[y.attributes["GROUP-ID"]] || {}, D = O[y.attributes["GROUP-ID"]], w = {
                default: /yes/i.test(y.attributes.DEFAULT)
              }, w.default ? w.autoselect = !0 : w.autoselect = /yes/i.test(y.attributes.AUTOSELECT), y.attributes.LANGUAGE && (w.language = y.attributes.LANGUAGE), y.attributes.URI && (w.uri = y.attributes.URI), y.attributes["INSTREAM-ID"] && (w.instreamId = y.attributes["INSTREAM-ID"]), y.attributes.CHARACTERISTICS && (w.characteristics = y.attributes.CHARACTERISTICS), y.attributes.FORCED && (w.forced = /yes/i.test(y.attributes.FORCED)), D[y.attributes.NAME] = w;
            },
            discontinuity() {
              _ += 1, r.discontinuity = !0, this.manifest.discontinuityStarts.push(s.length);
            },
            "program-date-time"() {
              typeof this.manifest.dateTimeString > "u" && (this.manifest.dateTimeString = y.dateTimeString, this.manifest.dateTimeObject = y.dateTimeObject), r.dateTimeString = y.dateTimeString, r.dateTimeObject = y.dateTimeObject;
              const {
                lastProgramDateTime: O
              } = this;
              this.lastProgramDateTime = new Date(y.dateTimeString).getTime(), O === null && this.manifest.segments.reduceRight((P, R) => (R.programDateTime = P - R.duration * 1e3, R.programDateTime), this.lastProgramDateTime);
            },
            targetduration() {
              if (!isFinite(y.duration) || y.duration < 0) {
                this.trigger("warn", {
                  message: "ignoring invalid target duration: " + y.duration
                });
                return;
              }
              this.manifest.targetDuration = y.duration, ga.call(this, this.manifest);
            },
            start() {
              if (!y.attributes || isNaN(y.attributes["TIME-OFFSET"])) {
                this.trigger("warn", {
                  message: "ignoring start declaration without appropriate attribute list"
                });
                return;
              }
              this.manifest.start = {
                timeOffset: y.attributes["TIME-OFFSET"],
                precise: y.attributes.PRECISE
              };
            },
            "cue-out"() {
              r.cueOut = y.data;
            },
            "cue-out-cont"() {
              r.cueOutCont = y.data;
            },
            "cue-in"() {
              r.cueIn = y.data;
            },
            skip() {
              this.manifest.skip = jt(y.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", y.attributes, ["SKIPPED-SEGMENTS"]);
            },
            part() {
              o = !0;
              const O = this.manifest.segments.length, P = jt(y.attributes);
              r.parts = r.parts || [], r.parts.push(P), P.byterange && (P.byterange.hasOwnProperty("offset") || (P.byterange.offset = C), C = P.byterange.offset + P.byterange.length);
              const R = r.parts.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-PART #${R} for segment #${O}`, y.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach((I, B) => {
                I.hasOwnProperty("lastPart") || this.trigger("warn", {
                  message: `#EXT-X-RENDITION-REPORT #${B} lacks required attribute(s): LAST-PART`
                });
              });
            },
            "server-control"() {
              const O = this.manifest.serverControl = jt(y.attributes);
              O.hasOwnProperty("canBlockReload") || (O.canBlockReload = !1, this.trigger("info", {
                message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
              })), ga.call(this, this.manifest), O.canSkipDateranges && !O.hasOwnProperty("canSkipUntil") && this.trigger("warn", {
                message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
              });
            },
            "preload-hint"() {
              const O = this.manifest.segments.length, P = jt(y.attributes), R = P.type && P.type === "PART";
              r.preloadHints = r.preloadHints || [], r.preloadHints.push(P), P.byterange && (P.byterange.hasOwnProperty("offset") || (P.byterange.offset = R ? C : 0, R && (C = P.byterange.offset + P.byterange.length)));
              const I = r.preloadHints.length - 1;
              if (this.warnOnMissingAttributes_(`#EXT-X-PRELOAD-HINT #${I} for segment #${O}`, y.attributes, ["TYPE", "URI"]), !!P.type)
                for (let B = 0; B < r.preloadHints.length - 1; B++) {
                  const H = r.preloadHints[B];
                  H.type && H.type === P.type && this.trigger("warn", {
                    message: `#EXT-X-PRELOAD-HINT #${I} for segment #${O} has the same TYPE ${P.type} as preload hint #${B}`
                  });
                }
            },
            "rendition-report"() {
              const O = jt(y.attributes);
              this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(O);
              const P = this.manifest.renditionReports.length - 1, R = ["LAST-MSN", "URI"];
              o && R.push("LAST-PART"), this.warnOnMissingAttributes_(`#EXT-X-RENDITION-REPORT #${P}`, y.attributes, R);
            },
            "part-inf"() {
              this.manifest.partInf = jt(y.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", y.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), ga.call(this, this.manifest);
            },
            daterange() {
              this.manifest.dateRanges.push(jt(y.attributes));
              const O = this.manifest.dateRanges.length - 1;
              this.warnOnMissingAttributes_(`#EXT-X-DATERANGE #${O}`, y.attributes, ["ID", "START-DATE"]);
              const P = this.manifest.dateRanges[O];
              P.endDate && P.startDate && new Date(P.endDate) < new Date(P.startDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE END-DATE must be equal to or later than the value of the START-DATE"
              }), P.duration && P.duration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE DURATION must not be negative"
              }), P.plannedDuration && P.plannedDuration < 0 && this.trigger("warn", {
                message: "EXT-X-DATERANGE PLANNED-DURATION must not be negative"
              });
              const R = !!P.endOnNext;
              if (R && !P.class && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must have a CLASS attribute"
              }), R && (P.duration || P.endDate) && this.trigger("warn", {
                message: "EXT-X-DATERANGE with an END-ON-NEXT=YES attribute must not contain DURATION or END-DATE attributes"
              }), P.duration && P.endDate) {
                const B = P.startDate.getTime() + P.duration * 1e3;
                this.manifest.dateRanges[O].endDate = new Date(B);
              }
              if (!A[P.id])
                A[P.id] = P;
              else {
                for (const B in A[P.id])
                  if (P[B] && JSON.stringify(A[P.id][B]) !== JSON.stringify(P[B])) {
                    this.trigger("warn", {
                      message: "EXT-X-DATERANGE tags with the same ID in a playlist must have the same attributes values"
                    });
                    break;
                  }
                const I = this.manifest.dateRanges.findIndex((B) => B.id === P.id);
                this.manifest.dateRanges[I] = ye(this.manifest.dateRanges[I], P), A[P.id] = ye(A[P.id], P), this.manifest.dateRanges.pop();
              }
            },
            "independent-segments"() {
              this.manifest.independentSegments = !0;
            },
            "i-frames-only"() {
              this.manifest.iFramesOnly = !0, this.requiredCompatibilityversion(this.manifest.version, 4);
            },
            "content-steering"() {
              this.manifest.contentSteering = jt(y.attributes), this.warnOnMissingAttributes_("#EXT-X-CONTENT-STEERING", y.attributes, ["SERVER-URI"]);
            },
            /** @this {Parser} */
            define() {
              this.manifest.definitions = this.manifest.definitions || {};
              const O = (P, R) => {
                if (P in this.manifest.definitions) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: Duplicate name ${P}`
                  });
                  return;
                }
                this.manifest.definitions[P] = R;
              };
              if ("QUERYPARAM" in y.attributes) {
                if ("NAME" in y.attributes || "IMPORT" in y.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                const P = this.params.get(y.attributes.QUERYPARAM);
                if (!P) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No query param ${y.attributes.QUERYPARAM}`
                  });
                  return;
                }
                O(y.attributes.QUERYPARAM, decodeURIComponent(P));
                return;
              }
              if ("NAME" in y.attributes) {
                if ("IMPORT" in y.attributes) {
                  this.trigger("error", {
                    message: "EXT-X-DEFINE: Invalid attributes"
                  });
                  return;
                }
                if (!("VALUE" in y.attributes) || typeof y.attributes.VALUE != "string") {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value for ${y.attributes.NAME}`
                  });
                  return;
                }
                O(y.attributes.NAME, y.attributes.VALUE);
                return;
              }
              if ("IMPORT" in y.attributes) {
                if (!this.mainDefinitions[y.attributes.IMPORT]) {
                  this.trigger("error", {
                    message: `EXT-X-DEFINE: No value ${y.attributes.IMPORT} to import, or IMPORT used on main playlist`
                  });
                  return;
                }
                O(y.attributes.IMPORT, this.mainDefinitions[y.attributes.IMPORT]);
                return;
              }
              this.trigger("error", {
                message: "EXT-X-DEFINE: No attribute"
              });
            },
            "i-frame-playlist"() {
              this.manifest.iFramePlaylists.push({
                attributes: y.attributes,
                uri: y.uri,
                timeline: _
              }), this.warnOnMissingAttributes_("#EXT-X-I-FRAME-STREAM-INF", y.attributes, ["BANDWIDTH", "URI"]);
            }
          }[y.tagType] || l).call(t);
        },
        uri() {
          r.uri = y.uri, s.push(r), this.manifest.targetDuration && !("duration" in r) && (this.trigger("warn", {
            message: "defaulting segment duration to the target duration"
          }), r.duration = this.manifest.targetDuration), a && (r.key = a), r.timeline = _, n && (r.map = n), C = 0, this.lastProgramDateTime !== null && (r.programDateTime = this.lastProgramDateTime, this.lastProgramDateTime += r.duration * 1e3), r = {};
        },
        comment() {
        },
        custom() {
          y.segment ? (r.custom = r.custom || {}, r.custom[y.customType] = y.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[y.customType] = y.data);
        }
      })[y.type].call(t);
    });
  }
  requiredCompatibilityversion(e, t) {
    (e < t || !e) && this.trigger("warn", {
      message: `manifest must be at least version ${t}`
    });
  }
  warnOnMissingAttributes_(e, t, s) {
    const r = [];
    s.forEach(function(n) {
      t.hasOwnProperty(n) || r.push(n);
    }), r.length && this.trigger("warn", {
      message: `${e} lacks required attribute(s): ${r.join(", ")}`
    });
  }
  /**
   * Parse the input string and update the manifest object.
   *
   * @param {string} chunk a potentially incomplete portion of the manifest
   */
  push(e) {
    this.lineStream.push(e);
  }
  /**
   * Flush any remaining input. This can be handy if the last line of an M3U8
   * manifest did not contain a trailing newline but the file has been
   * completely received.
   */
  end() {
    this.lineStream.push(`
`), this.manifest.dateRanges.length && this.lastProgramDateTime === null && this.trigger("warn", {
      message: "A playlist with EXT-X-DATERANGE tag must contain atleast one EXT-X-PROGRAM-DATE-TIME tag"
    }), this.lastProgramDateTime = null, this.trigger("end");
  }
  /**
   * Add an additional parser for non-standard tags
   *
   * @param {Object}   options              a map of options for the added parser
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {string}   options.customType   the custom type to register to the output
   * @param {Function} [options.dataParser] function to parse the line into an object
   * @param {boolean}  [options.segment]    should tag data be attached to the segment object
   */
  addParser(e) {
    this.parseStream.addParser(e);
  }
  /**
   * Add a custom header mapper
   *
   * @param {Object}   options
   * @param {RegExp}   options.expression   a regular expression to match the custom header
   * @param {Function} options.map          function to translate tag into a different tag
   */
  addTagMapper(e) {
    this.parseStream.addTagMapper(e);
  }
}
var hi = {
  // to determine mime types
  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
  // to determine if a codec is audio or video
  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
  text: /^(stpp.ttml.im1t)/,
  // mux.js support regex
  muxerVideo: /^(avc0?1)/,
  muxerAudio: /^(mp4a)/,
  // match nothing as muxer does not support text right now.
  // there cannot never be a character before the start of a string
  // so this matches nothing.
  muxerText: /a^/
}, P0 = ["video", "audio", "text"], Tl = ["Video", "Audio", "Text"], Jc = function(e) {
  return e && e.replace(/avc1\.(\d+)\.(\d+)/i, function(t, s, r) {
    var n = ("00" + Number(s).toString(16)).slice(-2), a = ("00" + Number(r).toString(16)).slice(-2);
    return "avc1." + n + "00" + a;
  });
}, mt = function(e) {
  e === void 0 && (e = "");
  var t = e.split(","), s = [];
  return t.forEach(function(r) {
    r = r.trim();
    var n;
    P0.forEach(function(a) {
      var o = hi[a].exec(r.toLowerCase());
      if (!(!o || o.length <= 1)) {
        n = a;
        var l = r.substring(0, o[1].length), h = r.replace(l, "");
        s.push({
          type: l,
          details: h,
          mediaType: a
        });
      }
    }), n || s.push({
      type: r,
      details: "",
      mediaType: "unknown"
    });
  }), s;
}, O0 = function(e, t) {
  if (!e.mediaGroups.AUDIO || !t)
    return null;
  var s = e.mediaGroups.AUDIO[t];
  if (!s)
    return null;
  for (var r in s) {
    var n = s[r];
    if (n.default && n.playlists)
      return mt(n.playlists[0].attributes.CODECS);
  }
  return null;
}, Zc = function(e) {
  return e === void 0 && (e = ""), hi.audio.test(e.trim().toLowerCase());
}, L0 = function(e) {
  return e === void 0 && (e = ""), hi.text.test(e.trim().toLowerCase());
}, ji = function(e) {
  if (!(!e || typeof e != "string")) {
    var t = e.toLowerCase().split(",").map(function(n) {
      return Jc(n.trim());
    }), s = "video";
    t.length === 1 && Zc(t[0]) ? s = "audio" : t.length === 1 && L0(t[0]) && (s = "application");
    var r = "mp4";
    return t.every(function(n) {
      return hi.mp4.test(n);
    }) ? r = "mp4" : t.every(function(n) {
      return hi.webm.test(n);
    }) ? r = "webm" : t.every(function(n) {
      return hi.ogg.test(n);
    }) && (r = "ogg"), s + "/" + r + ';codecs="' + e + '"';
  }
}, Ns = function(e, t) {
  return e === void 0 && (e = ""), t === void 0 && (t = !1), S.MediaSource && S.MediaSource.isTypeSupported && S.MediaSource.isTypeSupported(ji(e)) || t && S.ManagedMediaSource && S.ManagedMediaSource.isTypeSupported && S.ManagedMediaSource.isTypeSupported(ji(e)) || !1;
}, _a = function(e) {
  return e === void 0 && (e = ""), e.toLowerCase().split(",").every(function(t) {
    t = t.trim();
    for (var s = 0; s < Tl.length; s++) {
      var r = Tl[s];
      if (hi["muxer" + r].test(t))
        return !0;
    }
    return !1;
  });
}, vl = "mp4a.40.2", R0 = "avc1.4d400d", N0 = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i, M0 = /^application\/dash\+xml/i, ed = function(e) {
  return N0.test(e) ? "hls" : M0.test(e) ? "dash" : e === "application/vnd.videojs.vhs+json" ? "vhs-json" : null;
}, B0 = function(e) {
  return e.toString(2).length;
}, F0 = function(e) {
  return Math.ceil(B0(e) / 8);
}, td = function(e) {
  return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer;
}, U0 = function(e) {
  return td(e);
}, z = function(e) {
  return e instanceof Uint8Array ? e : (!Array.isArray(e) && !U0(e) && !(e instanceof ArrayBuffer) && (typeof e != "number" || typeof e == "number" && e !== e ? e = 0 : e = [e]), new Uint8Array(e && e.buffer || e, e && e.byteOffset || 0, e && e.byteLength || 0));
}, Ie = S.BigInt || Number, Na = [Ie("0x1"), Ie("0x100"), Ie("0x10000"), Ie("0x1000000"), Ie("0x100000000"), Ie("0x10000000000"), Ie("0x1000000000000"), Ie("0x100000000000000"), Ie("0x10000000000000000")];
(function() {
  var i = new Uint16Array([65484]), e = new Uint8Array(i.buffer, i.byteOffset, i.byteLength);
  return e[0] === 255 ? "big" : e[0] === 204 ? "little" : "unknown";
})();
var $0 = function(e, t) {
  var s = t === void 0 ? {} : t, r = s.signed, n = r === void 0 ? !1 : r, a = s.le, o = a === void 0 ? !1 : a;
  e = z(e);
  var l = o ? "reduce" : "reduceRight", h = e[l] ? e[l] : Array.prototype[l], m = h.call(e, function(v, C, A) {
    var y = o ? A : Math.abs(A + 1 - e.length);
    return v + Ie(C) * Na[y];
  }, Ie(0));
  if (n) {
    var _ = Na[e.length] / Ie(2) - Ie(1);
    m = Ie(m), m > _ && (m -= _, m -= _, m -= Ie(2));
  }
  return Number(m);
}, q0 = function(e, t) {
  var s = {}, r = s.le, n = r === void 0 ? !1 : r;
  (typeof e != "bigint" && typeof e != "number" || typeof e == "number" && e !== e) && (e = 0), e = Ie(e);
  for (var a = F0(e), o = new Uint8Array(new ArrayBuffer(a)), l = 0; l < a; l++) {
    var h = n ? l : Math.abs(l + 1 - o.length);
    o[h] = Number(e / Na[l] & Ie(255)), e < 0 && (o[h] = Math.abs(~o[h]), o[h] -= l === 0 ? 1 : 2);
  }
  return o;
}, id = function(e, t) {
  if (typeof e != "string" && e && typeof e.toString == "function" && (e = e.toString()), typeof e != "string")
    return new Uint8Array();
  t || (e = unescape(encodeURIComponent(e)));
  for (var s = new Uint8Array(e.length), r = 0; r < e.length; r++)
    s[r] = e.charCodeAt(r);
  return s;
}, j0 = function() {
  for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++)
    t[s] = arguments[s];
  if (t = t.filter(function(o) {
    return o && (o.byteLength || o.length) && typeof o != "string";
  }), t.length <= 1)
    return z(t[0]);
  var r = t.reduce(function(o, l, h) {
    return o + (l.byteLength || l.length);
  }, 0), n = new Uint8Array(r), a = 0;
  return t.forEach(function(o) {
    o = z(o), n.set(o, a), a += o.byteLength;
  }), n;
}, fe = function(e, t, s) {
  var r = s === void 0 ? {} : s, n = r.offset, a = n === void 0 ? 0 : n, o = r.mask, l = o === void 0 ? [] : o;
  e = z(e), t = z(t);
  var h = t.every ? t.every : Array.prototype.every;
  return t.length && e.length - a >= t.length && // ie 11 doesn't support every on uin8
  h.call(t, function(m, _) {
    var v = l[_] ? l[_] & e[a + _] : e[a + _];
    return m === v;
  });
}, H0 = function(e, t, s) {
  t.forEach(function(r) {
    for (var n in e.mediaGroups[r])
      for (var a in e.mediaGroups[r][n]) {
        var o = e.mediaGroups[r][n][a];
        s(o, r, n, a);
      }
  });
}, Yt = {}, Ut = {};
function V0(i, e, t) {
  if (t === void 0 && (t = Array.prototype), i && typeof t.find == "function")
    return t.find.call(i, e);
  for (var s = 0; s < i.length; s++)
    if (Object.prototype.hasOwnProperty.call(i, s)) {
      var r = i[s];
      if (e.call(void 0, r, s, i))
        return r;
    }
}
function go(i, e) {
  return e === void 0 && (e = Object), e && typeof e.freeze == "function" ? e.freeze(i) : i;
}
function z0(i, e) {
  if (i === null || typeof i != "object")
    throw new TypeError("target is not an object");
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && (i[t] = e[t]);
  return i;
}
var sd = go({
  /**
   * `text/html`, the only mime type that triggers treating an XML document as HTML.
   *
   * @see DOMParser.SupportedType.isHTML
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
   */
  HTML: "text/html",
  /**
   * Helper method to check a mime type if it indicates an HTML document
   *
   * @param {string} [value]
   * @returns {boolean}
   *
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
  isHTML: function(i) {
    return i === sd.HTML;
  },
  /**
   * `application/xml`, the standard mime type for XML documents.
   *
   * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
   * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_APPLICATION: "application/xml",
  /**
   * `text/html`, an alias for `application/xml`.
   *
   * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
   * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_TEXT: "text/xml",
  /**
   * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
   * but is parsed as an XML document.
   *
   * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
   * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
   */
  XML_XHTML_APPLICATION: "application/xhtml+xml",
  /**
   * `image/svg+xml`,
   *
   * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
   * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
   * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
   */
  XML_SVG_IMAGE: "image/svg+xml"
}), rd = go({
  /**
   * The XHTML namespace.
   *
   * @see http://www.w3.org/1999/xhtml
   */
  HTML: "http://www.w3.org/1999/xhtml",
  /**
   * Checks if `uri` equals `NAMESPACE.HTML`.
   *
   * @param {string} [uri]
   *
   * @see NAMESPACE.HTML
   */
  isHTML: function(i) {
    return i === rd.HTML;
  },
  /**
   * The SVG namespace.
   *
   * @see http://www.w3.org/2000/svg
   */
  SVG: "http://www.w3.org/2000/svg",
  /**
   * The `xml:` namespace.
   *
   * @see http://www.w3.org/XML/1998/namespace
   */
  XML: "http://www.w3.org/XML/1998/namespace",
  /**
   * The `xmlns:` namespace
   *
   * @see https://www.w3.org/2000/xmlns/
   */
  XMLNS: "http://www.w3.org/2000/xmlns/"
});
Ut.assign = z0;
Ut.find = V0;
Ut.freeze = go;
Ut.MIME_TYPE = sd;
Ut.NAMESPACE = rd;
var nd = Ut, bt = nd.find, js = nd.NAMESPACE;
function G0(i) {
  return i !== "";
}
function W0(i) {
  return i ? i.split(/[\t\n\f\r ]+/).filter(G0) : [];
}
function X0(i, e) {
  return i.hasOwnProperty(e) || (i[e] = !0), i;
}
function bl(i) {
  if (!i) return [];
  var e = W0(i);
  return Object.keys(e.reduce(X0, {}));
}
function K0(i) {
  return function(e) {
    return i && i.indexOf(e) !== -1;
  };
}
function Ys(i, e) {
  for (var t in i)
    Object.prototype.hasOwnProperty.call(i, t) && (e[t] = i[t]);
}
function Ke(i, e) {
  var t = i.prototype;
  if (!(t instanceof e)) {
    let s = function() {
    };
    s.prototype = e.prototype, s = new s(), Ys(t, s), i.prototype = t = s;
  }
  t.constructor != i && (typeof i != "function" && console.error("unknown Class:" + i), t.constructor = i);
}
var Ye = {}, ct = Ye.ELEMENT_NODE = 1, Hi = Ye.ATTRIBUTE_NODE = 2, zr = Ye.TEXT_NODE = 3, ad = Ye.CDATA_SECTION_NODE = 4, od = Ye.ENTITY_REFERENCE_NODE = 5, Y0 = Ye.ENTITY_NODE = 6, ud = Ye.PROCESSING_INSTRUCTION_NODE = 7, ld = Ye.COMMENT_NODE = 8, cd = Ye.DOCUMENT_NODE = 9, dd = Ye.DOCUMENT_TYPE_NODE = 10, Mt = Ye.DOCUMENT_FRAGMENT_NODE = 11, Q0 = Ye.NOTATION_NODE = 12, Le = {}, we = {};
Le.INDEX_SIZE_ERR = (we[1] = "Index size error", 1);
Le.DOMSTRING_SIZE_ERR = (we[2] = "DOMString size error", 2);
var ze = Le.HIERARCHY_REQUEST_ERR = (we[3] = "Hierarchy request error", 3);
Le.WRONG_DOCUMENT_ERR = (we[4] = "Wrong document", 4);
Le.INVALID_CHARACTER_ERR = (we[5] = "Invalid character", 5);
Le.NO_DATA_ALLOWED_ERR = (we[6] = "No data allowed", 6);
Le.NO_MODIFICATION_ALLOWED_ERR = (we[7] = "No modification allowed", 7);
var hd = Le.NOT_FOUND_ERR = (we[8] = "Not found", 8);
Le.NOT_SUPPORTED_ERR = (we[9] = "Not supported", 9);
var xl = Le.INUSE_ATTRIBUTE_ERR = (we[10] = "Attribute in use", 10);
Le.INVALID_STATE_ERR = (we[11] = "Invalid state", 11);
Le.SYNTAX_ERR = (we[12] = "Syntax error", 12);
Le.INVALID_MODIFICATION_ERR = (we[13] = "Invalid modification", 13);
Le.NAMESPACE_ERR = (we[14] = "Invalid namespace", 14);
Le.INVALID_ACCESS_ERR = (we[15] = "Invalid access", 15);
function Se(i, e) {
  if (e instanceof Error)
    var t = e;
  else
    t = this, Error.call(this, we[i]), this.message = we[i], Error.captureStackTrace && Error.captureStackTrace(this, Se);
  return t.code = i, e && (this.message = this.message + ": " + e), t;
}
Se.prototype = Error.prototype;
Ys(Le, Se);
function Lt() {
}
Lt.prototype = {
  /**
   * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
   * @standard level1
   */
  length: 0,
  /**
   * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
   * @standard level1
   * @param index  unsigned long
   *   Index into the collection.
   * @return Node
   * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
   */
  item: function(i) {
    return i >= 0 && i < this.length ? this[i] : null;
  },
  toString: function(i, e) {
    for (var t = [], s = 0; s < this.length; s++)
      Pi(this[s], t, i, e);
    return t.join("");
  },
  /**
   * @private
   * @param {function (Node):boolean} predicate
   * @returns {Node[]}
   */
  filter: function(i) {
    return Array.prototype.filter.call(this, i);
  },
  /**
   * @private
   * @param {Node} item
   * @returns {number}
   */
  indexOf: function(i) {
    return Array.prototype.indexOf.call(this, i);
  }
};
function Vi(i, e) {
  this._node = i, this._refresh = e, _o(this);
}
function _o(i) {
  var e = i._node._inc || i._node.ownerDocument._inc;
  if (i._inc !== e) {
    var t = i._refresh(i._node);
    if (Ed(i, "length", t.length), !i.$$length || t.length < i.$$length)
      for (var s = t.length; s in i; s++)
        Object.prototype.hasOwnProperty.call(i, s) && delete i[s];
    Ys(t, i), i._inc = e;
  }
}
Vi.prototype.item = function(i) {
  return _o(this), this[i] || null;
};
Ke(Vi, Lt);
function Gr() {
}
function fd(i, e) {
  for (var t = i.length; t--; )
    if (i[t] === e)
      return t;
}
function Sl(i, e, t, s) {
  if (s ? e[fd(e, s)] = t : e[e.length++] = t, i) {
    t.ownerElement = i;
    var r = i.ownerDocument;
    r && (s && gd(r, i, s), J0(r, i, t));
  }
}
function El(i, e, t) {
  var s = fd(e, t);
  if (s >= 0) {
    for (var r = e.length - 1; s < r; )
      e[s] = e[++s];
    if (e.length = r, i) {
      var n = i.ownerDocument;
      n && (gd(n, i, t), t.ownerElement = null);
    }
  } else
    throw new Se(hd, new Error(i.tagName + "@" + t));
}
Gr.prototype = {
  length: 0,
  item: Lt.prototype.item,
  getNamedItem: function(i) {
    for (var e = this.length; e--; ) {
      var t = this[e];
      if (t.nodeName == i)
        return t;
    }
  },
  setNamedItem: function(i) {
    var e = i.ownerElement;
    if (e && e != this._ownerElement)
      throw new Se(xl);
    var t = this.getNamedItem(i.nodeName);
    return Sl(this._ownerElement, this, i, t), t;
  },
  /* returns Node */
  setNamedItemNS: function(i) {
    var e = i.ownerElement, t;
    if (e && e != this._ownerElement)
      throw new Se(xl);
    return t = this.getNamedItemNS(i.namespaceURI, i.localName), Sl(this._ownerElement, this, i, t), t;
  },
  /* returns Node */
  removeNamedItem: function(i) {
    var e = this.getNamedItem(i);
    return El(this._ownerElement, this, e), e;
  },
  // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
  //for level2
  removeNamedItemNS: function(i, e) {
    var t = this.getNamedItemNS(i, e);
    return El(this._ownerElement, this, t), t;
  },
  getNamedItemNS: function(i, e) {
    for (var t = this.length; t--; ) {
      var s = this[t];
      if (s.localName == e && s.namespaceURI == i)
        return s;
    }
    return null;
  }
};
function pd() {
}
pd.prototype = {
  /**
   * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
   * The different implementations fairly diverged in what kind of features were reported.
   * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
   *
   * @deprecated It is deprecated and modern browsers return true in all cases.
   *
   * @param {string} feature
   * @param {string} [version]
   * @returns {boolean} always true
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
   * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
   */
  hasFeature: function(i, e) {
    return !0;
  },
  /**
   * Creates an XML Document object of the specified type with its document element.
   *
   * __It behaves slightly different from the description in the living standard__:
   * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
   * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string|null} namespaceURI
   * @param {string} qualifiedName
   * @param {DocumentType=null} doctype
   * @returns {Document}
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocument: function(i, e, t) {
    var s = new Qs();
    if (s.implementation = this, s.childNodes = new Lt(), s.doctype = t || null, t && s.appendChild(t), e) {
      var r = s.createElementNS(i, e);
      s.appendChild(r);
    }
    return s;
  },
  /**
   * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
   *
   * __This behavior is slightly different from the in the specs__:
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string} qualifiedName
   * @param {string} [publicId]
   * @param {string} [systemId]
   * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
   * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocumentType: function(i, e, t) {
    var s = new bn();
    return s.name = i, s.nodeName = i, s.publicId = e || "", s.systemId = t || "", s;
  }
};
function re() {
}
re.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  // Modified in DOM Level 2:
  insertBefore: function(i, e) {
    return Wr(this, i, e);
  },
  replaceChild: function(i, e) {
    Wr(this, i, e, yd), e && this.removeChild(e);
  },
  removeChild: function(i) {
    return _d(this, i);
  },
  appendChild: function(i) {
    return this.insertBefore(i, null);
  },
  hasChildNodes: function() {
    return this.firstChild != null;
  },
  cloneNode: function(i) {
    return Ma(this.ownerDocument || this, this, i);
  },
  // Modified in DOM Level 2:
  normalize: function() {
    for (var i = this.firstChild; i; ) {
      var e = i.nextSibling;
      e && e.nodeType == zr && i.nodeType == zr ? (this.removeChild(e), i.appendData(e.data)) : (i.normalize(), i = e);
    }
  },
  // Introduced in DOM Level 2:
  isSupported: function(i, e) {
    return this.ownerDocument.implementation.hasFeature(i, e);
  },
  // Introduced in DOM Level 2:
  hasAttributes: function() {
    return this.attributes.length > 0;
  },
  /**
   * Look up the prefix associated to the given namespace URI, starting from this node.
   * **The default namespace declarations are ignored by this method.**
   * See Namespace Prefix Lookup for details on the algorithm used by this method.
   *
   * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
   *
   * @param {string | null} namespaceURI
   * @returns {string | null}
   * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
   * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
   * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
   * @see https://github.com/xmldom/xmldom/issues/322
   */
  lookupPrefix: function(i) {
    for (var e = this; e; ) {
      var t = e._nsMap;
      if (t) {
        for (var s in t)
          if (Object.prototype.hasOwnProperty.call(t, s) && t[s] === i)
            return s;
      }
      e = e.nodeType == Hi ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  lookupNamespaceURI: function(i) {
    for (var e = this; e; ) {
      var t = e._nsMap;
      if (t && Object.prototype.hasOwnProperty.call(t, i))
        return t[i];
      e = e.nodeType == Hi ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  isDefaultNamespace: function(i) {
    var e = this.lookupPrefix(i);
    return e == null;
  }
};
function md(i) {
  return i == "<" && "&lt;" || i == ">" && "&gt;" || i == "&" && "&amp;" || i == '"' && "&quot;" || "&#" + i.charCodeAt() + ";";
}
Ys(Ye, re);
Ys(Ye, re.prototype);
function Hs(i, e) {
  if (e(i))
    return !0;
  if (i = i.firstChild)
    do
      if (Hs(i, e))
        return !0;
    while (i = i.nextSibling);
}
function Qs() {
  this.ownerDocument = this;
}
function J0(i, e, t) {
  i && i._inc++;
  var s = t.namespaceURI;
  s === js.XMLNS && (e._nsMap[t.prefix ? t.localName : ""] = t.value);
}
function gd(i, e, t, s) {
  i && i._inc++;
  var r = t.namespaceURI;
  r === js.XMLNS && delete e._nsMap[t.prefix ? t.localName : ""];
}
function yo(i, e, t) {
  if (i && i._inc) {
    i._inc++;
    var s = e.childNodes;
    if (t)
      s[s.length++] = t;
    else {
      for (var r = e.firstChild, n = 0; r; )
        s[n++] = r, r = r.nextSibling;
      s.length = n, delete s[s.length];
    }
  }
}
function _d(i, e) {
  var t = e.previousSibling, s = e.nextSibling;
  return t ? t.nextSibling = s : i.firstChild = s, s ? s.previousSibling = t : i.lastChild = t, e.parentNode = null, e.previousSibling = null, e.nextSibling = null, yo(i.ownerDocument, i), e;
}
function Z0(i) {
  return i && (i.nodeType === re.DOCUMENT_NODE || i.nodeType === re.DOCUMENT_FRAGMENT_NODE || i.nodeType === re.ELEMENT_NODE);
}
function e_(i) {
  return i && (xt(i) || To(i) || Bt(i) || i.nodeType === re.DOCUMENT_FRAGMENT_NODE || i.nodeType === re.COMMENT_NODE || i.nodeType === re.PROCESSING_INSTRUCTION_NODE);
}
function Bt(i) {
  return i && i.nodeType === re.DOCUMENT_TYPE_NODE;
}
function xt(i) {
  return i && i.nodeType === re.ELEMENT_NODE;
}
function To(i) {
  return i && i.nodeType === re.TEXT_NODE;
}
function Cl(i, e) {
  var t = i.childNodes || [];
  if (bt(t, xt) || Bt(e))
    return !1;
  var s = bt(t, Bt);
  return !(e && s && t.indexOf(s) > t.indexOf(e));
}
function Al(i, e) {
  var t = i.childNodes || [];
  function s(n) {
    return xt(n) && n !== e;
  }
  if (bt(t, s))
    return !1;
  var r = bt(t, Bt);
  return !(e && r && t.indexOf(r) > t.indexOf(e));
}
function t_(i, e, t) {
  if (!Z0(i))
    throw new Se(ze, "Unexpected parent node type " + i.nodeType);
  if (t && t.parentNode !== i)
    throw new Se(hd, "child not in parent");
  if (
    // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !e_(e) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    Bt(e) && i.nodeType !== re.DOCUMENT_NODE
  )
    throw new Se(
      ze,
      "Unexpected node type " + e.nodeType + " for parent node type " + i.nodeType
    );
}
function i_(i, e, t) {
  var s = i.childNodes || [], r = e.childNodes || [];
  if (e.nodeType === re.DOCUMENT_FRAGMENT_NODE) {
    var n = r.filter(xt);
    if (n.length > 1 || bt(r, To))
      throw new Se(ze, "More than one element or text in fragment");
    if (n.length === 1 && !Cl(i, t))
      throw new Se(ze, "Element in fragment can not be inserted before doctype");
  }
  if (xt(e) && !Cl(i, t))
    throw new Se(ze, "Only one element can be added and only after doctype");
  if (Bt(e)) {
    if (bt(s, Bt))
      throw new Se(ze, "Only one doctype is allowed");
    var a = bt(s, xt);
    if (t && s.indexOf(a) < s.indexOf(t))
      throw new Se(ze, "Doctype can only be inserted before an element");
    if (!t && a)
      throw new Se(ze, "Doctype can not be appended since element is present");
  }
}
function yd(i, e, t) {
  var s = i.childNodes || [], r = e.childNodes || [];
  if (e.nodeType === re.DOCUMENT_FRAGMENT_NODE) {
    var n = r.filter(xt);
    if (n.length > 1 || bt(r, To))
      throw new Se(ze, "More than one element or text in fragment");
    if (n.length === 1 && !Al(i, t))
      throw new Se(ze, "Element in fragment can not be inserted before doctype");
  }
  if (xt(e) && !Al(i, t))
    throw new Se(ze, "Only one element can be added and only after doctype");
  if (Bt(e)) {
    if (bt(s, function(l) {
      return Bt(l) && l !== t;
    }))
      throw new Se(ze, "Only one doctype is allowed");
    var a = bt(s, xt);
    if (t && s.indexOf(a) < s.indexOf(t))
      throw new Se(ze, "Doctype can only be inserted before an element");
  }
}
function Wr(i, e, t, s) {
  t_(i, e, t), i.nodeType === re.DOCUMENT_NODE && (s || i_)(i, e, t);
  var r = e.parentNode;
  if (r && r.removeChild(e), e.nodeType === Mt) {
    var n = e.firstChild;
    if (n == null)
      return e;
    var a = e.lastChild;
  } else
    n = a = e;
  var o = t ? t.previousSibling : i.lastChild;
  n.previousSibling = o, a.nextSibling = t, o ? o.nextSibling = n : i.firstChild = n, t == null ? i.lastChild = a : t.previousSibling = a;
  do
    n.parentNode = i;
  while (n !== a && (n = n.nextSibling));
  return yo(i.ownerDocument || i, i), e.nodeType == Mt && (e.firstChild = e.lastChild = null), e;
}
function s_(i, e) {
  return e.parentNode && e.parentNode.removeChild(e), e.parentNode = i, e.previousSibling = i.lastChild, e.nextSibling = null, e.previousSibling ? e.previousSibling.nextSibling = e : i.firstChild = e, i.lastChild = e, yo(i.ownerDocument, i, e), e;
}
Qs.prototype = {
  //implementation : null,
  nodeName: "#document",
  nodeType: cd,
  /**
   * The DocumentType node of the document.
   *
   * @readonly
   * @type DocumentType
   */
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function(i, e) {
    if (i.nodeType == Mt) {
      for (var t = i.firstChild; t; ) {
        var s = t.nextSibling;
        this.insertBefore(t, e), t = s;
      }
      return i;
    }
    return Wr(this, i, e), i.ownerDocument = this, this.documentElement === null && i.nodeType === ct && (this.documentElement = i), i;
  },
  removeChild: function(i) {
    return this.documentElement == i && (this.documentElement = null), _d(this, i);
  },
  replaceChild: function(i, e) {
    Wr(this, i, e, yd), i.ownerDocument = this, e && this.removeChild(e), xt(i) && (this.documentElement = i);
  },
  // Introduced in DOM Level 2:
  importNode: function(i, e) {
    return Sd(this, i, e);
  },
  // Introduced in DOM Level 2:
  getElementById: function(i) {
    var e = null;
    return Hs(this.documentElement, function(t) {
      if (t.nodeType == ct && t.getAttribute("id") == i)
        return e = t, !0;
    }), e;
  },
  /**
   * The `getElementsByClassName` method of `Document` interface returns an array-like object
   * of all child elements which have **all** of the given class name(s).
   *
   * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
   *
   *
   * Warning: This is a live LiveNodeList.
   * Changes in the DOM will reflect in the array as the changes occur.
   * If an element selected by this array no longer qualifies for the selector,
   * it will automatically be removed. Be aware of this for iteration purposes.
   *
   * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
   * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
   */
  getElementsByClassName: function(i) {
    var e = bl(i);
    return new Vi(this, function(t) {
      var s = [];
      return e.length > 0 && Hs(t.documentElement, function(r) {
        if (r !== t && r.nodeType === ct) {
          var n = r.getAttribute("class");
          if (n) {
            var a = i === n;
            if (!a) {
              var o = bl(n);
              a = e.every(K0(o));
            }
            a && s.push(r);
          }
        }
      }), s;
    });
  },
  //document factory method:
  createElement: function(i) {
    var e = new _i();
    e.ownerDocument = this, e.nodeName = i, e.tagName = i, e.localName = i, e.childNodes = new Lt();
    var t = e.attributes = new Gr();
    return t._ownerElement = e, e;
  },
  createDocumentFragment: function() {
    var i = new xn();
    return i.ownerDocument = this, i.childNodes = new Lt(), i;
  },
  createTextNode: function(i) {
    var e = new vo();
    return e.ownerDocument = this, e.appendData(i), e;
  },
  createComment: function(i) {
    var e = new bo();
    return e.ownerDocument = this, e.appendData(i), e;
  },
  createCDATASection: function(i) {
    var e = new xo();
    return e.ownerDocument = this, e.appendData(i), e;
  },
  createProcessingInstruction: function(i, e) {
    var t = new Eo();
    return t.ownerDocument = this, t.tagName = t.nodeName = t.target = i, t.nodeValue = t.data = e, t;
  },
  createAttribute: function(i) {
    var e = new Xr();
    return e.ownerDocument = this, e.name = i, e.nodeName = i, e.localName = i, e.specified = !0, e;
  },
  createEntityReference: function(i) {
    var e = new So();
    return e.ownerDocument = this, e.nodeName = i, e;
  },
  // Introduced in DOM Level 2:
  createElementNS: function(i, e) {
    var t = new _i(), s = e.split(":"), r = t.attributes = new Gr();
    return t.childNodes = new Lt(), t.ownerDocument = this, t.nodeName = e, t.tagName = e, t.namespaceURI = i, s.length == 2 ? (t.prefix = s[0], t.localName = s[1]) : t.localName = e, r._ownerElement = t, t;
  },
  // Introduced in DOM Level 2:
  createAttributeNS: function(i, e) {
    var t = new Xr(), s = e.split(":");
    return t.ownerDocument = this, t.nodeName = e, t.name = e, t.namespaceURI = i, t.specified = !0, s.length == 2 ? (t.prefix = s[0], t.localName = s[1]) : t.localName = e, t;
  }
};
Ke(Qs, re);
function _i() {
  this._nsMap = {};
}
_i.prototype = {
  nodeType: ct,
  hasAttribute: function(i) {
    return this.getAttributeNode(i) != null;
  },
  getAttribute: function(i) {
    var e = this.getAttributeNode(i);
    return e && e.value || "";
  },
  getAttributeNode: function(i) {
    return this.attributes.getNamedItem(i);
  },
  setAttribute: function(i, e) {
    var t = this.ownerDocument.createAttribute(i);
    t.value = t.nodeValue = "" + e, this.setAttributeNode(t);
  },
  removeAttribute: function(i) {
    var e = this.getAttributeNode(i);
    e && this.removeAttributeNode(e);
  },
  //four real opeartion method
  appendChild: function(i) {
    return i.nodeType === Mt ? this.insertBefore(i, null) : s_(this, i);
  },
  setAttributeNode: function(i) {
    return this.attributes.setNamedItem(i);
  },
  setAttributeNodeNS: function(i) {
    return this.attributes.setNamedItemNS(i);
  },
  removeAttributeNode: function(i) {
    return this.attributes.removeNamedItem(i.nodeName);
  },
  //get real attribute name,and remove it by removeAttributeNode
  removeAttributeNS: function(i, e) {
    var t = this.getAttributeNodeNS(i, e);
    t && this.removeAttributeNode(t);
  },
  hasAttributeNS: function(i, e) {
    return this.getAttributeNodeNS(i, e) != null;
  },
  getAttributeNS: function(i, e) {
    var t = this.getAttributeNodeNS(i, e);
    return t && t.value || "";
  },
  setAttributeNS: function(i, e, t) {
    var s = this.ownerDocument.createAttributeNS(i, e);
    s.value = s.nodeValue = "" + t, this.setAttributeNode(s);
  },
  getAttributeNodeNS: function(i, e) {
    return this.attributes.getNamedItemNS(i, e);
  },
  getElementsByTagName: function(i) {
    return new Vi(this, function(e) {
      var t = [];
      return Hs(e, function(s) {
        s !== e && s.nodeType == ct && (i === "*" || s.tagName == i) && t.push(s);
      }), t;
    });
  },
  getElementsByTagNameNS: function(i, e) {
    return new Vi(this, function(t) {
      var s = [];
      return Hs(t, function(r) {
        r !== t && r.nodeType === ct && (i === "*" || r.namespaceURI === i) && (e === "*" || r.localName == e) && s.push(r);
      }), s;
    });
  }
};
Qs.prototype.getElementsByTagName = _i.prototype.getElementsByTagName;
Qs.prototype.getElementsByTagNameNS = _i.prototype.getElementsByTagNameNS;
Ke(_i, re);
function Xr() {
}
Xr.prototype.nodeType = Hi;
Ke(Xr, re);
function Js() {
}
Js.prototype = {
  data: "",
  substringData: function(i, e) {
    return this.data.substring(i, i + e);
  },
  appendData: function(i) {
    i = this.data + i, this.nodeValue = this.data = i, this.length = i.length;
  },
  insertData: function(i, e) {
    this.replaceData(i, 0, e);
  },
  appendChild: function(i) {
    throw new Error(we[ze]);
  },
  deleteData: function(i, e) {
    this.replaceData(i, e, "");
  },
  replaceData: function(i, e, t) {
    var s = this.data.substring(0, i), r = this.data.substring(i + e);
    t = s + t + r, this.nodeValue = this.data = t, this.length = t.length;
  }
};
Ke(Js, re);
function vo() {
}
vo.prototype = {
  nodeName: "#text",
  nodeType: zr,
  splitText: function(i) {
    var e = this.data, t = e.substring(i);
    e = e.substring(0, i), this.data = this.nodeValue = e, this.length = e.length;
    var s = this.ownerDocument.createTextNode(t);
    return this.parentNode && this.parentNode.insertBefore(s, this.nextSibling), s;
  }
};
Ke(vo, Js);
function bo() {
}
bo.prototype = {
  nodeName: "#comment",
  nodeType: ld
};
Ke(bo, Js);
function xo() {
}
xo.prototype = {
  nodeName: "#cdata-section",
  nodeType: ad
};
Ke(xo, Js);
function bn() {
}
bn.prototype.nodeType = dd;
Ke(bn, re);
function Td() {
}
Td.prototype.nodeType = Q0;
Ke(Td, re);
function vd() {
}
vd.prototype.nodeType = Y0;
Ke(vd, re);
function So() {
}
So.prototype.nodeType = od;
Ke(So, re);
function xn() {
}
xn.prototype.nodeName = "#document-fragment";
xn.prototype.nodeType = Mt;
Ke(xn, re);
function Eo() {
}
Eo.prototype.nodeType = ud;
Ke(Eo, re);
function bd() {
}
bd.prototype.serializeToString = function(i, e, t) {
  return xd.call(i, e, t);
};
re.prototype.toString = xd;
function xd(i, e) {
  var t = [], s = this.nodeType == 9 && this.documentElement || this, r = s.prefix, n = s.namespaceURI;
  if (n && r == null) {
    var r = s.lookupPrefix(n);
    if (r == null)
      var a = [
        { namespace: n, prefix: null }
        //{namespace:uri,prefix:''}
      ];
  }
  return Pi(this, t, i, e, a), t.join("");
}
function Dl(i, e, t) {
  var s = i.prefix || "", r = i.namespaceURI;
  if (!r || s === "xml" && r === js.XML || r === js.XMLNS)
    return !1;
  for (var n = t.length; n--; ) {
    var a = t[n];
    if (a.prefix === s)
      return a.namespace !== r;
  }
  return !0;
}
function ya(i, e, t) {
  i.push(" ", e, '="', t.replace(/[<>&"\t\n\r]/g, md), '"');
}
function Pi(i, e, t, s, r) {
  if (r || (r = []), s)
    if (i = s(i), i) {
      if (typeof i == "string") {
        e.push(i);
        return;
      }
    } else
      return;
  switch (i.nodeType) {
    case ct:
      var n = i.attributes, a = n.length, w = i.firstChild, o = i.tagName;
      t = js.isHTML(i.namespaceURI) || t;
      var l = o;
      if (!t && !i.prefix && i.namespaceURI) {
        for (var h, m = 0; m < n.length; m++)
          if (n.item(m).name === "xmlns") {
            h = n.item(m).value;
            break;
          }
        if (!h)
          for (var _ = r.length - 1; _ >= 0; _--) {
            var v = r[_];
            if (v.prefix === "" && v.namespace === i.namespaceURI) {
              h = v.namespace;
              break;
            }
          }
        if (h !== i.namespaceURI)
          for (var _ = r.length - 1; _ >= 0; _--) {
            var v = r[_];
            if (v.namespace === i.namespaceURI) {
              v.prefix && (l = v.prefix + ":" + o);
              break;
            }
          }
      }
      e.push("<", l);
      for (var C = 0; C < a; C++) {
        var A = n.item(C);
        A.prefix == "xmlns" ? r.push({ prefix: A.localName, namespace: A.value }) : A.nodeName == "xmlns" && r.push({ prefix: "", namespace: A.value });
      }
      for (var C = 0; C < a; C++) {
        var A = n.item(C);
        if (Dl(A, t, r)) {
          var y = A.prefix || "", D = A.namespaceURI;
          ya(e, y ? "xmlns:" + y : "xmlns", D), r.push({ prefix: y, namespace: D });
        }
        Pi(A, e, t, s, r);
      }
      if (o === l && Dl(i, t, r)) {
        var y = i.prefix || "", D = i.namespaceURI;
        ya(e, y ? "xmlns:" + y : "xmlns", D), r.push({ prefix: y, namespace: D });
      }
      if (w || t && !/^(?:meta|link|img|br|hr|input)$/i.test(o)) {
        if (e.push(">"), t && /^script$/i.test(o))
          for (; w; )
            w.data ? e.push(w.data) : Pi(w, e, t, s, r.slice()), w = w.nextSibling;
        else
          for (; w; )
            Pi(w, e, t, s, r.slice()), w = w.nextSibling;
        e.push("</", l, ">");
      } else
        e.push("/>");
      return;
    case cd:
    case Mt:
      for (var w = i.firstChild; w; )
        Pi(w, e, t, s, r.slice()), w = w.nextSibling;
      return;
    case Hi:
      return ya(e, i.name, i.value);
    case zr:
      return e.push(
        i.data.replace(/[<&>]/g, md)
      );
    case ad:
      return e.push("<![CDATA[", i.data, "]]>");
    case ld:
      return e.push("<!--", i.data, "-->");
    case dd:
      var O = i.publicId, P = i.systemId;
      if (e.push("<!DOCTYPE ", i.name), O)
        e.push(" PUBLIC ", O), P && P != "." && e.push(" ", P), e.push(">");
      else if (P && P != ".")
        e.push(" SYSTEM ", P, ">");
      else {
        var R = i.internalSubset;
        R && e.push(" [", R, "]"), e.push(">");
      }
      return;
    case ud:
      return e.push("<?", i.target, " ", i.data, "?>");
    case od:
      return e.push("&", i.nodeName, ";");
    default:
      e.push("??", i.nodeName);
  }
}
function Sd(i, e, t) {
  var s;
  switch (e.nodeType) {
    case ct:
      s = e.cloneNode(!1), s.ownerDocument = i;
    case Mt:
      break;
    case Hi:
      t = !0;
      break;
  }
  if (s || (s = e.cloneNode(!1)), s.ownerDocument = i, s.parentNode = null, t)
    for (var r = e.firstChild; r; )
      s.appendChild(Sd(i, r, t)), r = r.nextSibling;
  return s;
}
function Ma(i, e, t) {
  var s = new e.constructor();
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      var n = e[r];
      typeof n != "object" && n != s[r] && (s[r] = n);
    }
  switch (e.childNodes && (s.childNodes = new Lt()), s.ownerDocument = i, s.nodeType) {
    case ct:
      var a = e.attributes, o = s.attributes = new Gr(), l = a.length;
      o._ownerElement = s;
      for (var h = 0; h < l; h++)
        s.setAttributeNode(Ma(i, a.item(h), !0));
      break;
    case Hi:
      t = !0;
  }
  if (t)
    for (var m = e.firstChild; m; )
      s.appendChild(Ma(i, m, t)), m = m.nextSibling;
  return s;
}
function Ed(i, e, t) {
  i[e] = t;
}
try {
  if (Object.defineProperty) {
    let i = function(e) {
      switch (e.nodeType) {
        case ct:
        case Mt:
          var t = [];
          for (e = e.firstChild; e; )
            e.nodeType !== 7 && e.nodeType !== 8 && t.push(i(e)), e = e.nextSibling;
          return t.join("");
        default:
          return e.nodeValue;
      }
    };
    Object.defineProperty(Vi.prototype, "length", {
      get: function() {
        return _o(this), this.$$length;
      }
    }), Object.defineProperty(re.prototype, "textContent", {
      get: function() {
        return i(this);
      },
      set: function(e) {
        switch (this.nodeType) {
          case ct:
          case Mt:
            for (; this.firstChild; )
              this.removeChild(this.firstChild);
            (e || String(e)) && this.appendChild(this.ownerDocument.createTextNode(e));
            break;
          default:
            this.data = e, this.value = e, this.nodeValue = e;
        }
      }
    }), Ed = function(e, t, s) {
      e["$$" + t] = s;
    };
  }
} catch {
}
Yt.DocumentType = bn;
Yt.DOMException = Se;
Yt.DOMImplementation = pd;
Yt.Element = _i;
Yt.Node = re;
Yt.NodeList = Lt;
Yt.XMLSerializer = bd;
var Sn = {}, Cd = {};
(function(i) {
  var e = Ut.freeze;
  i.XML_ENTITIES = e({
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
  }), i.HTML_ENTITIES = e({
    Aacute: "Á",
    aacute: "á",
    Abreve: "Ă",
    abreve: "ă",
    ac: "∾",
    acd: "∿",
    acE: "∾̳",
    Acirc: "Â",
    acirc: "â",
    acute: "´",
    Acy: "А",
    acy: "а",
    AElig: "Æ",
    aelig: "æ",
    af: "⁡",
    Afr: "𝔄",
    afr: "𝔞",
    Agrave: "À",
    agrave: "à",
    alefsym: "ℵ",
    aleph: "ℵ",
    Alpha: "Α",
    alpha: "α",
    Amacr: "Ā",
    amacr: "ā",
    amalg: "⨿",
    AMP: "&",
    amp: "&",
    And: "⩓",
    and: "∧",
    andand: "⩕",
    andd: "⩜",
    andslope: "⩘",
    andv: "⩚",
    ang: "∠",
    ange: "⦤",
    angle: "∠",
    angmsd: "∡",
    angmsdaa: "⦨",
    angmsdab: "⦩",
    angmsdac: "⦪",
    angmsdad: "⦫",
    angmsdae: "⦬",
    angmsdaf: "⦭",
    angmsdag: "⦮",
    angmsdah: "⦯",
    angrt: "∟",
    angrtvb: "⊾",
    angrtvbd: "⦝",
    angsph: "∢",
    angst: "Å",
    angzarr: "⍼",
    Aogon: "Ą",
    aogon: "ą",
    Aopf: "𝔸",
    aopf: "𝕒",
    ap: "≈",
    apacir: "⩯",
    apE: "⩰",
    ape: "≊",
    apid: "≋",
    apos: "'",
    ApplyFunction: "⁡",
    approx: "≈",
    approxeq: "≊",
    Aring: "Å",
    aring: "å",
    Ascr: "𝒜",
    ascr: "𝒶",
    Assign: "≔",
    ast: "*",
    asymp: "≈",
    asympeq: "≍",
    Atilde: "Ã",
    atilde: "ã",
    Auml: "Ä",
    auml: "ä",
    awconint: "∳",
    awint: "⨑",
    backcong: "≌",
    backepsilon: "϶",
    backprime: "‵",
    backsim: "∽",
    backsimeq: "⋍",
    Backslash: "∖",
    Barv: "⫧",
    barvee: "⊽",
    Barwed: "⌆",
    barwed: "⌅",
    barwedge: "⌅",
    bbrk: "⎵",
    bbrktbrk: "⎶",
    bcong: "≌",
    Bcy: "Б",
    bcy: "б",
    bdquo: "„",
    becaus: "∵",
    Because: "∵",
    because: "∵",
    bemptyv: "⦰",
    bepsi: "϶",
    bernou: "ℬ",
    Bernoullis: "ℬ",
    Beta: "Β",
    beta: "β",
    beth: "ℶ",
    between: "≬",
    Bfr: "𝔅",
    bfr: "𝔟",
    bigcap: "⋂",
    bigcirc: "◯",
    bigcup: "⋃",
    bigodot: "⨀",
    bigoplus: "⨁",
    bigotimes: "⨂",
    bigsqcup: "⨆",
    bigstar: "★",
    bigtriangledown: "▽",
    bigtriangleup: "△",
    biguplus: "⨄",
    bigvee: "⋁",
    bigwedge: "⋀",
    bkarow: "⤍",
    blacklozenge: "⧫",
    blacksquare: "▪",
    blacktriangle: "▴",
    blacktriangledown: "▾",
    blacktriangleleft: "◂",
    blacktriangleright: "▸",
    blank: "␣",
    blk12: "▒",
    blk14: "░",
    blk34: "▓",
    block: "█",
    bne: "=⃥",
    bnequiv: "≡⃥",
    bNot: "⫭",
    bnot: "⌐",
    Bopf: "𝔹",
    bopf: "𝕓",
    bot: "⊥",
    bottom: "⊥",
    bowtie: "⋈",
    boxbox: "⧉",
    boxDL: "╗",
    boxDl: "╖",
    boxdL: "╕",
    boxdl: "┐",
    boxDR: "╔",
    boxDr: "╓",
    boxdR: "╒",
    boxdr: "┌",
    boxH: "═",
    boxh: "─",
    boxHD: "╦",
    boxHd: "╤",
    boxhD: "╥",
    boxhd: "┬",
    boxHU: "╩",
    boxHu: "╧",
    boxhU: "╨",
    boxhu: "┴",
    boxminus: "⊟",
    boxplus: "⊞",
    boxtimes: "⊠",
    boxUL: "╝",
    boxUl: "╜",
    boxuL: "╛",
    boxul: "┘",
    boxUR: "╚",
    boxUr: "╙",
    boxuR: "╘",
    boxur: "└",
    boxV: "║",
    boxv: "│",
    boxVH: "╬",
    boxVh: "╫",
    boxvH: "╪",
    boxvh: "┼",
    boxVL: "╣",
    boxVl: "╢",
    boxvL: "╡",
    boxvl: "┤",
    boxVR: "╠",
    boxVr: "╟",
    boxvR: "╞",
    boxvr: "├",
    bprime: "‵",
    Breve: "˘",
    breve: "˘",
    brvbar: "¦",
    Bscr: "ℬ",
    bscr: "𝒷",
    bsemi: "⁏",
    bsim: "∽",
    bsime: "⋍",
    bsol: "\\",
    bsolb: "⧅",
    bsolhsub: "⟈",
    bull: "•",
    bullet: "•",
    bump: "≎",
    bumpE: "⪮",
    bumpe: "≏",
    Bumpeq: "≎",
    bumpeq: "≏",
    Cacute: "Ć",
    cacute: "ć",
    Cap: "⋒",
    cap: "∩",
    capand: "⩄",
    capbrcup: "⩉",
    capcap: "⩋",
    capcup: "⩇",
    capdot: "⩀",
    CapitalDifferentialD: "ⅅ",
    caps: "∩︀",
    caret: "⁁",
    caron: "ˇ",
    Cayleys: "ℭ",
    ccaps: "⩍",
    Ccaron: "Č",
    ccaron: "č",
    Ccedil: "Ç",
    ccedil: "ç",
    Ccirc: "Ĉ",
    ccirc: "ĉ",
    Cconint: "∰",
    ccups: "⩌",
    ccupssm: "⩐",
    Cdot: "Ċ",
    cdot: "ċ",
    cedil: "¸",
    Cedilla: "¸",
    cemptyv: "⦲",
    cent: "¢",
    CenterDot: "·",
    centerdot: "·",
    Cfr: "ℭ",
    cfr: "𝔠",
    CHcy: "Ч",
    chcy: "ч",
    check: "✓",
    checkmark: "✓",
    Chi: "Χ",
    chi: "χ",
    cir: "○",
    circ: "ˆ",
    circeq: "≗",
    circlearrowleft: "↺",
    circlearrowright: "↻",
    circledast: "⊛",
    circledcirc: "⊚",
    circleddash: "⊝",
    CircleDot: "⊙",
    circledR: "®",
    circledS: "Ⓢ",
    CircleMinus: "⊖",
    CirclePlus: "⊕",
    CircleTimes: "⊗",
    cirE: "⧃",
    cire: "≗",
    cirfnint: "⨐",
    cirmid: "⫯",
    cirscir: "⧂",
    ClockwiseContourIntegral: "∲",
    CloseCurlyDoubleQuote: "”",
    CloseCurlyQuote: "’",
    clubs: "♣",
    clubsuit: "♣",
    Colon: "∷",
    colon: ":",
    Colone: "⩴",
    colone: "≔",
    coloneq: "≔",
    comma: ",",
    commat: "@",
    comp: "∁",
    compfn: "∘",
    complement: "∁",
    complexes: "ℂ",
    cong: "≅",
    congdot: "⩭",
    Congruent: "≡",
    Conint: "∯",
    conint: "∮",
    ContourIntegral: "∮",
    Copf: "ℂ",
    copf: "𝕔",
    coprod: "∐",
    Coproduct: "∐",
    COPY: "©",
    copy: "©",
    copysr: "℗",
    CounterClockwiseContourIntegral: "∳",
    crarr: "↵",
    Cross: "⨯",
    cross: "✗",
    Cscr: "𝒞",
    cscr: "𝒸",
    csub: "⫏",
    csube: "⫑",
    csup: "⫐",
    csupe: "⫒",
    ctdot: "⋯",
    cudarrl: "⤸",
    cudarrr: "⤵",
    cuepr: "⋞",
    cuesc: "⋟",
    cularr: "↶",
    cularrp: "⤽",
    Cup: "⋓",
    cup: "∪",
    cupbrcap: "⩈",
    CupCap: "≍",
    cupcap: "⩆",
    cupcup: "⩊",
    cupdot: "⊍",
    cupor: "⩅",
    cups: "∪︀",
    curarr: "↷",
    curarrm: "⤼",
    curlyeqprec: "⋞",
    curlyeqsucc: "⋟",
    curlyvee: "⋎",
    curlywedge: "⋏",
    curren: "¤",
    curvearrowleft: "↶",
    curvearrowright: "↷",
    cuvee: "⋎",
    cuwed: "⋏",
    cwconint: "∲",
    cwint: "∱",
    cylcty: "⌭",
    Dagger: "‡",
    dagger: "†",
    daleth: "ℸ",
    Darr: "↡",
    dArr: "⇓",
    darr: "↓",
    dash: "‐",
    Dashv: "⫤",
    dashv: "⊣",
    dbkarow: "⤏",
    dblac: "˝",
    Dcaron: "Ď",
    dcaron: "ď",
    Dcy: "Д",
    dcy: "д",
    DD: "ⅅ",
    dd: "ⅆ",
    ddagger: "‡",
    ddarr: "⇊",
    DDotrahd: "⤑",
    ddotseq: "⩷",
    deg: "°",
    Del: "∇",
    Delta: "Δ",
    delta: "δ",
    demptyv: "⦱",
    dfisht: "⥿",
    Dfr: "𝔇",
    dfr: "𝔡",
    dHar: "⥥",
    dharl: "⇃",
    dharr: "⇂",
    DiacriticalAcute: "´",
    DiacriticalDot: "˙",
    DiacriticalDoubleAcute: "˝",
    DiacriticalGrave: "`",
    DiacriticalTilde: "˜",
    diam: "⋄",
    Diamond: "⋄",
    diamond: "⋄",
    diamondsuit: "♦",
    diams: "♦",
    die: "¨",
    DifferentialD: "ⅆ",
    digamma: "ϝ",
    disin: "⋲",
    div: "÷",
    divide: "÷",
    divideontimes: "⋇",
    divonx: "⋇",
    DJcy: "Ђ",
    djcy: "ђ",
    dlcorn: "⌞",
    dlcrop: "⌍",
    dollar: "$",
    Dopf: "𝔻",
    dopf: "𝕕",
    Dot: "¨",
    dot: "˙",
    DotDot: "⃜",
    doteq: "≐",
    doteqdot: "≑",
    DotEqual: "≐",
    dotminus: "∸",
    dotplus: "∔",
    dotsquare: "⊡",
    doublebarwedge: "⌆",
    DoubleContourIntegral: "∯",
    DoubleDot: "¨",
    DoubleDownArrow: "⇓",
    DoubleLeftArrow: "⇐",
    DoubleLeftRightArrow: "⇔",
    DoubleLeftTee: "⫤",
    DoubleLongLeftArrow: "⟸",
    DoubleLongLeftRightArrow: "⟺",
    DoubleLongRightArrow: "⟹",
    DoubleRightArrow: "⇒",
    DoubleRightTee: "⊨",
    DoubleUpArrow: "⇑",
    DoubleUpDownArrow: "⇕",
    DoubleVerticalBar: "∥",
    DownArrow: "↓",
    Downarrow: "⇓",
    downarrow: "↓",
    DownArrowBar: "⤓",
    DownArrowUpArrow: "⇵",
    DownBreve: "̑",
    downdownarrows: "⇊",
    downharpoonleft: "⇃",
    downharpoonright: "⇂",
    DownLeftRightVector: "⥐",
    DownLeftTeeVector: "⥞",
    DownLeftVector: "↽",
    DownLeftVectorBar: "⥖",
    DownRightTeeVector: "⥟",
    DownRightVector: "⇁",
    DownRightVectorBar: "⥗",
    DownTee: "⊤",
    DownTeeArrow: "↧",
    drbkarow: "⤐",
    drcorn: "⌟",
    drcrop: "⌌",
    Dscr: "𝒟",
    dscr: "𝒹",
    DScy: "Ѕ",
    dscy: "ѕ",
    dsol: "⧶",
    Dstrok: "Đ",
    dstrok: "đ",
    dtdot: "⋱",
    dtri: "▿",
    dtrif: "▾",
    duarr: "⇵",
    duhar: "⥯",
    dwangle: "⦦",
    DZcy: "Џ",
    dzcy: "џ",
    dzigrarr: "⟿",
    Eacute: "É",
    eacute: "é",
    easter: "⩮",
    Ecaron: "Ě",
    ecaron: "ě",
    ecir: "≖",
    Ecirc: "Ê",
    ecirc: "ê",
    ecolon: "≕",
    Ecy: "Э",
    ecy: "э",
    eDDot: "⩷",
    Edot: "Ė",
    eDot: "≑",
    edot: "ė",
    ee: "ⅇ",
    efDot: "≒",
    Efr: "𝔈",
    efr: "𝔢",
    eg: "⪚",
    Egrave: "È",
    egrave: "è",
    egs: "⪖",
    egsdot: "⪘",
    el: "⪙",
    Element: "∈",
    elinters: "⏧",
    ell: "ℓ",
    els: "⪕",
    elsdot: "⪗",
    Emacr: "Ē",
    emacr: "ē",
    empty: "∅",
    emptyset: "∅",
    EmptySmallSquare: "◻",
    emptyv: "∅",
    EmptyVerySmallSquare: "▫",
    emsp: " ",
    emsp13: " ",
    emsp14: " ",
    ENG: "Ŋ",
    eng: "ŋ",
    ensp: " ",
    Eogon: "Ę",
    eogon: "ę",
    Eopf: "𝔼",
    eopf: "𝕖",
    epar: "⋕",
    eparsl: "⧣",
    eplus: "⩱",
    epsi: "ε",
    Epsilon: "Ε",
    epsilon: "ε",
    epsiv: "ϵ",
    eqcirc: "≖",
    eqcolon: "≕",
    eqsim: "≂",
    eqslantgtr: "⪖",
    eqslantless: "⪕",
    Equal: "⩵",
    equals: "=",
    EqualTilde: "≂",
    equest: "≟",
    Equilibrium: "⇌",
    equiv: "≡",
    equivDD: "⩸",
    eqvparsl: "⧥",
    erarr: "⥱",
    erDot: "≓",
    Escr: "ℰ",
    escr: "ℯ",
    esdot: "≐",
    Esim: "⩳",
    esim: "≂",
    Eta: "Η",
    eta: "η",
    ETH: "Ð",
    eth: "ð",
    Euml: "Ë",
    euml: "ë",
    euro: "€",
    excl: "!",
    exist: "∃",
    Exists: "∃",
    expectation: "ℰ",
    ExponentialE: "ⅇ",
    exponentiale: "ⅇ",
    fallingdotseq: "≒",
    Fcy: "Ф",
    fcy: "ф",
    female: "♀",
    ffilig: "ﬃ",
    fflig: "ﬀ",
    ffllig: "ﬄ",
    Ffr: "𝔉",
    ffr: "𝔣",
    filig: "ﬁ",
    FilledSmallSquare: "◼",
    FilledVerySmallSquare: "▪",
    fjlig: "fj",
    flat: "♭",
    fllig: "ﬂ",
    fltns: "▱",
    fnof: "ƒ",
    Fopf: "𝔽",
    fopf: "𝕗",
    ForAll: "∀",
    forall: "∀",
    fork: "⋔",
    forkv: "⫙",
    Fouriertrf: "ℱ",
    fpartint: "⨍",
    frac12: "½",
    frac13: "⅓",
    frac14: "¼",
    frac15: "⅕",
    frac16: "⅙",
    frac18: "⅛",
    frac23: "⅔",
    frac25: "⅖",
    frac34: "¾",
    frac35: "⅗",
    frac38: "⅜",
    frac45: "⅘",
    frac56: "⅚",
    frac58: "⅝",
    frac78: "⅞",
    frasl: "⁄",
    frown: "⌢",
    Fscr: "ℱ",
    fscr: "𝒻",
    gacute: "ǵ",
    Gamma: "Γ",
    gamma: "γ",
    Gammad: "Ϝ",
    gammad: "ϝ",
    gap: "⪆",
    Gbreve: "Ğ",
    gbreve: "ğ",
    Gcedil: "Ģ",
    Gcirc: "Ĝ",
    gcirc: "ĝ",
    Gcy: "Г",
    gcy: "г",
    Gdot: "Ġ",
    gdot: "ġ",
    gE: "≧",
    ge: "≥",
    gEl: "⪌",
    gel: "⋛",
    geq: "≥",
    geqq: "≧",
    geqslant: "⩾",
    ges: "⩾",
    gescc: "⪩",
    gesdot: "⪀",
    gesdoto: "⪂",
    gesdotol: "⪄",
    gesl: "⋛︀",
    gesles: "⪔",
    Gfr: "𝔊",
    gfr: "𝔤",
    Gg: "⋙",
    gg: "≫",
    ggg: "⋙",
    gimel: "ℷ",
    GJcy: "Ѓ",
    gjcy: "ѓ",
    gl: "≷",
    gla: "⪥",
    glE: "⪒",
    glj: "⪤",
    gnap: "⪊",
    gnapprox: "⪊",
    gnE: "≩",
    gne: "⪈",
    gneq: "⪈",
    gneqq: "≩",
    gnsim: "⋧",
    Gopf: "𝔾",
    gopf: "𝕘",
    grave: "`",
    GreaterEqual: "≥",
    GreaterEqualLess: "⋛",
    GreaterFullEqual: "≧",
    GreaterGreater: "⪢",
    GreaterLess: "≷",
    GreaterSlantEqual: "⩾",
    GreaterTilde: "≳",
    Gscr: "𝒢",
    gscr: "ℊ",
    gsim: "≳",
    gsime: "⪎",
    gsiml: "⪐",
    Gt: "≫",
    GT: ">",
    gt: ">",
    gtcc: "⪧",
    gtcir: "⩺",
    gtdot: "⋗",
    gtlPar: "⦕",
    gtquest: "⩼",
    gtrapprox: "⪆",
    gtrarr: "⥸",
    gtrdot: "⋗",
    gtreqless: "⋛",
    gtreqqless: "⪌",
    gtrless: "≷",
    gtrsim: "≳",
    gvertneqq: "≩︀",
    gvnE: "≩︀",
    Hacek: "ˇ",
    hairsp: " ",
    half: "½",
    hamilt: "ℋ",
    HARDcy: "Ъ",
    hardcy: "ъ",
    hArr: "⇔",
    harr: "↔",
    harrcir: "⥈",
    harrw: "↭",
    Hat: "^",
    hbar: "ℏ",
    Hcirc: "Ĥ",
    hcirc: "ĥ",
    hearts: "♥",
    heartsuit: "♥",
    hellip: "…",
    hercon: "⊹",
    Hfr: "ℌ",
    hfr: "𝔥",
    HilbertSpace: "ℋ",
    hksearow: "⤥",
    hkswarow: "⤦",
    hoarr: "⇿",
    homtht: "∻",
    hookleftarrow: "↩",
    hookrightarrow: "↪",
    Hopf: "ℍ",
    hopf: "𝕙",
    horbar: "―",
    HorizontalLine: "─",
    Hscr: "ℋ",
    hscr: "𝒽",
    hslash: "ℏ",
    Hstrok: "Ħ",
    hstrok: "ħ",
    HumpDownHump: "≎",
    HumpEqual: "≏",
    hybull: "⁃",
    hyphen: "‐",
    Iacute: "Í",
    iacute: "í",
    ic: "⁣",
    Icirc: "Î",
    icirc: "î",
    Icy: "И",
    icy: "и",
    Idot: "İ",
    IEcy: "Е",
    iecy: "е",
    iexcl: "¡",
    iff: "⇔",
    Ifr: "ℑ",
    ifr: "𝔦",
    Igrave: "Ì",
    igrave: "ì",
    ii: "ⅈ",
    iiiint: "⨌",
    iiint: "∭",
    iinfin: "⧜",
    iiota: "℩",
    IJlig: "Ĳ",
    ijlig: "ĳ",
    Im: "ℑ",
    Imacr: "Ī",
    imacr: "ī",
    image: "ℑ",
    ImaginaryI: "ⅈ",
    imagline: "ℐ",
    imagpart: "ℑ",
    imath: "ı",
    imof: "⊷",
    imped: "Ƶ",
    Implies: "⇒",
    in: "∈",
    incare: "℅",
    infin: "∞",
    infintie: "⧝",
    inodot: "ı",
    Int: "∬",
    int: "∫",
    intcal: "⊺",
    integers: "ℤ",
    Integral: "∫",
    intercal: "⊺",
    Intersection: "⋂",
    intlarhk: "⨗",
    intprod: "⨼",
    InvisibleComma: "⁣",
    InvisibleTimes: "⁢",
    IOcy: "Ё",
    iocy: "ё",
    Iogon: "Į",
    iogon: "į",
    Iopf: "𝕀",
    iopf: "𝕚",
    Iota: "Ι",
    iota: "ι",
    iprod: "⨼",
    iquest: "¿",
    Iscr: "ℐ",
    iscr: "𝒾",
    isin: "∈",
    isindot: "⋵",
    isinE: "⋹",
    isins: "⋴",
    isinsv: "⋳",
    isinv: "∈",
    it: "⁢",
    Itilde: "Ĩ",
    itilde: "ĩ",
    Iukcy: "І",
    iukcy: "і",
    Iuml: "Ï",
    iuml: "ï",
    Jcirc: "Ĵ",
    jcirc: "ĵ",
    Jcy: "Й",
    jcy: "й",
    Jfr: "𝔍",
    jfr: "𝔧",
    jmath: "ȷ",
    Jopf: "𝕁",
    jopf: "𝕛",
    Jscr: "𝒥",
    jscr: "𝒿",
    Jsercy: "Ј",
    jsercy: "ј",
    Jukcy: "Є",
    jukcy: "є",
    Kappa: "Κ",
    kappa: "κ",
    kappav: "ϰ",
    Kcedil: "Ķ",
    kcedil: "ķ",
    Kcy: "К",
    kcy: "к",
    Kfr: "𝔎",
    kfr: "𝔨",
    kgreen: "ĸ",
    KHcy: "Х",
    khcy: "х",
    KJcy: "Ќ",
    kjcy: "ќ",
    Kopf: "𝕂",
    kopf: "𝕜",
    Kscr: "𝒦",
    kscr: "𝓀",
    lAarr: "⇚",
    Lacute: "Ĺ",
    lacute: "ĺ",
    laemptyv: "⦴",
    lagran: "ℒ",
    Lambda: "Λ",
    lambda: "λ",
    Lang: "⟪",
    lang: "⟨",
    langd: "⦑",
    langle: "⟨",
    lap: "⪅",
    Laplacetrf: "ℒ",
    laquo: "«",
    Larr: "↞",
    lArr: "⇐",
    larr: "←",
    larrb: "⇤",
    larrbfs: "⤟",
    larrfs: "⤝",
    larrhk: "↩",
    larrlp: "↫",
    larrpl: "⤹",
    larrsim: "⥳",
    larrtl: "↢",
    lat: "⪫",
    lAtail: "⤛",
    latail: "⤙",
    late: "⪭",
    lates: "⪭︀",
    lBarr: "⤎",
    lbarr: "⤌",
    lbbrk: "❲",
    lbrace: "{",
    lbrack: "[",
    lbrke: "⦋",
    lbrksld: "⦏",
    lbrkslu: "⦍",
    Lcaron: "Ľ",
    lcaron: "ľ",
    Lcedil: "Ļ",
    lcedil: "ļ",
    lceil: "⌈",
    lcub: "{",
    Lcy: "Л",
    lcy: "л",
    ldca: "⤶",
    ldquo: "“",
    ldquor: "„",
    ldrdhar: "⥧",
    ldrushar: "⥋",
    ldsh: "↲",
    lE: "≦",
    le: "≤",
    LeftAngleBracket: "⟨",
    LeftArrow: "←",
    Leftarrow: "⇐",
    leftarrow: "←",
    LeftArrowBar: "⇤",
    LeftArrowRightArrow: "⇆",
    leftarrowtail: "↢",
    LeftCeiling: "⌈",
    LeftDoubleBracket: "⟦",
    LeftDownTeeVector: "⥡",
    LeftDownVector: "⇃",
    LeftDownVectorBar: "⥙",
    LeftFloor: "⌊",
    leftharpoondown: "↽",
    leftharpoonup: "↼",
    leftleftarrows: "⇇",
    LeftRightArrow: "↔",
    Leftrightarrow: "⇔",
    leftrightarrow: "↔",
    leftrightarrows: "⇆",
    leftrightharpoons: "⇋",
    leftrightsquigarrow: "↭",
    LeftRightVector: "⥎",
    LeftTee: "⊣",
    LeftTeeArrow: "↤",
    LeftTeeVector: "⥚",
    leftthreetimes: "⋋",
    LeftTriangle: "⊲",
    LeftTriangleBar: "⧏",
    LeftTriangleEqual: "⊴",
    LeftUpDownVector: "⥑",
    LeftUpTeeVector: "⥠",
    LeftUpVector: "↿",
    LeftUpVectorBar: "⥘",
    LeftVector: "↼",
    LeftVectorBar: "⥒",
    lEg: "⪋",
    leg: "⋚",
    leq: "≤",
    leqq: "≦",
    leqslant: "⩽",
    les: "⩽",
    lescc: "⪨",
    lesdot: "⩿",
    lesdoto: "⪁",
    lesdotor: "⪃",
    lesg: "⋚︀",
    lesges: "⪓",
    lessapprox: "⪅",
    lessdot: "⋖",
    lesseqgtr: "⋚",
    lesseqqgtr: "⪋",
    LessEqualGreater: "⋚",
    LessFullEqual: "≦",
    LessGreater: "≶",
    lessgtr: "≶",
    LessLess: "⪡",
    lesssim: "≲",
    LessSlantEqual: "⩽",
    LessTilde: "≲",
    lfisht: "⥼",
    lfloor: "⌊",
    Lfr: "𝔏",
    lfr: "𝔩",
    lg: "≶",
    lgE: "⪑",
    lHar: "⥢",
    lhard: "↽",
    lharu: "↼",
    lharul: "⥪",
    lhblk: "▄",
    LJcy: "Љ",
    ljcy: "љ",
    Ll: "⋘",
    ll: "≪",
    llarr: "⇇",
    llcorner: "⌞",
    Lleftarrow: "⇚",
    llhard: "⥫",
    lltri: "◺",
    Lmidot: "Ŀ",
    lmidot: "ŀ",
    lmoust: "⎰",
    lmoustache: "⎰",
    lnap: "⪉",
    lnapprox: "⪉",
    lnE: "≨",
    lne: "⪇",
    lneq: "⪇",
    lneqq: "≨",
    lnsim: "⋦",
    loang: "⟬",
    loarr: "⇽",
    lobrk: "⟦",
    LongLeftArrow: "⟵",
    Longleftarrow: "⟸",
    longleftarrow: "⟵",
    LongLeftRightArrow: "⟷",
    Longleftrightarrow: "⟺",
    longleftrightarrow: "⟷",
    longmapsto: "⟼",
    LongRightArrow: "⟶",
    Longrightarrow: "⟹",
    longrightarrow: "⟶",
    looparrowleft: "↫",
    looparrowright: "↬",
    lopar: "⦅",
    Lopf: "𝕃",
    lopf: "𝕝",
    loplus: "⨭",
    lotimes: "⨴",
    lowast: "∗",
    lowbar: "_",
    LowerLeftArrow: "↙",
    LowerRightArrow: "↘",
    loz: "◊",
    lozenge: "◊",
    lozf: "⧫",
    lpar: "(",
    lparlt: "⦓",
    lrarr: "⇆",
    lrcorner: "⌟",
    lrhar: "⇋",
    lrhard: "⥭",
    lrm: "‎",
    lrtri: "⊿",
    lsaquo: "‹",
    Lscr: "ℒ",
    lscr: "𝓁",
    Lsh: "↰",
    lsh: "↰",
    lsim: "≲",
    lsime: "⪍",
    lsimg: "⪏",
    lsqb: "[",
    lsquo: "‘",
    lsquor: "‚",
    Lstrok: "Ł",
    lstrok: "ł",
    Lt: "≪",
    LT: "<",
    lt: "<",
    ltcc: "⪦",
    ltcir: "⩹",
    ltdot: "⋖",
    lthree: "⋋",
    ltimes: "⋉",
    ltlarr: "⥶",
    ltquest: "⩻",
    ltri: "◃",
    ltrie: "⊴",
    ltrif: "◂",
    ltrPar: "⦖",
    lurdshar: "⥊",
    luruhar: "⥦",
    lvertneqq: "≨︀",
    lvnE: "≨︀",
    macr: "¯",
    male: "♂",
    malt: "✠",
    maltese: "✠",
    Map: "⤅",
    map: "↦",
    mapsto: "↦",
    mapstodown: "↧",
    mapstoleft: "↤",
    mapstoup: "↥",
    marker: "▮",
    mcomma: "⨩",
    Mcy: "М",
    mcy: "м",
    mdash: "—",
    mDDot: "∺",
    measuredangle: "∡",
    MediumSpace: " ",
    Mellintrf: "ℳ",
    Mfr: "𝔐",
    mfr: "𝔪",
    mho: "℧",
    micro: "µ",
    mid: "∣",
    midast: "*",
    midcir: "⫰",
    middot: "·",
    minus: "−",
    minusb: "⊟",
    minusd: "∸",
    minusdu: "⨪",
    MinusPlus: "∓",
    mlcp: "⫛",
    mldr: "…",
    mnplus: "∓",
    models: "⊧",
    Mopf: "𝕄",
    mopf: "𝕞",
    mp: "∓",
    Mscr: "ℳ",
    mscr: "𝓂",
    mstpos: "∾",
    Mu: "Μ",
    mu: "μ",
    multimap: "⊸",
    mumap: "⊸",
    nabla: "∇",
    Nacute: "Ń",
    nacute: "ń",
    nang: "∠⃒",
    nap: "≉",
    napE: "⩰̸",
    napid: "≋̸",
    napos: "ŉ",
    napprox: "≉",
    natur: "♮",
    natural: "♮",
    naturals: "ℕ",
    nbsp: " ",
    nbump: "≎̸",
    nbumpe: "≏̸",
    ncap: "⩃",
    Ncaron: "Ň",
    ncaron: "ň",
    Ncedil: "Ņ",
    ncedil: "ņ",
    ncong: "≇",
    ncongdot: "⩭̸",
    ncup: "⩂",
    Ncy: "Н",
    ncy: "н",
    ndash: "–",
    ne: "≠",
    nearhk: "⤤",
    neArr: "⇗",
    nearr: "↗",
    nearrow: "↗",
    nedot: "≐̸",
    NegativeMediumSpace: "​",
    NegativeThickSpace: "​",
    NegativeThinSpace: "​",
    NegativeVeryThinSpace: "​",
    nequiv: "≢",
    nesear: "⤨",
    nesim: "≂̸",
    NestedGreaterGreater: "≫",
    NestedLessLess: "≪",
    NewLine: `
`,
    nexist: "∄",
    nexists: "∄",
    Nfr: "𝔑",
    nfr: "𝔫",
    ngE: "≧̸",
    nge: "≱",
    ngeq: "≱",
    ngeqq: "≧̸",
    ngeqslant: "⩾̸",
    nges: "⩾̸",
    nGg: "⋙̸",
    ngsim: "≵",
    nGt: "≫⃒",
    ngt: "≯",
    ngtr: "≯",
    nGtv: "≫̸",
    nhArr: "⇎",
    nharr: "↮",
    nhpar: "⫲",
    ni: "∋",
    nis: "⋼",
    nisd: "⋺",
    niv: "∋",
    NJcy: "Њ",
    njcy: "њ",
    nlArr: "⇍",
    nlarr: "↚",
    nldr: "‥",
    nlE: "≦̸",
    nle: "≰",
    nLeftarrow: "⇍",
    nleftarrow: "↚",
    nLeftrightarrow: "⇎",
    nleftrightarrow: "↮",
    nleq: "≰",
    nleqq: "≦̸",
    nleqslant: "⩽̸",
    nles: "⩽̸",
    nless: "≮",
    nLl: "⋘̸",
    nlsim: "≴",
    nLt: "≪⃒",
    nlt: "≮",
    nltri: "⋪",
    nltrie: "⋬",
    nLtv: "≪̸",
    nmid: "∤",
    NoBreak: "⁠",
    NonBreakingSpace: " ",
    Nopf: "ℕ",
    nopf: "𝕟",
    Not: "⫬",
    not: "¬",
    NotCongruent: "≢",
    NotCupCap: "≭",
    NotDoubleVerticalBar: "∦",
    NotElement: "∉",
    NotEqual: "≠",
    NotEqualTilde: "≂̸",
    NotExists: "∄",
    NotGreater: "≯",
    NotGreaterEqual: "≱",
    NotGreaterFullEqual: "≧̸",
    NotGreaterGreater: "≫̸",
    NotGreaterLess: "≹",
    NotGreaterSlantEqual: "⩾̸",
    NotGreaterTilde: "≵",
    NotHumpDownHump: "≎̸",
    NotHumpEqual: "≏̸",
    notin: "∉",
    notindot: "⋵̸",
    notinE: "⋹̸",
    notinva: "∉",
    notinvb: "⋷",
    notinvc: "⋶",
    NotLeftTriangle: "⋪",
    NotLeftTriangleBar: "⧏̸",
    NotLeftTriangleEqual: "⋬",
    NotLess: "≮",
    NotLessEqual: "≰",
    NotLessGreater: "≸",
    NotLessLess: "≪̸",
    NotLessSlantEqual: "⩽̸",
    NotLessTilde: "≴",
    NotNestedGreaterGreater: "⪢̸",
    NotNestedLessLess: "⪡̸",
    notni: "∌",
    notniva: "∌",
    notnivb: "⋾",
    notnivc: "⋽",
    NotPrecedes: "⊀",
    NotPrecedesEqual: "⪯̸",
    NotPrecedesSlantEqual: "⋠",
    NotReverseElement: "∌",
    NotRightTriangle: "⋫",
    NotRightTriangleBar: "⧐̸",
    NotRightTriangleEqual: "⋭",
    NotSquareSubset: "⊏̸",
    NotSquareSubsetEqual: "⋢",
    NotSquareSuperset: "⊐̸",
    NotSquareSupersetEqual: "⋣",
    NotSubset: "⊂⃒",
    NotSubsetEqual: "⊈",
    NotSucceeds: "⊁",
    NotSucceedsEqual: "⪰̸",
    NotSucceedsSlantEqual: "⋡",
    NotSucceedsTilde: "≿̸",
    NotSuperset: "⊃⃒",
    NotSupersetEqual: "⊉",
    NotTilde: "≁",
    NotTildeEqual: "≄",
    NotTildeFullEqual: "≇",
    NotTildeTilde: "≉",
    NotVerticalBar: "∤",
    npar: "∦",
    nparallel: "∦",
    nparsl: "⫽⃥",
    npart: "∂̸",
    npolint: "⨔",
    npr: "⊀",
    nprcue: "⋠",
    npre: "⪯̸",
    nprec: "⊀",
    npreceq: "⪯̸",
    nrArr: "⇏",
    nrarr: "↛",
    nrarrc: "⤳̸",
    nrarrw: "↝̸",
    nRightarrow: "⇏",
    nrightarrow: "↛",
    nrtri: "⋫",
    nrtrie: "⋭",
    nsc: "⊁",
    nsccue: "⋡",
    nsce: "⪰̸",
    Nscr: "𝒩",
    nscr: "𝓃",
    nshortmid: "∤",
    nshortparallel: "∦",
    nsim: "≁",
    nsime: "≄",
    nsimeq: "≄",
    nsmid: "∤",
    nspar: "∦",
    nsqsube: "⋢",
    nsqsupe: "⋣",
    nsub: "⊄",
    nsubE: "⫅̸",
    nsube: "⊈",
    nsubset: "⊂⃒",
    nsubseteq: "⊈",
    nsubseteqq: "⫅̸",
    nsucc: "⊁",
    nsucceq: "⪰̸",
    nsup: "⊅",
    nsupE: "⫆̸",
    nsupe: "⊉",
    nsupset: "⊃⃒",
    nsupseteq: "⊉",
    nsupseteqq: "⫆̸",
    ntgl: "≹",
    Ntilde: "Ñ",
    ntilde: "ñ",
    ntlg: "≸",
    ntriangleleft: "⋪",
    ntrianglelefteq: "⋬",
    ntriangleright: "⋫",
    ntrianglerighteq: "⋭",
    Nu: "Ν",
    nu: "ν",
    num: "#",
    numero: "№",
    numsp: " ",
    nvap: "≍⃒",
    nVDash: "⊯",
    nVdash: "⊮",
    nvDash: "⊭",
    nvdash: "⊬",
    nvge: "≥⃒",
    nvgt: ">⃒",
    nvHarr: "⤄",
    nvinfin: "⧞",
    nvlArr: "⤂",
    nvle: "≤⃒",
    nvlt: "<⃒",
    nvltrie: "⊴⃒",
    nvrArr: "⤃",
    nvrtrie: "⊵⃒",
    nvsim: "∼⃒",
    nwarhk: "⤣",
    nwArr: "⇖",
    nwarr: "↖",
    nwarrow: "↖",
    nwnear: "⤧",
    Oacute: "Ó",
    oacute: "ó",
    oast: "⊛",
    ocir: "⊚",
    Ocirc: "Ô",
    ocirc: "ô",
    Ocy: "О",
    ocy: "о",
    odash: "⊝",
    Odblac: "Ő",
    odblac: "ő",
    odiv: "⨸",
    odot: "⊙",
    odsold: "⦼",
    OElig: "Œ",
    oelig: "œ",
    ofcir: "⦿",
    Ofr: "𝔒",
    ofr: "𝔬",
    ogon: "˛",
    Ograve: "Ò",
    ograve: "ò",
    ogt: "⧁",
    ohbar: "⦵",
    ohm: "Ω",
    oint: "∮",
    olarr: "↺",
    olcir: "⦾",
    olcross: "⦻",
    oline: "‾",
    olt: "⧀",
    Omacr: "Ō",
    omacr: "ō",
    Omega: "Ω",
    omega: "ω",
    Omicron: "Ο",
    omicron: "ο",
    omid: "⦶",
    ominus: "⊖",
    Oopf: "𝕆",
    oopf: "𝕠",
    opar: "⦷",
    OpenCurlyDoubleQuote: "“",
    OpenCurlyQuote: "‘",
    operp: "⦹",
    oplus: "⊕",
    Or: "⩔",
    or: "∨",
    orarr: "↻",
    ord: "⩝",
    order: "ℴ",
    orderof: "ℴ",
    ordf: "ª",
    ordm: "º",
    origof: "⊶",
    oror: "⩖",
    orslope: "⩗",
    orv: "⩛",
    oS: "Ⓢ",
    Oscr: "𝒪",
    oscr: "ℴ",
    Oslash: "Ø",
    oslash: "ø",
    osol: "⊘",
    Otilde: "Õ",
    otilde: "õ",
    Otimes: "⨷",
    otimes: "⊗",
    otimesas: "⨶",
    Ouml: "Ö",
    ouml: "ö",
    ovbar: "⌽",
    OverBar: "‾",
    OverBrace: "⏞",
    OverBracket: "⎴",
    OverParenthesis: "⏜",
    par: "∥",
    para: "¶",
    parallel: "∥",
    parsim: "⫳",
    parsl: "⫽",
    part: "∂",
    PartialD: "∂",
    Pcy: "П",
    pcy: "п",
    percnt: "%",
    period: ".",
    permil: "‰",
    perp: "⊥",
    pertenk: "‱",
    Pfr: "𝔓",
    pfr: "𝔭",
    Phi: "Φ",
    phi: "φ",
    phiv: "ϕ",
    phmmat: "ℳ",
    phone: "☎",
    Pi: "Π",
    pi: "π",
    pitchfork: "⋔",
    piv: "ϖ",
    planck: "ℏ",
    planckh: "ℎ",
    plankv: "ℏ",
    plus: "+",
    plusacir: "⨣",
    plusb: "⊞",
    pluscir: "⨢",
    plusdo: "∔",
    plusdu: "⨥",
    pluse: "⩲",
    PlusMinus: "±",
    plusmn: "±",
    plussim: "⨦",
    plustwo: "⨧",
    pm: "±",
    Poincareplane: "ℌ",
    pointint: "⨕",
    Popf: "ℙ",
    popf: "𝕡",
    pound: "£",
    Pr: "⪻",
    pr: "≺",
    prap: "⪷",
    prcue: "≼",
    prE: "⪳",
    pre: "⪯",
    prec: "≺",
    precapprox: "⪷",
    preccurlyeq: "≼",
    Precedes: "≺",
    PrecedesEqual: "⪯",
    PrecedesSlantEqual: "≼",
    PrecedesTilde: "≾",
    preceq: "⪯",
    precnapprox: "⪹",
    precneqq: "⪵",
    precnsim: "⋨",
    precsim: "≾",
    Prime: "″",
    prime: "′",
    primes: "ℙ",
    prnap: "⪹",
    prnE: "⪵",
    prnsim: "⋨",
    prod: "∏",
    Product: "∏",
    profalar: "⌮",
    profline: "⌒",
    profsurf: "⌓",
    prop: "∝",
    Proportion: "∷",
    Proportional: "∝",
    propto: "∝",
    prsim: "≾",
    prurel: "⊰",
    Pscr: "𝒫",
    pscr: "𝓅",
    Psi: "Ψ",
    psi: "ψ",
    puncsp: " ",
    Qfr: "𝔔",
    qfr: "𝔮",
    qint: "⨌",
    Qopf: "ℚ",
    qopf: "𝕢",
    qprime: "⁗",
    Qscr: "𝒬",
    qscr: "𝓆",
    quaternions: "ℍ",
    quatint: "⨖",
    quest: "?",
    questeq: "≟",
    QUOT: '"',
    quot: '"',
    rAarr: "⇛",
    race: "∽̱",
    Racute: "Ŕ",
    racute: "ŕ",
    radic: "√",
    raemptyv: "⦳",
    Rang: "⟫",
    rang: "⟩",
    rangd: "⦒",
    range: "⦥",
    rangle: "⟩",
    raquo: "»",
    Rarr: "↠",
    rArr: "⇒",
    rarr: "→",
    rarrap: "⥵",
    rarrb: "⇥",
    rarrbfs: "⤠",
    rarrc: "⤳",
    rarrfs: "⤞",
    rarrhk: "↪",
    rarrlp: "↬",
    rarrpl: "⥅",
    rarrsim: "⥴",
    Rarrtl: "⤖",
    rarrtl: "↣",
    rarrw: "↝",
    rAtail: "⤜",
    ratail: "⤚",
    ratio: "∶",
    rationals: "ℚ",
    RBarr: "⤐",
    rBarr: "⤏",
    rbarr: "⤍",
    rbbrk: "❳",
    rbrace: "}",
    rbrack: "]",
    rbrke: "⦌",
    rbrksld: "⦎",
    rbrkslu: "⦐",
    Rcaron: "Ř",
    rcaron: "ř",
    Rcedil: "Ŗ",
    rcedil: "ŗ",
    rceil: "⌉",
    rcub: "}",
    Rcy: "Р",
    rcy: "р",
    rdca: "⤷",
    rdldhar: "⥩",
    rdquo: "”",
    rdquor: "”",
    rdsh: "↳",
    Re: "ℜ",
    real: "ℜ",
    realine: "ℛ",
    realpart: "ℜ",
    reals: "ℝ",
    rect: "▭",
    REG: "®",
    reg: "®",
    ReverseElement: "∋",
    ReverseEquilibrium: "⇋",
    ReverseUpEquilibrium: "⥯",
    rfisht: "⥽",
    rfloor: "⌋",
    Rfr: "ℜ",
    rfr: "𝔯",
    rHar: "⥤",
    rhard: "⇁",
    rharu: "⇀",
    rharul: "⥬",
    Rho: "Ρ",
    rho: "ρ",
    rhov: "ϱ",
    RightAngleBracket: "⟩",
    RightArrow: "→",
    Rightarrow: "⇒",
    rightarrow: "→",
    RightArrowBar: "⇥",
    RightArrowLeftArrow: "⇄",
    rightarrowtail: "↣",
    RightCeiling: "⌉",
    RightDoubleBracket: "⟧",
    RightDownTeeVector: "⥝",
    RightDownVector: "⇂",
    RightDownVectorBar: "⥕",
    RightFloor: "⌋",
    rightharpoondown: "⇁",
    rightharpoonup: "⇀",
    rightleftarrows: "⇄",
    rightleftharpoons: "⇌",
    rightrightarrows: "⇉",
    rightsquigarrow: "↝",
    RightTee: "⊢",
    RightTeeArrow: "↦",
    RightTeeVector: "⥛",
    rightthreetimes: "⋌",
    RightTriangle: "⊳",
    RightTriangleBar: "⧐",
    RightTriangleEqual: "⊵",
    RightUpDownVector: "⥏",
    RightUpTeeVector: "⥜",
    RightUpVector: "↾",
    RightUpVectorBar: "⥔",
    RightVector: "⇀",
    RightVectorBar: "⥓",
    ring: "˚",
    risingdotseq: "≓",
    rlarr: "⇄",
    rlhar: "⇌",
    rlm: "‏",
    rmoust: "⎱",
    rmoustache: "⎱",
    rnmid: "⫮",
    roang: "⟭",
    roarr: "⇾",
    robrk: "⟧",
    ropar: "⦆",
    Ropf: "ℝ",
    ropf: "𝕣",
    roplus: "⨮",
    rotimes: "⨵",
    RoundImplies: "⥰",
    rpar: ")",
    rpargt: "⦔",
    rppolint: "⨒",
    rrarr: "⇉",
    Rrightarrow: "⇛",
    rsaquo: "›",
    Rscr: "ℛ",
    rscr: "𝓇",
    Rsh: "↱",
    rsh: "↱",
    rsqb: "]",
    rsquo: "’",
    rsquor: "’",
    rthree: "⋌",
    rtimes: "⋊",
    rtri: "▹",
    rtrie: "⊵",
    rtrif: "▸",
    rtriltri: "⧎",
    RuleDelayed: "⧴",
    ruluhar: "⥨",
    rx: "℞",
    Sacute: "Ś",
    sacute: "ś",
    sbquo: "‚",
    Sc: "⪼",
    sc: "≻",
    scap: "⪸",
    Scaron: "Š",
    scaron: "š",
    sccue: "≽",
    scE: "⪴",
    sce: "⪰",
    Scedil: "Ş",
    scedil: "ş",
    Scirc: "Ŝ",
    scirc: "ŝ",
    scnap: "⪺",
    scnE: "⪶",
    scnsim: "⋩",
    scpolint: "⨓",
    scsim: "≿",
    Scy: "С",
    scy: "с",
    sdot: "⋅",
    sdotb: "⊡",
    sdote: "⩦",
    searhk: "⤥",
    seArr: "⇘",
    searr: "↘",
    searrow: "↘",
    sect: "§",
    semi: ";",
    seswar: "⤩",
    setminus: "∖",
    setmn: "∖",
    sext: "✶",
    Sfr: "𝔖",
    sfr: "𝔰",
    sfrown: "⌢",
    sharp: "♯",
    SHCHcy: "Щ",
    shchcy: "щ",
    SHcy: "Ш",
    shcy: "ш",
    ShortDownArrow: "↓",
    ShortLeftArrow: "←",
    shortmid: "∣",
    shortparallel: "∥",
    ShortRightArrow: "→",
    ShortUpArrow: "↑",
    shy: "­",
    Sigma: "Σ",
    sigma: "σ",
    sigmaf: "ς",
    sigmav: "ς",
    sim: "∼",
    simdot: "⩪",
    sime: "≃",
    simeq: "≃",
    simg: "⪞",
    simgE: "⪠",
    siml: "⪝",
    simlE: "⪟",
    simne: "≆",
    simplus: "⨤",
    simrarr: "⥲",
    slarr: "←",
    SmallCircle: "∘",
    smallsetminus: "∖",
    smashp: "⨳",
    smeparsl: "⧤",
    smid: "∣",
    smile: "⌣",
    smt: "⪪",
    smte: "⪬",
    smtes: "⪬︀",
    SOFTcy: "Ь",
    softcy: "ь",
    sol: "/",
    solb: "⧄",
    solbar: "⌿",
    Sopf: "𝕊",
    sopf: "𝕤",
    spades: "♠",
    spadesuit: "♠",
    spar: "∥",
    sqcap: "⊓",
    sqcaps: "⊓︀",
    sqcup: "⊔",
    sqcups: "⊔︀",
    Sqrt: "√",
    sqsub: "⊏",
    sqsube: "⊑",
    sqsubset: "⊏",
    sqsubseteq: "⊑",
    sqsup: "⊐",
    sqsupe: "⊒",
    sqsupset: "⊐",
    sqsupseteq: "⊒",
    squ: "□",
    Square: "□",
    square: "□",
    SquareIntersection: "⊓",
    SquareSubset: "⊏",
    SquareSubsetEqual: "⊑",
    SquareSuperset: "⊐",
    SquareSupersetEqual: "⊒",
    SquareUnion: "⊔",
    squarf: "▪",
    squf: "▪",
    srarr: "→",
    Sscr: "𝒮",
    sscr: "𝓈",
    ssetmn: "∖",
    ssmile: "⌣",
    sstarf: "⋆",
    Star: "⋆",
    star: "☆",
    starf: "★",
    straightepsilon: "ϵ",
    straightphi: "ϕ",
    strns: "¯",
    Sub: "⋐",
    sub: "⊂",
    subdot: "⪽",
    subE: "⫅",
    sube: "⊆",
    subedot: "⫃",
    submult: "⫁",
    subnE: "⫋",
    subne: "⊊",
    subplus: "⪿",
    subrarr: "⥹",
    Subset: "⋐",
    subset: "⊂",
    subseteq: "⊆",
    subseteqq: "⫅",
    SubsetEqual: "⊆",
    subsetneq: "⊊",
    subsetneqq: "⫋",
    subsim: "⫇",
    subsub: "⫕",
    subsup: "⫓",
    succ: "≻",
    succapprox: "⪸",
    succcurlyeq: "≽",
    Succeeds: "≻",
    SucceedsEqual: "⪰",
    SucceedsSlantEqual: "≽",
    SucceedsTilde: "≿",
    succeq: "⪰",
    succnapprox: "⪺",
    succneqq: "⪶",
    succnsim: "⋩",
    succsim: "≿",
    SuchThat: "∋",
    Sum: "∑",
    sum: "∑",
    sung: "♪",
    Sup: "⋑",
    sup: "⊃",
    sup1: "¹",
    sup2: "²",
    sup3: "³",
    supdot: "⪾",
    supdsub: "⫘",
    supE: "⫆",
    supe: "⊇",
    supedot: "⫄",
    Superset: "⊃",
    SupersetEqual: "⊇",
    suphsol: "⟉",
    suphsub: "⫗",
    suplarr: "⥻",
    supmult: "⫂",
    supnE: "⫌",
    supne: "⊋",
    supplus: "⫀",
    Supset: "⋑",
    supset: "⊃",
    supseteq: "⊇",
    supseteqq: "⫆",
    supsetneq: "⊋",
    supsetneqq: "⫌",
    supsim: "⫈",
    supsub: "⫔",
    supsup: "⫖",
    swarhk: "⤦",
    swArr: "⇙",
    swarr: "↙",
    swarrow: "↙",
    swnwar: "⤪",
    szlig: "ß",
    Tab: "	",
    target: "⌖",
    Tau: "Τ",
    tau: "τ",
    tbrk: "⎴",
    Tcaron: "Ť",
    tcaron: "ť",
    Tcedil: "Ţ",
    tcedil: "ţ",
    Tcy: "Т",
    tcy: "т",
    tdot: "⃛",
    telrec: "⌕",
    Tfr: "𝔗",
    tfr: "𝔱",
    there4: "∴",
    Therefore: "∴",
    therefore: "∴",
    Theta: "Θ",
    theta: "θ",
    thetasym: "ϑ",
    thetav: "ϑ",
    thickapprox: "≈",
    thicksim: "∼",
    ThickSpace: "  ",
    thinsp: " ",
    ThinSpace: " ",
    thkap: "≈",
    thksim: "∼",
    THORN: "Þ",
    thorn: "þ",
    Tilde: "∼",
    tilde: "˜",
    TildeEqual: "≃",
    TildeFullEqual: "≅",
    TildeTilde: "≈",
    times: "×",
    timesb: "⊠",
    timesbar: "⨱",
    timesd: "⨰",
    tint: "∭",
    toea: "⤨",
    top: "⊤",
    topbot: "⌶",
    topcir: "⫱",
    Topf: "𝕋",
    topf: "𝕥",
    topfork: "⫚",
    tosa: "⤩",
    tprime: "‴",
    TRADE: "™",
    trade: "™",
    triangle: "▵",
    triangledown: "▿",
    triangleleft: "◃",
    trianglelefteq: "⊴",
    triangleq: "≜",
    triangleright: "▹",
    trianglerighteq: "⊵",
    tridot: "◬",
    trie: "≜",
    triminus: "⨺",
    TripleDot: "⃛",
    triplus: "⨹",
    trisb: "⧍",
    tritime: "⨻",
    trpezium: "⏢",
    Tscr: "𝒯",
    tscr: "𝓉",
    TScy: "Ц",
    tscy: "ц",
    TSHcy: "Ћ",
    tshcy: "ћ",
    Tstrok: "Ŧ",
    tstrok: "ŧ",
    twixt: "≬",
    twoheadleftarrow: "↞",
    twoheadrightarrow: "↠",
    Uacute: "Ú",
    uacute: "ú",
    Uarr: "↟",
    uArr: "⇑",
    uarr: "↑",
    Uarrocir: "⥉",
    Ubrcy: "Ў",
    ubrcy: "ў",
    Ubreve: "Ŭ",
    ubreve: "ŭ",
    Ucirc: "Û",
    ucirc: "û",
    Ucy: "У",
    ucy: "у",
    udarr: "⇅",
    Udblac: "Ű",
    udblac: "ű",
    udhar: "⥮",
    ufisht: "⥾",
    Ufr: "𝔘",
    ufr: "𝔲",
    Ugrave: "Ù",
    ugrave: "ù",
    uHar: "⥣",
    uharl: "↿",
    uharr: "↾",
    uhblk: "▀",
    ulcorn: "⌜",
    ulcorner: "⌜",
    ulcrop: "⌏",
    ultri: "◸",
    Umacr: "Ū",
    umacr: "ū",
    uml: "¨",
    UnderBar: "_",
    UnderBrace: "⏟",
    UnderBracket: "⎵",
    UnderParenthesis: "⏝",
    Union: "⋃",
    UnionPlus: "⊎",
    Uogon: "Ų",
    uogon: "ų",
    Uopf: "𝕌",
    uopf: "𝕦",
    UpArrow: "↑",
    Uparrow: "⇑",
    uparrow: "↑",
    UpArrowBar: "⤒",
    UpArrowDownArrow: "⇅",
    UpDownArrow: "↕",
    Updownarrow: "⇕",
    updownarrow: "↕",
    UpEquilibrium: "⥮",
    upharpoonleft: "↿",
    upharpoonright: "↾",
    uplus: "⊎",
    UpperLeftArrow: "↖",
    UpperRightArrow: "↗",
    Upsi: "ϒ",
    upsi: "υ",
    upsih: "ϒ",
    Upsilon: "Υ",
    upsilon: "υ",
    UpTee: "⊥",
    UpTeeArrow: "↥",
    upuparrows: "⇈",
    urcorn: "⌝",
    urcorner: "⌝",
    urcrop: "⌎",
    Uring: "Ů",
    uring: "ů",
    urtri: "◹",
    Uscr: "𝒰",
    uscr: "𝓊",
    utdot: "⋰",
    Utilde: "Ũ",
    utilde: "ũ",
    utri: "▵",
    utrif: "▴",
    uuarr: "⇈",
    Uuml: "Ü",
    uuml: "ü",
    uwangle: "⦧",
    vangrt: "⦜",
    varepsilon: "ϵ",
    varkappa: "ϰ",
    varnothing: "∅",
    varphi: "ϕ",
    varpi: "ϖ",
    varpropto: "∝",
    vArr: "⇕",
    varr: "↕",
    varrho: "ϱ",
    varsigma: "ς",
    varsubsetneq: "⊊︀",
    varsubsetneqq: "⫋︀",
    varsupsetneq: "⊋︀",
    varsupsetneqq: "⫌︀",
    vartheta: "ϑ",
    vartriangleleft: "⊲",
    vartriangleright: "⊳",
    Vbar: "⫫",
    vBar: "⫨",
    vBarv: "⫩",
    Vcy: "В",
    vcy: "в",
    VDash: "⊫",
    Vdash: "⊩",
    vDash: "⊨",
    vdash: "⊢",
    Vdashl: "⫦",
    Vee: "⋁",
    vee: "∨",
    veebar: "⊻",
    veeeq: "≚",
    vellip: "⋮",
    Verbar: "‖",
    verbar: "|",
    Vert: "‖",
    vert: "|",
    VerticalBar: "∣",
    VerticalLine: "|",
    VerticalSeparator: "❘",
    VerticalTilde: "≀",
    VeryThinSpace: " ",
    Vfr: "𝔙",
    vfr: "𝔳",
    vltri: "⊲",
    vnsub: "⊂⃒",
    vnsup: "⊃⃒",
    Vopf: "𝕍",
    vopf: "𝕧",
    vprop: "∝",
    vrtri: "⊳",
    Vscr: "𝒱",
    vscr: "𝓋",
    vsubnE: "⫋︀",
    vsubne: "⊊︀",
    vsupnE: "⫌︀",
    vsupne: "⊋︀",
    Vvdash: "⊪",
    vzigzag: "⦚",
    Wcirc: "Ŵ",
    wcirc: "ŵ",
    wedbar: "⩟",
    Wedge: "⋀",
    wedge: "∧",
    wedgeq: "≙",
    weierp: "℘",
    Wfr: "𝔚",
    wfr: "𝔴",
    Wopf: "𝕎",
    wopf: "𝕨",
    wp: "℘",
    wr: "≀",
    wreath: "≀",
    Wscr: "𝒲",
    wscr: "𝓌",
    xcap: "⋂",
    xcirc: "◯",
    xcup: "⋃",
    xdtri: "▽",
    Xfr: "𝔛",
    xfr: "𝔵",
    xhArr: "⟺",
    xharr: "⟷",
    Xi: "Ξ",
    xi: "ξ",
    xlArr: "⟸",
    xlarr: "⟵",
    xmap: "⟼",
    xnis: "⋻",
    xodot: "⨀",
    Xopf: "𝕏",
    xopf: "𝕩",
    xoplus: "⨁",
    xotime: "⨂",
    xrArr: "⟹",
    xrarr: "⟶",
    Xscr: "𝒳",
    xscr: "𝓍",
    xsqcup: "⨆",
    xuplus: "⨄",
    xutri: "△",
    xvee: "⋁",
    xwedge: "⋀",
    Yacute: "Ý",
    yacute: "ý",
    YAcy: "Я",
    yacy: "я",
    Ycirc: "Ŷ",
    ycirc: "ŷ",
    Ycy: "Ы",
    ycy: "ы",
    yen: "¥",
    Yfr: "𝔜",
    yfr: "𝔶",
    YIcy: "Ї",
    yicy: "ї",
    Yopf: "𝕐",
    yopf: "𝕪",
    Yscr: "𝒴",
    yscr: "𝓎",
    YUcy: "Ю",
    yucy: "ю",
    Yuml: "Ÿ",
    yuml: "ÿ",
    Zacute: "Ź",
    zacute: "ź",
    Zcaron: "Ž",
    zcaron: "ž",
    Zcy: "З",
    zcy: "з",
    Zdot: "Ż",
    zdot: "ż",
    zeetrf: "ℨ",
    ZeroWidthSpace: "​",
    Zeta: "Ζ",
    zeta: "ζ",
    Zfr: "ℨ",
    zfr: "𝔷",
    ZHcy: "Ж",
    zhcy: "ж",
    zigrarr: "⇝",
    Zopf: "ℤ",
    zopf: "𝕫",
    Zscr: "𝒵",
    zscr: "𝓏",
    zwj: "‍",
    zwnj: "‌"
  }), i.entityMap = i.HTML_ENTITIES;
})(Cd);
var Co = {}, Vs = Ut.NAMESPACE, Ba = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, wl = new RegExp("[\\-\\.0-9" + Ba.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), Il = new RegExp("^" + Ba.source + wl.source + "*(?::" + Ba.source + wl.source + "*)?$"), xs = 0, Ht = 1, Ei = 2, Ss = 3, Ci = 4, Ai = 5, Es = 6, Or = 7;
function zi(i, e) {
  this.message = i, this.locator = e, Error.captureStackTrace && Error.captureStackTrace(this, zi);
}
zi.prototype = new Error();
zi.prototype.name = zi.name;
function Ad() {
}
Ad.prototype = {
  parse: function(i, e, t) {
    var s = this.domBuilder;
    s.startDocument(), Dd(e, e = {}), r_(
      i,
      e,
      t,
      s,
      this.errorHandler
    ), s.endDocument();
  }
};
function r_(i, e, t, s, r) {
  function n(ee) {
    if (ee > 65535) {
      ee -= 65536;
      var Te = 55296 + (ee >> 10), Dt = 56320 + (ee & 1023);
      return String.fromCharCode(Te, Dt);
    } else
      return String.fromCharCode(ee);
  }
  function a(ee) {
    var Te = ee.slice(1, -1);
    return Object.hasOwnProperty.call(t, Te) ? t[Te] : Te.charAt(0) === "#" ? n(parseInt(Te.substr(1).replace("x", "0x"))) : (r.error("entity not found:" + ee), ee);
  }
  function o(ee) {
    if (ee > y) {
      var Te = i.substring(y, ee).replace(/&#?\w+;/g, a);
      v && l(y), s.characters(Te, 0, ee - y), y = ee;
    }
  }
  function l(ee, Te) {
    for (; ee >= m && (Te = _.exec(i)); )
      h = Te.index, m = h + Te[0].length, v.lineNumber++;
    v.columnNumber = ee - h + 1;
  }
  for (var h = 0, m = 0, _ = /.*(?:\r\n?|\n)|.*$/g, v = s.locator, C = [{ currentNSMap: e }], A = {}, y = 0; ; ) {
    try {
      var D = i.indexOf("<", y);
      if (D < 0) {
        if (!i.substr(y).match(/^\s*$/)) {
          var w = s.doc, O = w.createTextNode(i.substr(y));
          w.appendChild(O), s.currentElement = O;
        }
        return;
      }
      switch (D > y && o(D), i.charAt(D + 1)) {
        case "/":
          var J = i.indexOf(">", D + 3), P = i.substring(D + 2, J).replace(/[ \t\n\r]+$/g, ""), R = C.pop();
          J < 0 ? (P = i.substring(D + 2).replace(/[\s<].*/, ""), r.error("end tag name: " + P + " is not complete:" + R.tagName), J = D + 1 + P.length) : P.match(/\s</) && (P = P.replace(/[\s<].*/, ""), r.error("end tag name: " + P + " maybe not complete"), J = D + 1 + P.length);
          var I = R.localNSMap, B = R.tagName == P, H = B || R.tagName && R.tagName.toLowerCase() == P.toLowerCase();
          if (H) {
            if (s.endElement(R.uri, R.localName, P), I)
              for (var $ in I)
                Object.prototype.hasOwnProperty.call(I, $) && s.endPrefixMapping($);
            B || r.fatalError("end tag name: " + P + " is not match the current start tagName:" + R.tagName);
          } else
            C.push(R);
          J++;
          break;
        case "?":
          v && l(D), J = l_(i, D, s);
          break;
        case "!":
          v && l(D), J = u_(i, D, s, r);
          break;
        default:
          v && l(D);
          var X = new wd(), ue = C[C.length - 1].currentNSMap, J = n_(i, D, X, ue, a, r), ne = X.length;
          if (!X.closed && o_(i, J, X.tagName, A) && (X.closed = !0, t.nbsp || r.warning("unclosed xml attribute")), v && ne) {
            for (var V = kl(v, {}), Z = 0; Z < ne; Z++) {
              var Re = X[Z];
              l(Re.offset), Re.locator = kl(v, {});
            }
            s.locator = V, Pl(X, s, ue) && C.push(X), s.locator = v;
          } else
            Pl(X, s, ue) && C.push(X);
          Vs.isHTML(X.uri) && !X.closed ? J = a_(i, J, X.tagName, a, s) : J++;
      }
    } catch (ee) {
      if (ee instanceof zi)
        throw ee;
      r.error("element parse error: " + ee), J = -1;
    }
    J > y ? y = J : o(Math.max(D, y) + 1);
  }
}
function kl(i, e) {
  return e.lineNumber = i.lineNumber, e.columnNumber = i.columnNumber, e;
}
function n_(i, e, t, s, r, n) {
  function a(v, C, A) {
    t.attributeNames.hasOwnProperty(v) && n.fatalError("Attribute " + v + " redefined"), t.addValue(
      v,
      // @see https://www.w3.org/TR/xml/#AVNormalize
      // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
      // - recursive replacement of (DTD) entity references
      // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
      C.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, r),
      A
    );
  }
  for (var o, l, h = ++e, m = xs; ; ) {
    var _ = i.charAt(h);
    switch (_) {
      case "=":
        if (m === Ht)
          o = i.slice(e, h), m = Ss;
        else if (m === Ei)
          m = Ss;
        else
          throw new Error("attribute equal must after attrName");
        break;
      case "'":
      case '"':
        if (m === Ss || m === Ht)
          if (m === Ht && (n.warning('attribute value must after "="'), o = i.slice(e, h)), e = h + 1, h = i.indexOf(_, e), h > 0)
            l = i.slice(e, h), a(o, l, e - 1), m = Ai;
          else
            throw new Error("attribute value no end '" + _ + "' match");
        else if (m == Ci)
          l = i.slice(e, h), a(o, l, e), n.warning('attribute "' + o + '" missed start quot(' + _ + ")!!"), e = h + 1, m = Ai;
        else
          throw new Error('attribute value must after "="');
        break;
      case "/":
        switch (m) {
          case xs:
            t.setTagName(i.slice(e, h));
          case Ai:
          case Es:
          case Or:
            m = Or, t.closed = !0;
          case Ci:
          case Ht:
            break;
          case Ei:
            t.closed = !0;
            break;
          default:
            throw new Error("attribute invalid close char('/')");
        }
        break;
      case "":
        return n.error("unexpected end of input"), m == xs && t.setTagName(i.slice(e, h)), h;
      case ">":
        switch (m) {
          case xs:
            t.setTagName(i.slice(e, h));
          case Ai:
          case Es:
          case Or:
            break;
          case Ci:
          case Ht:
            l = i.slice(e, h), l.slice(-1) === "/" && (t.closed = !0, l = l.slice(0, -1));
          case Ei:
            m === Ei && (l = o), m == Ci ? (n.warning('attribute "' + l + '" missed quot(")!'), a(o, l, e)) : ((!Vs.isHTML(s[""]) || !l.match(/^(?:disabled|checked|selected)$/i)) && n.warning('attribute "' + l + '" missed value!! "' + l + '" instead!!'), a(l, l, e));
            break;
          case Ss:
            throw new Error("attribute value missed!!");
        }
        return h;
      case "":
        _ = " ";
      default:
        if (_ <= " ")
          switch (m) {
            case xs:
              t.setTagName(i.slice(e, h)), m = Es;
              break;
            case Ht:
              o = i.slice(e, h), m = Ei;
              break;
            case Ci:
              var l = i.slice(e, h);
              n.warning('attribute "' + l + '" missed quot(")!!'), a(o, l, e);
            case Ai:
              m = Es;
              break;
          }
        else
          switch (m) {
            case Ei:
              t.tagName, (!Vs.isHTML(s[""]) || !o.match(/^(?:disabled|checked|selected)$/i)) && n.warning('attribute "' + o + '" missed value!! "' + o + '" instead2!!'), a(o, o, e), e = h, m = Ht;
              break;
            case Ai:
              n.warning('attribute space is required"' + o + '"!!');
            case Es:
              m = Ht, e = h;
              break;
            case Ss:
              m = Ci, e = h;
              break;
            case Or:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
    }
    h++;
  }
}
function Pl(i, e, t) {
  for (var s = i.tagName, r = null, _ = i.length; _--; ) {
    var n = i[_], a = n.qName, o = n.value, v = a.indexOf(":");
    if (v > 0)
      var l = n.prefix = a.slice(0, v), h = a.slice(v + 1), m = l === "xmlns" && h;
    else
      h = a, l = null, m = a === "xmlns" && "";
    n.localName = h, m !== !1 && (r == null && (r = {}, Dd(t, t = {})), t[m] = r[m] = o, n.uri = Vs.XMLNS, e.startPrefixMapping(m, o));
  }
  for (var _ = i.length; _--; ) {
    n = i[_];
    var l = n.prefix;
    l && (l === "xml" && (n.uri = Vs.XML), l !== "xmlns" && (n.uri = t[l || ""]));
  }
  var v = s.indexOf(":");
  v > 0 ? (l = i.prefix = s.slice(0, v), h = i.localName = s.slice(v + 1)) : (l = null, h = i.localName = s);
  var C = i.uri = t[l || ""];
  if (e.startElement(C, h, s, i), i.closed) {
    if (e.endElement(C, h, s), r)
      for (l in r)
        Object.prototype.hasOwnProperty.call(r, l) && e.endPrefixMapping(l);
  } else
    return i.currentNSMap = t, i.localNSMap = r, !0;
}
function a_(i, e, t, s, r) {
  if (/^(?:script|textarea)$/i.test(t)) {
    var n = i.indexOf("</" + t + ">", e), a = i.substring(e + 1, n);
    if (/[&<]/.test(a))
      return /^script$/i.test(t) ? (r.characters(a, 0, a.length), n) : (a = a.replace(/&#?\w+;/g, s), r.characters(a, 0, a.length), n);
  }
  return e + 1;
}
function o_(i, e, t, s) {
  var r = s[t];
  return r == null && (r = i.lastIndexOf("</" + t + ">"), r < e && (r = i.lastIndexOf("</" + t)), s[t] = r), r < e;
}
function Dd(i, e) {
  for (var t in i)
    Object.prototype.hasOwnProperty.call(i, t) && (e[t] = i[t]);
}
function u_(i, e, t, s) {
  var r = i.charAt(e + 2);
  switch (r) {
    case "-":
      if (i.charAt(e + 3) === "-") {
        var n = i.indexOf("-->", e + 4);
        return n > e ? (t.comment(i, e + 4, n - e - 4), n + 3) : (s.error("Unclosed comment"), -1);
      } else
        return -1;
    default:
      if (i.substr(e + 3, 6) == "CDATA[") {
        var n = i.indexOf("]]>", e + 9);
        return t.startCDATA(), t.characters(i, e + 9, n - e - 9), t.endCDATA(), n + 3;
      }
      var a = c_(i, e), o = a.length;
      if (o > 1 && /!doctype/i.test(a[0][0])) {
        var l = a[1][0], h = !1, m = !1;
        o > 3 && (/^public$/i.test(a[2][0]) ? (h = a[3][0], m = o > 4 && a[4][0]) : /^system$/i.test(a[2][0]) && (m = a[3][0]));
        var _ = a[o - 1];
        return t.startDTD(l, h, m), t.endDTD(), _.index + _[0].length;
      }
  }
  return -1;
}
function l_(i, e, t) {
  var s = i.indexOf("?>", e);
  if (s) {
    var r = i.substring(e, s).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    return r ? (r[0].length, t.processingInstruction(r[1], r[2]), s + 2) : -1;
  }
  return -1;
}
function wd() {
  this.attributeNames = {};
}
wd.prototype = {
  setTagName: function(i) {
    if (!Il.test(i))
      throw new Error("invalid tagName:" + i);
    this.tagName = i;
  },
  addValue: function(i, e, t) {
    if (!Il.test(i))
      throw new Error("invalid attribute:" + i);
    this.attributeNames[i] = this.length, this[this.length++] = { qName: i, value: e, offset: t };
  },
  length: 0,
  getLocalName: function(i) {
    return this[i].localName;
  },
  getLocator: function(i) {
    return this[i].locator;
  },
  getQName: function(i) {
    return this[i].qName;
  },
  getURI: function(i) {
    return this[i].uri;
  },
  getValue: function(i) {
    return this[i].value;
  }
  //	,getIndex:function(uri, localName)){
  //		if(localName){
  //
  //		}else{
  //			var qName = uri
  //		}
  //	},
  //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
  //	getType:function(uri,localName){}
  //	getType:function(i){},
};
function c_(i, e) {
  var t, s = [], r = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  for (r.lastIndex = e, r.exec(i); t = r.exec(i); )
    if (s.push(t), t[1]) return s;
}
Co.XMLReader = Ad;
Co.ParseError = zi;
var d_ = Ut, h_ = Yt, Ol = Cd, Id = Co, f_ = h_.DOMImplementation, Ll = d_.NAMESPACE, p_ = Id.ParseError, m_ = Id.XMLReader;
function kd(i) {
  return i.replace(/\r[\n\u0085]/g, `
`).replace(/[\r\u0085\u2028]/g, `
`);
}
function Pd(i) {
  this.options = i || { locator: {} };
}
Pd.prototype.parseFromString = function(i, e) {
  var t = this.options, s = new m_(), r = t.domBuilder || new Zs(), n = t.errorHandler, a = t.locator, o = t.xmlns || {}, l = /\/x?html?$/.test(e), h = l ? Ol.HTML_ENTITIES : Ol.XML_ENTITIES;
  a && r.setDocumentLocator(a), s.errorHandler = g_(n, r, a), s.domBuilder = t.domBuilder || r, l && (o[""] = Ll.HTML), o.xml = o.xml || Ll.XML;
  var m = t.normalizeLineEndings || kd;
  return i && typeof i == "string" ? s.parse(
    m(i),
    o,
    h
  ) : s.errorHandler.error("invalid doc source"), r.doc;
};
function g_(i, e, t) {
  if (!i) {
    if (e instanceof Zs)
      return e;
    i = e;
  }
  var s = {}, r = i instanceof Function;
  t = t || {};
  function n(a) {
    var o = i[a];
    !o && r && (o = i.length == 2 ? function(l) {
      i(a, l);
    } : i), s[a] = o && function(l) {
      o("[xmldom " + a + "]	" + l + Fa(t));
    } || function() {
    };
  }
  return n("warning"), n("error"), n("fatalError"), s;
}
function Zs() {
  this.cdata = !1;
}
function Di(i, e) {
  e.lineNumber = i.lineNumber, e.columnNumber = i.columnNumber;
}
Zs.prototype = {
  startDocument: function() {
    this.doc = new f_().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
  },
  startElement: function(i, e, t, s) {
    var r = this.doc, n = r.createElementNS(i, t || e), a = s.length;
    Lr(this, n), this.currentElement = n, this.locator && Di(this.locator, n);
    for (var o = 0; o < a; o++) {
      var i = s.getURI(o), l = s.getValue(o), t = s.getQName(o), h = r.createAttributeNS(i, t);
      this.locator && Di(s.getLocator(o), h), h.value = h.nodeValue = l, n.setAttributeNode(h);
    }
  },
  endElement: function(i, e, t) {
    var s = this.currentElement;
    s.tagName, this.currentElement = s.parentNode;
  },
  startPrefixMapping: function(i, e) {
  },
  endPrefixMapping: function(i) {
  },
  processingInstruction: function(i, e) {
    var t = this.doc.createProcessingInstruction(i, e);
    this.locator && Di(this.locator, t), Lr(this, t);
  },
  ignorableWhitespace: function(i, e, t) {
  },
  characters: function(i, e, t) {
    if (i = Rl.apply(this, arguments), i) {
      if (this.cdata)
        var s = this.doc.createCDATASection(i);
      else
        var s = this.doc.createTextNode(i);
      this.currentElement ? this.currentElement.appendChild(s) : /^\s*$/.test(i) && this.doc.appendChild(s), this.locator && Di(this.locator, s);
    }
  },
  skippedEntity: function(i) {
  },
  endDocument: function() {
    this.doc.normalize();
  },
  setDocumentLocator: function(i) {
    (this.locator = i) && (i.lineNumber = 0);
  },
  //LexicalHandler
  comment: function(i, e, t) {
    i = Rl.apply(this, arguments);
    var s = this.doc.createComment(i);
    this.locator && Di(this.locator, s), Lr(this, s);
  },
  startCDATA: function() {
    this.cdata = !0;
  },
  endCDATA: function() {
    this.cdata = !1;
  },
  startDTD: function(i, e, t) {
    var s = this.doc.implementation;
    if (s && s.createDocumentType) {
      var r = s.createDocumentType(i, e, t);
      this.locator && Di(this.locator, r), Lr(this, r), this.doc.doctype = r;
    }
  },
  /**
   * @see org.xml.sax.ErrorHandler
   * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
   */
  warning: function(i) {
    console.warn("[xmldom warning]	" + i, Fa(this.locator));
  },
  error: function(i) {
    console.error("[xmldom error]	" + i, Fa(this.locator));
  },
  fatalError: function(i) {
    throw new p_(i, this.locator);
  }
};
function Fa(i) {
  if (i)
    return `
@` + (i.systemId || "") + "#[line:" + i.lineNumber + ",col:" + i.columnNumber + "]";
}
function Rl(i, e, t) {
  return typeof i == "string" ? i.substr(e, t) : i.length >= e + t || e ? new java.lang.String(i, e, t) + "" : i;
}
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(i) {
  Zs.prototype[i] = function() {
    return null;
  };
});
function Lr(i, e) {
  i.currentElement ? i.currentElement.appendChild(e) : i.doc.appendChild(e);
}
Sn.__DOMHandler = Zs;
Sn.normalizeLineEndings = kd;
Sn.DOMParser = Pd;
var __ = Sn.DOMParser;
/*! @name mpd-parser @version 1.3.1 @license Apache-2.0 */
const Nl = (i) => !!i && typeof i == "object", De = (...i) => i.reduce((e, t) => (typeof t != "object" || Object.keys(t).forEach((s) => {
  Array.isArray(e[s]) && Array.isArray(t[s]) ? e[s] = e[s].concat(t[s]) : Nl(e[s]) && Nl(t[s]) ? e[s] = De(e[s], t[s]) : e[s] = t[s];
}), e), {}), Od = (i) => Object.keys(i).map((e) => i[e]), y_ = (i, e) => {
  const t = [];
  for (let s = i; s < e; s++)
    t.push(s);
  return t;
}, Gi = (i) => i.reduce((e, t) => e.concat(t), []), Ld = (i) => {
  if (!i.length)
    return [];
  const e = [];
  for (let t = 0; t < i.length; t++)
    e.push(i[t]);
  return e;
}, T_ = (i, e) => i.reduce((t, s, r) => (s[e] && t.push(r), t), []), v_ = (i, e) => Od(i.reduce((t, s) => (s.forEach((r) => {
  t[e(r)] = r;
}), t), {}));
var Wi = {
  INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
  INVALID_NUMBER_OF_CONTENT_STEERING: "INVALID_NUMBER_OF_CONTENT_STEERING",
  DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
  DASH_INVALID_XML: "DASH_INVALID_XML",
  NO_BASE_URL: "NO_BASE_URL",
  MISSING_SEGMENT_INFORMATION: "MISSING_SEGMENT_INFORMATION",
  SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
  UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
};
const zs = ({
  baseUrl: i = "",
  source: e = "",
  range: t = "",
  indexRange: s = ""
}) => {
  const r = {
    uri: e,
    resolvedUri: vn(i || "", e)
  };
  if (t || s) {
    const a = (t || s).split("-");
    let o = S.BigInt ? S.BigInt(a[0]) : parseInt(a[0], 10), l = S.BigInt ? S.BigInt(a[1]) : parseInt(a[1], 10);
    o < Number.MAX_SAFE_INTEGER && typeof o == "bigint" && (o = Number(o)), l < Number.MAX_SAFE_INTEGER && typeof l == "bigint" && (l = Number(l));
    let h;
    typeof l == "bigint" || typeof o == "bigint" ? h = S.BigInt(l) - S.BigInt(o) + S.BigInt(1) : h = l - o + 1, typeof h == "bigint" && h < Number.MAX_SAFE_INTEGER && (h = Number(h)), r.byterange = {
      length: h,
      offset: o
    };
  }
  return r;
}, b_ = (i) => {
  let e;
  return typeof i.offset == "bigint" || typeof i.length == "bigint" ? e = S.BigInt(i.offset) + S.BigInt(i.length) - S.BigInt(1) : e = i.offset + i.length - 1, `${i.offset}-${e}`;
}, Ml = (i) => (i && typeof i != "number" && (i = parseInt(i, 10)), isNaN(i) ? null : i), x_ = {
  /**
   * Returns the entire range of available segments for a static MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  static(i) {
    const {
      duration: e,
      timescale: t = 1,
      sourceDuration: s,
      periodDuration: r
    } = i, n = Ml(i.endNumber), a = e / t;
    return typeof n == "number" ? {
      start: 0,
      end: n
    } : typeof r == "number" ? {
      start: 0,
      end: r / a
    } : {
      start: 0,
      end: s / a
    };
  },
  /**
   * Returns the current live window range of available segments for a dynamic MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  dynamic(i) {
    const {
      NOW: e,
      clientOffset: t,
      availabilityStartTime: s,
      timescale: r = 1,
      duration: n,
      periodStart: a = 0,
      minimumUpdatePeriod: o = 0,
      timeShiftBufferDepth: l = 1 / 0
    } = i, h = Ml(i.endNumber), m = (e + t) / 1e3, _ = s + a, C = m + o - _, A = Math.ceil(C * r / n), y = Math.floor((m - _ - l) * r / n), D = Math.floor((m - _) * r / n);
    return {
      start: Math.max(0, y),
      end: typeof h == "number" ? h : Math.min(A, D)
    };
  }
}, S_ = (i) => (e) => {
  const {
    duration: t,
    timescale: s = 1,
    periodStart: r,
    startNumber: n = 1
  } = i;
  return {
    number: n + e,
    duration: t / s,
    timeline: r,
    time: e * t
  };
}, Ao = (i) => {
  const {
    type: e,
    duration: t,
    timescale: s = 1,
    periodDuration: r,
    sourceDuration: n
  } = i, {
    start: a,
    end: o
  } = x_[e](i), l = y_(a, o).map(S_(i));
  if (e === "static") {
    const h = l.length - 1, m = typeof r == "number" ? r : n;
    l[h].duration = m - t / s * h;
  }
  return l;
}, Rd = (i) => {
  const {
    baseUrl: e,
    initialization: t = {},
    sourceDuration: s,
    indexRange: r = "",
    periodStart: n,
    presentationTime: a,
    number: o = 0,
    duration: l
  } = i;
  if (!e)
    throw new Error(Wi.NO_BASE_URL);
  const h = zs({
    baseUrl: e,
    source: t.sourceURL,
    range: t.range
  }), m = zs({
    baseUrl: e,
    source: e,
    indexRange: r
  });
  if (m.map = h, l) {
    const _ = Ao(i);
    _.length && (m.duration = _[0].duration, m.timeline = _[0].timeline);
  } else s && (m.duration = s, m.timeline = n);
  return m.presentationTime = a || n, m.number = o, [m];
}, Do = (i, e, t) => {
  const s = i.sidx.map ? i.sidx.map : null, r = i.sidx.duration, n = i.timeline || 0, a = i.sidx.byterange, o = a.offset + a.length, l = e.timescale, h = e.references.filter((D) => D.referenceType !== 1), m = [], _ = i.endList ? "static" : "dynamic", v = i.sidx.timeline;
  let C = v, A = i.mediaSequence || 0, y;
  typeof e.firstOffset == "bigint" ? y = S.BigInt(o) + e.firstOffset : y = o + e.firstOffset;
  for (let D = 0; D < h.length; D++) {
    const w = e.references[D], O = w.referencedSize, P = w.subsegmentDuration;
    let R;
    typeof y == "bigint" ? R = y + S.BigInt(O) - S.BigInt(1) : R = y + O - 1;
    const I = `${y}-${R}`, H = Rd({
      baseUrl: t,
      timescale: l,
      timeline: n,
      periodStart: v,
      presentationTime: C,
      number: A,
      duration: P,
      sourceDuration: r,
      indexRange: I,
      type: _
    })[0];
    s && (H.map = s), m.push(H), typeof y == "bigint" ? y += S.BigInt(O) : y += O, C += P / l, A++;
  }
  return i.segments = m, i;
}, E_ = ["AUDIO", "SUBTITLES"], C_ = 1 / 60, Nd = (i) => v_(i, ({
  timeline: e
}) => e).sort((e, t) => e.timeline > t.timeline ? 1 : -1), A_ = (i, e) => {
  for (let t = 0; t < i.length; t++)
    if (i[t].attributes.NAME === e)
      return i[t];
  return null;
}, Bl = (i) => {
  let e = [];
  return H0(i, E_, (t, s, r, n) => {
    e = e.concat(t.playlists || []);
  }), e;
}, Fl = ({
  playlist: i,
  mediaSequence: e
}) => {
  i.mediaSequence = e, i.segments.forEach((t, s) => {
    t.number = i.mediaSequence + s;
  });
}, D_ = ({
  oldPlaylists: i,
  newPlaylists: e,
  timelineStarts: t
}) => {
  e.forEach((s) => {
    s.discontinuitySequence = t.findIndex(function({
      timeline: l
    }) {
      return l === s.timeline;
    });
    const r = A_(i, s.attributes.NAME);
    if (!r || s.sidx)
      return;
    const n = s.segments[0], a = r.segments.findIndex(function(l) {
      return Math.abs(l.presentationTime - n.presentationTime) < C_;
    });
    if (a === -1) {
      Fl({
        playlist: s,
        mediaSequence: r.mediaSequence + r.segments.length
      }), s.segments[0].discontinuity = !0, s.discontinuityStarts.unshift(0), (!r.segments.length && s.timeline > r.timeline || r.segments.length && s.timeline > r.segments[r.segments.length - 1].timeline) && s.discontinuitySequence--;
      return;
    }
    r.segments[a].discontinuity && !n.discontinuity && (n.discontinuity = !0, s.discontinuityStarts.unshift(0), s.discontinuitySequence--), Fl({
      playlist: s,
      mediaSequence: r.segments[a].number
    });
  });
}, w_ = ({
  oldManifest: i,
  newManifest: e
}) => {
  const t = i.playlists.concat(Bl(i)), s = e.playlists.concat(Bl(e));
  return e.timelineStarts = Nd([i.timelineStarts, e.timelineStarts]), D_({
    oldPlaylists: t,
    newPlaylists: s,
    timelineStarts: e.timelineStarts
  }), e;
}, En = (i) => i && i.uri + "-" + b_(i.byterange), Ta = (i) => {
  const e = i.reduce(function(s, r) {
    return s[r.attributes.baseUrl] || (s[r.attributes.baseUrl] = []), s[r.attributes.baseUrl].push(r), s;
  }, {});
  let t = [];
  return Object.values(e).forEach((s) => {
    const r = Od(s.reduce((n, a) => {
      const o = a.attributes.id + (a.attributes.lang || "");
      return n[o] ? (a.segments && (a.segments[0] && (a.segments[0].discontinuity = !0), n[o].segments.push(...a.segments)), a.attributes.contentProtection && (n[o].attributes.contentProtection = a.attributes.contentProtection)) : (n[o] = a, n[o].attributes.timelineStarts = []), n[o].attributes.timelineStarts.push({
        // Although they represent the same number, it's important to have both to make it
        // compatible with HLS potentially having a similar attribute.
        start: a.attributes.periodStart,
        timeline: a.attributes.periodStart
      }), n;
    }, {}));
    t = t.concat(r);
  }), t.map((s) => (s.discontinuityStarts = T_(s.segments || [], "discontinuity"), s));
}, wo = (i, e) => {
  const t = En(i.sidx), s = t && e[t] && e[t].sidx;
  return s && Do(i, s, i.sidx.resolvedUri), i;
}, I_ = (i, e = {}) => {
  if (!Object.keys(e).length)
    return i;
  for (const t in i)
    i[t] = wo(i[t], e);
  return i;
}, k_ = ({
  attributes: i,
  segments: e,
  sidx: t,
  mediaSequence: s,
  discontinuitySequence: r,
  discontinuityStarts: n
}, a) => {
  const o = {
    attributes: {
      NAME: i.id,
      BANDWIDTH: i.bandwidth,
      CODECS: i.codecs,
      "PROGRAM-ID": 1
    },
    uri: "",
    endList: i.type === "static",
    timeline: i.periodStart,
    resolvedUri: i.baseUrl || "",
    targetDuration: i.duration,
    discontinuitySequence: r,
    discontinuityStarts: n,
    timelineStarts: i.timelineStarts,
    mediaSequence: s,
    segments: e
  };
  return i.contentProtection && (o.contentProtection = i.contentProtection), i.serviceLocation && (o.attributes.serviceLocation = i.serviceLocation), t && (o.sidx = t), a && (o.attributes.AUDIO = "audio", o.attributes.SUBTITLES = "subs"), o;
}, P_ = ({
  attributes: i,
  segments: e,
  mediaSequence: t,
  discontinuityStarts: s,
  discontinuitySequence: r
}) => {
  typeof e > "u" && (e = [{
    uri: i.baseUrl,
    timeline: i.periodStart,
    resolvedUri: i.baseUrl || "",
    duration: i.sourceDuration,
    number: 0
  }], i.duration = i.sourceDuration);
  const n = {
    NAME: i.id,
    BANDWIDTH: i.bandwidth,
    "PROGRAM-ID": 1
  };
  i.codecs && (n.CODECS = i.codecs);
  const a = {
    attributes: n,
    uri: "",
    endList: i.type === "static",
    timeline: i.periodStart,
    resolvedUri: i.baseUrl || "",
    targetDuration: i.duration,
    timelineStarts: i.timelineStarts,
    discontinuityStarts: s,
    discontinuitySequence: r,
    mediaSequence: t,
    segments: e
  };
  return i.serviceLocation && (a.attributes.serviceLocation = i.serviceLocation), a;
}, O_ = (i, e = {}, t = !1) => {
  let s;
  const r = i.reduce((n, a) => {
    const o = a.attributes.role && a.attributes.role.value || "", l = a.attributes.lang || "";
    let h = a.attributes.label || "main";
    if (l && !a.attributes.label) {
      const _ = o ? ` (${o})` : "";
      h = `${a.attributes.lang}${_}`;
    }
    n[h] || (n[h] = {
      language: l,
      autoselect: !0,
      default: o === "main",
      playlists: [],
      uri: ""
    });
    const m = wo(k_(a, t), e);
    return n[h].playlists.push(m), typeof s > "u" && o === "main" && (s = a, s.default = !0), n;
  }, {});
  if (!s) {
    const n = Object.keys(r)[0];
    r[n].default = !0;
  }
  return r;
}, L_ = (i, e = {}) => i.reduce((t, s) => {
  const r = s.attributes.label || s.attributes.lang || "text", n = s.attributes.lang || "und";
  return t[r] || (t[r] = {
    language: n,
    default: !1,
    autoselect: !1,
    playlists: [],
    uri: ""
  }), t[r].playlists.push(wo(P_(s), e)), t;
}, {}), R_ = (i) => i.reduce((e, t) => (t && t.forEach((s) => {
  const {
    channel: r,
    language: n
  } = s;
  e[n] = {
    autoselect: !1,
    default: !1,
    instreamId: r,
    language: n
  }, s.hasOwnProperty("aspectRatio") && (e[n].aspectRatio = s.aspectRatio), s.hasOwnProperty("easyReader") && (e[n].easyReader = s.easyReader), s.hasOwnProperty("3D") && (e[n]["3D"] = s["3D"]);
}), e), {}), N_ = ({
  attributes: i,
  segments: e,
  sidx: t,
  discontinuityStarts: s
}) => {
  const r = {
    attributes: {
      NAME: i.id,
      AUDIO: "audio",
      SUBTITLES: "subs",
      RESOLUTION: {
        width: i.width,
        height: i.height
      },
      CODECS: i.codecs,
      BANDWIDTH: i.bandwidth,
      "PROGRAM-ID": 1
    },
    uri: "",
    endList: i.type === "static",
    timeline: i.periodStart,
    resolvedUri: i.baseUrl || "",
    targetDuration: i.duration,
    discontinuityStarts: s,
    timelineStarts: i.timelineStarts,
    segments: e
  };
  return i.frameRate && (r.attributes["FRAME-RATE"] = i.frameRate), i.contentProtection && (r.contentProtection = i.contentProtection), i.serviceLocation && (r.attributes.serviceLocation = i.serviceLocation), t && (r.sidx = t), r;
}, M_ = ({
  attributes: i
}) => i.mimeType === "video/mp4" || i.mimeType === "video/webm" || i.contentType === "video", B_ = ({
  attributes: i
}) => i.mimeType === "audio/mp4" || i.mimeType === "audio/webm" || i.contentType === "audio", F_ = ({
  attributes: i
}) => i.mimeType === "text/vtt" || i.contentType === "text", U_ = (i, e) => {
  i.forEach((t) => {
    t.mediaSequence = 0, t.discontinuitySequence = e.findIndex(function({
      timeline: s
    }) {
      return s === t.timeline;
    }), t.segments && t.segments.forEach((s, r) => {
      s.number = r;
    });
  });
}, Ul = (i) => i ? Object.keys(i).reduce((e, t) => {
  const s = i[t];
  return e.concat(s.playlists);
}, []) : [], $_ = ({
  dashPlaylists: i,
  locations: e,
  contentSteering: t,
  sidxMapping: s = {},
  previousManifest: r,
  eventStream: n
}) => {
  if (!i.length)
    return {};
  const {
    sourceDuration: a,
    type: o,
    suggestedPresentationDelay: l,
    minimumUpdatePeriod: h
  } = i[0].attributes, m = Ta(i.filter(M_)).map(N_), _ = Ta(i.filter(B_)), v = Ta(i.filter(F_)), C = i.map((R) => R.attributes.captionServices).filter(Boolean), A = {
    allowCache: !0,
    discontinuityStarts: [],
    segments: [],
    endList: !0,
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: "",
    duration: a,
    playlists: I_(m, s)
  };
  h >= 0 && (A.minimumUpdatePeriod = h * 1e3), e && (A.locations = e), t && (A.contentSteering = t), o === "dynamic" && (A.suggestedPresentationDelay = l), n && n.length > 0 && (A.eventStream = n);
  const y = A.playlists.length === 0, D = _.length ? O_(_, s, y) : null, w = v.length ? L_(v, s) : null, O = m.concat(Ul(D), Ul(w)), P = O.map(({
    timelineStarts: R
  }) => R);
  return A.timelineStarts = Nd(P), U_(O, A.timelineStarts), D && (A.mediaGroups.AUDIO.audio = D), w && (A.mediaGroups.SUBTITLES.subs = w), C.length && (A.mediaGroups["CLOSED-CAPTIONS"].cc = R_(C)), r ? w_({
    oldManifest: r,
    newManifest: A
  }) : A;
}, q_ = (i, e, t) => {
  const {
    NOW: s,
    clientOffset: r,
    availabilityStartTime: n,
    timescale: a = 1,
    periodStart: o = 0,
    minimumUpdatePeriod: l = 0
  } = i, h = (s + r) / 1e3, m = n + o, v = h + l - m;
  return Math.ceil((v * a - e) / t);
}, Md = (i, e) => {
  const {
    type: t,
    minimumUpdatePeriod: s = 0,
    media: r = "",
    sourceDuration: n,
    timescale: a = 1,
    startNumber: o = 1,
    periodStart: l
  } = i, h = [];
  let m = -1;
  for (let _ = 0; _ < e.length; _++) {
    const v = e[_], C = v.d, A = v.r || 0, y = v.t || 0;
    m < 0 && (m = y), y && y > m && (m = y);
    let D;
    if (A < 0) {
      const P = _ + 1;
      P === e.length ? t === "dynamic" && s > 0 && r.indexOf("$Number$") > 0 ? D = q_(i, m, C) : D = (n * a - m) / C : D = (e[P].t - m) / C;
    } else
      D = A + 1;
    const w = o + h.length + D;
    let O = o + h.length;
    for (; O < w; )
      h.push({
        number: O,
        duration: C / a,
        time: m,
        timeline: l
      }), m += C, O++;
  }
  return h;
}, j_ = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g, H_ = (i) => (e, t, s, r) => {
  if (e === "$$")
    return "$";
  if (typeof i[t] > "u")
    return e;
  const n = "" + i[t];
  return t === "RepresentationID" || (s ? r = parseInt(r, 10) : r = 1, n.length >= r) ? n : `${new Array(r - n.length + 1).join("0")}${n}`;
}, $l = (i, e) => i.replace(j_, H_(e)), V_ = (i, e) => !i.duration && !e ? [{
  number: i.startNumber || 1,
  duration: i.sourceDuration,
  time: 0,
  timeline: i.periodStart
}] : i.duration ? Ao(i) : Md(i, e), z_ = (i, e) => {
  const t = {
    RepresentationID: i.id,
    Bandwidth: i.bandwidth || 0
  }, {
    initialization: s = {
      sourceURL: "",
      range: ""
    }
  } = i, r = zs({
    baseUrl: i.baseUrl,
    source: $l(s.sourceURL, t),
    range: s.range
  });
  return V_(i, e).map((a) => {
    t.Number = a.number, t.Time = a.time;
    const o = $l(i.media || "", t), l = i.timescale || 1, h = i.presentationTimeOffset || 0, m = (
      // Even if the @t attribute is not specified for the segment, segment.time is
      // calculated in mpd-parser prior to this, so it's assumed to be available.
      i.periodStart + (a.time - h) / l
    );
    return {
      uri: o,
      timeline: a.timeline,
      duration: a.duration,
      resolvedUri: vn(i.baseUrl || "", o),
      map: r,
      number: a.number,
      presentationTime: m
    };
  });
}, G_ = (i, e) => {
  const {
    baseUrl: t,
    initialization: s = {}
  } = i, r = zs({
    baseUrl: t,
    source: s.sourceURL,
    range: s.range
  }), n = zs({
    baseUrl: t,
    source: e.media,
    range: e.mediaRange
  });
  return n.map = r, n;
}, W_ = (i, e) => {
  const {
    duration: t,
    segmentUrls: s = [],
    periodStart: r
  } = i;
  if (!t && !e || t && e)
    throw new Error(Wi.SEGMENT_TIME_UNSPECIFIED);
  const n = s.map((l) => G_(i, l));
  let a;
  return t && (a = Ao(i)), e && (a = Md(i, e)), a.map((l, h) => {
    if (n[h]) {
      const m = n[h], _ = i.timescale || 1, v = i.presentationTimeOffset || 0;
      return m.timeline = l.timeline, m.duration = l.duration, m.number = l.number, m.presentationTime = r + (l.time - v) / _, m;
    }
  }).filter((l) => l);
}, X_ = ({
  attributes: i,
  segmentInfo: e
}) => {
  let t, s;
  e.template ? (s = z_, t = De(i, e.template)) : e.base ? (s = Rd, t = De(i, e.base)) : e.list && (s = W_, t = De(i, e.list));
  const r = {
    attributes: i
  };
  if (!s)
    return r;
  const n = s(t, e.segmentTimeline);
  if (t.duration) {
    const {
      duration: a,
      timescale: o = 1
    } = t;
    t.duration = a / o;
  } else n.length ? t.duration = n.reduce((a, o) => Math.max(a, Math.ceil(o.duration)), 0) : t.duration = 0;
  return r.attributes = t, r.segments = n, e.base && t.indexRange && (r.sidx = n[0], r.segments = []), r;
}, K_ = (i) => i.map(X_), pe = (i, e) => Ld(i.childNodes).filter(({
  tagName: t
}) => t === e), er = (i) => i.textContent.trim(), Y_ = (i) => parseFloat(i.split("/").reduce((e, t) => e / t)), wi = (i) => {
  const o = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/.exec(i);
  if (!o)
    return 0;
  const [l, h, m, _, v, C] = o.slice(1);
  return parseFloat(l || 0) * 31536e3 + parseFloat(h || 0) * 2592e3 + parseFloat(m || 0) * 86400 + parseFloat(_ || 0) * 3600 + parseFloat(v || 0) * 60 + parseFloat(C || 0);
}, Q_ = (i) => (/^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/.test(i) && (i += "Z"), Date.parse(i)), ql = {
  /**
   * Specifies the duration of the entire Media Presentation. Format is a duration string
   * as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  mediaPresentationDuration(i) {
    return wi(i);
  },
  /**
   * Specifies the Segment availability start time for all Segments referred to in this
   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
   * time. Format is a date string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The date as seconds from unix epoch
   */
  availabilityStartTime(i) {
    return Q_(i) / 1e3;
  },
  /**
   * Specifies the smallest period between potential changes to the MPD. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  minimumUpdatePeriod(i) {
    return wi(i);
  },
  /**
   * Specifies the suggested presentation delay. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  suggestedPresentationDelay(i) {
    return wi(i);
  },
  /**
   * specifices the type of mpd. Can be either "static" or "dynamic"
   *
   * @param {string} value
   *        value of attribute as a string
   *
   * @return {string}
   *         The type as a string
   */
  type(i) {
    return i;
  },
  /**
   * Specifies the duration of the smallest time shifting buffer for any Representation
   * in the MPD. Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  timeShiftBufferDepth(i) {
    return wi(i);
  },
  /**
   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
   * Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  start(i) {
    return wi(i);
  },
  /**
   * Specifies the width of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed width
   */
  width(i) {
    return parseInt(i, 10);
  },
  /**
   * Specifies the height of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed height
   */
  height(i) {
    return parseInt(i, 10);
  },
  /**
   * Specifies the bitrate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed bandwidth
   */
  bandwidth(i) {
    return parseInt(i, 10);
  },
  /**
   * Specifies the frame rate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed frame rate
   */
  frameRate(i) {
    return Y_(i);
  },
  /**
   * Specifies the number of the first Media Segment in this Representation in the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  startNumber(i) {
    return parseInt(i, 10);
  },
  /**
   * Specifies the timescale in units per seconds
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed timescale
   */
  timescale(i) {
    return parseInt(i, 10);
  },
  /**
   * Specifies the presentationTimeOffset.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTimeOffset
   */
  presentationTimeOffset(i) {
    return parseInt(i, 10);
  },
  /**
   * Specifies the constant approximate Segment duration
   * NOTE: The <Period> element also contains an @duration attribute. This duration
   *       specifies the duration of the Period. This attribute is currently not
   *       supported by the rest of the parser, however we still check for it to prevent
   *       errors.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  duration(i) {
    const e = parseInt(i, 10);
    return isNaN(e) ? wi(i) : e;
  },
  /**
   * Specifies the Segment duration, in units of the value of the @timescale.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  d(i) {
    return parseInt(i, 10);
  },
  /**
   * Specifies the MPD start time, in @timescale units, the first Segment in the series
   * starts relative to the beginning of the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed time
   */
  t(i) {
    return parseInt(i, 10);
  },
  /**
   * Specifies the repeat count of the number of following contiguous Segments with the
   * same duration expressed by the value of @d
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  r(i) {
    return parseInt(i, 10);
  },
  /**
   * Specifies the presentationTime.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTime
   */
  presentationTime(i) {
    return parseInt(i, 10);
  },
  /**
   * Default parser for all other attributes. Acts as a no-op and just returns the value
   * as a string
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {string}
   *         Unparsed value
   */
  DEFAULT(i) {
    return i;
  }
}, Ee = (i) => i && i.attributes ? Ld(i.attributes).reduce((e, t) => {
  const s = ql[t.name] || ql.DEFAULT;
  return e[t.name] = s(t.value), e;
}, {}) : {}, J_ = {
  "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
  "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
  "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
  "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime",
  // ISO_IEC 23009-1_2022 5.8.5.2.2 The mp4 Protection Scheme
  "urn:mpeg:dash:mp4protection:2011": "mp4protection"
}, Cn = (i, e) => e.length ? Gi(i.map(function(t) {
  return e.map(function(s) {
    const r = er(s), n = vn(t.baseUrl, r), a = De(Ee(s), {
      baseUrl: n
    });
    return n !== r && !a.serviceLocation && t.serviceLocation && (a.serviceLocation = t.serviceLocation), a;
  });
})) : i, Io = (i) => {
  const e = pe(i, "SegmentTemplate")[0], t = pe(i, "SegmentList")[0], s = t && pe(t, "SegmentURL").map((_) => De({
    tag: "SegmentURL"
  }, Ee(_))), r = pe(i, "SegmentBase")[0], n = t || e, a = n && pe(n, "SegmentTimeline")[0], o = t || r || e, l = o && pe(o, "Initialization")[0], h = e && Ee(e);
  h && l ? h.initialization = l && Ee(l) : h && h.initialization && (h.initialization = {
    sourceURL: h.initialization
  });
  const m = {
    template: h,
    segmentTimeline: a && pe(a, "S").map((_) => Ee(_)),
    list: t && De(Ee(t), {
      segmentUrls: s,
      initialization: Ee(l)
    }),
    base: r && De(Ee(r), {
      initialization: Ee(l)
    })
  };
  return Object.keys(m).forEach((_) => {
    m[_] || delete m[_];
  }), m;
}, Z_ = (i, e, t) => (s) => {
  const r = pe(s, "BaseURL"), n = Cn(e, r), a = De(i, Ee(s)), o = Io(s);
  return n.map((l) => ({
    segmentInfo: De(t, o),
    attributes: De(a, l)
  }));
}, ey = (i) => i.reduce((e, t) => {
  const s = Ee(t);
  s.schemeIdUri && (s.schemeIdUri = s.schemeIdUri.toLowerCase());
  const r = J_[s.schemeIdUri];
  if (r) {
    e[r] = {
      attributes: s
    };
    const n = pe(t, "cenc:pssh")[0];
    if (n) {
      const a = er(n);
      e[r].pssh = a && Qc(a);
    }
  }
  return e;
}, {}), ty = (i) => {
  if (i.schemeIdUri === "urn:scte:dash:cc:cea-608:2015")
    return (typeof i.value != "string" ? [] : i.value.split(";")).map((t) => {
      let s, r;
      return r = t, /^CC\d=/.test(t) ? [s, r] = t.split("=") : /^CC\d$/.test(t) && (s = t), {
        channel: s,
        language: r
      };
    });
  if (i.schemeIdUri === "urn:scte:dash:cc:cea-708:2015")
    return (typeof i.value != "string" ? [] : i.value.split(";")).map((t) => {
      const s = {
        // service or channel number 1-63
        channel: void 0,
        // language is a 3ALPHA per ISO 639.2/B
        // field is required
        language: void 0,
        // BIT 1/0 or ?
        // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
        aspectRatio: 1,
        // BIT 1/0
        // easy reader flag indicated the text is tailed to the needs of beginning readers
        // default 0, or off
        easyReader: 0,
        // BIT 1/0
        // If 3d metadata is present (CEA-708.1) then 1
        // default 0
        "3D": 0
      };
      if (/=/.test(t)) {
        const [r, n = ""] = t.split("=");
        s.channel = r, s.language = t, n.split(",").forEach((a) => {
          const [o, l] = a.split(":");
          o === "lang" ? s.language = l : o === "er" ? s.easyReader = Number(l) : o === "war" ? s.aspectRatio = Number(l) : o === "3D" && (s["3D"] = Number(l));
        });
      } else
        s.language = t;
      return s.channel && (s.channel = "SERVICE" + s.channel), s;
    });
}, iy = (i) => Gi(pe(i.node, "EventStream").map((e) => {
  const t = Ee(e), s = t.schemeIdUri;
  return pe(e, "Event").map((r) => {
    const n = Ee(r), a = n.presentationTime || 0, o = t.timescale || 1, l = n.duration || 0, h = a / o + i.attributes.start;
    return {
      schemeIdUri: s,
      value: t.value,
      id: n.id,
      start: h,
      end: h + l / o,
      messageData: er(r) || n.messageData,
      contentEncoding: t.contentEncoding,
      presentationTimeOffset: t.presentationTimeOffset || 0
    };
  });
})), sy = (i, e, t) => (s) => {
  const r = Ee(s), n = Cn(e, pe(s, "BaseURL")), a = pe(s, "Role")[0], o = {
    role: Ee(a)
  };
  let l = De(i, r, o);
  const h = pe(s, "Accessibility")[0], m = ty(Ee(h));
  m && (l = De(l, {
    captionServices: m
  }));
  const _ = pe(s, "Label")[0];
  if (_ && _.childNodes.length) {
    const D = _.childNodes[0].nodeValue.trim();
    l = De(l, {
      label: D
    });
  }
  const v = ey(pe(s, "ContentProtection"));
  Object.keys(v).length && (l = De(l, {
    contentProtection: v
  }));
  const C = Io(s), A = pe(s, "Representation"), y = De(t, C);
  return Gi(A.map(Z_(l, n, y)));
}, ry = (i, e) => (t, s) => {
  const r = Cn(e, pe(t.node, "BaseURL")), n = De(i, {
    periodStart: t.attributes.start
  });
  typeof t.attributes.duration == "number" && (n.periodDuration = t.attributes.duration);
  const a = pe(t.node, "AdaptationSet"), o = Io(t.node);
  return Gi(a.map(sy(n, r, o)));
}, ny = (i, e) => {
  if (i.length > 1 && e({
    type: "warn",
    message: "The MPD manifest should contain no more than one ContentSteering tag"
  }), !i.length)
    return null;
  const t = De({
    serverURL: er(i[0])
  }, Ee(i[0]));
  return t.queryBeforeStart = t.queryBeforeStart === "true", t;
}, ay = ({
  attributes: i,
  priorPeriodAttributes: e,
  mpdType: t
}) => typeof i.start == "number" ? i.start : e && typeof e.start == "number" && typeof e.duration == "number" ? e.start + e.duration : !e && t === "static" ? 0 : null, oy = (i, e = {}) => {
  const {
    manifestUri: t = "",
    NOW: s = Date.now(),
    clientOffset: r = 0,
    // TODO: For now, we are expecting an eventHandler callback function
    // to be passed into the mpd parser as an option.
    // In the future, we should enable stream parsing by using the Stream class from vhs-utils.
    // This will support new features including a standardized event handler.
    // See the m3u8 parser for examples of how stream parsing is currently used for HLS parsing.
    // https://github.com/videojs/vhs-utils/blob/88d6e10c631e57a5af02c5a62bc7376cd456b4f5/src/stream.js#L9
    eventHandler: n = function() {
    }
  } = e, a = pe(i, "Period");
  if (!a.length)
    throw new Error(Wi.INVALID_NUMBER_OF_PERIOD);
  const o = pe(i, "Location"), l = Ee(i), h = Cn([{
    baseUrl: t
  }], pe(i, "BaseURL")), m = pe(i, "ContentSteering");
  l.type = l.type || "static", l.sourceDuration = l.mediaPresentationDuration || 0, l.NOW = s, l.clientOffset = r, o.length && (l.locations = o.map(er));
  const _ = [];
  return a.forEach((v, C) => {
    const A = Ee(v), y = _[C - 1];
    A.start = ay({
      attributes: A,
      priorPeriodAttributes: y ? y.attributes : null,
      mpdType: l.type
    }), _.push({
      node: v,
      attributes: A
    });
  }), {
    locations: l.locations,
    contentSteeringInfo: ny(m, n),
    // TODO: There are occurences where this `representationInfo` array contains undesired
    // duplicates. This generally occurs when there are multiple BaseURL nodes that are
    // direct children of the MPD node. When we attempt to resolve URLs from a combination of the
    // parent BaseURL and a child BaseURL, and the value does not resolve,
    // we end up returning the child BaseURL multiple times.
    // We need to determine a way to remove these duplicates in a safe way.
    // See: https://github.com/videojs/mpd-parser/pull/17#discussion_r162750527
    representationInfo: Gi(_.map(ry(l, h))),
    eventStream: Gi(_.map(iy))
  };
}, Bd = (i) => {
  if (i === "")
    throw new Error(Wi.DASH_EMPTY_MANIFEST);
  const e = new __();
  let t, s;
  try {
    t = e.parseFromString(i, "application/xml"), s = t && t.documentElement.tagName === "MPD" ? t.documentElement : null;
  } catch {
  }
  if (!s || s && s.getElementsByTagName("parsererror").length > 0)
    throw new Error(Wi.DASH_INVALID_XML);
  return s;
}, uy = (i) => {
  const e = pe(i, "UTCTiming")[0];
  if (!e)
    return null;
  const t = Ee(e);
  switch (t.schemeIdUri) {
    case "urn:mpeg:dash:utc:http-head:2014":
    case "urn:mpeg:dash:utc:http-head:2012":
      t.method = "HEAD";
      break;
    case "urn:mpeg:dash:utc:http-xsdate:2014":
    case "urn:mpeg:dash:utc:http-iso:2014":
    case "urn:mpeg:dash:utc:http-xsdate:2012":
    case "urn:mpeg:dash:utc:http-iso:2012":
      t.method = "GET";
      break;
    case "urn:mpeg:dash:utc:direct:2014":
    case "urn:mpeg:dash:utc:direct:2012":
      t.method = "DIRECT", t.value = Date.parse(t.value);
      break;
    case "urn:mpeg:dash:utc:http-ntp:2014":
    case "urn:mpeg:dash:utc:ntp:2014":
    case "urn:mpeg:dash:utc:sntp:2014":
    default:
      throw new Error(Wi.UNSUPPORTED_UTC_TIMING_SCHEME);
  }
  return t;
}, ly = (i, e = {}) => {
  const t = oy(Bd(i), e), s = K_(t.representationInfo);
  return $_({
    dashPlaylists: s,
    locations: t.locations,
    contentSteering: t.contentSteeringInfo,
    sidxMapping: e.sidxMapping,
    previousManifest: e.previousManifest,
    eventStream: t.eventStream
  });
}, cy = (i) => uy(Bd(i));
var Fd = Math.pow(2, 32), dy = function(i) {
  var e = new DataView(i.buffer, i.byteOffset, i.byteLength), t;
  return e.getBigUint64 ? (t = e.getBigUint64(0), t < Number.MAX_SAFE_INTEGER ? Number(t) : t) : e.getUint32(0) * Fd + e.getUint32(4);
}, hy = {
  getUint64: dy,
  MAX_UINT32: Fd
}, jl = hy.getUint64, fy = function(i) {
  var e = new DataView(i.buffer, i.byteOffset, i.byteLength), t = {
    version: i[0],
    flags: new Uint8Array(i.subarray(1, 4)),
    references: [],
    referenceId: e.getUint32(4),
    timescale: e.getUint32(8)
  }, s = 12;
  t.version === 0 ? (t.earliestPresentationTime = e.getUint32(s), t.firstOffset = e.getUint32(s + 4), s += 8) : (t.earliestPresentationTime = jl(i.subarray(s)), t.firstOffset = jl(i.subarray(s + 8)), s += 16), s += 2;
  var r = e.getUint16(s);
  for (s += 2; r > 0; s += 12, r--)
    t.references.push({
      referenceType: (i[s] & 128) >>> 7,
      referencedSize: e.getUint32(s) & 2147483647,
      subsegmentDuration: e.getUint32(s + 4),
      startsWithSap: !!(i[s + 8] & 128),
      sapType: (i[s + 8] & 112) >>> 4,
      sapDeltaTime: e.getUint32(s + 8) & 268435455
    });
  return t;
}, py = fy;
const my = /* @__PURE__ */ Ks(py);
var gy = z([73, 68, 51]), _y = function(e, t) {
  t === void 0 && (t = 0), e = z(e);
  var s = e[t + 5], r = e[t + 6] << 21 | e[t + 7] << 14 | e[t + 8] << 7 | e[t + 9], n = (s & 16) >> 4;
  return n ? r + 20 : r + 10;
}, Ps = function i(e, t) {
  return t === void 0 && (t = 0), e = z(e), e.length - t < 10 || !fe(e, gy, {
    offset: t
  }) ? t : (t += _y(e, t), i(e, t));
}, Hl = function(e) {
  return typeof e == "string" ? id(e) : e;
}, yy = function(e) {
  return Array.isArray(e) ? e.map(function(t) {
    return Hl(t);
  }) : [Hl(e)];
}, Ty = function i(e, t, s) {
  s === void 0 && (s = !1), t = yy(t), e = z(e);
  var r = [];
  if (!t.length)
    return r;
  for (var n = 0; n < e.length; ) {
    var a = (e[n] << 24 | e[n + 1] << 16 | e[n + 2] << 8 | e[n + 3]) >>> 0, o = e.subarray(n + 4, n + 8);
    if (a === 0)
      break;
    var l = n + a;
    if (l > e.length) {
      if (s)
        break;
      l = e.length;
    }
    var h = e.subarray(n + 8, l);
    fe(o, t[0]) && (t.length === 1 ? r.push(h) : r.push.apply(r, i(h, t.slice(1), s))), n = l;
  }
  return r;
}, Rr = {
  EBML: z([26, 69, 223, 163]),
  DocType: z([66, 130]),
  Segment: z([24, 83, 128, 103]),
  SegmentInfo: z([21, 73, 169, 102]),
  Tracks: z([22, 84, 174, 107]),
  Track: z([174]),
  TrackNumber: z([215]),
  DefaultDuration: z([35, 227, 131]),
  TrackEntry: z([174]),
  TrackType: z([131]),
  FlagDefault: z([136]),
  CodecID: z([134]),
  CodecPrivate: z([99, 162]),
  VideoTrack: z([224]),
  AudioTrack: z([225]),
  // Not used yet, but will be used for live webm/mkv
  // see https://www.matroska.org/technical/basics.html#block-structure
  // see https://www.matroska.org/technical/basics.html#simpleblock-structure
  Cluster: z([31, 67, 182, 117]),
  Timestamp: z([231]),
  TimestampScale: z([42, 215, 177]),
  BlockGroup: z([160]),
  BlockDuration: z([155]),
  Block: z([161]),
  SimpleBlock: z([163])
}, Ua = [128, 64, 32, 16, 8, 4, 2, 1], vy = function(e) {
  for (var t = 1, s = 0; s < Ua.length && !(e & Ua[s]); s++)
    t++;
  return t;
}, Kr = function(e, t, s, r) {
  s === void 0 && (s = !0), r === void 0 && (r = !1);
  var n = vy(e[t]), a = e.subarray(t, t + n);
  return s && (a = Array.prototype.slice.call(e, t, t + n), a[0] ^= Ua[n - 1]), {
    length: n,
    value: $0(a, {
      signed: r
    }),
    bytes: a
  };
}, Vl = function i(e) {
  return typeof e == "string" ? e.match(/.{1,2}/g).map(function(t) {
    return i(t);
  }) : typeof e == "number" ? q0(e) : e;
}, by = function(e) {
  return Array.isArray(e) ? e.map(function(t) {
    return Vl(t);
  }) : [Vl(e)];
}, xy = function i(e, t, s) {
  if (s >= t.length)
    return t.length;
  var r = Kr(t, s, !1);
  if (fe(e.bytes, r.bytes))
    return s;
  var n = Kr(t, s + r.length);
  return i(e, t, s + n.length + n.value + r.length);
}, zl = function i(e, t) {
  t = by(t), e = z(e);
  var s = [];
  if (!t.length)
    return s;
  for (var r = 0; r < e.length; ) {
    var n = Kr(e, r, !1), a = Kr(e, r + n.length), o = r + n.length + a.length;
    a.value === 127 && (a.value = xy(n, e, o), a.value !== e.length && (a.value -= o));
    var l = o + a.value > e.length ? e.length : o + a.value, h = e.subarray(o, l);
    fe(t[0], n.bytes) && (t.length === 1 ? s.push(h) : s = s.concat(i(h, t.slice(1))));
    var m = n.length + a.length + h.length;
    r += m;
  }
  return s;
}, Sy = z([0, 0, 0, 1]), Ey = z([0, 0, 1]), Cy = z([0, 0, 3]), Ay = function(e) {
  for (var t = [], s = 1; s < e.length - 2; )
    fe(e.subarray(s, s + 3), Cy) && (t.push(s + 2), s++), s++;
  if (t.length === 0)
    return e;
  var r = e.length - t.length, n = new Uint8Array(r), a = 0;
  for (s = 0; s < r; a++, s++)
    a === t[0] && (a++, t.shift()), n[s] = e[a];
  return n;
}, Ud = function(e, t, s, r) {
  e = z(e), s = [].concat(s);
  for (var n = 0, a, o = 0; n < e.length && (o < r || a); ) {
    var l = void 0;
    if (fe(e.subarray(n), Sy) ? l = 4 : fe(e.subarray(n), Ey) && (l = 3), !l) {
      n++;
      continue;
    }
    if (o++, a)
      return Ay(e.subarray(a, n));
    var h = void 0;
    t === "h264" ? h = e[n + l] & 31 : t === "h265" && (h = e[n + l] >> 1 & 63), s.indexOf(h) !== -1 && (a = n + l), n += l + (t === "h264" ? 1 : 2);
  }
  return e.subarray(0, 0);
}, Dy = function(e, t, s) {
  return Ud(e, "h264", t, s);
}, wy = function(e, t, s) {
  return Ud(e, "h265", t, s);
}, Be = {
  // "webm" string literal in hex
  webm: z([119, 101, 98, 109]),
  // "matroska" string literal in hex
  matroska: z([109, 97, 116, 114, 111, 115, 107, 97]),
  // "fLaC" string literal in hex
  flac: z([102, 76, 97, 67]),
  // "OggS" string literal in hex
  ogg: z([79, 103, 103, 83]),
  // ac-3 sync byte, also works for ec-3 as that is simply a codec
  // of ac-3
  ac3: z([11, 119]),
  // "RIFF" string literal in hex used for wav and avi
  riff: z([82, 73, 70, 70]),
  // "AVI" string literal in hex
  avi: z([65, 86, 73]),
  // "WAVE" string literal in hex
  wav: z([87, 65, 86, 69]),
  // "ftyp3g" string literal in hex
  "3gp": z([102, 116, 121, 112, 51, 103]),
  // "ftyp" string literal in hex
  mp4: z([102, 116, 121, 112]),
  // "styp" string literal in hex
  fmp4: z([115, 116, 121, 112]),
  // "ftypqt" string literal in hex
  mov: z([102, 116, 121, 112, 113, 116]),
  // moov string literal in hex
  moov: z([109, 111, 111, 118]),
  // moof string literal in hex
  moof: z([109, 111, 111, 102])
}, Xi = {
  aac: function(e) {
    var t = Ps(e);
    return fe(e, [255, 16], {
      offset: t,
      mask: [255, 22]
    });
  },
  mp3: function(e) {
    var t = Ps(e);
    return fe(e, [255, 2], {
      offset: t,
      mask: [255, 6]
    });
  },
  webm: function(e) {
    var t = zl(e, [Rr.EBML, Rr.DocType])[0];
    return fe(t, Be.webm);
  },
  mkv: function(e) {
    var t = zl(e, [Rr.EBML, Rr.DocType])[0];
    return fe(t, Be.matroska);
  },
  mp4: function(e) {
    if (Xi["3gp"](e) || Xi.mov(e))
      return !1;
    if (fe(e, Be.mp4, {
      offset: 4
    }) || fe(e, Be.fmp4, {
      offset: 4
    }) || fe(e, Be.moof, {
      offset: 4
    }) || fe(e, Be.moov, {
      offset: 4
    }))
      return !0;
  },
  mov: function(e) {
    return fe(e, Be.mov, {
      offset: 4
    });
  },
  "3gp": function(e) {
    return fe(e, Be["3gp"], {
      offset: 4
    });
  },
  ac3: function(e) {
    var t = Ps(e);
    return fe(e, Be.ac3, {
      offset: t
    });
  },
  ts: function(e) {
    if (e.length < 189 && e.length >= 1)
      return e[0] === 71;
    for (var t = 0; t + 188 < e.length && t < 188; ) {
      if (e[t] === 71 && e[t + 188] === 71)
        return !0;
      t += 1;
    }
    return !1;
  },
  flac: function(e) {
    var t = Ps(e);
    return fe(e, Be.flac, {
      offset: t
    });
  },
  ogg: function(e) {
    return fe(e, Be.ogg);
  },
  avi: function(e) {
    return fe(e, Be.riff) && fe(e, Be.avi, {
      offset: 8
    });
  },
  wav: function(e) {
    return fe(e, Be.riff) && fe(e, Be.wav, {
      offset: 8
    });
  },
  h264: function(e) {
    return Dy(e, 7, 3).length;
  },
  h265: function(e) {
    return wy(e, [32, 33], 3).length;
  }
}, $a = Object.keys(Xi).filter(function(i) {
  return i !== "ts" && i !== "h264" && i !== "h265";
}).concat(["ts", "h264", "h265"]);
$a.forEach(function(i) {
  var e = Xi[i];
  Xi[i] = function(t) {
    return e(z(t));
  };
});
var Iy = Xi, ko = function(e) {
  e = z(e);
  for (var t = 0; t < $a.length; t++) {
    var s = $a[t];
    if (Iy[s](e))
      return s;
  }
  return "";
}, ky = function(e) {
  return Ty(e, ["moof"]).length > 0;
}, Po = 9e4, Oo, Lo, An, Ro, $d, qd, jd;
Oo = function(i) {
  return i * Po;
};
Lo = function(i, e) {
  return i * e;
};
An = function(i) {
  return i / Po;
};
Ro = function(i, e) {
  return i / e;
};
$d = function(i, e) {
  return Oo(Ro(i, e));
};
qd = function(i, e) {
  return Lo(An(i), e);
};
jd = function(i, e, t) {
  return An(t ? i : i - e);
};
var ci = {
  ONE_SECOND_IN_TS: Po,
  secondsToVideoTs: Oo,
  secondsToAudioTs: Lo,
  videoTsToSeconds: An,
  audioTsToSeconds: Ro,
  audioTsToVideoTs: $d,
  videoTsToAudioTs: qd,
  metadataTsToSeconds: jd
};
/**
 * @license
 * Video.js 8.19.1 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */
var qa = "8.19.1";
const Pt = {}, Xt = function(i, e) {
  return Pt[i] = Pt[i] || [], e && (Pt[i] = Pt[i].concat(e)), Pt[i];
}, Py = function(i, e) {
  Xt(i, e);
}, Hd = function(i, e) {
  const t = Xt(i).indexOf(e);
  return t <= -1 ? !1 : (Pt[i] = Pt[i].slice(), Pt[i].splice(t, 1), !0);
}, Oy = function(i, e) {
  Xt(i, [].concat(e).map((t) => {
    const s = (...r) => (Hd(i, s), t(...r));
    return s;
  }));
}, Yr = {
  prefixed: !0
}, $r = [
  ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"],
  // WebKit
  ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"]
], Gl = $r[0];
let Os;
for (let i = 0; i < $r.length; i++)
  if ($r[i][1] in U) {
    Os = $r[i];
    break;
  }
if (Os) {
  for (let i = 0; i < Os.length; i++)
    Yr[Gl[i]] = Os[i];
  Yr.prefixed = Os[0] !== Gl[0];
}
let Ve = [];
const Ly = (i, e, t) => (s, r, n) => {
  const a = e.levels[r], o = new RegExp(`^(${a})$`);
  let l = i;
  if (s !== "log" && n.unshift(s.toUpperCase() + ":"), t && (l = `%c${i}`, n.unshift(t)), n.unshift(l + ":"), Ve) {
    Ve.push([].concat(n));
    const m = Ve.length - 1e3;
    Ve.splice(0, m > 0 ? m : 0);
  }
  if (!S.console)
    return;
  let h = S.console[s];
  !h && s === "debug" && (h = S.console.info || S.console.log), !(!h || !a || !o.test(s)) && h[Array.isArray(n) ? "apply" : "call"](S.console, n);
};
function ja(i, e = ":", t = "") {
  let s = "info", r;
  function n(...a) {
    r("log", s, a);
  }
  return r = Ly(i, n, t), n.createLogger = (a, o, l) => {
    const h = o !== void 0 ? o : e, m = l !== void 0 ? l : t, _ = `${i} ${h} ${a}`;
    return ja(_, h, m);
  }, n.createNewLogger = (a, o, l) => ja(a, o, l), n.levels = {
    all: "debug|log|warn|error",
    off: "",
    debug: "debug|log|warn|error",
    info: "log|warn|error",
    warn: "warn|error",
    error: "error",
    DEFAULT: s
  }, n.level = (a) => {
    if (typeof a == "string") {
      if (!n.levels.hasOwnProperty(a))
        throw new Error(`"${a}" in not a valid log level`);
      s = a;
    }
    return s;
  }, n.history = () => Ve ? [].concat(Ve) : [], n.history.filter = (a) => (Ve || []).filter((o) => new RegExp(`.*${a}.*`).test(o[0])), n.history.clear = () => {
    Ve && (Ve.length = 0);
  }, n.history.disable = () => {
    Ve !== null && (Ve.length = 0, Ve = null);
  }, n.history.enable = () => {
    Ve === null && (Ve = []);
  }, n.error = (...a) => r("error", s, a), n.warn = (...a) => r("warn", s, a), n.debug = (...a) => r("debug", s, a), n;
}
const Q = ja("VIDEOJS"), Vd = Q.createLogger, Ry = Object.prototype.toString, zd = function(i) {
  return St(i) ? Object.keys(i) : [];
};
function Ni(i, e) {
  zd(i).forEach((t) => e(i[t], t));
}
function Gd(i, e, t = 0) {
  return zd(i).reduce((s, r) => e(s, i[r], r), t);
}
function St(i) {
  return !!i && typeof i == "object";
}
function Ki(i) {
  return St(i) && Ry.call(i) === "[object Object]" && i.constructor === Object;
}
function oe(...i) {
  const e = {};
  return i.forEach((t) => {
    t && Ni(t, (s, r) => {
      if (!Ki(s)) {
        e[r] = s;
        return;
      }
      Ki(e[r]) || (e[r] = {}), e[r] = oe(e[r], s);
    });
  }), e;
}
function Wd(i = {}) {
  const e = [];
  for (const t in i)
    if (i.hasOwnProperty(t)) {
      const s = i[t];
      e.push(s);
    }
  return e;
}
function Dn(i, e, t, s = !0) {
  const r = (a) => Object.defineProperty(i, e, {
    value: a,
    enumerable: !0,
    writable: !0
  }), n = {
    configurable: !0,
    enumerable: !0,
    get() {
      const a = t();
      return r(a), a;
    }
  };
  return s && (n.set = r), Object.defineProperty(i, e, n);
}
var Ny = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  each: Ni,
  reduce: Gd,
  isObject: St,
  isPlain: Ki,
  merge: oe,
  values: Wd,
  defineLazyProperty: Dn
});
let No = !1, Xd = null, Et = !1, Kd, Yd = !1, Mi = !1, Bi = !1, Ct = !1, Mo = null, wn = null;
const My = !!(S.cast && S.cast.framework && S.cast.framework.CastReceiverContext);
let Qd = null, Qr = !1, In = !1, Jr = !1, kn = !1, Zr = !1, en = !1, tn = !1;
const Gs = !!(is() && ("ontouchstart" in S || S.navigator.maxTouchPoints || S.DocumentTouch && S.document instanceof S.DocumentTouch)), Vt = S.navigator && S.navigator.userAgentData;
Vt && Vt.platform && Vt.brands && (Et = Vt.platform === "Android", Mi = !!Vt.brands.find((i) => i.brand === "Microsoft Edge"), Bi = !!Vt.brands.find((i) => i.brand === "Chromium"), Ct = !Mi && Bi, Mo = wn = (Vt.brands.find((i) => i.brand === "Chromium") || {}).version || null, In = Vt.platform === "Windows");
if (!Bi) {
  const i = S.navigator && S.navigator.userAgent || "";
  No = /iPod/i.test(i), Xd = function() {
    const e = i.match(/OS (\d+)_/i);
    return e && e[1] ? e[1] : null;
  }(), Et = /Android/i.test(i), Kd = function() {
    const e = i.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
    if (!e)
      return null;
    const t = e[1] && parseFloat(e[1]), s = e[2] && parseFloat(e[2]);
    return t && s ? parseFloat(e[1] + "." + e[2]) : t || null;
  }(), Yd = /Firefox/i.test(i), Mi = /Edg/i.test(i), Bi = /Chrome/i.test(i) || /CriOS/i.test(i), Ct = !Mi && Bi, Mo = wn = function() {
    const e = i.match(/(Chrome|CriOS)\/(\d+)/);
    return e && e[2] ? parseFloat(e[2]) : null;
  }(), Qd = function() {
    const e = /MSIE\s(\d+)\.\d/.exec(i);
    let t = e && parseFloat(e[1]);
    return !t && /Trident\/7.0/i.test(i) && /rv:11.0/.test(i) && (t = 11), t;
  }(), Zr = /Tizen/i.test(i), en = /Web0S/i.test(i), tn = Zr || en, Qr = /Safari/i.test(i) && !Ct && !Et && !Mi && !tn, In = /Windows/i.test(i), Jr = /iPad/i.test(i) || Qr && Gs && !/iPhone/i.test(i), kn = /iPhone/i.test(i) && !Jr;
}
const je = kn || Jr || No, Pn = (Qr || je) && !Ct;
var Jd = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  get IS_IPOD() {
    return No;
  },
  get IOS_VERSION() {
    return Xd;
  },
  get IS_ANDROID() {
    return Et;
  },
  get ANDROID_VERSION() {
    return Kd;
  },
  get IS_FIREFOX() {
    return Yd;
  },
  get IS_EDGE() {
    return Mi;
  },
  get IS_CHROMIUM() {
    return Bi;
  },
  get IS_CHROME() {
    return Ct;
  },
  get CHROMIUM_VERSION() {
    return Mo;
  },
  get CHROME_VERSION() {
    return wn;
  },
  IS_CHROMECAST_RECEIVER: My,
  get IE_VERSION() {
    return Qd;
  },
  get IS_SAFARI() {
    return Qr;
  },
  get IS_WINDOWS() {
    return In;
  },
  get IS_IPAD() {
    return Jr;
  },
  get IS_IPHONE() {
    return kn;
  },
  get IS_TIZEN() {
    return Zr;
  },
  get IS_WEBOS() {
    return en;
  },
  get IS_SMART_TV() {
    return tn;
  },
  TOUCH_ENABLED: Gs,
  IS_IOS: je,
  IS_ANY_SAFARI: Pn
});
function Wl(i) {
  return typeof i == "string" && !!i.trim();
}
function By(i) {
  if (i.indexOf(" ") >= 0)
    throw new Error("class has illegal whitespace characters");
}
function is() {
  return U === S.document;
}
function ss(i) {
  return St(i) && i.nodeType === 1;
}
function Zd() {
  try {
    return S.parent !== S.self;
  } catch {
    return !0;
  }
}
function eh(i) {
  return function(e, t) {
    if (!Wl(e))
      return U[i](null);
    Wl(t) && (t = U.querySelector(t));
    const s = ss(t) ? t : U;
    return s[i] && s[i](e);
  };
}
function W(i = "div", e = {}, t = {}, s) {
  const r = U.createElement(i);
  return Object.getOwnPropertyNames(e).forEach(function(n) {
    const a = e[n];
    n === "textContent" ? Qt(r, a) : (r[n] !== a || n === "tabIndex") && (r[n] = a);
  }), Object.getOwnPropertyNames(t).forEach(function(n) {
    r.setAttribute(n, t[n]);
  }), s && Bo(r, s), r;
}
function Qt(i, e) {
  return typeof i.textContent > "u" ? i.innerText = e : i.textContent = e, i;
}
function Ha(i, e) {
  e.firstChild ? e.insertBefore(i, e.firstChild) : e.appendChild(i);
}
function Ms(i, e) {
  return By(e), i.classList.contains(e);
}
function fi(i, ...e) {
  return i.classList.add(...e.reduce((t, s) => t.concat(s.split(/\s+/)), [])), i;
}
function On(i, ...e) {
  return i ? (i.classList.remove(...e.reduce((t, s) => t.concat(s.split(/\s+/)), [])), i) : (Q.warn("removeClass was called with an element that doesn't exist"), null);
}
function th(i, e, t) {
  return typeof t == "function" && (t = t(i, e)), typeof t != "boolean" && (t = void 0), e.split(/\s+/).forEach((s) => i.classList.toggle(s, t)), i;
}
function ih(i, e) {
  Object.getOwnPropertyNames(e).forEach(function(t) {
    const s = e[t];
    s === null || typeof s > "u" || s === !1 ? i.removeAttribute(t) : i.setAttribute(t, s === !0 ? "" : s);
  });
}
function Gt(i) {
  const e = {}, t = ["autoplay", "controls", "playsinline", "loop", "muted", "default", "defaultMuted"];
  if (i && i.attributes && i.attributes.length > 0) {
    const s = i.attributes;
    for (let r = s.length - 1; r >= 0; r--) {
      const n = s[r].name;
      let a = s[r].value;
      t.includes(n) && (a = a !== null), e[n] = a;
    }
  }
  return e;
}
function sh(i, e) {
  return i.getAttribute(e);
}
function Yi(i, e, t) {
  i.setAttribute(e, t);
}
function Ln(i, e) {
  i.removeAttribute(e);
}
function rh() {
  U.body.focus(), U.onselectstart = function() {
    return !1;
  };
}
function nh() {
  U.onselectstart = function() {
    return !0;
  };
}
function Qi(i) {
  if (i && i.getBoundingClientRect && i.parentNode) {
    const e = i.getBoundingClientRect(), t = {};
    return ["bottom", "height", "left", "right", "top", "width"].forEach((s) => {
      e[s] !== void 0 && (t[s] = e[s]);
    }), t.height || (t.height = parseFloat(Ji(i, "height"))), t.width || (t.width = parseFloat(Ji(i, "width"))), t;
  }
}
function Ws(i) {
  if (!i || i && !i.offsetParent)
    return {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    };
  const e = i.offsetWidth, t = i.offsetHeight;
  let s = 0, r = 0;
  for (; i.offsetParent && i !== U[Yr.fullscreenElement]; )
    s += i.offsetLeft, r += i.offsetTop, i = i.offsetParent;
  return {
    left: s,
    top: r,
    width: e,
    height: t
  };
}
function Rn(i, e) {
  const t = {
    x: 0,
    y: 0
  };
  if (je) {
    let m = i;
    for (; m && m.nodeName.toLowerCase() !== "html"; ) {
      const _ = Ji(m, "transform");
      if (/^matrix/.test(_)) {
        const v = _.slice(7, -1).split(/,\s/).map(Number);
        t.x += v[4], t.y += v[5];
      } else if (/^matrix3d/.test(_)) {
        const v = _.slice(9, -1).split(/,\s/).map(Number);
        t.x += v[12], t.y += v[13];
      }
      if (m.assignedSlot && m.assignedSlot.parentElement && S.WebKitCSSMatrix) {
        const v = S.getComputedStyle(m.assignedSlot.parentElement).transform, C = new S.WebKitCSSMatrix(v);
        t.x += C.m41, t.y += C.m42;
      }
      m = m.parentNode || m.host;
    }
  }
  const s = {}, r = Ws(e.target), n = Ws(i), a = n.width, o = n.height;
  let l = e.offsetY - (n.top - r.top), h = e.offsetX - (n.left - r.left);
  return e.changedTouches && (h = e.changedTouches[0].pageX - n.left, l = e.changedTouches[0].pageY + n.top, je && (h -= t.x, l -= t.y)), s.y = 1 - Math.max(0, Math.min(1, l / o)), s.x = Math.max(0, Math.min(1, h / a)), s;
}
function ah(i) {
  return St(i) && i.nodeType === 3;
}
function Nn(i) {
  for (; i.firstChild; )
    i.removeChild(i.firstChild);
  return i;
}
function oh(i) {
  return typeof i == "function" && (i = i()), (Array.isArray(i) ? i : [i]).map((e) => {
    if (typeof e == "function" && (e = e()), ss(e) || ah(e))
      return e;
    if (typeof e == "string" && /\S/.test(e))
      return U.createTextNode(e);
  }).filter((e) => e);
}
function Bo(i, e) {
  return oh(e).forEach((t) => i.appendChild(t)), i;
}
function uh(i, e) {
  return Bo(Nn(i), e);
}
function Xs(i) {
  return i.button === void 0 && i.buttons === void 0 || i.button === 0 && i.buttons === void 0 || i.type === "mouseup" && i.button === 0 && i.buttons === 0 || i.type === "mousedown" && i.button === 0 && i.buttons === 0 ? !0 : !(i.button !== 0 || i.buttons !== 1);
}
const Kt = eh("querySelector"), lh = eh("querySelectorAll");
function Ji(i, e) {
  if (!i || !e)
    return "";
  if (typeof S.getComputedStyle == "function") {
    let t;
    try {
      t = S.getComputedStyle(i);
    } catch {
      return "";
    }
    return t ? t.getPropertyValue(e) || t[e] : "";
  }
  return "";
}
function ch(i) {
  [...U.styleSheets].forEach((e) => {
    try {
      const t = [...e.cssRules].map((r) => r.cssText).join(""), s = U.createElement("style");
      s.textContent = t, i.document.head.appendChild(s);
    } catch {
      const s = U.createElement("link");
      s.rel = "stylesheet", s.type = e.type, s.media = e.media.mediaText, s.href = e.href, i.document.head.appendChild(s);
    }
  });
}
var dh = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isReal: is,
  isEl: ss,
  isInFrame: Zd,
  createEl: W,
  textContent: Qt,
  prependTo: Ha,
  hasClass: Ms,
  addClass: fi,
  removeClass: On,
  toggleClass: th,
  setAttributes: ih,
  getAttributes: Gt,
  getAttribute: sh,
  setAttribute: Yi,
  removeAttribute: Ln,
  blockTextSelection: rh,
  unblockTextSelection: nh,
  getBoundingClientRect: Qi,
  findPosition: Ws,
  getPointerPosition: Rn,
  isTextNode: ah,
  emptyEl: Nn,
  normalizeContent: oh,
  appendContent: Bo,
  insertContent: uh,
  isSingleLeftClick: Xs,
  $: Kt,
  $$: lh,
  computedStyle: Ji,
  copyStyleSheetsToWindow: ch
});
let hh = !1, Va;
const Fy = function() {
  if (Va.options.autoSetup === !1)
    return;
  const i = Array.prototype.slice.call(U.getElementsByTagName("video")), e = Array.prototype.slice.call(U.getElementsByTagName("audio")), t = Array.prototype.slice.call(U.getElementsByTagName("video-js")), s = i.concat(e, t);
  if (s && s.length > 0)
    for (let r = 0, n = s.length; r < n; r++) {
      const a = s[r];
      if (a && a.getAttribute)
        a.player === void 0 && a.getAttribute("data-setup") !== null && Va(a);
      else {
        za(1);
        break;
      }
    }
  else hh || za(1);
};
function za(i, e) {
  is() && (e && (Va = e), S.setTimeout(Fy, i));
}
function Ga() {
  hh = !0, S.removeEventListener("load", Ga);
}
is() && (U.readyState === "complete" ? Ga() : S.addEventListener("load", Ga));
const fh = function(i) {
  const e = U.createElement("style");
  return e.className = i, e;
}, ph = function(i, e) {
  i.styleSheet ? i.styleSheet.cssText = e : i.textContent = e;
};
var qe = /* @__PURE__ */ new WeakMap();
const Uy = 3;
let $y = Uy;
function nt() {
  return $y++;
}
function Xl(i, e) {
  if (!qe.has(i))
    return;
  const t = qe.get(i);
  t.handlers[e].length === 0 && (delete t.handlers[e], i.removeEventListener ? i.removeEventListener(e, t.dispatcher, !1) : i.detachEvent && i.detachEvent("on" + e, t.dispatcher)), Object.getOwnPropertyNames(t.handlers).length <= 0 && (delete t.handlers, delete t.dispatcher, delete t.disabled), Object.getOwnPropertyNames(t).length === 0 && qe.delete(i);
}
function Fo(i, e, t, s) {
  t.forEach(function(r) {
    i(e, r, s);
  });
}
function Mn(i) {
  if (i.fixed_)
    return i;
  function e() {
    return !0;
  }
  function t() {
    return !1;
  }
  if (!i || !i.isPropagationStopped || !i.isImmediatePropagationStopped) {
    const s = i || S.event;
    i = {};
    const r = ["layerX", "layerY", "keyLocation", "path", "webkitMovementX", "webkitMovementY", "mozPressure", "mozInputSource"];
    for (const n in s)
      r.includes(n) || n === "returnValue" && s.preventDefault || (i[n] = s[n]);
    if (i.target || (i.target = i.srcElement || U), i.relatedTarget || (i.relatedTarget = i.fromElement === i.target ? i.toElement : i.fromElement), i.preventDefault = function() {
      s.preventDefault && s.preventDefault(), i.returnValue = !1, s.returnValue = !1, i.defaultPrevented = !0;
    }, i.defaultPrevented = !1, i.stopPropagation = function() {
      s.stopPropagation && s.stopPropagation(), i.cancelBubble = !0, s.cancelBubble = !0, i.isPropagationStopped = e;
    }, i.isPropagationStopped = t, i.stopImmediatePropagation = function() {
      s.stopImmediatePropagation && s.stopImmediatePropagation(), i.isImmediatePropagationStopped = e, i.stopPropagation();
    }, i.isImmediatePropagationStopped = t, i.clientX !== null && i.clientX !== void 0) {
      const n = U.documentElement, a = U.body;
      i.pageX = i.clientX + (n && n.scrollLeft || a && a.scrollLeft || 0) - (n && n.clientLeft || a && a.clientLeft || 0), i.pageY = i.clientY + (n && n.scrollTop || a && a.scrollTop || 0) - (n && n.clientTop || a && a.clientTop || 0);
    }
    i.which = i.charCode || i.keyCode, i.button !== null && i.button !== void 0 && (i.button = i.button & 1 ? 0 : i.button & 4 ? 1 : i.button & 2 ? 2 : 0);
  }
  return i.fixed_ = !0, i;
}
let Nr;
const qy = function() {
  if (typeof Nr != "boolean") {
    Nr = !1;
    try {
      const i = Object.defineProperty({}, "passive", {
        get() {
          Nr = !0;
        }
      });
      S.addEventListener("test", null, i), S.removeEventListener("test", null, i);
    } catch {
    }
  }
  return Nr;
}, jy = ["touchstart", "touchmove"];
function et(i, e, t) {
  if (Array.isArray(e))
    return Fo(et, i, e, t);
  qe.has(i) || qe.set(i, {});
  const s = qe.get(i);
  if (s.handlers || (s.handlers = {}), s.handlers[e] || (s.handlers[e] = []), t.guid || (t.guid = nt()), s.handlers[e].push(t), s.dispatcher || (s.disabled = !1, s.dispatcher = function(r, n) {
    if (s.disabled)
      return;
    r = Mn(r);
    const a = s.handlers[r.type];
    if (a) {
      const o = a.slice(0);
      for (let l = 0, h = o.length; l < h && !r.isImmediatePropagationStopped(); l++)
        try {
          o[l].call(i, r, n);
        } catch (m) {
          Q.error(m);
        }
    }
  }), s.handlers[e].length === 1)
    if (i.addEventListener) {
      let r = !1;
      qy() && jy.indexOf(e) > -1 && (r = {
        passive: !0
      }), i.addEventListener(e, s.dispatcher, r);
    } else i.attachEvent && i.attachEvent("on" + e, s.dispatcher);
}
function Pe(i, e, t) {
  if (!qe.has(i))
    return;
  const s = qe.get(i);
  if (!s.handlers)
    return;
  if (Array.isArray(e))
    return Fo(Pe, i, e, t);
  const r = function(a, o) {
    s.handlers[o] = [], Xl(a, o);
  };
  if (e === void 0) {
    for (const a in s.handlers)
      Object.prototype.hasOwnProperty.call(s.handlers || {}, a) && r(i, a);
    return;
  }
  const n = s.handlers[e];
  if (n) {
    if (!t) {
      r(i, e);
      return;
    }
    if (t.guid)
      for (let a = 0; a < n.length; a++)
        n[a].guid === t.guid && n.splice(a--, 1);
    Xl(i, e);
  }
}
function rs(i, e, t) {
  const s = qe.has(i) ? qe.get(i) : {}, r = i.parentNode || i.ownerDocument;
  if (typeof e == "string" ? e = {
    type: e,
    target: i
  } : e.target || (e.target = i), e = Mn(e), s.dispatcher && s.dispatcher.call(i, e, t), r && !e.isPropagationStopped() && e.bubbles === !0)
    rs.call(null, r, e, t);
  else if (!r && !e.defaultPrevented && e.target && e.target[e.type]) {
    qe.has(e.target) || qe.set(e.target, {});
    const n = qe.get(e.target);
    e.target[e.type] && (n.disabled = !0, typeof e.target[e.type] == "function" && e.target[e.type](), n.disabled = !1);
  }
  return !e.defaultPrevented;
}
function Bn(i, e, t) {
  if (Array.isArray(e))
    return Fo(Bn, i, e, t);
  const s = function() {
    Pe(i, e, s), t.apply(this, arguments);
  };
  s.guid = t.guid = t.guid || nt(), et(i, e, s);
}
function Uo(i, e, t) {
  const s = function() {
    Pe(i, e, s), t.apply(this, arguments);
  };
  s.guid = t.guid = t.guid || nt(), et(i, e, s);
}
var Hy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fixEvent: Mn,
  on: et,
  off: Pe,
  trigger: rs,
  one: Bn,
  any: Uo
});
const at = 30, le = function(i, e, t) {
  e.guid || (e.guid = nt());
  const s = e.bind(i);
  return s.guid = t ? t + "_" + e.guid : e.guid, s;
}, At = function(i, e) {
  let t = S.performance.now();
  return function(...r) {
    const n = S.performance.now();
    n - t >= e && (i(...r), t = n);
  };
}, mh = function(i, e, t, s = S) {
  let r;
  const n = () => {
    s.clearTimeout(r), r = null;
  }, a = function() {
    const o = this, l = arguments;
    let h = function() {
      r = null, h = null, t || i.apply(o, l);
    };
    !r && t && i.apply(o, l), s.clearTimeout(r), r = s.setTimeout(h, e);
  };
  return a.cancel = n, a;
};
var Vy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  UPDATE_REFRESH_INTERVAL: at,
  bind_: le,
  throttle: At,
  debounce: mh
});
let Cs;
class tt {
  /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */
  on(e, t) {
    const s = this.addEventListener;
    this.addEventListener = () => {
    }, et(this, e, t), this.addEventListener = s;
  }
  /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to remove.
   */
  off(e, t) {
    Pe(this, e, t);
  }
  /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  one(e, t) {
    const s = this.addEventListener;
    this.addEventListener = () => {
    }, Bn(this, e, t), this.addEventListener = s;
  }
  /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  any(e, t) {
    const s = this.addEventListener;
    this.addEventListener = () => {
    }, Uo(this, e, t), this.addEventListener = s;
  }
  /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|EventTarget~Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   */
  trigger(e) {
    const t = e.type || e;
    typeof e == "string" && (e = {
      type: t
    }), e = Mn(e), this.allowedEvents_[t] && this["on" + t] && this["on" + t](e), rs(this, e);
  }
  queueTrigger(e) {
    Cs || (Cs = /* @__PURE__ */ new Map());
    const t = e.type || e;
    let s = Cs.get(this);
    s || (s = /* @__PURE__ */ new Map(), Cs.set(this, s));
    const r = s.get(t);
    s.delete(t), S.clearTimeout(r);
    const n = S.setTimeout(() => {
      s.delete(t), s.size === 0 && (s = null, Cs.delete(this)), this.trigger(e);
    }, 0);
    s.set(t, n);
  }
}
tt.prototype.allowedEvents_ = {};
tt.prototype.addEventListener = tt.prototype.on;
tt.prototype.removeEventListener = tt.prototype.off;
tt.prototype.dispatchEvent = tt.prototype.trigger;
const Fn = (i) => typeof i.name == "function" ? i.name() : typeof i.name == "string" ? i.name : i.name_ ? i.name_ : i.constructor && i.constructor.name ? i.constructor.name : typeof i, Rt = (i) => i instanceof tt || !!i.eventBusEl_ && ["on", "one", "off", "trigger"].every((e) => typeof i[e] == "function"), zy = (i, e) => {
  Rt(i) ? e() : (i.eventedCallbacks || (i.eventedCallbacks = []), i.eventedCallbacks.push(e));
}, Wa = (i) => (
  // The regex here verifies that the `type` contains at least one non-
  // whitespace character.
  typeof i == "string" && /\S/.test(i) || Array.isArray(i) && !!i.length
), sn = (i, e, t) => {
  if (!i || !i.nodeName && !Rt(i))
    throw new Error(`Invalid target for ${Fn(e)}#${t}; must be a DOM node or evented object.`);
}, gh = (i, e, t) => {
  if (!Wa(i))
    throw new Error(`Invalid event type for ${Fn(e)}#${t}; must be a non-empty string or array.`);
}, _h = (i, e, t) => {
  if (typeof i != "function")
    throw new Error(`Invalid listener for ${Fn(e)}#${t}; must be a function.`);
}, va = (i, e, t) => {
  const s = e.length < 3 || e[0] === i || e[0] === i.eventBusEl_;
  let r, n, a;
  return s ? (r = i.eventBusEl_, e.length >= 3 && e.shift(), [n, a] = e) : (r = e[0], n = e[1], a = e[2]), sn(r, i, t), gh(n, i, t), _h(a, i, t), a = le(i, a), {
    isTargetingSelf: s,
    target: r,
    type: n,
    listener: a
  };
}, oi = (i, e, t, s) => {
  sn(i, i, e), i.nodeName ? Hy[e](i, t, s) : i[e](t, s);
}, Gy = {
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  on(...i) {
    const {
      isTargetingSelf: e,
      target: t,
      type: s,
      listener: r
    } = va(this, i, "on");
    if (oi(t, "on", s, r), !e) {
      const n = () => this.off(t, s, r);
      n.guid = r.guid;
      const a = () => this.off("dispose", n);
      a.guid = r.guid, oi(this, "on", "dispose", n), oi(t, "on", "dispose", a);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will be called once per event and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  one(...i) {
    const {
      isTargetingSelf: e,
      target: t,
      type: s,
      listener: r
    } = va(this, i, "one");
    if (e)
      oi(t, "one", s, r);
    else {
      const n = (...a) => {
        this.off(t, s, n), r.apply(null, a);
      };
      n.guid = r.guid, oi(t, "one", s, n);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once for the first event that is triggered
   * then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  any(...i) {
    const {
      isTargetingSelf: e,
      target: t,
      type: s,
      listener: r
    } = va(this, i, "any");
    if (e)
      oi(t, "any", s, r);
    else {
      const n = (...a) => {
        this.off(t, s, n), r.apply(null, a);
      };
      n.guid = r.guid, oi(t, "any", s, n);
    }
  },
  /**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */
  off(i, e, t) {
    if (!i || Wa(i))
      Pe(this.eventBusEl_, i, e);
    else {
      const s = i, r = e;
      sn(s, this, "off"), gh(r, this, "off"), _h(t, this, "off"), t = le(this, t), this.off("dispose", t), s.nodeName ? (Pe(s, r, t), Pe(s, "dispose", t)) : Rt(s) && (s.off(r, t), s.off("dispose", t));
    }
  },
  /**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @return {boolean}
   *          Whether or not the default behavior was prevented.
   */
  trigger(i, e) {
    sn(this.eventBusEl_, this, "trigger");
    const t = i && typeof i != "string" ? i.type : i;
    if (!Wa(t))
      throw new Error(`Invalid event type for ${Fn(this)}#trigger; must be a non-empty string or object with a type key that has a non-empty value.`);
    return rs(this.eventBusEl_, i, e);
  }
};
function $o(i, e = {}) {
  const {
    eventBusKey: t
  } = e;
  if (t) {
    if (!i[t].nodeName)
      throw new Error(`The eventBusKey "${t}" does not refer to an element.`);
    i.eventBusEl_ = i[t];
  } else
    i.eventBusEl_ = W("span", {
      className: "vjs-event-bus"
    });
  return Object.assign(i, Gy), i.eventedCallbacks && i.eventedCallbacks.forEach((s) => {
    s();
  }), i.on("dispose", () => {
    i.off(), [i, i.el_, i.eventBusEl_].forEach(function(s) {
      s && qe.has(s) && qe.delete(s);
    }), S.setTimeout(() => {
      i.eventBusEl_ = null;
    }, 0);
  }), i;
}
const Wy = {
  /**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */
  state: {},
  /**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @return {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */
  setState(i) {
    typeof i == "function" && (i = i());
    let e;
    return Ni(i, (t, s) => {
      this.state[s] !== t && (e = e || {}, e[s] = {
        from: this.state[s],
        to: t
      }), this.state[s] = t;
    }), e && Rt(this) && this.trigger({
      changes: e,
      type: "statechanged"
    }), e;
  }
};
function yh(i, e) {
  return Object.assign(i, Wy), i.state = Object.assign({}, i.state, e), typeof i.handleStateChanged == "function" && Rt(i) && i.on("statechanged", i.handleStateChanged), i;
}
const Bs = function(i) {
  return typeof i != "string" ? i : i.replace(/./, (e) => e.toLowerCase());
}, _e = function(i) {
  return typeof i != "string" ? i : i.replace(/./, (e) => e.toUpperCase());
}, Th = function(i, e) {
  return _e(i) === _e(e);
};
var Xy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  toLowerCase: Bs,
  toTitleCase: _e,
  titleCaseEquals: Th
});
class M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of component options.
   *
   * @param {Object[]} [options.children]
   *        An array of children objects to initialize this component with. Children objects have
   *        a name property that will be used if more than one component of the same type needs to be
   *        added.
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   * @param {ReadyCallback} [ready]
   *        Function that gets called when the `Component` is ready.
   */
  constructor(e, t, s) {
    if (!e && this.play ? this.player_ = e = this : this.player_ = e, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = oe({}, this.options_), t = this.options_ = oe(this.options_, t), this.id_ = t.id || t.el && t.el.id, !this.id_) {
      const r = e && e.id && e.id() || "no_player";
      this.id_ = `${r}_component_${nt()}`;
    }
    this.name_ = t.name || null, t.el ? this.el_ = t.el : t.createEl !== !1 && (this.el_ = this.createEl()), t.className && this.el_ && t.className.split(" ").forEach((r) => this.addClass(r)), ["on", "off", "one", "any", "trigger"].forEach((r) => {
      this[r] = void 0;
    }), t.evented !== !1 && ($o(this, {
      eventBusKey: this.el_ ? "el_" : null
    }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), yh(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = /* @__PURE__ */ new Set(), this.setIntervalIds_ = /* @__PURE__ */ new Set(), this.rafIds_ = /* @__PURE__ */ new Set(), this.namedRafs_ = /* @__PURE__ */ new Map(), this.clearingTimersOnDispose_ = !1, t.initChildren !== !1 && this.initChildren(), this.ready(s), t.reportTouchActivity !== !1 && this.enableTouchActivity();
  }
  // `on`, `off`, `one`, `any` and `trigger` are here so tsc includes them in definitions.
  // They are replaced or removed in the constructor
  /**
   * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
   * function that will get called when an event with a certain name gets triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to call with `EventTarget`s
   */
  /**
   * Removes an `event listener` for a specific event from an instance of `EventTarget`.
   * This makes it so that the `event listener` will no longer get called when the
   * named event happens.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} [fn]
   *        The function to remove. If not specified, all listeners managed by Video.js will be removed.
   */
  /**
   * This function will add an `event listener` that gets triggered only once. After the
   * first trigger it will get removed. This is like adding an `event listener`
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  /**
   * This function will add an `event listener` that gets triggered only once and is
   * removed from all events. This is like adding an array of `event listener`s
   * with {@link EventTarget#on} that calls {@link EventTarget#off} on all events the
   * first time it is triggered.
   *
   * @param {string|string[]} type
   *        An event name or an array of event names.
   *
   * @param {Function} fn
   *        The function to be called once for each event name.
   */
  /**
   * This function causes an event to happen. This will then cause any `event listeners`
   * that are waiting for that event, to get called. If there are no `event listeners`
   * for an event then nothing will happen.
   *
   * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
   * Trigger will also call the `on` + `uppercaseEventName` function.
   *
   * Example:
   * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
   * `onClick` if it exists.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * @param {Object} [hash]
   *        Optionally extra argument to pass through to an event listener
   */
  /**
   * Dispose of the `Component` and all child components.
   *
   * @fires Component#dispose
   *
   * @param {Object} options
   * @param {Element} options.originalEl element with which to replace player element
   */
  dispose(e = {}) {
    if (!this.isDisposed_) {
      if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
        type: "dispose",
        bubbles: !1
      }), this.isDisposed_ = !0, this.children_)
        for (let t = this.children_.length - 1; t >= 0; t--)
          this.children_[t].dispose && this.children_[t].dispose();
      this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ && (this.el_.parentNode && (e.restoreEl ? this.el_.parentNode.replaceChild(e.restoreEl, this.el_) : this.el_.parentNode.removeChild(this.el_)), this.el_ = null), this.player_ = null;
    }
  }
  /**
   * Determine whether or not this component has been disposed.
   *
   * @return {boolean}
   *         If the component has been disposed, will be `true`. Otherwise, `false`.
   */
  isDisposed() {
    return !!this.isDisposed_;
  }
  /**
   * Return the {@link Player} that the `Component` has attached to.
   *
   * @return {Player}
   *         The player that this `Component` has attached to.
   */
  player() {
    return this.player_;
  }
  /**
   * Deep merge of options objects with new options.
   * > Note: When both `obj` and `options` contain properties whose values are objects.
   *         The two properties get merged using {@link module:obj.merge}
   *
   * @param {Object} obj
   *        The object that contains new options.
   *
   * @return {Object}
   *         A new object of `this.options_` and `obj` merged together.
   */
  options(e) {
    return e ? (this.options_ = oe(this.options_, e), this.options_) : this.options_;
  }
  /**
   * Get the `Component`s DOM element
   *
   * @return {Element}
   *         The DOM element for this `Component`.
   */
  el() {
    return this.el_;
  }
  /**
   * Create the `Component`s DOM element.
   *
   * @param {string} [tagName]
   *        Element's DOM node type. e.g. 'div'
   *
   * @param {Object} [properties]
   *        An object of properties that should be set.
   *
   * @param {Object} [attributes]
   *        An object of attributes that should be set.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, t, s) {
    return W(e, t, s);
  }
  /**
   * Localize a string given the string in english.
   *
   * If tokens are provided, it'll try and run a simple token replacement on the provided string.
   * The tokens it looks for look like `{1}` with the index being 1-indexed into the tokens array.
   *
   * If a `defaultValue` is provided, it'll use that over `string`,
   * if a value isn't found in provided language files.
   * This is useful if you want to have a descriptive key for token replacement
   * but have a succinct localized string and not require `en.json` to be included.
   *
   * Currently, it is used for the progress bar timing.
   * ```js
   * {
   *   "progress bar timing: currentTime={1} duration={2}": "{1} of {2}"
   * }
   * ```
   * It is then used like so:
   * ```js
   * this.localize('progress bar timing: currentTime={1} duration{2}',
   *               [this.player_.currentTime(), this.player_.duration()],
   *               '{1} of {2}');
   * ```
   *
   * Which outputs something like: `01:23 of 24:56`.
   *
   *
   * @param {string} string
   *        The string to localize and the key to lookup in the language files.
   * @param {string[]} [tokens]
   *        If the current item has token replacements, provide the tokens here.
   * @param {string} [defaultValue]
   *        Defaults to `string`. Can be a default value to use for token replacement
   *        if the lookup key is needed to be separate.
   *
   * @return {string}
   *         The localized string or if no localization exists the english string.
   */
  localize(e, t, s = e) {
    const r = this.player_.language && this.player_.language(), n = this.player_.languages && this.player_.languages(), a = n && n[r], o = r && r.split("-")[0], l = n && n[o];
    let h = s;
    return a && a[e] ? h = a[e] : l && l[e] && (h = l[e]), t && (h = h.replace(/\{(\d+)\}/g, function(m, _) {
      const v = t[_ - 1];
      let C = v;
      return typeof v > "u" && (C = m), C;
    })), h;
  }
  /**
   * Handles language change for the player in components. Should be overridden by sub-components.
   *
   * @abstract
   */
  handleLanguagechange() {
  }
  /**
   * Return the `Component`s DOM element. This is where children get inserted.
   * This will usually be the the same as the element returned in {@link Component#el}.
   *
   * @return {Element}
   *         The content element for this `Component`.
   */
  contentEl() {
    return this.contentEl_ || this.el_;
  }
  /**
   * Get this `Component`s ID
   *
   * @return {string}
   *         The id of this `Component`
   */
  id() {
    return this.id_;
  }
  /**
   * Get the `Component`s name. The name gets used to reference the `Component`
   * and is set during registration.
   *
   * @return {string}
   *         The name of this `Component`.
   */
  name() {
    return this.name_;
  }
  /**
   * Get an array of all child components
   *
   * @return {Array}
   *         The children
   */
  children() {
    return this.children_;
  }
  /**
   * Returns the child `Component` with the given `id`.
   *
   * @param {string} id
   *        The id of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `id` or undefined.
   */
  getChildById(e) {
    return this.childIndex_[e];
  }
  /**
   * Returns the child `Component` with the given `name`.
   *
   * @param {string} name
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The child `Component` with the given `name` or undefined.
   */
  getChild(e) {
    if (e)
      return this.childNameIndex_[e];
  }
  /**
   * Returns the descendant `Component` following the givent
   * descendant `names`. For instance ['foo', 'bar', 'baz'] would
   * try to get 'foo' on the current component, 'bar' on the 'foo'
   * component and 'baz' on the 'bar' component and return undefined
   * if any of those don't exist.
   *
   * @param {...string[]|...string} names
   *        The name of the child `Component` to get.
   *
   * @return {Component|undefined}
   *         The descendant `Component` following the given descendant
   *         `names` or undefined.
   */
  getDescendant(...e) {
    e = e.reduce((s, r) => s.concat(r), []);
    let t = this;
    for (let s = 0; s < e.length; s++)
      if (t = t.getChild(e[s]), !t || !t.getChild)
        return;
    return t;
  }
  /**
   * Adds an SVG icon element to another element or component.
   *
   * @param {string} iconName
   *        The name of icon. A list of all the icon names can be found at 'sandbox/svg-icons.html'
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on. Defaults to the current Component's element.
   *
   * @return {Element}
   *        The newly created icon element.
   */
  setIcon(e, t = this.el()) {
    if (!this.player_.options_.experimentalSvgIcons)
      return;
    const s = "http://www.w3.org/2000/svg", r = W("span", {
      className: "vjs-icon-placeholder vjs-svg-icon"
    }, {
      "aria-hidden": "true"
    }), n = U.createElementNS(s, "svg");
    n.setAttributeNS(null, "viewBox", "0 0 512 512");
    const a = U.createElementNS(s, "use");
    return n.appendChild(a), a.setAttributeNS(null, "href", `#vjs-icon-${e}`), r.appendChild(n), this.iconIsSet_ ? t.replaceChild(r, t.querySelector(".vjs-icon-placeholder")) : t.appendChild(r), this.iconIsSet_ = !0, r;
  }
  /**
   * Add a child `Component` inside the current `Component`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @param {number} [index=this.children_.length]
   *        The index to attempt to add a child into.
   *
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   */
  addChild(e, t = {}, s = this.children_.length) {
    let r, n;
    if (typeof e == "string") {
      n = _e(e);
      const a = t.componentClass || n;
      t.name = n;
      const o = M.getComponent(a);
      if (!o)
        throw new Error(`Component ${a} does not exist`);
      if (typeof o != "function")
        return null;
      r = new o(this.player_ || this, t);
    } else
      r = e;
    if (r.parentComponent_ && r.parentComponent_.removeChild(r), this.children_.splice(s, 0, r), r.parentComponent_ = this, typeof r.id == "function" && (this.childIndex_[r.id()] = r), n = n || r.name && _e(r.name()), n && (this.childNameIndex_[n] = r, this.childNameIndex_[Bs(n)] = r), typeof r.el == "function" && r.el()) {
      let a = null;
      this.children_[s + 1] && (this.children_[s + 1].el_ ? a = this.children_[s + 1].el_ : ss(this.children_[s + 1]) && (a = this.children_[s + 1])), this.contentEl().insertBefore(r.el(), a);
    }
    return r;
  }
  /**
   * Remove a child `Component` from this `Component`s list of children. Also removes
   * the child `Component`s element from this `Component`s element.
   *
   * @param {Component} component
   *        The child `Component` to remove.
   */
  removeChild(e) {
    if (typeof e == "string" && (e = this.getChild(e)), !e || !this.children_)
      return;
    let t = !1;
    for (let r = this.children_.length - 1; r >= 0; r--)
      if (this.children_[r] === e) {
        t = !0, this.children_.splice(r, 1);
        break;
      }
    if (!t)
      return;
    e.parentComponent_ = null, this.childIndex_[e.id()] = null, this.childNameIndex_[_e(e.name())] = null, this.childNameIndex_[Bs(e.name())] = null;
    const s = e.el();
    s && s.parentNode === this.contentEl() && this.contentEl().removeChild(e.el());
  }
  /**
   * Add and initialize default child `Component`s based upon options.
   */
  initChildren() {
    const e = this.options_.children;
    if (e) {
      const t = this.options_, s = (a) => {
        const o = a.name;
        let l = a.opts;
        if (t[o] !== void 0 && (l = t[o]), l === !1)
          return;
        l === !0 && (l = {}), l.playerOptions = this.options_.playerOptions;
        const h = this.addChild(o, l);
        h && (this[o] = h);
      };
      let r;
      const n = M.getComponent("Tech");
      Array.isArray(e) ? r = e : r = Object.keys(e), r.concat(Object.keys(this.options_).filter(function(a) {
        return !r.some(function(o) {
          return typeof o == "string" ? a === o : a === o.name;
        });
      })).map((a) => {
        let o, l;
        return typeof a == "string" ? (o = a, l = e[o] || this.options_[o] || {}) : (o = a.name, l = a), {
          name: o,
          opts: l
        };
      }).filter((a) => {
        const o = M.getComponent(a.opts.componentClass || _e(a.name));
        return o && !n.isTech(o);
      }).forEach(s);
    }
  }
  /**
   * Builds the default DOM class name. Should be overridden by sub-components.
   *
   * @return {string}
   *         The DOM class name for this object.
   *
   * @abstract
   */
  buildCSSClass() {
    return "";
  }
  /**
   * Bind a listener to the component's ready state.
   * Different from event listeners in that if the ready event has already happened
   * it will trigger the function immediately.
   *
   * @param {ReadyCallback} fn
   *        Function that gets called when the `Component` is ready.
   */
  ready(e, t = !1) {
    if (e) {
      if (!this.isReady_) {
        this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(e);
        return;
      }
      t ? e.call(this) : this.setTimeout(e, 1);
    }
  }
  /**
   * Trigger all the ready listeners for this `Component`.
   *
   * @fires Component#ready
   */
  triggerReady() {
    this.isReady_ = !0, this.setTimeout(function() {
      const e = this.readyQueue_;
      this.readyQueue_ = [], e && e.length > 0 && e.forEach(function(t) {
        t.call(this);
      }, this), this.trigger("ready");
    }, 1);
  }
  /**
   * Find a single DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelector`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {Element|null}
   *         the dom element that was found, or null
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */
  $(e, t) {
    return Kt(e, t || this.contentEl());
  }
  /**
   * Finds all DOM element matching a `selector`. This can be within the `Component`s
   * `contentEl()` or another custom context.
   *
   * @param {string} selector
   *        A valid CSS selector, which will be passed to `querySelectorAll`.
   *
   * @param {Element|string} [context=this.contentEl()]
   *        A DOM element within which to query. Can also be a selector string in
   *        which case the first matching element will get used as context. If
   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
   *        nothing it falls back to `document`.
   *
   * @return {NodeList}
   *         a list of dom elements that were found
   *
   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
   */
  $$(e, t) {
    return lh(e, t || this.contentEl());
  }
  /**
   * Check if a component's element has a CSS class name.
   *
   * @param {string} classToCheck
   *        CSS class name to check.
   *
   * @return {boolean}
   *         - True if the `Component` has the class.
   *         - False if the `Component` does not have the class`
   */
  hasClass(e) {
    return Ms(this.el_, e);
  }
  /**
   * Add a CSS class name to the `Component`s element.
   *
   * @param {...string} classesToAdd
   *        One or more CSS class name to add.
   */
  addClass(...e) {
    fi(this.el_, ...e);
  }
  /**
   * Remove a CSS class name from the `Component`s element.
   *
   * @param {...string} classesToRemove
   *        One or more CSS class name to remove.
   */
  removeClass(...e) {
    On(this.el_, ...e);
  }
  /**
   * Add or remove a CSS class name from the component's element.
   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
   *
   * @param  {string} classToToggle
   *         The class to add or remove. Passed to DOMTokenList's toggle()
   *
   * @param  {boolean|Dom.PredicateCallback} [predicate]
   *         A boolean or function that returns a boolean. Passed to DOMTokenList's toggle().
   */
  toggleClass(e, t) {
    th(this.el_, e, t);
  }
  /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */
  show() {
    this.removeClass("vjs-hidden");
  }
  /**
   * Hide the `Component`s element if it is currently showing by adding the
   * 'vjs-hidden` class name to it.
   */
  hide() {
    this.addClass("vjs-hidden");
  }
  /**
   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
   * class name to it. Used during fadeIn/fadeOut.
   *
   * @private
   */
  lockShowing() {
    this.addClass("vjs-lock-showing");
  }
  /**
   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
   * class name from it. Used during fadeIn/fadeOut.
   *
   * @private
   */
  unlockShowing() {
    this.removeClass("vjs-lock-showing");
  }
  /**
   * Get the value of an attribute on the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to get the value from.
   *
   * @return {string|null}
   *         - The value of the attribute that was asked for.
   *         - Can be an empty string on some browsers if the attribute does not exist
   *           or has no value
   *         - Most browsers will return null if the attribute does not exist or has
   *           no value.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
   */
  getAttribute(e) {
    return sh(this.el_, e);
  }
  /**
   * Set the value of an attribute on the `Component`'s element
   *
   * @param {string} attribute
   *        Name of the attribute to set.
   *
   * @param {string} value
   *        Value to set the attribute to.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
   */
  setAttribute(e, t) {
    Yi(this.el_, e, t);
  }
  /**
   * Remove an attribute from the `Component`s element.
   *
   * @param {string} attribute
   *        Name of the attribute to remove.
   *
   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
   */
  removeAttribute(e) {
    Ln(this.el_, e);
  }
  /**
   * Get or set the width of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The width that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The width when getting, zero if there is no width
   */
  width(e, t) {
    return this.dimension("width", e, t);
  }
  /**
   * Get or set the height of the component based upon the CSS styles.
   * See {@link Component#dimension} for more detailed information.
   *
   * @param {number|string} [num]
   *        The height that you want to set postfixed with '%', 'px' or nothing.
   *
   * @param {boolean} [skipListeners]
   *        Skip the componentresize event trigger
   *
   * @return {number|undefined}
   *         The height when getting, zero if there is no height
   */
  height(e, t) {
    return this.dimension("height", e, t);
  }
  /**
   * Set both the width and height of the `Component` element at the same time.
   *
   * @param  {number|string} width
   *         Width to set the `Component`s element to.
   *
   * @param  {number|string} height
   *         Height to set the `Component`s element to.
   */
  dimensions(e, t) {
    this.width(e, !0), this.height(t);
  }
  /**
   * Get or set width or height of the `Component` element. This is the shared code
   * for the {@link Component#width} and {@link Component#height}.
   *
   * Things to know:
   * - If the width or height in an number this will return the number postfixed with 'px'.
   * - If the width/height is a percent this will return the percent postfixed with '%'
   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
   *   for more information
   * - If you want the computed style of the component, use {@link Component#currentWidth}
   *   and {@link {Component#currentHeight}
   *
   * @fires Component#componentresize
   *
   * @param {string} widthOrHeight
   8        'width' or 'height'
   *
   * @param  {number|string} [num]
   8         New dimension
   *
   * @param  {boolean} [skipListeners]
   *         Skip componentresize event trigger
   *
   * @return {number|undefined}
   *         The dimension when getting or 0 if unset
   */
  dimension(e, t, s) {
    if (t !== void 0) {
      (t === null || t !== t) && (t = 0), ("" + t).indexOf("%") !== -1 || ("" + t).indexOf("px") !== -1 ? this.el_.style[e] = t : t === "auto" ? this.el_.style[e] = "" : this.el_.style[e] = t + "px", s || this.trigger("componentresize");
      return;
    }
    if (!this.el_)
      return 0;
    const r = this.el_.style[e], n = r.indexOf("px");
    return parseInt(n !== -1 ? r.slice(0, n) : this.el_["offset" + _e(e)], 10);
  }
  /**
   * Get the computed width or the height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @param {string} widthOrHeight
   *        A string containing 'width' or 'height'. Whichever one you want to get.
   *
   * @return {number}
   *         The dimension that gets asked for or 0 if nothing was set
   *         for that dimension.
   */
  currentDimension(e) {
    let t = 0;
    if (e !== "width" && e !== "height")
      throw new Error("currentDimension only accepts width or height value");
    if (t = Ji(this.el_, e), t = parseFloat(t), t === 0 || isNaN(t)) {
      const s = `offset${_e(e)}`;
      t = this.el_[s];
    }
    return t;
  }
  /**
   * An object that contains width and height values of the `Component`s
   * computed style. Uses `window.getComputedStyle`.
   *
   * @typedef {Object} Component~DimensionObject
   *
   * @property {number} width
   *           The width of the `Component`s computed style.
   *
   * @property {number} height
   *           The height of the `Component`s computed style.
   */
  /**
   * Get an object that contains computed width and height values of the
   * component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {Component~DimensionObject}
   *         The computed dimensions of the component's element.
   */
  currentDimensions() {
    return {
      width: this.currentDimension("width"),
      height: this.currentDimension("height")
    };
  }
  /**
   * Get the computed width of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed width of the component's element.
   */
  currentWidth() {
    return this.currentDimension("width");
  }
  /**
   * Get the computed height of the component's element.
   *
   * Uses `window.getComputedStyle`.
   *
   * @return {number}
   *         The computed height of the component's element.
   */
  currentHeight() {
    return this.currentDimension("height");
  }
  /**
   * Retrieves the position and size information of the component's element.
   *
   * @return {Object} An object with `boundingClientRect` and `center` properties.
   *         - `boundingClientRect`: An object with properties `x`, `y`, `width`,
   *           `height`, `top`, `right`, `bottom`, and `left`, representing
   *           the bounding rectangle of the element.
   *         - `center`: An object with properties `x` and `y`, representing
   *           the center point of the element. `width` and `height` are set to 0.
   */
  getPositions() {
    const e = this.el_.getBoundingClientRect(), t = {
      x: e.x,
      y: e.y,
      width: e.width,
      height: e.height,
      top: e.top,
      right: e.right,
      bottom: e.bottom,
      left: e.left
    }, s = {
      x: e.left + e.width / 2,
      y: e.top + e.height / 2,
      width: 0,
      height: 0,
      top: e.top + e.height / 2,
      right: e.left + e.width / 2,
      bottom: e.top + e.height / 2,
      left: e.left + e.width / 2
    };
    return {
      boundingClientRect: t,
      center: s
    };
  }
  /**
   * Set the focus to this component
   */
  focus() {
    this.el_.focus();
  }
  /**
   * Remove the focus from this component
   */
  blur() {
    this.el_.blur();
  }
  /**
   * When this Component receives a `keydown` event which it does not process,
   *  it passes the event to the Player for handling.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   */
  handleKeyDown(e) {
    this.player_ && (e.key !== "Tab" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled) && e.stopPropagation(), this.player_.handleKeyDown(e));
  }
  /**
   * Many components used to have a `handleKeyPress` method, which was poorly
   * named because it listened to a `keydown` event. This method name now
   * delegates to `handleKeyDown`. This means anyone calling `handleKeyPress`
   * will not see their method calls stop working.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to be called.
   */
  handleKeyPress(e) {
    this.handleKeyDown(e);
  }
  /**
   * Emit a 'tap' events when touch event support gets detected. This gets used to
   * support toggling the controls through a tap on the video. They get enabled
   * because every sub-component would have extra overhead otherwise.
   *
   * @protected
   * @fires Component#tap
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchleave
   * @listens Component#touchcancel
   * @listens Component#touchend
    */
  emitTapEvents() {
    let e = 0, t = null;
    const s = 10, r = 200;
    let n;
    this.on("touchstart", function(o) {
      o.touches.length === 1 && (t = {
        pageX: o.touches[0].pageX,
        pageY: o.touches[0].pageY
      }, e = S.performance.now(), n = !0);
    }), this.on("touchmove", function(o) {
      if (o.touches.length > 1)
        n = !1;
      else if (t) {
        const l = o.touches[0].pageX - t.pageX, h = o.touches[0].pageY - t.pageY;
        Math.sqrt(l * l + h * h) > s && (n = !1);
      }
    });
    const a = function() {
      n = !1;
    };
    this.on("touchleave", a), this.on("touchcancel", a), this.on("touchend", function(o) {
      t = null, n === !0 && S.performance.now() - e < r && (o.preventDefault(), this.trigger("tap"));
    });
  }
  /**
   * This function reports user activity whenever touch events happen. This can get
   * turned off by any sub-components that wants touch events to act another way.
   *
   * Report user touch activity when touch events occur. User activity gets used to
   * determine when controls should show/hide. It is simple when it comes to mouse
   * events, because any mouse event should show the controls. So we capture mouse
   * events that bubble up to the player and report activity when that happens.
   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
   * controls. So touch events can't help us at the player level either.
   *
   * User activity gets checked asynchronously. So what could happen is a tap event
   * on the video turns the controls off. Then the `touchend` event bubbles up to
   * the player. Which, if it reported user activity, would turn the controls right
   * back on. We also don't want to completely block touch events from bubbling up.
   * Furthermore a `touchmove` event and anything other than a tap, should not turn
   * controls back on.
   *
   * @listens Component#touchstart
   * @listens Component#touchmove
   * @listens Component#touchend
   * @listens Component#touchcancel
   */
  enableTouchActivity() {
    if (!this.player() || !this.player().reportUserActivity)
      return;
    const e = le(this.player(), this.player().reportUserActivity);
    let t;
    this.on("touchstart", function() {
      e(), this.clearInterval(t), t = this.setInterval(e, 250);
    });
    const s = function(r) {
      e(), this.clearInterval(t);
    };
    this.on("touchmove", e), this.on("touchend", s), this.on("touchcancel", s);
  }
  /**
   * A callback that has no parameters and is bound into `Component`s context.
   *
   * @callback Component~GenericCallback
   * @this Component
   */
  /**
   * Creates a function that runs after an `x` millisecond timeout. This function is a
   * wrapper around `window.setTimeout`. There are a few reasons to use this one
   * instead though:
   * 1. It gets cleared via  {@link Component#clearTimeout} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
   *
   * > Note: You can't use `window.clearTimeout` on the id returned by this function. This
   *         will cause its dispose listener not to get cleaned up! Please use
   *         {@link Component#clearTimeout} or {@link Component#dispose} instead.
   *
   * @param {Component~GenericCallback} fn
   *        The function that will be run after `timeout`.
   *
   * @param {number} timeout
   *        Timeout in milliseconds to delay before executing the specified function.
   *
   * @return {number}
   *         Returns a timeout ID that gets used to identify the timeout. It can also
   *         get used in {@link Component#clearTimeout} to clear the timeout that
   *         was set.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
   */
  setTimeout(e, t) {
    var s;
    return e = le(this, e), this.clearTimersOnDispose_(), s = S.setTimeout(() => {
      this.setTimeoutIds_.has(s) && this.setTimeoutIds_.delete(s), e();
    }, t), this.setTimeoutIds_.add(s), s;
  }
  /**
   * Clears a timeout that gets created via `window.setTimeout` or
   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
   * use this function instead of `window.clearTimout`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} timeoutId
   *        The id of the timeout to clear. The return value of
   *        {@link Component#setTimeout} or `window.setTimeout`.
   *
   * @return {number}
   *         Returns the timeout id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
   */
  clearTimeout(e) {
    return this.setTimeoutIds_.has(e) && (this.setTimeoutIds_.delete(e), S.clearTimeout(e)), e;
  }
  /**
   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
   * around `window.setInterval`. There are a few reasons to use this one instead though.
   * 1. It gets cleared via  {@link Component#clearInterval} when
   *    {@link Component#dispose} gets called.
   * 2. The function callback will be a {@link Component~GenericCallback}
   *
   * @param {Component~GenericCallback} fn
   *        The function to run every `x` seconds.
   *
   * @param {number} interval
   *        Execute the specified function every `x` milliseconds.
   *
   * @return {number}
   *         Returns an id that can be used to identify the interval. It can also be be used in
   *         {@link Component#clearInterval} to clear the interval.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
   */
  setInterval(e, t) {
    e = le(this, e), this.clearTimersOnDispose_();
    const s = S.setInterval(e, t);
    return this.setIntervalIds_.add(s), s;
  }
  /**
   * Clears an interval that gets created via `window.setInterval` or
   * {@link Component#setInterval}. If you set an interval via {@link Component#setInterval}
   * use this function instead of `window.clearInterval`. If you don't your dispose
   * listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} intervalId
   *        The id of the interval to clear. The return value of
   *        {@link Component#setInterval} or `window.setInterval`.
   *
   * @return {number}
   *         Returns the interval id that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
   */
  clearInterval(e) {
    return this.setIntervalIds_.has(e) && (this.setIntervalIds_.delete(e), S.clearInterval(e)), e;
  }
  /**
   * Queues up a callback to be passed to requestAnimationFrame (rAF), but
   * with a few extra bonuses:
   *
   * - Supports browsers that do not support rAF by falling back to
   *   {@link Component#setTimeout}.
   *
   * - The callback is turned into a {@link Component~GenericCallback} (i.e.
   *   bound to the component).
   *
   * - Automatic cancellation of the rAF callback is handled if the component
   *   is disposed before it is called.
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   *
   * @return {number}
   *         Returns an rAF ID that gets used to identify the timeout. It can
   *         also be used in {@link Component#cancelAnimationFrame} to cancel
   *         the animation frame callback.
   *
   * @listens Component#dispose
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/requestAnimationFrame}
   */
  requestAnimationFrame(e) {
    this.clearTimersOnDispose_();
    var t;
    return e = le(this, e), t = S.requestAnimationFrame(() => {
      this.rafIds_.has(t) && this.rafIds_.delete(t), e();
    }), this.rafIds_.add(t), t;
  }
  /**
   * Request an animation frame, but only one named animation
   * frame will be queued. Another will never be added until
   * the previous one finishes.
   *
   * @param {string} name
   *        The name to give this requestAnimationFrame
   *
   * @param  {Component~GenericCallback} fn
   *         A function that will be bound to this component and executed just
   *         before the browser's next repaint.
   */
  requestNamedAnimationFrame(e, t) {
    this.namedRafs_.has(e) && this.cancelNamedAnimationFrame(e), this.clearTimersOnDispose_(), t = le(this, t);
    const s = this.requestAnimationFrame(() => {
      t(), this.namedRafs_.has(e) && this.namedRafs_.delete(e);
    });
    return this.namedRafs_.set(e, s), e;
  }
  /**
   * Cancels a current named animation frame if it exists.
   *
   * @param {string} name
   *        The name of the requestAnimationFrame to cancel.
   */
  cancelNamedAnimationFrame(e) {
    this.namedRafs_.has(e) && (this.cancelAnimationFrame(this.namedRafs_.get(e)), this.namedRafs_.delete(e));
  }
  /**
   * Cancels a queued callback passed to {@link Component#requestAnimationFrame}
   * (rAF).
   *
   * If you queue an rAF callback via {@link Component#requestAnimationFrame},
   * use this function instead of `window.cancelAnimationFrame`. If you don't,
   * your dispose listener will not get cleaned up until {@link Component#dispose}!
   *
   * @param {number} id
   *        The rAF ID to clear. The return value of {@link Component#requestAnimationFrame}.
   *
   * @return {number}
   *         Returns the rAF ID that was cleared.
   *
   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/window/cancelAnimationFrame}
   */
  cancelAnimationFrame(e) {
    return this.rafIds_.has(e) && (this.rafIds_.delete(e), S.cancelAnimationFrame(e)), e;
  }
  /**
   * A function to setup `requestAnimationFrame`, `setTimeout`,
   * and `setInterval`, clearing on dispose.
   *
   * > Previously each timer added and removed dispose listeners on it's own.
   * For better performance it was decided to batch them all, and use `Set`s
   * to track outstanding timer ids.
   *
   * @private
   */
  clearTimersOnDispose_() {
    this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", () => {
      [["namedRafs_", "cancelNamedAnimationFrame"], ["rafIds_", "cancelAnimationFrame"], ["setTimeoutIds_", "clearTimeout"], ["setIntervalIds_", "clearInterval"]].forEach(([e, t]) => {
        this[e].forEach((s, r) => this[t](r));
      }), this.clearingTimersOnDispose_ = !1;
    }));
  }
  /**
    * Decide whether an element is actually disabled or not.
    *
    * @function isActuallyDisabled
    * @param element {Node}
    * @return {boolean}
    *
    * @see {@link https://html.spec.whatwg.org/multipage/semantics-other.html#concept-element-disabled}
    */
  getIsDisabled() {
    return !!this.el_.disabled;
  }
  /**
    * Decide whether the element is expressly inert or not.
    *
    * @see {@link https://html.spec.whatwg.org/multipage/interaction.html#expressly-inert}
    * @function isExpresslyInert
    * @param element {Node}
    * @return {boolean}
    */
  getIsExpresslyInert() {
    return this.el_.inert && !this.el_.ownerDocument.documentElement.inert;
  }
  /**
   * Determine whether or not this component can be considered as focusable component.
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can be focused, will be `true`. Otherwise, `false`.
   */
  getIsFocusable(e) {
    return (e || this.el_).tabIndex >= 0 && !(this.getIsDisabled() || this.getIsExpresslyInert());
  }
  /**
   * Determine whether or not this component is currently visible/enabled/etc...
   *
   * @param {HTMLElement} el - The HTML element representing the component.
   * @return {boolean}
   *         If the component can is currently visible & enabled, will be `true`. Otherwise, `false`.
   */
  getIsAvailableToBeFocused(e) {
    function t(n) {
      const a = S.getComputedStyle(n, null), o = a.getPropertyValue("visibility");
      return a.getPropertyValue("display") !== "none" && !["hidden", "collapse"].includes(o);
    }
    function s(n) {
      return !(!t(n.parentElement) || !t(n) || n.style.opacity === "0" || S.getComputedStyle(n).height === "0px" || S.getComputedStyle(n).width === "0px");
    }
    function r(n) {
      if (n.offsetWidth + n.offsetHeight + n.getBoundingClientRect().height + n.getBoundingClientRect().width === 0)
        return !1;
      const a = {
        x: n.getBoundingClientRect().left + n.offsetWidth / 2,
        y: n.getBoundingClientRect().top + n.offsetHeight / 2
      };
      if (a.x < 0 || a.x > (U.documentElement.clientWidth || S.innerWidth) || a.y < 0 || a.y > (U.documentElement.clientHeight || S.innerHeight))
        return !1;
      let o = U.elementFromPoint(a.x, a.y);
      for (; o; ) {
        if (o === n)
          return !0;
        if (o.parentNode)
          o = o.parentNode;
        else
          return !1;
      }
    }
    return e || (e = this.el()), !!(r(e) && s(e) && (!e.parentElement || e.tabIndex >= 0));
  }
  /**
   * Register a `Component` with `videojs` given the name and the component.
   *
   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
   *         should be registered using {@link Tech.registerTech} or
   *         {@link videojs:videojs.registerTech}.
   *
   * > NOTE: This function can also be seen on videojs as
   *         {@link videojs:videojs.registerComponent}.
   *
   * @param {string} name
   *        The name of the `Component` to register.
   *
   * @param {Component} ComponentToRegister
   *        The `Component` class to register.
   *
   * @return {Component}
   *         The `Component` that was registered.
   */
  static registerComponent(e, t) {
    if (typeof e != "string" || !e)
      throw new Error(`Illegal component name, "${e}"; must be a non-empty string.`);
    const s = M.getComponent("Tech"), r = s && s.isTech(t), n = M === t || M.prototype.isPrototypeOf(t.prototype);
    if (r || !n) {
      let o;
      throw r ? o = "techs must be registered using Tech.registerTech()" : o = "must be a Component subclass", new Error(`Illegal component, "${e}"; ${o}.`);
    }
    e = _e(e), M.components_ || (M.components_ = {});
    const a = M.getComponent("Player");
    if (e === "Player" && a && a.players) {
      const o = a.players, l = Object.keys(o);
      if (o && l.length > 0 && l.map((h) => o[h]).every(Boolean))
        throw new Error("Can not register Player component after player has been created.");
    }
    return M.components_[e] = t, M.components_[Bs(e)] = t, t;
  }
  /**
   * Get a `Component` based on the name it was registered with.
   *
   * @param {string} name
   *        The Name of the component to get.
   *
   * @return {typeof Component}
   *         The `Component` that got registered under the given name.
   */
  static getComponent(e) {
    if (!(!e || !M.components_))
      return M.components_[e];
  }
}
M.registerComponent("Component", M);
function Ky(i, e, t) {
  if (typeof e != "number" || e < 0 || e > t)
    throw new Error(`Failed to execute '${i}' on 'TimeRanges': The index provided (${e}) is non-numeric or out of bounds (0-${t}).`);
}
function Kl(i, e, t, s) {
  return Ky(i, s, t.length - 1), t[s][e];
}
function ba(i) {
  let e;
  return i === void 0 || i.length === 0 ? e = {
    length: 0,
    start() {
      throw new Error("This TimeRanges object is empty");
    },
    end() {
      throw new Error("This TimeRanges object is empty");
    }
  } : e = {
    length: i.length,
    start: Kl.bind(null, "start", 0, i),
    end: Kl.bind(null, "end", 1, i)
  }, S.Symbol && S.Symbol.iterator && (e[S.Symbol.iterator] = () => (i || []).values()), e;
}
function dt(i, e) {
  return Array.isArray(i) ? ba(i) : i === void 0 || e === void 0 ? ba() : ba([[i, e]]);
}
const vh = function(i, e) {
  i = i < 0 ? 0 : i;
  let t = Math.floor(i % 60), s = Math.floor(i / 60 % 60), r = Math.floor(i / 3600);
  const n = Math.floor(e / 60 % 60), a = Math.floor(e / 3600);
  return (isNaN(i) || i === 1 / 0) && (r = s = t = "-"), r = r > 0 || a > 0 ? r + ":" : "", s = ((r || n >= 10) && s < 10 ? "0" + s : s) + ":", t = t < 10 ? "0" + t : t, r + s + t;
};
let qo = vh;
function bh(i) {
  qo = i;
}
function xh() {
  qo = vh;
}
function yi(i, e = i) {
  return qo(i, e);
}
var Yy = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTimeRanges: dt,
  createTimeRange: dt,
  setFormatTime: bh,
  resetFormatTime: xh,
  formatTime: yi
});
function Sh(i, e) {
  let t = 0, s, r;
  if (!e)
    return 0;
  (!i || !i.length) && (i = dt(0, 0));
  for (let n = 0; n < i.length; n++)
    s = i.start(n), r = i.end(n), r > e && (r = e), t += r - s;
  return t / e;
}
function ge(i) {
  if (i instanceof ge)
    return i;
  typeof i == "number" ? this.code = i : typeof i == "string" ? this.message = i : St(i) && (typeof i.code == "number" && (this.code = i.code), Object.assign(this, i)), this.message || (this.message = ge.defaultMessages[this.code] || "");
}
ge.prototype.code = 0;
ge.prototype.message = "";
ge.prototype.status = null;
ge.prototype.metadata = null;
ge.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"];
ge.defaultMessages = {
  1: "You aborted the media playback",
  2: "A network error caused the media download to fail part-way.",
  3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
  4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
  5: "The media is encrypted and we do not have the keys to decrypt it."
};
ge.MEDIA_ERR_CUSTOM = 0;
ge.prototype.MEDIA_ERR_CUSTOM = 0;
ge.MEDIA_ERR_ABORTED = 1;
ge.prototype.MEDIA_ERR_ABORTED = 1;
ge.MEDIA_ERR_NETWORK = 2;
ge.prototype.MEDIA_ERR_NETWORK = 2;
ge.MEDIA_ERR_DECODE = 3;
ge.prototype.MEDIA_ERR_DECODE = 3;
ge.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
ge.prototype.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
ge.MEDIA_ERR_ENCRYPTED = 5;
ge.prototype.MEDIA_ERR_ENCRYPTED = 5;
function Fs(i) {
  return i != null && typeof i.then == "function";
}
function _t(i) {
  Fs(i) && i.then(null, (e) => {
  });
}
const Xa = function(i) {
  return ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce((t, s, r) => (i[s] && (t[s] = i[s]), t), {
    cues: i.cues && Array.prototype.map.call(i.cues, function(t) {
      return {
        startTime: t.startTime,
        endTime: t.endTime,
        text: t.text,
        id: t.id
      };
    })
  });
}, Qy = function(i) {
  const e = i.$$("track"), t = Array.prototype.map.call(e, (r) => r.track);
  return Array.prototype.map.call(e, function(r) {
    const n = Xa(r.track);
    return r.src && (n.src = r.src), n;
  }).concat(Array.prototype.filter.call(i.textTracks(), function(r) {
    return t.indexOf(r) === -1;
  }).map(Xa));
}, Jy = function(i, e) {
  return i.forEach(function(t) {
    const s = e.addRemoteTextTrack(t).track;
    !t.src && t.cues && t.cues.forEach((r) => s.addCue(r));
  }), e.textTracks();
};
var Yl = {
  textTracksToJson: Qy,
  jsonToTextTracks: Jy,
  trackToJson_: Xa
};
const xa = "vjs-modal-dialog";
class ns extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.description]
   *        A text description for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.fillAlways=false]
   *        Normally, modals are automatically filled only the first time
   *        they open. This tells the modal to refresh its content
   *        every time it opens.
   *
   * @param {string} [options.label]
   *        A text label for the modal, primarily for accessibility.
   *
   * @param {boolean} [options.pauseOnOpen=true]
   *        If `true`, playback will will be paused if playing when
   *        the modal opens, and resumed when it closes.
   *
   * @param {boolean} [options.temporary=true]
   *        If `true`, the modal can only be opened once; it will be
   *        disposed as soon as it's closed.
   *
   * @param {boolean} [options.uncloseable=false]
   *        If `true`, the user will not be able to close the modal
   *        through the UI in the normal ways. Programmatic closing is
   *        still possible.
   */
  constructor(e, t) {
    super(e, t), this.handleKeyDown_ = (s) => this.handleKeyDown(s), this.close_ = (s) => this.close(s), this.opened_ = this.hasBeenOpened_ = this.hasBeenFilled_ = !1, this.closeable(!this.options_.uncloseable), this.content(this.options_.content), this.contentEl_ = W("div", {
      className: `${xa}-content`
    }, {
      role: "document"
    }), this.descEl_ = W("p", {
      className: `${xa}-description vjs-control-text`,
      id: this.el().getAttribute("aria-describedby")
    }), Qt(this.descEl_, this.description()), this.el_.appendChild(this.descEl_), this.el_.appendChild(this.contentEl_);
  }
  /**
   * Create the `ModalDialog`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      "aria-describedby": `${this.id()}_description`,
      "aria-hidden": "true",
      "aria-label": this.label(),
      role: "dialog",
      "aria-live": "polite"
    });
  }
  dispose() {
    this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, super.dispose();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `${xa} vjs-hidden ${super.buildCSSClass()}`;
  }
  /**
   * Returns the label string for this modal. Primarily used for accessibility.
   *
   * @return {string}
   *         the localized or raw label of this modal.
   */
  label() {
    return this.localize(this.options_.label || "Modal Window");
  }
  /**
   * Returns the description string for this modal. Primarily used for
   * accessibility.
   *
   * @return {string}
   *         The localized or raw description of this modal.
   */
  description() {
    let e = this.options_.description || this.localize("This is a modal window.");
    return this.closeable() && (e += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), e;
  }
  /**
   * Opens the modal.
   *
   * @fires ModalDialog#beforemodalopen
   * @fires ModalDialog#modalopen
   */
  open() {
    if (this.opened_) {
      this.options_.fillAlways && this.fill();
      return;
    }
    const e = this.player();
    this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !e.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && e.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = e.controls(), e.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
  }
  /**
   * If the `ModalDialog` is currently open or closed.
   *
   * @param  {boolean} [value]
   *         If given, it will open (`true`) or close (`false`) the modal.
   *
   * @return {boolean}
   *         the current open state of the modaldialog
   */
  opened(e) {
    return typeof e == "boolean" && this[e ? "open" : "close"](), this.opened_;
  }
  /**
   * Closes the modal, does nothing if the `ModalDialog` is
   * not open.
   *
   * @fires ModalDialog#beforemodalclose
   * @fires ModalDialog#modalclose
   */
  close() {
    if (!this.opened_)
      return;
    const e = this.player();
    this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && e.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && e.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger({
      type: "modalclose",
      bubbles: !0
    }), this.conditionalBlur_(), this.options_.temporary && this.dispose();
  }
  /**
   * Check to see if the `ModalDialog` is closeable via the UI.
   *
   * @param  {boolean} [value]
   *         If given as a boolean, it will set the `closeable` option.
   *
   * @return {boolean}
   *         Returns the final value of the closable option.
   */
  closeable(e) {
    if (typeof e == "boolean") {
      const t = this.closeable_ = !!e;
      let s = this.getChild("closeButton");
      if (t && !s) {
        const r = this.contentEl_;
        this.contentEl_ = this.el_, s = this.addChild("closeButton", {
          controlText: "Close Modal Dialog"
        }), this.contentEl_ = r, this.on(s, "close", this.close_);
      }
      !t && s && (this.off(s, "close", this.close_), this.removeChild(s), s.dispose());
    }
    return this.closeable_;
  }
  /**
   * Fill the modal's content element with the modal's "content" option.
   * The content element will be emptied before this change takes place.
   */
  fill() {
    this.fillWith(this.content());
  }
  /**
   * Fill the modal's content element with arbitrary content.
   * The content element will be emptied before this change takes place.
   *
   * @fires ModalDialog#beforemodalfill
   * @fires ModalDialog#modalfill
   *
   * @param {ContentDescriptor} [content]
   *        The same rules apply to this as apply to the `content` option.
   */
  fillWith(e) {
    const t = this.contentEl(), s = t.parentNode, r = t.nextSibling;
    this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, s.removeChild(t), this.empty(), uh(t, e), this.trigger("modalfill"), r ? s.insertBefore(t, r) : s.appendChild(t);
    const n = this.getChild("closeButton");
    n && s.appendChild(n.el_), this.trigger("aftermodalfill");
  }
  /**
   * Empties the content element. This happens anytime the modal is filled.
   *
   * @fires ModalDialog#beforemodalempty
   * @fires ModalDialog#modalempty
   */
  empty() {
    this.trigger("beforemodalempty"), Nn(this.contentEl()), this.trigger("modalempty");
  }
  /**
   * Gets or sets the modal content, which gets normalized before being
   * rendered into the DOM.
   *
   * This does not update the DOM or fill the modal, but it is called during
   * that process.
   *
   * @param  {ContentDescriptor} [value]
   *         If defined, sets the internal content value to be used on the
   *         next call(s) to `fill`. This value is normalized before being
   *         inserted. To "clear" the internal content value, pass `null`.
   *
   * @return {ContentDescriptor}
   *         The current content of the modal dialog
   */
  content(e) {
    return typeof e < "u" && (this.content_ = e), this.content_;
  }
  /**
   * conditionally focus the modal dialog if focus was previously on the player.
   *
   * @private
   */
  conditionalFocus_() {
    const e = U.activeElement, t = this.player_.el_;
    this.previouslyActiveEl_ = null, (t.contains(e) || t === e) && (this.previouslyActiveEl_ = e, this.focus());
  }
  /**
   * conditionally blur the element and refocus the last focused element
   *
   * @private
   */
  conditionalBlur_() {
    this.previouslyActiveEl_ && (this.previouslyActiveEl_.focus(), this.previouslyActiveEl_ = null);
  }
  /**
   * Keydown handler. Attached when modal is focused.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    if (this.trigger({
      type: "modalKeydown",
      originalEvent: e,
      target: this,
      bubbles: !0
    }), e.stopPropagation(), e.key === "Escape" && this.closeable()) {
      e.preventDefault(), this.close();
      return;
    }
    if (e.key !== "Tab")
      return;
    const t = this.focusableEls_(), s = this.el_.querySelector(":focus");
    let r;
    for (let n = 0; n < t.length; n++)
      if (s === t[n]) {
        r = n;
        break;
      }
    U.activeElement === this.el_ && (r = 0), e.shiftKey && r === 0 ? (t[t.length - 1].focus(), e.preventDefault()) : !e.shiftKey && r === t.length - 1 && (t[0].focus(), e.preventDefault());
  }
  /**
   * get all focusable elements
   *
   * @private
   */
  focusableEls_() {
    const e = this.el_.querySelectorAll("*");
    return Array.prototype.filter.call(e, (t) => (t instanceof S.HTMLAnchorElement || t instanceof S.HTMLAreaElement) && t.hasAttribute("href") || (t instanceof S.HTMLInputElement || t instanceof S.HTMLSelectElement || t instanceof S.HTMLTextAreaElement || t instanceof S.HTMLButtonElement) && !t.hasAttribute("disabled") || t instanceof S.HTMLIFrameElement || t instanceof S.HTMLObjectElement || t instanceof S.HTMLEmbedElement || t.hasAttribute("tabindex") && t.getAttribute("tabindex") !== -1 || t.hasAttribute("contenteditable"));
  }
}
ns.prototype.options_ = {
  pauseOnOpen: !0,
  temporary: !0
};
M.registerComponent("ModalDialog", ns);
class Zi extends tt {
  /**
   * Create an instance of this class
   *
   * @param { Track[] } tracks
   *        A list of tracks to initialize the list with.
   *
   * @abstract
   */
  constructor(e = []) {
    super(), this.tracks_ = [], Object.defineProperty(this, "length", {
      get() {
        return this.tracks_.length;
      }
    });
    for (let t = 0; t < e.length; t++)
      this.addTrack(e[t]);
  }
  /**
   * Add a {@link Track} to the `TrackList`
   *
   * @param {Track} track
   *        The audio, video, or text track to add to the list.
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    const t = this.tracks_.length;
    "" + t in this || Object.defineProperty(this, t, {
      get() {
        return this.tracks_[t];
      }
    }), this.tracks_.indexOf(e) === -1 && (this.tracks_.push(e), this.trigger({
      track: e,
      type: "addtrack",
      target: this
    })), e.labelchange_ = () => {
      this.trigger({
        track: e,
        type: "labelchange",
        target: this
      });
    }, Rt(e) && e.addEventListener("labelchange", e.labelchange_);
  }
  /**
   * Remove a {@link Track} from the `TrackList`
   *
   * @param {Track} rtrack
   *        The audio, video, or text track to remove from the list.
   *
   * @fires TrackList#removetrack
   */
  removeTrack(e) {
    let t;
    for (let s = 0, r = this.length; s < r; s++)
      if (this[s] === e) {
        t = this[s], t.off && t.off(), this.tracks_.splice(s, 1);
        break;
      }
    t && this.trigger({
      track: t,
      type: "removetrack",
      target: this
    });
  }
  /**
   * Get a Track from the TrackList by a tracks id
   *
   * @param {string} id - the id of the track to get
   * @method getTrackById
   * @return {Track}
   * @private
   */
  getTrackById(e) {
    let t = null;
    for (let s = 0, r = this.length; s < r; s++) {
      const n = this[s];
      if (n.id === e) {
        t = n;
        break;
      }
    }
    return t;
  }
}
Zi.prototype.allowedEvents_ = {
  change: "change",
  addtrack: "addtrack",
  removetrack: "removetrack",
  labelchange: "labelchange"
};
for (const i in Zi.prototype.allowedEvents_)
  Zi.prototype["on" + i] = null;
const Sa = function(i, e) {
  for (let t = 0; t < i.length; t++)
    !Object.keys(i[t]).length || e.id === i[t].id || (i[t].enabled = !1);
};
class Zy extends Zi {
  /**
   * Create an instance of this class.
   *
   * @param {AudioTrack[]} [tracks=[]]
   *        A list of `AudioTrack` to instantiate the list with.
   */
  constructor(e = []) {
    for (let t = e.length - 1; t >= 0; t--)
      if (e[t].enabled) {
        Sa(e, e[t]);
        break;
      }
    super(e), this.changing_ = !1;
  }
  /**
   * Add an {@link AudioTrack} to the `AudioTrackList`.
   *
   * @param {AudioTrack} track
   *        The AudioTrack to add to the list
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    e.enabled && Sa(this, e), super.addTrack(e), e.addEventListener && (e.enabledChange_ = () => {
      this.changing_ || (this.changing_ = !0, Sa(this, e), this.changing_ = !1, this.trigger("change"));
    }, e.addEventListener("enabledchange", e.enabledChange_));
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && e.enabledChange_ && (e.removeEventListener("enabledchange", e.enabledChange_), e.enabledChange_ = null);
  }
}
const Ea = function(i, e) {
  for (let t = 0; t < i.length; t++)
    !Object.keys(i[t]).length || e.id === i[t].id || (i[t].selected = !1);
};
class eT extends Zi {
  /**
   * Create an instance of this class.
   *
   * @param {VideoTrack[]} [tracks=[]]
   *        A list of `VideoTrack` to instantiate the list with.
   */
  constructor(e = []) {
    for (let t = e.length - 1; t >= 0; t--)
      if (e[t].selected) {
        Ea(e, e[t]);
        break;
      }
    super(e), this.changing_ = !1, Object.defineProperty(this, "selectedIndex", {
      get() {
        for (let t = 0; t < this.length; t++)
          if (this[t].selected)
            return t;
        return -1;
      },
      set() {
      }
    });
  }
  /**
   * Add a {@link VideoTrack} to the `VideoTrackList`.
   *
   * @param {VideoTrack} track
   *        The VideoTrack to add to the list
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    e.selected && Ea(this, e), super.addTrack(e), e.addEventListener && (e.selectedChange_ = () => {
      this.changing_ || (this.changing_ = !0, Ea(this, e), this.changing_ = !1, this.trigger("change"));
    }, e.addEventListener("selectedchange", e.selectedChange_));
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && e.selectedChange_ && (e.removeEventListener("selectedchange", e.selectedChange_), e.selectedChange_ = null);
  }
}
class Eh extends Zi {
  /**
   * Add a {@link TextTrack} to the `TextTrackList`
   *
   * @param {TextTrack} track
   *        The text track to add to the list.
   *
   * @fires TrackList#addtrack
   */
  addTrack(e) {
    super.addTrack(e), this.queueChange_ || (this.queueChange_ = () => this.queueTrigger("change")), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = () => this.trigger("selectedlanguagechange")), e.addEventListener("modechange", this.queueChange_), ["metadata", "chapters"].indexOf(e.kind) === -1 && e.addEventListener("modechange", this.triggerSelectedlanguagechange_);
  }
  removeTrack(e) {
    super.removeTrack(e), e.removeEventListener && (this.queueChange_ && e.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && e.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
  }
}
class tT {
  /**
   * Create an instance of this class.
   *
   * @param {HtmlTrackElement[]} [tracks=[]]
   *        A list of `HtmlTrackElement` to instantiate the list with.
   */
  constructor(e = []) {
    this.trackElements_ = [], Object.defineProperty(this, "length", {
      get() {
        return this.trackElements_.length;
      }
    });
    for (let t = 0, s = e.length; t < s; t++)
      this.addTrackElement_(e[t]);
  }
  /**
   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to add to the list.
   *
   * @private
   */
  addTrackElement_(e) {
    const t = this.trackElements_.length;
    "" + t in this || Object.defineProperty(this, t, {
      get() {
        return this.trackElements_[t];
      }
    }), this.trackElements_.indexOf(e) === -1 && this.trackElements_.push(e);
  }
  /**
   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
   * {@link TextTrack}.
   *
   * @param {TextTrack} track
   *        The track associated with a track element.
   *
   * @return {HtmlTrackElement|undefined}
   *         The track element that was found or undefined.
   *
   * @private
   */
  getTrackElementByTrack_(e) {
    let t;
    for (let s = 0, r = this.trackElements_.length; s < r; s++)
      if (e === this.trackElements_[s].track) {
        t = this.trackElements_[s];
        break;
      }
    return t;
  }
  /**
   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
   *
   * @param {HtmlTrackElement} trackElement
   *        The track element to remove from the list.
   *
   * @private
   */
  removeTrackElement_(e) {
    for (let t = 0, s = this.trackElements_.length; t < s; t++)
      if (e === this.trackElements_[t]) {
        this.trackElements_[t].track && typeof this.trackElements_[t].track.off == "function" && this.trackElements_[t].track.off(), typeof this.trackElements_[t].off == "function" && this.trackElements_[t].off(), this.trackElements_.splice(t, 1);
        break;
      }
  }
}
class rn {
  /**
   * Create an instance of this class..
   *
   * @param {Array} cues
   *        A list of cues to be initialized with
   */
  constructor(e) {
    rn.prototype.setCues_.call(this, e), Object.defineProperty(this, "length", {
      get() {
        return this.length_;
      }
    });
  }
  /**
   * A setter for cues in this list. Creates getters
   * an an index for the cues.
   *
   * @param {Array} cues
   *        An array of cues to set
   *
   * @private
   */
  setCues_(e) {
    const t = this.length || 0;
    let s = 0;
    const r = e.length;
    this.cues_ = e, this.length_ = e.length;
    const n = function(a) {
      "" + a in this || Object.defineProperty(this, "" + a, {
        get() {
          return this.cues_[a];
        }
      });
    };
    if (t < r)
      for (s = t; s < r; s++)
        n.call(this, s);
  }
  /**
   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
   *
   * @param {string} id
   *        The id of the cue that should be searched for.
   *
   * @return {TextTrackCueList~TextTrackCue|null}
   *         A single cue or null if none was found.
   */
  getCueById(e) {
    let t = null;
    for (let s = 0, r = this.length; s < r; s++) {
      const n = this[s];
      if (n.id === e) {
        t = n;
        break;
      }
    }
    return t;
  }
}
const iT = {
  alternative: "alternative",
  captions: "captions",
  main: "main",
  sign: "sign",
  subtitles: "subtitles",
  commentary: "commentary"
}, sT = {
  alternative: "alternative",
  descriptions: "descriptions",
  main: "main",
  "main-desc": "main-desc",
  translation: "translation",
  commentary: "commentary"
}, rT = {
  subtitles: "subtitles",
  captions: "captions",
  descriptions: "descriptions",
  chapters: "chapters",
  metadata: "metadata"
}, Ql = {
  disabled: "disabled",
  hidden: "hidden",
  showing: "showing"
};
class jo extends tt {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid kind for the track type you are creating.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @abstract
   */
  constructor(e = {}) {
    super();
    const t = {
      id: e.id || "vjs_track_" + nt(),
      kind: e.kind || "",
      language: e.language || ""
    };
    let s = e.label || "";
    for (const r in t)
      Object.defineProperty(this, r, {
        get() {
          return t[r];
        },
        set() {
        }
      });
    Object.defineProperty(this, "label", {
      get() {
        return s;
      },
      set(r) {
        r !== s && (s = r, this.trigger("labelchange"));
      }
    });
  }
}
const Ho = function(i) {
  return new URL(i, U.baseURI);
}, Ch = function(i) {
  return new URL(i, U.baseURI).href;
}, Vo = function(i) {
  if (typeof i == "string") {
    const t = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/.exec(i);
    if (t)
      return t.pop().toLowerCase();
  }
  return "";
}, Un = function(i, e = S.location) {
  return Ho(i).origin !== e.origin;
};
var nT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  parseUrl: Ho,
  getAbsoluteURL: Ch,
  getFileExtension: Vo,
  isCrossOrigin: Un
});
const Jl = function(i, e) {
  const t = new S.WebVTT.Parser(S, S.vttjs, S.WebVTT.StringDecoder()), s = [];
  t.oncue = function(r) {
    e.addCue(r);
  }, t.onparsingerror = function(r) {
    s.push(r);
  }, t.onflush = function() {
    e.trigger({
      type: "loadeddata",
      target: e
    });
  }, t.parse(i), s.length > 0 && (S.console && S.console.groupCollapsed && S.console.groupCollapsed(`Text Track parsing errors for ${e.src}`), s.forEach((r) => Q.error(r)), S.console && S.console.groupEnd && S.console.groupEnd()), t.flush();
}, Zl = function(i, e) {
  const t = {
    uri: i
  }, s = Un(i);
  s && (t.cors = s);
  const r = e.tech_.crossOrigin() === "use-credentials";
  r && (t.withCredentials = r), Wc(t, le(this, function(n, a, o) {
    if (n)
      return Q.error(n, a);
    e.loaded_ = !0, typeof S.WebVTT != "function" ? e.tech_ && e.tech_.any(["vttjsloaded", "vttjserror"], (l) => {
      if (l.type === "vttjserror") {
        Q.error(`vttjs failed to load, stopping trying to process ${e.src}`);
        return;
      }
      return Jl(o, e);
    }) : Jl(o, e);
  }));
};
class tr extends jo {
  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this TextTrack.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  constructor(e = {}) {
    if (!e.tech)
      throw new Error("A tech was not provided.");
    const t = oe(e, {
      kind: rT[e.kind] || "subtitles",
      language: e.language || e.srclang || ""
    });
    let s = Ql[t.mode] || "disabled";
    const r = t.default;
    (t.kind === "metadata" || t.kind === "chapters") && (s = "hidden"), super(t), this.tech_ = t.tech, this.cues_ = [], this.activeCues_ = [], this.preload_ = this.tech_.preloadTextTracks !== !1;
    const n = new rn(this.cues_), a = new rn(this.activeCues_);
    let o = !1;
    this.timeupdateHandler = le(this, function(h = {}) {
      if (!this.tech_.isDisposed()) {
        if (!this.tech_.isReady_) {
          h.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
          return;
        }
        this.activeCues = this.activeCues, o && (this.trigger("cuechange"), o = !1), h.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
      }
    });
    const l = () => {
      this.stopTracking();
    };
    this.tech_.one("dispose", l), s !== "disabled" && this.startTracking(), Object.defineProperties(this, {
      /**
       * @memberof TextTrack
       * @member {boolean} default
       *         If this track was set to be on or off by default. Cannot be changed after
       *         creation.
       * @instance
       *
       * @readonly
       */
      default: {
        get() {
          return r;
        },
        set() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {string} mode
       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
       *         not be set if setting to an invalid mode.
       * @instance
       *
       * @fires TextTrack#modechange
       */
      mode: {
        get() {
          return s;
        },
        set(h) {
          Ql[h] && s !== h && (s = h, !this.preload_ && s !== "disabled" && this.cues.length === 0 && Zl(this.src, this), this.stopTracking(), s !== "disabled" && this.startTracking(), this.trigger("modechange"));
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} cues
       *         The text track cue list for this TextTrack.
       * @instance
       */
      cues: {
        get() {
          return this.loaded_ ? n : null;
        },
        set() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} activeCues
       *         The list text track cues that are currently active for this TextTrack.
       * @instance
       */
      activeCues: {
        get() {
          if (!this.loaded_)
            return null;
          if (this.cues.length === 0)
            return a;
          const h = this.tech_.currentTime(), m = [];
          for (let _ = 0, v = this.cues.length; _ < v; _++) {
            const C = this.cues[_];
            C.startTime <= h && C.endTime >= h && m.push(C);
          }
          if (o = !1, m.length !== this.activeCues_.length)
            o = !0;
          else
            for (let _ = 0; _ < m.length; _++)
              this.activeCues_.indexOf(m[_]) === -1 && (o = !0);
          return this.activeCues_ = m, a.setCues_(this.activeCues_), a;
        },
        // /!\ Keep this setter empty (see the timeupdate handler above)
        set() {
        }
      }
    }), t.src ? (this.src = t.src, this.preload_ || (this.loaded_ = !0), (this.preload_ || t.kind !== "subtitles" && t.kind !== "captions") && Zl(this.src, this)) : this.loaded_ = !0;
  }
  startTracking() {
    this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler), this.tech_.on("timeupdate", this.timeupdateHandler);
  }
  stopTracking() {
    this.rvf_ && (this.tech_.cancelVideoFrameCallback(this.rvf_), this.rvf_ = void 0), this.tech_.off("timeupdate", this.timeupdateHandler);
  }
  /**
   * Add a cue to the internal list of cues.
   *
   * @param {TextTrack~Cue} cue
   *        The cue to add to our internal list
   */
  addCue(e) {
    let t = e;
    if (!("getCueAsHTML" in t)) {
      t = new S.vttjs.VTTCue(e.startTime, e.endTime, e.text);
      for (const r in e)
        r in t || (t[r] = e[r]);
      t.id = e.id, t.originalCue_ = e;
    }
    const s = this.tech_.textTracks();
    for (let r = 0; r < s.length; r++)
      s[r] !== this && s[r].removeCue(t);
    this.cues_.push(t), this.cues.setCues_(this.cues_);
  }
  /**
   * Remove a cue from our internal list
   *
   * @param {TextTrack~Cue} removeCue
   *        The cue to remove from our internal list
   */
  removeCue(e) {
    let t = this.cues_.length;
    for (; t--; ) {
      const s = this.cues_[t];
      if (s === e || s.originalCue_ && s.originalCue_ === e) {
        this.cues_.splice(t, 1), this.cues.setCues_(this.cues_);
        break;
      }
    }
  }
}
tr.prototype.allowedEvents_ = {
  cuechange: "cuechange"
};
class Ah extends jo {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {AudioTrack~Kind} [options.kind='']
   *        A valid audio track kind
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.enabled]
   *        If this track is the one that is currently playing. If this track is part of
   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
   */
  constructor(e = {}) {
    const t = oe(e, {
      kind: sT[e.kind] || ""
    });
    super(t);
    let s = !1;
    Object.defineProperty(this, "enabled", {
      get() {
        return s;
      },
      set(r) {
        typeof r != "boolean" || r === s || (s = r, this.trigger("enabledchange"));
      }
    }), t.enabled && (this.enabled = t.enabled), this.loaded_ = !0;
  }
}
class Dh extends jo {
  /**
   * Create an instance of this class.
   *
   * @param {Object} [options={}]
   *        Object of option names and values
   *
   * @param {string} [options.kind='']
   *        A valid {@link VideoTrack~Kind}
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this AudioTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {boolean} [options.selected]
   *        If this track is the one that is currently playing.
   */
  constructor(e = {}) {
    const t = oe(e, {
      kind: iT[e.kind] || ""
    });
    super(t);
    let s = !1;
    Object.defineProperty(this, "selected", {
      get() {
        return s;
      },
      set(r) {
        typeof r != "boolean" || r === s || (s = r, this.trigger("selectedchange"));
      }
    }), t.selected && (this.selected = t.selected);
  }
}
class Ft extends tt {
  /**
   * Create an instance of this class.
   *
   * @param {Object} options={}
   *        Object of option names and values
   *
   * @param {Tech} options.tech
   *        A reference to the tech that owns this HTMLTrackElement.
   *
   * @param {TextTrack~Kind} [options.kind='subtitles']
   *        A valid text track kind.
   *
   * @param {TextTrack~Mode} [options.mode='disabled']
   *        A valid text track mode.
   *
   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
   *        A unique id for this TextTrack.
   *
   * @param {string} [options.label='']
   *        The menu label for this track.
   *
   * @param {string} [options.language='']
   *        A valid two character language code.
   *
   * @param {string} [options.srclang='']
   *        A valid two character language code. An alternative, but deprioritized
   *        version of `options.language`
   *
   * @param {string} [options.src]
   *        A url to TextTrack cues.
   *
   * @param {boolean} [options.default]
   *        If this track should default to on or off.
   */
  constructor(e = {}) {
    super();
    let t;
    const s = new tr(e);
    this.kind = s.kind, this.src = s.src, this.srclang = s.language, this.label = s.label, this.default = s.default, Object.defineProperties(this, {
      /**
       * @memberof HTMLTrackElement
       * @member {HTMLTrackElement~ReadyState} readyState
       *         The current ready state of the track element.
       * @instance
       */
      readyState: {
        get() {
          return t;
        }
      },
      /**
       * @memberof HTMLTrackElement
       * @member {TextTrack} track
       *         The underlying TextTrack object.
       * @instance
       *
       */
      track: {
        get() {
          return s;
        }
      }
    }), t = Ft.NONE, s.addEventListener("loadeddata", () => {
      t = Ft.LOADED, this.trigger({
        type: "load",
        target: this
      });
    });
  }
}
Ft.prototype.allowedEvents_ = {
  load: "load"
};
Ft.NONE = 0;
Ft.LOADING = 1;
Ft.LOADED = 2;
Ft.ERROR = 3;
const rt = {
  audio: {
    ListClass: Zy,
    TrackClass: Ah,
    capitalName: "Audio"
  },
  video: {
    ListClass: eT,
    TrackClass: Dh,
    capitalName: "Video"
  },
  text: {
    ListClass: Eh,
    TrackClass: tr,
    capitalName: "Text"
  }
};
Object.keys(rt).forEach(function(i) {
  rt[i].getterName = `${i}Tracks`, rt[i].privateName = `${i}Tracks_`;
});
const es = {
  remoteText: {
    ListClass: Eh,
    TrackClass: tr,
    capitalName: "RemoteText",
    getterName: "remoteTextTracks",
    privateName: "remoteTextTracks_"
  },
  remoteTextEl: {
    ListClass: tT,
    TrackClass: Ft,
    capitalName: "RemoteTextTrackEls",
    getterName: "remoteTextTrackEls",
    privateName: "remoteTextTrackEls_"
  }
}, Ue = Object.assign({}, rt, es);
es.names = Object.keys(es);
rt.names = Object.keys(rt);
Ue.names = [].concat(es.names).concat(rt.names);
function aT(i, e, t, s, r = {}) {
  const n = i.textTracks();
  r.kind = e, t && (r.label = t), s && (r.language = s), r.tech = i;
  const a = new Ue.text.TrackClass(r);
  return n.addTrack(a), a;
}
class Y extends M {
  /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */
  constructor(e = {}, t = function() {
  }) {
    e.reportTouchActivity = !1, super(null, e, t), this.onDurationChange_ = (s) => this.onDurationChange(s), this.trackProgress_ = (s) => this.trackProgress(s), this.trackCurrentTime_ = (s) => this.trackCurrentTime(s), this.stopTrackingCurrentTime_ = (s) => this.stopTrackingCurrentTime(s), this.disposeSourceHandler_ = (s) => this.disposeSourceHandler(s), this.queuedHanders_ = /* @__PURE__ */ new Set(), this.hasStarted_ = !1, this.on("playing", function() {
      this.hasStarted_ = !0;
    }), this.on("loadstart", function() {
      this.hasStarted_ = !1;
    }), Ue.names.forEach((s) => {
      const r = Ue[s];
      e && e[r.getterName] && (this[r.privateName] = e[r.getterName]);
    }), this.featuresProgressEvents || this.manualProgressOn(), this.featuresTimeupdateEvents || this.manualTimeUpdatesOn(), ["Text", "Audio", "Video"].forEach((s) => {
      e[`native${s}Tracks`] === !1 && (this[`featuresNative${s}Tracks`] = !1);
    }), e.nativeCaptions === !1 || e.nativeTextTracks === !1 ? this.featuresNativeTextTracks = !1 : (e.nativeCaptions === !0 || e.nativeTextTracks === !0) && (this.featuresNativeTextTracks = !0), this.featuresNativeTextTracks || this.emulateTextTracks(), this.preloadTextTracks = e.preloadTextTracks !== !1, this.autoRemoteTextTracks_ = new Ue.text.ListClass(), this.initTrackListeners(), e.nativeControlsForTouch || this.emitTapEvents(), this.constructor && (this.name_ = this.constructor.name || "Unknown Tech");
  }
  /**
   * A special function to trigger source set in a way that will allow player
   * to re-trigger if the player or tech are not ready yet.
   *
   * @fires Tech#sourceset
   * @param {string} src The source string at the time of the source changing.
   */
  triggerSourceset(e) {
    this.isReady_ || this.one("ready", () => this.setTimeout(() => this.triggerSourceset(e), 1)), this.trigger({
      src: e,
      type: "sourceset"
    });
  }
  /* Fallbacks for unsupported event types
  ================================================================================ */
  /**
   * Polyfill the `progress` event for browsers that don't support it natively.
   *
   * @see {@link Tech#trackProgress}
   */
  manualProgressOn() {
    this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_);
  }
  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   */
  manualProgressOff() {
    this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_);
  }
  /**
   * This is used to trigger a `progress` event when the buffered percent changes. It
   * sets an interval function that will be called every 500 milliseconds to check if the
   * buffer end percent has changed.
   *
   * > This function is called by {@link Tech#manualProgressOn}
   *
   * @param {Event} event
   *        The `ready` event that caused this to run.
   *
   * @listens Tech#ready
   * @fires Tech#progress
   */
  trackProgress(e) {
    this.stopTrackingProgress(), this.progressInterval = this.setInterval(le(this, function() {
      const t = this.bufferedPercent();
      this.bufferedPercent_ !== t && this.trigger("progress"), this.bufferedPercent_ = t, t === 1 && this.stopTrackingProgress();
    }), 500);
  }
  /**
   * Update our internal duration on a `durationchange` event by calling
   * {@link Tech#duration}.
   *
   * @param {Event} event
   *        The `durationchange` event that caused this to run.
   *
   * @listens Tech#durationchange
   */
  onDurationChange(e) {
    this.duration_ = this.duration();
  }
  /**
   * Get and create a `TimeRange` object for buffering.
   *
   * @return {TimeRange}
   *         The time range object that was created.
   */
  buffered() {
    return dt(0, 0);
  }
  /**
   * Get the percentage of the current video that is currently buffered.
   *
   * @return {number}
   *         A number from 0 to 1 that represents the decimal percentage of the
   *         video that is buffered.
   *
   */
  bufferedPercent() {
    return Sh(this.buffered(), this.duration_);
  }
  /**
   * Turn off the polyfill for `progress` events that was created in
   * {@link Tech#manualProgressOn}
   * Stop manually tracking progress events by clearing the interval that was set in
   * {@link Tech#trackProgress}.
   */
  stopTrackingProgress() {
    this.clearInterval(this.progressInterval);
  }
  /**
   * Polyfill the `timeupdate` event for browsers that don't support it.
   *
   * @see {@link Tech#trackCurrentTime}
   */
  manualTimeUpdatesOn() {
    this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_);
  }
  /**
   * Turn off the polyfill for `timeupdate` events that was created in
   * {@link Tech#manualTimeUpdatesOn}
   */
  manualTimeUpdatesOff() {
    this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_);
  }
  /**
   * Sets up an interval function to track current time and trigger `timeupdate` every
   * 250 milliseconds.
   *
   * @listens Tech#play
   * @triggers Tech#timeupdate
   */
  trackCurrentTime() {
    this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function() {
      this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: !0
      });
    }, 250);
  }
  /**
   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
   * `timeupdate` event is no longer triggered.
   *
   * @listens {Tech#pause}
   */
  stopTrackingCurrentTime() {
    this.clearInterval(this.currentTimeInterval), this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }
  /**
   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
   *
   * @fires Component#dispose
   */
  dispose() {
    this.clearTracks(rt.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), super.dispose();
  }
  /**
   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
   *
   * > Note: Techs without source handlers should call this between sources for `video`
   *         & `audio` tracks. You don't want to use them between tracks!
   *
   * @param {string[]|string} types
   *        TrackList names to clear, valid names are `video`, `audio`, and
   *        `text`.
   */
  clearTracks(e) {
    e = [].concat(e), e.forEach((t) => {
      const s = this[`${t}Tracks`]() || [];
      let r = s.length;
      for (; r--; ) {
        const n = s[r];
        t === "text" && this.removeRemoteTextTrack(n), s.removeTrack(n);
      }
    });
  }
  /**
   * Remove any TextTracks added via addRemoteTextTrack that are
   * flagged for automatic garbage collection
   */
  cleanupAutoTextTracks() {
    const e = this.autoRemoteTextTracks_ || [];
    let t = e.length;
    for (; t--; ) {
      const s = e[t];
      this.removeRemoteTextTrack(s);
    }
  }
  /**
   * Reset the tech, which will removes all sources and reset the internal readyState.
   *
   * @abstract
   */
  reset() {
  }
  /**
   * Get the value of `crossOrigin` from the tech.
   *
   * @abstract
   *
   * @see {Html5#crossOrigin}
   */
  crossOrigin() {
  }
  /**
   * Set the value of `crossOrigin` on the tech.
   *
   * @abstract
   *
   * @param {string} crossOrigin the crossOrigin value
   * @see {Html5#setCrossOrigin}
   */
  setCrossOrigin() {
  }
  /**
   * Get or set an error on the Tech.
   *
   * @param {MediaError} [err]
   *        Error to set on the Tech
   *
   * @return {MediaError|null}
   *         The current error object on the tech, or null if there isn't one.
   */
  error(e) {
    return e !== void 0 && (this.error_ = new ge(e), this.trigger("error")), this.error_;
  }
  /**
   * Returns the `TimeRange`s that have been played through for the current source.
   *
   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
   *         It only checks whether the source has played at all or not.
   *
   * @return {TimeRange}
   *         - A single time range if this video has played
   *         - An empty set of ranges if not.
   */
  played() {
    return this.hasStarted_ ? dt(0, 0) : dt();
  }
  /**
   * Start playback
   *
   * @abstract
   *
   * @see {Html5#play}
   */
  play() {
  }
  /**
   * Set whether we are scrubbing or not
   *
   * @abstract
   * @param {boolean} _isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   *
   * @see {Html5#setScrubbing}
   */
  setScrubbing(e) {
  }
  /**
   * Get whether we are scrubbing or not
   *
   * @abstract
   *
   * @see {Html5#scrubbing}
   */
  scrubbing() {
  }
  /**
   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
   * previously called.
   *
   * @param {number} _seconds
   *        Set the current time of the media to this.
   * @fires Tech#timeupdate
   */
  setCurrentTime(e) {
    this.manualTimeUpdates && this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }
  /**
   * Turn on listeners for {@link VideoTrackList}, {@link {AudioTrackList}, and
   * {@link TextTrackList} events.
   *
   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
   *
   * @fires Tech#audiotrackchange
   * @fires Tech#videotrackchange
   * @fires Tech#texttrackchange
   */
  initTrackListeners() {
    rt.names.forEach((e) => {
      const t = rt[e], s = () => {
        this.trigger(`${e}trackchange`);
      }, r = this[t.getterName]();
      r.addEventListener("removetrack", s), r.addEventListener("addtrack", s), this.on("dispose", () => {
        r.removeEventListener("removetrack", s), r.removeEventListener("addtrack", s);
      });
    });
  }
  /**
   * Emulate TextTracks using vtt.js if necessary
   *
   * @fires Tech#vttjsloaded
   * @fires Tech#vttjserror
   */
  addWebVttScript_() {
    if (!S.WebVTT)
      if (U.body.contains(this.el())) {
        if (!this.options_["vtt.js"] && Ki(gl) && Object.keys(gl).length > 0) {
          this.trigger("vttjsloaded");
          return;
        }
        const e = U.createElement("script");
        e.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", e.onload = () => {
          this.trigger("vttjsloaded");
        }, e.onerror = () => {
          this.trigger("vttjserror");
        }, this.on("dispose", () => {
          e.onload = null, e.onerror = null;
        }), S.WebVTT = !0, this.el().parentNode.appendChild(e);
      } else
        this.ready(this.addWebVttScript_);
  }
  /**
   * Emulate texttracks
   *
   */
  emulateTextTracks() {
    const e = this.textTracks(), t = this.remoteTextTracks(), s = (o) => e.addTrack(o.track), r = (o) => e.removeTrack(o.track);
    t.on("addtrack", s), t.on("removetrack", r), this.addWebVttScript_();
    const n = () => this.trigger("texttrackchange"), a = () => {
      n();
      for (let o = 0; o < e.length; o++) {
        const l = e[o];
        l.removeEventListener("cuechange", n), l.mode === "showing" && l.addEventListener("cuechange", n);
      }
    };
    a(), e.addEventListener("change", a), e.addEventListener("addtrack", a), e.addEventListener("removetrack", a), this.on("dispose", function() {
      t.off("addtrack", s), t.off("removetrack", r), e.removeEventListener("change", a), e.removeEventListener("addtrack", a), e.removeEventListener("removetrack", a);
      for (let o = 0; o < e.length; o++)
        e[o].removeEventListener("cuechange", n);
    });
  }
  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */
  addTextTrack(e, t, s) {
    if (!e)
      throw new Error("TextTrack kind is required but was not provided");
    return aT(this, e, t, s);
  }
  /**
   * Create an emulated TextTrack for use by addRemoteTextTrack
   *
   * This is intended to be overridden by classes that inherit from
   * Tech in order to create native or custom TextTracks.
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label].
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */
  createRemoteTextTrack(e) {
    const t = oe(e, {
      tech: this
    });
    return new es.remoteTextEl.TrackClass(t);
  }
  /**
   * Creates a remote text track object and returns an html track element.
   *
   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   * @param {Object} options
   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
   *
   * @param {boolean} [manualCleanup=false]
   *        - When false: the TextTrack will be automatically removed from the video
   *          element whenever the source changes
   *        - When True: The TextTrack will have to be cleaned up manually
   *
   * @return {HTMLTrackElement}
   *         An Html Track Element.
   *
   */
  addRemoteTextTrack(e = {}, t) {
    const s = this.createRemoteTextTrack(e);
    return typeof t != "boolean" && (t = !1), this.remoteTextTrackEls().addTrackElement_(s), this.remoteTextTracks().addTrack(s.track), t === !1 && this.ready(() => this.autoRemoteTextTracks_.addTrack(s.track)), s;
  }
  /**
   * Remove a remote text track from the remote `TextTrackList`.
   *
   * @param {TextTrack} track
   *        `TextTrack` to remove from the `TextTrackList`
   */
  removeRemoteTextTrack(e) {
    const t = this.remoteTextTrackEls().getTrackElementByTrack_(e);
    this.remoteTextTrackEls().removeTrackElement_(t), this.remoteTextTracks().removeTrack(e), this.autoRemoteTextTracks_.removeTrack(e);
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   *
   * @abstract
   */
  getVideoPlaybackQuality() {
    return {};
  }
  /**
   * Attempt to create a floating video window always on top of other windows
   * so that users may continue consuming media while they interact with other
   * content sites, or applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise|undefined}
   *         A promise with a Picture-in-Picture window if the browser supports
   *         Promises (or one was passed in as an option). It returns undefined
   *         otherwise.
   *
   * @abstract
   */
  requestPictureInPicture() {
    return Promise.reject();
  }
  /**
   * A method to check for the value of the 'disablePictureInPicture' <video> property.
   * Defaults to true, as it should be considered disabled if the tech does not support pip
   *
   * @abstract
   */
  disablePictureInPicture() {
    return !0;
  }
  /**
   * A method to set or unset the 'disablePictureInPicture' <video> property.
   *
   * @abstract
   */
  setDisablePictureInPicture() {
  }
  /**
   * A fallback implementation of requestVideoFrameCallback using requestAnimationFrame
   *
   * @param {function} cb
   * @return {number} request id
   */
  requestVideoFrameCallback(e) {
    const t = nt();
    return !this.isReady_ || this.paused() ? (this.queuedHanders_.add(t), this.one("playing", () => {
      this.queuedHanders_.has(t) && (this.queuedHanders_.delete(t), e());
    })) : this.requestNamedAnimationFrame(t, e), t;
  }
  /**
   * A fallback implementation of cancelVideoFrameCallback
   *
   * @param {number} id id of callback to be cancelled
   */
  cancelVideoFrameCallback(e) {
    this.queuedHanders_.has(e) ? this.queuedHanders_.delete(e) : this.cancelNamedAnimationFrame(e);
  }
  /**
   * A method to set a poster from a `Tech`.
   *
   * @abstract
   */
  setPoster() {
  }
  /**
   * A method to check for the presence of the 'playsinline' <video> attribute.
   *
   * @abstract
   */
  playsinline() {
  }
  /**
   * A method to set or unset the 'playsinline' <video> attribute.
   *
   * @abstract
   */
  setPlaysinline() {
  }
  /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   *
   * @abstract
   */
  overrideNativeAudioTracks(e) {
  }
  /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   *
   * @abstract
   */
  overrideNativeVideoTracks(e) {
  }
  /**
   * Check if the tech can support the given mime-type.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param  {string} _type
   *         The mimetype to check for support
   *
   * @return {string}
   *         'probably', 'maybe', or empty string
   *
   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
   *
   * @abstract
   */
  canPlayType(e) {
    return "";
  }
  /**
   * Check if the type is supported by this tech.
   *
   * The base tech does not support any type, but source handlers might
   * overwrite this.
   *
   * @param {string} _type
   *        The media type to check
   * @return {string} Returns the native video element's response
   */
  static canPlayType(e) {
    return "";
  }
  /**
   * Check if the tech can support the given source
   *
   * @param {Object} srcObj
   *        The source object
   * @param {Object} options
   *        The options passed to the tech
   * @return {string} 'probably', 'maybe', or '' (empty string)
   */
  static canPlaySource(e, t) {
    return Y.canPlayType(e.type);
  }
  /*
   * Return whether the argument is a Tech or not.
   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
   *
   * @param {Object} component
   *        The item to check
   *
   * @return {boolean}
   *         Whether it is a tech or not
   *         - True if it is a tech
   *         - False if it is not
   */
  static isTech(e) {
    return e.prototype instanceof Y || e instanceof Y || e === Y;
  }
  /**
   * Registers a `Tech` into a shared list for videojs.
   *
   * @param {string} name
   *        Name of the `Tech` to register.
   *
   * @param {Object} tech
   *        The `Tech` class to register.
   */
  static registerTech(e, t) {
    if (Y.techs_ || (Y.techs_ = {}), !Y.isTech(t))
      throw new Error(`Tech ${e} must be a Tech`);
    if (!Y.canPlayType)
      throw new Error("Techs must have a static canPlayType method on them");
    if (!Y.canPlaySource)
      throw new Error("Techs must have a static canPlaySource method on them");
    return e = _e(e), Y.techs_[e] = t, Y.techs_[Bs(e)] = t, e !== "Tech" && Y.defaultTechOrder_.push(e), t;
  }
  /**
   * Get a `Tech` from the shared list by name.
   *
   * @param {string} name
   *        `camelCase` or `TitleCase` name of the Tech to get
   *
   * @return {Tech|undefined}
   *         The `Tech` or undefined if there was no tech with the name requested.
   */
  static getTech(e) {
    if (e) {
      if (Y.techs_ && Y.techs_[e])
        return Y.techs_[e];
      if (e = _e(e), S && S.videojs && S.videojs[e])
        return Q.warn(`The ${e} tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)`), S.videojs[e];
    }
  }
}
Ue.names.forEach(function(i) {
  const e = Ue[i];
  Y.prototype[e.getterName] = function() {
    return this[e.privateName] = this[e.privateName] || new e.ListClass(), this[e.privateName];
  };
});
Y.prototype.featuresVolumeControl = !0;
Y.prototype.featuresMuteControl = !0;
Y.prototype.featuresFullscreenResize = !1;
Y.prototype.featuresPlaybackRate = !1;
Y.prototype.featuresProgressEvents = !1;
Y.prototype.featuresSourceset = !1;
Y.prototype.featuresTimeupdateEvents = !1;
Y.prototype.featuresNativeTextTracks = !1;
Y.prototype.featuresVideoFrameCallback = !1;
Y.withSourceHandlers = function(i) {
  i.registerSourceHandler = function(t, s) {
    let r = i.sourceHandlers;
    r || (r = i.sourceHandlers = []), s === void 0 && (s = r.length), r.splice(s, 0, t);
  }, i.canPlayType = function(t) {
    const s = i.sourceHandlers || [];
    let r;
    for (let n = 0; n < s.length; n++)
      if (r = s[n].canPlayType(t), r)
        return r;
    return "";
  }, i.selectSourceHandler = function(t, s) {
    const r = i.sourceHandlers || [];
    let n;
    for (let a = 0; a < r.length; a++)
      if (n = r[a].canHandleSource(t, s), n)
        return r[a];
    return null;
  }, i.canPlaySource = function(t, s) {
    const r = i.selectSourceHandler(t, s);
    return r ? r.canHandleSource(t, s) : "";
  }, ["seekable", "seeking", "duration"].forEach(function(t) {
    const s = this[t];
    typeof s == "function" && (this[t] = function() {
      return this.sourceHandler_ && this.sourceHandler_[t] ? this.sourceHandler_[t].apply(this.sourceHandler_, arguments) : s.apply(this, arguments);
    });
  }, i.prototype), i.prototype.setSource = function(t) {
    let s = i.selectSourceHandler(t, this.options_);
    s || (i.nativeSourceHandler ? s = i.nativeSourceHandler : Q.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), s !== i.nativeSourceHandler && (this.currentSource_ = t), this.sourceHandler_ = s.handleSource(t, this, this.options_), this.one("dispose", this.disposeSourceHandler_);
  }, i.prototype.disposeSourceHandler = function() {
    this.currentSource_ && (this.clearTracks(["audio", "video"]), this.currentSource_ = null), this.cleanupAutoTextTracks(), this.sourceHandler_ && (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), this.sourceHandler_ = null);
  };
};
M.registerComponent("Tech", Y);
Y.registerTech("Tech", Y);
Y.defaultTechOrder_ = [];
const pi = {}, nn = {}, an = {};
function oT(i, e) {
  pi[i] = pi[i] || [], pi[i].push(e);
}
function uT(i, e, t) {
  i.setTimeout(() => ui(e, pi[e.type], t, i), 1);
}
function lT(i, e) {
  i.forEach((t) => t.setTech && t.setTech(e));
}
function cT(i, e, t) {
  return i.reduceRight(zo(t), e[t]());
}
function dT(i, e, t, s) {
  return e[t](i.reduce(zo(t), s));
}
function ec(i, e, t, s = null) {
  const r = "call" + _e(t), n = i.reduce(zo(r), s), a = n === an, o = a ? null : e[t](n);
  return pT(i, t, o, a), o;
}
const hT = {
  buffered: 1,
  currentTime: 1,
  duration: 1,
  muted: 1,
  played: 1,
  paused: 1,
  seekable: 1,
  volume: 1,
  ended: 1
}, fT = {
  setCurrentTime: 1,
  setMuted: 1,
  setVolume: 1
}, tc = {
  play: 1,
  pause: 1
};
function zo(i) {
  return (e, t) => e === an ? an : t[i] ? t[i](e) : e;
}
function pT(i, e, t, s) {
  for (let r = i.length - 1; r >= 0; r--) {
    const n = i[r];
    n[e] && n[e](s, t);
  }
}
function mT(i) {
  nn.hasOwnProperty(i.id()) && delete nn[i.id()];
}
function gT(i, e) {
  const t = nn[i.id()];
  let s = null;
  if (t == null)
    return s = e(i), nn[i.id()] = [[e, s]], s;
  for (let r = 0; r < t.length; r++) {
    const [n, a] = t[r];
    n === e && (s = a);
  }
  return s === null && (s = e(i), t.push([e, s])), s;
}
function ui(i = {}, e = [], t, s, r = [], n = !1) {
  const [a, ...o] = e;
  if (typeof a == "string")
    ui(i, pi[a], t, s, r, n);
  else if (a) {
    const l = gT(s, a);
    if (!l.setSource)
      return r.push(l), ui(i, o, t, s, r, n);
    l.setSource(Object.assign({}, i), function(h, m) {
      if (h)
        return ui(i, o, t, s, r, n);
      r.push(l), ui(m, i.type === m.type ? o : pi[m.type], t, s, r, n);
    });
  } else o.length ? ui(i, o, t, s, r, n) : n ? t(i, r) : ui(i, pi["*"], t, s, r, !0);
}
const _T = {
  opus: "video/ogg",
  ogv: "video/ogg",
  mp4: "video/mp4",
  mov: "video/mp4",
  m4v: "video/mp4",
  mkv: "video/x-matroska",
  m4a: "audio/mp4",
  mp3: "audio/mpeg",
  aac: "audio/aac",
  caf: "audio/x-caf",
  flac: "audio/flac",
  oga: "audio/ogg",
  wav: "audio/wav",
  m3u8: "application/x-mpegURL",
  mpd: "application/dash+xml",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  png: "image/png",
  svg: "image/svg+xml",
  webp: "image/webp"
}, on = function(i = "") {
  const e = Vo(i);
  return _T[e.toLowerCase()] || "";
}, yT = (i, e) => {
  if (!e)
    return "";
  if (i.cache_.source.src === e && i.cache_.source.type)
    return i.cache_.source.type;
  const t = i.cache_.sources.filter((r) => r.src === e);
  if (t.length)
    return t[0].type;
  const s = i.$$("source");
  for (let r = 0; r < s.length; r++) {
    const n = s[r];
    if (n.type && n.src && n.src === e)
      return n.type;
  }
  return on(e);
}, wh = function(i) {
  if (Array.isArray(i)) {
    let e = [];
    i.forEach(function(t) {
      t = wh(t), Array.isArray(t) ? e = e.concat(t) : St(t) && e.push(t);
    }), i = e;
  } else typeof i == "string" && i.trim() ? i = [ic({
    src: i
  })] : St(i) && typeof i.src == "string" && i.src && i.src.trim() ? i = [ic(i)] : i = [];
  return i;
};
function ic(i) {
  if (!i.type) {
    const e = on(i.src);
    e && (i.type = e);
  }
  return i;
}
var TT = `<svg xmlns="http://www.w3.org/2000/svg">
  <defs>
    <symbol viewBox="0 0 48 48" id="vjs-icon-play">
      <path d="M16 10v28l22-14z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-pause">
      <path d="M12 38h8V10h-8v28zm16-28v28h8V10h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-audio">
      <path d="M24 2C14.06 2 6 10.06 6 20v14c0 3.31 2.69 6 6 6h6V24h-8v-4c0-7.73 6.27-14 14-14s14 6.27 14 14v4h-8v16h6c3.31 0 6-2.69 6-6V20c0-9.94-8.06-18-18-18z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-captions">
      <path d="M38 8H10c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM22 22h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2zm14 0h-3v-1h-4v6h4v-1h3v2a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-subtitles">
      <path d="M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zM8 24h8v4H8v-4zm20 12H8v-4h20v4zm12 0h-8v-4h8v4zm0-8H20v-4h20v4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-enter">
      <path d="M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-fullscreen-exit">
      <path d="M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-play-circle">
      <path d="M20 33l12-9-12-9v18zm4-29C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-mute">
      <path d="M33 24c0-3.53-2.04-6.58-5-8.05v4.42l4.91 4.91c.06-.42.09-.85.09-1.28zm5 0c0 1.88-.41 3.65-1.08 5.28l3.03 3.03C41.25 29.82 42 27 42 24c0-8.56-5.99-15.72-14-17.54v4.13c5.78 1.72 10 7.07 10 13.41zM8.55 6L6 8.55 15.45 18H6v12h8l10 10V26.55l8.51 8.51c-1.34 1.03-2.85 1.86-4.51 2.36v4.13a17.94 17.94 0 0 0 7.37-3.62L39.45 42 42 39.45l-18-18L8.55 6zM24 8l-4.18 4.18L24 16.36V8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-low">
      <path d="M14 18v12h8l10 10V8L22 18h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-medium">
      <path d="M37 24c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zm-27-6v12h8l10 10V8L18 18h-8z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-volume-high">
      <path d="M6 18v12h8l10 10V8L14 18H6zm27 6c0-3.53-2.04-6.58-5-8.05v16.11c2.96-1.48 5-4.53 5-8.06zM28 6.46v4.13c5.78 1.72 10 7.07 10 13.41s-4.22 11.69-10 13.41v4.13c8.01-1.82 14-8.97 14-17.54S36.01 8.28 28 6.46z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-spinner">
      <path d="M18.8 21l9.53-16.51C26.94 4.18 25.49 4 24 4c-4.8 0-9.19 1.69-12.64 4.51l7.33 12.69.11-.2zm24.28-3c-1.84-5.85-6.3-10.52-11.99-12.68L23.77 18h19.31zm.52 2H28.62l.58 1 9.53 16.5C41.99 33.94 44 29.21 44 24c0-1.37-.14-2.71-.4-4zm-26.53 4l-7.8-13.5C6.01 14.06 4 18.79 4 24c0 1.37.14 2.71.4 4h14.98l-2.31-4zM4.92 30c1.84 5.85 6.3 10.52 11.99 12.68L24.23 30H4.92zm22.54 0l-7.8 13.51c1.4.31 2.85.49 4.34.49 4.8 0 9.19-1.69 12.64-4.51L29.31 26.8 27.46 30z"></path>
    </symbol>
    <symbol viewBox="0 0 24 24" id="vjs-icon-hd">
      <path d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-chapters">
      <path d="M6 26h4v-4H6v4zm0 8h4v-4H6v4zm0-16h4v-4H6v4zm8 8h28v-4H14v4zm0 8h28v-4H14v4zm0-20v4h28v-4H14z"></path>
    </symbol>
    <symbol viewBox="0 0 40 40" id="vjs-icon-downloading">
      <path d="M18.208 36.875q-3.208-.292-5.979-1.729-2.771-1.438-4.812-3.729-2.042-2.292-3.188-5.229-1.146-2.938-1.146-6.23 0-6.583 4.334-11.416 4.333-4.834 10.833-5.5v3.166q-5.167.75-8.583 4.646Q6.25 14.75 6.25 19.958q0 5.209 3.396 9.104 3.396 3.896 8.562 4.646zM20 28.417L11.542 20l2.083-2.083 4.917 4.916v-11.25h2.916v11.25l4.875-4.916L28.417 20zm1.792 8.458v-3.167q1.833-.25 3.541-.958 1.709-.708 3.167-1.875l2.333 2.292q-1.958 1.583-4.25 2.541-2.291.959-4.791 1.167zm6.791-27.792q-1.541-1.125-3.25-1.854-1.708-.729-3.541-1.021V3.042q2.5.25 4.77 1.208 2.271.958 4.271 2.5zm4.584 21.584l-2.25-2.25q1.166-1.5 1.854-3.209.687-1.708.937-3.541h3.209q-.292 2.5-1.229 4.791-.938 2.292-2.521 4.209zm.541-12.417q-.291-1.833-.958-3.562-.667-1.73-1.833-3.188l2.375-2.208q1.541 1.916 2.458 4.208.917 2.292 1.167 4.75z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download">
      <path d="M10.8 40.55q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h26.35v-7.7h3.4v7.7q0 1.4-1 2.4t-2.4 1zM24 32.1L13.9 22.05l2.45-2.45 5.95 5.95V7.15h3.4v18.4l5.95-5.95 2.45 2.45z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-done">
      <path d="M9.8 40.5v-3.45h28.4v3.45zm9.2-9.05L7.4 19.85l2.45-2.35L19 26.65l19.2-19.2 2.4 2.4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-file-download-off">
      <path d="M4.9 4.75L43.25 43.1 41 45.3l-4.75-4.75q-.05.05-.075.025-.025-.025-.075-.025H10.8q-1.35 0-2.375-1T7.4 37.15v-7.7h3.4v7.7h22.05l-7-7-1.85 1.8L13.9 21.9l1.85-1.85L2.7 7zm26.75 14.7l2.45 2.45-3.75 3.8-2.45-2.5zM25.7 7.15V21.1l-3.4-3.45V7.15z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-share">
      <path d="M36 32.17c-1.52 0-2.89.59-3.93 1.54L17.82 25.4c.11-.45.18-.92.18-1.4s-.07-.95-.18-1.4l14.1-8.23c1.07 1 2.5 1.62 4.08 1.62 3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6c0 .48.07.95.18 1.4l-14.1 8.23c-1.07-1-2.5-1.62-4.08-1.62-3.31 0-6 2.69-6 6s2.69 6 6 6c1.58 0 3.01-.62 4.08-1.62l14.25 8.31c-.1.42-.16.86-.16 1.31A5.83 5.83 0 1 0 36 32.17z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cog">
      <path d="M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97L29 4.84c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3a14.8 14.8 0 0 0-3.38 1.97L9.9 10.1a1 1 0 0 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31C9.06 22.69 9 23.34 9 24s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3a14.8 14.8 0 0 0 3.38-1.97l4.98 2.01a1 1 0 0 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zM24 31c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-square">
      <path d="M36 8H12c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm0 28H12V12h24v24z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle">
      <circle cx="24" cy="24" r="20"></circle>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-outline">
      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-circle-inner-circle">
      <path d="M24 4C12.97 4 4 12.97 4 24s8.97 20 20 20 20-8.97 20-20S35.03 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm6-16c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cancel">
      <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 27.17L31.17 34 24 26.83 16.83 34 14 31.17 21.17 24 14 16.83 16.83 14 24 21.17 31.17 14 34 16.83 26.83 24 34 31.17z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-replay">
      <path d="M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-repeat">
      <path d="M14 14h20v6l8-8-8-8v6H10v12h4v-8zm20 20H14v-6l-8 8 8 8v-6h24V26h-4v8z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-5">
      <path d="M17.689 98l-8.697 8.696 8.697 8.697 2.486-2.485-4.32-4.319h1.302c4.93 0 9.071 1.722 12.424 5.165 3.352 3.443 5.029 7.638 5.029 12.584h3.55c0-2.958-.553-5.73-1.658-8.313-1.104-2.583-2.622-4.841-4.555-6.774-1.932-1.932-4.19-3.45-6.773-4.555-2.584-1.104-5.355-1.657-8.313-1.657H15.5l4.615-4.615zm-8.08 21.659v13.861h11.357v5.008H9.609V143h12.7c.834 0 1.55-.298 2.146-.894.596-.597.895-1.31.895-2.145v-7.781c0-.835-.299-1.55-.895-2.147a2.929 2.929 0 0 0-2.147-.894h-8.227v-5.096H25.35v-4.384z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-10">
      <path d="M42.315 125.63c0-4.997-1.694-9.235-5.08-12.713-3.388-3.479-7.571-5.218-12.552-5.218h-1.315l4.363 4.363-2.51 2.51-8.787-8.786L25.221 97l2.45 2.45-4.662 4.663h1.375c2.988 0 5.788.557 8.397 1.673 2.61 1.116 4.892 2.65 6.844 4.602 1.953 1.953 3.487 4.234 4.602 6.844 1.116 2.61 1.674 5.41 1.674 8.398zM8.183 142v-19.657H3.176V117.8h9.643V142zm13.63 0c-1.156 0-2.127-.393-2.912-1.178-.778-.778-1.168-1.746-1.168-2.902v-16.04c0-1.156.393-2.127 1.178-2.912.779-.779 1.746-1.168 2.902-1.168h7.696c1.156 0 2.126.392 2.911 1.177.779.78 1.168 1.747 1.168 2.903v16.04c0 1.156-.392 2.127-1.177 2.912-.779.779-1.746 1.168-2.902 1.168zm.556-4.636h6.583v-15.02H22.37z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-replay-30">
      <path d="M26.047 97l-8.733 8.732 8.733 8.733 2.496-2.494-4.336-4.338h1.307c4.95 0 9.108 1.73 12.474 5.187 3.367 3.458 5.051 7.668 5.051 12.635h3.565c0-2.97-.556-5.751-1.665-8.346-1.109-2.594-2.633-4.862-4.574-6.802-1.94-1.941-4.208-3.466-6.803-4.575-2.594-1.109-5.375-1.664-8.345-1.664H23.85l4.634-4.634zM2.555 117.531v4.688h10.297v5.25H5.873v4.687h6.979v5.156H2.555V142H13.36c1.061 0 1.95-.395 2.668-1.186.718-.79 1.076-1.772 1.076-2.94v-16.218c0-1.168-.358-2.149-1.076-2.94-.717-.79-1.607-1.185-2.668-1.185zm22.482.14c-1.149 0-2.11.39-2.885 1.165-.78.78-1.172 1.744-1.172 2.893v15.943c0 1.149.388 2.11 1.163 2.885.78.78 1.745 1.172 2.894 1.172h7.649c1.148 0 2.11-.388 2.884-1.163.78-.78 1.17-1.745 1.17-2.894v-15.943c0-1.15-.386-2.111-1.16-2.885-.78-.78-1.746-1.172-2.894-1.172zm.553 4.518h6.545v14.93H25.59z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-5">
      <path d="M29.508 97l-2.431 2.43 4.625 4.625h-1.364c-2.965 0-5.742.554-8.332 1.66-2.589 1.107-4.851 2.629-6.788 4.566-1.937 1.937-3.458 4.2-4.565 6.788-1.107 2.59-1.66 5.367-1.66 8.331h3.557c0-4.957 1.68-9.16 5.04-12.611 3.36-3.45 7.51-5.177 12.451-5.177h1.304l-4.326 4.33 2.49 2.49 8.715-8.716zm-9.783 21.61v13.89h11.382v5.018H19.725V142h12.727a2.93 2.93 0 0 0 2.15-.896 2.93 2.93 0 0 0 .896-2.15v-7.798c0-.837-.299-1.554-.896-2.152a2.93 2.93 0 0 0-2.15-.896h-8.245V123h11.29v-4.392z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-10">
      <path d="M23.119 97l-2.386 2.383 4.538 4.538h-1.339c-2.908 0-5.633.543-8.173 1.63-2.54 1.085-4.76 2.577-6.66 4.478-1.9 1.9-3.392 4.12-4.478 6.66-1.085 2.54-1.629 5.264-1.629 8.172h3.49c0-4.863 1.648-8.986 4.944-12.372 3.297-3.385 7.368-5.078 12.216-5.078h1.279l-4.245 4.247 2.443 2.442 8.55-8.55zm-9.52 21.45v4.42h4.871V142h4.513v-23.55zm18.136 0c-1.125 0-2.066.377-2.824 1.135-.764.764-1.148 1.709-1.148 2.834v15.612c0 1.124.38 2.066 1.139 2.824.764.764 1.708 1.145 2.833 1.145h7.489c1.125 0 2.066-.378 2.824-1.136.764-.764 1.145-1.709 1.145-2.833v-15.612c0-1.125-.378-2.067-1.136-2.825-.764-.764-1.708-1.145-2.833-1.145zm.54 4.42h6.408v14.617h-6.407z"></path>
    </symbol>
    <symbol viewBox="0 96 48 48" id="vjs-icon-forward-30">
      <path d="M25.549 97l-2.437 2.434 4.634 4.635H26.38c-2.97 0-5.753.555-8.347 1.664-2.594 1.109-4.861 2.633-6.802 4.574-1.94 1.94-3.465 4.207-4.574 6.802-1.109 2.594-1.664 5.377-1.664 8.347h3.565c0-4.967 1.683-9.178 5.05-12.636 3.366-3.458 7.525-5.187 12.475-5.187h1.307l-4.335 4.338 2.495 2.494 8.732-8.732zm-11.553 20.53v4.689h10.297v5.249h-6.978v4.688h6.978v5.156H13.996V142h10.808c1.06 0 1.948-.395 2.666-1.186.718-.79 1.077-1.771 1.077-2.94v-16.217c0-1.169-.36-2.15-1.077-2.94-.718-.79-1.605-1.186-2.666-1.186zm21.174.168c-1.149 0-2.11.389-2.884 1.163-.78.78-1.172 1.745-1.172 2.894v15.942c0 1.15.388 2.11 1.162 2.885.78.78 1.745 1.17 2.894 1.17h7.649c1.149 0 2.11-.386 2.885-1.16.78-.78 1.17-1.746 1.17-2.895v-15.942c0-1.15-.387-2.11-1.161-2.885-.78-.78-1.745-1.172-2.894-1.172zm.552 4.516h6.542v14.931h-6.542z"></path>
    </symbol>
    <symbol viewBox="0 0 512 512" id="vjs-icon-audio-description">
      <g fill-rule="evenodd"><path d="M227.29 381.351V162.993c50.38-1.017 89.108-3.028 117.631 17.126 27.374 19.342 48.734 56.965 44.89 105.325-4.067 51.155-41.335 94.139-89.776 98.475-24.085 2.155-71.972 0-71.972 0s-.84-1.352-.773-2.568m48.755-54.804c31.43 1.26 53.208-16.633 56.495-45.386 4.403-38.51-21.188-63.552-58.041-60.796v103.612c-.036 1.466.575 2.22 1.546 2.57"></path><path d="M383.78 381.328c13.336 3.71 17.387-11.06 23.215-21.408 12.722-22.571 22.294-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.226 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M425.154 381.328c13.336 3.71 17.384-11.061 23.215-21.408 12.721-22.571 22.291-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.511c-.586 3.874 2.226 7.315 3.866 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894"></path><path d="M466.26 381.328c13.337 3.71 17.385-11.061 23.216-21.408 12.722-22.571 22.292-51.594 22.445-84.774.221-47.594-18.343-82.517-35.6-106.182h-8.51c-.587 3.874 2.225 7.315 3.865 10.276 13.166 23.762 25.367 56.553 25.54 94.194.2 43.176-14.162 79.278-30.955 107.894M4.477 383.005H72.58l18.573-28.484 64.169-.135s.065 19.413.065 28.62h48.756V160.307h-58.816c-5.653 9.537-140.85 222.697-140.85 222.697zm152.667-145.282v71.158l-40.453-.27 40.453-70.888z"></path></g>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-next-item">
      <path d="M12 36l17-12-17-12v24zm20-24v24h4V12h-4z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-previous-item">
      <path d="M12 12h4v24h-4zm7 12l17 12V12z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-shuffle">
      <path d="M21.17 18.34L10.83 8 8 10.83l10.34 10.34 2.83-2.83zM29 8l4.09 4.09L8 37.17 10.83 40l25.09-25.09L40 19V8H29zm.66 18.83l-2.83 2.83 6.26 6.26L29 40h11V29l-4.09 4.09-6.25-6.26z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-cast">
      <path d="M42 6H6c-2.21 0-4 1.79-4 4v6h4v-6h36v28H28v4h14c2.21 0 4-1.79 4-4V10c0-2.21-1.79-4-4-4zM2 36v6h6c0-3.31-2.69-6-6-6zm0-8v4c5.52 0 10 4.48 10 10h4c0-7.73-6.27-14-14-14zm0-8v4c9.94 0 18 8.06 18 18h4c0-12.15-9.85-22-22-22z"></path>
    </symbol>
    <symbol viewBox="0 0 48 48" id="vjs-icon-picture-in-picture-enter">
      <path d="M38 22H22v11.99h16V22zm8 16V9.96C46 7.76 44.2 6 42 6H6C3.8 6 2 7.76 2 9.96V38c0 2.2 1.8 4 4 4h36c2.2 0 4-1.8 4-4zm-4 .04H6V9.94h36v28.1z"></path>
    </symbol>
    <symbol viewBox="0 0 22 18" id="vjs-icon-picture-in-picture-exit">
      <path d="M18 4H4v10h14V4zm4 12V1.98C22 .88 21.1 0 20 0H2C.9 0 0 .88 0 1.98V16c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H2V1.97h18v14.05z"></path>
      <path fill="none" d="M-1-3h24v24H-1z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-facebook">
      <path d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759H734V905H479V609h255V391q0-186 104-288.5T1115 0q147 0 228 12z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-linkedin">
      <path d="M477 625v991H147V625h330zm21-306q1 73-50.5 122T312 490h-2q-82 0-132-49t-50-122q0-74 51.5-122.5T314 148t133 48.5T498 319zm1166 729v568h-329v-530q0-105-40.5-164.5T1168 862q-63 0-105.5 34.5T999 982q-11 30-11 81v553H659q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5T1285 602q171 0 275 113.5t104 332.5z"></path>
    </symbol>
    <symbol viewBox="0 0 1200 1227" id="vjs-icon-twitter">
      <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"/>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-tumblr">
      <path d="M1328 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26T787 1564t-95-106-55.5-120-16.5-118V676H452V461q72-26 129-69.5t91-90 58-102 34-99T779 12q1-5 4.5-8.5T791 0h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z"></path>
    </symbol>
    <symbol viewBox="0 0 1792 1792" id="vjs-icon-pinterest">
      <path d="M1664 896q0 209-103 385.5T1281.5 1561 896 1664q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214T1180 449t-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5T377 866q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5T904 517q151 0 235.5 82t84.5 213q0 170-68.5 289T980 1220q-61 0-98-43.5T859 1072q8-35 26.5-93.5t30-103T927 800q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281T128 896q0-209 103-385.5T510.5 231 896 128t385.5 103T1561 510.5 1664 896z"></path>
    </symbol>
  </defs>
</svg>`;
const sc = Zr ? 10009 : en ? 461 : 8, Ii = {
  codes: {
    play: 415,
    pause: 19,
    ff: 417,
    rw: 412,
    back: sc
  },
  names: {
    415: "play",
    19: "pause",
    417: "ff",
    412: "rw",
    [sc]: "back"
  },
  isEventKey(i, e) {
    return e = e.toLowerCase(), !!(this.names[i.keyCode] && this.names[i.keyCode] === e);
  },
  getEventName(i) {
    if (this.names[i.keyCode])
      return this.names[i.keyCode];
    if (this.codes[i.code]) {
      const e = this.codes[i.code];
      return this.names[e];
    }
    return null;
  }
}, rc = 5;
class vT extends tt {
  /**
   * Constructs a SpatialNavigation instance with initial settings.
   * Sets up the player instance, and prepares the spatial navigation system.
   *
   * @class
   * @param {Player} player - The Video.js player instance to which the spatial navigation is attached.
   */
  constructor(e) {
    super(), this.player_ = e, this.focusableComponents = [], this.isListening_ = !1, this.isPaused_ = !1, this.onKeyDown_ = this.onKeyDown_.bind(this), this.lastFocusedComponent_ = null;
  }
  /**
   * Starts the spatial navigation by adding a keydown event listener to the video container.
   * This method ensures that the event listener is added only once.
   */
  start() {
    this.isListening_ || (this.player_.on("keydown", this.onKeyDown_), this.player_.on("modalKeydown", this.onKeyDown_), this.player_.on("loadedmetadata", () => {
      this.focus(this.updateFocusableComponents()[0]);
    }), this.player_.on("modalclose", () => {
      this.refocusComponent();
    }), this.player_.on("focusin", this.handlePlayerFocus_.bind(this)), this.player_.on("focusout", this.handlePlayerBlur_.bind(this)), this.isListening_ = !0, this.player_.errorDisplay && this.player_.errorDisplay.on("aftermodalfill", () => {
      this.updateFocusableComponents(), this.focusableComponents.length && (this.focusableComponents.length > 1 ? this.focusableComponents[1].focus() : this.focusableComponents[0].focus());
    }));
  }
  /**
   * Stops the spatial navigation by removing the keydown event listener from the video container.
   * Also sets the `isListening_` flag to false.
   */
  stop() {
    this.player_.off("keydown", this.onKeyDown_), this.isListening_ = !1;
  }
  /**
   * Responds to keydown events for spatial navigation and media control.
   *
   * Determines if spatial navigation or media control is active and handles key inputs accordingly.
   *
   * @param {KeyboardEvent} event - The keydown event to be handled.
   */
  onKeyDown_(e) {
    const t = e.originalEvent ? e.originalEvent : e;
    if (["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(t.key)) {
      if (this.isPaused_)
        return;
      t.preventDefault();
      const s = t.key.substring(5).toLowerCase();
      this.move(s);
    } else if (Ii.isEventKey(t, "play") || Ii.isEventKey(t, "pause") || Ii.isEventKey(t, "ff") || Ii.isEventKey(t, "rw")) {
      t.preventDefault();
      const s = Ii.getEventName(t);
      this.performMediaAction_(s);
    } else Ii.isEventKey(t, "Back") && e.target && typeof e.target.closeable == "function" && e.target.closeable() && (t.preventDefault(), e.target.close());
  }
  /**
   * Performs media control actions based on the given key input.
   *
   * Controls the playback and seeking functionalities of the media player.
   *
   * @param {string} key - The key representing the media action to be performed.
   *   Accepted keys: 'play', 'pause', 'ff' (fast-forward), 'rw' (rewind).
   */
  performMediaAction_(e) {
    if (this.player_)
      switch (e) {
        case "play":
          this.player_.paused() && this.player_.play();
          break;
        case "pause":
          this.player_.paused() || this.player_.pause();
          break;
        case "ff":
          this.userSeek_(this.player_.currentTime() + rc);
          break;
        case "rw":
          this.userSeek_(this.player_.currentTime() - rc);
          break;
      }
  }
  /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */
  userSeek_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
  }
  /**
   * Pauses the spatial navigation functionality.
   * This method sets a flag that can be used to temporarily disable the navigation logic.
   */
  pause() {
    this.isPaused_ = !0;
  }
  /**
   * Resumes the spatial navigation functionality if it has been paused.
   * This method resets the pause flag, re-enabling the navigation logic.
   */
  resume() {
    this.isPaused_ = !1;
  }
  /**
   * Handles Player Blur.
   *
   * @param {string|Event|Object} event
   *        The name of the event, an `Event`, or an object with a key of type set to
   *        an event name.
   *
   * Calls for handling of the Player Blur if:
   * *The next focused element is not a child of current focused element &
   * The next focused element is not a child of the Player.
   * *There is no next focused element
   */
  handlePlayerBlur_(e) {
    const t = e.relatedTarget;
    let s = null;
    const r = this.getCurrentComponent(e.target);
    t && (s = !!t.closest(".video-js"), t.classList.contains("vjs-text-track-settings") && !this.isPaused_ && this.searchForTrackSelect_()), (!e.currentTarget.contains(e.relatedTarget) && !s || !t) && (r && r.name() === "CloseButton" ? this.refocusComponent() : (this.pause(), r && r.el() && (this.lastFocusedComponent_ = r)));
  }
  /**
   * Handles the Player focus event.
   *
   * Calls for handling of the Player Focus if current element is focusable.
   */
  handlePlayerFocus_() {
    this.getCurrentComponent() && this.getCurrentComponent().getIsFocusable() && this.resume();
  }
  /**
   * Gets a set of focusable components.
   *
   * @return {Array}
   *         Returns an array of focusable components.
   */
  updateFocusableComponents() {
    const e = this.player_, t = [];
    function s(r) {
      for (const n of r)
        n.hasOwnProperty("el_") && n.getIsFocusable() && n.getIsAvailableToBeFocused(n.el()) && t.push(n), n.hasOwnProperty("children_") && n.children_.length > 0 && s(n.children_);
    }
    return e.children_.forEach((r) => {
      if (r.hasOwnProperty("el_"))
        if (r.getIsFocusable && r.getIsAvailableToBeFocused && r.getIsFocusable() && r.getIsAvailableToBeFocused(r.el())) {
          t.push(r);
          return;
        } else r.hasOwnProperty("children_") && r.children_.length > 0 ? s(r.children_) : r.hasOwnProperty("items") && r.items.length > 0 ? s(r.items) : this.findSuitableDOMChild(r) && t.push(r);
      if (r.name_ === "ErrorDisplay" && r.opened_) {
        const n = r.el_.querySelector(".vjs-errors-ok-button-container");
        n && n.querySelectorAll("button").forEach((o, l) => {
          t.push({
            name: () => "ModalButton" + (l + 1),
            el: () => o,
            getPositions: () => {
              const h = o.getBoundingClientRect(), m = {
                x: h.x,
                y: h.y,
                width: h.width,
                height: h.height,
                top: h.top,
                right: h.right,
                bottom: h.bottom,
                left: h.left
              }, _ = {
                x: h.left + h.width / 2,
                y: h.top + h.height / 2,
                width: 0,
                height: 0,
                top: h.top + h.height / 2,
                right: h.left + h.width / 2,
                bottom: h.top + h.height / 2,
                left: h.left + h.width / 2
              };
              return {
                boundingClientRect: m,
                center: _
              };
            },
            // Asume that the following are always focusable
            getIsAvailableToBeFocused: () => !0,
            getIsFocusable: (h) => !0,
            focus: () => o.focus()
          });
        });
      }
    }), this.focusableComponents = t, this.focusableComponents;
  }
  /**
   * Finds a suitable child element within the provided component's DOM element.
   *
   * @param {Object} component - The component containing the DOM element to search within.
   * @return {HTMLElement|null} Returns the suitable child element if found, or null if not found.
   */
  findSuitableDOMChild(e) {
    function t(s) {
      if (e.getIsFocusable(s) && e.getIsAvailableToBeFocused(s))
        return s;
      for (let r = 0; r < s.children.length; r++) {
        const n = s.children[r], a = t(n);
        if (a)
          return a;
      }
      return null;
    }
    return e.el() ? t(e.el()) : null;
  }
  /**
   * Gets the currently focused component from the list of focusable components.
   * If a target element is provided, it uses that element to find the corresponding
   * component. If no target is provided, it defaults to using the document's currently
   * active element.
   *
   * @param {HTMLElement} [target] - The DOM element to check against the focusable components.
   *                                 If not provided, `document.activeElement` is used.
   * @return {Component|null} - Returns the focused component if found among the focusable components,
   *                            otherwise returns null if no matching component is found.
   */
  getCurrentComponent(e) {
    this.updateFocusableComponents();
    const t = e || document.activeElement;
    if (this.focusableComponents.length) {
      for (const s of this.focusableComponents)
        if (s.el() === t)
          return s;
    }
  }
  /**
   * Adds a component to the array of focusable components.
   *
   * @param {Component} component
   *        The `Component` to be added.
   */
  add(e) {
    const t = [...this.focusableComponents];
    e.hasOwnProperty("el_") && e.getIsFocusable() && e.getIsAvailableToBeFocused(e.el()) && t.push(e), this.focusableComponents = t, this.trigger({
      type: "focusableComponentsChanged",
      focusableComponents: this.focusableComponents
    });
  }
  /**
   * Removes component from the array of focusable components.
   *
   * @param {Component} component - The component to be removed from the focusable components array.
   */
  remove(e) {
    for (let t = 0; t < this.focusableComponents.length; t++)
      if (this.focusableComponents[t].name() === e.name()) {
        this.focusableComponents.splice(t, 1), this.trigger({
          type: "focusableComponentsChanged",
          focusableComponents: this.focusableComponents
        });
        return;
      }
  }
  /**
   * Clears array of focusable components.
   */
  clear() {
    this.focusableComponents.length > 0 && (this.focusableComponents = [], this.trigger({
      type: "focusableComponentsChanged",
      focusableComponents: this.focusableComponents
    }));
  }
  /**
   * Navigates to the next focusable component based on the specified direction.
   *
   * @param {string} direction 'up', 'down', 'left', 'right'
   */
  move(e) {
    const t = this.getCurrentComponent();
    if (!t)
      return;
    const s = t.getPositions(), r = this.focusableComponents.filter((a) => a !== t && this.isInDirection_(s.boundingClientRect, a.getPositions().boundingClientRect, e)), n = this.findBestCandidate_(s.center, r, e);
    n ? this.focus(n) : this.trigger({
      type: "endOfFocusableComponents",
      direction: e,
      focusedComponent: t
    });
  }
  /**
   * Finds the best candidate on the current center position,
   * the list of candidates, and the specified navigation direction.
   *
   * @param {Object} currentCenter The center position of the current focused component element.
   * @param {Array} candidates An array of candidate components to receive focus.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {Object|null} The component that is the best candidate for receiving focus.
   */
  findBestCandidate_(e, t, s) {
    let r = 1 / 0, n = null;
    for (const a of t) {
      const o = a.getPositions().center, l = this.calculateDistance_(e, o, s);
      l < r && (r = l, n = a);
    }
    return n;
  }
  /**
   * Determines if a target rectangle is in the specified navigation direction
   * relative to a source rectangle.
   *
   * @param {Object} srcRect The bounding rectangle of the source element.
   * @param {Object} targetRect The bounding rectangle of the target element.
   * @param {string} direction The navigation direction ('up', 'down', 'left', 'right').
   * @return {boolean} True if the target is in the specified direction relative to the source.
   */
  isInDirection_(e, t, s) {
    switch (s) {
      case "right":
        return t.left >= e.right;
      case "left":
        return t.right <= e.left;
      case "down":
        return t.top >= e.bottom;
      case "up":
        return t.bottom <= e.top;
      default:
        return !1;
    }
  }
  /**
   * Focus the last focused component saved before blur on player.
   */
  refocusComponent() {
    if (this.lastFocusedComponent_) {
      this.player_.userActive() || this.player_.userActive(!0), this.updateFocusableComponents();
      for (let e = 0; e < this.focusableComponents.length; e++)
        if (this.focusableComponents[e].name() === this.lastFocusedComponent_.name()) {
          this.focus(this.focusableComponents[e]);
          return;
        }
    } else
      this.focus(this.updateFocusableComponents()[0]);
  }
  /**
   * Focuses on a given component.
   * If the component is available to be focused, it focuses on the component.
   * If not, it attempts to find a suitable DOM child within the component and focuses on it.
   *
   * @param {Component} component - The component to be focused.
   */
  focus(e) {
    typeof e == "object" && (e.getIsAvailableToBeFocused(e.el()) ? e.focus() : this.findSuitableDOMChild(e) && this.findSuitableDOMChild(e).focus());
  }
  /**
   * Calculates the distance between two points, adjusting the calculation based on
   * the specified navigation direction.
   *
   * @param {Object} center1 The center point of the first element.
   * @param {Object} center2 The center point of the second element.
   * @param {string} direction The direction of navigation ('up', 'down', 'left', 'right').
   * @return {number} The calculated distance between the two centers.
   */
  calculateDistance_(e, t, s) {
    const r = Math.abs(e.x - t.x), n = Math.abs(e.y - t.y);
    let a;
    switch (s) {
      case "right":
      case "left":
        a = r + n * 100;
        break;
      case "up":
        a = n * 2 + r * 0.5;
        break;
      case "down":
        a = n * 5 + r;
        break;
      default:
        a = r + n;
    }
    return a;
  }
  /**
   * This gets called by 'handlePlayerBlur_' if 'spatialNavigation' is enabled.
   * Searches for the first 'TextTrackSelect' inside of modal to focus.
   *
   * @private
   */
  searchForTrackSelect_() {
    const e = this;
    for (const t of e.updateFocusableComponents())
      if (t.constructor.name === "TextTrackSelect") {
        e.focus(t);
        break;
      }
  }
}
class bT extends M {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function that is run when this component is ready.
   */
  constructor(e, t, s) {
    const r = oe({
      createEl: !1
    }, t);
    if (super(e, r, s), !t.playerOptions.sources || t.playerOptions.sources.length === 0)
      for (let n = 0, a = t.playerOptions.techOrder; n < a.length; n++) {
        const o = _e(a[n]);
        let l = Y.getTech(o);
        if (o || (l = M.getComponent(o)), l && l.isSupported()) {
          e.loadTech_(o);
          break;
        }
      }
    else
      e.src(t.playerOptions.sources);
  }
}
M.registerComponent("MediaLoader", bT);
class $n extends M {
  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of component options.
   *
   * @param  {function} [options.clickHandler]
   *         The function to call when the button is clicked / activated
   *
   * @param  {string} [options.controlText]
   *         The text to set on the button
   *
   * @param  {string} [options.className]
   *         A class or space separated list of classes to add the component
   *
   */
  constructor(e, t) {
    super(e, t), this.options_.controlText && this.controlText(this.options_.controlText), this.handleMouseOver_ = (s) => this.handleMouseOver(s), this.handleMouseOut_ = (s) => this.handleMouseOut(s), this.handleClick_ = (s) => this.handleClick(s), this.handleKeyDown_ = (s) => this.handleKeyDown(s), this.emitTapEvents(), this.enable();
  }
  /**
   * Create the `ClickableComponent`s DOM element.
   *
   * @param {string} [tag=div]
   *        The element's node type.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e = "div", t = {}, s = {}) {
    t = Object.assign({
      className: this.buildCSSClass(),
      tabIndex: 0
    }, t), e === "button" && Q.error(`Creating a ClickableComponent with an HTML element of ${e} is not supported; use a Button instead.`), s = Object.assign({
      role: "button"
    }, s), this.tabIndex_ = t.tabIndex;
    const r = W(e, t, s);
    return this.player_.options_.experimentalSvgIcons || r.appendChild(W("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(r), r;
  }
  dispose() {
    this.controlTextEl_ = null, super.dispose();
  }
  /**
   * Create a control text element on this `ClickableComponent`
   *
   * @param {Element} [el]
   *        Parent element for the control text.
   *
   * @return {Element}
   *         The control text element that gets created.
   */
  createControlTextEl(e) {
    return this.controlTextEl_ = W("span", {
      className: "vjs-control-text"
    }, {
      // let the screen reader user know that the text of the element may change
      "aria-live": "polite"
    }), e && e.appendChild(this.controlTextEl_), this.controlText(this.controlText_, e), this.controlTextEl_;
  }
  /**
   * Get or set the localize text to use for the controls on the `ClickableComponent`.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */
  controlText(e, t = this.el()) {
    if (e === void 0)
      return this.controlText_ || "Need Text";
    const s = this.localize(e);
    this.controlText_ = e, Qt(this.controlTextEl_, s), !this.nonIconControl && !this.player_.options_.noUITitleAttributes && t.setAttribute("title", s);
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-control vjs-button ${super.buildCSSClass()}`;
  }
  /**
   * Enable this `ClickableComponent`
   */
  enable() {
    this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), typeof this.tabIndex_ < "u" && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_));
  }
  /**
   * Disable this `ClickableComponent`
   */
  disable() {
    this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), typeof this.tabIndex_ < "u" && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_);
  }
  /**
   * Handles language change in ClickableComponent for the player in components
   *
   *
   */
  handleLanguagechange() {
    this.controlText(this.controlText_);
  }
  /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `click` or `tap` event.
   *
   * @param {Event} event
   *        The `tap` or `click` event that caused this function to be called.
   *
   * @listens tap
   * @listens click
   * @abstract
   */
  handleClick(e) {
    this.options_.clickHandler && this.options_.clickHandler.call(this, arguments);
  }
  /**
   * Event handler that is called when a `ClickableComponent` receives a
   * `keydown` event.
   *
   * By default, if the key is Space or Enter, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === " " || e.key === "Enter" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
  }
}
M.registerComponent("ClickableComponent", $n);
class Ka extends $n {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should attach to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.update(), this.update_ = (s) => this.update(s), e.on("posterchange", this.update_);
  }
  /**
   * Clean up and dispose of the `PosterImage`.
   */
  dispose() {
    this.player().off("posterchange", this.update_), super.dispose();
  }
  /**
   * Create the `PosterImage`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    return W("div", {
      className: "vjs-poster"
    });
  }
  /**
   * Get or set the `PosterImage`'s crossOrigin option.
   *
   * @param {string|null} [value]
   *        The value to set the crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */
  crossOrigin(e) {
    if (typeof e > "u")
      return this.$("img") ? this.$("img").crossOrigin : this.player_.tech_ && this.player_.tech_.isReady_ ? this.player_.crossOrigin() : this.player_.options_.crossOrigin || this.player_.options_.crossorigin || null;
    if (e !== null && e !== "anonymous" && e !== "use-credentials") {
      this.player_.log.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
      return;
    }
    this.$("img") && (this.$("img").crossOrigin = e);
  }
  /**
   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
   *
   * @listens Player#posterchange
   *
   * @param {Event} [event]
   *        The `Player#posterchange` event that triggered this function.
   */
  update(e) {
    const t = this.player().poster();
    this.setSrc(t), t ? this.show() : this.hide();
  }
  /**
   * Set the source of the `PosterImage` depending on the display method. (Re)creates
   * the inner picture and img elementss when needed.
   *
   * @param {string} [url]
   *        The URL to the source for the `PosterImage`. If not specified or falsy,
   *        any source and ant inner picture/img are removed.
   */
  setSrc(e) {
    if (!e) {
      this.el_.textContent = "";
      return;
    }
    this.$("img") || this.el_.appendChild(W("picture", {
      className: "vjs-poster",
      // Don't want poster to be tabbable.
      tabIndex: -1
    }, {}, W("img", {
      loading: "lazy",
      crossOrigin: this.crossOrigin()
    }, {
      alt: ""
    }))), this.$("img").src = e;
  }
  /**
   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
   *
   * @listens tap
   * @listens click
   * @listens keydown
   *
   * @param {Event} event
   +        The `click`, `tap` or `keydown` event that caused this function to be called.
   */
  handleClick(e) {
    this.player_.controls() && (this.player_.tech(!0) && this.player_.tech(!0).focus(), this.player_.paused() ? _t(this.player_.play()) : this.player_.pause());
  }
}
Ka.prototype.crossorigin = Ka.prototype.crossOrigin;
M.registerComponent("PosterImage", Ka);
const st = "#222", nc = "#ccc", xT = {
  monospace: "monospace",
  sansSerif: "sans-serif",
  serif: "serif",
  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
  monospaceSerif: '"Courier New", monospace',
  proportionalSansSerif: "sans-serif",
  proportionalSerif: "serif",
  casual: '"Comic Sans MS", Impact, fantasy',
  script: '"Monotype Corsiva", cursive',
  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
function Ca(i, e) {
  let t;
  if (i.length === 4)
    t = i[1] + i[1] + i[2] + i[2] + i[3] + i[3];
  else if (i.length === 7)
    t = i.slice(1);
  else
    throw new Error("Invalid color code provided, " + i + "; must be formatted as e.g. #f0e or #f604e2.");
  return "rgba(" + parseInt(t.slice(0, 2), 16) + "," + parseInt(t.slice(2, 4), 16) + "," + parseInt(t.slice(4, 6), 16) + "," + e + ")";
}
function pt(i, e, t) {
  try {
    i.style[e] = t;
  } catch {
    return;
  }
}
function ac(i) {
  return i ? `${i}px` : "";
}
class ST extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when `TextTrackDisplay` is ready.
   */
  constructor(e, t, s) {
    super(e, t, s);
    const r = (a) => this.updateDisplay(a), n = (a) => {
      this.updateDisplayOverlay(), this.updateDisplay(a);
    };
    e.on("loadstart", (a) => this.toggleDisplay(a)), e.on("texttrackchange", r), e.on("loadedmetadata", (a) => {
      this.updateDisplayOverlay(), this.preselectTrack(a);
    }), e.ready(le(this, function() {
      if (e.tech_ && e.tech_.featuresNativeTextTracks) {
        this.hide();
        return;
      }
      e.on("fullscreenchange", n), e.on("playerresize", n);
      const a = S.screen.orientation || S, o = S.screen.orientation ? "change" : "orientationchange";
      a.addEventListener(o, n), e.on("dispose", () => a.removeEventListener(o, n));
      const l = this.options_.playerOptions.tracks || [];
      for (let h = 0; h < l.length; h++)
        this.player_.addRemoteTextTrack(l[h], !0);
      this.preselectTrack();
    }));
  }
  /**
  * Preselect a track following this precedence:
  * - matches the previously selected {@link TextTrack}'s language and kind
  * - matches the previously selected {@link TextTrack}'s language only
  * - is the first default captions track
  * - is the first default descriptions track
  *
  * @listens Player#loadstart
  */
  preselectTrack() {
    const e = {
      captions: 1,
      subtitles: 1
    }, t = this.player_.textTracks(), s = this.player_.cache_.selectedLanguage;
    let r, n, a;
    for (let o = 0; o < t.length; o++) {
      const l = t[o];
      s && s.enabled && s.language && s.language === l.language && l.kind in e ? l.kind === s.kind ? a = l : a || (a = l) : s && !s.enabled ? (a = null, r = null, n = null) : l.default && (l.kind === "descriptions" && !r ? r = l : l.kind in e && !n && (n = l));
    }
    a ? a.mode = "showing" : n ? n.mode = "showing" : r && (r.mode = "showing");
  }
  /**
   * Turn display of {@link TextTrack}'s from the current state into the other state.
   * There are only two states:
   * - 'shown'
   * - 'hidden'
   *
   * @listens Player#loadstart
   */
  toggleDisplay() {
    this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
  }
  /**
   * Create the {@link Component}'s DOM element.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-text-track-display"
    }, {
      translate: "yes",
      "aria-live": "off",
      "aria-atomic": "true"
    });
  }
  /**
   * Clear all displayed {@link TextTrack}s.
   */
  clearDisplay() {
    typeof S.WebVTT == "function" && S.WebVTT.processCues(S, [], this.el_);
  }
  /**
   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
   * a {@link Player#fullscreenchange} is fired.
   *
   * @listens Player#texttrackchange
   * @listens Player#fullscreenchange
   */
  updateDisplay() {
    const e = this.player_.textTracks(), t = this.options_.allowMultipleShowingTracks;
    if (this.clearDisplay(), t) {
      const a = [];
      for (let o = 0; o < e.length; ++o) {
        const l = e[o];
        l.mode === "showing" && a.push(l);
      }
      this.updateForTrack(a);
      return;
    }
    let s = null, r = null, n = e.length;
    for (; n--; ) {
      const a = e[n];
      a.mode === "showing" && (a.kind === "descriptions" ? s = a : r = a);
    }
    if (r ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(r)) : s && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(s)), !S.CSS.supports("inset", "10px")) {
      const a = this.el_, o = a.querySelectorAll(".vjs-text-track-cue"), l = this.player_.controlBar.el_.getBoundingClientRect().height, h = this.player_.el_.getBoundingClientRect().height;
      a.style = "", pt(a, "position", "relative"), pt(a, "height", h - l + "px"), pt(a, "top", "unset"), tn ? pt(a, "bottom", h + "px") : pt(a, "bottom", "0px"), o.length > 0 && o.forEach((m) => {
        if (m.style.inset) {
          const _ = m.style.inset.split(" ");
          _.length === 3 && Object.assign(m.style, {
            top: _[0],
            right: _[1],
            bottom: _[2],
            left: "unset"
          });
        }
      });
    }
  }
  /**
   * Updates the displayed TextTrack to be sure it overlays the video when a either
   * a {@link Player#texttrackchange} or a {@link Player#fullscreenchange} is fired.
   */
  updateDisplayOverlay() {
    if (!this.player_.videoHeight() || !S.CSS.supports("inset-inline: 10px"))
      return;
    const e = this.player_.currentWidth(), t = this.player_.currentHeight(), s = e / t, r = this.player_.videoWidth() / this.player_.videoHeight();
    let n = 0, a = 0;
    Math.abs(s - r) > 0.1 && (s > r ? n = Math.round((e - t * r) / 2) : a = Math.round((t - e / r) / 2)), pt(this.el_, "insetInline", ac(n)), pt(this.el_, "insetBlock", ac(a));
  }
  /**
   * Style {@Link TextTrack} activeCues according to {@Link TextTrackSettings}.
   *
   * @param {TextTrack} track
   *        Text track object containing active cues to style.
   */
  updateDisplayState(e) {
    const t = this.player_.textTrackSettings.getValues(), s = e.activeCues;
    let r = s.length;
    for (; r--; ) {
      const n = s[r];
      if (!n)
        continue;
      const a = n.displayState;
      if (t.color && (a.firstChild.style.color = t.color), t.textOpacity && pt(a.firstChild, "color", Ca(t.color || "#fff", t.textOpacity)), t.backgroundColor && (a.firstChild.style.backgroundColor = t.backgroundColor), t.backgroundOpacity && pt(a.firstChild, "backgroundColor", Ca(t.backgroundColor || "#000", t.backgroundOpacity)), t.windowColor && (t.windowOpacity ? pt(a, "backgroundColor", Ca(t.windowColor, t.windowOpacity)) : a.style.backgroundColor = t.windowColor), t.edgeStyle && (t.edgeStyle === "dropshadow" ? a.firstChild.style.textShadow = `2px 2px 3px ${st}, 2px 2px 4px ${st}, 2px 2px 5px ${st}` : t.edgeStyle === "raised" ? a.firstChild.style.textShadow = `1px 1px ${st}, 2px 2px ${st}, 3px 3px ${st}` : t.edgeStyle === "depressed" ? a.firstChild.style.textShadow = `1px 1px ${nc}, 0 1px ${nc}, -1px -1px ${st}, 0 -1px ${st}` : t.edgeStyle === "uniform" && (a.firstChild.style.textShadow = `0 0 4px ${st}, 0 0 4px ${st}, 0 0 4px ${st}, 0 0 4px ${st}`)), t.fontPercent && t.fontPercent !== 1) {
        const o = S.parseFloat(a.style.fontSize);
        a.style.fontSize = o * t.fontPercent + "px", a.style.height = "auto", a.style.top = "auto";
      }
      t.fontFamily && t.fontFamily !== "default" && (t.fontFamily === "small-caps" ? a.firstChild.style.fontVariant = "small-caps" : a.firstChild.style.fontFamily = xT[t.fontFamily]);
    }
  }
  /**
   * Add an {@link TextTrack} to to the {@link Tech}s {@link TextTrackList}.
   *
   * @param {TextTrack|TextTrack[]} tracks
   *        Text track object or text track array to be added to the list.
   */
  updateForTrack(e) {
    if (Array.isArray(e) || (e = [e]), typeof S.WebVTT != "function" || e.every((s) => !s.activeCues))
      return;
    const t = [];
    for (let s = 0; s < e.length; ++s) {
      const r = e[s];
      for (let n = 0; n < r.activeCues.length; ++n)
        t.push(r.activeCues[n]);
    }
    S.WebVTT.processCues(S, t, this.el_);
    for (let s = 0; s < e.length; ++s) {
      const r = e[s];
      for (let n = 0; n < r.activeCues.length; ++n) {
        const a = r.activeCues[n].displayState;
        fi(a, "vjs-text-track-cue", "vjs-text-track-cue-" + (r.language ? r.language : s)), r.language && Yi(a, "lang", r.language);
      }
      this.player_.textTrackSettings && this.updateDisplayState(r);
    }
  }
}
M.registerComponent("TextTrackDisplay", ST);
class ET extends M {
  /**
   * Create the `LoadingSpinner`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */
  createEl() {
    const e = this.player_.isAudio(), t = this.localize(e ? "Audio Player" : "Video Player"), s = W("span", {
      className: "vjs-control-text",
      textContent: this.localize("{1} is loading.", [t])
    }), r = super.createEl("div", {
      className: "vjs-loading-spinner",
      dir: "ltr"
    });
    return r.appendChild(s), r;
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-control-text").textContent = this.localize("{1} is loading.", [this.player_.isAudio() ? "Audio Player" : "Video Player"]);
  }
}
M.registerComponent("LoadingSpinner", ET);
class Oe extends $n {
  /**
   * Create the `Button`s DOM element.
   *
   * @param {string} [tag="button"]
   *        The element's node type. This argument is IGNORED: no matter what
   *        is passed, it will always create a `button` element.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element.
   *
   * @param {Object} [attributes={}]
   *        An object of attributes that should be set on the element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, t = {}, s = {}) {
    e = "button", t = Object.assign({
      className: this.buildCSSClass()
    }, t), s = Object.assign({
      // Necessary since the default button type is "submit"
      type: "button"
    }, s);
    const r = W(e, t, s);
    return this.player_.options_.experimentalSvgIcons || r.appendChild(W("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(r), r;
  }
  /**
   * Add a child `Component` inside of this `Button`.
   *
   * @param {string|Component} child
   *        The name or instance of a child to add.
   *
   * @param {Object} [options={}]
   *        The key/value store of options that will get passed to children of
   *        the child.
   *
   * @return {Component}
   *         The `Component` that gets added as a child. When using a string the
   *         `Component` will get created by this process.
   *
   * @deprecated since version 5
   */
  addChild(e, t = {}) {
    const s = this.constructor.name;
    return Q.warn(`Adding an actionable (user controllable) child to a Button (${s}) is not supported; use a ClickableComponent instead.`), M.prototype.addChild.call(this, e, t);
  }
  /**
   * Enable the `Button` element so that it can be activated or clicked. Use this with
   * {@link Button#disable}.
   */
  enable() {
    super.enable(), this.el_.removeAttribute("disabled");
  }
  /**
   * Disable the `Button` element so that it cannot be activated or clicked. Use this with
   * {@link Button#enable}.
   */
  disable() {
    super.disable(), this.el_.setAttribute("disabled", "disabled");
  }
  /**
   * This gets called when a `Button` has focus and `keydown` is triggered via a key
   * press.
   *
   * @param {KeyboardEvent} event
   *        The event that caused this function to get called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    if (e.key === " " || e.key === "Enter") {
      e.stopPropagation();
      return;
    }
    super.handleKeyDown(e);
  }
}
M.registerComponent("Button", Oe);
class Ih extends Oe {
  constructor(e, t) {
    super(e, t), this.mouseused_ = !1, this.setIcon("play"), this.on("mousedown", (s) => this.handleMouseDown(s));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
   */
  buildCSSClass() {
    return "vjs-big-play-button";
  }
  /**
   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {KeyboardEvent|MouseEvent|TouchEvent} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const t = this.player_.play();
    if (this.mouseused_ && "clientX" in e && "clientY" in e) {
      _t(t), this.player_.tech(!0) && this.player_.tech(!0).focus();
      return;
    }
    const s = this.player_.getChild("controlBar"), r = s && s.getChild("playToggle");
    if (!r) {
      this.player_.tech(!0).focus();
      return;
    }
    const n = () => r.focus();
    Fs(t) ? t.then(n, () => {
    }) : this.setTimeout(n, 1);
  }
  /**
   * Event handler that is called when a `BigPlayButton` receives a
   * `keydown` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    this.mouseused_ = !1, super.handleKeyDown(e);
  }
  /**
   * Handle `mousedown` events on the `BigPlayButton`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    this.mouseused_ = !0;
  }
}
Ih.prototype.controlText_ = "Play Video";
M.registerComponent("BigPlayButton", Ih);
class CT extends Oe {
  /**
  * Creates an instance of the this class.
  *
  * @param  {Player} player
  *         The `Player` that this class should be attached to.
  *
  * @param  {Object} [options]
  *         The key/value store of player options.
  */
  constructor(e, t) {
    super(e, t), this.setIcon("cancel"), this.controlText(t && t.controlText || this.localize("Close"));
  }
  /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */
  buildCSSClass() {
    return `vjs-close-button ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when a `CloseButton` gets clicked. See
   * {@link ClickableComponent#handleClick} for more information on when
   * this will be triggered
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   * @fires CloseButton#close
   */
  handleClick(e) {
    this.trigger({
      type: "close",
      bubbles: !1
    });
  }
  /**
   * Event handler that is called when a `CloseButton` receives a
   * `keydown` event.
   *
   * By default, if the key is Esc, it will trigger a `click` event.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "Escape" ? (e.preventDefault(), e.stopPropagation(), this.trigger("click")) : super.handleKeyDown(e);
  }
}
M.registerComponent("CloseButton", CT);
class kh extends Oe {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, t = {}) {
    super(e, t), t.replay = t.replay === void 0 || t.replay, this.setIcon("play"), this.on(e, "play", (s) => this.handlePlay(s)), this.on(e, "pause", (s) => this.handlePause(s)), t.replay && this.on(e, "ended", (s) => this.handleEnded(s));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-play-control ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when an `PlayToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.paused() ? _t(this.player_.play()) : this.player_.pause();
  }
  /**
   * This gets called once after the video has ended and the user seeks so that
   * we can change the replay button back to a play button.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#seeked
   */
  handleSeeked(e) {
    this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(e) : this.handlePlay(e);
  }
  /**
   * Add the vjs-playing class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#play
   */
  handlePlay(e) {
    this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.setIcon("pause"), this.controlText("Pause");
  }
  /**
   * Add the vjs-paused class to the element so it can change appearance.
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#pause
   */
  handlePause(e) {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.setIcon("play"), this.controlText("Play");
  }
  /**
   * Add the vjs-ended class to the element so it can change appearance
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ended
   */
  handleEnded(e) {
    this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.setIcon("replay"), this.controlText("Replay"), this.one(this.player_, "seeked", (t) => this.handleSeeked(t));
  }
}
kh.prototype.controlText_ = "Play";
M.registerComponent("PlayToggle", kh);
class as extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.on(e, ["timeupdate", "ended", "seeking"], (s) => this.update(s)), this.updateTextNode_();
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = this.buildCSSClass(), t = super.createEl("div", {
      className: `${e} vjs-time-control vjs-control`
    }), s = W("span", {
      className: "vjs-control-text",
      textContent: `${this.localize(this.labelText_)} `
    }, {
      role: "presentation"
    });
    return t.appendChild(s), this.contentEl_ = W("span", {
      className: `${e}-display`
    }, {
      // span elements have no implicit role, but some screen readers (notably VoiceOver)
      // treat them as a break between items in the DOM when using arrow keys
      // (or left-to-right swipes on iOS) to read contents of a page. Using
      // role='presentation' causes VoiceOver to NOT treat this span as a break.
      role: "presentation"
    }), t.appendChild(this.contentEl_), t;
  }
  dispose() {
    this.contentEl_ = null, this.textNode_ = null, super.dispose();
  }
  /**
   * Updates the displayed time according to the `updateContent` function which is defined in the child class.
   *
   * @param {Event} [event]
   *          The `timeupdate`, `ended` or `seeking` (if enableSmoothSeeking is true) event that caused this function to be called.
   */
  update(e) {
    !this.player_.options_.enableSmoothSeeking && e.type === "seeking" || this.updateContent(e);
  }
  /**
   * Updates the time display text node with a new time
   *
   * @param {number} [time=0] the time to update to
   *
   * @private
   */
  updateTextNode_(e = 0) {
    e = yi(e), this.formattedTime_ !== e && (this.formattedTime_ = e, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", () => {
      if (!this.contentEl_)
        return;
      let t = this.textNode_;
      t && this.contentEl_.firstChild !== t && (t = null, Q.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), this.textNode_ = U.createTextNode(this.formattedTime_), this.textNode_ && (t ? this.contentEl_.replaceChild(this.textNode_, t) : this.contentEl_.appendChild(this.textNode_));
    }));
  }
  /**
   * To be filled out in the child class, should update the displayed time
   * in accordance with the fact that the current time has changed.
   *
   * @param {Event} [event]
   *        The `timeupdate`  event that caused this to run.
   *
   * @listens Player#timeupdate
   */
  updateContent(e) {
  }
}
as.prototype.labelText_ = "Time";
as.prototype.controlText_ = "Time";
M.registerComponent("TimeDisplay", as);
class Go extends as {
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-current-time";
  }
  /**
   * Update current time display
   *
   * @param {Event} [event]
   *        The `timeupdate` event that caused this function to run.
   *
   * @listens Player#timeupdate
   */
  updateContent(e) {
    let t;
    this.player_.ended() ? t = this.player_.duration() : t = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(t);
  }
}
Go.prototype.labelText_ = "Current Time";
Go.prototype.controlText_ = "Current Time";
M.registerComponent("CurrentTimeDisplay", Go);
class Wo extends as {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t);
    const s = (r) => this.updateContent(r);
    this.on(e, "durationchange", s), this.on(e, "loadstart", s), this.on(e, "loadedmetadata", s);
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-duration";
  }
  /**
   * Update duration time display.
   *
   * @param {Event} [event]
   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
   *        this function to be called.
   *
   * @listens Player#durationchange
   * @listens Player#timeupdate
   * @listens Player#loadedmetadata
   */
  updateContent(e) {
    const t = this.player_.duration();
    this.updateTextNode_(t);
  }
}
Wo.prototype.labelText_ = "Duration";
Wo.prototype.controlText_ = "Duration";
M.registerComponent("DurationDisplay", Wo);
class AT extends M {
  /**
   * Create the component's DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-time-control vjs-time-divider"
    }, {
      // this element and its contents can be hidden from assistive techs since
      // it is made extraneous by the announcement of the control text
      // for the current time and duration displays
      "aria-hidden": !0
    }), t = super.createEl("div"), s = super.createEl("span", {
      textContent: "/"
    });
    return t.appendChild(s), e.appendChild(t), e;
  }
}
M.registerComponent("TimeDivider", AT);
class Xo extends as {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.on(e, "durationchange", (s) => this.updateContent(s));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return "vjs-remaining-time";
  }
  /**
   * Create the `Component`'s DOM element with the "minus" character prepend to the time
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl();
    return this.options_.displayNegative !== !1 && e.insertBefore(W("span", {}, {
      "aria-hidden": !0
    }, "-"), this.contentEl_), e;
  }
  /**
   * Update remaining time display.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `durationchange` event that caused this to run.
   *
   * @listens Player#timeupdate
   * @listens Player#durationchange
   */
  updateContent(e) {
    if (typeof this.player_.duration() != "number")
      return;
    let t;
    this.player_.ended() ? t = 0 : this.player_.remainingTimeDisplay ? t = this.player_.remainingTimeDisplay() : t = this.player_.remainingTime(), this.updateTextNode_(t);
  }
}
Xo.prototype.labelText_ = "Remaining Time";
Xo.prototype.controlText_ = "Remaining Time";
M.registerComponent("RemainingTimeDisplay", Xo);
class DT extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.updateShowing(), this.on(this.player(), "durationchange", (s) => this.updateShowing(s));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-live-control vjs-control"
    });
    return this.contentEl_ = W("div", {
      className: "vjs-live-display"
    }, {
      "aria-live": "off"
    }), this.contentEl_.appendChild(W("span", {
      className: "vjs-control-text",
      textContent: `${this.localize("Stream Type")} `
    })), this.contentEl_.appendChild(U.createTextNode(this.localize("LIVE"))), e.appendChild(this.contentEl_), e;
  }
  dispose() {
    this.contentEl_ = null, super.dispose();
  }
  /**
   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
   * it accordingly
   *
   * @param {Event} [event]
   *        The {@link Player#durationchange} event that caused this function to run.
   *
   * @listens Player#durationchange
   */
  updateShowing(e) {
    this.player().duration() === 1 / 0 ? this.show() : this.hide();
  }
}
M.registerComponent("LiveDisplay", DT);
class Ph extends Oe {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.updateLiveEdgeStatus(), this.player_.liveTracker && (this.updateLiveEdgeStatusHandler_ = (s) => this.updateLiveEdgeStatus(s), this.on(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("button", {
      className: "vjs-seek-to-live-control vjs-control"
    });
    return this.setIcon("circle", e), this.textEl_ = W("span", {
      className: "vjs-seek-to-live-text",
      textContent: this.localize("LIVE")
    }, {
      "aria-hidden": "true"
    }), e.appendChild(this.textEl_), e;
  }
  /**
   * Update the state of this button if we are at the live edge
   * or not
   */
  updateLiveEdgeStatus() {
    !this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
  }
  /**
   * On click bring us as near to the live point as possible.
   * This requires that we wait for the next `live-seekable-change`
   * event which will happen every segment length seconds.
   */
  handleClick() {
    this.player_.liveTracker.seekToLiveEdge();
  }
  /**
   * Dispose of the element and stop tracking
   */
  dispose() {
    this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, super.dispose();
  }
}
Ph.prototype.controlText_ = "Seek to live, currently playing live";
M.registerComponent("SeekToLive", Ph);
function ir(i, e, t) {
  return i = Number(i), Math.min(t, Math.max(e, isNaN(i) ? e : i));
}
var wT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  clamp: ir
});
class Ko extends M {
  /**
  * Create an instance of this class
  *
  * @param {Player} player
  *        The `Player` that this class should be attached to.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  */
  constructor(e, t) {
    super(e, t), this.handleMouseDown_ = (s) => this.handleMouseDown(s), this.handleMouseUp_ = (s) => this.handleMouseUp(s), this.handleKeyDown_ = (s) => this.handleKeyDown(s), this.handleClick_ = (s) => this.handleClick(s), this.handleMouseMove_ = (s) => this.handleMouseMove(s), this.update_ = (s) => this.update(s), this.bar = this.getChild(this.options_.barName), this.vertical(!!this.options_.vertical), this.enable();
  }
  /**
   * Are controls are currently enabled for this slider or not.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */
  enabled() {
    return this.enabled_;
  }
  /**
   * Enable controls for this slider if they are disabled
   */
  enable() {
    this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
  }
  /**
   * Disable controls for this slider if they are enabled
   */
  disable() {
    if (!this.enabled())
      return;
    const e = this.bar.el_.ownerDocument;
    this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(e, "mousemove", this.handleMouseMove_), this.off(e, "mouseup", this.handleMouseUp_), this.off(e, "touchmove", this.handleMouseMove_), this.off(e, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
  }
  /**
   * Create the `Slider`s DOM element.
   *
   * @param {string} type
   *        Type of element to create.
   *
   * @param {Object} [props={}]
   *        List of properties in Object form.
   *
   * @param {Object} [attributes={}]
   *        list of attributes in Object form.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, t = {}, s = {}) {
    return t.className = t.className + " vjs-slider", t = Object.assign({
      tabIndex: 0
    }, t), s = Object.assign({
      role: "slider",
      "aria-valuenow": 0,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    }, s), super.createEl(e, t, s);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   * @fires Slider#slideractive
   */
  handleMouseDown(e) {
    const t = this.bar.el_.ownerDocument;
    e.type === "mousedown" && e.preventDefault(), e.type === "touchstart" && !Ct && e.preventDefault(), rh(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(t, "mousemove", this.handleMouseMove_), this.on(t, "mouseup", this.handleMouseUp_), this.on(t, "touchmove", this.handleMouseMove_), this.on(t, "touchend", this.handleMouseUp_), this.handleMouseMove(e, !0);
  }
  /**
   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
   * The `mousemove` and `touchmove` events will only only trigger this function during
   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
   * {@link Slider#handleMouseUp}.
   *
   * @param {MouseEvent} event
   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
   *        this function
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false.
   *
   * @listens mousemove
   * @listens touchmove
   */
  handleMouseMove(e) {
  }
  /**
   * Handle `mouseup` or `touchend` events on the `Slider`.
   *
   * @param {MouseEvent} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   * @fires Slider#sliderinactive
   */
  handleMouseUp(e) {
    const t = this.bar.el_.ownerDocument;
    nh(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(t, "mousemove", this.handleMouseMove_), this.off(t, "mouseup", this.handleMouseUp_), this.off(t, "touchmove", this.handleMouseMove_), this.off(t, "touchend", this.handleMouseUp_), this.update();
  }
  /**
   * Update the progress bar of the `Slider`.
   *
   * @return {number}
   *          The percentage of progress the progress bar represents as a
   *          number from 0 to 1.
   */
  update() {
    if (!this.el_ || !this.bar)
      return;
    const e = this.getProgress();
    return e === this.progress_ || (this.progress_ = e, this.requestNamedAnimationFrame("Slider#update", () => {
      const t = this.vertical() ? "height" : "width";
      this.bar.el().style[t] = (e * 100).toFixed(2) + "%";
    })), e;
  }
  /**
   * Get the percentage of the bar that should be filled
   * but clamped and rounded.
   *
   * @return {number}
   *         percentage filled that the slider is
   */
  getProgress() {
    return Number(ir(this.getPercent(), 0, 1).toFixed(4));
  }
  /**
   * Calculate distance for slider
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @return {number}
   *         The current position of the Slider.
   *         - position.x for vertical `Slider`s
   *         - position.y for horizontal `Slider`s
   */
  calculateDistance(e) {
    const t = Rn(this.el_, e);
    return this.vertical() ? t.y : t.x;
  }
  /**
   * Handle a `keydown` event on the `Slider`. Watches for left, right, up, and down
   * arrow keys. This function will only be called when the slider has focus. See
   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
   *
   * @param {KeyboardEvent} event
   *        the `keydown` event that caused this function to run.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const t = this.options_.playerOptions.spatialNavigation, s = t && t.enabled, r = t && t.horizontalSeek;
    s ? r && e.key === "ArrowLeft" || !r && e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : r && e.key === "ArrowRight" || !r && e.key === "ArrowUp" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : super.handleKeyDown(e) : e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepBack()) : e.key === "ArrowUp" || e.key === "ArrowRight" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : super.handleKeyDown(e);
  }
  /**
   * Listener for click events on slider, used to prevent clicks
   *   from bubbling up to parent elements like button menus.
   *
   * @param {Object} event
   *        Event that caused this object to run
   */
  handleClick(e) {
    e.stopPropagation(), e.preventDefault();
  }
  /**
   * Get/set if slider is horizontal for vertical
   *
   * @param {boolean} [bool]
   *        - true if slider is vertical,
   *        - false is horizontal
   *
   * @return {boolean}
   *         - true if slider is vertical, and getting
   *         - false if the slider is horizontal, and getting
   */
  vertical(e) {
    if (e === void 0)
      return this.vertical_ || !1;
    this.vertical_ = !!e, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
  }
}
M.registerComponent("Slider", Ko);
const Aa = (i, e) => ir(i / e * 100, 0, 100).toFixed(2) + "%";
class IT extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.partEls_ = [], this.on(e, "progress", (s) => this.update(s));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-load-progress"
    }), t = W("span", {
      className: "vjs-control-text"
    }), s = W("span", {
      textContent: this.localize("Loaded")
    }), r = U.createTextNode(": ");
    return this.percentageEl_ = W("span", {
      className: "vjs-control-text-loaded-percentage",
      textContent: "0%"
    }), e.appendChild(t), t.appendChild(s), t.appendChild(r), t.appendChild(this.percentageEl_), e;
  }
  dispose() {
    this.partEls_ = null, this.percentageEl_ = null, super.dispose();
  }
  /**
   * Update progress bar
   *
   * @param {Event} [event]
   *        The `progress` event that caused this function to run.
   *
   * @listens Player#progress
   */
  update(e) {
    this.requestNamedAnimationFrame("LoadProgressBar#update", () => {
      const t = this.player_.liveTracker, s = this.player_.buffered(), r = t && t.isLive() ? t.seekableEnd() : this.player_.duration(), n = this.player_.bufferedEnd(), a = this.partEls_, o = Aa(n, r);
      this.percent_ !== o && (this.el_.style.width = o, Qt(this.percentageEl_, o), this.percent_ = o);
      for (let l = 0; l < s.length; l++) {
        const h = s.start(l), m = s.end(l);
        let _ = a[l];
        _ || (_ = this.el_.appendChild(W()), a[l] = _), !(_.dataset.start === h && _.dataset.end === m) && (_.dataset.start = h, _.dataset.end = m, _.style.left = Aa(h, n), _.style.width = Aa(m - h, n));
      }
      for (let l = a.length; l > s.length; l--)
        this.el_.removeChild(a[l - 1]);
      a.length = s.length;
    });
  }
}
M.registerComponent("LoadProgressBar", IT);
class kT extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.update = At(le(this, this.update), at);
  }
  /**
   * Create the time tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-time-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, t, s) {
    const r = Ws(this.el_), n = Qi(this.player_.el()), a = e.width * t;
    if (!n || !r)
      return;
    let o = e.left - n.left + a, l = e.width - a + (n.right - e.right);
    l || (l = e.width - a, o = a);
    let h = r.width / 2;
    o < h ? h += h - o : l < h && (h = l), h < 0 ? h = 0 : h > r.width && (h = r.width), h = Math.round(h), this.el_.style.right = `-${h}px`, this.write(s);
  }
  /**
   * Write the time to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted time for the tooltip.
   */
  write(e) {
    Qt(this.el_, e);
  }
  /**
   * Updates the position of the time tooltip relative to the `SeekBar`.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   *
   * @param {number} time
   *        The time to update the tooltip to, not used during live playback
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */
  updateTime(e, t, s, r) {
    this.requestNamedAnimationFrame("TimeTooltip#updateTime", () => {
      let n;
      const a = this.player_.duration();
      if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
        const o = this.player_.liveTracker.liveWindow(), l = o - t * o;
        n = (l < 1 ? "" : "-") + yi(l, o);
      } else
        n = yi(s, a);
      this.update(e, t, n), r && r();
    });
  }
}
M.registerComponent("TimeTooltip", kT);
class Yo extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.setIcon("circle"), this.update = At(le(this, this.update), at);
  }
  /**
   * Create the the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-play-progress vjs-slider-bar"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, t) {
    const s = this.getChild("timeTooltip");
    if (!s)
      return;
    const r = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
    s.updateTime(e, t, r);
  }
}
Yo.prototype.options_ = {
  children: []
};
!je && !Et && Yo.prototype.options_.children.push("timeTooltip");
M.registerComponent("PlayProgressBar", Yo);
class Oh extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.update = At(le(this, this.update), at);
  }
  /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-mouse-display"
    });
  }
  /**
   * Enqueues updates to its own DOM as well as the DOM of its
   * {@link TimeTooltip} child.
   *
   * @param {Object} seekBarRect
   *        The `ClientRect` for the {@link SeekBar} element.
   *
   * @param {number} seekBarPoint
   *        A number from 0 to 1, representing a horizontal reference point
   *        from the left edge of the {@link SeekBar}
   */
  update(e, t) {
    const s = t * this.player_.duration();
    this.getChild("timeTooltip").updateTime(e, t, s, () => {
      this.el_.style.left = `${e.width * t}px`;
    });
  }
}
Oh.prototype.options_ = {
  children: ["timeTooltip"]
};
M.registerComponent("MouseTimeDisplay", Oh);
const Mr = 5, oc = 12;
class Qo extends Ko {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.setEventHandlers_();
  }
  /**
   * Sets the event handlers
   *
   * @private
   */
  setEventHandlers_() {
    this.update_ = le(this, this.update), this.update = At(this.update_, at), this.on(this.player_, ["durationchange", "timeupdate"], this.update), this.on(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = (e) => this.enableInterval_(e), this.disableIntervalHandler_ = (e) => this.disableInterval_(e), this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in U && "visibilityState" in U && this.on(U, "visibilitychange", this.toggleVisibility_);
  }
  toggleVisibility_(e) {
    U.visibilityState === "hidden" ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(e)) : (!this.player_.ended() && !this.player_.paused() && this.enableInterval_(), this.update());
  }
  enableInterval_() {
    this.updateInterval || (this.updateInterval = this.setInterval(this.update, at));
  }
  disableInterval_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== "ended" || this.updateInterval && (this.clearInterval(this.updateInterval), this.updateInterval = null);
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-progress-holder"
    }, {
      "aria-label": this.localize("Progress Bar")
    });
  }
  /**
   * This function updates the play progress bar and accessibility
   * attributes to whatever is passed in.
   *
   * @param {Event} [event]
   *        The `timeupdate` or `ended` event that caused this to run.
   *
   * @listens Player#timeupdate
   *
   * @return {number}
   *          The current percent at a number from 0-1
   */
  update(e) {
    if (U.visibilityState === "hidden")
      return;
    const t = super.update();
    return this.requestNamedAnimationFrame("SeekBar#update", () => {
      const s = this.player_.ended() ? this.player_.duration() : this.getCurrentTime_(), r = this.player_.liveTracker;
      let n = this.player_.duration();
      r && r.isLive() && (n = this.player_.liveTracker.liveCurrentTime()), this.percent_ !== t && (this.el_.setAttribute("aria-valuenow", (t * 100).toFixed(2)), this.percent_ = t), (this.currentTime_ !== s || this.duration_ !== n) && (this.el_.setAttribute("aria-valuetext", this.localize("progress bar timing: currentTime={1} duration={2}", [yi(s, n), yi(n, n)], "{1} of {2}")), this.currentTime_ = s, this.duration_ = n), this.bar && this.bar.update(Qi(this.el()), this.getProgress());
    }), t;
  }
  /**
   * Prevent liveThreshold from causing seeks to seem like they
   * are not happening from a user perspective.
   *
   * @param {number} ct
   *        current time to seek to
   */
  userSeek_(e) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(e);
  }
  /**
   * Get the value of current time but allows for smooth scrubbing,
   * when player can't keep up.
   *
   * @return {number}
   *         The current time value to display
   *
   * @private
   */
  getCurrentTime_() {
    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
  }
  /**
   * Get the percentage of media played so far.
   *
   * @return {number}
   *         The percentage of media played so far (0 to 1).
   */
  getPercent() {
    const e = this.getCurrentTime_();
    let t;
    const s = this.player_.liveTracker;
    return s && s.isLive() ? (t = (e - s.seekableStart()) / s.liveWindow(), s.atLiveEdge() && (t = 1)) : t = e / this.player_.duration(), t;
  }
  /**
   * Handle mouse down on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    Xs(e) && (e.stopPropagation(), this.videoWasPlaying = !this.player_.paused(), this.player_.pause(), super.handleMouseDown(e));
  }
  /**
   * Handle mouse move on seek bar
   *
   * @param {MouseEvent} event
   *        The `mousemove` event that caused this to run.
   * @param {boolean} mouseDown this is a flag that should be set to true if `handleMouseMove` is called directly. It allows us to skip things that should not happen if coming from mouse down but should happen on regular mouse move handler. Defaults to false
   *
   * @listens mousemove
   */
  handleMouseMove(e, t = !1) {
    if (!Xs(e) || isNaN(this.player_.duration()))
      return;
    !t && !this.player_.scrubbing() && this.player_.scrubbing(!0);
    let s;
    const r = this.calculateDistance(e), n = this.player_.liveTracker;
    if (!n || !n.isLive())
      s = r * this.player_.duration(), s === this.player_.duration() && (s = s - 0.1);
    else {
      if (r >= 0.99) {
        n.seekToLiveEdge();
        return;
      }
      const a = n.seekableStart(), o = n.liveCurrentTime();
      if (s = a + r * n.liveWindow(), s >= o && (s = o), s <= a && (s = a + 0.1), s === 1 / 0)
        return;
    }
    this.userSeek_(s), this.player_.options_.enableSmoothSeeking && this.update();
  }
  enable() {
    super.enable();
    const e = this.getChild("mouseTimeDisplay");
    e && e.show();
  }
  disable() {
    super.disable();
    const e = this.getChild("mouseTimeDisplay");
    e && e.hide();
  }
  /**
   * Handle mouse up on seek bar
   *
   * @param {MouseEvent} event
   *        The `mouseup` event that caused this to run.
   *
   * @listens mouseup
   */
  handleMouseUp(e) {
    super.handleMouseUp(e), e && e.stopPropagation(), this.player_.scrubbing(!1), this.player_.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    }), this.videoWasPlaying ? _t(this.player_.play()) : this.update_();
  }
  /**
   * Move more quickly fast forward for keyboard-only users
   */
  stepForward() {
    this.userSeek_(this.player_.currentTime() + Mr);
  }
  /**
   * Move more quickly rewind for keyboard-only users
   */
  stepBack() {
    this.userSeek_(this.player_.currentTime() - Mr);
  }
  /**
   * Toggles the playback state of the player
   * This gets called when enter or space is used on the seekbar
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called
   *
   */
  handleAction(e) {
    this.player_.paused() ? this.player_.play() : this.player_.pause();
  }
  /**
   * Called when this SeekBar has focus and a key gets pressed down.
   * Supports the following keys:
   *
   *   Space or Enter key fire a click event
   *   Home key moves to start of the timeline
   *   End key moves to end of the timeline
   *   Digit "0" through "9" keys move to 0%, 10% ... 80%, 90% of the timeline
   *   PageDown key moves back a larger step than ArrowDown
   *   PageUp key moves forward a large step
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const t = this.player_.liveTracker;
    if (e.key === " " || e.key === "Enter")
      e.preventDefault(), e.stopPropagation(), this.handleAction(e);
    else if (e.key === "Home")
      e.preventDefault(), e.stopPropagation(), this.userSeek_(0);
    else if (e.key === "End")
      e.preventDefault(), e.stopPropagation(), t && t.isLive() ? this.userSeek_(t.liveCurrentTime()) : this.userSeek_(this.player_.duration());
    else if (/^[0-9]$/.test(e.key)) {
      e.preventDefault(), e.stopPropagation();
      const s = parseInt(e.key, 10) * 0.1;
      t && t.isLive() ? this.userSeek_(t.seekableStart() + t.liveWindow() * s) : this.userSeek_(this.player_.duration() * s);
    } else e.key === "PageDown" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() - Mr * oc)) : e.key === "PageUp" ? (e.preventDefault(), e.stopPropagation(), this.userSeek_(this.player_.currentTime() + Mr * oc)) : super.handleKeyDown(e);
  }
  dispose() {
    this.disableInterval_(), this.off(this.player_, ["durationchange", "timeupdate"], this.update), this.off(this.player_, ["ended"], this.update_), this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in U && "visibilityState" in U && this.off(U, "visibilitychange", this.toggleVisibility_), super.dispose();
  }
}
Qo.prototype.options_ = {
  children: ["loadProgressBar", "playProgressBar"],
  barName: "playProgressBar"
};
!je && !Et && Qo.prototype.options_.children.splice(1, 0, "mouseTimeDisplay");
M.registerComponent("SeekBar", Qo);
class Lh extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.handleMouseMove = At(le(this, this.handleMouseMove), at), this.throttledHandleMouseSeek = At(le(this, this.handleMouseSeek), at), this.handleMouseUpHandler_ = (s) => this.handleMouseUp(s), this.handleMouseDownHandler_ = (s) => this.handleMouseDown(s), this.enable();
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-progress-control vjs-control"
    });
  }
  /**
   * When the mouse moves over the `ProgressControl`, the pointer position
   * gets passed down to the `MouseTimeDisplay` component.
   *
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   */
  handleMouseMove(e) {
    const t = this.getChild("seekBar");
    if (!t)
      return;
    const s = t.getChild("playProgressBar"), r = t.getChild("mouseTimeDisplay");
    if (!s && !r)
      return;
    const n = t.el(), a = Ws(n);
    let o = Rn(n, e).x;
    o = ir(o, 0, 1), r && r.update(a, o), s && s.update(a, t.getProgress());
  }
  /**
   * A throttled version of the {@link ProgressControl#handleMouseSeek} listener.
   *
   * @method ProgressControl#throttledHandleMouseSeek
   * @param {Event} event
   *        The `mousemove` event that caused this function to run.
   *
   * @listen mousemove
   * @listen touchmove
   */
  /**
   * Handle `mousemove` or `touchmove` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousemove
   * @listens touchmove
   */
  handleMouseSeek(e) {
    const t = this.getChild("seekBar");
    t && t.handleMouseMove(e);
  }
  /**
   * Are controls are currently enabled for this progress control.
   *
   * @return {boolean}
   *         true if controls are enabled, false otherwise
   */
  enabled() {
    return this.enabled_;
  }
  /**
   * Disable all controls on the progress control and its children
   */
  disable() {
    if (this.children().forEach((e) => e.disable && e.disable()), !!this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, "mousemove", this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
      const e = this.getChild("seekBar");
      this.player_.scrubbing(!1), e.videoWasPlaying && _t(this.player_.play());
    }
  }
  /**
   * Enable all controls on the progress control and its children
   */
  enable() {
    this.children().forEach((e) => e.enable && e.enable()), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, "mousemove", this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
  }
  /**
   * Cleanup listeners after the user finishes interacting with the progress controls
   */
  removeListenersAddedOnMousedownAndTouchstart() {
    const e = this.el_.ownerDocument;
    this.off(e, "mousemove", this.throttledHandleMouseSeek), this.off(e, "touchmove", this.throttledHandleMouseSeek), this.off(e, "mouseup", this.handleMouseUpHandler_), this.off(e, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseDown(e) {
    const t = this.el_.ownerDocument, s = this.getChild("seekBar");
    s && s.handleMouseDown(e), this.on(t, "mousemove", this.throttledHandleMouseSeek), this.on(t, "touchmove", this.throttledHandleMouseSeek), this.on(t, "mouseup", this.handleMouseUpHandler_), this.on(t, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mouseup` or `touchend` events on the `ProgressControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */
  handleMouseUp(e) {
    const t = this.getChild("seekBar");
    t && t.handleMouseUp(e), this.removeListenersAddedOnMousedownAndTouchstart();
  }
}
Lh.prototype.options_ = {
  children: ["seekBar"]
};
M.registerComponent("ProgressControl", Lh);
class Rh extends Oe {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */
  constructor(e, t) {
    super(e, t), this.setIcon("picture-in-picture-enter"), this.on(e, ["enterpictureinpicture", "leavepictureinpicture"], (s) => this.handlePictureInPictureChange(s)), this.on(e, ["disablepictureinpicturechanged", "loadedmetadata"], (s) => this.handlePictureInPictureEnabledChange(s)), this.on(e, ["loadedmetadata", "audioonlymodechange", "audiopostermodechange"], () => this.handlePictureInPictureAudioModeChange()), this.disable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-picture-in-picture-control vjs-hidden ${super.buildCSSClass()}`;
  }
  /**
   * Displays or hides the button depending on the audio mode detection.
   * Exits picture-in-picture if it is enabled when switching to audio mode.
   */
  handlePictureInPictureAudioModeChange() {
    if (!(this.player_.currentType().substring(0, 5) === "audio" || this.player_.audioPosterMode() || this.player_.audioOnlyMode())) {
      this.show();
      return;
    }
    this.player_.isInPictureInPicture() && this.player_.exitPictureInPicture(), this.hide();
  }
  /**
   * Enables or disables button based on availability of a Picture-In-Picture mode.
   *
   * Enabled if
   * - `player.options().enableDocumentPictureInPicture` is true and
   *   window.documentPictureInPicture is available; or
   * - `player.disablePictureInPicture()` is false and
   *   element.requestPictureInPicture is available
   */
  handlePictureInPictureEnabledChange() {
    U.pictureInPictureEnabled && this.player_.disablePictureInPicture() === !1 || this.player_.options_.enableDocumentPictureInPicture && "documentPictureInPicture" in S ? this.enable() : this.disable();
  }
  /**
   * Handles enterpictureinpicture and leavepictureinpicture on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#enterpictureinpicture} or {@link Player#leavepictureinpicture} event that caused this function to be
   *        called.
   *
   * @listens Player#enterpictureinpicture
   * @listens Player#leavepictureinpicture
   */
  handlePictureInPictureChange(e) {
    this.player_.isInPictureInPicture() ? (this.setIcon("picture-in-picture-exit"), this.controlText("Exit Picture-in-Picture")) : (this.setIcon("picture-in-picture-enter"), this.controlText("Picture-in-Picture")), this.handlePictureInPictureEnabledChange();
  }
  /**
   * This gets called when an `PictureInPictureToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
  }
  /**
   * Show the `Component`s element if it is hidden by removing the
   * 'vjs-hidden' class name from it only in browsers that support the Picture-in-Picture API.
   */
  show() {
    typeof U.exitPictureInPicture == "function" && super.show();
  }
}
Rh.prototype.controlText_ = "Picture-in-Picture";
M.registerComponent("PictureInPictureToggle", Rh);
class Nh extends Oe {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.setIcon("fullscreen-enter"), this.on(e, "fullscreenchange", (s) => this.handleFullscreenChange(s)), U[e.fsApi_.fullscreenEnabled] === !1 && this.disable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-fullscreen-control ${super.buildCSSClass()}`;
  }
  /**
   * Handles fullscreenchange on the player and change control text accordingly.
   *
   * @param {Event} [event]
   *        The {@link Player#fullscreenchange} event that caused this function to be
   *        called.
   *
   * @listens Player#fullscreenchange
   */
  handleFullscreenChange(e) {
    this.player_.isFullscreen() ? (this.controlText("Exit Fullscreen"), this.setIcon("fullscreen-exit")) : (this.controlText("Fullscreen"), this.setIcon("fullscreen-enter"));
  }
  /**
   * This gets called when an `FullscreenToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
  }
}
Nh.prototype.controlText_ = "Fullscreen";
M.registerComponent("FullscreenToggle", Nh);
const PT = function(i, e) {
  e.tech_ && !e.tech_.featuresVolumeControl && i.addClass("vjs-hidden"), i.on(e, "loadstart", function() {
    e.tech_.featuresVolumeControl ? i.removeClass("vjs-hidden") : i.addClass("vjs-hidden");
  });
};
class OT extends M {
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl("div", {
      className: "vjs-volume-level"
    });
    return this.setIcon("circle", e), e.appendChild(super.createEl("span", {
      className: "vjs-control-text"
    })), e;
  }
}
M.registerComponent("VolumeLevel", OT);
class LT extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.update = At(le(this, this.update), at);
  }
  /**
   * Create the volume tooltip DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-volume-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Updates the position of the tooltip relative to the `VolumeBar` and
   * its content text.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */
  update(e, t, s, r) {
    if (!s) {
      const n = Qi(this.el_), a = Qi(this.player_.el()), o = e.width * t;
      if (!a || !n)
        return;
      const l = e.left - a.left + o, h = e.width - o + (a.right - e.right);
      let m = n.width / 2;
      l < m ? m += m - l : h < m && (m = h), m < 0 ? m = 0 : m > n.width && (m = n.width), this.el_.style.right = `-${m}px`;
    }
    this.write(`${r}%`);
  }
  /**
   * Write the volume to the tooltip DOM element.
   *
   * @param {string} content
   *        The formatted volume for the tooltip.
   */
  write(e) {
    Qt(this.el_, e);
  }
  /**
   * Updates the position of the volume tooltip relative to the `VolumeBar`.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   * @param {number} volume
   *        The volume level to update the tooltip to
   *
   * @param {Function} cb
   *        A function that will be called during the request animation frame
   *        for tooltips that need to do additional animations from the default
   */
  updateVolume(e, t, s, r, n) {
    this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", () => {
      this.update(e, t, s, r.toFixed(0)), n && n();
    });
  }
}
M.registerComponent("VolumeLevelTooltip", LT);
class Mh extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The {@link Player} that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.update = At(le(this, this.update), at);
  }
  /**
   * Create the DOM element for this class.
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-mouse-display"
    });
  }
  /**
   * Enquires updates to its own DOM as well as the DOM of its
   * {@link VolumeLevelTooltip} child.
   *
   * @param {Object} rangeBarRect
   *        The `ClientRect` for the {@link VolumeBar} element.
   *
   * @param {number} rangeBarPoint
   *        A number from 0 to 1, representing a horizontal/vertical reference point
   *        from the left edge of the {@link VolumeBar}
   *
   * @param {boolean} vertical
   *        Referees to the Volume control position
   *        in the control bar{@link VolumeControl}
   *
   */
  update(e, t, s) {
    const r = 100 * t;
    this.getChild("volumeLevelTooltip").updateVolume(e, t, s, r, () => {
      s ? this.el_.style.bottom = `${e.height * t}px` : this.el_.style.left = `${e.width * t}px`;
    });
  }
}
Mh.prototype.options_ = {
  children: ["volumeLevelTooltip"]
};
M.registerComponent("MouseVolumeLevelDisplay", Mh);
class qn extends Ko {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.on("slideractive", (s) => this.updateLastVolume_(s)), this.on(e, "volumechange", (s) => this.updateARIAAttributes(s)), e.ready(() => this.updateARIAAttributes());
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-volume-bar vjs-slider-bar"
    }, {
      "aria-label": this.localize("Volume Level"),
      "aria-live": "polite"
    });
  }
  /**
   * Handle mouse down on volume bar
   *
   * @param {Event} event
   *        The `mousedown` event that caused this to run.
   *
   * @listens mousedown
   */
  handleMouseDown(e) {
    Xs(e) && super.handleMouseDown(e);
  }
  /**
   * Handle movement events on the {@link VolumeMenuButton}.
   *
   * @param {Event} event
   *        The event that caused this function to run.
   *
   * @listens mousemove
   */
  handleMouseMove(e) {
    const t = this.getChild("mouseVolumeLevelDisplay");
    if (t) {
      const s = this.el(), r = Qi(s), n = this.vertical();
      let a = Rn(s, e);
      a = n ? a.y : a.x, a = ir(a, 0, 1), t.update(r, a, n);
    }
    Xs(e) && (this.checkMuted(), this.player_.volume(this.calculateDistance(e)));
  }
  /**
   * If the player is muted unmute it.
   */
  checkMuted() {
    this.player_.muted() && this.player_.muted(!1);
  }
  /**
   * Get percent of volume level
   *
   * @return {number}
   *         Volume level percent as a decimal number.
   */
  getPercent() {
    return this.player_.muted() ? 0 : this.player_.volume();
  }
  /**
   * Increase volume level for keyboard users
   */
  stepForward() {
    this.checkMuted(), this.player_.volume(this.player_.volume() + 0.1);
  }
  /**
   * Decrease volume level for keyboard users
   */
  stepBack() {
    this.checkMuted(), this.player_.volume(this.player_.volume() - 0.1);
  }
  /**
   * Update ARIA accessibility attributes
   *
   * @param {Event} [event]
   *        The `volumechange` event that caused this function to run.
   *
   * @listens Player#volumechange
   */
  updateARIAAttributes(e) {
    const t = this.player_.muted() ? 0 : this.volumeAsPercentage_();
    this.el_.setAttribute("aria-valuenow", t), this.el_.setAttribute("aria-valuetext", t + "%");
  }
  /**
   * Returns the current value of the player volume as a percentage
   *
   * @private
   */
  volumeAsPercentage_() {
    return Math.round(this.player_.volume() * 100);
  }
  /**
   * When user starts dragging the VolumeBar, store the volume and listen for
   * the end of the drag. When the drag ends, if the volume was set to zero,
   * set lastVolume to the stored volume.
   *
   * @listens slideractive
   * @private
   */
  updateLastVolume_() {
    const e = this.player_.volume();
    this.one("sliderinactive", () => {
      this.player_.volume() === 0 && this.player_.lastVolume_(e);
    });
  }
}
qn.prototype.options_ = {
  children: ["volumeLevel"],
  barName: "volumeLevel"
};
!je && !Et && qn.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay");
qn.prototype.playerEvent = "volumechange";
M.registerComponent("VolumeBar", qn);
class Bh extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, t = {}) {
    t.vertical = t.vertical || !1, (typeof t.volumeBar > "u" || Ki(t.volumeBar)) && (t.volumeBar = t.volumeBar || {}, t.volumeBar.vertical = t.vertical), super(e, t), PT(this, e), this.throttledHandleMouseMove = At(le(this, this.handleMouseMove), at), this.handleMouseUpHandler_ = (s) => this.handleMouseUp(s), this.on("mousedown", (s) => this.handleMouseDown(s)), this.on("touchstart", (s) => this.handleMouseDown(s)), this.on("mousemove", (s) => this.handleMouseMove(s)), this.on(this.volumeBar, ["focus", "slideractive"], () => {
      this.volumeBar.addClass("vjs-slider-active"), this.addClass("vjs-slider-active"), this.trigger("slideractive");
    }), this.on(this.volumeBar, ["blur", "sliderinactive"], () => {
      this.volumeBar.removeClass("vjs-slider-active"), this.removeClass("vjs-slider-active"), this.trigger("sliderinactive");
    });
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    let e = "vjs-volume-horizontal";
    return this.options_.vertical && (e = "vjs-volume-vertical"), super.createEl("div", {
      className: `vjs-volume-control vjs-control ${e}`
    });
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseDown(e) {
    const t = this.el_.ownerDocument;
    this.on(t, "mousemove", this.throttledHandleMouseMove), this.on(t, "touchmove", this.throttledHandleMouseMove), this.on(t, "mouseup", this.handleMouseUpHandler_), this.on(t, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mouseup` or `touchend` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mouseup` or `touchend` event that triggered this function.
   *
   * @listens touchend
   * @listens mouseup
   */
  handleMouseUp(e) {
    const t = this.el_.ownerDocument;
    this.off(t, "mousemove", this.throttledHandleMouseMove), this.off(t, "touchmove", this.throttledHandleMouseMove), this.off(t, "mouseup", this.handleMouseUpHandler_), this.off(t, "touchend", this.handleMouseUpHandler_);
  }
  /**
   * Handle `mousedown` or `touchstart` events on the `VolumeControl`.
   *
   * @param {Event} event
   *        `mousedown` or `touchstart` event that triggered this function
   *
   * @listens mousedown
   * @listens touchstart
   */
  handleMouseMove(e) {
    this.volumeBar.handleMouseMove(e);
  }
}
Bh.prototype.options_ = {
  children: ["volumeBar"]
};
M.registerComponent("VolumeControl", Bh);
const RT = function(i, e) {
  e.tech_ && !e.tech_.featuresMuteControl && i.addClass("vjs-hidden"), i.on(e, "loadstart", function() {
    e.tech_.featuresMuteControl ? i.removeClass("vjs-hidden") : i.addClass("vjs-hidden");
  });
};
class Fh extends Oe {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), RT(this, e), this.on(e, ["loadstart", "volumechange"], (s) => this.update(s));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-mute-control ${super.buildCSSClass()}`;
  }
  /**
   * This gets called when an `MuteToggle` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const t = this.player_.volume(), s = this.player_.lastVolume_();
    if (t === 0) {
      const r = s < 0.1 ? 0.1 : s;
      this.player_.volume(r), this.player_.muted(!1);
    } else
      this.player_.muted(!this.player_.muted());
  }
  /**
   * Update the `MuteToggle` button based on the state of `volume` and `muted`
   * on the player.
   *
   * @param {Event} [event]
   *        The {@link Player#loadstart} event if this function was called
   *        through an event.
   *
   * @listens Player#loadstart
   * @listens Player#volumechange
   */
  update(e) {
    this.updateIcon_(), this.updateControlText_();
  }
  /**
   * Update the appearance of the `MuteToggle` icon.
   *
   * Possible states (given `level` variable below):
   * - 0: crossed out
   * - 1: zero bars of volume
   * - 2: one bar of volume
   * - 3: two bars of volume
   *
   * @private
   */
  updateIcon_() {
    const e = this.player_.volume();
    let t = 3;
    this.setIcon("volume-high"), je && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), e === 0 || this.player_.muted() ? (this.setIcon("volume-mute"), t = 0) : e < 0.33 ? (this.setIcon("volume-low"), t = 1) : e < 0.67 && (this.setIcon("volume-medium"), t = 2), On(this.el_, [0, 1, 2, 3].reduce((s, r) => s + `${r ? " " : ""}vjs-vol-${r}`, "")), fi(this.el_, `vjs-vol-${t}`);
  }
  /**
   * If `muted` has changed on the player, update the control text
   * (`title` attribute on `vjs-mute-control` element and content of
   * `vjs-control-text` element).
   *
   * @private
   */
  updateControlText_() {
    const t = this.player_.muted() || this.player_.volume() === 0 ? "Unmute" : "Mute";
    this.controlText() !== t && this.controlText(t);
  }
}
Fh.prototype.controlText_ = "Mute";
M.registerComponent("MuteToggle", Fh);
class Uh extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, t = {}) {
    typeof t.inline < "u" ? t.inline = t.inline : t.inline = !0, (typeof t.volumeControl > "u" || Ki(t.volumeControl)) && (t.volumeControl = t.volumeControl || {}, t.volumeControl.vertical = !t.inline), super(e, t), this.handleKeyPressHandler_ = (s) => this.handleKeyPress(s), this.on(e, ["loadstart"], (s) => this.volumePanelState_(s)), this.on(this.muteToggle, "keyup", (s) => this.handleKeyPress(s)), this.on(this.volumeControl, "keyup", (s) => this.handleVolumeControlKeyUp(s)), this.on("keydown", (s) => this.handleKeyPress(s)), this.on("mouseover", (s) => this.handleMouseOver(s)), this.on("mouseout", (s) => this.handleMouseOut(s)), this.on(this.volumeControl, ["slideractive"], this.sliderActive_), this.on(this.volumeControl, ["sliderinactive"], this.sliderInactive_);
  }
  /**
   * Add vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#slideractive
   * @private
   */
  sliderActive_() {
    this.addClass("vjs-slider-active");
  }
  /**
   * Removes vjs-slider-active class to the VolumePanel
   *
   * @listens VolumeControl#sliderinactive
   * @private
   */
  sliderInactive_() {
    this.removeClass("vjs-slider-active");
  }
  /**
   * Adds vjs-hidden or vjs-mute-toggle-only to the VolumePanel
   * depending on MuteToggle and VolumeControl state
   *
   * @listens Player#loadstart
   * @private
   */
  volumePanelState_() {
    this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    let e = "vjs-volume-panel-horizontal";
    return this.options_.inline || (e = "vjs-volume-panel-vertical"), super.createEl("div", {
      className: `vjs-volume-panel vjs-control ${e}`
    });
  }
  /**
   * Dispose of the `volume-panel` and all child components.
   */
  dispose() {
    this.handleMouseOut(), super.dispose();
  }
  /**
   * Handles `keyup` events on the `VolumeControl`, looking for ESC, which closes
   * the volume panel and sets focus on `MuteToggle`.
   *
   * @param {Event} event
   *        The `keyup` event that caused this function to be called.
   *
   * @listens keyup
   */
  handleVolumeControlKeyUp(e) {
    e.key === "Escape" && this.muteToggle.focus();
  }
  /**
   * This gets called when a `VolumePanel` gains hover via a `mouseover` event.
   * Turns on listening for `mouseover` event. When they happen it
   * calls `this.handleMouseOver`.
   *
   * @param {Event} event
   *        The `mouseover` event that caused this function to be called.
   *
   * @listens mouseover
   */
  handleMouseOver(e) {
    this.addClass("vjs-hover"), et(U, "keyup", this.handleKeyPressHandler_);
  }
  /**
   * This gets called when a `VolumePanel` gains hover via a `mouseout` event.
   * Turns on listening for `mouseout` event. When they happen it
   * calls `this.handleMouseOut`.
   *
   * @param {Event} event
   *        The `mouseout` event that caused this function to be called.
   *
   * @listens mouseout
   */
  handleMouseOut(e) {
    this.removeClass("vjs-hover"), Pe(U, "keyup", this.handleKeyPressHandler_);
  }
  /**
   * Handles `keyup` event on the document or `keydown` event on the `VolumePanel`,
   * looking for ESC, which hides the `VolumeControl`.
   *
   * @param {Event} event
   *        The keypress that triggered this event.
   *
   * @listens keydown | keyup
   */
  handleKeyPress(e) {
    e.key === "Escape" && this.handleMouseOut();
  }
}
Uh.prototype.options_ = {
  children: ["muteToggle", "volumeControl"]
};
M.registerComponent("VolumePanel", Uh);
class $h extends Oe {
  constructor(e, t) {
    super(e, t), this.validOptions = [5, 10, 30], this.skipTime = this.getSkipForwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`forward-${this.skipTime}`), this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
  }
  getSkipForwardTime() {
    const e = this.options_.playerOptions;
    return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.forward;
  }
  buildCSSClass() {
    return `vjs-skip-forward-${this.getSkipForwardTime()} ${super.buildCSSClass()}`;
  }
  /**
   * On click, skips forward in the duration/seekable range by a configurable amount of seconds.
   * If the time left in the duration/seekable range is less than the configured 'skip forward' time,
   * skips to end of duration/seekable range.
   *
   * Handle a click on a `SkipForward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */
  handleClick(e) {
    if (isNaN(this.player_.duration()))
      return;
    const t = this.player_.currentTime(), s = this.player_.liveTracker, r = s && s.isLive() ? s.seekableEnd() : this.player_.duration();
    let n;
    t + this.skipTime <= r ? n = t + this.skipTime : n = r, this.player_.currentTime(n);
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.controlText(this.localize("Skip forward {1} seconds", [this.skipTime]));
  }
}
$h.prototype.controlText_ = "Skip Forward";
M.registerComponent("SkipForward", $h);
class qh extends Oe {
  constructor(e, t) {
    super(e, t), this.validOptions = [5, 10, 30], this.skipTime = this.getSkipBackwardTime(), this.skipTime && this.validOptions.includes(this.skipTime) ? (this.setIcon(`replay-${this.skipTime}`), this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime.toLocaleString(e.language())])), this.show()) : this.hide();
  }
  getSkipBackwardTime() {
    const e = this.options_.playerOptions;
    return e.controlBar && e.controlBar.skipButtons && e.controlBar.skipButtons.backward;
  }
  buildCSSClass() {
    return `vjs-skip-backward-${this.getSkipBackwardTime()} ${super.buildCSSClass()}`;
  }
  /**
   * On click, skips backward in the video by a configurable amount of seconds.
   * If the current time in the video is less than the configured 'skip backward' time,
   * skips to beginning of video or seekable range.
   *
   * Handle a click on a `SkipBackward` button
   *
   * @param {EventTarget~Event} event
   *        The `click` event that caused this function
   *        to be called
   */
  handleClick(e) {
    const t = this.player_.currentTime(), s = this.player_.liveTracker, r = s && s.isLive() && s.seekableStart();
    let n;
    r && t - this.skipTime <= r ? n = r : t >= this.skipTime ? n = t - this.skipTime : n = 0, this.player_.currentTime(n);
  }
  /**
   * Update control text on languagechange
   */
  handleLanguagechange() {
    this.controlText(this.localize("Skip backward {1} seconds", [this.skipTime]));
  }
}
qh.prototype.controlText_ = "Skip Backward";
M.registerComponent("SkipBackward", qh);
class jh extends M {
  /**
   * Create an instance of this class.
   *
   * @param {Player} player
   *        the player that this component should attach to
   *
   * @param {Object} [options]
   *        Object of option names and values
   *
   */
  constructor(e, t) {
    super(e, t), t && (this.menuButton_ = t.menuButton), this.focusedChild_ = -1, this.on("keydown", (s) => this.handleKeyDown(s)), this.boundHandleBlur_ = (s) => this.handleBlur(s), this.boundHandleTapClick_ = (s) => this.handleTapClick(s);
  }
  /**
   * Add event listeners to the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to add listeners to.
   *
   */
  addEventListenerForItem(e) {
    e instanceof M && (this.on(e, "blur", this.boundHandleBlur_), this.on(e, ["tap", "click"], this.boundHandleTapClick_));
  }
  /**
   * Remove event listeners from the {@link MenuItem}.
   *
   * @param {Object} component
   *        The instance of the `MenuItem` to remove listeners.
   *
   */
  removeEventListenerForItem(e) {
    e instanceof M && (this.off(e, "blur", this.boundHandleBlur_), this.off(e, ["tap", "click"], this.boundHandleTapClick_));
  }
  /**
   * This method will be called indirectly when the component has been added
   * before the component adds to the new menu instance by `addItem`.
   * In this case, the original menu instance will remove the component
   * by calling `removeChild`.
   *
   * @param {Object} component
   *        The instance of the `MenuItem`
   */
  removeChild(e) {
    typeof e == "string" && (e = this.getChild(e)), this.removeEventListenerForItem(e), super.removeChild(e);
  }
  /**
   * Add a {@link MenuItem} to the menu.
   *
   * @param {Object|string} component
   *        The name or instance of the `MenuItem` to add.
   *
   */
  addItem(e) {
    const t = this.addChild(e);
    t && this.addEventListenerForItem(t);
  }
  /**
   * Create the `Menu`s DOM element.
   *
   * @return {Element}
   *         the element that was created
   */
  createEl() {
    const e = this.options_.contentElType || "ul";
    this.contentEl_ = W(e, {
      className: "vjs-menu-content"
    }), this.contentEl_.setAttribute("role", "menu");
    const t = super.createEl("div", {
      append: this.contentEl_,
      className: "vjs-menu"
    });
    return t.appendChild(this.contentEl_), et(t, "click", function(s) {
      s.preventDefault(), s.stopImmediatePropagation();
    }), t;
  }
  dispose() {
    this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, super.dispose();
  }
  /**
   * Called when a `MenuItem` loses focus.
   *
   * @param {Event} event
   *        The `blur` event that caused this function to be called.
   *
   * @listens blur
   */
  handleBlur(e) {
    const t = e.relatedTarget || U.activeElement;
    if (!this.children().some((s) => s.el() === t)) {
      const s = this.menuButton_;
      s && s.buttonPressed_ && t !== s.el().firstChild && s.unpressButton();
    }
  }
  /**
   * Called when a `MenuItem` gets clicked or tapped.
   *
   * @param {Event} event
   *        The `click` or `tap` event that caused this function to be called.
   *
   * @listens click,tap
   */
  handleTapClick(e) {
    if (this.menuButton_) {
      this.menuButton_.unpressButton();
      const t = this.children();
      if (!Array.isArray(t))
        return;
      const s = t.filter((r) => r.el() === e.target)[0];
      if (!s)
        return;
      s.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
    }
  }
  /**
   * Handle a `keydown` event on this menu. This listener is added in the constructor.
   *
   * @param {KeyboardEvent} event
   *        A `keydown` event that happened on the menu.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "ArrowLeft" || e.key === "ArrowDown" ? (e.preventDefault(), e.stopPropagation(), this.stepForward()) : (e.key === "ArrowRight" || e.key === "ArrowUp") && (e.preventDefault(), e.stopPropagation(), this.stepBack());
  }
  /**
   * Move to next (lower) menu item for keyboard users.
   */
  stepForward() {
    let e = 0;
    this.focusedChild_ !== void 0 && (e = this.focusedChild_ + 1), this.focus(e);
  }
  /**
   * Move to previous (higher) menu item for keyboard users.
   */
  stepBack() {
    let e = 0;
    this.focusedChild_ !== void 0 && (e = this.focusedChild_ - 1), this.focus(e);
  }
  /**
   * Set focus on a {@link MenuItem} in the `Menu`.
   *
   * @param {Object|string} [item=0]
   *        Index of child item set focus on.
   */
  focus(e = 0) {
    const t = this.children().slice();
    t.length && t[0].hasClass("vjs-menu-title") && t.shift(), t.length > 0 && (e < 0 ? e = 0 : e >= t.length && (e = t.length - 1), this.focusedChild_ = e, t[e].el_.focus());
  }
}
M.registerComponent("Menu", jh);
class Jo extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, t = {}) {
    super(e, t), this.menuButton_ = new Oe(e, t), this.menuButton_.controlText(this.controlText_), this.menuButton_.el_.setAttribute("aria-haspopup", "true");
    const s = Oe.prototype.buildCSSClass();
    this.menuButton_.el_.className = this.buildCSSClass() + " " + s, this.menuButton_.removeClass("vjs-control"), this.addChild(this.menuButton_), this.update(), this.enabled_ = !0;
    const r = (n) => this.handleClick(n);
    this.handleMenuKeyUp_ = (n) => this.handleMenuKeyUp(n), this.on(this.menuButton_, "tap", r), this.on(this.menuButton_, "click", r), this.on(this.menuButton_, "keydown", (n) => this.handleKeyDown(n)), this.on(this.menuButton_, "mouseenter", () => {
      this.addClass("vjs-hover"), this.menu.show(), et(U, "keyup", this.handleMenuKeyUp_);
    }), this.on("mouseleave", (n) => this.handleMouseLeave(n)), this.on("keydown", (n) => this.handleSubmenuKeyDown(n));
  }
  /**
   * Update the menu based on the current state of its items.
   */
  update() {
    const e = this.createMenu();
    this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = e, this.addChild(e), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? (this.hide(), this.menu.contentEl_.removeAttribute("role")) : (this.show(), this.menu.contentEl_.setAttribute("role", "menu"));
  }
  /**
   * Create the menu and add all items to it.
   *
   * @return {Menu}
   *         The constructed menu
   */
  createMenu() {
    const e = new jh(this.player_, {
      menuButton: this
    });
    if (this.hideThreshold_ = 0, this.options_.title) {
      const t = W("li", {
        className: "vjs-menu-title",
        textContent: _e(this.options_.title),
        tabIndex: -1
      }), s = new M(this.player_, {
        el: t
      });
      e.addItem(s);
    }
    if (this.items = this.createItems(), this.items)
      for (let t = 0; t < this.items.length; t++)
        e.addItem(this.items[t]);
    return e;
  }
  /**
   * Create the list of menu items. Specific to each subclass.
   *
   * @abstract
   */
  createItems() {
  }
  /**
   * Create the `MenuButtons`s DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildWrapperCSSClass()
    }, {});
  }
  /**
   * Overwrites the `setIcon` method from `Component`.
   * In this case, we want the icon to be appended to the menuButton.
   *
   * @param {string} name
   *         The icon name to be added.
   */
  setIcon(e) {
    super.setIcon(e, this.menuButton_.el_);
  }
  /**
   * Allow sub components to stack CSS class names for the wrapper element
   *
   * @return {string}
   *         The constructed wrapper DOM `className`
   */
  buildWrapperCSSClass() {
    let e = "vjs-menu-button";
    this.options_.inline === !0 ? e += "-inline" : e += "-popup";
    const t = Oe.prototype.buildCSSClass();
    return `vjs-menu-button ${e} ${t} ${super.buildCSSClass()}`;
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    let e = "vjs-menu-button";
    return this.options_.inline === !0 ? e += "-inline" : e += "-popup", `vjs-menu-button ${e} ${super.buildCSSClass()}`;
  }
  /**
   * Get or set the localized control text that will be used for accessibility.
   *
   * > NOTE: This will come from the internal `menuButton_` element.
   *
   * @param {string} [text]
   *        Control text for element.
   *
   * @param {Element} [el=this.menuButton_.el()]
   *        Element to set the title on.
   *
   * @return {string}
   *         - The control text when getting
   */
  controlText(e, t = this.menuButton_.el()) {
    return this.menuButton_.controlText(e, t);
  }
  /**
   * Dispose of the `menu-button` and all child components.
   */
  dispose() {
    this.handleMouseLeave(), super.dispose();
  }
  /**
   * Handle a click on a `MenuButton`.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.buttonPressed_ ? this.unpressButton() : this.pressButton();
  }
  /**
   * Handle `mouseleave` for `MenuButton`.
   *
   * @param {Event} event
   *        The `mouseleave` event that caused this function to be called.
   *
   * @listens mouseleave
   */
  handleMouseLeave(e) {
    this.removeClass("vjs-hover"), Pe(U, "keyup", this.handleMenuKeyUp_);
  }
  /**
   * Set the focus to the actual button, not to this element
   */
  focus() {
    this.menuButton_.focus();
  }
  /**
   * Remove the focus from the actual button, not this element
   */
  blur() {
    this.menuButton_.blur();
  }
  /**
   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    e.key === "Esc" || e.key === "Tab" ? (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus())) : (e.key === "Up" || e.key === "Down" && !(this.player_.options_.playerOptions.spatialNavigation && this.player_.options_.playerOptions.spatialNavigation.enabled)) && (this.buttonPressed_ || (e.preventDefault(), this.pressButton()));
  }
  /**
   * Handle a `keyup` event on a `MenuButton`. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keyup
   */
  handleMenuKeyUp(e) {
    (e.key === "Esc" || e.key === "Tab") && this.removeClass("vjs-hover");
  }
  /**
   * This method name now delegates to `handleSubmenuKeyDown`. This means
   * anyone calling `handleSubmenuKeyPress` will not see their method calls
   * stop working.
   *
   * @param {Event} event
   *        The event that caused this function to be called.
   */
  handleSubmenuKeyPress(e) {
    this.handleSubmenuKeyDown(e);
  }
  /**
   * Handle a `keydown` event on a sub-menu. The listener for this is added in
   * the constructor.
   *
   * @param {Event} event
   *        Key press event
   *
   * @listens keydown
   */
  handleSubmenuKeyDown(e) {
    (e.key === "Esc" || e.key === "Tab") && (this.buttonPressed_ && this.unpressButton(), !e.key === "Tab" && (e.preventDefault(), this.menuButton_.focus()));
  }
  /**
   * Put the current `MenuButton` into a pressed state.
   */
  pressButton() {
    if (this.enabled_) {
      if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), je && Zd())
        return;
      this.menu.focus();
    }
  }
  /**
   * Take the current `MenuButton` out of a pressed state.
   */
  unpressButton() {
    this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
  }
  /**
   * Disable the `MenuButton`. Don't allow it to be clicked.
   */
  disable() {
    this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
  }
  /**
   * Enable the `MenuButton`. Allow it to be clicked.
   */
  enable() {
    this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
  }
}
M.registerComponent("MenuButton", Jo);
class Zo extends Jo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    const s = t.tracks;
    if (super(e, t), this.items.length <= 1 && this.hide(), !s)
      return;
    const r = le(this, this.update);
    s.addEventListener("removetrack", r), s.addEventListener("addtrack", r), s.addEventListener("labelchange", r), this.player_.on("ready", r), this.player_.on("dispose", function() {
      s.removeEventListener("removetrack", r), s.removeEventListener("addtrack", r), s.removeEventListener("labelchange", r);
    });
  }
}
M.registerComponent("TrackButton", Zo);
class sr extends $n {
  /**
   * Creates an instance of the this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   *
   */
  constructor(e, t) {
    super(e, t), this.selectable = t.selectable, this.isSelected_ = t.selected || !1, this.multiSelectable = t.multiSelectable, this.selected(this.isSelected_), this.selectable ? this.multiSelectable ? this.el_.setAttribute("role", "menuitemcheckbox") : this.el_.setAttribute("role", "menuitemradio") : this.el_.setAttribute("role", "menuitem");
  }
  /**
   * Create the `MenuItem's DOM element
   *
   * @param {string} [type=li]
   *        Element's node type, not actually used, always set to `li`.
   *
   * @param {Object} [props={}]
   *        An object of properties that should be set on the element
   *
   * @param {Object} [attrs={}]
   *        An object of attributes that should be set on the element
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl(e, t, s) {
    this.nonIconControl = !0;
    const r = super.createEl("li", Object.assign({
      className: "vjs-menu-item",
      tabIndex: -1
    }, t), s), n = W("span", {
      className: "vjs-menu-item-text",
      textContent: this.localize(this.options_.label)
    });
    return this.player_.options_.experimentalSvgIcons ? r.appendChild(n) : r.replaceChild(n, r.querySelector(".vjs-icon-placeholder")), r;
  }
  /**
   * Ignore keys which are used by the menu, but pass any other ones up. See
   * {@link ClickableComponent#handleKeyDown} for instances where this is called.
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    ["Tab", "Escape", "ArrowUp", "ArrowLeft", "ArrowRight", "ArrowDown"].includes(e.key) || super.handleKeyDown(e);
  }
  /**
   * Any click on a `MenuItem` puts it into the selected state.
   * See {@link ClickableComponent#handleClick} for instances where this is called.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.selected(!0);
  }
  /**
   * Set the state for this menu item as selected or not.
   *
   * @param {boolean} selected
   *        if the menu item is selected or not
   */
  selected(e) {
    this.selectable && (e ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
  }
}
M.registerComponent("MenuItem", sr);
class rr extends sr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    const s = t.track, r = e.textTracks();
    t.label = s.label || s.language || "Unknown", t.selected = s.mode === "showing", super(e, t), this.track = s, this.kinds = (t.kinds || [t.kind || this.track.kind]).filter(Boolean);
    const n = (...o) => {
      this.handleTracksChange.apply(this, o);
    }, a = (...o) => {
      this.handleSelectedLanguageChange.apply(this, o);
    };
    if (e.on(["loadstart", "texttrackchange"], n), r.addEventListener("change", n), r.addEventListener("selectedlanguagechange", a), this.on("dispose", function() {
      e.off(["loadstart", "texttrackchange"], n), r.removeEventListener("change", n), r.removeEventListener("selectedlanguagechange", a);
    }), r.onchange === void 0) {
      let o;
      this.on(["tap", "click"], function() {
        if (typeof S.Event != "object")
          try {
            o = new S.Event("change");
          } catch {
          }
        o || (o = U.createEvent("Event"), o.initEvent("change", !0, !0)), r.dispatchEvent(o);
      });
    }
    this.handleTracksChange();
  }
  /**
   * This gets called when an `TextTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} event
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    const t = this.track, s = this.player_.textTracks();
    if (super.handleClick(e), !!s)
      for (let r = 0; r < s.length; r++) {
        const n = s[r];
        this.kinds.indexOf(n.kind) !== -1 && (n === t ? n.mode !== "showing" && (n.mode = "showing") : n.mode !== "disabled" && (n.mode = "disabled"));
      }
  }
  /**
   * Handle text track list change
   *
   * @param {Event} event
   *        The `change` event that caused this function to be called.
   *
   * @listens TextTrackList#change
   */
  handleTracksChange(e) {
    const t = this.track.mode === "showing";
    t !== this.isSelected_ && this.selected(t);
  }
  handleSelectedLanguageChange(e) {
    if (this.track.mode === "showing") {
      const t = this.player_.cache_.selectedLanguage;
      if (t && t.enabled && t.language === this.track.language && t.kind !== this.track.kind)
        return;
      this.player_.cache_.selectedLanguage = {
        enabled: !0,
        language: this.track.language,
        kind: this.track.kind
      };
    }
  }
  dispose() {
    this.track = null, super.dispose();
  }
}
M.registerComponent("TextTrackMenuItem", rr);
class Hh extends rr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    t.track = {
      player: e,
      // it is no longer necessary to store `kind` or `kinds` on the track itself
      // since they are now stored in the `kinds` property of all instances of
      // TextTrackMenuItem, but this will remain for backwards compatibility
      kind: t.kind,
      kinds: t.kinds,
      default: !1,
      mode: "disabled"
    }, t.kinds || (t.kinds = [t.kind]), t.label ? t.track.label = t.label : t.track.label = t.kinds.join(" and ") + " off", t.selectable = !0, t.multiSelectable = !1, super(e, t);
  }
  /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   */
  handleTracksChange(e) {
    const t = this.player().textTracks();
    let s = !0;
    for (let r = 0, n = t.length; r < n; r++) {
      const a = t[r];
      if (this.options_.kinds.indexOf(a.kind) > -1 && a.mode === "showing") {
        s = !1;
        break;
      }
    }
    s !== this.isSelected_ && this.selected(s);
  }
  handleSelectedLanguageChange(e) {
    const t = this.player().textTracks();
    let s = !0;
    for (let r = 0, n = t.length; r < n; r++) {
      const a = t[r];
      if (["captions", "descriptions", "subtitles"].indexOf(a.kind) > -1 && a.mode === "showing") {
        s = !1;
        break;
      }
    }
    s && (this.player_.cache_.selectedLanguage = {
      enabled: !1
    });
  }
  /**
   * Update control text and label on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.label), super.handleLanguagechange();
  }
}
M.registerComponent("OffTextTrackMenuItem", Hh);
class os extends Zo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, t = {}) {
    t.tracks = e.textTracks(), super(e, t);
  }
  /**
   * Create a menu item for each text track
   *
   * @param {TextTrackMenuItem[]} [items=[]]
   *        Existing array of items to use during creation
   *
   * @return {TextTrackMenuItem[]}
   *         Array of menu items that were created
   */
  createItems(e = [], t = rr) {
    let s;
    this.label_ && (s = `${this.label_} off`), e.push(new Hh(this.player_, {
      kinds: this.kinds_,
      kind: this.kind_,
      label: s
    })), this.hideThreshold_ += 1;
    const r = this.player_.textTracks();
    Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
    for (let n = 0; n < r.length; n++) {
      const a = r[n];
      if (this.kinds_.indexOf(a.kind) > -1) {
        const o = new t(this.player_, {
          track: a,
          kinds: this.kinds_,
          kind: this.kind_,
          // MenuItem is selectable
          selectable: !0,
          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
          multiSelectable: !1
        });
        o.addClass(`vjs-${a.kind}-menu-item`), e.push(o);
      }
    }
    return e;
  }
}
M.registerComponent("TextTrackButton", os);
class Vh extends sr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    const s = t.track, r = t.cue, n = e.currentTime();
    t.selectable = !0, t.multiSelectable = !1, t.label = r.text, t.selected = r.startTime <= n && n < r.endTime, super(e, t), this.track = s, this.cue = r;
  }
  /**
   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    super.handleClick(), this.player_.currentTime(this.cue.startTime);
  }
}
M.registerComponent("ChaptersTrackMenuItem", Vh);
class eu extends os {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this function is ready.
   */
  constructor(e, t, s) {
    super(e, t, s), this.setIcon("chapters"), this.selectCurrentItem_ = () => {
      this.items.forEach((r) => {
        r.selected(this.track_.activeCues[0] === r.cue);
      });
    };
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-chapters-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-chapters-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Update the menu based on the current state of its items.
   *
   * @param {Event} [event]
   *        An event that triggered this function to run.
   *
   * @listens TextTrackList#addtrack
   * @listens TextTrackList#removetrack
   * @listens TextTrackList#change
   */
  update(e) {
    if (e && e.track && e.track.kind !== "chapters")
      return;
    const t = this.findChaptersTrack();
    t !== this.track_ ? (this.setTrack(t), super.update()) : (!this.items || t && t.cues && t.cues.length !== this.items.length) && super.update();
  }
  /**
   * Set the currently selected track for the chapters button.
   *
   * @param {TextTrack} track
   *        The new track to select. Nothing will change if this is the currently selected
   *        track.
   */
  setTrack(e) {
    if (this.track_ !== e) {
      if (this.updateHandler_ || (this.updateHandler_ = this.update.bind(this)), this.track_) {
        const t = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        t && t.removeEventListener("load", this.updateHandler_), this.track_.removeEventListener("cuechange", this.selectCurrentItem_), this.track_ = null;
      }
      if (this.track_ = e, this.track_) {
        this.track_.mode = "hidden";
        const t = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        t && t.addEventListener("load", this.updateHandler_), this.track_.addEventListener("cuechange", this.selectCurrentItem_);
      }
    }
  }
  /**
   * Find the track object that is currently in use by this ChaptersButton
   *
   * @return {TextTrack|undefined}
   *         The current track or undefined if none was found.
   */
  findChaptersTrack() {
    const e = this.player_.textTracks() || [];
    for (let t = e.length - 1; t >= 0; t--) {
      const s = e[t];
      if (s.kind === this.kind_)
        return s;
    }
  }
  /**
   * Get the caption for the ChaptersButton based on the track label. This will also
   * use the current tracks localized kind as a fallback if a label does not exist.
   *
   * @return {string}
   *         The tracks current label or the localized track kind.
   */
  getMenuCaption() {
    return this.track_ && this.track_.label ? this.track_.label : this.localize(_e(this.kind_));
  }
  /**
   * Create menu from chapter track
   *
   * @return {Menu}
   *         New menu for the chapter buttons
   */
  createMenu() {
    return this.options_.title = this.getMenuCaption(), super.createMenu();
  }
  /**
   * Create a menu item for each text track
   *
   * @return  {TextTrackMenuItem[]}
   *         Array of menu items
   */
  createItems() {
    const e = [];
    if (!this.track_)
      return e;
    const t = this.track_.cues;
    if (!t)
      return e;
    for (let s = 0, r = t.length; s < r; s++) {
      const n = t[s], a = new Vh(this.player_, {
        track: this.track_,
        cue: n
      });
      e.push(a);
    }
    return e;
  }
}
eu.prototype.kind_ = "chapters";
eu.prototype.controlText_ = "Chapters";
M.registerComponent("ChaptersButton", eu);
class tu extends os {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, t, s) {
    super(e, t, s), this.setIcon("audio-description");
    const r = e.textTracks(), n = le(this, this.handleTracksChange);
    r.addEventListener("change", n), this.on("dispose", function() {
      r.removeEventListener("change", n);
    });
  }
  /**
   * Handle text track change
   *
   * @param {Event} event
   *        The event that caused this function to run
   *
   * @listens TextTrackList#change
   */
  handleTracksChange(e) {
    const t = this.player().textTracks();
    let s = !1;
    for (let r = 0, n = t.length; r < n; r++) {
      const a = t[r];
      if (a.kind !== this.kind_ && a.mode === "showing") {
        s = !0;
        break;
      }
    }
    s ? this.disable() : this.enable();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-descriptions-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-descriptions-button ${super.buildWrapperCSSClass()}`;
  }
}
tu.prototype.kind_ = "descriptions";
tu.prototype.controlText_ = "Descriptions";
M.registerComponent("DescriptionsButton", tu);
class iu extends os {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, t, s) {
    super(e, t, s), this.setIcon("subtitles");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-subtitles-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-subtitles-button ${super.buildWrapperCSSClass()}`;
  }
}
iu.prototype.kind_ = "subtitles";
iu.prototype.controlText_ = "Subtitles";
M.registerComponent("SubtitlesButton", iu);
class su extends rr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    t.track = {
      player: e,
      kind: t.kind,
      label: t.kind + " settings",
      selectable: !1,
      default: !1,
      mode: "disabled"
    }, t.selectable = !1, t.name = "CaptionSettingsMenuItem", super(e, t), this.addClass("vjs-texttrack-settings"), this.controlText(", opens " + t.kind + " settings dialog");
  }
  /**
   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    this.player().getChild("textTrackSettings").open();
  }
  /**
   * Update control text and label on languagechange
   */
  handleLanguagechange() {
    this.$(".vjs-menu-item-text").textContent = this.player_.localize(this.options_.kind + " settings"), super.handleLanguagechange();
  }
}
M.registerComponent("CaptionSettingsMenuItem", su);
class ru extends os {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, t, s) {
    super(e, t, s), this.setIcon("captions");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-captions-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-captions-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create caption menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */
  createItems() {
    const e = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new su(this.player_, {
      kind: this.kind_
    })), this.hideThreshold_ += 1), super.createItems(e);
  }
}
ru.prototype.kind_ = "captions";
ru.prototype.controlText_ = "Captions";
M.registerComponent("CaptionsButton", ru);
class zh extends rr {
  createEl(e, t, s) {
    const r = super.createEl(e, t, s), n = r.querySelector(".vjs-menu-item-text");
    return this.options_.track.kind === "captions" && (this.player_.options_.experimentalSvgIcons ? this.setIcon("captions", r) : n.appendChild(W("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), n.appendChild(W("span", {
      className: "vjs-control-text",
      // space added as the text will visually flow with the
      // label
      textContent: ` ${this.localize("Captions")}`
    }))), r;
  }
}
M.registerComponent("SubsCapsMenuItem", zh);
class nu extends os {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {Function} [ready]
   *        The function to call when this component is ready.
   */
  constructor(e, t = {}) {
    super(e, t), this.label_ = "subtitles", this.setIcon("subtitles"), ["en", "en-us", "en-ca", "fr-ca"].indexOf(this.player_.language_) > -1 && (this.label_ = "captions", this.setIcon("captions")), this.menuButton_.controlText(_e(this.label_));
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-subs-caps-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-subs-caps-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create caption/subtitles menu items
   *
   * @return {CaptionSettingsMenuItem[]}
   *         The array of current menu items.
   */
  createItems() {
    let e = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (e.push(new su(this.player_, {
      kind: this.label_
    })), this.hideThreshold_ += 1), e = super.createItems(e, zh), e;
  }
}
nu.prototype.kinds_ = ["captions", "subtitles"];
nu.prototype.controlText_ = "Subtitles";
M.registerComponent("SubsCapsButton", nu);
class Gh extends sr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    const s = t.track, r = e.audioTracks();
    t.label = s.label || s.language || "Unknown", t.selected = s.enabled, super(e, t), this.track = s, this.addClass(`vjs-${s.kind}-menu-item`);
    const n = (...a) => {
      this.handleTracksChange.apply(this, a);
    };
    r.addEventListener("change", n), this.on("dispose", () => {
      r.removeEventListener("change", n);
    });
  }
  createEl(e, t, s) {
    const r = super.createEl(e, t, s), n = r.querySelector(".vjs-menu-item-text");
    return ["main-desc", "descriptions"].indexOf(this.options_.track.kind) >= 0 && (n.appendChild(W("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), n.appendChild(W("span", {
      className: "vjs-control-text",
      textContent: " " + this.localize("Descriptions")
    }))), r;
  }
  /**
   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
   * for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    if (super.handleClick(e), this.track.enabled = !0, this.player_.tech_.featuresNativeAudioTracks) {
      const t = this.player_.audioTracks();
      for (let s = 0; s < t.length; s++) {
        const r = t[s];
        r !== this.track && (r.enabled = r === this.track);
      }
    }
  }
  /**
   * Handle any {@link AudioTrack} change.
   *
   * @param {Event} [event]
   *        The {@link AudioTrackList#change} event that caused this to run.
   *
   * @listens AudioTrackList#change
   */
  handleTracksChange(e) {
    this.selected(this.track.enabled);
  }
}
M.registerComponent("AudioTrackMenuItem", Gh);
class Wh extends Zo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options={}]
   *        The key/value store of player options.
   */
  constructor(e, t = {}) {
    t.tracks = e.audioTracks(), super(e, t), this.setIcon("audio");
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-audio-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-audio-button ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create a menu item for each audio track
   *
   * @param {AudioTrackMenuItem[]} [items=[]]
   *        An array of existing menu items to use.
   *
   * @return {AudioTrackMenuItem[]}
   *         An array of menu items
   */
  createItems(e = []) {
    this.hideThreshold_ = 1;
    const t = this.player_.audioTracks();
    for (let s = 0; s < t.length; s++) {
      const r = t[s];
      e.push(new Gh(this.player_, {
        track: r,
        // MenuItem is selectable
        selectable: !0,
        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
        multiSelectable: !1
      }));
    }
    return e;
  }
}
Wh.prototype.controlText_ = "Audio Track";
M.registerComponent("AudioTrackButton", Wh);
class au extends sr {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    const s = t.rate, r = parseFloat(s, 10);
    t.label = s, t.selected = r === e.playbackRate(), t.selectable = !0, t.multiSelectable = !1, super(e, t), this.label = s, this.rate = r, this.on(e, "ratechange", (n) => this.update(n));
  }
  /**
   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
   * {@link ClickableComponent} for more detailed information on what a click can be.
   *
   * @param {Event} [event]
   *        The `keydown`, `tap`, or `click` event that caused this function to be
   *        called.
   *
   * @listens tap
   * @listens click
   */
  handleClick(e) {
    super.handleClick(), this.player().playbackRate(this.rate);
  }
  /**
   * Update the PlaybackRateMenuItem when the playbackrate changes.
   *
   * @param {Event} [event]
   *        The `ratechange` event that caused this function to run.
   *
   * @listens Player#ratechange
   */
  update(e) {
    this.selected(this.player().playbackRate() === this.rate);
  }
}
au.prototype.contentElType = "button";
M.registerComponent("PlaybackRateMenuItem", au);
class Xh extends Jo {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.menuButton_.el_.setAttribute("aria-describedby", this.labelElId_), this.updateVisibility(), this.updateLabel(), this.on(e, "loadstart", (s) => this.updateVisibility(s)), this.on(e, "ratechange", (s) => this.updateLabel(s)), this.on(e, "playbackrateschange", (s) => this.handlePlaybackRateschange(s));
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    const e = super.createEl();
    return this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_, this.labelEl_ = W("div", {
      className: "vjs-playback-rate-value",
      id: this.labelElId_,
      textContent: "1x"
    }), e.appendChild(this.labelEl_), e;
  }
  dispose() {
    this.labelEl_ = null, super.dispose();
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-playback-rate ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-playback-rate ${super.buildWrapperCSSClass()}`;
  }
  /**
   * Create the list of menu items. Specific to each subclass.
   *
   */
  createItems() {
    const e = this.playbackRates(), t = [];
    for (let s = e.length - 1; s >= 0; s--)
      t.push(new au(this.player(), {
        rate: e[s] + "x"
      }));
    return t;
  }
  /**
   * On playbackrateschange, update the menu to account for the new items.
   *
   * @listens Player#playbackrateschange
   */
  handlePlaybackRateschange(e) {
    this.update();
  }
  /**
   * Get possible playback rates
   *
   * @return {Array}
   *         All possible playback rates
   */
  playbackRates() {
    const e = this.player();
    return e.playbackRates && e.playbackRates() || [];
  }
  /**
   * Get whether playback rates is supported by the tech
   * and an array of playback rates exists
   *
   * @return {boolean}
   *         Whether changing playback rate is supported
   */
  playbackRateSupported() {
    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
  }
  /**
   * Hide playback rate controls when they're no playback rate options to select
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#loadstart
   */
  updateVisibility(e) {
    this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
  }
  /**
   * Update button label when rate changed
   *
   * @param {Event} [event]
   *        The event that caused this function to run.
   *
   * @listens Player#ratechange
   */
  updateLabel(e) {
    this.playbackRateSupported() && (this.labelEl_.textContent = this.player().playbackRate() + "x");
  }
}
Xh.prototype.controlText_ = "Playback Rate";
M.registerComponent("PlaybackRateMenuButton", Xh);
class Kh extends M {
  /**
  * Builds the default DOM `className`.
  *
  * @return {string}
  *         The DOM `className` for this object.
  */
  buildCSSClass() {
    return `vjs-spacer ${super.buildCSSClass()}`;
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl(e = "div", t = {}, s = {}) {
    return t.className || (t.className = this.buildCSSClass()), super.createEl(e, t, s);
  }
}
M.registerComponent("Spacer", Kh);
class NT extends Kh {
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   */
  buildCSSClass() {
    return `vjs-custom-control-spacer ${super.buildCSSClass()}`;
  }
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: this.buildCSSClass(),
      // No-flex/table-cell mode requires there be some content
      // in the cell to fill the remaining space of the table.
      textContent: " "
    });
  }
}
M.registerComponent("CustomControlSpacer", NT);
class Yh extends M {
  /**
   * Create the `Component`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return super.createEl("div", {
      className: "vjs-control-bar",
      dir: "ltr"
    });
  }
}
Yh.prototype.options_ = {
  children: ["playToggle", "skipBackward", "skipForward", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "pictureInPictureToggle", "fullscreenToggle"]
};
M.registerComponent("ControlBar", Yh);
class Qh extends ns {
  /**
   * Creates an instance of this class.
   *
   * @param  {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param  {Object} [options]
   *         The key/value store of player options.
   */
  constructor(e, t) {
    super(e, t), this.on(e, "error", (s) => {
      this.open(s);
    });
  }
  /**
   * Builds the default DOM `className`.
   *
   * @return {string}
   *         The DOM `className` for this object.
   *
   * @deprecated Since version 5.
   */
  buildCSSClass() {
    return `vjs-error-display ${super.buildCSSClass()}`;
  }
  /**
   * Gets the localized error message based on the `Player`s error.
   *
   * @return {string}
   *         The `Player`s error message localized or an empty string.
   */
  content() {
    const e = this.player().error();
    return e ? this.localize(e.message) : "";
  }
}
Qh.prototype.options_ = Object.assign({}, ns.prototype.options_, {
  pauseOnOpen: !1,
  fillAlways: !0,
  temporary: !1,
  uncloseable: !0
});
M.registerComponent("ErrorDisplay", Qh);
class Jh extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements.
   */
  constructor(e, t = {}) {
    super(e, t), this.el_.setAttribute("aria-labelledby", this.selectLabelledbyIds);
  }
  /**
   * Create the `TextTrackSelect`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return this.selectLabelledbyIds = [this.options_.legendId, this.options_.labelId].join(" ").trim(), W("select", {
      id: this.options_.id
    }, {}, this.options_.SelectOptions.map((t) => {
      const s = (this.options_.labelId ? this.options_.labelId : `vjs-track-option-${nt()}`) + "-" + t[1].replace(/\W+/g, ""), r = W("option", {
        id: s,
        value: this.localize(t[0]),
        textContent: t[1]
      });
      return r.setAttribute("aria-labelledby", `${this.selectLabelledbyIds} ${s}`), r;
    }));
  }
}
M.registerComponent("TextTrackSelect", Jh);
class mi extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {string} [options.legendId]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.id]
   *        A text with part of an string to create atribute of aria-labelledby.
   *        It passes to 'TextTrackSelect'.
   *
   * @param {string} [options.legendText]
   *        A text to use as the text content of the legend element.
   *
   * @param {Array} [options.selects]
   *        Array that contains the selects that are use to create 'selects'
   *        components.
   *
   * @param {Array} [options.SelectOptions]
   *        Array that contains the value & textContent of for each of the
   *        options elements, it passes to 'TextTrackSelect'.
   *
   * @param {string} [options.type]
   *        Conditions if some DOM elements will be added to the fieldset
   *        component.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the selects configurations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        These properties are use to configure the 'TextTrackSelect' Component.
   */
  constructor(e, t = {}) {
    super(e, t);
    const s = W("legend", {
      textContent: this.localize(this.options_.legendText),
      id: this.options_.legendId
    });
    this.el().appendChild(s);
    const r = this.options_.selects;
    for (const n of r) {
      const a = this.options_.selectConfigs[n], o = a.className, l = a.id.replace("%s", this.options_.id_);
      let h = null;
      const m = `vjs_select_${nt()}`;
      if (this.options_.type === "colors") {
        h = W("span", {
          className: o
        });
        const v = W("label", {
          id: l,
          className: "vjs-label",
          textContent: a.label
        });
        v.setAttribute("for", m), h.appendChild(v);
      }
      const _ = new Jh(e, {
        SelectOptions: a.options,
        legendId: this.options_.legendId,
        id: m,
        labelId: l
      });
      this.addChild(_), this.options_.type === "colors" && (h.appendChild(_.el()), this.el().appendChild(h));
    }
  }
  /**
   * Create the `TextTrackFieldset`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return W("fieldset", {
      // Prefixing classes of elements within a player with "vjs-"
      // is a convention used in Video.js.
      className: this.options_.className
    });
  }
}
M.registerComponent("TextTrackFieldset", mi);
class Zh extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */
  constructor(e, t = {}) {
    super(e, t);
    const s = this.options_.textTrackComponentid, r = new mi(e, {
      id_: s,
      legendId: `captions-text-legend-${s}`,
      legendText: this.localize("Text"),
      className: "vjs-fg vjs-track-setting",
      selects: this.options_.fieldSets[0],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(r);
    const n = new mi(e, {
      id_: s,
      legendId: `captions-background-${s}`,
      legendText: this.localize("Text Background"),
      className: "vjs-bg vjs-track-setting",
      selects: this.options_.fieldSets[1],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(n);
    const a = new mi(e, {
      id_: s,
      legendId: `captions-window-${s}`,
      legendText: this.localize("Caption Area Background"),
      className: "vjs-window vjs-track-setting",
      selects: this.options_.fieldSets[2],
      selectConfigs: this.options_.selectConfigs,
      type: "colors"
    });
    this.addChild(a);
  }
  /**
   * Create the `TextTrackSettingsColors`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return W("div", {
      className: "vjs-track-settings-colors"
    });
  }
}
M.registerComponent("TextTrackSettingsColors", Zh);
class ef extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {ContentDescriptor} [options.content=undefined]
   *        Provide customized content for this modal.
   *
   * @param {Array} [options.fieldSets]
   *        Array that contains the configurations for the selects.
   *
   * @param {Object} [options.selectConfigs]
   *        Object with the following properties that are the select confugations:
   *        backgroundColor, backgroundOpacity, color, edgeStyle, fontFamily,
   *        fontPercent, textOpacity, windowColor, windowOpacity.
   *        it passes to 'TextTrackFieldset'.
   */
  constructor(e, t = {}) {
    super(e, t);
    const s = this.options_.textTrackComponentid, r = new mi(e, {
      id_: s,
      legendId: `captions-font-size-${s}`,
      legendText: "Font Size",
      className: "vjs-font-percent vjs-track-setting",
      selects: this.options_.fieldSets[0],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(r);
    const n = new mi(e, {
      id_: s,
      legendId: `captions-edge-style-${s}`,
      legendText: this.localize("Text Edge Style"),
      className: "vjs-edge-style vjs-track-setting",
      selects: this.options_.fieldSets[1],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(n);
    const a = new mi(e, {
      id_: s,
      legendId: `captions-font-family-${s}`,
      legendText: this.localize("Font Family"),
      className: "vjs-font-family vjs-track-setting",
      selects: this.options_.fieldSets[2],
      selectConfigs: this.options_.selectConfigs,
      type: "font"
    });
    this.addChild(a);
  }
  /**
   * Create the `TextTrackSettingsFont`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return W("div", {
      className: "vjs-track-settings-font"
    });
  }
}
M.registerComponent("TextTrackSettingsFont", ef);
class tf extends M {
  constructor(e, t = {}) {
    super(e, t);
    const s = this.localize("restore all settings to the default values"), r = new Oe(e, {
      controlText: s,
      className: "vjs-default-button"
    });
    r.el().classList.remove("vjs-control", "vjs-button"), r.el().textContent = this.localize("Reset"), this.addChild(r);
    const n = new Oe(e, {
      controlText: s,
      className: "vjs-done-button"
    });
    n.el().classList.remove("vjs-control", "vjs-button"), n.el().textContent = this.localize("Done"), this.addChild(n);
  }
  /**
   * Create the `TrackSettingsControls`'s DOM element
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    return W("div", {
      className: "vjs-track-settings-controls"
    });
  }
}
M.registerComponent("TrackSettingsControls", tf);
const Da = "vjs-text-track-settings", uc = ["#000", "Black"], lc = ["#00F", "Blue"], cc = ["#0FF", "Cyan"], dc = ["#0F0", "Green"], hc = ["#F0F", "Magenta"], fc = ["#F00", "Red"], pc = ["#FFF", "White"], mc = ["#FF0", "Yellow"], wa = ["1", "Opaque"], Ia = ["0.5", "Semi-Transparent"], gc = ["0", "Transparent"], Wt = {
  backgroundColor: {
    selector: ".vjs-bg-color > select",
    id: "captions-background-color-%s",
    label: "Color",
    options: [uc, pc, fc, dc, lc, mc, hc, cc],
    className: "vjs-bg-color"
  },
  backgroundOpacity: {
    selector: ".vjs-bg-opacity > select",
    id: "captions-background-opacity-%s",
    label: "Opacity",
    options: [wa, Ia, gc],
    className: "vjs-bg-opacity vjs-opacity"
  },
  color: {
    selector: ".vjs-text-color > select",
    id: "captions-foreground-color-%s",
    label: "Color",
    options: [pc, uc, fc, dc, lc, mc, hc, cc],
    className: "vjs-text-color"
  },
  edgeStyle: {
    selector: ".vjs-edge-style > select",
    id: "",
    label: "Text Edge Style",
    options: [["none", "None"], ["raised", "Raised"], ["depressed", "Depressed"], ["uniform", "Uniform"], ["dropshadow", "Drop shadow"]]
  },
  fontFamily: {
    selector: ".vjs-font-family > select",
    id: "",
    label: "Font Family",
    options: [["proportionalSansSerif", "Proportional Sans-Serif"], ["monospaceSansSerif", "Monospace Sans-Serif"], ["proportionalSerif", "Proportional Serif"], ["monospaceSerif", "Monospace Serif"], ["casual", "Casual"], ["script", "Script"], ["small-caps", "Small Caps"]]
  },
  fontPercent: {
    selector: ".vjs-font-percent > select",
    id: "",
    label: "Font Size",
    options: [["0.50", "50%"], ["0.75", "75%"], ["1.00", "100%"], ["1.25", "125%"], ["1.50", "150%"], ["1.75", "175%"], ["2.00", "200%"], ["3.00", "300%"], ["4.00", "400%"]],
    default: 2,
    parser: (i) => i === "1.00" ? null : Number(i)
  },
  textOpacity: {
    selector: ".vjs-text-opacity > select",
    id: "captions-foreground-opacity-%s",
    label: "Opacity",
    options: [wa, Ia],
    className: "vjs-text-opacity vjs-opacity"
  },
  // Options for this object are defined below.
  windowColor: {
    selector: ".vjs-window-color > select",
    id: "captions-window-color-%s",
    label: "Color",
    className: "vjs-window-color"
  },
  // Options for this object are defined below.
  windowOpacity: {
    selector: ".vjs-window-opacity > select",
    id: "captions-window-opacity-%s",
    label: "Opacity",
    options: [gc, Ia, wa],
    className: "vjs-window-opacity vjs-opacity"
  }
};
Wt.windowColor.options = Wt.backgroundColor.options;
function sf(i, e) {
  if (e && (i = e(i)), i && i !== "none")
    return i;
}
function MT(i, e) {
  const t = i.options[i.options.selectedIndex].value;
  return sf(t, e);
}
function BT(i, e, t) {
  if (e) {
    for (let s = 0; s < i.options.length; s++)
      if (sf(i.options[s].value, t) === e) {
        i.selectedIndex = s;
        break;
      }
  }
}
class FT extends ns {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *         The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *         The key/value store of player options.
   */
  constructor(e, t) {
    t.temporary = !1, super(e, t), this.updateDisplay = this.updateDisplay.bind(this), this.fill(), this.hasBeenOpened_ = this.hasBeenFilled_ = !0, this.renderModalComponents(e), this.endDialog = W("p", {
      className: "vjs-control-text",
      textContent: this.localize("End of dialog window.")
    }), this.el().appendChild(this.endDialog), this.setDefaults(), t.persistTextTrackSettings === void 0 && (this.options_.persistTextTrackSettings = this.options_.playerOptions.persistTextTrackSettings), this.bindFunctionsToSelectsAndButtons(), this.options_.persistTextTrackSettings && this.restoreSettings();
  }
  renderModalComponents(e) {
    const t = new Zh(e, {
      textTrackComponentid: this.id_,
      selectConfigs: Wt,
      fieldSets: [["color", "textOpacity"], ["backgroundColor", "backgroundOpacity"], ["windowColor", "windowOpacity"]]
    });
    this.addChild(t);
    const s = new ef(e, {
      textTrackComponentid: this.id_,
      selectConfigs: Wt,
      fieldSets: [["fontPercent"], ["edgeStyle"], ["fontFamily"]]
    });
    this.addChild(s);
    const r = new tf(e);
    this.addChild(r);
  }
  bindFunctionsToSelectsAndButtons() {
    this.on(this.$(".vjs-done-button"), ["click", "tap"], () => {
      this.saveSettings(), this.close();
    }), this.on(this.$(".vjs-default-button"), ["click", "tap"], () => {
      this.setDefaults(), this.updateDisplay();
    }), Ni(Wt, (e) => {
      this.on(this.$(e.selector), "change", this.updateDisplay);
    });
  }
  dispose() {
    this.endDialog = null, super.dispose();
  }
  label() {
    return this.localize("Caption Settings Dialog");
  }
  description() {
    return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
  }
  buildCSSClass() {
    return super.buildCSSClass() + " vjs-text-track-settings";
  }
  /**
   * Gets an object of text track settings (or null).
   *
   * @return {Object}
   *         An object with config values parsed from the DOM or localStorage.
   */
  getValues() {
    return Gd(Wt, (e, t, s) => {
      const r = MT(this.$(t.selector), t.parser);
      return r !== void 0 && (e[s] = r), e;
    }, {});
  }
  /**
   * Sets text track settings from an object of values.
   *
   * @param {Object} values
   *        An object with config values parsed from the DOM or localStorage.
   */
  setValues(e) {
    Ni(Wt, (t, s) => {
      BT(this.$(t.selector), e[s], t.parser);
    });
  }
  /**
   * Sets all `<select>` elements to their default values.
   */
  setDefaults() {
    Ni(Wt, (e) => {
      const t = e.hasOwnProperty("default") ? e.default : 0;
      this.$(e.selector).selectedIndex = t;
    });
  }
  /**
   * Restore texttrack settings from localStorage
   */
  restoreSettings() {
    let e;
    try {
      e = JSON.parse(S.localStorage.getItem(Da));
    } catch (t) {
      Q.warn(t);
    }
    e && this.setValues(e);
  }
  /**
   * Save text track settings to localStorage
   */
  saveSettings() {
    if (!this.options_.persistTextTrackSettings)
      return;
    const e = this.getValues();
    try {
      Object.keys(e).length ? S.localStorage.setItem(Da, JSON.stringify(e)) : S.localStorage.removeItem(Da);
    } catch (t) {
      Q.warn(t);
    }
  }
  /**
   * Update display of text track settings
   */
  updateDisplay() {
    const e = this.player_.getChild("textTrackDisplay");
    e && e.updateDisplay();
  }
  /**
   * Repopulate dialog with new localizations on languagechange
   */
  handleLanguagechange() {
    this.fill(), this.renderModalComponents(this.player_), this.bindFunctionsToSelectsAndButtons();
  }
}
M.registerComponent("TextTrackSettings", FT);
class UT extends M {
  /**
   * Create the ResizeManager.
   *
   * @param {Object} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of ResizeManager options.
   *
   * @param {Object} [options.ResizeObserver]
   *        A polyfill for ResizeObserver can be passed in here.
   *        If this is set to null it will ignore the native ResizeObserver and fall back to the iframe fallback.
   */
  constructor(e, t) {
    let s = t.ResizeObserver || S.ResizeObserver;
    t.ResizeObserver === null && (s = !1);
    const r = oe({
      createEl: !s,
      reportTouchActivity: !1
    }, t);
    super(e, r), this.ResizeObserver = t.ResizeObserver || S.ResizeObserver, this.loadListener_ = null, this.resizeObserver_ = null, this.debouncedHandler_ = mh(() => {
      this.resizeHandler();
    }, 100, !1, this), s ? (this.resizeObserver_ = new this.ResizeObserver(this.debouncedHandler_), this.resizeObserver_.observe(e.el())) : (this.loadListener_ = () => {
      if (!this.el_ || !this.el_.contentWindow)
        return;
      const n = this.debouncedHandler_;
      let a = this.unloadListener_ = function() {
        Pe(this, "resize", n), Pe(this, "unload", a), a = null;
      };
      et(this.el_.contentWindow, "unload", a), et(this.el_.contentWindow, "resize", n);
    }, this.one("load", this.loadListener_));
  }
  createEl() {
    return super.createEl("iframe", {
      className: "vjs-resize-manager",
      tabIndex: -1,
      title: this.localize("No content")
    }, {
      "aria-hidden": "true"
    });
  }
  /**
   * Called when a resize is triggered on the iframe or a resize is observed via the ResizeObserver
   *
   * @fires Player#playerresize
   */
  resizeHandler() {
    !this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
  }
  dispose() {
    this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, super.dispose();
  }
}
M.registerComponent("ResizeManager", UT);
const $T = {
  trackingThreshold: 20,
  liveTolerance: 15
};
class qT extends M {
  /**
   * Creates an instance of this class.
   *
   * @param {Player} player
   *        The `Player` that this class should be attached to.
   *
   * @param {Object} [options]
   *        The key/value store of player options.
   *
   * @param {number} [options.trackingThreshold=20]
   *        Number of seconds of live window (seekableEnd - seekableStart) that
   *        media needs to have before the liveui will be shown.
   *
   * @param {number} [options.liveTolerance=15]
   *        Number of seconds behind live that we have to be
   *        before we will be considered non-live. Note that this will only
   *        be used when playing at the live edge. This allows large seekable end
   *        changes to not effect whether we are live or not.
   */
  constructor(e, t) {
    const s = oe($T, t, {
      createEl: !1
    });
    super(e, s), this.trackLiveHandler_ = () => this.trackLive_(), this.handlePlay_ = (r) => this.handlePlay(r), this.handleFirstTimeupdate_ = (r) => this.handleFirstTimeupdate(r), this.handleSeeked_ = (r) => this.handleSeeked(r), this.seekToLiveEdge_ = (r) => this.seekToLiveEdge(r), this.reset_(), this.on(this.player_, "durationchange", (r) => this.handleDurationchange(r)), this.on(this.player_, "canplay", () => this.toggleTracking());
  }
  /**
   * all the functionality for tracking when seek end changes
   * and for tracking how far past seek end we should be
   */
  trackLive_() {
    const e = this.player_.seekable();
    if (!e || !e.length)
      return;
    const t = Number(S.performance.now().toFixed(4)), s = this.lastTime_ === -1 ? 0 : (t - this.lastTime_) / 1e3;
    this.lastTime_ = t, this.pastSeekEnd_ = this.pastSeekEnd() + s;
    const r = this.liveCurrentTime(), n = this.player_.currentTime();
    let a = this.player_.paused() || this.seekedBehindLive_ || Math.abs(r - n) > this.options_.liveTolerance;
    (!this.timeupdateSeen_ || r === 1 / 0) && (a = !1), a !== this.behindLiveEdge_ && (this.behindLiveEdge_ = a, this.trigger("liveedgechange"));
  }
  /**
   * handle a durationchange event on the player
   * and start/stop tracking accordingly.
   */
  handleDurationchange() {
    this.toggleTracking();
  }
  /**
   * start/stop tracking
   */
  toggleTracking() {
    this.player_.duration() === 1 / 0 && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking());
  }
  /**
   * start tracking live playback
   */
  startTracking() {
    this.isTracking() || (this.timeupdateSeen_ || (this.timeupdateSeen_ = this.player_.hasStarted()), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, at), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)));
  }
  /**
   * handle the first timeupdate on the player if it wasn't already playing
   * when live tracker started tracking.
   */
  handleFirstTimeupdate() {
    this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_);
  }
  /**
   * Keep track of what time a seek starts, and listen for seeked
   * to find where a seek ends.
   */
  handleSeeked() {
    const e = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
    this.seekedBehindLive_ = this.nextSeekedFromUser_ && e > 2, this.nextSeekedFromUser_ = !1, this.trackLive_();
  }
  /**
   * handle the first play on the player, and make sure that we seek
   * right to the live edge.
   */
  handlePlay() {
    this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
  }
  /**
   * Stop tracking, and set all internal variables to
   * their initial value.
   */
  reset_() {
    this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.nextSeekedFromUser_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
  }
  /**
   * The next seeked event is from the user. Meaning that any seek
   * > 2s behind live will be considered behind live for real and
   * liveTolerance will be ignored.
   */
  nextSeekedFromUser() {
    this.nextSeekedFromUser_ = !0;
  }
  /**
   * stop tracking live playback
   */
  stopTracking() {
    this.isTracking() && (this.reset_(), this.trigger("liveedgechange"));
  }
  /**
   * A helper to get the player seekable end
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The furthest seekable end or Infinity.
   */
  seekableEnd() {
    const e = this.player_.seekable(), t = [];
    let s = e ? e.length : 0;
    for (; s--; )
      t.push(e.end(s));
    return t.length ? t.sort()[t.length - 1] : 1 / 0;
  }
  /**
   * A helper to get the player seekable start
   * so that we don't have to null check everywhere
   *
   * @return {number}
   *         The earliest seekable start or 0.
   */
  seekableStart() {
    const e = this.player_.seekable(), t = [];
    let s = e ? e.length : 0;
    for (; s--; )
      t.push(e.start(s));
    return t.length ? t.sort()[0] : 0;
  }
  /**
   * Get the live time window aka
   * the amount of time between seekable start and
   * live current time.
   *
   * @return {number}
   *         The amount of seconds that are seekable in
   *         the live video.
   */
  liveWindow() {
    const e = this.liveCurrentTime();
    return e === 1 / 0 ? 0 : e - this.seekableStart();
  }
  /**
   * Determines if the player is live, only checks if this component
   * is tracking live playback or not
   *
   * @return {boolean}
   *         Whether liveTracker is tracking
   */
  isLive() {
    return this.isTracking();
  }
  /**
   * Determines if currentTime is at the live edge and won't fall behind
   * on each seekableendchange
   *
   * @return {boolean}
   *         Whether playback is at the live edge
   */
  atLiveEdge() {
    return !this.behindLiveEdge();
  }
  /**
   * get what we expect the live current time to be
   *
   * @return {number}
   *         The expected live current time
   */
  liveCurrentTime() {
    return this.pastSeekEnd() + this.seekableEnd();
  }
  /**
   * The number of seconds that have occurred after seekable end
   * changed. This will be reset to 0 once seekable end changes.
   *
   * @return {number}
   *         Seconds past the current seekable end
   */
  pastSeekEnd() {
    const e = this.seekableEnd();
    return this.lastSeekEnd_ !== -1 && e !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = e, this.pastSeekEnd_;
  }
  /**
   * If we are currently behind the live edge, aka currentTime will be
   * behind on a seekableendchange
   *
   * @return {boolean}
   *         If we are behind the live edge
   */
  behindLiveEdge() {
    return this.behindLiveEdge_;
  }
  /**
   * Whether live tracker is currently tracking or not.
   */
  isTracking() {
    return typeof this.trackingInterval_ == "number";
  }
  /**
   * Seek to the live edge if we are behind the live edge
   */
  seekToLiveEdge() {
    this.seekedBehindLive_ = !1, !this.atLiveEdge() && (this.nextSeekedFromUser_ = !1, this.player_.currentTime(this.liveCurrentTime()));
  }
  /**
   * Dispose of liveTracker
   */
  dispose() {
    this.stopTracking(), super.dispose();
  }
}
M.registerComponent("LiveTracker", qT);
class jT extends M {
  constructor(e, t) {
    super(e, t), this.on("statechanged", (s) => this.updateDom_()), this.updateDom_();
  }
  /**
   * Create the `TitleBar`'s DOM element
   *
   * @return {Element}
   *         The element that was created.
   */
  createEl() {
    return this.els = {
      title: W("div", {
        className: "vjs-title-bar-title",
        id: `vjs-title-bar-title-${nt()}`
      }),
      description: W("div", {
        className: "vjs-title-bar-description",
        id: `vjs-title-bar-description-${nt()}`
      })
    }, W("div", {
      className: "vjs-title-bar"
    }, {}, Wd(this.els));
  }
  /**
   * Updates the DOM based on the component's state object.
   */
  updateDom_() {
    const e = this.player_.tech_, t = e && e.el_, s = {
      title: "aria-labelledby",
      description: "aria-describedby"
    };
    ["title", "description"].forEach((r) => {
      const n = this.state[r], a = this.els[r], o = s[r];
      Nn(a), n && Qt(a, n), t && (t.removeAttribute(o), n && t.setAttribute(o, a.id));
    }), this.state.title || this.state.description ? this.show() : this.hide();
  }
  /**
   * Update the contents of the title bar component with new title and
   * description text.
   *
   * If both title and description are missing, the title bar will be hidden.
   *
   * If either title or description are present, the title bar will be visible.
   *
   * NOTE: Any previously set value will be preserved. To unset a previously
   * set value, you must pass an empty string or null.
   *
   * For example:
   *
   * ```
   * update({title: 'foo', description: 'bar'}) // title: 'foo', description: 'bar'
   * update({description: 'bar2'}) // title: 'foo', description: 'bar2'
   * update({title: ''}) // title: '', description: 'bar2'
   * update({title: 'foo', description: null}) // title: 'foo', description: null
   * ```
   *
   * @param  {Object} [options={}]
   *         An options object. When empty, the title bar will be hidden.
   *
   * @param  {string} [options.title]
   *         A title to display in the title bar.
   *
   * @param  {string} [options.description]
   *         A description to display in the title bar.
   */
  update(e) {
    this.setState(e);
  }
  /**
   * Dispose the component.
   */
  dispose() {
    const e = this.player_.tech_, t = e && e.el_;
    t && (t.removeAttribute("aria-labelledby"), t.removeAttribute("aria-describedby")), super.dispose(), this.els = null;
  }
}
M.registerComponent("TitleBar", jT);
const HT = {
  initialDisplay: 4e3,
  position: [],
  takeFocus: !1
};
class VT extends Oe {
  /**
   * TransientButton constructor
   *
   * @param {Player} player The button's player
   * @param {TransientButtonOptions} options Options for the transient button
   */
  constructor(e, t) {
    t = oe(HT, t), super(e, t), this.controlText(t.controlText), this.hide(), this.on(this.player_, ["useractive", "userinactive"], (s) => {
      this.removeClass("force-display");
    });
  }
  /**
   * Return CSS class including position classes
   *
   * @return {string} CSS class list
   */
  buildCSSClass() {
    return `vjs-transient-button focus-visible ${this.options_.position.map((e) => `vjs-${e}`).join(" ")}`;
  }
  /**
   * Create the button element
   *
   * @return {HTMLButtonElement} The button element
   */
  createEl() {
    const e = W("button", {}, {
      type: "button",
      class: this.buildCSSClass()
    }, W("span"));
    return this.controlTextEl_ = e.querySelector("span"), e;
  }
  /**
   * Show the button. The button will remain visible for the `initialDisplay` time, default 4s,
   * and when there is user activity.
   */
  show() {
    super.show(), this.addClass("force-display"), this.options_.takeFocus && this.el().focus({
      preventScroll: !0
    }), this.forceDisplayTimeout = this.player_.setTimeout(() => {
      this.removeClass("force-display");
    }, this.options_.initialDisplay);
  }
  /**
   * Hide the display, even if during the `initialDisplay` time.
   */
  hide() {
    this.removeClass("force-display"), super.hide();
  }
  /**
   * Dispose the component
   */
  dispose() {
    this.player_.clearTimeout(this.forceDisplayTimeout), super.dispose();
  }
}
M.registerComponent("TransientButton", VT);
const Ya = (i) => {
  const e = i.el();
  if (e.hasAttribute("src"))
    return i.triggerSourceset(e.src), !0;
  const t = i.$$("source"), s = [];
  let r = "";
  if (!t.length)
    return !1;
  for (let n = 0; n < t.length; n++) {
    const a = t[n].src;
    a && s.indexOf(a) === -1 && s.push(a);
  }
  return s.length ? (s.length === 1 && (r = s[0]), i.triggerSourceset(r), !0) : !1;
}, zT = Object.defineProperty({}, "innerHTML", {
  get() {
    return this.cloneNode(!0).innerHTML;
  },
  set(i) {
    const e = U.createElement(this.nodeName.toLowerCase());
    e.innerHTML = i;
    const t = U.createDocumentFragment();
    for (; e.childNodes.length; )
      t.appendChild(e.childNodes[0]);
    return this.innerText = "", S.Element.prototype.appendChild.call(this, t), this.innerHTML;
  }
}), rf = (i, e) => {
  let t = {};
  for (let s = 0; s < i.length && (t = Object.getOwnPropertyDescriptor(i[s], e), !(t && t.set && t.get)); s++)
    ;
  return t.enumerable = !0, t.configurable = !0, t;
}, GT = (i) => rf([i.el(), S.HTMLMediaElement.prototype, S.Element.prototype, zT], "innerHTML"), _c = function(i) {
  const e = i.el();
  if (e.resetSourceWatch_)
    return;
  const t = {}, s = GT(i), r = (n) => (...a) => {
    const o = n.apply(e, a);
    return Ya(i), o;
  };
  ["append", "appendChild", "insertAdjacentHTML"].forEach((n) => {
    e[n] && (t[n] = e[n], e[n] = r(t[n]));
  }), Object.defineProperty(e, "innerHTML", oe(s, {
    set: r(s.set)
  })), e.resetSourceWatch_ = () => {
    e.resetSourceWatch_ = null, Object.keys(t).forEach((n) => {
      e[n] = t[n];
    }), Object.defineProperty(e, "innerHTML", s);
  }, i.one("sourceset", e.resetSourceWatch_);
}, WT = Object.defineProperty({}, "src", {
  get() {
    return this.hasAttribute("src") ? Ch(S.Element.prototype.getAttribute.call(this, "src")) : "";
  },
  set(i) {
    return S.Element.prototype.setAttribute.call(this, "src", i), i;
  }
}), XT = (i) => rf([i.el(), S.HTMLMediaElement.prototype, WT], "src"), KT = function(i) {
  if (!i.featuresSourceset)
    return;
  const e = i.el();
  if (e.resetSourceset_)
    return;
  const t = XT(i), s = e.setAttribute, r = e.load;
  Object.defineProperty(e, "src", oe(t, {
    set: (n) => {
      const a = t.set.call(e, n);
      return i.triggerSourceset(e.src), a;
    }
  })), e.setAttribute = (n, a) => {
    const o = s.call(e, n, a);
    return /src/i.test(n) && i.triggerSourceset(e.src), o;
  }, e.load = () => {
    const n = r.call(e);
    return Ya(i) || (i.triggerSourceset(""), _c(i)), n;
  }, e.currentSrc ? i.triggerSourceset(e.currentSrc) : Ya(i) || _c(i), e.resetSourceset_ = () => {
    e.resetSourceset_ = null, e.load = r, e.setAttribute = s, Object.defineProperty(e, "src", t), e.resetSourceWatch_ && e.resetSourceWatch_();
  };
};
class j extends Y {
  /**
  * Create an instance of this Tech.
  *
  * @param {Object} [options]
  *        The key/value store of player options.
  *
  * @param {Function} [ready]
  *        Callback function to call when the `HTML5` Tech is ready.
  */
  constructor(e, t) {
    super(e, t);
    const s = e.source;
    let r = !1;
    if (this.featuresVideoFrameCallback = this.featuresVideoFrameCallback && this.el_.tagName === "VIDEO", s && (this.el_.currentSrc !== s.src || e.tag && e.tag.initNetworkState_ === 3) ? this.setSource(s) : this.handleLateInit_(this.el_), e.enableSourceset && this.setupSourcesetHandling_(), this.isScrubbing_ = !1, this.el_.hasChildNodes()) {
      const n = this.el_.childNodes;
      let a = n.length;
      const o = [];
      for (; a--; ) {
        const l = n[a];
        l.nodeName.toLowerCase() === "track" && (this.featuresNativeTextTracks ? (this.remoteTextTrackEls().addTrackElement_(l), this.remoteTextTracks().addTrack(l.track), this.textTracks().addTrack(l.track), !r && !this.el_.hasAttribute("crossorigin") && Un(l.src) && (r = !0)) : o.push(l));
      }
      for (let l = 0; l < o.length; l++)
        this.el_.removeChild(o[l]);
    }
    this.proxyNativeTracks_(), this.featuresNativeTextTracks && r && Q.warn(`Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.
This may prevent text tracks from loading.`), this.restoreMetadataTracksInIOSNativePlayer_(), (Gs || kn) && e.nativeControlsForTouch === !0 && this.setControls(!0), this.proxyWebkitFullscreen_(), this.triggerReady();
  }
  /**
   * Dispose of `HTML5` media element and remove all tracks.
   */
  dispose() {
    this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), j.disposeMediaElement(this.el_), this.options_ = null, super.dispose();
  }
  /**
   * Modify the media element so that we can detect when
   * the source is changed. Fires `sourceset` just after the source has changed
   */
  setupSourcesetHandling_() {
    KT(this);
  }
  /**
   * When a captions track is enabled in the iOS Safari native player, all other
   * tracks are disabled (including metadata tracks), which nulls all of their
   * associated cue points. This will restore metadata tracks to their pre-fullscreen
   * state in those cases so that cue points are not needlessly lost.
   *
   * @private
   */
  restoreMetadataTracksInIOSNativePlayer_() {
    const e = this.textTracks();
    let t;
    const s = () => {
      t = [];
      for (let n = 0; n < e.length; n++) {
        const a = e[n];
        a.kind === "metadata" && t.push({
          track: a,
          storedMode: a.mode
        });
      }
    };
    s(), e.addEventListener("change", s), this.on("dispose", () => e.removeEventListener("change", s));
    const r = () => {
      for (let n = 0; n < t.length; n++) {
        const a = t[n];
        a.track.mode === "disabled" && a.track.mode !== a.storedMode && (a.track.mode = a.storedMode);
      }
      e.removeEventListener("change", r);
    };
    this.on("webkitbeginfullscreen", () => {
      e.removeEventListener("change", s), e.removeEventListener("change", r), e.addEventListener("change", r);
    }), this.on("webkitendfullscreen", () => {
      e.removeEventListener("change", s), e.addEventListener("change", s), e.removeEventListener("change", r);
    });
  }
  /**
   * Attempt to force override of tracks for the given type
   *
   * @param {string} type - Track type to override, possible values include 'Audio',
   * 'Video', and 'Text'.
   * @param {boolean} override - If set to true native audio/video will be overridden,
   * otherwise native audio/video will potentially be used.
   * @private
   */
  overrideNative_(e, t) {
    if (t !== this[`featuresNative${e}Tracks`])
      return;
    const s = e.toLowerCase();
    this[`${s}TracksListeners_`] && Object.keys(this[`${s}TracksListeners_`]).forEach((r) => {
      this.el()[`${s}Tracks`].removeEventListener(r, this[`${s}TracksListeners_`][r]);
    }), this[`featuresNative${e}Tracks`] = !t, this[`${s}TracksListeners_`] = null, this.proxyNativeTracksForType_(s);
  }
  /**
   * Attempt to force override of native audio tracks.
   *
   * @param {boolean} override - If set to true native audio will be overridden,
   * otherwise native audio will potentially be used.
   */
  overrideNativeAudioTracks(e) {
    this.overrideNative_("Audio", e);
  }
  /**
   * Attempt to force override of native video tracks.
   *
   * @param {boolean} override - If set to true native video will be overridden,
   * otherwise native video will potentially be used.
   */
  overrideNativeVideoTracks(e) {
    this.overrideNative_("Video", e);
  }
  /**
   * Proxy native track list events for the given type to our track
   * lists if the browser we are playing in supports that type of track list.
   *
   * @param {string} name - Track type; values include 'audio', 'video', and 'text'
   * @private
   */
  proxyNativeTracksForType_(e) {
    const t = rt[e], s = this.el()[t.getterName], r = this[t.getterName]();
    if (!this[`featuresNative${t.capitalName}Tracks`] || !s || !s.addEventListener)
      return;
    const n = {
      change: (o) => {
        const l = {
          type: "change",
          target: r,
          currentTarget: r,
          srcElement: r
        };
        r.trigger(l), e === "text" && this[es.remoteText.getterName]().trigger(l);
      },
      addtrack(o) {
        r.addTrack(o.track);
      },
      removetrack(o) {
        r.removeTrack(o.track);
      }
    }, a = function() {
      const o = [];
      for (let l = 0; l < r.length; l++) {
        let h = !1;
        for (let m = 0; m < s.length; m++)
          if (s[m] === r[l]) {
            h = !0;
            break;
          }
        h || o.push(r[l]);
      }
      for (; o.length; )
        r.removeTrack(o.shift());
    };
    this[t.getterName + "Listeners_"] = n, Object.keys(n).forEach((o) => {
      const l = n[o];
      s.addEventListener(o, l), this.on("dispose", (h) => s.removeEventListener(o, l));
    }), this.on("loadstart", a), this.on("dispose", (o) => this.off("loadstart", a));
  }
  /**
   * Proxy all native track list events to our track lists if the browser we are playing
   * in supports that type of track list.
   *
   * @private
   */
  proxyNativeTracks_() {
    rt.names.forEach((e) => {
      this.proxyNativeTracksForType_(e);
    });
  }
  /**
   * Create the `Html5` Tech's DOM element.
   *
   * @return {Element}
   *         The element that gets created.
   */
  createEl() {
    let e = this.options_.tag;
    if (!e || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
      if (e) {
        const s = e.cloneNode(!0);
        e.parentNode && e.parentNode.insertBefore(s, e), j.disposeMediaElement(e), e = s;
      } else {
        e = U.createElement("video");
        const s = this.options_.tag && Gt(this.options_.tag), r = oe({}, s);
        (!Gs || this.options_.nativeControlsForTouch !== !0) && delete r.controls, ih(e, Object.assign(r, {
          id: this.options_.techId,
          class: "vjs-tech"
        }));
      }
      e.playerId = this.options_.playerId;
    }
    typeof this.options_.preload < "u" && Yi(e, "preload", this.options_.preload), this.options_.disablePictureInPicture !== void 0 && (e.disablePictureInPicture = this.options_.disablePictureInPicture);
    const t = ["loop", "muted", "playsinline", "autoplay"];
    for (let s = 0; s < t.length; s++) {
      const r = t[s], n = this.options_[r];
      typeof n < "u" && (n ? Yi(e, r, r) : Ln(e, r), e[r] = n);
    }
    return e;
  }
  /**
   * This will be triggered if the loadstart event has already fired, before videojs was
   * ready. Two known examples of when this can happen are:
   * 1. If we're loading the playback object after it has started loading
   * 2. The media is already playing the (often with autoplay on) then
   *
   * This function will fire another loadstart so that videojs can catchup.
   *
   * @fires Tech#loadstart
   *
   * @return {undefined}
   *         returns nothing.
   */
  handleLateInit_(e) {
    if (e.networkState === 0 || e.networkState === 3)
      return;
    if (e.readyState === 0) {
      let s = !1;
      const r = function() {
        s = !0;
      };
      this.on("loadstart", r);
      const n = function() {
        s || this.trigger("loadstart");
      };
      this.on("loadedmetadata", n), this.ready(function() {
        this.off("loadstart", r), this.off("loadedmetadata", n), s || this.trigger("loadstart");
      });
      return;
    }
    const t = ["loadstart"];
    t.push("loadedmetadata"), e.readyState >= 2 && t.push("loadeddata"), e.readyState >= 3 && t.push("canplay"), e.readyState >= 4 && t.push("canplaythrough"), this.ready(function() {
      t.forEach(function(s) {
        this.trigger(s);
      }, this);
    });
  }
  /**
   * Set whether we are scrubbing or not.
   * This is used to decide whether we should use `fastSeek` or not.
   * `fastSeek` is used to provide trick play on Safari browsers.
   *
   * @param {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */
  setScrubbing(e) {
    this.isScrubbing_ = e;
  }
  /**
   * Get whether we are scrubbing or not.
   *
   * @return {boolean} isScrubbing
   *                  - true for we are currently scrubbing
   *                  - false for we are no longer scrubbing
   */
  scrubbing() {
    return this.isScrubbing_;
  }
  /**
   * Set current time for the `HTML5` tech.
   *
   * @param {number} seconds
   *        Set the current time of the media to this.
   */
  setCurrentTime(e) {
    try {
      this.isScrubbing_ && this.el_.fastSeek && Pn ? this.el_.fastSeek(e) : this.el_.currentTime = e;
    } catch (t) {
      Q(t, "Video is not ready. (Video.js)");
    }
  }
  /**
   * Get the current duration of the HTML5 media element.
   *
   * @return {number}
   *         The duration of the media or 0 if there is no duration.
   */
  duration() {
    if (this.el_.duration === 1 / 0 && Et && Ct && this.el_.currentTime === 0) {
      const e = () => {
        this.el_.currentTime > 0 && (this.el_.duration === 1 / 0 && this.trigger("durationchange"), this.off("timeupdate", e));
      };
      return this.on("timeupdate", e), NaN;
    }
    return this.el_.duration || NaN;
  }
  /**
   * Get the current width of the HTML5 media element.
   *
   * @return {number}
   *         The width of the HTML5 media element.
   */
  width() {
    return this.el_.offsetWidth;
  }
  /**
   * Get the current height of the HTML5 media element.
   *
   * @return {number}
   *         The height of the HTML5 media element.
   */
  height() {
    return this.el_.offsetHeight;
  }
  /**
   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
   * `fullscreenchange` event.
   *
   * @private
   * @fires fullscreenchange
   * @listens webkitendfullscreen
   * @listens webkitbeginfullscreen
   * @listens webkitbeginfullscreen
   */
  proxyWebkitFullscreen_() {
    if (!("webkitDisplayingFullscreen" in this.el_))
      return;
    const e = function() {
      this.trigger("fullscreenchange", {
        isFullscreen: !1
      }), this.el_.controls && !this.options_.nativeControlsForTouch && this.controls() && (this.el_.controls = !1);
    }, t = function() {
      "webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", e), this.trigger("fullscreenchange", {
        isFullscreen: !0,
        // set a flag in case another tech triggers fullscreenchange
        nativeIOSFullscreen: !0
      }));
    };
    this.on("webkitbeginfullscreen", t), this.on("dispose", () => {
      this.off("webkitbeginfullscreen", t), this.off("webkitendfullscreen", e);
    });
  }
  /**
   * Check if fullscreen is supported on the video el.
   *
   * @return {boolean}
   *         - True if fullscreen is supported.
   *         - False if fullscreen is not supported.
   */
  supportsFullScreen() {
    return typeof this.el_.webkitEnterFullScreen == "function";
  }
  /**
   * Request that the `HTML5` Tech enter fullscreen.
   */
  enterFullScreen() {
    const e = this.el_;
    if (e.paused && e.networkState <= e.HAVE_METADATA)
      _t(this.el_.play()), this.setTimeout(function() {
        e.pause();
        try {
          e.webkitEnterFullScreen();
        } catch (t) {
          this.trigger("fullscreenerror", t);
        }
      }, 0);
    else
      try {
        e.webkitEnterFullScreen();
      } catch (t) {
        this.trigger("fullscreenerror", t);
      }
  }
  /**
   * Request that the `HTML5` Tech exit fullscreen.
   */
  exitFullScreen() {
    if (!this.el_.webkitDisplayingFullscreen) {
      this.trigger("fullscreenerror", new Error("The video is not fullscreen"));
      return;
    }
    this.el_.webkitExitFullScreen();
  }
  /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */
  requestPictureInPicture() {
    return this.el_.requestPictureInPicture();
  }
  /**
   * Native requestVideoFrameCallback if supported by browser/tech, or fallback
   * Don't use rVCF on Safari when DRM is playing, as it doesn't fire
   * Needs to be checked later than the constructor
   * This will be a false positive for clear sources loaded after a Fairplay source
   *
   * @param {function} cb function to call
   * @return {number} id of request
   */
  requestVideoFrameCallback(e) {
    return this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.requestVideoFrameCallback(e) : super.requestVideoFrameCallback(e);
  }
  /**
   * Native or fallback requestVideoFrameCallback
   *
   * @param {number} id request id to cancel
   */
  cancelVideoFrameCallback(e) {
    this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.cancelVideoFrameCallback(e) : super.cancelVideoFrameCallback(e);
  }
  /**
   * A getter/setter for the `Html5` Tech's source object.
   * > Note: Please use {@link Html5#setSource}
   *
   * @param {Tech~SourceObject} [src]
   *        The source object you want to set on the `HTML5` techs element.
   *
   * @return {Tech~SourceObject|undefined}
   *         - The current source object when a source is not passed in.
   *         - undefined when setting
   *
   * @deprecated Since version 5.
   */
  src(e) {
    if (e === void 0)
      return this.el_.src;
    this.setSrc(e);
  }
  /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */
  addSourceElement(e, t) {
    if (!e)
      return Q.error("Invalid source URL."), !1;
    const s = {
      src: e
    };
    t && (s.type = t);
    const r = W("source", {}, s);
    return this.el_.appendChild(r), !0;
  }
  /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */
  removeSourceElement(e) {
    if (!e)
      return Q.error("Source URL is required to remove the source element."), !1;
    const t = this.el_.querySelectorAll("source");
    for (const s of t)
      if (s.src === e)
        return this.el_.removeChild(s), !0;
    return Q.warn(`No matching source element found with src: ${e}`), !1;
  }
  /**
   * Reset the tech by removing all sources and then calling
   * {@link Html5.resetMediaElement}.
   */
  reset() {
    j.resetMediaElement(this.el_);
  }
  /**
   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
   * the HTML5 media element.
   *
   * @return {Tech~SourceObject}
   *         The current source object from the HTML5 tech. With a fallback to the
   *         elements source.
   */
  currentSrc() {
    return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
  }
  /**
   * Set controls attribute for the HTML5 media Element.
   *
   * @param {string} val
   *        Value to set the controls attribute to
   */
  setControls(e) {
    this.el_.controls = !!e;
  }
  /**
   * Create and returns a remote {@link TextTrack} object.
   *
   * @param {string} kind
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
   *
   * @param {string} [label]
   *        Label to identify the text track
   *
   * @param {string} [language]
   *        Two letter language abbreviation
   *
   * @return {TextTrack}
   *         The TextTrack that gets created.
   */
  addTextTrack(e, t, s) {
    return this.featuresNativeTextTracks ? this.el_.addTextTrack(e, t, s) : super.addTextTrack(e, t, s);
  }
  /**
   * Creates either native TextTrack or an emulated TextTrack depending
   * on the value of `featuresNativeTextTracks`
   *
   * @param {Object} options
   *        The object should contain the options to initialize the TextTrack with.
   *
   * @param {string} [options.kind]
   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
   *
   * @param {string} [options.label]
   *        Label to identify the text track
   *
   * @param {string} [options.language]
   *        Two letter language abbreviation.
   *
   * @param {boolean} [options.default]
   *        Default this track to on.
   *
   * @param {string} [options.id]
   *        The internal id to assign this track.
   *
   * @param {string} [options.src]
   *        A source url for the track.
   *
   * @return {HTMLTrackElement}
   *         The track element that gets created.
   */
  createRemoteTextTrack(e) {
    if (!this.featuresNativeTextTracks)
      return super.createRemoteTextTrack(e);
    const t = U.createElement("track");
    return e.kind && (t.kind = e.kind), e.label && (t.label = e.label), (e.language || e.srclang) && (t.srclang = e.language || e.srclang), e.default && (t.default = e.default), e.id && (t.id = e.id), e.src && (t.src = e.src), t;
  }
  /**
   * Creates a remote text track object and returns an html track element.
   *
   * @param {Object} options The object should contain values for
   * kind, language, label, and src (location of the WebVTT file)
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack
   * will not be removed from the TextTrackList and HtmlTrackElementList
   * after a source change
   * @return {HTMLTrackElement} An Html Track Element.
   * This can be an emulated {@link HTMLTrackElement} or a native one.
   *
   */
  addRemoteTextTrack(e, t) {
    const s = super.addRemoteTextTrack(e, t);
    return this.featuresNativeTextTracks && this.el().appendChild(s), s;
  }
  /**
   * Remove remote `TextTrack` from `TextTrackList` object
   *
   * @param {TextTrack} track
   *        `TextTrack` object to remove
   */
  removeRemoteTextTrack(e) {
    if (super.removeRemoteTextTrack(e), this.featuresNativeTextTracks) {
      const t = this.$$("track");
      let s = t.length;
      for (; s--; )
        (e === t[s] || e === t[s].track) && this.el().removeChild(t[s]);
    }
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object}
   *         An object with supported media playback quality metrics
   */
  getVideoPlaybackQuality() {
    if (typeof this.el().getVideoPlaybackQuality == "function")
      return this.el().getVideoPlaybackQuality();
    const e = {};
    return typeof this.el().webkitDroppedFrameCount < "u" && typeof this.el().webkitDecodedFrameCount < "u" && (e.droppedVideoFrames = this.el().webkitDroppedFrameCount, e.totalVideoFrames = this.el().webkitDecodedFrameCount), S.performance && (e.creationTime = S.performance.now()), e;
  }
}
Dn(j, "TEST_VID", function() {
  if (!is())
    return;
  const i = U.createElement("video"), e = U.createElement("track");
  return e.kind = "captions", e.srclang = "en", e.label = "English", i.appendChild(e), i;
});
j.isSupported = function() {
  try {
    j.TEST_VID.volume = 0.5;
  } catch {
    return !1;
  }
  return !!(j.TEST_VID && j.TEST_VID.canPlayType);
};
j.canPlayType = function(i) {
  return j.TEST_VID.canPlayType(i);
};
j.canPlaySource = function(i, e) {
  return j.canPlayType(i.type);
};
j.canControlVolume = function() {
  try {
    const i = j.TEST_VID.volume;
    j.TEST_VID.volume = i / 2 + 0.1;
    const e = i !== j.TEST_VID.volume;
    return e && je ? (S.setTimeout(() => {
      j && j.prototype && (j.prototype.featuresVolumeControl = i !== j.TEST_VID.volume);
    }), !1) : e;
  } catch {
    return !1;
  }
};
j.canMuteVolume = function() {
  try {
    const i = j.TEST_VID.muted;
    return j.TEST_VID.muted = !i, j.TEST_VID.muted ? Yi(j.TEST_VID, "muted", "muted") : Ln(j.TEST_VID, "muted", "muted"), i !== j.TEST_VID.muted;
  } catch {
    return !1;
  }
};
j.canControlPlaybackRate = function() {
  if (Et && Ct && wn < 58)
    return !1;
  try {
    const i = j.TEST_VID.playbackRate;
    return j.TEST_VID.playbackRate = i / 2 + 0.1, i !== j.TEST_VID.playbackRate;
  } catch {
    return !1;
  }
};
j.canOverrideAttributes = function() {
  try {
    const i = () => {
    };
    Object.defineProperty(U.createElement("video"), "src", {
      get: i,
      set: i
    }), Object.defineProperty(U.createElement("audio"), "src", {
      get: i,
      set: i
    }), Object.defineProperty(U.createElement("video"), "innerHTML", {
      get: i,
      set: i
    }), Object.defineProperty(U.createElement("audio"), "innerHTML", {
      get: i,
      set: i
    });
  } catch {
    return !1;
  }
  return !0;
};
j.supportsNativeTextTracks = function() {
  return Pn || je && Ct;
};
j.supportsNativeVideoTracks = function() {
  return !!(j.TEST_VID && j.TEST_VID.videoTracks);
};
j.supportsNativeAudioTracks = function() {
  return !!(j.TEST_VID && j.TEST_VID.audioTracks);
};
j.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"];
[["featuresMuteControl", "canMuteVolume"], ["featuresPlaybackRate", "canControlPlaybackRate"], ["featuresSourceset", "canOverrideAttributes"], ["featuresNativeTextTracks", "supportsNativeTextTracks"], ["featuresNativeVideoTracks", "supportsNativeVideoTracks"], ["featuresNativeAudioTracks", "supportsNativeAudioTracks"]].forEach(function([i, e]) {
  Dn(j.prototype, i, () => j[e](), !0);
});
j.prototype.featuresVolumeControl = j.canControlVolume();
j.prototype.movingMediaElementInDOM = !je;
j.prototype.featuresFullscreenResize = !0;
j.prototype.featuresProgressEvents = !0;
j.prototype.featuresTimeupdateEvents = !0;
j.prototype.featuresVideoFrameCallback = !!(j.TEST_VID && j.TEST_VID.requestVideoFrameCallback);
j.disposeMediaElement = function(i) {
  if (i) {
    for (i.parentNode && i.parentNode.removeChild(i); i.hasChildNodes(); )
      i.removeChild(i.firstChild);
    i.removeAttribute("src"), typeof i.load == "function" && function() {
      try {
        i.load();
      } catch {
      }
    }();
  }
};
j.resetMediaElement = function(i) {
  if (!i)
    return;
  const e = i.querySelectorAll("source");
  let t = e.length;
  for (; t--; )
    i.removeChild(e[t]);
  i.removeAttribute("src"), typeof i.load == "function" && function() {
    try {
      i.load();
    } catch {
    }
  }();
};
[
  /**
   * Get the value of `muted` from the media element. `muted` indicates
   * that the volume for the media should be set to silent. This does not actually change
   * the `volume` attribute.
   *
   * @method Html5#muted
   * @return {boolean}
   *         - True if the value of `volume` should be ignored and the audio set to silent.
   *         - False if the value of `volume` should be used.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
   * whether the media should start muted or not. Only changes the default state of the
   * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
   * current state.
   *
   * @method Html5#defaultMuted
   * @return {boolean}
   *         - The value of `defaultMuted` from the media element.
   *         - True indicates that the media should start muted.
   *         - False indicates that the media should not start muted
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Get the value of `autoplay` from the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#autoplay
   * @return {boolean}
   *         - The value of `autoplay` from the media element.
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Get the value of `controls` from the media element. `controls` indicates
   * whether the native media controls should be shown or hidden.
   *
   * @method Html5#controls
   * @return {boolean}
   *         - The value of `controls` from the media element.
   *         - True indicates that native controls should be showing.
   *         - False indicates that native controls should be hidden.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
   */
  "controls",
  /**
   * Get the value of `loop` from the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#loop
   * @return {boolean}
   *         - The value of `loop` from the media element.
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Get the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#playsinline
   * @return {boolean}
   *         - The value of `playsinline` from the media element.
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(i) {
  j.prototype[i] = function() {
    return this.el_[i] || this.el_.hasAttribute(i);
  };
});
[
  /**
   * Set the value of `muted` on the media element. `muted` indicates that the current
   * audio level should be silent.
   *
   * @method Html5#setMuted
   * @param {boolean} muted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
   * audio level should be silent, but will only effect the muted level on initial playback..
   *
   * @method Html5.prototype.setDefaultMuted
   * @param {boolean} defaultMuted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Set the value of `autoplay` on the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#setAutoplay
   * @param {boolean} autoplay
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Set the value of `loop` on the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#setLoop
   * @param {boolean} loop
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Set the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#setPlaysinline
   * @param {boolean} playsinline
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(i) {
  j.prototype["set" + _e(i)] = function(e) {
    this.el_[i] = e, e ? this.el_.setAttribute(i, i) : this.el_.removeAttribute(i);
  };
});
[
  /**
   * Get the value of `paused` from the media element. `paused` indicates whether the media element
   * is currently paused or not.
   *
   * @method Html5#paused
   * @return {boolean}
   *         The value of `paused` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
   */
  "paused",
  /**
   * Get the value of `currentTime` from the media element. `currentTime` indicates
   * the current second that the media is at in playback.
   *
   * @method Html5#currentTime
   * @return {number}
   *         The value of `currentTime` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
   */
  "currentTime",
  /**
   * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
   * object that represents the parts of the media that are already downloaded and
   * available for playback.
   *
   * @method Html5#buffered
   * @return {TimeRange}
   *         The value of `buffered` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
   */
  "buffered",
  /**
   * Get the value of `volume` from the media element. `volume` indicates
   * the current playback volume of audio for a media. `volume` will be a value from 0
   * (silent) to 1 (loudest and default).
   *
   * @method Html5#volume
   * @return {number}
   *         The value of `volume` from the media element. Value will be between 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Get the value of `poster` from the media element. `poster` indicates
   * that the url of an image file that can/will be shown when no media data is available.
   *
   * @method Html5#poster
   * @return {string}
   *         The value of `poster` from the media element. Value will be a url to an
   *         image.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
   */
  "poster",
  /**
   * Get the value of `preload` from the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#preload
   * @return {string}
   *         The value of `preload` from the media element. Will be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Get the value of the `error` from the media element. `error` indicates any
   * MediaError that may have occurred during playback. If error returns null there is no
   * current error.
   *
   * @method Html5#error
   * @return {MediaError|null}
   *         The value of `error` from the media element. Will be `MediaError` if there
   *         is a current error and null otherwise.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
   */
  "error",
  /**
   * Get the value of `seeking` from the media element. `seeking` indicates whether the
   * media is currently seeking to a new position or not.
   *
   * @method Html5#seeking
   * @return {boolean}
   *         - The value of `seeking` from the media element.
   *         - True indicates that the media is currently seeking to a new position.
   *         - False indicates that the media is not seeking to a new position at this time.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
   */
  "seeking",
  /**
   * Get the value of `seekable` from the media element. `seekable` returns a
   * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
   *
   * @method Html5#seekable
   * @return {TimeRange}
   *         The value of `seekable` from the media element. A `TimeRange` object
   *         indicating the current ranges of time that can be seeked to.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
   */
  "seekable",
  /**
   * Get the value of `ended` from the media element. `ended` indicates whether
   * the media has reached the end or not.
   *
   * @method Html5#ended
   * @return {boolean}
   *         - The value of `ended` from the media element.
   *         - True indicates that the media has ended.
   *         - False indicates that the media has not ended.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
   */
  "ended",
  /**
   * Get the value of `playbackRate` from the media element. `playbackRate` indicates
   * the rate at which the media is currently playing back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#playbackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
   * the rate at which the media is currently playing back. This value will not indicate the current
   * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
   *
   * Examples:
   *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
   *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.defaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "defaultPlaybackRate",
  /**
   * Get the value of 'disablePictureInPicture' from the video element.
   *
   * @method Html5#disablePictureInPicture
   * @return {boolean} value
   *         - The value of `disablePictureInPicture` from the video element.
   *         - True indicates that the video can't be played in Picture-In-Picture mode
   *         - False indicates that the video can be played in Picture-In-Picture mode
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Get the value of `played` from the media element. `played` returns a `TimeRange`
   * object representing points in the media timeline that have been played.
   *
   * @method Html5#played
   * @return {TimeRange}
   *         The value of `played` from the media element. A `TimeRange` object indicating
   *         the ranges of time that have been played.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
   */
  "played",
  /**
   * Get the value of `networkState` from the media element. `networkState` indicates
   * the current network state. It returns an enumeration from the following list:
   * - 0: NETWORK_EMPTY
   * - 1: NETWORK_IDLE
   * - 2: NETWORK_LOADING
   * - 3: NETWORK_NO_SOURCE
   *
   * @method Html5#networkState
   * @return {number}
   *         The value of `networkState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
   */
  "networkState",
  /**
   * Get the value of `readyState` from the media element. `readyState` indicates
   * the current state of the media element. It returns an enumeration from the
   * following list:
   * - 0: HAVE_NOTHING
   * - 1: HAVE_METADATA
   * - 2: HAVE_CURRENT_DATA
   * - 3: HAVE_FUTURE_DATA
   * - 4: HAVE_ENOUGH_DATA
   *
   * @method Html5#readyState
   * @return {number}
   *         The value of `readyState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
   */
  "readyState",
  /**
   * Get the value of `videoWidth` from the video element. `videoWidth` indicates
   * the current width of the video in css pixels.
   *
   * @method Html5#videoWidth
   * @return {number}
   *         The value of `videoWidth` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoWidth",
  /**
   * Get the value of `videoHeight` from the video element. `videoHeight` indicates
   * the current height of the video in css pixels.
   *
   * @method Html5#videoHeight
   * @return {number}
   *         The value of `videoHeight` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoHeight",
  /**
   * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#crossOrigin
   * @return {string}
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(i) {
  j.prototype[i] = function() {
    return this.el_[i];
  };
});
[
  /**
   * Set the value of `volume` on the media element. `volume` indicates the current
   * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
   * so on.
   *
   * @method Html5#setVolume
   * @param {number} percentAsDecimal
   *        The volume percent as a decimal. Valid range is from 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Set the value of `src` on the media element. `src` indicates the current
   * {@link Tech~SourceObject} for the media.
   *
   * @method Html5#setSrc
   * @param {Tech~SourceObject} src
   *        The source object to set as the current source.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
   */
  "src",
  /**
   * Set the value of `poster` on the media element. `poster` is the url to
   * an image file that can/will be shown when no media data is available.
   *
   * @method Html5#setPoster
   * @param {string} poster
   *        The url to an image that should be used as the `poster` for the media
   *        element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
   */
  "poster",
  /**
   * Set the value of `preload` on the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#setPreload
   * @param {string} preload
   *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Set the value of `playbackRate` on the media element. `playbackRate` indicates
   * the rate at which the media should play back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#setPlaybackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
   * the rate at which the media should play back upon initial startup. Changing this value
   * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
   *
   * Example Values:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.setDefaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
   */
  "defaultPlaybackRate",
  /**
   * Prevents the browser from suggesting a Picture-in-Picture context menu
   * or to request Picture-in-Picture automatically in some cases.
   *
   * @method Html5#setDisablePictureInPicture
   * @param {boolean} value
   *         The true value will disable Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#setCrossOrigin
   * @param {string} crossOrigin
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(i) {
  j.prototype["set" + _e(i)] = function(e) {
    this.el_[i] = e;
  };
});
[
  /**
   * A wrapper around the media elements `pause` function. This will call the `HTML5`
   * media elements `pause` function.
   *
   * @method Html5#pause
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
   */
  "pause",
  /**
   * A wrapper around the media elements `load` function. This will call the `HTML5`s
   * media element `load` function.
   *
   * @method Html5#load
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
   */
  "load",
  /**
   * A wrapper around the media elements `play` function. This will call the `HTML5`s
   * media element `play` function.
   *
   * @method Html5#play
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
   */
  "play"
].forEach(function(i) {
  j.prototype[i] = function() {
    return this.el_[i]();
  };
});
Y.withSourceHandlers(j);
j.nativeSourceHandler = {};
j.nativeSourceHandler.canPlayType = function(i) {
  try {
    return j.TEST_VID.canPlayType(i);
  } catch {
    return "";
  }
};
j.nativeSourceHandler.canHandleSource = function(i, e) {
  if (i.type)
    return j.nativeSourceHandler.canPlayType(i.type);
  if (i.src) {
    const t = Vo(i.src);
    return j.nativeSourceHandler.canPlayType(`video/${t}`);
  }
  return "";
};
j.nativeSourceHandler.handleSource = function(i, e, t) {
  e.setSrc(i.src);
};
j.nativeSourceHandler.dispose = function() {
};
j.registerSourceHandler(j.nativeSourceHandler);
Y.registerTech("Html5", j);
const nf = [
  /**
   * Fired while the user agent is downloading media data.
   *
   * @event Player#progress
   * @type {Event}
   */
  /**
   * Retrigger the `progress` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechProgress_
   * @fires Player#progress
   * @listens Tech#progress
   */
  "progress",
  /**
   * Fires when the loading of an audio/video is aborted.
   *
   * @event Player#abort
   * @type {Event}
   */
  /**
   * Retrigger the `abort` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechAbort_
   * @fires Player#abort
   * @listens Tech#abort
   */
  "abort",
  /**
   * Fires when the browser is intentionally not getting media data.
   *
   * @event Player#suspend
   * @type {Event}
   */
  /**
   * Retrigger the `suspend` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechSuspend_
   * @fires Player#suspend
   * @listens Tech#suspend
   */
  "suspend",
  /**
   * Fires when the current playlist is empty.
   *
   * @event Player#emptied
   * @type {Event}
   */
  /**
   * Retrigger the `emptied` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechEmptied_
   * @fires Player#emptied
   * @listens Tech#emptied
   */
  "emptied",
  /**
   * Fires when the browser is trying to get media data, but data is not available.
   *
   * @event Player#stalled
   * @type {Event}
   */
  /**
   * Retrigger the `stalled` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechStalled_
   * @fires Player#stalled
   * @listens Tech#stalled
   */
  "stalled",
  /**
   * Fires when the browser has loaded meta data for the audio/video.
   *
   * @event Player#loadedmetadata
   * @type {Event}
   */
  /**
   * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoadedmetadata_
   * @fires Player#loadedmetadata
   * @listens Tech#loadedmetadata
   */
  "loadedmetadata",
  /**
   * Fires when the browser has loaded the current frame of the audio/video.
   *
   * @event Player#loadeddata
   * @type {event}
   */
  /**
   * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoaddeddata_
   * @fires Player#loadeddata
   * @listens Tech#loadeddata
   */
  "loadeddata",
  /**
   * Fires when the current playback position has changed.
   *
   * @event Player#timeupdate
   * @type {event}
   */
  /**
   * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTimeUpdate_
   * @fires Player#timeupdate
   * @listens Tech#timeupdate
   */
  "timeupdate",
  /**
   * Fires when the video's intrinsic dimensions change
   *
   * @event Player#resize
   * @type {event}
   */
  /**
   * Retrigger the `resize` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechResize_
   * @fires Player#resize
   * @listens Tech#resize
   */
  "resize",
  /**
   * Fires when the volume has been changed
   *
   * @event Player#volumechange
   * @type {event}
   */
  /**
   * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechVolumechange_
   * @fires Player#volumechange
   * @listens Tech#volumechange
   */
  "volumechange",
  /**
   * Fires when the text track has been changed
   *
   * @event Player#texttrackchange
   * @type {event}
   */
  /**
   * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTexttrackchange_
   * @fires Player#texttrackchange
   * @listens Tech#texttrackchange
   */
  "texttrackchange"
], ka = {
  canplay: "CanPlay",
  canplaythrough: "CanPlayThrough",
  playing: "Playing",
  seeked: "Seeked"
}, Qa = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"], qr = {};
Qa.forEach((i) => {
  const e = i.charAt(0) === "x" ? `x-${i.substring(1)}` : i;
  qr[i] = `vjs-layout-${e}`;
});
const YT = {
  tiny: 210,
  xsmall: 320,
  small: 425,
  medium: 768,
  large: 1440,
  xlarge: 2560,
  huge: 1 / 0
};
class de extends M {
  /**
   * Create an instance of this class.
   *
   * @param {Element} tag
   *        The original video DOM element used for configuring options.
   *
   * @param {Object} [options]
   *        Object of option names and values.
   *
   * @param {PlayerReadyCallback} [ready]
   *        Ready callback function.
   */
  constructor(e, t, s) {
    if (e.id = e.id || t.id || `vjs_video_${nt()}`, t = Object.assign(de.getTagSettings(e), t), t.initChildren = !1, t.createEl = !1, t.evented = !1, t.reportTouchActivity = !1, !t.language) {
      const a = e.closest("[lang]");
      a && (t.language = a.getAttribute("lang"));
    }
    if (super(null, t, s), this.boundDocumentFullscreenChange_ = (a) => this.documentFullscreenChange_(a), this.boundFullWindowOnEscKey_ = (a) => this.fullWindowOnEscKey(a), this.boundUpdateStyleEl_ = (a) => this.updateStyleEl_(a), this.boundApplyInitTime_ = (a) => this.applyInitTime_(a), this.boundUpdateCurrentBreakpoint_ = (a) => this.updateCurrentBreakpoint_(a), this.boundHandleTechClick_ = (a) => this.handleTechClick_(a), this.boundHandleTechDoubleClick_ = (a) => this.handleTechDoubleClick_(a), this.boundHandleTechTouchStart_ = (a) => this.handleTechTouchStart_(a), this.boundHandleTechTouchMove_ = (a) => this.handleTechTouchMove_(a), this.boundHandleTechTouchEnd_ = (a) => this.handleTechTouchEnd_(a), this.boundHandleTechTap_ = (a) => this.handleTechTap_(a), this.boundUpdatePlayerHeightOnAudioOnlyMode_ = (a) => this.updatePlayerHeightOnAudioOnlyMode_(a), this.isFullscreen_ = !1, this.log = Vd(this.id_), this.fsApi_ = Yr, this.isPosterFromTech_ = !1, this.queuedCallbacks_ = [], this.isReady_ = !1, this.hasStarted_ = !1, this.userActive_ = !1, this.debugEnabled_ = !1, this.audioOnlyMode_ = !1, this.audioPosterMode_ = !1, this.audioOnlyCache_ = {
      controlBarHeight: null,
      playerHeight: null,
      hiddenChildren: []
    }, !this.options_ || !this.options_.techOrder || !this.options_.techOrder.length)
      throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
    if (this.tag = e, this.tagAttributes = e && Gt(e), this.language(this.options_.language), t.languages) {
      const a = {};
      Object.getOwnPropertyNames(t.languages).forEach(function(o) {
        a[o.toLowerCase()] = t.languages[o];
      }), this.languages_ = a;
    } else
      this.languages_ = de.prototype.options_.languages;
    this.resetCache_(), this.poster_ = t.poster || "", this.controls_ = !!t.controls, e.controls = !1, e.removeAttribute("controls"), this.changingSrc_ = !1, this.playCallbacks_ = [], this.playTerminatedQueue_ = [], e.hasAttribute("autoplay") ? this.autoplay(!0) : this.autoplay(this.options_.autoplay), t.plugins && Object.keys(t.plugins).forEach((a) => {
      if (typeof this[a] != "function")
        throw new Error(`plugin "${a}" does not exist`);
    }), this.scrubbing_ = !1, this.el_ = this.createEl(), $o(this, {
      eventBusKey: "el_"
    }), this.fsApi_.requestFullscreen && (et(U, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), this.on(this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_)), this.fluid_ && this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
    const r = oe(this.options_);
    if (t.plugins && Object.keys(t.plugins).forEach((a) => {
      this[a](t.plugins[a]);
    }), t.debug && this.debug(!0), this.options_.playerOptions = r, this.middleware_ = [], this.playbackRates(t.playbackRates), t.experimentalSvgIcons) {
      const o = new S.DOMParser().parseFromString(TT, "image/svg+xml");
      if (o.querySelector("parsererror"))
        Q.warn("Failed to load SVG Icons. Falling back to Font Icons."), this.options_.experimentalSvgIcons = null;
      else {
        const h = o.documentElement;
        h.style.display = "none", this.el_.appendChild(h), this.addClass("vjs-svg-icons-enabled");
      }
    }
    this.initChildren(), this.isAudio(e.nodeName.toLowerCase() === "audio"), this.controls() ? this.addClass("vjs-controls-enabled") : this.addClass("vjs-controls-disabled"), this.el_.setAttribute("role", "region"), this.isAudio() ? this.el_.setAttribute("aria-label", this.localize("Audio Player")) : this.el_.setAttribute("aria-label", this.localize("Video Player")), this.isAudio() && this.addClass("vjs-audio"), t.spatialNavigation && t.spatialNavigation.enabled && (this.spatialNavigation = new vT(this), this.addClass("vjs-spatial-navigation-enabled")), Gs && this.addClass("vjs-touch-enabled"), je || this.addClass("vjs-workinghover"), de.players[this.id_] = this;
    const n = qa.split(".")[0];
    this.addClass(`vjs-v${n}`), this.userActive(!0), this.reportUserActivity(), this.one("play", (a) => this.listenForUserActivity_(a)), this.on("keydown", (a) => this.handleKeyDown(a)), this.on("languagechange", (a) => this.handleLanguagechange(a)), this.breakpoints(this.options_.breakpoints), this.responsive(this.options_.responsive), this.on("ready", () => {
      this.audioPosterMode(this.options_.audioPosterMode), this.audioOnlyMode(this.options_.audioOnlyMode);
    });
  }
  /**
   * Destroys the video player and does any necessary cleanup.
   *
   * This is especially helpful if you are dynamically adding and removing videos
   * to/from the DOM.
   *
   * @fires Player#dispose
   */
  dispose() {
    this.trigger("dispose"), this.off("dispose"), Pe(U, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), Pe(U, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), de.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ && (this.playerElIngest_ = null), this.tag && (this.tag = null), mT(this), Ue.names.forEach((e) => {
      const t = Ue[e], s = this[t.getterName]();
      s && s.off && s.off();
    }), super.dispose({
      restoreEl: this.options_.restoreEl
    });
  }
  /**
   * Create the `Player`'s DOM element.
   *
   * @return {Element}
   *         The DOM element that gets created.
   */
  createEl() {
    let e = this.tag, t, s = this.playerElIngest_ = e.parentNode && e.parentNode.hasAttribute && e.parentNode.hasAttribute("data-vjs-player");
    const r = this.tag.tagName.toLowerCase() === "video-js";
    s ? t = this.el_ = e.parentNode : r || (t = this.el_ = super.createEl("div"));
    const n = Gt(e);
    if (r) {
      for (t = this.el_ = e, e = this.tag = U.createElement("video"); t.children.length; )
        e.appendChild(t.firstChild);
      Ms(t, "video-js") || fi(t, "video-js"), t.appendChild(e), s = this.playerElIngest_ = t, Object.keys(t).forEach((l) => {
        try {
          e[l] = t[l];
        } catch {
        }
      });
    }
    e.setAttribute("tabindex", "-1"), n.tabindex = "-1", Ct && In && (e.setAttribute("role", "application"), n.role = "application"), e.removeAttribute("width"), e.removeAttribute("height"), "width" in n && delete n.width, "height" in n && delete n.height, Object.getOwnPropertyNames(n).forEach(function(l) {
      r && l === "class" || t.setAttribute(l, n[l]), r && e.setAttribute(l, n[l]);
    }), e.playerId = e.id, e.id += "_html5_api", e.className = "vjs-tech", e.player = t.player = this, this.addClass("vjs-paused");
    const a = ["IS_SMART_TV", "IS_TIZEN", "IS_WEBOS", "IS_ANDROID", "IS_IPAD", "IS_IPHONE", "IS_CHROMECAST_RECEIVER"].filter((l) => Jd[l]).map((l) => "vjs-device-" + l.substring(3).toLowerCase().replace(/\_/g, "-"));
    if (this.addClass(...a), S.VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
      this.styleEl_ = fh("vjs-styles-dimensions");
      const l = Kt(".vjs-styles-defaults"), h = Kt("head");
      h.insertBefore(this.styleEl_, l ? l.nextSibling : h.firstChild);
    }
    this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
    const o = e.getElementsByTagName("a");
    for (let l = 0; l < o.length; l++) {
      const h = o.item(l);
      fi(h, "vjs-hidden"), h.setAttribute("hidden", "hidden");
    }
    return e.initNetworkState_ = e.networkState, e.parentNode && !s && e.parentNode.insertBefore(t, e), Ha(e, t), this.children_.unshift(e), this.el_.setAttribute("lang", this.language_), this.el_.setAttribute("translate", "no"), this.el_ = t, t;
  }
  /**
   * Get or set the `Player`'s crossOrigin option. For the HTML5 player, this
   * sets the `crossOrigin` property on the `<video>` tag to control the CORS
   * behavior.
   *
   * @see [Video Element Attributes]{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#attr-crossorigin}
   *
   * @param {string|null} [value]
   *        The value to set the `Player`'s crossOrigin to. If an argument is
   *        given, must be one of `'anonymous'` or `'use-credentials'`, or 'null'.
   *
   * @return {string|null|undefined}
   *         - The current crossOrigin value of the `Player` when getting.
   *         - undefined when setting
   */
  crossOrigin(e) {
    if (typeof e > "u")
      return this.techGet_("crossOrigin");
    if (e !== null && e !== "anonymous" && e !== "use-credentials") {
      Q.warn(`crossOrigin must be null,  "anonymous" or "use-credentials", given "${e}"`);
      return;
    }
    this.techCall_("setCrossOrigin", e), this.posterImage && this.posterImage.crossOrigin(e);
  }
  /**
   * A getter/setter for the `Player`'s width. Returns the player's configured value.
   * To get the current width use `currentWidth()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s width to.
   *
   * @return {number|undefined}
   *         - The current width of the `Player` when getting.
   *         - Nothing when setting
   */
  width(e) {
    return this.dimension("width", e);
  }
  /**
   * A getter/setter for the `Player`'s height. Returns the player's configured value.
   * To get the current height use `currentheight()`.
   *
   * @param {number|string} [value]
   *        CSS value to set the `Player`'s height to.
   *
   * @return {number|undefined}
   *         - The current height of the `Player` when getting.
   *         - Nothing when setting
   */
  height(e) {
    return this.dimension("height", e);
  }
  /**
   * A getter/setter for the `Player`'s width & height.
   *
   * @param {string} dimension
   *        This string can be:
   *        - 'width'
   *        - 'height'
   *
   * @param {number|string} [value]
   *        Value for dimension specified in the first argument.
   *
   * @return {number}
   *         The dimension arguments value when getting (width/height).
   */
  dimension(e, t) {
    const s = e + "_";
    if (t === void 0)
      return this[s] || 0;
    if (t === "" || t === "auto") {
      this[s] = void 0, this.updateStyleEl_();
      return;
    }
    const r = parseFloat(t);
    if (isNaN(r)) {
      Q.error(`Improper value "${t}" supplied for for ${e}`);
      return;
    }
    this[s] = r, this.updateStyleEl_();
  }
  /**
   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
   *
   * Turning this on will turn off fill mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */
  fluid(e) {
    if (e === void 0)
      return !!this.fluid_;
    this.fluid_ = !!e, Rt(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), e ? (this.addClass("vjs-fluid"), this.fill(!1), zy(this, () => {
      this.on(["playerreset", "resize"], this.boundUpdateStyleEl_);
    })) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
  }
  /**
   * A getter/setter/toggler for the vjs-fill `className` on the `Player`.
   *
   * Turning this on will turn off fluid mode.
   *
   * @param {boolean} [bool]
   *        - A value of true adds the class.
   *        - A value of false removes the class.
   *        - No value will be a getter.
   *
   * @return {boolean|undefined}
   *         - The value of fluid when getting.
   *         - `undefined` when setting.
   */
  fill(e) {
    if (e === void 0)
      return !!this.fill_;
    this.fill_ = !!e, e ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
  }
  /**
   * Get/Set the aspect ratio
   *
   * @param {string} [ratio]
   *        Aspect ratio for player
   *
   * @return {string|undefined}
   *         returns the current aspect ratio when getting
   */
  /**
   * A getter/setter for the `Player`'s aspect ratio.
   *
   * @param {string} [ratio]
   *        The value to set the `Player`'s aspect ratio to.
   *
   * @return {string|undefined}
   *         - The current aspect ratio of the `Player` when getting.
   *         - undefined when setting
   */
  aspectRatio(e) {
    if (e === void 0)
      return this.aspectRatio_;
    if (!/^\d+\:\d+$/.test(e))
      throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
    this.aspectRatio_ = e, this.fluid(!0), this.updateStyleEl_();
  }
  /**
   * Update styles of the `Player` element (height, width and aspect ratio).
   *
   * @private
   * @listens Tech#loadedmetadata
   */
  updateStyleEl_() {
    if (S.VIDEOJS_NO_DYNAMIC_STYLE === !0) {
      const o = typeof this.width_ == "number" ? this.width_ : this.options_.width, l = typeof this.height_ == "number" ? this.height_ : this.options_.height, h = this.tech_ && this.tech_.el();
      h && (o >= 0 && (h.width = o), l >= 0 && (h.height = l));
      return;
    }
    let e, t, s, r;
    this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? s = this.aspectRatio_ : this.videoWidth() > 0 ? s = this.videoWidth() + ":" + this.videoHeight() : s = "16:9";
    const n = s.split(":"), a = n[1] / n[0];
    this.width_ !== void 0 ? e = this.width_ : this.height_ !== void 0 ? e = this.height_ / a : e = this.videoWidth() || 300, this.height_ !== void 0 ? t = this.height_ : t = e * a, /^[^a-zA-Z]/.test(this.id()) ? r = "dimensions-" + this.id() : r = this.id() + "-dimensions", this.addClass(r), ph(this.styleEl_, `
      .${r} {
        width: ${e}px;
        height: ${t}px;
      }

      .${r}.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ${a * 100}%;
      }
    `);
  }
  /**
   * Load/Create an instance of playback {@link Tech} including element
   * and API methods. Then append the `Tech` element in `Player` as a child.
   *
   * @param {string} techName
   *        name of the playback technology
   *
   * @param {string} source
   *        video source
   *
   * @private
   */
  loadTech_(e, t) {
    this.tech_ && this.unloadTech_();
    const s = _e(e), r = e.charAt(0).toLowerCase() + e.slice(1);
    s !== "Html5" && this.tag && (Y.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = s, this.isReady_ = !1;
    let n = this.autoplay();
    (typeof this.autoplay() == "string" || this.autoplay() === !0 && this.options_.normalizeAutoplay) && (n = !1);
    const a = {
      source: t,
      autoplay: n,
      nativeControlsForTouch: this.options_.nativeControlsForTouch,
      playerId: this.id(),
      techId: `${this.id()}_${r}_api`,
      playsinline: this.options_.playsinline,
      preload: this.options_.preload,
      loop: this.options_.loop,
      disablePictureInPicture: this.options_.disablePictureInPicture,
      muted: this.options_.muted,
      poster: this.poster(),
      language: this.language(),
      playerElIngest: this.playerElIngest_ || !1,
      "vtt.js": this.options_["vtt.js"],
      canOverridePoster: !!this.options_.techCanOverridePoster,
      enableSourceset: this.options_.enableSourceset
    };
    Ue.names.forEach((l) => {
      const h = Ue[l];
      a[h.getterName] = this[h.privateName];
    }), Object.assign(a, this.options_[s]), Object.assign(a, this.options_[r]), Object.assign(a, this.options_[e.toLowerCase()]), this.tag && (a.tag = this.tag), t && t.src === this.cache_.src && this.cache_.currentTime > 0 && (a.startTime = this.cache_.currentTime);
    const o = Y.getTech(e);
    if (!o)
      throw new Error(`No Tech named '${s}' exists! '${s}' should be registered using videojs.registerTech()'`);
    this.tech_ = new o(a), this.tech_.ready(le(this, this.handleTechReady_), !0), Yl.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), nf.forEach((l) => {
      this.on(this.tech_, l, (h) => this[`handleTech${_e(l)}_`](h));
    }), Object.keys(ka).forEach((l) => {
      this.on(this.tech_, l, (h) => {
        if (this.tech_.playbackRate() === 0 && this.tech_.seeking()) {
          this.queuedCallbacks_.push({
            callback: this[`handleTech${ka[l]}_`].bind(this),
            event: h
          });
          return;
        }
        this[`handleTech${ka[l]}_`](h);
      });
    }), this.on(this.tech_, "loadstart", (l) => this.handleTechLoadStart_(l)), this.on(this.tech_, "sourceset", (l) => this.handleTechSourceset_(l)), this.on(this.tech_, "waiting", (l) => this.handleTechWaiting_(l)), this.on(this.tech_, "ended", (l) => this.handleTechEnded_(l)), this.on(this.tech_, "seeking", (l) => this.handleTechSeeking_(l)), this.on(this.tech_, "play", (l) => this.handleTechPlay_(l)), this.on(this.tech_, "pause", (l) => this.handleTechPause_(l)), this.on(this.tech_, "durationchange", (l) => this.handleTechDurationChange_(l)), this.on(this.tech_, "fullscreenchange", (l, h) => this.handleTechFullscreenChange_(l, h)), this.on(this.tech_, "fullscreenerror", (l, h) => this.handleTechFullscreenError_(l, h)), this.on(this.tech_, "enterpictureinpicture", (l) => this.handleTechEnterPictureInPicture_(l)), this.on(this.tech_, "leavepictureinpicture", (l) => this.handleTechLeavePictureInPicture_(l)), this.on(this.tech_, "error", (l) => this.handleTechError_(l)), this.on(this.tech_, "posterchange", (l) => this.handleTechPosterChange_(l)), this.on(this.tech_, "textdata", (l) => this.handleTechTextData_(l)), this.on(this.tech_, "ratechange", (l) => this.handleTechRateChange_(l)), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (s !== "Html5" || !this.tag) && Ha(this.tech_.el(), this.el()), this.tag && (this.tag.player = null, this.tag = null);
  }
  /**
   * Unload and dispose of the current playback {@link Tech}.
   *
   * @private
   */
  unloadTech_() {
    Ue.names.forEach((e) => {
      const t = Ue[e];
      this[t.privateName] = this[t.getterName]();
    }), this.textTracksJson_ = Yl.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
  }
  /**
   * Return a reference to the current {@link Tech}.
   * It will print a warning by default about the danger of using the tech directly
   * but any argument that is passed in will silence the warning.
   *
   * @param {*} [safety]
   *        Anything passed in to silence the warning
   *
   * @return {Tech}
   *         The Tech
   */
  tech(e) {
    return e === void 0 && Q.warn(`Using the tech directly can be dangerous. I hope you know what you're doing.
See https://github.com/videojs/video.js/issues/2617 for more info.
`), this.tech_;
  }
  /**
   * An object that contains Video.js version.
   *
   * @typedef {Object} PlayerVersion
   *
   * @property {string} 'video.js' - Video.js version
   */
  /**
   * Returns an object with Video.js version.
   *
   * @return {PlayerVersion}
   *          An object with Video.js version.
   */
  version() {
    return {
      "video.js": qa
    };
  }
  /**
   * Set up click and touch listeners for the playback element
   *
   * - On desktops: a click on the video itself will toggle playback
   * - On mobile devices: a click on the video toggles controls
   *   which is done by toggling the user state between active and
   *   inactive
   * - A tap can signal that a user has become active or has become inactive
   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
   *   quick tap should hide them again (signaling the user is in an inactive
   *   viewing state)
   * - In addition to this, we still want the user to be considered inactive after
   *   a few seconds of inactivity.
   *
   * > Note: the only part of iOS interaction we can't mimic with this setup
   * is a touch and hold on the video element counting as activity in order to
   * keep the controls showing, but that shouldn't be an issue. A touch and hold
   * on any controls will still keep the user active
   *
   * @private
   */
  addTechControlsListeners_() {
    this.removeTechControlsListeners_(), this.on(this.tech_, "click", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_);
  }
  /**
   * Remove the listeners used for click and tap controls. This is needed for
   * toggling to controls disabled, where a tap/touch should do nothing.
   *
   * @private
   */
  removeTechControlsListeners_() {
    this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "click", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
  }
  /**
   * Player waits for the tech to be ready
   *
   * @private
   */
  handleTechReady_() {
    this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
  }
  /**
   * Retrigger the `loadstart` event that was triggered by the {@link Tech}.
   *
   * @fires Player#loadstart
   * @listens Tech#loadstart
   * @private
   */
  handleTechLoadStart_() {
    this.removeClass("vjs-ended", "vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() ? (this.hasStarted(!1), this.trigger("loadstart")) : this.trigger("loadstart"), this.manualAutoplay_(this.autoplay() === !0 && this.options_.normalizeAutoplay ? "play" : this.autoplay());
  }
  /**
   * Handle autoplay string values, rather than the typical boolean
   * values that should be handled by the tech. Note that this is not
   * part of any specification. Valid values and what they do can be
   * found on the autoplay getter at Player#autoplay()
   */
  manualAutoplay_(e) {
    if (!this.tech_ || typeof e != "string")
      return;
    const t = () => {
      const r = this.muted();
      this.muted(!0);
      const n = () => {
        this.muted(r);
      };
      this.playTerminatedQueue_.push(n);
      const a = this.play();
      if (Fs(a))
        return a.catch((o) => {
          throw n(), new Error(`Rejection at manualAutoplay. Restoring muted value. ${o || ""}`);
        });
    };
    let s;
    if (e === "any" && !this.muted() ? (s = this.play(), Fs(s) && (s = s.catch(t))) : e === "muted" && !this.muted() ? s = t() : s = this.play(), !!Fs(s))
      return s.then(() => {
        this.trigger({
          type: "autoplay-success",
          autoplay: e
        });
      }).catch(() => {
        this.trigger({
          type: "autoplay-failure",
          autoplay: e
        });
      });
  }
  /**
   * Update the internal source caches so that we return the correct source from
   * `src()`, `currentSource()`, and `currentSources()`.
   *
   * > Note: `currentSources` will not be updated if the source that is passed in exists
   *         in the current `currentSources` cache.
   *
   *
   * @param {Tech~SourceObject} srcObj
   *        A string or object source to update our caches to.
   */
  updateSourceCaches_(e = "") {
    let t = e, s = "";
    typeof t != "string" && (t = e.src, s = e.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], t && !s && (s = yT(this, t)), this.cache_.source = oe({}, e, {
      src: t,
      type: s
    });
    const r = this.cache_.sources.filter((l) => l.src && l.src === t), n = [], a = this.$$("source"), o = [];
    for (let l = 0; l < a.length; l++) {
      const h = Gt(a[l]);
      n.push(h), h.src && h.src === t && o.push(h.src);
    }
    o.length && !r.length ? this.cache_.sources = n : r.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = t;
  }
  /**
   * *EXPERIMENTAL* Fired when the source is set or changed on the {@link Tech}
   * causing the media element to reload.
   *
   * It will fire for the initial source and each subsequent source.
   * This event is a custom event from Video.js and is triggered by the {@link Tech}.
   *
   * The event object for this event contains a `src` property that will contain the source
   * that was available when the event was triggered. This is generally only necessary if Video.js
   * is switching techs while the source was being changed.
   *
   * It is also fired when `load` is called on the player (or media element)
   * because the {@link https://html.spec.whatwg.org/multipage/media.html#dom-media-load|specification for `load`}
   * says that the resource selection algorithm needs to be aborted and restarted.
   * In this case, it is very likely that the `src` property will be set to the
   * empty string `""` to indicate we do not know what the source will be but
   * that it is changing.
   *
   * *This event is currently still experimental and may change in minor releases.*
   * __To use this, pass `enableSourceset` option to the player.__
   *
   * @event Player#sourceset
   * @type {Event}
   * @prop {string} src
   *                The source url available when the `sourceset` was triggered.
   *                It will be an empty string if we cannot know what the source is
   *                but know that the source will change.
   */
  /**
   * Retrigger the `sourceset` event that was triggered by the {@link Tech}.
   *
   * @fires Player#sourceset
   * @listens Tech#sourceset
   * @private
   */
  handleTechSourceset_(e) {
    if (!this.changingSrc_) {
      let t = (n) => this.updateSourceCaches_(n);
      const s = this.currentSource().src, r = e.src;
      s && !/^blob:/.test(s) && /^blob:/.test(r) && (!this.lastSource_ || this.lastSource_.tech !== r && this.lastSource_.player !== s) && (t = () => {
      }), t(r), e.src || this.tech_.any(["sourceset", "loadstart"], (n) => {
        if (n.type === "sourceset")
          return;
        const a = this.techGet_("currentSrc");
        this.lastSource_.tech = a, this.updateSourceCaches_(a);
      });
    }
    this.lastSource_ = {
      player: this.currentSource().src,
      tech: e.src
    }, this.trigger({
      src: e.src,
      type: "sourceset"
    });
  }
  /**
   * Add/remove the vjs-has-started class
   *
   *
   * @param {boolean} request
   *        - true: adds the class
   *        - false: remove the class
   *
   * @return {boolean}
   *         the boolean value of hasStarted_
   */
  hasStarted(e) {
    if (e === void 0)
      return this.hasStarted_;
    e !== this.hasStarted_ && (this.hasStarted_ = e, this.hasStarted_ ? this.addClass("vjs-has-started") : this.removeClass("vjs-has-started"));
  }
  /**
   * Fired whenever the media begins or resumes playback
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
   * @fires Player#play
   * @listens Tech#play
   * @private
   */
  handleTechPlay_() {
    this.removeClass("vjs-ended", "vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
  }
  /**
   * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
   *
   * If there were any events queued while the playback rate was zero, fire
   * those events now.
   *
   * @private
   * @method Player#handleTechRateChange_
   * @fires Player#ratechange
   * @listens Tech#ratechange
   */
  handleTechRateChange_() {
    this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach((e) => e.callback(e.event)), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
  }
  /**
   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
   *
   * @fires Player#waiting
   * @listens Tech#waiting
   * @private
   */
  handleTechWaiting_() {
    this.addClass("vjs-waiting"), this.trigger("waiting");
    const e = this.currentTime(), t = () => {
      e !== this.currentTime() && (this.removeClass("vjs-waiting"), this.off("timeupdate", t));
    };
    this.on("timeupdate", t);
  }
  /**
   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
   * > Note: This is not consistent between browsers. See #1351
   *
   * @fires Player#canplay
   * @listens Tech#canplay
   * @private
   */
  handleTechCanPlay_() {
    this.removeClass("vjs-waiting"), this.trigger("canplay");
  }
  /**
   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
   *
   * @fires Player#canplaythrough
   * @listens Tech#canplaythrough
   * @private
   */
  handleTechCanPlayThrough_() {
    this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
  }
  /**
   * Retrigger the `playing` event that was triggered by the {@link Tech}.
   *
   * @fires Player#playing
   * @listens Tech#playing
   * @private
   */
  handleTechPlaying_() {
    this.removeClass("vjs-waiting"), this.trigger("playing");
  }
  /**
   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeking
   * @listens Tech#seeking
   * @private
   */
  handleTechSeeking_() {
    this.addClass("vjs-seeking"), this.trigger("seeking");
  }
  /**
   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
   *
   * @fires Player#seeked
   * @listens Tech#seeked
   * @private
   */
  handleTechSeeked_() {
    this.removeClass("vjs-seeking", "vjs-ended"), this.trigger("seeked");
  }
  /**
   * Retrigger the `pause` event that was triggered by the {@link Tech}.
   *
   * @fires Player#pause
   * @listens Tech#pause
   * @private
   */
  handleTechPause_() {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
  }
  /**
   * Retrigger the `ended` event that was triggered by the {@link Tech}.
   *
   * @fires Player#ended
   * @listens Tech#ended
   * @private
   */
  handleTechEnded_() {
    this.addClass("vjs-ended"), this.removeClass("vjs-waiting"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
  }
  /**
   * Fired when the duration of the media resource is first known or changed
   *
   * @listens Tech#durationchange
   * @private
   */
  handleTechDurationChange_() {
    this.duration(this.techGet_("duration"));
  }
  /**
   * Handle a click on the media element to play/pause
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#click
   * @private
   */
  handleTechClick_(e) {
    this.controls_ && (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click == "function" ? this.options_.userActions.click.call(this, e) : this.paused() ? _t(this.play()) : this.pause());
  }
  /**
   * Handle a double-click on the media element to enter/exit fullscreen,
   * or exit documentPictureInPicture mode
   *
   * @param {Event} event
   *        the event that caused this function to trigger
   *
   * @listens Tech#dblclick
   * @private
   */
  handleTechDoubleClick_(e) {
    if (!this.controls_)
      return;
    Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), (s) => s.contains(e.target)) || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, e) : this.isInPictureInPicture() && !U.pictureInPictureElement ? this.exitPictureInPicture() : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen());
  }
  /**
   * Handle a tap on the media element. It will toggle the user
   * activity state, which hides and shows the controls.
   *
   * @listens Tech#tap
   * @private
   */
  handleTechTap_() {
    this.userActive(!this.userActive());
  }
  /**
   * Handle touch to start
   *
   * @listens Tech#touchstart
   * @private
   */
  handleTechTouchStart_() {
    this.userWasActive = this.userActive();
  }
  /**
   * Handle touch to move
   *
   * @listens Tech#touchmove
   * @private
   */
  handleTechTouchMove_() {
    this.userWasActive && this.reportUserActivity();
  }
  /**
   * Handle touch to end
   *
   * @param {Event} event
   *        the touchend event that triggered
   *        this function
   *
   * @listens Tech#touchend
   * @private
   */
  handleTechTouchEnd_(e) {
    e.cancelable && e.preventDefault();
  }
  /**
   * @private
   */
  toggleFullscreenClass_() {
    this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
  }
  /**
   * when the document fschange event triggers it calls this
   */
  documentFullscreenChange_(e) {
    const t = e.target.player;
    if (t && t !== this)
      return;
    const s = this.el();
    let r = U[this.fsApi_.fullscreenElement] === s;
    !r && s.matches && (r = s.matches(":" + this.fsApi_.fullscreen)), this.isFullscreen(r);
  }
  /**
   * Handle Tech Fullscreen Change
   *
   * @param {Event} event
   *        the fullscreenchange event that triggered this function
   *
   * @param {Object} data
   *        the data that was sent with the event
   *
   * @private
   * @listens Tech#fullscreenchange
   * @fires Player#fullscreenchange
   */
  handleTechFullscreenChange_(e, t) {
    t && (t.nativeIOSFullscreen && (this.addClass("vjs-ios-native-fs"), this.tech_.one("webkitendfullscreen", () => {
      this.removeClass("vjs-ios-native-fs");
    })), this.isFullscreen(t.isFullscreen));
  }
  handleTechFullscreenError_(e, t) {
    this.trigger("fullscreenerror", t);
  }
  /**
   * @private
   */
  togglePictureInPictureClass_() {
    this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
  }
  /**
   * Handle Tech Enter Picture-in-Picture.
   *
   * @param {Event} event
   *        the enterpictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#enterpictureinpicture
   */
  handleTechEnterPictureInPicture_(e) {
    this.isInPictureInPicture(!0);
  }
  /**
   * Handle Tech Leave Picture-in-Picture.
   *
   * @param {Event} event
   *        the leavepictureinpicture event that triggered this function
   *
   * @private
   * @listens Tech#leavepictureinpicture
   */
  handleTechLeavePictureInPicture_(e) {
    this.isInPictureInPicture(!1);
  }
  /**
   * Fires when an error occurred during the loading of an audio/video.
   *
   * @private
   * @listens Tech#error
   */
  handleTechError_() {
    const e = this.tech_.error();
    e && this.error(e);
  }
  /**
   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
   *
   * @fires Player#textdata
   * @listens Tech#textdata
   * @private
   */
  handleTechTextData_() {
    let e = null;
    arguments.length > 1 && (e = arguments[1]), this.trigger("textdata", e);
  }
  /**
   * Get object for cached values.
   *
   * @return {Object}
   *         get the current object cache
   */
  getCache() {
    return this.cache_;
  }
  /**
   * Resets the internal cache object.
   *
   * Using this function outside the player constructor or reset method may
   * have unintended side-effects.
   *
   * @private
   */
  resetCache_() {
    this.cache_ = {
      // Right now, the currentTime is not _really_ cached because it is always
      // retrieved from the tech (see: currentTime). However, for completeness,
      // we set it to zero here to ensure that if we do start actually caching
      // it, we reset it along with everything else.
      currentTime: 0,
      initTime: 0,
      inactivityTimeout: this.options_.inactivityTimeout,
      duration: NaN,
      lastVolume: 1,
      lastPlaybackRate: this.defaultPlaybackRate(),
      media: null,
      src: "",
      source: {},
      sources: [],
      playbackRates: [],
      volume: 1
    };
  }
  /**
   * Pass values to the playback tech
   *
   * @param {string} [method]
   *        the method to call
   *
   * @param {Object} [arg]
   *        the argument to pass
   *
   * @private
   */
  techCall_(e, t) {
    this.ready(function() {
      if (e in fT)
        return dT(this.middleware_, this.tech_, e, t);
      if (e in tc)
        return ec(this.middleware_, this.tech_, e, t);
      try {
        this.tech_ && this.tech_[e](t);
      } catch (s) {
        throw Q(s), s;
      }
    }, !0);
  }
  /**
   * Mediate attempt to call playback tech method
   * and return the value of the method called.
   *
   * @param {string} method
   *        Tech method
   *
   * @return {*}
   *         Value returned by the tech method called, undefined if tech
   *         is not ready or tech method is not present
   *
   * @private
   */
  techGet_(e) {
    if (!(!this.tech_ || !this.tech_.isReady_)) {
      if (e in hT)
        return cT(this.middleware_, this.tech_, e);
      if (e in tc)
        return ec(this.middleware_, this.tech_, e);
      try {
        return this.tech_[e]();
      } catch (t) {
        throw this.tech_[e] === void 0 ? (Q(`Video.js: ${e} method not defined for ${this.techName_} playback technology.`, t), t) : t.name === "TypeError" ? (Q(`Video.js: ${e} unavailable on ${this.techName_} playback technology element.`, t), this.tech_.isReady_ = !1, t) : (Q(t), t);
      }
    }
  }
  /**
   * Attempt to begin playback at the first opportunity.
   *
   * @return {Promise|undefined}
   *         Returns a promise if the browser supports Promises (or one
   *         was passed in as an option). This promise will be resolved on
   *         the return value of play. If this is undefined it will fulfill the
   *         promise chain otherwise the promise chain will be fulfilled when
   *         the promise from play is fulfilled.
   */
  play() {
    return new Promise((e) => {
      this.play_(e);
    });
  }
  /**
   * The actual logic for play, takes a callback that will be resolved on the
   * return value of play. This allows us to resolve to the play promise if there
   * is one on modern browsers.
   *
   * @private
   * @param {Function} [callback]
   *        The callback that should be called when the techs play is actually called
   */
  play_(e = _t) {
    this.playCallbacks_.push(e);
    const t = !!(!this.changingSrc_ && (this.src() || this.currentSrc())), s = !!(Pn || je);
    if (this.waitToPlay_ && (this.off(["ready", "loadstart"], this.waitToPlay_), this.waitToPlay_ = null), !this.isReady_ || !t) {
      this.waitToPlay_ = (a) => {
        this.play_();
      }, this.one(["ready", "loadstart"], this.waitToPlay_), !t && s && this.load();
      return;
    }
    const r = this.techGet_("play");
    s && this.hasClass("vjs-ended") && this.resetProgressBar_(), r === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(r);
  }
  /**
   * These functions will be run when if play is terminated. If play
   * runPlayCallbacks_ is run these function will not be run. This allows us
   * to differentiate between a terminated play and an actual call to play.
   */
  runPlayTerminatedQueue_() {
    const e = this.playTerminatedQueue_.slice(0);
    this.playTerminatedQueue_ = [], e.forEach(function(t) {
      t();
    });
  }
  /**
   * When a callback to play is delayed we have to run these
   * callbacks when play is actually called on the tech. This function
   * runs the callbacks that were delayed and accepts the return value
   * from the tech.
   *
   * @param {undefined|Promise} val
   *        The return value from the tech.
   */
  runPlayCallbacks_(e) {
    const t = this.playCallbacks_.slice(0);
    this.playCallbacks_ = [], this.playTerminatedQueue_ = [], t.forEach(function(s) {
      s(e);
    });
  }
  /**
   * Pause the video playback
   */
  pause() {
    this.techCall_("pause");
  }
  /**
   * Check if the player is paused or has yet to play
   *
   * @return {boolean}
   *         - false: if the media is currently playing
   *         - true: if media is not currently playing
   */
  paused() {
    return this.techGet_("paused") !== !1;
  }
  /**
   * Get a TimeRange object representing the current ranges of time that the user
   * has played.
   *
   * @return {TimeRange}
   *         A time range object that represents all the increments of time that have
   *         been played.
   */
  played() {
    return this.techGet_("played") || dt(0, 0);
  }
  /**
   * Sets or returns whether or not the user is "scrubbing". Scrubbing is
   * when the user has clicked the progress bar handle and is
   * dragging it along the progress bar.
   *
   * @param {boolean} [isScrubbing]
   *        whether the user is or is not scrubbing
   *
   * @return {boolean|undefined}
   *         - The value of scrubbing when getting
   *         - Nothing when setting
   */
  scrubbing(e) {
    if (typeof e > "u")
      return this.scrubbing_;
    this.scrubbing_ = !!e, this.techCall_("setScrubbing", this.scrubbing_), e ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
  }
  /**
   * Get or set the current time (in seconds)
   *
   * @param {number|string} [seconds]
   *        The time to seek to in seconds
   *
   * @return {number|undefined}
   *         - the current time in seconds when getting
   *         - Nothing when setting
   */
  currentTime(e) {
    if (e === void 0)
      return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
    if (e < 0 && (e = 0), !this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
      this.cache_.initTime = e, this.off("canplay", this.boundApplyInitTime_), this.one("canplay", this.boundApplyInitTime_);
      return;
    }
    this.techCall_("setCurrentTime", e), this.cache_.initTime = 0, isFinite(e) && (this.cache_.currentTime = Number(e));
  }
  /**
   * Apply the value of initTime stored in cache as currentTime.
   *
   * @private
   */
  applyInitTime_() {
    this.currentTime(this.cache_.initTime);
  }
  /**
   * Normally gets the length in time of the video in seconds;
   * in all but the rarest use cases an argument will NOT be passed to the method
   *
   * > **NOTE**: The video must have started loading before the duration can be
   * known, and depending on preload behaviour may not be known until the video starts
   * playing.
   *
   * @fires Player#durationchange
   *
   * @param {number} [seconds]
   *        The duration of the video to set in seconds
   *
   * @return {number|undefined}
   *         - The duration of the video in seconds when getting
   *         - Nothing when setting
   */
  duration(e) {
    if (e === void 0)
      return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
    e = parseFloat(e), e < 0 && (e = 1 / 0), e !== this.cache_.duration && (this.cache_.duration = e, e === 1 / 0 ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(e) || this.trigger("durationchange"));
  }
  /**
   * Calculates how much time is left in the video. Not part
   * of the native video API.
   *
   * @return {number}
   *         The time remaining in seconds
   */
  remainingTime() {
    return this.duration() - this.currentTime();
  }
  /**
   * A remaining time function that is intended to be used when
   * the time is to be displayed directly to the user.
   *
   * @return {number}
   *         The rounded time remaining in seconds
   */
  remainingTimeDisplay() {
    return Math.floor(this.duration()) - Math.floor(this.currentTime());
  }
  //
  // Kind of like an array of portions of the video that have been downloaded.
  /**
   * Get a TimeRange object with an array of the times of the video
   * that have been downloaded. If you just want the percent of the
   * video that's been downloaded, use bufferedPercent.
   *
   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */
  buffered() {
    let e = this.techGet_("buffered");
    return (!e || !e.length) && (e = dt(0, 0)), e;
  }
  /**
   * Get the TimeRanges of the media that are currently available
   * for seeking to.
   *
   * @see [Seekable Spec]{@link https://html.spec.whatwg.org/multipage/media.html#dom-media-seekable}
   *
   * @return {TimeRange}
   *         A mock {@link TimeRanges} object (following HTML spec)
   */
  seekable() {
    let e = this.techGet_("seekable");
    return (!e || !e.length) && (e = dt(0, 0)), e;
  }
  /**
   * Returns whether the player is in the "seeking" state.
   *
   * @return {boolean} True if the player is in the seeking state, false if not.
   */
  seeking() {
    return this.techGet_("seeking");
  }
  /**
   * Returns whether the player is in the "ended" state.
   *
   * @return {boolean} True if the player is in the ended state, false if not.
   */
  ended() {
    return this.techGet_("ended");
  }
  /**
   * Returns the current state of network activity for the element, from
   * the codes in the list below.
   * - NETWORK_EMPTY (numeric value 0)
   *   The element has not yet been initialised. All attributes are in
   *   their initial states.
   * - NETWORK_IDLE (numeric value 1)
   *   The element's resource selection algorithm is active and has
   *   selected a resource, but it is not actually using the network at
   *   this time.
   * - NETWORK_LOADING (numeric value 2)
   *   The user agent is actively trying to download data.
   * - NETWORK_NO_SOURCE (numeric value 3)
   *   The element's resource selection algorithm is active, but it has
   *   not yet found a resource to use.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
   * @return {number} the current network activity state
   */
  networkState() {
    return this.techGet_("networkState");
  }
  /**
   * Returns a value that expresses the current state of the element
   * with respect to rendering the current playback position, from the
   * codes in the list below.
   * - HAVE_NOTHING (numeric value 0)
   *   No information regarding the media resource is available.
   * - HAVE_METADATA (numeric value 1)
   *   Enough of the resource has been obtained that the duration of the
   *   resource is available.
   * - HAVE_CURRENT_DATA (numeric value 2)
   *   Data for the immediate current playback position is available.
   * - HAVE_FUTURE_DATA (numeric value 3)
   *   Data for the immediate current playback position is available, as
   *   well as enough data for the user agent to advance the current
   *   playback position in the direction of playback.
   * - HAVE_ENOUGH_DATA (numeric value 4)
   *   The user agent estimates that enough data is available for
   *   playback to proceed uninterrupted.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
   * @return {number} the current playback rendering state
   */
  readyState() {
    return this.techGet_("readyState");
  }
  /**
   * Get the percent (as a decimal) of the video that's been downloaded.
   * This method is not a part of the native HTML video API.
   *
   * @return {number}
   *         A decimal between 0 and 1 representing the percent
   *         that is buffered 0 being 0% and 1 being 100%
   */
  bufferedPercent() {
    return Sh(this.buffered(), this.duration());
  }
  /**
   * Get the ending time of the last buffered time range
   * This is used in the progress bar to encapsulate all time ranges.
   *
   * @return {number}
   *         The end of the last buffered time range
   */
  bufferedEnd() {
    const e = this.buffered(), t = this.duration();
    let s = e.end(e.length - 1);
    return s > t && (s = t), s;
  }
  /**
   * Get or set the current volume of the media
   *
   * @param  {number} [percentAsDecimal]
   *         The new volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         The current volume as a percent when getting
   */
  volume(e) {
    let t;
    if (e !== void 0) {
      t = Math.max(0, Math.min(1, e)), this.cache_.volume = t, this.techCall_("setVolume", t), t > 0 && this.lastVolume_(t);
      return;
    }
    return t = parseFloat(this.techGet_("volume")), isNaN(t) ? 1 : t;
  }
  /**
   * Get the current muted state, or turn mute on or off
   *
   * @param {boolean} [muted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if mute is on and getting
   *         - false if mute is off and getting
   *         - nothing if setting
   */
  muted(e) {
    if (e !== void 0) {
      this.techCall_("setMuted", e);
      return;
    }
    return this.techGet_("muted") || !1;
  }
  /**
   * Get the current defaultMuted state, or turn defaultMuted on or off. defaultMuted
   * indicates the state of muted on initial playback.
   *
   * ```js
   *   var myPlayer = videojs('some-player-id');
   *
   *   myPlayer.src("http://www.example.com/path/to/video.mp4");
   *
   *   // get, should be false
   *   console.log(myPlayer.defaultMuted());
   *   // set to true
   *   myPlayer.defaultMuted(true);
   *   // get should be true
   *   console.log(myPlayer.defaultMuted());
   * ```
   *
   * @param {boolean} [defaultMuted]
   *        - true to mute
   *        - false to unmute
   *
   * @return {boolean|undefined}
   *         - true if defaultMuted is on and getting
   *         - false if defaultMuted is off and getting
   *         - Nothing when setting
   */
  defaultMuted(e) {
    return e !== void 0 && this.techCall_("setDefaultMuted", e), this.techGet_("defaultMuted") || !1;
  }
  /**
   * Get the last volume, or set it
   *
   * @param  {number} [percentAsDecimal]
   *         The new last volume as a decimal percent:
   *         - 0 is muted/0%/off
   *         - 1.0 is 100%/full
   *         - 0.5 is half volume or 50%
   *
   * @return {number|undefined}
   *         - The current value of lastVolume as a percent when getting
   *         - Nothing when setting
   *
   * @private
   */
  lastVolume_(e) {
    if (e !== void 0 && e !== 0) {
      this.cache_.lastVolume = e;
      return;
    }
    return this.cache_.lastVolume;
  }
  /**
   * Check if current tech can support native fullscreen
   * (e.g. with built in controls like iOS)
   *
   * @return {boolean}
   *         if native fullscreen is supported
   */
  supportsFullScreen() {
    return this.techGet_("supportsFullScreen") || !1;
  }
  /**
   * Check if the player is in fullscreen mode or tell the player that it
   * is or is not in fullscreen mode.
   *
   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
   * property and instead document.fullscreenElement is used. But isFullscreen is
   * still a valuable property for internal player workings.
   *
   * @param  {boolean} [isFS]
   *         Set the players current fullscreen state
   *
   * @return {boolean|undefined}
   *         - true if fullscreen is on and getting
   *         - false if fullscreen is off and getting
   *         - Nothing when setting
   */
  isFullscreen(e) {
    if (e !== void 0) {
      const t = this.isFullscreen_;
      this.isFullscreen_ = !!e, this.isFullscreen_ !== t && this.fsApi_.prefixed && this.trigger("fullscreenchange"), this.toggleFullscreenClass_();
      return;
    }
    return this.isFullscreen_;
  }
  /**
   * Increase the size of the video to full screen
   * In some browsers, full screen is not supported natively, so it enters
   * "full window mode", where the video fills the browser window.
   * In browsers and devices that support native full screen, sometimes the
   * browser's default controls will be shown, and not the Video.js custom skin.
   * This includes most mobile devices (iOS, Android) and older versions of
   * Safari.
   *
   * @param  {Object} [fullscreenOptions]
   *         Override the player fullscreen options
   *
   * @fires Player#fullscreenchange
   */
  requestFullscreen(e) {
    this.isInPictureInPicture() && this.exitPictureInPicture();
    const t = this;
    return new Promise((s, r) => {
      function n() {
        t.off("fullscreenerror", o), t.off("fullscreenchange", a);
      }
      function a() {
        n(), s();
      }
      function o(h, m) {
        n(), r(m);
      }
      t.one("fullscreenchange", a), t.one("fullscreenerror", o);
      const l = t.requestFullscreenHelper_(e);
      l && (l.then(n, n), l.then(s, r));
    });
  }
  requestFullscreenHelper_(e) {
    let t;
    if (this.fsApi_.prefixed || (t = this.options_.fullscreen && this.options_.fullscreen.options || {}, e !== void 0 && (t = e)), this.fsApi_.requestFullscreen) {
      const s = this.el_[this.fsApi_.requestFullscreen](t);
      return s && s.then(() => this.isFullscreen(!0), () => this.isFullscreen(!1)), s;
    } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("enterFullScreen") : this.enterFullWindow();
  }
  /**
   * Return the video to its normal size after having been in full screen mode
   *
   * @fires Player#fullscreenchange
   */
  exitFullscreen() {
    const e = this;
    return new Promise((t, s) => {
      function r() {
        e.off("fullscreenerror", a), e.off("fullscreenchange", n);
      }
      function n() {
        r(), t();
      }
      function a(l, h) {
        r(), s(h);
      }
      e.one("fullscreenchange", n), e.one("fullscreenerror", a);
      const o = e.exitFullscreenHelper_();
      o && (o.then(r, r), o.then(t, s));
    });
  }
  exitFullscreenHelper_() {
    if (this.fsApi_.requestFullscreen) {
      const e = U[this.fsApi_.exitFullscreen]();
      return e && _t(e.then(() => this.isFullscreen(!1))), e;
    } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("exitFullScreen") : this.exitFullWindow();
  }
  /**
   * When fullscreen isn't supported we can stretch the
   * video container to as wide as the browser will let us.
   *
   * @fires Player#enterFullWindow
   */
  enterFullWindow() {
    this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = U.documentElement.style.overflow, et(U, "keydown", this.boundFullWindowOnEscKey_), U.documentElement.style.overflow = "hidden", fi(U.body, "vjs-full-window"), this.trigger("enterFullWindow");
  }
  /**
   * Check for call to either exit full window or
   * full screen on ESC key
   *
   * @param {string} event
   *        Event to check for key press
   */
  fullWindowOnEscKey(e) {
    e.key === "Escape" && this.isFullscreen() === !0 && (this.isFullWindow ? this.exitFullWindow() : this.exitFullscreen());
  }
  /**
   * Exit full window
   *
   * @fires Player#exitFullWindow
   */
  exitFullWindow() {
    this.isFullscreen(!1), this.isFullWindow = !1, Pe(U, "keydown", this.boundFullWindowOnEscKey_), U.documentElement.style.overflow = this.docOrigOverflow, On(U.body, "vjs-full-window"), this.trigger("exitFullWindow");
  }
  /**
   * Get or set disable Picture-in-Picture mode.
   *
   * @param {boolean} [value]
   *                  - true will disable Picture-in-Picture mode
   *                  - false will enable Picture-in-Picture mode
   */
  disablePictureInPicture(e) {
    if (e === void 0)
      return this.techGet_("disablePictureInPicture");
    this.techCall_("setDisablePictureInPicture", e), this.options_.disablePictureInPicture = e, this.trigger("disablepictureinpicturechanged");
  }
  /**
   * Check if the player is in Picture-in-Picture mode or tell the player that it
   * is or is not in Picture-in-Picture mode.
   *
   * @param  {boolean} [isPiP]
   *         Set the players current Picture-in-Picture state
   *
   * @return {boolean|undefined}
   *         - true if Picture-in-Picture is on and getting
   *         - false if Picture-in-Picture is off and getting
   *         - nothing if setting
   */
  isInPictureInPicture(e) {
    if (e !== void 0) {
      this.isInPictureInPicture_ = !!e, this.togglePictureInPictureClass_();
      return;
    }
    return !!this.isInPictureInPicture_;
  }
  /**
   * Create a floating video window always on top of other windows so that users may
   * continue consuming media while they interact with other content sites, or
   * applications on their device.
   *
   * This can use document picture-in-picture or element picture in picture
   *
   * Set `enableDocumentPictureInPicture` to `true` to use docPiP on a supported browser
   * Else set `disablePictureInPicture` to `false` to disable elPiP on a supported browser
   *
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/}
   * @see [Spec]{@link https://wicg.github.io/document-picture-in-picture/}
   *
   * @fires Player#enterpictureinpicture
   *
   * @return {Promise}
   *         A promise with a Picture-in-Picture window.
   */
  requestPictureInPicture() {
    if (this.options_.enableDocumentPictureInPicture && S.documentPictureInPicture) {
      const e = U.createElement(this.el().tagName);
      return e.classList = this.el().classList, e.classList.add("vjs-pip-container"), this.posterImage && e.appendChild(this.posterImage.el().cloneNode(!0)), this.titleBar && e.appendChild(this.titleBar.el().cloneNode(!0)), e.appendChild(W("p", {
        className: "vjs-pip-text"
      }, {}, this.localize("Playing in picture-in-picture"))), S.documentPictureInPicture.requestWindow({
        // The aspect ratio won't be correct, Chrome bug https://crbug.com/1407629
        width: this.videoWidth(),
        height: this.videoHeight()
      }).then((t) => (ch(t), this.el_.parentNode.insertBefore(e, this.el_), t.document.body.appendChild(this.el_), t.document.body.classList.add("vjs-pip-window"), this.player_.isInPictureInPicture(!0), this.player_.trigger({
        type: "enterpictureinpicture",
        pipWindow: t
      }), t.addEventListener("pagehide", (s) => {
        const r = s.target.querySelector(".video-js");
        e.parentNode.replaceChild(r, e), this.player_.isInPictureInPicture(!1), this.player_.trigger("leavepictureinpicture");
      }), t));
    }
    return "pictureInPictureEnabled" in U && this.disablePictureInPicture() === !1 ? this.techGet_("requestPictureInPicture") : Promise.reject("No PiP mode is available");
  }
  /**
   * Exit Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://wicg.github.io/picture-in-picture}
   *
   * @fires Player#leavepictureinpicture
   *
   * @return {Promise}
   *         A promise.
   */
  exitPictureInPicture() {
    if (S.documentPictureInPicture && S.documentPictureInPicture.window)
      return S.documentPictureInPicture.window.close(), Promise.resolve();
    if ("pictureInPictureEnabled" in U)
      return U.exitPictureInPicture();
  }
  /**
   * Called when this Player has focus and a key gets pressed down, or when
   * any Component of this player receives a key press that it doesn't handle.
   * This allows player-wide hotkeys (either as defined below, or optionally
   * by an external function).
   *
   * @param {KeyboardEvent} event
   *        The `keydown` event that caused this function to be called.
   *
   * @listens keydown
   */
  handleKeyDown(e) {
    const {
      userActions: t
    } = this.options_;
    !t || !t.hotkeys || ((r) => {
      const n = r.tagName.toLowerCase();
      if (r.isContentEditable)
        return !0;
      const a = ["button", "checkbox", "hidden", "radio", "reset", "submit"];
      return n === "input" ? a.indexOf(r.type) === -1 : ["textarea"].indexOf(n) !== -1;
    })(this.el_.ownerDocument.activeElement) || (typeof t.hotkeys == "function" ? t.hotkeys.call(this, e) : this.handleHotkeys(e));
  }
  /**
   * Called when this Player receives a hotkey keydown event.
   * Supported player-wide hotkeys are:
   *
   *   f          - toggle fullscreen
   *   m          - toggle mute
   *   k or Space - toggle play/pause
   *
   * @param {Event} event
   *        The `keydown` event that caused this function to be called.
   */
  handleHotkeys(e) {
    const t = this.options_.userActions ? this.options_.userActions.hotkeys : {}, {
      fullscreenKey: s = (a) => e.key.toLowerCase() === "f",
      muteKey: r = (a) => e.key.toLowerCase() === "m",
      playPauseKey: n = (a) => e.key.toLowerCase() === "k" || e.key.toLowerCase() === " "
    } = t;
    if (s.call(this, e)) {
      e.preventDefault(), e.stopPropagation();
      const a = M.getComponent("FullscreenToggle");
      U[this.fsApi_.fullscreenEnabled] !== !1 && a.prototype.handleClick.call(this, e);
    } else r.call(this, e) ? (e.preventDefault(), e.stopPropagation(), M.getComponent("MuteToggle").prototype.handleClick.call(this, e)) : n.call(this, e) && (e.preventDefault(), e.stopPropagation(), M.getComponent("PlayToggle").prototype.handleClick.call(this, e));
  }
  /**
   * Check whether the player can play a given mimetype
   *
   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
   *
   * @param {string} type
   *        The mimetype to check
   *
   * @return {string}
   *         'probably', 'maybe', or '' (empty string)
   */
  canPlayType(e) {
    let t;
    for (let s = 0, r = this.options_.techOrder; s < r.length; s++) {
      const n = r[s];
      let a = Y.getTech(n);
      if (a || (a = M.getComponent(n)), !a) {
        Q.error(`The "${n}" tech is undefined. Skipped browser support check for that tech.`);
        continue;
      }
      if (a.isSupported() && (t = a.canPlayType(e), t))
        return t;
    }
    return "";
  }
  /**
   * Select source based on tech-order or source-order
   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
   * defaults to tech-order selection
   *
   * @param {Array} sources
   *        The sources for a media asset
   *
   * @return {Object|boolean}
   *         Object of source and tech order or false
   */
  selectSource(e) {
    const t = this.options_.techOrder.map((o) => [o, Y.getTech(o)]).filter(([o, l]) => l ? l.isSupported() : (Q.error(`The "${o}" tech is undefined. Skipped browser support check for that tech.`), !1)), s = function(o, l, h) {
      let m;
      return o.some((_) => l.some((v) => {
        if (m = h(_, v), m)
          return !0;
      })), m;
    };
    let r;
    const n = (o) => (l, h) => o(h, l), a = ([o, l], h) => {
      if (l.canPlaySource(h, this.options_[o.toLowerCase()]))
        return {
          source: h,
          tech: o
        };
    };
    return this.options_.sourceOrder ? r = s(e, t, n(a)) : r = s(t, e, a), r || !1;
  }
  /**
   * Executes source setting and getting logic
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   * @param {boolean} [isRetry]
   *        Indicates whether this is being called internally as a result of a retry
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */
  handleSrc_(e, t) {
    if (typeof e > "u")
      return this.cache_.src || "";
    this.resetRetryOnError_ && this.resetRetryOnError_();
    const s = wh(e);
    if (!s.length) {
      this.setTimeout(function() {
        this.error({
          code: 4,
          message: this.options_.notSupportedMessage
        });
      }, 0);
      return;
    }
    if (this.changingSrc_ = !0, t || (this.cache_.sources = s), this.updateSourceCaches_(s[0]), uT(this, s[0], (r, n) => {
      if (this.middleware_ = n, t || (this.cache_.sources = s), this.updateSourceCaches_(r), this.src_(r)) {
        if (s.length > 1)
          return this.handleSrc_(s.slice(1));
        this.changingSrc_ = !1, this.setTimeout(function() {
          this.error({
            code: 4,
            message: this.options_.notSupportedMessage
          });
        }, 0), this.triggerReady();
        return;
      }
      lT(n, this.tech_);
    }), s.length > 1) {
      const r = () => {
        this.error(null), this.handleSrc_(s.slice(1), !0);
      }, n = () => {
        this.off("error", r);
      };
      this.one("error", r), this.one("playing", n), this.resetRetryOnError_ = () => {
        this.off("error", r), this.off("playing", n);
      };
    }
  }
  /**
   * Get or set the video source.
   *
   * @param {Tech~SourceObject|Tech~SourceObject[]|string} [source]
   *        A SourceObject, an array of SourceObjects, or a string referencing
   *        a URL to a media source. It is _highly recommended_ that an object
   *        or array of objects is used here, so that source selection
   *        algorithms can take the `type` into account.
   *
   *        If not provided, this method acts as a getter.
   *
   * @return {string|undefined}
   *         If the `source` argument is missing, returns the current source
   *         URL. Otherwise, returns nothing/undefined.
   */
  src(e) {
    return this.handleSrc_(e, !1);
  }
  /**
   * Set the source object on the tech, returns a boolean that indicates whether
   * there is a tech that can play the source or not
   *
   * @param {Tech~SourceObject} source
   *        The source object to set on the Tech
   *
   * @return {boolean}
   *         - True if there is no Tech to playback this source
   *         - False otherwise
   *
   * @private
   */
  src_(e) {
    const t = this.selectSource([e]);
    return t ? Th(t.tech, this.techName_) ? (this.ready(function() {
      this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", e) : this.techCall_("src", e.src), this.changingSrc_ = !1;
    }, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(t.tech, t.source), this.tech_.ready(() => {
      this.changingSrc_ = !1;
    }), !1) : !0;
  }
  /**
   * Add a <source> element to the <video> element.
   *
   * @param {string} srcUrl
   *        The URL of the video source.
   *
   * @param {string} [mimeType]
   *        The MIME type of the video source. Optional but recommended.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully added, false otherwise.
   */
  addSourceElement(e, t) {
    return this.tech_ ? this.tech_.addSourceElement(e, t) : !1;
  }
  /**
   * Remove a <source> element from the <video> element by its URL.
   *
   * @param {string} srcUrl
   *        The URL of the source to remove.
   *
   * @return {boolean}
   *         Returns true if the source element was successfully removed, false otherwise.
   */
  removeSourceElement(e) {
    return this.tech_ ? this.tech_.removeSourceElement(e) : !1;
  }
  /**
   * Begin loading the src data.
   */
  load() {
    if (this.tech_ && this.tech_.vhs) {
      this.src(this.currentSource());
      return;
    }
    this.techCall_("load");
  }
  /**
   * Reset the player. Loads the first tech in the techOrder,
   * removes all the text tracks in the existing `tech`,
   * and calls `reset` on the `tech`.
   */
  reset() {
    if (this.paused())
      this.doReset_();
    else {
      const e = this.play();
      _t(e.then(() => this.doReset_()));
    }
  }
  doReset_() {
    this.tech_ && this.tech_.clearTracks("text"), this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), this.error(null), this.titleBar && this.titleBar.update({
      title: void 0,
      description: void 0
    }), Rt(this) && this.trigger("playerreset");
  }
  /**
   * Reset Control Bar's UI by calling sub-methods that reset
   * all of Control Bar's components
   */
  resetControlBarUI_() {
    this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
  }
  /**
   * Reset tech's progress so progress bar is reset in the UI
   */
  resetProgressBar_() {
    this.currentTime(0);
    const {
      currentTimeDisplay: e,
      durationDisplay: t,
      progressControl: s,
      remainingTimeDisplay: r
    } = this.controlBar || {}, {
      seekBar: n
    } = s || {};
    e && e.updateContent(), t && t.updateContent(), r && r.updateContent(), n && (n.update(), n.loadProgressBar && n.loadProgressBar.update());
  }
  /**
   * Reset Playback ratio
   */
  resetPlaybackRate_() {
    this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
  }
  /**
   * Reset Volume bar
   */
  resetVolumeBar_() {
    this.volume(1), this.trigger("volumechange");
  }
  /**
   * Returns all of the current source objects.
   *
   * @return {Tech~SourceObject[]}
   *         The current source objects
   */
  currentSources() {
    const e = this.currentSource(), t = [];
    return Object.keys(e).length !== 0 && t.push(e), this.cache_.sources || t;
  }
  /**
   * Returns the current source object.
   *
   * @return {Tech~SourceObject}
   *         The current source object
   */
  currentSource() {
    return this.cache_.source || {};
  }
  /**
   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
   * Can be used in conjunction with `currentType` to assist in rebuilding the current source object.
   *
   * @return {string}
   *         The current source
   */
  currentSrc() {
    return this.currentSource() && this.currentSource().src || "";
  }
  /**
   * Get the current source type e.g. video/mp4
   * This can allow you rebuild the current source object so that you could load the same
   * source and tech later
   *
   * @return {string}
   *         The source MIME type
   */
  currentType() {
    return this.currentSource() && this.currentSource().type || "";
  }
  /**
   * Get or set the preload attribute
   *
   * @param {'none'|'auto'|'metadata'} [value]
   *        Preload mode to pass to tech
   *
   * @return {string|undefined}
   *         - The preload attribute value when getting
   *         - Nothing when setting
   */
  preload(e) {
    if (e !== void 0) {
      this.techCall_("setPreload", e), this.options_.preload = e;
      return;
    }
    return this.techGet_("preload");
  }
  /**
   * Get or set the autoplay option. When this is a boolean it will
   * modify the attribute on the tech. When this is a string the attribute on
   * the tech will be removed and `Player` will handle autoplay on loadstarts.
   *
   * @param {boolean|'play'|'muted'|'any'} [value]
   *        - true: autoplay using the browser behavior
   *        - false: do not autoplay
   *        - 'play': call play() on every loadstart
   *        - 'muted': call muted() then play() on every loadstart
   *        - 'any': call play() on every loadstart. if that fails call muted() then play().
   *        - *: values other than those listed here will be set `autoplay` to true
   *
   * @return {boolean|string|undefined}
   *         - The current value of autoplay when getting
   *         - Nothing when setting
   */
  autoplay(e) {
    if (e === void 0)
      return this.options_.autoplay || !1;
    let t;
    typeof e == "string" && /(any|play|muted)/.test(e) || e === !0 && this.options_.normalizeAutoplay ? (this.options_.autoplay = e, this.manualAutoplay_(typeof e == "string" ? e : "play"), t = !1) : e ? this.options_.autoplay = !0 : this.options_.autoplay = !1, t = typeof t > "u" ? this.options_.autoplay : t, this.tech_ && this.techCall_("setAutoplay", t);
  }
  /**
   * Set or unset the playsinline attribute.
   * Playsinline tells the browser that non-fullscreen playback is preferred.
   *
   * @param {boolean} [value]
   *        - true means that we should try to play inline by default
   *        - false means that we should use the browser's default playback mode,
   *          which in most cases is inline. iOS Safari is a notable exception
   *          and plays fullscreen by default.
   *
   * @return {string|undefined}
   *         - the current value of playsinline
   *         - Nothing when setting
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  playsinline(e) {
    return e !== void 0 && (this.techCall_("setPlaysinline", e), this.options_.playsinline = e), this.techGet_("playsinline");
  }
  /**
   * Get or set the loop attribute on the video element.
   *
   * @param {boolean} [value]
   *        - true means that we should loop the video
   *        - false means that we should not loop the video
   *
   * @return {boolean|undefined}
   *         - The current value of loop when getting
   *         - Nothing when setting
   */
  loop(e) {
    if (e !== void 0) {
      this.techCall_("setLoop", e), this.options_.loop = e;
      return;
    }
    return this.techGet_("loop");
  }
  /**
   * Get or set the poster image source url
   *
   * @fires Player#posterchange
   *
   * @param {string} [src]
   *        Poster image source URL
   *
   * @return {string|undefined}
   *         - The current value of poster when getting
   *         - Nothing when setting
   */
  poster(e) {
    if (e === void 0)
      return this.poster_;
    e || (e = ""), e !== this.poster_ && (this.poster_ = e, this.techCall_("setPoster", e), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
  }
  /**
   * Some techs (e.g. YouTube) can provide a poster source in an
   * asynchronous way. We want the poster component to use this
   * poster source so that it covers up the tech's controls.
   * (YouTube's play button). However we only want to use this
   * source if the player user hasn't set a poster through
   * the normal APIs.
   *
   * @fires Player#posterchange
   * @listens Tech#posterchange
   * @private
   */
  handleTechPosterChange_() {
    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
      const e = this.tech_.poster() || "";
      e !== this.poster_ && (this.poster_ = e, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
    }
  }
  /**
   * Get or set whether or not the controls are showing.
   *
   * @fires Player#controlsenabled
   *
   * @param {boolean} [bool]
   *        - true to turn controls on
   *        - false to turn controls off
   *
   * @return {boolean|undefined}
   *         - The current value of controls when getting
   *         - Nothing when setting
   */
  controls(e) {
    if (e === void 0)
      return !!this.controls_;
    e = !!e, this.controls_ !== e && (this.controls_ = e, this.usingNativeControls() && this.techCall_("setControls", e), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
  }
  /**
   * Toggle native controls on/off. Native controls are the controls built into
   * devices (e.g. default iPhone controls) or other techs
   * (e.g. Vimeo Controls)
   * **This should only be set by the current tech, because only the tech knows
   * if it can support native controls**
   *
   * @fires Player#usingnativecontrols
   * @fires Player#usingcustomcontrols
   *
   * @param {boolean} [bool]
   *        - true to turn native controls on
   *        - false to turn native controls off
   *
   * @return {boolean|undefined}
   *         - The current value of native controls when getting
   *         - Nothing when setting
   */
  usingNativeControls(e) {
    if (e === void 0)
      return !!this.usingNativeControls_;
    e = !!e, this.usingNativeControls_ !== e && (this.usingNativeControls_ = e, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
  }
  /**
   * Set or get the current MediaError
   *
   * @fires Player#error
   *
   * @param  {MediaError|string|number} [err]
   *         A MediaError or a string/number to be turned
   *         into a MediaError
   *
   * @return {MediaError|null|undefined}
   *         - The current MediaError when getting (or null)
   *         - Nothing when setting
   */
  error(e) {
    if (e === void 0)
      return this.error_ || null;
    if (Xt("beforeerror").forEach((t) => {
      const s = t(this, e);
      if (!(St(s) && !Array.isArray(s) || typeof s == "string" || typeof s == "number" || s === null)) {
        this.log.error("please return a value that MediaError expects in beforeerror hooks");
        return;
      }
      e = s;
    }), this.options_.suppressNotSupportedError && e && e.code === 4) {
      const t = function() {
        this.error(e);
      };
      this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], t), this.one("loadstart", function() {
        this.off(["click", "touchstart"], t);
      });
      return;
    }
    if (e === null) {
      this.error_ = null, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
      return;
    }
    this.error_ = new ge(e), this.addClass("vjs-error"), Q.error(`(CODE:${this.error_.code} ${ge.errorTypes[this.error_.code]})`, this.error_.message, this.error_), this.trigger("error"), Xt("error").forEach((t) => t(this, this.error_));
  }
  /**
   * Report user activity
   *
   * @param {Object} event
   *        Event object
   */
  reportUserActivity(e) {
    this.userActivity_ = !0;
  }
  /**
   * Get/set if user is active
   *
   * @fires Player#useractive
   * @fires Player#userinactive
   *
   * @param {boolean} [bool]
   *        - true if the user is active
   *        - false if the user is inactive
   *
   * @return {boolean|undefined}
   *         - The current value of userActive when getting
   *         - Nothing when setting
   */
  userActive(e) {
    if (e === void 0)
      return this.userActive_;
    if (e = !!e, e !== this.userActive_) {
      if (this.userActive_ = e, this.userActive_) {
        this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
        return;
      }
      this.tech_ && this.tech_.one("mousemove", function(t) {
        t.stopPropagation(), t.preventDefault();
      }), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
    }
  }
  /**
   * Listen for user activity based on timeout value
   *
   * @private
   */
  listenForUserActivity_() {
    let e, t, s;
    const r = le(this, this.reportUserActivity), n = function(_) {
      (_.screenX !== t || _.screenY !== s) && (t = _.screenX, s = _.screenY, r());
    }, a = function() {
      r(), this.clearInterval(e), e = this.setInterval(r, 250);
    }, o = function(_) {
      r(), this.clearInterval(e);
    };
    this.on("mousedown", a), this.on("mousemove", n), this.on("mouseup", o), this.on("mouseleave", o);
    const l = this.getChild("controlBar");
    l && !je && !Et && (l.on("mouseenter", function(_) {
      this.player().options_.inactivityTimeout !== 0 && (this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout), this.player().options_.inactivityTimeout = 0;
    }), l.on("mouseleave", function(_) {
      this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
    })), this.on("keydown", r), this.on("keyup", r);
    let h;
    const m = function() {
      if (!this.userActivity_)
        return;
      this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(h);
      const _ = this.options_.inactivityTimeout;
      _ <= 0 || (h = this.setTimeout(function() {
        this.userActivity_ || this.userActive(!1);
      }, _));
    };
    this.setInterval(m, 250);
  }
  /**
   * Gets or sets the current playback rate. A playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed
   * playback, for instance.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
   *
   * @param {number} [rate]
   *       New playback rate to set.
   *
   * @return {number|undefined}
   *         - The current playback rate when getting or 1.0
   *         - Nothing when setting
   */
  playbackRate(e) {
    if (e !== void 0) {
      this.techCall_("setPlaybackRate", e);
      return;
    }
    return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
  }
  /**
   * Gets or sets the current default playback rate. A default playback rate of
   * 1.0 represents normal speed and 0.5 would indicate half-speed playback, for instance.
   * defaultPlaybackRate will only represent what the initial playbackRate of a video was, not
   * not the current playbackRate.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-defaultplaybackrate
   *
   * @param {number} [rate]
   *       New default playback rate to set.
   *
   * @return {number|undefined}
   *         - The default playback rate when getting or 1.0
   *         - Nothing when setting
   */
  defaultPlaybackRate(e) {
    return e !== void 0 ? this.techCall_("setDefaultPlaybackRate", e) : this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1;
  }
  /**
   * Gets or sets the audio flag
   *
   * @param {boolean} [bool]
   *        - true signals that this is an audio player
   *        - false signals that this is not an audio player
   *
   * @return {boolean|undefined}
   *         - The current value of isAudio when getting
   *         - Nothing when setting
   */
  isAudio(e) {
    if (e !== void 0) {
      this.isAudio_ = !!e;
      return;
    }
    return !!this.isAudio_;
  }
  updatePlayerHeightOnAudioOnlyMode_() {
    const e = this.getChild("ControlBar");
    !e || this.audioOnlyCache_.controlBarHeight === e.currentHeight() || (this.audioOnlyCache_.controlBarHeight = e.currentHeight(), this.height(this.audioOnlyCache_.controlBarHeight));
  }
  enableAudioOnlyUI_() {
    this.addClass("vjs-audio-only-mode");
    const e = this.children(), t = this.getChild("ControlBar"), s = t && t.currentHeight();
    e.forEach((r) => {
      r !== t && r.el_ && !r.hasClass("vjs-hidden") && (r.hide(), this.audioOnlyCache_.hiddenChildren.push(r));
    }), this.audioOnlyCache_.playerHeight = this.currentHeight(), this.audioOnlyCache_.controlBarHeight = s, this.on("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.height(s), this.trigger("audioonlymodechange");
  }
  disableAudioOnlyUI_() {
    this.removeClass("vjs-audio-only-mode"), this.off("playerresize", this.boundUpdatePlayerHeightOnAudioOnlyMode_), this.audioOnlyCache_.hiddenChildren.forEach((e) => e.show()), this.height(this.audioOnlyCache_.playerHeight), this.trigger("audioonlymodechange");
  }
  /**
   * Get the current audioOnlyMode state or set audioOnlyMode to true or false.
   *
   * Setting this to `true` will hide all player components except the control bar,
   * as well as control bar components needed only for video.
   *
   * @param {boolean} [value]
   *         The value to set audioOnlyMode to.
   *
   * @return {Promise|boolean}
   *        A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */
  audioOnlyMode(e) {
    if (typeof e != "boolean" || e === this.audioOnlyMode_)
      return this.audioOnlyMode_;
    if (this.audioOnlyMode_ = e, e) {
      const t = [];
      return this.isInPictureInPicture() && t.push(this.exitPictureInPicture()), this.isFullscreen() && t.push(this.exitFullscreen()), this.audioPosterMode() && t.push(this.audioPosterMode(!1)), Promise.all(t).then(() => this.enableAudioOnlyUI_());
    }
    return Promise.resolve().then(() => this.disableAudioOnlyUI_());
  }
  enablePosterModeUI_() {
    (this.tech_ && this.tech_).hide(), this.addClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }
  disablePosterModeUI_() {
    (this.tech_ && this.tech_).show(), this.removeClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }
  /**
   * Get the current audioPosterMode state or set audioPosterMode to true or false
   *
   * @param {boolean} [value]
   *         The value to set audioPosterMode to.
   *
   * @return {Promise|boolean}
   *         A Promise is returned when setting the state, and a boolean when getting
   *        the present state
   */
  audioPosterMode(e) {
    return typeof e != "boolean" || e === this.audioPosterMode_ ? this.audioPosterMode_ : (this.audioPosterMode_ = e, e ? this.audioOnlyMode() ? this.audioOnlyMode(!1).then(() => {
      this.enablePosterModeUI_();
    }) : Promise.resolve().then(() => {
      this.enablePosterModeUI_();
    }) : Promise.resolve().then(() => {
      this.disablePosterModeUI_();
    }));
  }
  /**
   * A helper method for adding a {@link TextTrack} to our
   * {@link TextTrackList}.
   *
   * In addition to the W3C settings we allow adding additional info through options.
   *
   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
   *
   * @param {string} [kind]
   *        the kind of TextTrack you are adding
   *
   * @param {string} [label]
   *        the label to give the TextTrack label
   *
   * @param {string} [language]
   *        the language to set on the TextTrack
   *
   * @return {TextTrack|undefined}
   *         the TextTrack that was added or undefined
   *         if there is no tech
   */
  addTextTrack(e, t, s) {
    if (this.tech_)
      return this.tech_.addTextTrack(e, t, s);
  }
  /**
   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}.
   *
   * @param {Object} options
   *        Options to pass to {@link HTMLTrackElement} during creation. See
   *        {@link HTMLTrackElement} for object properties that you should use.
   *
   * @param {boolean} [manualCleanup=false] if set to true, the TextTrack will not be removed
   *                                        from the TextTrackList and HtmlTrackElementList
   *                                        after a source change
   *
   * @return {HtmlTrackElement}
   *         the HTMLTrackElement that was created and added
   *         to the HtmlTrackElementList and the remote
   *         TextTrackList
   *
   */
  addRemoteTextTrack(e, t) {
    if (this.tech_)
      return this.tech_.addRemoteTextTrack(e, t);
  }
  /**
   * Remove a remote {@link TextTrack} from the respective
   * {@link TextTrackList} and {@link HtmlTrackElementList}.
   *
   * @param {Object} track
   *        Remote {@link TextTrack} to remove
   *
   * @return {undefined}
   *         does not return anything
   */
  removeRemoteTextTrack(e = {}) {
    let {
      track: t
    } = e;
    if (t || (t = e), this.tech_)
      return this.tech_.removeRemoteTextTrack(t);
  }
  /**
   * Gets available media playback quality metrics as specified by the W3C's Media
   * Playback Quality API.
   *
   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
   *
   * @return {Object|undefined}
   *         An object with supported media playback quality metrics or undefined if there
   *         is no tech or the tech does not support it.
   */
  getVideoPlaybackQuality() {
    return this.techGet_("getVideoPlaybackQuality");
  }
  /**
   * Get video width
   *
   * @return {number}
   *         current video width
   */
  videoWidth() {
    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
  }
  /**
   * Get video height
   *
   * @return {number}
   *         current video height
   */
  videoHeight() {
    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
  }
  /**
   * Set or get the player's language code.
   *
   * Changing the language will trigger
   * [languagechange]{@link Player#event:languagechange}
   * which Components can use to update control text.
   * ClickableComponent will update its control text by default on
   * [languagechange]{@link Player#event:languagechange}.
   *
   * @fires Player#languagechange
   *
   * @param {string} [code]
   *        the language code to set the player to
   *
   * @return {string|undefined}
   *         - The current language code when getting
   *         - Nothing when setting
   */
  language(e) {
    if (e === void 0)
      return this.language_;
    this.language_ !== String(e).toLowerCase() && (this.language_ = String(e).toLowerCase(), Rt(this) && this.trigger("languagechange"));
  }
  /**
   * Get the player's language dictionary
   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
   * Languages specified directly in the player options have precedence
   *
   * @return {Array}
   *         An array of of supported languages
   */
  languages() {
    return oe(de.prototype.options_.languages, this.languages_);
  }
  /**
   * returns a JavaScript object representing the current track
   * information. **DOES not return it as JSON**
   *
   * @return {Object}
   *         Object representing the current of track info
   */
  toJSON() {
    const e = oe(this.options_), t = e.tracks;
    e.tracks = [];
    for (let s = 0; s < t.length; s++) {
      let r = t[s];
      r = oe(r), r.player = void 0, e.tracks[s] = r;
    }
    return e;
  }
  /**
   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
   * component) that immediately overlays the player with arbitrary
   * content and removes itself when closed.
   *
   * @param {string|Function|Element|Array|null} content
   *        Same as {@link ModalDialog#content}'s param of the same name.
   *        The most straight-forward usage is to provide a string or DOM
   *        element.
   *
   * @param {Object} [options]
   *        Extra options which will be passed on to the {@link ModalDialog}.
   *
   * @return {ModalDialog}
   *         the {@link ModalDialog} that was created
   */
  createModal(e, t) {
    t = t || {}, t.content = e || "";
    const s = new ns(this, t);
    return this.addChild(s), s.on("dispose", () => {
      this.removeChild(s);
    }), s.open(), s;
  }
  /**
   * Change breakpoint classes when the player resizes.
   *
   * @private
   */
  updateCurrentBreakpoint_() {
    if (!this.responsive())
      return;
    const e = this.currentBreakpoint(), t = this.currentWidth();
    for (let s = 0; s < Qa.length; s++) {
      const r = Qa[s], n = this.breakpoints_[r];
      if (t <= n) {
        if (e === r)
          return;
        e && this.removeClass(qr[e]), this.addClass(qr[r]), this.breakpoint_ = r;
        break;
      }
    }
  }
  /**
   * Removes the current breakpoint.
   *
   * @private
   */
  removeCurrentBreakpoint_() {
    const e = this.currentBreakpointClass();
    this.breakpoint_ = "", e && this.removeClass(e);
  }
  /**
   * Get or set breakpoints on the player.
   *
   * Calling this method with an object or `true` will remove any previous
   * custom breakpoints and start from the defaults again.
   *
   * @param  {Object|boolean} [breakpoints]
   *         If an object is given, it can be used to provide custom
   *         breakpoints. If `true` is given, will set default breakpoints.
   *         If this argument is not given, will simply return the current
   *         breakpoints.
   *
   * @param  {number} [breakpoints.tiny]
   *         The maximum width for the "vjs-layout-tiny" class.
   *
   * @param  {number} [breakpoints.xsmall]
   *         The maximum width for the "vjs-layout-x-small" class.
   *
   * @param  {number} [breakpoints.small]
   *         The maximum width for the "vjs-layout-small" class.
   *
   * @param  {number} [breakpoints.medium]
   *         The maximum width for the "vjs-layout-medium" class.
   *
   * @param  {number} [breakpoints.large]
   *         The maximum width for the "vjs-layout-large" class.
   *
   * @param  {number} [breakpoints.xlarge]
   *         The maximum width for the "vjs-layout-x-large" class.
   *
   * @param  {number} [breakpoints.huge]
   *         The maximum width for the "vjs-layout-huge" class.
   *
   * @return {Object}
   *         An object mapping breakpoint names to maximum width values.
   */
  breakpoints(e) {
    return e === void 0 ? Object.assign(this.breakpoints_) : (this.breakpoint_ = "", this.breakpoints_ = Object.assign({}, YT, e), this.updateCurrentBreakpoint_(), Object.assign(this.breakpoints_));
  }
  /**
   * Get or set a flag indicating whether or not this player should adjust
   * its UI based on its dimensions.
   *
   * @param  {boolean} [value]
   *         Should be `true` if the player should adjust its UI based on its
   *         dimensions; otherwise, should be `false`.
   *
   * @return {boolean|undefined}
   *         Will be `true` if this player should adjust its UI based on its
   *         dimensions; otherwise, will be `false`.
   *         Nothing if setting
   */
  responsive(e) {
    if (e === void 0)
      return this.responsive_;
    e = !!e;
    const t = this.responsive_;
    if (e !== t)
      return this.responsive_ = e, e ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), e;
  }
  /**
   * Get current breakpoint name, if any.
   *
   * @return {string}
   *         If there is currently a breakpoint set, returns a the key from the
   *         breakpoints object matching it. Otherwise, returns an empty string.
   */
  currentBreakpoint() {
    return this.breakpoint_;
  }
  /**
   * Get the current breakpoint class name.
   *
   * @return {string}
   *         The matching class name (e.g. `"vjs-layout-tiny"` or
   *         `"vjs-layout-large"`) for the current breakpoint. Empty string if
   *         there is no current breakpoint.
   */
  currentBreakpointClass() {
    return qr[this.breakpoint_] || "";
  }
  /**
   * An object that describes a single piece of media.
   *
   * Properties that are not part of this type description will be retained; so,
   * this can be viewed as a generic metadata storage mechanism as well.
   *
   * @see      {@link https://wicg.github.io/mediasession/#the-mediametadata-interface}
   * @typedef  {Object} Player~MediaObject
   *
   * @property {string} [album]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {string} [artist]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [artwork]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API. If not specified, will be populated via the `poster`, if
   *           available.
   *
   * @property {string} [poster]
   *           URL to an image that will display before playback.
   *
   * @property {Tech~SourceObject|Tech~SourceObject[]|string} [src]
   *           A single source object, an array of source objects, or a string
   *           referencing a URL to a media source. It is _highly recommended_
   *           that an object or array of objects is used here, so that source
   *           selection algorithms can take the `type` into account.
   *
   * @property {string} [title]
   *           Unused, except if this object is passed to the `MediaSession`
   *           API.
   *
   * @property {Object[]} [textTracks]
   *           An array of objects to be used to create text tracks, following
   *           the {@link https://www.w3.org/TR/html50/embedded-content-0.html#the-track-element|native track element format}.
   *           For ease of removal, these will be created as "remote" text
   *           tracks and set to automatically clean up on source changes.
   *
   *           These objects may have properties like `src`, `kind`, `label`,
   *           and `language`, see {@link Tech#createRemoteTextTrack}.
   */
  /**
   * Populate the player using a {@link Player~MediaObject|MediaObject}.
   *
   * @param  {Player~MediaObject} media
   *         A media object.
   *
   * @param  {Function} ready
   *         A callback to be called when the player is ready.
   */
  loadMedia(e, t) {
    if (!e || typeof e != "object")
      return;
    const s = this.crossOrigin();
    this.reset(), this.cache_.media = oe(e);
    const {
      artist: r,
      artwork: n,
      description: a,
      poster: o,
      src: l,
      textTracks: h,
      title: m
    } = this.cache_.media;
    !n && o && (this.cache_.media.artwork = [{
      src: o,
      type: on(o)
    }]), s && this.crossOrigin(s), l && this.src(l), o && this.poster(o), Array.isArray(h) && h.forEach((_) => this.addRemoteTextTrack(_, !1)), this.titleBar && this.titleBar.update({
      title: m,
      description: a || r || ""
    }), this.ready(t);
  }
  /**
   * Get a clone of the current {@link Player~MediaObject} for this player.
   *
   * If the `loadMedia` method has not been used, will attempt to return a
   * {@link Player~MediaObject} based on the current state of the player.
   *
   * @return {Player~MediaObject}
   */
  getMedia() {
    if (!this.cache_.media) {
      const e = this.poster(), t = this.currentSources(), s = Array.prototype.map.call(this.remoteTextTracks(), (n) => ({
        kind: n.kind,
        label: n.label,
        language: n.language,
        src: n.src
      })), r = {
        src: t,
        textTracks: s
      };
      return e && (r.poster = e, r.artwork = [{
        src: r.poster,
        type: on(r.poster)
      }]), r;
    }
    return oe(this.cache_.media);
  }
  /**
   * Gets tag settings
   *
   * @param {Element} tag
   *        The player tag
   *
   * @return {Object}
   *         An object containing all of the settings
   *         for a player tag
   */
  static getTagSettings(e) {
    const t = {
      sources: [],
      tracks: []
    }, s = Gt(e), r = s["data-setup"];
    if (Ms(e, "vjs-fill") && (s.fill = !0), Ms(e, "vjs-fluid") && (s.fluid = !0), r !== null)
      try {
        Object.assign(s, JSON.parse(r || "{}"));
      } catch (n) {
        Q.error("data-setup", n);
      }
    if (Object.assign(t, s), e.hasChildNodes()) {
      const n = e.childNodes;
      for (let a = 0, o = n.length; a < o; a++) {
        const l = n[a], h = l.nodeName.toLowerCase();
        h === "source" ? t.sources.push(Gt(l)) : h === "track" && t.tracks.push(Gt(l));
      }
    }
    return t;
  }
  /**
   * Set debug mode to enable/disable logs at info level.
   *
   * @param {boolean} enabled
   * @fires Player#debugon
   * @fires Player#debugoff
   * @return {boolean|undefined}
   */
  debug(e) {
    if (e === void 0)
      return this.debugEnabled_;
    e ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1);
  }
  /**
   * Set or get current playback rates.
   * Takes an array and updates the playback rates menu with the new items.
   * Pass in an empty array to hide the menu.
   * Values other than arrays are ignored.
   *
   * @fires Player#playbackrateschange
   * @param {number[]} [newRates]
   *                   The new rates that the playback rates menu should update to.
   *                   An empty array will hide the menu
   * @return {number[]} When used as a getter will return the current playback rates
   */
  playbackRates(e) {
    if (e === void 0)
      return this.cache_.playbackRates;
    Array.isArray(e) && e.every((t) => typeof t == "number") && (this.cache_.playbackRates = e, this.trigger("playbackrateschange"));
  }
  /**
   * Reports whether or not a player has a plugin available.
   *
   * This does not report whether or not the plugin has ever been initialized
   * on this player. For that, [usingPlugin]{@link Player#usingPlugin}.
   *
   * @method hasPlugin
   * @param  {string}  name
   *         The name of a plugin.
   *
   * @return {boolean}
   *         Whether or not this player has the requested plugin available.
   */
  /**
   * Reports whether or not a player is using a plugin by name.
   *
   * For basic plugins, this only reports whether the plugin has _ever_ been
   * initialized on this player.
   *
   * @method Player#usingPlugin
   * @param  {string} name
   *         The name of a plugin.
   *
   * @return {boolean}
   *         Whether or not this player is using the requested plugin.
   */
}
Ue.names.forEach(function(i) {
  const e = Ue[i];
  de.prototype[e.getterName] = function() {
    return this.tech_ ? this.tech_[e.getterName]() : (this[e.privateName] = this[e.privateName] || new e.ListClass(), this[e.privateName]);
  };
});
de.prototype.crossorigin = de.prototype.crossOrigin;
de.players = {};
const As = S.navigator;
de.prototype.options_ = {
  // Default order of fallback technology
  techOrder: Y.defaultTechOrder_,
  html5: {},
  // enable sourceset by default
  enableSourceset: !0,
  // default inactivity timeout
  inactivityTimeout: 2e3,
  // default playback rates
  playbackRates: [],
  // Add playback rate selection by adding rates
  // 'playbackRates': [0.5, 1, 1.5, 2],
  liveui: !1,
  // Included control sets
  children: ["mediaLoader", "posterImage", "titleBar", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
  language: As && (As.languages && As.languages[0] || As.userLanguage || As.language) || "en",
  // locales and their language translations
  languages: {},
  // Default message to show when a video cannot be played.
  notSupportedMessage: "No compatible source was found for this media.",
  normalizeAutoplay: !1,
  fullscreen: {
    options: {
      navigationUI: "hide"
    }
  },
  breakpoints: {},
  responsive: !1,
  audioOnlyMode: !1,
  audioPosterMode: !1,
  spatialNavigation: {
    enabled: !1,
    horizontalSeek: !1
  },
  // Default smooth seeking to false
  enableSmoothSeeking: !1
};
nf.forEach(function(i) {
  de.prototype[`handleTech${_e(i)}_`] = function() {
    return this.trigger(i);
  };
});
M.registerComponent("Player", de);
const un = "plugin", Fi = "activePlugins_", Oi = {}, ln = (i) => Oi.hasOwnProperty(i), jr = (i) => ln(i) ? Oi[i] : void 0, af = (i, e) => {
  i[Fi] = i[Fi] || {}, i[Fi][e] = !0;
}, cn = (i, e, t) => {
  const s = (t ? "before" : "") + "pluginsetup";
  i.trigger(s, e), i.trigger(s + ":" + e.name, e);
}, QT = function(i, e) {
  const t = function() {
    cn(this, {
      name: i,
      plugin: e,
      instance: null
    }, !0);
    const s = e.apply(this, arguments);
    return af(this, i), cn(this, {
      name: i,
      plugin: e,
      instance: s
    }), s;
  };
  return Object.keys(e).forEach(function(s) {
    t[s] = e[s];
  }), t;
}, yc = (i, e) => (e.prototype.name = i, function(...t) {
  cn(this, {
    name: i,
    plugin: e,
    instance: null
  }, !0);
  const s = new e(this, ...t);
  return this[i] = () => s, cn(this, s.getEventHash()), s;
});
class Xe {
  /**
   * Creates an instance of this class.
   *
   * Sub-classes should call `super` to ensure plugins are properly initialized.
   *
   * @param {Player} player
   *        A Video.js player instance.
   */
  constructor(e) {
    if (this.constructor === Xe)
      throw new Error("Plugin must be sub-classed; not directly instantiated.");
    this.player = e, this.log || (this.log = this.player.log.createLogger(this.name)), $o(this), delete this.trigger, yh(this, this.constructor.defaultState), af(e, this.name), this.dispose = this.dispose.bind(this), e.on("dispose", this.dispose);
  }
  /**
   * Get the version of the plugin that was set on <pluginName>.VERSION
   */
  version() {
    return this.constructor.VERSION;
  }
  /**
   * Each event triggered by plugins includes a hash of additional data with
   * conventional properties.
   *
   * This returns that object or mutates an existing hash.
   *
   * @param   {Object} [hash={}]
   *          An object to be used as event an event hash.
   *
   * @return {PluginEventHash}
   *          An event hash object with provided properties mixed-in.
   */
  getEventHash(e = {}) {
    return e.name = this.name, e.plugin = this.constructor, e.instance = this, e;
  }
  /**
   * Triggers an event on the plugin object and overrides
   * {@link module:evented~EventedMixin.trigger|EventedMixin.trigger}.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash={}]
   *          Additional data hash to merge with a
   *          {@link PluginEventHash|PluginEventHash}.
   *
   * @return {boolean}
   *          Whether or not default was prevented.
   */
  trigger(e, t = {}) {
    return rs(this.eventBusEl_, e, this.getEventHash(t));
  }
  /**
   * Handles "statechanged" events on the plugin. No-op by default, override by
   * subclassing.
   *
   * @abstract
   * @param    {Event} e
   *           An event object provided by a "statechanged" event.
   *
   * @param    {Object} e.changes
   *           An object describing changes that occurred with the "statechanged"
   *           event.
   */
  handleStateChanged(e) {
  }
  /**
   * Disposes a plugin.
   *
   * Subclasses can override this if they want, but for the sake of safety,
   * it's probably best to subscribe the "dispose" event.
   *
   * @fires Plugin#dispose
   */
  dispose() {
    const {
      name: e,
      player: t
    } = this;
    this.trigger("dispose"), this.off(), t.off("dispose", this.dispose), t[Fi][e] = !1, this.player = this.state = null, t[e] = yc(e, Oi[e]);
  }
  /**
   * Determines if a plugin is a basic plugin (i.e. not a sub-class of `Plugin`).
   *
   * @param   {string|Function} plugin
   *          If a string, matches the name of a plugin. If a function, will be
   *          tested directly.
   *
   * @return {boolean}
   *          Whether or not a plugin is a basic plugin.
   */
  static isBasic(e) {
    const t = typeof e == "string" ? jr(e) : e;
    return typeof t == "function" && !Xe.prototype.isPrototypeOf(t.prototype);
  }
  /**
   * Register a Video.js plugin.
   *
   * @param   {string} name
   *          The name of the plugin to be registered. Must be a string and
   *          must not match an existing plugin or a method on the `Player`
   *          prototype.
   *
   * @param   {typeof Plugin|Function} plugin
   *          A sub-class of `Plugin` or a function for basic plugins.
   *
   * @return {typeof Plugin|Function}
   *          For advanced plugins, a factory function for that plugin. For
   *          basic plugins, a wrapper function that initializes the plugin.
   */
  static registerPlugin(e, t) {
    if (typeof e != "string")
      throw new Error(`Illegal plugin name, "${e}", must be a string, was ${typeof e}.`);
    if (ln(e))
      Q.warn(`A plugin named "${e}" already exists. You may want to avoid re-registering plugins!`);
    else if (de.prototype.hasOwnProperty(e))
      throw new Error(`Illegal plugin name, "${e}", cannot share a name with an existing player method!`);
    if (typeof t != "function")
      throw new Error(`Illegal plugin for "${e}", must be a function, was ${typeof t}.`);
    return Oi[e] = t, e !== un && (Xe.isBasic(t) ? de.prototype[e] = QT(e, t) : de.prototype[e] = yc(e, t)), t;
  }
  /**
   * De-register a Video.js plugin.
   *
   * @param  {string} name
   *         The name of the plugin to be de-registered. Must be a string that
   *         matches an existing plugin.
   *
   * @throws {Error}
   *         If an attempt is made to de-register the base plugin.
   */
  static deregisterPlugin(e) {
    if (e === un)
      throw new Error("Cannot de-register base plugin.");
    ln(e) && (delete Oi[e], delete de.prototype[e]);
  }
  /**
   * Gets an object containing multiple Video.js plugins.
   *
   * @param   {Array} [names]
   *          If provided, should be an array of plugin names. Defaults to _all_
   *          plugin names.
   *
   * @return {Object|undefined}
   *          An object containing plugin(s) associated with their name(s) or
   *          `undefined` if no matching plugins exist).
   */
  static getPlugins(e = Object.keys(Oi)) {
    let t;
    return e.forEach((s) => {
      const r = jr(s);
      r && (t = t || {}, t[s] = r);
    }), t;
  }
  /**
   * Gets a plugin's version, if available
   *
   * @param   {string} name
   *          The name of a plugin.
   *
   * @return {string}
   *          The plugin's version or an empty string.
   */
  static getPluginVersion(e) {
    const t = jr(e);
    return t && t.VERSION || "";
  }
}
Xe.getPlugin = jr;
Xe.BASE_PLUGIN_NAME = un;
Xe.registerPlugin(un, Xe);
de.prototype.usingPlugin = function(i) {
  return !!this[Fi] && this[Fi][i] === !0;
};
de.prototype.hasPlugin = function(i) {
  return !!ln(i);
};
function JT(i, e) {
  let t = !1;
  return function(...s) {
    return t || Q.warn(i), t = !0, e.apply(this, s);
  };
}
function ht(i, e, t, s) {
  return JT(`${e} is deprecated and will be removed in ${i}.0; please use ${t} instead.`, s);
}
var ZT = {
  NetworkBadStatus: "networkbadstatus",
  NetworkRequestFailed: "networkrequestfailed",
  NetworkRequestAborted: "networkrequestaborted",
  NetworkRequestTimeout: "networkrequesttimeout",
  NetworkBodyParserFailed: "networkbodyparserfailed",
  StreamingHlsPlaylistParserError: "streaminghlsplaylistparsererror",
  StreamingDashManifestParserError: "streamingdashmanifestparsererror",
  StreamingContentSteeringParserError: "streamingcontentsteeringparsererror",
  StreamingVttParserError: "streamingvttparsererror",
  StreamingFailedToSelectNextSegment: "streamingfailedtoselectnextsegment",
  StreamingFailedToDecryptSegment: "streamingfailedtodecryptsegment",
  StreamingFailedToTransmuxSegment: "streamingfailedtotransmuxsegment",
  StreamingFailedToAppendSegment: "streamingfailedtoappendsegment",
  StreamingCodecsChangeError: "streamingcodecschangeerror"
};
const of = (i) => i.indexOf("#") === 0 ? i.slice(1) : i;
function L(i, e, t) {
  let s = L.getPlayer(i);
  if (s)
    return e && Q.warn(`Player "${i}" is already initialised. Options will not be applied.`), t && s.ready(t), s;
  const r = typeof i == "string" ? Kt("#" + of(i)) : i;
  if (!ss(r))
    throw new TypeError("The element or ID supplied is not valid. (videojs)");
  const a = ("getRootNode" in r ? r.getRootNode() instanceof S.ShadowRoot : !1) ? r.getRootNode() : r.ownerDocument.body;
  (!r.ownerDocument.defaultView || !a.contains(r)) && Q.warn("The element supplied is not included in the DOM"), e = e || {}, e.restoreEl === !0 && (e.restoreEl = (r.parentNode && r.parentNode.hasAttribute && r.parentNode.hasAttribute("data-vjs-player") ? r.parentNode : r).cloneNode(!0)), Xt("beforesetup").forEach((l) => {
    const h = l(r, oe(e));
    if (!St(h) || Array.isArray(h)) {
      Q.error("please return an object in beforesetup hooks");
      return;
    }
    e = oe(e, h);
  });
  const o = M.getComponent("Player");
  return s = new o(r, e, t), Xt("setup").forEach((l) => l(s)), s;
}
L.hooks_ = Pt;
L.hooks = Xt;
L.hook = Py;
L.hookOnce = Oy;
L.removeHook = Hd;
if (S.VIDEOJS_NO_DYNAMIC_STYLE !== !0 && is()) {
  let i = Kt(".vjs-styles-defaults");
  if (!i) {
    i = fh("vjs-styles-defaults");
    const e = Kt("head");
    e && e.insertBefore(i, e.firstChild), ph(i, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
  }
}
za(1, L);
L.VERSION = qa;
L.options = de.prototype.options_;
L.getPlayers = () => de.players;
L.getPlayer = (i) => {
  const e = de.players;
  let t;
  if (typeof i == "string") {
    const s = of(i), r = e[s];
    if (r)
      return r;
    t = Kt("#" + s);
  } else
    t = i;
  if (ss(t)) {
    const {
      player: s,
      playerId: r
    } = t;
    if (s || e[r])
      return s || e[r];
  }
};
L.getAllPlayers = () => (
  // Disposed players leave a key with a `null` value, so we need to make sure
  // we filter those out.
  Object.keys(de.players).map((i) => de.players[i]).filter(Boolean)
);
L.players = de.players;
L.getComponent = M.getComponent;
L.registerComponent = (i, e) => (Y.isTech(e) && Q.warn(`The ${i} tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)`), M.registerComponent.call(M, i, e));
L.getTech = Y.getTech;
L.registerTech = Y.registerTech;
L.use = oT;
Object.defineProperty(L, "middleware", {
  value: {},
  writeable: !1,
  enumerable: !0
});
Object.defineProperty(L.middleware, "TERMINATOR", {
  value: an,
  writeable: !1,
  enumerable: !0
});
L.browser = Jd;
L.obj = Ny;
L.mergeOptions = ht(9, "videojs.mergeOptions", "videojs.obj.merge", oe);
L.defineLazyProperty = ht(9, "videojs.defineLazyProperty", "videojs.obj.defineLazyProperty", Dn);
L.bind = ht(9, "videojs.bind", "native Function.prototype.bind", le);
L.registerPlugin = Xe.registerPlugin;
L.deregisterPlugin = Xe.deregisterPlugin;
L.plugin = (i, e) => (Q.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), Xe.registerPlugin(i, e));
L.getPlugins = Xe.getPlugins;
L.getPlugin = Xe.getPlugin;
L.getPluginVersion = Xe.getPluginVersion;
L.addLanguage = function(i, e) {
  return i = ("" + i).toLowerCase(), L.options.languages = oe(L.options.languages, {
    [i]: e
  }), L.options.languages[i];
};
L.log = Q;
L.createLogger = Vd;
L.time = Yy;
L.createTimeRange = ht(9, "videojs.createTimeRange", "videojs.time.createTimeRanges", dt);
L.createTimeRanges = ht(9, "videojs.createTimeRanges", "videojs.time.createTimeRanges", dt);
L.formatTime = ht(9, "videojs.formatTime", "videojs.time.formatTime", yi);
L.setFormatTime = ht(9, "videojs.setFormatTime", "videojs.time.setFormatTime", bh);
L.resetFormatTime = ht(9, "videojs.resetFormatTime", "videojs.time.resetFormatTime", xh);
L.parseUrl = ht(9, "videojs.parseUrl", "videojs.url.parseUrl", Ho);
L.isCrossOrigin = ht(9, "videojs.isCrossOrigin", "videojs.url.isCrossOrigin", Un);
L.EventTarget = tt;
L.any = Uo;
L.on = et;
L.one = Bn;
L.off = Pe;
L.trigger = rs;
L.xhr = Wc;
L.TextTrack = tr;
L.AudioTrack = Ah;
L.VideoTrack = Dh;
["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach((i) => {
  L[i] = function() {
    return Q.warn(`videojs.${i}() is deprecated; use videojs.dom.${i}() instead`), dh[i].apply(null, arguments);
  };
});
L.computedStyle = ht(9, "videojs.computedStyle", "videojs.dom.computedStyle", Ji);
L.dom = dh;
L.fn = Vy;
L.num = wT;
L.str = Xy;
L.url = nT;
L.Error = ZT;
/*! @name videojs-contrib-quality-levels @version 4.1.0 @license Apache-2.0 */
class ev {
  /**
   * Creates a QualityLevel
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   */
  constructor(e) {
    let t = this;
    return t.id = e.id, t.label = t.id, t.width = e.width, t.height = e.height, t.bitrate = e.bandwidth, t.frameRate = e.frameRate, t.enabled_ = e.enabled, Object.defineProperty(t, "enabled", {
      /**
       * Get whether the QualityLevel is enabled.
       *
       * @return {boolean} True if the QualityLevel is enabled.
       */
      get() {
        return t.enabled_();
      },
      /**
       * Enable or disable the QualityLevel.
       *
       * @param {boolean} enable true to enable QualityLevel, false to disable.
       */
      set(s) {
        t.enabled_(s);
      }
    }), t;
  }
}
class dn extends L.EventTarget {
  /**
   * Creates a QualityLevelList.
   */
  constructor() {
    super();
    let e = this;
    return e.levels_ = [], e.selectedIndex_ = -1, Object.defineProperty(e, "selectedIndex", {
      get() {
        return e.selectedIndex_;
      }
    }), Object.defineProperty(e, "length", {
      get() {
        return e.levels_.length;
      }
    }), e[Symbol.iterator] = () => e.levels_.values(), e;
  }
  /**
   * Adds a quality level to the list.
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   * @return {QualityLevel} the QualityLevel added to the list
   * @method addQualityLevel
   */
  addQualityLevel(e) {
    let t = this.getQualityLevelById(e.id);
    if (t)
      return t;
    const s = this.levels_.length;
    return t = new ev(e), "" + s in this || Object.defineProperty(this, s, {
      get() {
        return this.levels_[s];
      }
    }), this.levels_.push(t), this.trigger({
      qualityLevel: t,
      type: "addqualitylevel"
    }), t;
  }
  /**
   * Removes a quality level from the list.
   *
   * @param {QualityLevel} qualityLevel The QualityLevel to remove from the list.
   * @return {QualityLevel|null} the QualityLevel removed or null if nothing removed
   * @method removeQualityLevel
   */
  removeQualityLevel(e) {
    let t = null;
    for (let s = 0, r = this.length; s < r; s++)
      if (this[s] === e) {
        t = this.levels_.splice(s, 1)[0], this.selectedIndex_ === s ? this.selectedIndex_ = -1 : this.selectedIndex_ > s && this.selectedIndex_--;
        break;
      }
    return t && this.trigger({
      qualityLevel: e,
      type: "removequalitylevel"
    }), t;
  }
  /**
   * Searches for a QualityLevel with the given id.
   *
   * @param {string} id The id of the QualityLevel to find.
   * @return {QualityLevel|null} The QualityLevel with id, or null if not found.
   * @method getQualityLevelById
   */
  getQualityLevelById(e) {
    for (let t = 0, s = this.length; t < s; t++) {
      const r = this[t];
      if (r.id === e)
        return r;
    }
    return null;
  }
  /**
   * Resets the list of QualityLevels to empty
   *
   * @method dispose
   */
  dispose() {
    this.selectedIndex_ = -1, this.levels_.length = 0;
  }
}
dn.prototype.allowedEvents_ = {
  change: "change",
  addqualitylevel: "addqualitylevel",
  removequalitylevel: "removequalitylevel"
};
for (const i in dn.prototype.allowedEvents_)
  dn.prototype["on" + i] = null;
var uf = "4.1.0";
const tv = function(i, e) {
  const t = i.qualityLevels, s = new dn(), r = function() {
    s.dispose(), i.qualityLevels = t, i.off("dispose", r);
  };
  return i.on("dispose", r), i.qualityLevels = () => s, i.qualityLevels.VERSION = uf, s;
}, lf = function(i) {
  return tv(this, L.obj.merge({}, i));
};
L.registerPlugin("qualityLevels", lf);
lf.VERSION = uf;
/*! @name @videojs/http-streaming @version 3.15.0 @license Apache-2.0 */
const Ge = vn, hn = (i, e) => e && e.responseURL && i !== e.responseURL ? e.responseURL : i, ot = (i) => L.log.debug ? L.log.debug.bind(L, "VHS:", `${i} >`) : function() {
};
function te(...i) {
  const e = L.obj || L;
  return (e.merge || e.mergeOptions).apply(e, i);
}
function ke(...i) {
  const e = L.time || L;
  return (e.createTimeRanges || e.createTimeRanges).apply(e, i);
}
function iv(i) {
  if (i.length === 0)
    return "Buffered Ranges are empty";
  let e = `Buffered Ranges: 
`;
  for (let t = 0; t < i.length; t++) {
    const s = i.start(t), r = i.end(t);
    e += `${s} --> ${r}. Duration (${r - s})
`;
  }
  return e;
}
const yt = 1 / 30, Tt = yt * 3, cf = function(i, e) {
  const t = [];
  let s;
  if (i && i.length)
    for (s = 0; s < i.length; s++)
      e(i.start(s), i.end(s)) && t.push([i.start(s), i.end(s)]);
  return ke(t);
}, Li = function(i, e) {
  return cf(i, function(t, s) {
    return t - Tt <= e && s + Tt >= e;
  });
}, Br = function(i, e) {
  return cf(i, function(t) {
    return t - yt >= e;
  });
}, sv = function(i) {
  if (i.length < 2)
    return ke();
  const e = [];
  for (let t = 1; t < i.length; t++) {
    const s = i.end(t - 1), r = i.start(t);
    e.push([s, r]);
  }
  return ke(e);
}, rv = function(i, e) {
  let t = null, s = null, r = 0;
  const n = [], a = [];
  if (!i || !i.length || !e || !e.length)
    return ke();
  let o = i.length;
  for (; o--; )
    n.push({
      time: i.start(o),
      type: "start"
    }), n.push({
      time: i.end(o),
      type: "end"
    });
  for (o = e.length; o--; )
    n.push({
      time: e.start(o),
      type: "start"
    }), n.push({
      time: e.end(o),
      type: "end"
    });
  for (n.sort(function(l, h) {
    return l.time - h.time;
  }), o = 0; o < n.length; o++)
    n[o].type === "start" ? (r++, r === 2 && (t = n[o].time)) : n[o].type === "end" && (r--, r === 1 && (s = n[o].time)), t !== null && s !== null && (a.push([t, s]), t = null, s = null);
  return ke(a);
}, df = (i) => {
  const e = [];
  if (!i || !i.length)
    return "";
  for (let t = 0; t < i.length; t++)
    e.push(i.start(t) + " => " + i.end(t));
  return e.join(", ");
}, nv = function(i, e, t = 1) {
  return ((i.length ? i.end(i.length - 1) : 0) - e) / t;
}, di = (i) => {
  const e = [];
  for (let t = 0; t < i.length; t++)
    e.push({
      start: i.start(t),
      end: i.end(t)
    });
  return e;
}, av = function(i, e) {
  if (i === e)
    return !1;
  if (!i && e || !e && i || i.length !== e.length)
    return !0;
  for (let t = 0; t < i.length; t++)
    if (i.start(t) !== e.start(t) || i.end(t) !== e.end(t))
      return !0;
  return !1;
}, Pa = function(i) {
  if (!(!i || !i.length || !i.end))
    return i.end(i.length - 1);
}, ou = function(i, e) {
  let t = 0;
  if (!i || !i.length)
    return t;
  for (let s = 0; s < i.length; s++) {
    const r = i.start(s), n = i.end(s);
    if (!(e > n)) {
      if (e > r && e <= n) {
        t += n - e;
        continue;
      }
      t += n - r;
    }
  }
  return t;
}, uu = (i, e) => {
  if (!e.preload)
    return e.duration;
  let t = 0;
  return (e.parts || []).forEach(function(s) {
    t += s.duration;
  }), (e.preloadHints || []).forEach(function(s) {
    s.type === "PART" && (t += i.partTargetDuration);
  }), t;
}, Ja = (i) => (i.segments || []).reduce((e, t, s) => (t.parts ? t.parts.forEach(function(r, n) {
  e.push({
    duration: r.duration,
    segmentIndex: s,
    partIndex: n,
    part: r,
    segment: t
  });
}) : e.push({
  duration: t.duration,
  segmentIndex: s,
  partIndex: null,
  segment: t,
  part: null
}), e), []), hf = (i) => {
  const e = i.segments && i.segments.length && i.segments[i.segments.length - 1];
  return e && e.parts || [];
}, ff = ({
  preloadSegment: i
}) => {
  if (!i)
    return;
  const {
    parts: e,
    preloadHints: t
  } = i;
  let s = (t || []).reduce((r, n) => r + (n.type === "PART" ? 1 : 0), 0);
  return s += e && e.length ? e.length : 0, s;
}, pf = (i, e) => {
  if (e.endList)
    return 0;
  if (i && i.suggestedPresentationDelay)
    return i.suggestedPresentationDelay;
  const t = hf(e).length > 0;
  return t && e.serverControl && e.serverControl.partHoldBack ? e.serverControl.partHoldBack : t && e.partTargetDuration ? e.partTargetDuration * 3 : e.serverControl && e.serverControl.holdBack ? e.serverControl.holdBack : e.targetDuration ? e.targetDuration * 3 : 0;
}, ov = function(i, e) {
  let t = 0, s = e - i.mediaSequence, r = i.segments[s];
  if (r) {
    if (typeof r.start < "u")
      return {
        result: r.start,
        precise: !0
      };
    if (typeof r.end < "u")
      return {
        result: r.end - r.duration,
        precise: !0
      };
  }
  for (; s--; ) {
    if (r = i.segments[s], typeof r.end < "u")
      return {
        result: t + r.end,
        precise: !0
      };
    if (t += uu(i, r), typeof r.start < "u")
      return {
        result: t + r.start,
        precise: !0
      };
  }
  return {
    result: t,
    precise: !1
  };
}, uv = function(i, e) {
  let t = 0, s, r = e - i.mediaSequence;
  for (; r < i.segments.length; r++) {
    if (s = i.segments[r], typeof s.start < "u")
      return {
        result: s.start - t,
        precise: !0
      };
    if (t += uu(i, s), typeof s.end < "u")
      return {
        result: s.end - t,
        precise: !0
      };
  }
  return {
    result: -1,
    precise: !1
  };
}, mf = function(i, e, t) {
  if (typeof e > "u" && (e = i.mediaSequence + i.segments.length), e < i.mediaSequence)
    return 0;
  const s = ov(i, e);
  if (s.precise)
    return s.result;
  const r = uv(i, e);
  return r.precise ? r.result : s.result + t;
}, gf = function(i, e, t) {
  if (!i)
    return 0;
  if (typeof t != "number" && (t = 0), typeof e > "u") {
    if (i.totalDuration)
      return i.totalDuration;
    if (!i.endList)
      return S.Infinity;
  }
  return mf(i, e, t);
}, Us = function({
  defaultDuration: i,
  durationList: e,
  startIndex: t,
  endIndex: s
}) {
  let r = 0;
  if (t > s && ([t, s] = [s, t]), t < 0) {
    for (let n = t; n < Math.min(0, s); n++)
      r += i;
    t = 0;
  }
  for (let n = t; n < s; n++)
    r += e[n].duration;
  return r;
}, _f = function(i, e, t, s) {
  if (!i || !i.segments)
    return null;
  if (i.endList)
    return gf(i);
  if (e === null)
    return null;
  e = e || 0;
  let r = mf(i, i.mediaSequence + i.segments.length, e);
  return t && (s = typeof s == "number" ? s : pf(null, i), r -= s), Math.max(0, r);
}, lv = function(i, e, t) {
  const r = e || 0;
  let n = _f(i, e, !0, t);
  return n === null ? ke() : (n < r && (n = r), ke(r, n));
}, cv = function({
  playlist: i,
  currentTime: e,
  startingSegmentIndex: t,
  startingPartIndex: s,
  startTime: r,
  exactManifestTimings: n
}) {
  let a = e - r;
  const o = Ja(i);
  let l = 0;
  for (let h = 0; h < o.length; h++) {
    const m = o[h];
    if (t === m.segmentIndex && !(typeof s == "number" && typeof m.partIndex == "number" && s !== m.partIndex)) {
      l = h;
      break;
    }
  }
  if (a < 0) {
    if (l > 0)
      for (let h = l - 1; h >= 0; h--) {
        const m = o[h];
        if (a += m.duration, n) {
          if (a < 0)
            continue;
        } else if (a + yt <= 0)
          continue;
        return {
          partIndex: m.partIndex,
          segmentIndex: m.segmentIndex,
          startTime: r - Us({
            defaultDuration: i.targetDuration,
            durationList: o,
            startIndex: l,
            endIndex: h
          })
        };
      }
    return {
      partIndex: o[0] && o[0].partIndex || null,
      segmentIndex: o[0] && o[0].segmentIndex || 0,
      startTime: e
    };
  }
  if (l < 0) {
    for (let h = l; h < 0; h++)
      if (a -= i.targetDuration, a < 0)
        return {
          partIndex: o[0] && o[0].partIndex || null,
          segmentIndex: o[0] && o[0].segmentIndex || 0,
          startTime: e
        };
    l = 0;
  }
  for (let h = l; h < o.length; h++) {
    const m = o[h];
    a -= m.duration;
    const _ = m.duration > yt, v = a === 0, C = _ && a + yt >= 0;
    if (!((v || C) && h !== o.length - 1)) {
      if (n) {
        if (a > 0)
          continue;
      } else if (a - yt >= 0)
        continue;
      return {
        partIndex: m.partIndex,
        segmentIndex: m.segmentIndex,
        startTime: r + Us({
          defaultDuration: i.targetDuration,
          durationList: o,
          startIndex: l,
          endIndex: h
        })
      };
    }
  }
  return {
    segmentIndex: o[o.length - 1].segmentIndex,
    partIndex: o[o.length - 1].partIndex,
    startTime: e
  };
}, yf = function(i) {
  return i.excludeUntil && i.excludeUntil > Date.now();
}, lu = function(i) {
  return i.excludeUntil && i.excludeUntil === 1 / 0;
}, jn = function(i) {
  const e = yf(i);
  return !i.disabled && !e;
}, dv = function(i) {
  return i.disabled;
}, hv = function(i) {
  for (let e = 0; e < i.segments.length; e++)
    if (i.segments[e].key)
      return !0;
  return !1;
}, Tf = function(i, e) {
  return e.attributes && e.attributes[i];
}, fv = function(i, e, t, s = 0) {
  return Tf("BANDWIDTH", t) ? (i * t.attributes.BANDWIDTH - s * 8) / e : NaN;
}, Za = (i, e) => {
  if (i.playlists.length === 1)
    return !0;
  const t = e.attributes.BANDWIDTH || Number.MAX_VALUE;
  return i.playlists.filter((s) => jn(s) ? (s.attributes.BANDWIDTH || 0) < t : !1).length === 0;
}, cu = (i, e) => !i && !e || !i && e || i && !e ? !1 : !!(i === e || i.id && e.id && i.id === e.id || i.resolvedUri && e.resolvedUri && i.resolvedUri === e.resolvedUri || i.uri && e.uri && i.uri === e.uri), Tc = function(i, e) {
  const t = i && i.mediaGroups && i.mediaGroups.AUDIO || {};
  let s = !1;
  for (const r in t) {
    for (const n in t[r])
      if (s = e(t[r][n]), s)
        break;
    if (s)
      break;
  }
  return !!s;
}, nr = (i) => {
  if (!i || !i.playlists || !i.playlists.length)
    return Tc(i, (t) => t.playlists && t.playlists.length || t.uri);
  for (let e = 0; e < i.playlists.length; e++) {
    const t = i.playlists[e], s = t.attributes && t.attributes.CODECS;
    if (!(s && s.split(",").every((n) => Zc(n)) || Tc(i, (n) => cu(t, n))))
      return !1;
  }
  return !0;
};
var We = {
  liveEdgeDelay: pf,
  duration: gf,
  seekable: lv,
  getMediaInfoForTime: cv,
  isEnabled: jn,
  isDisabled: dv,
  isExcluded: yf,
  isIncompatible: lu,
  playlistEnd: _f,
  isAes: hv,
  hasAttribute: Tf,
  estimateSegmentRequestTime: fv,
  isLowestEnabledRendition: Za,
  isAudioOnly: nr,
  playlistMatch: cu,
  segmentDurationWithParts: uu
};
const {
  log: vf
} = L, Ui = (i, e) => `${i}-${e}`, bf = (i, e, t) => `placeholder-uri-${i}-${e}-${t}`, pv = ({
  onwarn: i,
  oninfo: e,
  manifestString: t,
  customTagParsers: s = [],
  customTagMappers: r = [],
  llhls: n
}) => {
  const a = new k0();
  i && a.on("warn", i), e && a.on("info", e), s.forEach((h) => a.addParser(h)), r.forEach((h) => a.addTagMapper(h)), a.push(t), a.end();
  const o = a.manifest;
  if (n || (["preloadSegment", "skip", "serverControl", "renditionReports", "partInf", "partTargetDuration"].forEach(function(h) {
    o.hasOwnProperty(h) && delete o[h];
  }), o.segments && o.segments.forEach(function(h) {
    ["parts", "preloadHints"].forEach(function(m) {
      h.hasOwnProperty(m) && delete h[m];
    });
  })), !o.targetDuration) {
    let h = 10;
    o.segments && o.segments.length && (h = o.segments.reduce((m, _) => Math.max(m, _.duration), 0)), i && i({
      message: `manifest has no targetDuration defaulting to ${h}`
    }), o.targetDuration = h;
  }
  const l = hf(o);
  if (l.length && !o.partTargetDuration) {
    const h = l.reduce((m, _) => Math.max(m, _.duration), 0);
    i && (i({
      message: `manifest has no partTargetDuration defaulting to ${h}`
    }), vf.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.")), o.partTargetDuration = h;
  }
  return o;
}, us = (i, e) => {
  i.mediaGroups && ["AUDIO", "SUBTITLES"].forEach((t) => {
    if (i.mediaGroups[t])
      for (const s in i.mediaGroups[t])
        for (const r in i.mediaGroups[t][s]) {
          const n = i.mediaGroups[t][s][r];
          e(n, t, s, r);
        }
  });
}, xf = ({
  playlist: i,
  uri: e,
  id: t
}) => {
  i.id = t, i.playlistErrors_ = 0, e && (i.uri = e), i.attributes = i.attributes || {};
}, mv = (i) => {
  let e = i.playlists.length;
  for (; e--; ) {
    const t = i.playlists[e];
    xf({
      playlist: t,
      id: Ui(e, t.uri)
    }), t.resolvedUri = Ge(i.uri, t.uri), i.playlists[t.id] = t, i.playlists[t.uri] = t, t.attributes.BANDWIDTH || vf.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
  }
}, gv = (i) => {
  us(i, (e) => {
    e.uri && (e.resolvedUri = Ge(i.uri, e.uri));
  });
}, _v = (i, e) => {
  const t = Ui(0, e), s = {
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: S.location.href,
    resolvedUri: S.location.href,
    playlists: [{
      uri: e,
      id: t,
      resolvedUri: e,
      // m3u8-parser does not attach an attributes property to media playlists so make
      // sure that the property is attached to avoid undefined reference errors
      attributes: {}
    }]
  };
  return s.playlists[t] = s.playlists[0], s.playlists[e] = s.playlists[0], s;
}, Sf = (i, e, t = bf) => {
  i.uri = e;
  for (let r = 0; r < i.playlists.length; r++)
    if (!i.playlists[r].uri) {
      const n = `placeholder-uri-${r}`;
      i.playlists[r].uri = n;
    }
  const s = nr(i);
  us(i, (r, n, a, o) => {
    if (!r.playlists || !r.playlists.length) {
      if (s && n === "AUDIO" && !r.uri)
        for (let l = 0; l < i.playlists.length; l++) {
          const h = i.playlists[l];
          if (h.attributes && h.attributes.AUDIO && h.attributes.AUDIO === a)
            return;
        }
      r.playlists = [ye({}, r)];
    }
    r.playlists.forEach(function(l, h) {
      const m = t(n, a, o, l), _ = Ui(h, m);
      l.uri ? l.resolvedUri = l.resolvedUri || Ge(i.uri, l.uri) : (l.uri = h === 0 ? m : _, l.resolvedUri = l.uri), l.id = l.id || _, l.attributes = l.attributes || {}, i.playlists[l.id] = l, i.playlists[l.uri] = l;
    });
  }), mv(i), gv(i);
};
class vc {
  constructor() {
    this.offset_ = null, this.pendingDateRanges_ = /* @__PURE__ */ new Map(), this.processedDateRanges_ = /* @__PURE__ */ new Map();
  }
  setOffset(e = []) {
    if (this.offset_ !== null || !e.length)
      return;
    const [t] = e;
    t.programDateTime !== void 0 && (this.offset_ = t.programDateTime / 1e3);
  }
  setPendingDateRanges(e = []) {
    if (!e.length)
      return;
    const [t] = e, s = t.startDate.getTime();
    this.trimProcessedDateRanges_(s), this.pendingDateRanges_ = e.reduce((r, n) => (r.set(n.id, n), r), /* @__PURE__ */ new Map());
  }
  processDateRange(e) {
    this.pendingDateRanges_.delete(e.id), this.processedDateRanges_.set(e.id, e);
  }
  getDateRangesToProcess() {
    if (this.offset_ === null)
      return [];
    const e = {}, t = [];
    this.pendingDateRanges_.forEach((s, r) => {
      if (!this.processedDateRanges_.has(r) && (s.startTime = s.startDate.getTime() / 1e3 - this.offset_, s.processDateRange = () => this.processDateRange(s), t.push(s), !!s.class))
        if (e[s.class]) {
          const n = e[s.class].push(s);
          s.classListIndex = n - 1;
        } else
          e[s.class] = [s], s.classListIndex = 0;
    });
    for (const s of t) {
      const r = e[s.class] || [];
      s.endDate ? s.endTime = s.endDate.getTime() / 1e3 - this.offset_ : s.endOnNext && r[s.classListIndex + 1] ? s.endTime = r[s.classListIndex + 1].startTime : s.duration ? s.endTime = s.startTime + s.duration : s.plannedDuration ? s.endTime = s.startTime + s.plannedDuration : s.endTime = s.startTime;
    }
    return t;
  }
  trimProcessedDateRanges_(e) {
    new Map(this.processedDateRanges_).forEach((s, r) => {
      s.startDate.getTime() < e && this.processedDateRanges_.delete(r);
    });
  }
}
const Ef = 22, gi = ({
  requestType: i,
  request: e,
  error: t,
  parseFailure: s
}) => {
  const r = e.status < 200 || e.status > 299, n = e.status >= 400 && e.status <= 499, a = {
    uri: e.uri,
    requestType: i
  }, o = r && !n || s;
  if (t && n)
    a.error = ye({}, t), a.errorType = L.Error.NetworkRequestFailed;
  else if (e.aborted)
    a.errorType = L.Error.NetworkRequestAborted;
  else if (e.timedout)
    a.erroType = L.Error.NetworkRequestTimeout;
  else if (o) {
    const l = s ? L.Error.NetworkBodyParserFailed : L.Error.NetworkBadStatus;
    a.errorType = l, a.status = e.status, a.headers = e.headers;
  }
  return a;
}, {
  EventTarget: yv
} = L, Tv = (i, e) => {
  if (e.endList || !e.serverControl)
    return i;
  const t = {};
  if (e.serverControl.canBlockReload) {
    const {
      preloadSegment: s
    } = e;
    let r = e.mediaSequence + e.segments.length;
    if (s) {
      const n = s.parts || [], a = ff(e) - 1;
      a > -1 && a !== n.length - 1 && (t._HLS_part = a), (a > -1 || n.length) && r--;
    }
    t._HLS_msn = r;
  }
  if (e.serverControl && e.serverControl.canSkipUntil && (t._HLS_skip = e.serverControl.canSkipDateranges ? "v2" : "YES"), Object.keys(t).length) {
    const s = new S.URL(i);
    ["_HLS_skip", "_HLS_msn", "_HLS_part"].forEach(function(r) {
      t.hasOwnProperty(r) && s.searchParams.set(r, t[r]);
    }), i = s.toString();
  }
  return i;
}, vv = (i, e) => {
  if (!i)
    return e;
  const t = te(i, e);
  if (i.preloadHints && !e.preloadHints && delete t.preloadHints, i.parts && !e.parts)
    delete t.parts;
  else if (i.parts && e.parts)
    for (let s = 0; s < e.parts.length; s++)
      i.parts && i.parts[s] && (t.parts[s] = te(i.parts[s], e.parts[s]));
  return !i.skipped && e.skipped && (t.skipped = !1), i.preload && !e.preload && (t.preload = !1), t;
}, bv = (i, e, t) => {
  const s = i.slice(), r = e.slice();
  t = t || 0;
  const n = [];
  let a;
  for (let o = 0; o < r.length; o++) {
    const l = s[o + t], h = r[o];
    l ? (a = l.map || a, n.push(vv(l, h))) : (a && !h.map && (h.map = a), n.push(h));
  }
  return n;
}, Cf = (i, e) => {
  !i.resolvedUri && i.uri && (i.resolvedUri = Ge(e, i.uri)), i.key && !i.key.resolvedUri && (i.key.resolvedUri = Ge(e, i.key.uri)), i.map && !i.map.resolvedUri && (i.map.resolvedUri = Ge(e, i.map.uri)), i.map && i.map.key && !i.map.key.resolvedUri && (i.map.key.resolvedUri = Ge(e, i.map.key.uri)), i.parts && i.parts.length && i.parts.forEach((t) => {
    t.resolvedUri || (t.resolvedUri = Ge(e, t.uri));
  }), i.preloadHints && i.preloadHints.length && i.preloadHints.forEach((t) => {
    t.resolvedUri || (t.resolvedUri = Ge(e, t.uri));
  });
}, Af = function(i) {
  const e = i.segments || [], t = i.preloadSegment;
  if (t && t.parts && t.parts.length) {
    if (t.preloadHints) {
      for (let s = 0; s < t.preloadHints.length; s++)
        if (t.preloadHints[s].type === "MAP")
          return e;
    }
    t.duration = i.targetDuration, t.preload = !0, e.push(t);
  }
  return e;
}, Df = (i, e) => i === e || i.segments && e.segments && i.segments.length === e.segments.length && i.endList === e.endList && i.mediaSequence === e.mediaSequence && i.preloadSegment === e.preloadSegment, eo = (i, e, t = Df) => {
  const s = te(i, {}), r = s.playlists[e.id];
  if (!r || t(r, e))
    return null;
  e.segments = Af(e);
  const n = te(r, e);
  if (n.preloadSegment && !e.preloadSegment && delete n.preloadSegment, r.segments) {
    if (e.skip) {
      e.segments = e.segments || [];
      for (let a = 0; a < e.skip.skippedSegments; a++)
        e.segments.unshift({
          skipped: !0
        });
    }
    n.segments = bv(r.segments, e.segments, e.mediaSequence - r.mediaSequence);
  }
  n.segments.forEach((a) => {
    Cf(a, n.resolvedUri);
  });
  for (let a = 0; a < s.playlists.length; a++)
    s.playlists[a].id === e.id && (s.playlists[a] = n);
  return s.playlists[e.id] = n, s.playlists[e.uri] = n, us(i, (a, o, l, h) => {
    if (a.playlists)
      for (let m = 0; m < a.playlists.length; m++)
        e.id === a.playlists[m].id && (a.playlists[m] = n);
  }), s;
}, to = (i, e) => {
  const t = i.segments || [], s = t[t.length - 1], r = s && s.parts && s.parts[s.parts.length - 1], n = r && r.duration || s && s.duration;
  return e && n ? n * 1e3 : (i.partTargetDuration || i.targetDuration || 10) * 500;
}, bc = (i, e, t) => {
  if (!i)
    return;
  const s = [];
  return i.forEach((r) => {
    if (!r.attributes)
      return;
    const {
      BANDWIDTH: n,
      RESOLUTION: a,
      CODECS: o
    } = r.attributes;
    s.push({
      id: r.id,
      bandwidth: n,
      resolution: a,
      codecs: o
    });
  }), {
    type: e,
    isLive: t,
    renditions: s
  };
};
class Ri extends yv {
  constructor(e, t, s = {}) {
    if (super(), !e)
      throw new Error("A non-empty playlist URL or object is required");
    this.logger_ = ot("PlaylistLoader");
    const {
      withCredentials: r = !1
    } = s;
    this.src = e, this.vhs_ = t, this.withCredentials = r, this.addDateRangesToTextTrack_ = s.addDateRangesToTextTrack;
    const n = t.options_;
    this.customTagParsers = n && n.customTagParsers || [], this.customTagMappers = n && n.customTagMappers || [], this.llhls = n && n.llhls, this.dateRangesStorage_ = new vc(), this.state = "HAVE_NOTHING", this.handleMediaupdatetimeout_ = this.handleMediaupdatetimeout_.bind(this), this.on("mediaupdatetimeout", this.handleMediaupdatetimeout_), this.on("loadedplaylist", this.handleLoadedPlaylist_.bind(this));
  }
  handleLoadedPlaylist_() {
    const e = this.media();
    if (!e)
      return;
    this.dateRangesStorage_.setOffset(e.segments), this.dateRangesStorage_.setPendingDateRanges(e.dateRanges);
    const t = this.dateRangesStorage_.getDateRangesToProcess();
    !t.length || !this.addDateRangesToTextTrack_ || this.addDateRangesToTextTrack_(t);
  }
  handleMediaupdatetimeout_() {
    if (this.state !== "HAVE_METADATA")
      return;
    const e = this.media();
    let t = Ge(this.main.uri, e.uri);
    this.llhls && (t = Tv(t, e)), this.state = "HAVE_CURRENT_METADATA", this.request = this.vhs_.xhr({
      uri: t,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (s, r) => {
      if (this.request) {
        if (s)
          return this.playlistRequestError(this.request, this.media(), "HAVE_METADATA");
        this.haveMetadata({
          playlistString: this.request.responseText,
          url: this.media().uri,
          id: this.media().id
        });
      }
    });
  }
  playlistRequestError(e, t, s) {
    const {
      uri: r,
      id: n
    } = t;
    this.request = null, s && (this.state = s), this.error = {
      playlist: this.main.playlists[n],
      status: e.status,
      message: `HLS playlist request error at URL: ${r}.`,
      responseText: e.responseText,
      code: e.status >= 500 ? 4 : 2,
      metadata: gi({
        requestType: e.requestType,
        request: e,
        error: e.error
      })
    }, this.trigger("error");
  }
  parseManifest_({
    url: e,
    manifestString: t
  }) {
    try {
      return pv({
        onwarn: ({
          message: s
        }) => this.logger_(`m3u8-parser warn for ${e}: ${s}`),
        oninfo: ({
          message: s
        }) => this.logger_(`m3u8-parser info for ${e}: ${s}`),
        manifestString: t,
        customTagParsers: this.customTagParsers,
        customTagMappers: this.customTagMappers,
        llhls: this.llhls
      });
    } catch (s) {
      this.error = s, this.error.metadata = {
        errorType: L.Error.StreamingHlsPlaylistParserError,
        error: s
      };
    }
  }
  /**
   * Update the playlist loader's state in response to a new or updated playlist.
   *
   * @param {string} [playlistString]
   *        Playlist string (if playlistObject is not provided)
   * @param {Object} [playlistObject]
   *        Playlist object (if playlistString is not provided)
   * @param {string} url
   *        URL of playlist
   * @param {string} id
   *        ID to use for playlist
   */
  haveMetadata({
    playlistString: e,
    playlistObject: t,
    url: s,
    id: r
  }) {
    this.request = null, this.state = "HAVE_METADATA";
    const n = {
      playlistInfo: {
        type: "media",
        uri: s
      }
    };
    this.trigger({
      type: "playlistparsestart",
      metadata: n
    });
    const a = t || this.parseManifest_({
      url: s,
      manifestString: e
    });
    a.lastRequest = Date.now(), xf({
      playlist: a,
      uri: s,
      id: r
    });
    const o = eo(this.main, a);
    this.targetDuration = a.partTargetDuration || a.targetDuration, this.pendingMedia_ = null, o ? (this.main = o, this.media_ = this.main.playlists[r]) : this.trigger("playlistunchanged"), this.updateMediaUpdateTimeout_(to(this.media(), !!o)), n.parsedPlaylist = bc(this.main.playlists, n.playlistInfo.type, !this.media_.endList), this.trigger({
      type: "playlistparsecomplete",
      metadata: n
    }), this.trigger("loadedplaylist");
  }
  /**
    * Abort any outstanding work and clean up.
    */
  dispose() {
    this.trigger("dispose"), this.stopRequest(), S.clearTimeout(this.mediaUpdateTimeout), S.clearTimeout(this.finalRenditionTimeout), this.dateRangesStorage_ = new vc(), this.off();
  }
  stopRequest() {
    if (this.request) {
      const e = this.request;
      this.request = null, e.onreadystatechange = null, e.abort();
    }
  }
  /**
    * When called without any arguments, returns the currently
    * active media playlist. When called with a single argument,
    * triggers the playlist loader to asynchronously switch to the
    * specified media playlist. Calling this method while the
    * loader is in the HAVE_NOTHING causes an error to be emitted
    * but otherwise has no effect.
    *
    * @param {Object=} playlist the parsed media playlist
    * object to switch to
    * @param {boolean=} shouldDelay whether we should delay the request by half target duration
    *
    * @return {Playlist} the current loaded media
    */
  media(e, t) {
    if (!e)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    if (typeof e == "string") {
      if (!this.main.playlists[e])
        throw new Error("Unknown playlist URI: " + e);
      e = this.main.playlists[e];
    }
    if (S.clearTimeout(this.finalRenditionTimeout), t) {
      const o = (e.partTargetDuration || e.targetDuration) / 2 * 1e3 || 5e3;
      this.finalRenditionTimeout = S.setTimeout(this.media.bind(this, e, !1), o);
      return;
    }
    const s = this.state, r = !this.media_ || e.id !== this.media_.id, n = this.main.playlists[e.id];
    if (n && n.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
    // media playlist or, for the case of demuxed audio, a resolved audio media group)
    e.endList && e.segments.length) {
      this.request && (this.request.onreadystatechange = null, this.request.abort(), this.request = null), this.state = "HAVE_METADATA", this.media_ = e, r && (this.trigger("mediachanging"), s === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange"));
      return;
    }
    if (this.updateMediaUpdateTimeout_(to(e, !0)), !r)
      return;
    if (this.state = "SWITCHING_MEDIA", this.request) {
      if (e.resolvedUri === this.request.url)
        return;
      this.request.onreadystatechange = null, this.request.abort(), this.request = null;
    }
    this.media_ && this.trigger("mediachanging"), this.pendingMedia_ = e;
    const a = {
      playlistInfo: {
        type: "media",
        uri: e.uri
      }
    };
    this.trigger({
      type: "playlistrequeststart",
      metadata: a
    }), this.request = this.vhs_.xhr({
      uri: e.resolvedUri,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (o, l) => {
      if (this.request) {
        if (e.lastRequest = Date.now(), e.resolvedUri = hn(e.resolvedUri, l), o)
          return this.playlistRequestError(this.request, e, s);
        this.trigger({
          type: "playlistrequestcomplete",
          metadata: a
        }), this.haveMetadata({
          playlistString: l.responseText,
          url: e.uri,
          id: e.id
        }), s === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
      }
    });
  }
  /**
   * pause loading of the playlist
   */
  pause() {
    this.mediaUpdateTimeout && (S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), this.stopRequest(), this.state === "HAVE_NOTHING" && (this.started = !1), this.state === "SWITCHING_MEDIA" ? this.media_ ? this.state = "HAVE_METADATA" : this.state = "HAVE_MAIN_MANIFEST" : this.state === "HAVE_CURRENT_METADATA" && (this.state = "HAVE_METADATA");
  }
  /**
   * start loading of the playlist
   */
  load(e) {
    this.mediaUpdateTimeout && (S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null);
    const t = this.media();
    if (e) {
      const s = t ? (t.partTargetDuration || t.targetDuration) / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = S.setTimeout(() => {
        this.mediaUpdateTimeout = null, this.load();
      }, s);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    t && !t.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist");
  }
  updateMediaUpdateTimeout_(e) {
    this.mediaUpdateTimeout && (S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), !(!this.media() || this.media().endList) && (this.mediaUpdateTimeout = S.setTimeout(() => {
      this.mediaUpdateTimeout = null, this.trigger("mediaupdatetimeout"), this.updateMediaUpdateTimeout_(e);
    }, e));
  }
  /**
   * start loading of the playlist
   */
  start() {
    if (this.started = !0, typeof this.src == "object") {
      this.src.uri || (this.src.uri = S.location.href), this.src.resolvedUri = this.src.uri, setTimeout(() => {
        this.setupInitialPlaylist(this.src);
      }, 0);
      return;
    }
    const e = {
      playlistInfo: {
        type: "multivariant",
        uri: this.src
      }
    };
    this.trigger({
      type: "playlistrequeststart",
      metadata: e
    }), this.request = this.vhs_.xhr({
      uri: this.src,
      withCredentials: this.withCredentials,
      requestType: "hls-playlist"
    }, (t, s) => {
      if (!this.request)
        return;
      if (this.request = null, t)
        return this.error = {
          status: s.status,
          message: `HLS playlist request error at URL: ${this.src}.`,
          responseText: s.responseText,
          // MEDIA_ERR_NETWORK
          code: 2,
          metadata: gi({
            requestType: s.requestType,
            request: s,
            error: t
          })
        }, this.state === "HAVE_NOTHING" && (this.started = !1), this.trigger("error");
      this.trigger({
        type: "playlistrequestcomplete",
        metadata: e
      }), this.src = hn(this.src, s), this.trigger({
        type: "playlistparsestart",
        metadata: e
      });
      const r = this.parseManifest_({
        manifestString: s.responseText,
        url: this.src
      });
      e.parsedPlaylist = bc(r.playlists, e.playlistInfo.type, !1), this.trigger({
        type: "playlistparsecomplete",
        metadata: e
      }), this.setupInitialPlaylist(r);
    });
  }
  srcUri() {
    return typeof this.src == "string" ? this.src : this.src.uri;
  }
  /**
   * Given a manifest object that's either a main or media playlist, trigger the proper
   * events and set the state of the playlist loader.
   *
   * If the manifest object represents a main playlist, `loadedplaylist` will be
   * triggered to allow listeners to select a playlist. If none is selected, the loader
   * will default to the first one in the playlists array.
   *
   * If the manifest object represents a media playlist, `loadedplaylist` will be
   * triggered followed by `loadedmetadata`, as the only available playlist is loaded.
   *
   * In the case of a media playlist, a main playlist object wrapper with one playlist
   * will be created so that all logic can handle playlists in the same fashion (as an
   * assumed manifest object schema).
   *
   * @param {Object} manifest
   *        The parsed manifest object
   */
  setupInitialPlaylist(e) {
    if (this.state = "HAVE_MAIN_MANIFEST", e.playlists) {
      this.main = e, Sf(this.main, this.srcUri()), e.playlists.forEach((s) => {
        s.segments = Af(s), s.segments.forEach((r) => {
          Cf(r, s.resolvedUri);
        });
      }), this.trigger("loadedplaylist"), this.request || this.media(this.main.playlists[0]);
      return;
    }
    const t = this.srcUri() || S.location.href;
    this.main = _v(e, t), this.haveMetadata({
      playlistObject: e,
      url: t,
      id: this.main.playlists[0].id
    }), this.trigger("loadedmetadata");
  }
  /**
   * Updates or deletes a preexisting pathway clone.
   * Ensures that all playlists related to the old pathway clone are
   * either updated or deleted.
   *
   * @param {Object} clone On update, the pathway clone object for the newly updated pathway clone.
   *        On delete, the old pathway clone object to be deleted.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */
  updateOrDeleteClone(e, t) {
    const s = this.main, r = e.ID;
    let n = s.playlists.length;
    for (; n--; ) {
      const a = s.playlists[n];
      if (a.attributes["PATHWAY-ID"] === r) {
        const o = a.resolvedUri, l = a.id;
        if (t) {
          const h = this.createCloneURI_(a.resolvedUri, e), m = Ui(r, h), _ = this.createCloneAttributes_(r, a.attributes), v = this.createClonePlaylist_(a, m, e, _);
          s.playlists[n] = v, s.playlists[m] = v, s.playlists[h] = v;
        } else
          s.playlists.splice(n, 1);
        delete s.playlists[l], delete s.playlists[o];
      }
    }
    this.updateOrDeleteCloneMedia(e, t);
  }
  /**
   * Updates or deletes media data based on the pathway clone object.
   * Due to the complexity of the media groups and playlists, in all cases
   * we remove all of the old media groups and playlists.
   * On updates, we then create new media groups and playlists based on the
   * new pathway clone object.
   *
   * @param {Object} clone The pathway clone object for the newly updated pathway clone.
   * @param {boolean} isUpdate True if the pathway is to be updated,
   *        false if it is meant to be deleted.
   */
  updateOrDeleteCloneMedia(e, t) {
    const s = this.main, r = e.ID;
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((n) => {
      if (!(!s.mediaGroups[n] || !s.mediaGroups[n][r])) {
        for (const a in s.mediaGroups[n])
          if (a === r) {
            for (const o in s.mediaGroups[n][a])
              s.mediaGroups[n][a][o].playlists.forEach((h, m) => {
                const _ = s.playlists[h.id], v = _.id, C = _.resolvedUri;
                delete s.playlists[v], delete s.playlists[C];
              });
            delete s.mediaGroups[n][a];
          }
      }
    }), t && this.createClonedMediaGroups_(e);
  }
  /**
   * Given a pathway clone object, clones all necessary playlists.
   *
   * @param {Object} clone The pathway clone object.
   * @param {Object} basePlaylist The original playlist to clone from.
   */
  addClonePathway(e, t = {}) {
    const s = this.main, r = s.playlists.length, n = this.createCloneURI_(t.resolvedUri, e), a = Ui(e.ID, n), o = this.createCloneAttributes_(e.ID, t.attributes), l = this.createClonePlaylist_(t, a, e, o);
    s.playlists[r] = l, s.playlists[a] = l, s.playlists[n] = l, this.createClonedMediaGroups_(e);
  }
  /**
   * Given a pathway clone object we create clones of all media.
   * In this function, all necessary information and updated playlists
   * are added to the `mediaGroup` object.
   * Playlists are also added to the `playlists` array so the media groups
   * will be properly linked.
   *
   * @param {Object} clone The pathway clone object.
   */
  createClonedMediaGroups_(e) {
    const t = e.ID, s = e["BASE-ID"], r = this.main;
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((n) => {
      if (!(!r.mediaGroups[n] || r.mediaGroups[n][t]))
        for (const a in r.mediaGroups[n]) {
          if (a === s)
            r.mediaGroups[n][t] = {};
          else
            continue;
          for (const o in r.mediaGroups[n][a]) {
            const l = r.mediaGroups[n][a][o];
            r.mediaGroups[n][t][o] = ye({}, l);
            const h = r.mediaGroups[n][t][o], m = this.createCloneURI_(l.resolvedUri, e);
            h.resolvedUri = m, h.uri = m, h.playlists = [], l.playlists.forEach((_, v) => {
              const C = r.playlists[_.id], A = bf(n, t, o), y = Ui(t, A);
              if (C && !r.playlists[y]) {
                const D = this.createClonePlaylist_(C, y, e), w = D.resolvedUri;
                r.playlists[y] = D, r.playlists[w] = D;
              }
              h.playlists[v] = this.createClonePlaylist_(_, y, e);
            });
          }
        }
    });
  }
  /**
   * Using the original playlist to be cloned, and the pathway clone object
   * information, we create a new playlist.
   *
   * @param {Object} basePlaylist  The original playlist to be cloned from.
   * @param {string} id The desired id of the newly cloned playlist.
   * @param {Object} clone The pathway clone object.
   * @param {Object} attributes An optional object to populate the `attributes` property in the playlist.
   *
   * @return {Object} The combined cloned playlist.
   */
  createClonePlaylist_(e, t, s, r) {
    const n = this.createCloneURI_(e.resolvedUri, s), a = {
      resolvedUri: n,
      uri: n,
      id: t
    };
    return e.segments && (a.segments = []), r && (a.attributes = r), te(e, a);
  }
  /**
   * Generates an updated URI for a cloned pathway based on the original
   * pathway's URI and the paramaters from the pathway clone object in the
   * content steering server response.
   *
   * @param {string} baseUri URI to be updated in the cloned pathway.
   * @param {Object} clone The pathway clone object.
   *
   * @return {string} The updated URI for the cloned pathway.
   */
  createCloneURI_(e, t) {
    const s = new URL(e);
    s.hostname = t["URI-REPLACEMENT"].HOST;
    const r = t["URI-REPLACEMENT"].PARAMS;
    for (const n of Object.keys(r))
      s.searchParams.set(n, r[n]);
    return s.href;
  }
  /**
   * Helper function to create the attributes needed for the new clone.
   * This mainly adds the necessary media attributes.
   *
   * @param {string} id The pathway clone object ID.
   * @param {Object} oldAttributes The old attributes to compare to.
   * @return {Object} The new attributes to add to the playlist.
   */
  createCloneAttributes_(e, t) {
    const s = {
      "PATHWAY-ID": e
    };
    return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((r) => {
      t[r] && (s[r] = e);
    }), s;
  }
  /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */
  getKeyIdSet(e) {
    if (e.contentProtection) {
      const t = /* @__PURE__ */ new Set();
      for (const s in e.contentProtection) {
        const r = e.contentProtection[s].attributes.keyId;
        r && t.add(r.toLowerCase());
      }
      return t;
    }
  }
}
const io = function(i, e, t, s) {
  const r = i.responseType === "arraybuffer" ? i.response : i.responseText;
  !e && r && (i.responseTime = Date.now(), i.roundTripTime = i.responseTime - i.requestTime, i.bytesReceived = r.byteLength || r.length, i.bandwidth || (i.bandwidth = Math.floor(i.bytesReceived / i.roundTripTime * 8 * 1e3))), t.headers && (i.responseHeaders = t.headers), e && e.code === "ETIMEDOUT" && (i.timedout = !0), !e && !i.aborted && t.statusCode !== 200 && t.statusCode !== 206 && t.statusCode !== 0 && (e = new Error("XHR Failed with a response of: " + (i && (r || i.responseText)))), s(e, i);
}, xv = (i, e) => {
  if (!i || !i.size)
    return;
  let t = e;
  return i.forEach((s) => {
    t = s(t);
  }), t;
}, Sv = (i, e, t, s) => {
  !i || !i.size || i.forEach((r) => {
    r(e, t, s);
  });
}, wf = function() {
  const i = function e(t, s) {
    t = te({
      timeout: 45e3
    }, t);
    const r = e.beforeRequest || L.Vhs.xhr.beforeRequest, n = e._requestCallbackSet || L.Vhs.xhr._requestCallbackSet || /* @__PURE__ */ new Set(), a = e._responseCallbackSet || L.Vhs.xhr._responseCallbackSet;
    r && typeof r == "function" && (L.log.warn("beforeRequest is deprecated, use onRequest instead."), n.add(r));
    const o = L.Vhs.xhr.original === !0 ? L.xhr : L.Vhs.xhr, l = xv(n, t);
    n.delete(r);
    const h = o(l || t, function(_, v) {
      return Sv(a, h, _, v), io(h, _, v, s);
    }), m = h.abort;
    return h.abort = function() {
      return h.aborted = !0, m.apply(h, arguments);
    }, h.uri = t.uri, h.requestType = t.requestType, h.requestTime = Date.now(), h;
  };
  return i.original = !0, i;
}, Ev = function(i) {
  let e;
  const t = i.offset;
  return typeof i.offset == "bigint" || typeof i.length == "bigint" ? e = S.BigInt(i.offset) + S.BigInt(i.length) - S.BigInt(1) : e = i.offset + i.length - 1, "bytes=" + t + "-" + e;
}, so = function(i) {
  const e = {};
  return i.byterange && (e.Range = Ev(i.byterange)), e;
}, Cv = function(i, e) {
  return i.start(e) + "-" + i.end(e);
}, Av = function(i, e) {
  const t = i.toString(16);
  return "00".substring(0, 2 - t.length) + t + (e % 2 ? " " : "");
}, Dv = function(i) {
  return i >= 32 && i < 126 ? String.fromCharCode(i) : ".";
}, If = function(i) {
  const e = {};
  return Object.keys(i).forEach((t) => {
    const s = i[t];
    td(s) ? e[t] = {
      bytes: s.buffer,
      byteOffset: s.byteOffset,
      byteLength: s.byteLength
    } : e[t] = s;
  }), e;
}, fn = function(i) {
  const e = i.byterange || {
    length: 1 / 0,
    offset: 0
  };
  return [e.length, e.offset, i.resolvedUri].join(",");
}, kf = function(i) {
  return i.resolvedUri;
}, Pf = (i) => {
  const e = Array.prototype.slice.call(i), t = 16;
  let s = "", r, n;
  for (let a = 0; a < e.length / t; a++)
    r = e.slice(a * t, a * t + t).map(Av).join(""), n = e.slice(a * t, a * t + t).map(Dv).join(""), s += r + " " + n + `
`;
  return s;
}, wv = ({
  bytes: i
}) => Pf(i), Iv = (i) => {
  let e = "", t;
  for (t = 0; t < i.length; t++)
    e += Cv(i, t) + " ";
  return e;
};
var kv = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTransferableMessage: If,
  initSegmentId: fn,
  segmentKeyId: kf,
  hexDump: Pf,
  tagDump: wv,
  textRanges: Iv
});
const Of = 0.25, Pv = (i, e) => {
  if (!e.dateTimeObject)
    return null;
  const t = e.videoTimingInfo.transmuxerPrependedSeconds, r = e.videoTimingInfo.transmuxedPresentationStart + t, n = i - r;
  return new Date(e.dateTimeObject.getTime() + n * 1e3);
}, Ov = (i) => i.transmuxedPresentationEnd - i.transmuxedPresentationStart - i.transmuxerPrependedSeconds, Lv = (i, e) => {
  let t;
  try {
    t = new Date(i);
  } catch {
    return null;
  }
  if (!e || !e.segments || e.segments.length === 0)
    return null;
  let s = e.segments[0];
  if (t < new Date(s.dateTimeObject))
    return null;
  for (let l = 0; l < e.segments.length - 1; l++) {
    s = e.segments[l];
    const h = new Date(e.segments[l + 1].dateTimeObject);
    if (t < h)
      break;
  }
  const r = e.segments[e.segments.length - 1], n = r.dateTimeObject, a = r.videoTimingInfo ? Ov(r.videoTimingInfo) : r.duration + r.duration * Of, o = new Date(n.getTime() + a * 1e3);
  return t > o ? null : (t > new Date(n) && (s = r), {
    segment: s,
    estimatedStart: s.videoTimingInfo ? s.videoTimingInfo.transmuxedPresentationStart : We.duration(e, e.mediaSequence + e.segments.indexOf(s)),
    // Although, given that all segments have accurate date time objects, the segment
    // selected should be accurate, unless the video has been transmuxed at some point
    // (determined by the presence of the videoTimingInfo object), the segment's "player
    // time" (the start time in the player) can't be considered accurate.
    type: s.videoTimingInfo ? "accurate" : "estimate"
  });
}, Rv = (i, e) => {
  if (!e || !e.segments || e.segments.length === 0)
    return null;
  let t = 0, s;
  for (let n = 0; n < e.segments.length && (s = e.segments[n], t = s.videoTimingInfo ? s.videoTimingInfo.transmuxedPresentationEnd : t + s.duration, !(i <= t)); n++)
    ;
  const r = e.segments[e.segments.length - 1];
  if (r.videoTimingInfo && r.videoTimingInfo.transmuxedPresentationEnd < i)
    return null;
  if (i > t) {
    if (i > t + r.duration * Of)
      return null;
    s = r;
  }
  return {
    segment: s,
    estimatedStart: s.videoTimingInfo ? s.videoTimingInfo.transmuxedPresentationStart : t - s.duration,
    // Because videoTimingInfo is only set after transmux, it is the only way to get
    // accurate timing values.
    type: s.videoTimingInfo ? "accurate" : "estimate"
  };
}, Nv = (i, e) => {
  let t, s;
  try {
    t = new Date(i), s = new Date(e);
  } catch {
  }
  const r = t.getTime();
  return (s.getTime() - r) / 1e3;
}, Mv = (i) => {
  if (!i.segments || i.segments.length === 0)
    return !1;
  for (let e = 0; e < i.segments.length; e++)
    if (!i.segments[e].dateTimeObject)
      return !1;
  return !0;
}, Bv = ({
  playlist: i,
  time: e = void 0,
  callback: t
}) => {
  if (!t)
    throw new Error("getProgramTime: callback must be provided");
  if (!i || e === void 0)
    return t({
      message: "getProgramTime: playlist and time must be provided"
    });
  const s = Rv(e, i);
  if (!s)
    return t({
      message: "valid programTime was not found"
    });
  if (s.type === "estimate")
    return t({
      message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
      seekTime: s.estimatedStart
    });
  const r = {
    mediaSeconds: e
  }, n = Pv(e, s.segment);
  return n && (r.programDateTime = n.toISOString()), t(null, r);
}, Lf = ({
  programTime: i,
  playlist: e,
  retryCount: t = 2,
  seekTo: s,
  pauseAfterSeek: r = !0,
  tech: n,
  callback: a
}) => {
  if (!a)
    throw new Error("seekToProgramTime: callback must be provided");
  if (typeof i > "u" || !e || !s)
    return a({
      message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
    });
  if (!e.endList && !n.hasStarted_)
    return a({
      message: "player must be playing a live stream to start buffering"
    });
  if (!Mv(e))
    return a({
      message: "programDateTime tags must be provided in the manifest " + e.resolvedUri
    });
  const o = Lv(i, e);
  if (!o)
    return a({
      message: `${i} was not found in the stream`
    });
  const l = o.segment, h = Nv(l.dateTimeObject, i);
  if (o.type === "estimate") {
    if (t === 0)
      return a({
        message: `${i} is not buffered yet. Try again`
      });
    s(o.estimatedStart + h), n.one("seeked", () => {
      Lf({
        programTime: i,
        playlist: e,
        retryCount: t - 1,
        seekTo: s,
        pauseAfterSeek: r,
        tech: n,
        callback: a
      });
    });
    return;
  }
  const m = l.start + h, _ = () => a(null, n.currentTime());
  n.one("seeked", _), r && n.pause(), s(m);
}, Oa = (i, e) => {
  if (i.readyState === 4)
    return e();
}, Fv = (i, e, t, s) => {
  let r = [], n, a = !1;
  const o = function(_, v, C, A) {
    return v.abort(), a = !0, t(_, v, C, A);
  }, l = function(_, v) {
    if (a)
      return;
    if (_)
      return _.metadata = gi({
        requestType: s,
        request: v,
        error: _
      }), o(_, v, "", r);
    const C = v.responseText.substring(r && r.byteLength || 0, v.responseText.length);
    if (r = j0(r, id(C, !0)), n = n || Ps(r), r.length < 10 || n && r.length < n + 2)
      return Oa(v, () => o(_, v, "", r));
    const A = ko(r);
    return A === "ts" && r.length < 188 ? Oa(v, () => o(_, v, "", r)) : !A && r.length < 376 ? Oa(v, () => o(_, v, "", r)) : o(null, v, A, r);
  }, m = e({
    uri: i,
    beforeSend(_) {
      _.overrideMimeType("text/plain; charset=x-user-defined"), _.addEventListener("progress", function({
        total: v,
        loaded: C
      }) {
        return io(_, null, {
          statusCode: _.status
        }, l);
      });
    }
  }, function(_, v) {
    return io(m, _, v, l);
  });
  return m;
}, {
  EventTarget: Uv
} = L, xc = function(i, e) {
  if (!Df(i, e) || i.sidx && e.sidx && (i.sidx.offset !== e.sidx.offset || i.sidx.length !== e.sidx.length))
    return !1;
  if (!i.sidx && e.sidx || i.sidx && !e.sidx || i.segments && !e.segments || !i.segments && e.segments)
    return !1;
  if (!i.segments && !e.segments)
    return !0;
  for (let t = 0; t < i.segments.length; t++) {
    const s = i.segments[t], r = e.segments[t];
    if (s.uri !== r.uri)
      return !1;
    if (!s.byterange && !r.byterange)
      continue;
    const n = s.byterange, a = r.byterange;
    if (n && !a || !n && a || n.offset !== a.offset || n.length !== a.length)
      return !1;
  }
  return !0;
}, $v = (i, e, t, s) => {
  const r = s.attributes.NAME || t;
  return `placeholder-uri-${i}-${e}-${r}`;
}, qv = ({
  mainXml: i,
  srcUrl: e,
  clientOffset: t,
  sidxMapping: s,
  previousManifest: r
}) => {
  const n = ly(i, {
    manifestUri: e,
    clientOffset: t,
    sidxMapping: s,
    previousManifest: r
  });
  return Sf(n, e, $v), n;
}, jv = (i, e) => {
  us(i, (t, s, r, n) => {
    (!e.mediaGroups[s][r] || !(n in e.mediaGroups[s][r])) && delete i.mediaGroups[s][r][n];
  });
}, Hv = (i, e, t) => {
  let s = !0, r = te(i, {
    // These are top level properties that can be updated
    duration: e.duration,
    minimumUpdatePeriod: e.minimumUpdatePeriod,
    timelineStarts: e.timelineStarts
  });
  for (let n = 0; n < e.playlists.length; n++) {
    const a = e.playlists[n];
    if (a.sidx) {
      const l = En(a.sidx);
      t && t[l] && t[l].sidx && Do(a, t[l].sidx, a.sidx.resolvedUri);
    }
    const o = eo(r, a, xc);
    o && (r = o, s = !1);
  }
  return us(e, (n, a, o, l) => {
    if (n.playlists && n.playlists.length) {
      const h = n.playlists[0].id, m = eo(r, n.playlists[0], xc);
      m && (r = m, l in r.mediaGroups[a][o] || (r.mediaGroups[a][o][l] = n), r.mediaGroups[a][o][l].playlists[0] = r.playlists[h], s = !1);
    }
  }), jv(r, e), e.minimumUpdatePeriod !== i.minimumUpdatePeriod && (s = !1), s ? null : r;
}, Vv = (i, e) => (!i.map && !e.map || !!(i.map && e.map && i.map.byterange.offset === e.map.byterange.offset && i.map.byterange.length === e.map.byterange.length)) && i.uri === e.uri && i.byterange.offset === e.byterange.offset && i.byterange.length === e.byterange.length, Sc = (i, e) => {
  const t = {};
  for (const s in i) {
    const n = i[s].sidx;
    if (n) {
      const a = En(n);
      if (!e[a])
        break;
      const o = e[a].sidxInfo;
      Vv(o, n) && (t[a] = e[a]);
    }
  }
  return t;
}, zv = (i, e) => {
  let s = Sc(i.playlists, e);
  return us(i, (r, n, a, o) => {
    if (r.playlists && r.playlists.length) {
      const l = r.playlists;
      s = te(s, Sc(l, e));
    }
  }), s;
};
class ro extends Uv {
  // DashPlaylistLoader must accept either a src url or a playlist because subsequent
  // playlist loader setups from media groups will expect to be able to pass a playlist
  // (since there aren't external URLs to media playlists with DASH)
  constructor(e, t, s = {}, r) {
    super(), this.mainPlaylistLoader_ = r || this, r || (this.isMain_ = !0);
    const {
      withCredentials: n = !1
    } = s;
    if (this.vhs_ = t, this.withCredentials = n, this.addMetadataToTextTrack = s.addMetadataToTextTrack, !e)
      throw new Error("A non-empty playlist URL or object is required");
    this.on("minimumUpdatePeriod", () => {
      this.refreshXml_();
    }), this.on("mediaupdatetimeout", () => {
      this.refreshMedia_(this.media().id);
    }), this.state = "HAVE_NOTHING", this.loadedPlaylists_ = {}, this.logger_ = ot("DashPlaylistLoader"), this.isMain_ ? (this.mainPlaylistLoader_.srcUrl = e, this.mainPlaylistLoader_.sidxMapping_ = {}) : this.childPlaylist_ = e;
  }
  requestErrored_(e, t, s) {
    if (!this.request)
      return !0;
    if (this.request = null, e)
      return this.error = typeof e == "object" && !(e instanceof Error) ? e : {
        status: t.status,
        message: "DASH request error at URL: " + t.uri,
        response: t.response,
        // MEDIA_ERR_NETWORK
        code: 2,
        metadata: e.metadata
      }, s && (this.state = s), this.trigger("error"), !0;
  }
  /**
   * Verify that the container of the sidx segment can be parsed
   * and if it can, get and parse that segment.
   */
  addSidxSegments_(e, t, s) {
    const r = e.sidx && En(e.sidx);
    if (!e.sidx || !r || this.mainPlaylistLoader_.sidxMapping_[r]) {
      this.mediaRequest_ = S.setTimeout(() => s(!1), 0);
      return;
    }
    const n = hn(e.sidx.resolvedUri), a = (l, h) => {
      if (this.requestErrored_(l, h, t))
        return;
      const m = this.mainPlaylistLoader_.sidxMapping_, {
        requestType: _
      } = h;
      let v;
      try {
        v = my(z(h.response).subarray(8));
      } catch (C) {
        C.metadata = gi({
          requestType: _,
          request: h,
          parseFailure: !0
        }), this.requestErrored_(C, h, t);
        return;
      }
      return m[r] = {
        sidxInfo: e.sidx,
        sidx: v
      }, Do(e, v, e.sidx.resolvedUri), s(!0);
    }, o = "dash-sidx";
    this.request = Fv(n, this.vhs_.xhr, (l, h, m, _) => {
      if (l)
        return a(l, h);
      if (!m || m !== "mp4") {
        const A = m || "unknown";
        return a({
          status: h.status,
          message: `Unsupported ${A} container type for sidx segment at URL: ${n}`,
          // response is just bytes in this case
          // but we really don't want to return that.
          response: "",
          playlist: e,
          internal: !0,
          playlistExclusionDuration: 1 / 0,
          // MEDIA_ERR_NETWORK
          code: 2
        }, h);
      }
      const {
        offset: v,
        length: C
      } = e.sidx.byterange;
      if (_.length >= C + v)
        return a(l, {
          response: _.subarray(v, v + C),
          status: h.status,
          uri: h.uri
        });
      this.request = this.vhs_.xhr({
        uri: n,
        responseType: "arraybuffer",
        requestType: "dash-sidx",
        headers: so({
          byterange: e.sidx.byterange
        })
      }, a);
    }, o);
  }
  dispose() {
    this.trigger("dispose"), this.stopRequest(), this.loadedPlaylists_ = {}, S.clearTimeout(this.minimumUpdatePeriodTimeout_), S.clearTimeout(this.mediaRequest_), S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.mediaRequest_ = null, this.minimumUpdatePeriodTimeout_ = null, this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.off();
  }
  hasPendingRequest() {
    return this.request || this.mediaRequest_;
  }
  stopRequest() {
    if (this.request) {
      const e = this.request;
      this.request = null, e.onreadystatechange = null, e.abort();
    }
  }
  media(e) {
    if (!e)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    const t = this.state;
    if (typeof e == "string") {
      if (!this.mainPlaylistLoader_.main.playlists[e])
        throw new Error("Unknown playlist URI: " + e);
      e = this.mainPlaylistLoader_.main.playlists[e];
    }
    const s = !this.media_ || e.id !== this.media_.id;
    if (s && this.loadedPlaylists_[e.id] && this.loadedPlaylists_[e.id].endList) {
      this.state = "HAVE_METADATA", this.media_ = e, s && (this.trigger("mediachanging"), this.trigger("mediachange"));
      return;
    }
    s && (this.media_ && this.trigger("mediachanging"), this.addSidxSegments_(e, t, (r) => {
      this.haveMetadata({
        startingState: t,
        playlist: e
      });
    }));
  }
  haveMetadata({
    startingState: e,
    playlist: t
  }) {
    this.state = "HAVE_METADATA", this.loadedPlaylists_[t.id] = t, this.mediaRequest_ = null, this.refreshMedia_(t.id), e === "HAVE_MAIN_MANIFEST" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
  }
  pause() {
    this.mainPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.mainPlaylistLoader_.createMupOnMedia_), this.mainPlaylistLoader_.createMupOnMedia_ = null), this.stopRequest(), S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.isMain_ && (S.clearTimeout(this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_), this.mainPlaylistLoader_.minimumUpdatePeriodTimeout_ = null), this.state === "HAVE_NOTHING" && (this.started = !1);
  }
  load(e) {
    S.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null;
    const t = this.media();
    if (e) {
      const s = t ? t.targetDuration / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = S.setTimeout(() => this.load(), s);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    t && !t.endList ? (this.isMain_ && !this.minimumUpdatePeriodTimeout_ && (this.trigger("minimumUpdatePeriod"), this.updateMinimumUpdatePeriodTimeout_()), this.trigger("mediaupdatetimeout")) : this.trigger("loadedplaylist");
  }
  start() {
    if (this.started = !0, !this.isMain_) {
      this.mediaRequest_ = S.setTimeout(() => this.haveMain_(), 0);
      return;
    }
    this.requestMain_((e, t) => {
      this.haveMain_(), !this.hasPendingRequest() && !this.media_ && this.media(this.mainPlaylistLoader_.main.playlists[0]);
    });
  }
  requestMain_(e) {
    const t = {
      manifestInfo: {
        uri: this.mainPlaylistLoader_.srcUrl
      }
    };
    this.trigger({
      type: "manifestrequeststart",
      metadata: t
    }), this.request = this.vhs_.xhr({
      uri: this.mainPlaylistLoader_.srcUrl,
      withCredentials: this.withCredentials,
      requestType: "dash-manifest"
    }, (s, r) => {
      if (s) {
        const {
          requestType: a
        } = r;
        s.metadata = gi({
          requestType: a,
          request: r,
          error: s
        });
      }
      if (this.requestErrored_(s, r)) {
        this.state === "HAVE_NOTHING" && (this.started = !1);
        return;
      }
      this.trigger({
        type: "manifestrequestcomplete",
        metadata: t
      });
      const n = r.responseText !== this.mainPlaylistLoader_.mainXml_;
      if (this.mainPlaylistLoader_.mainXml_ = r.responseText, r.responseHeaders && r.responseHeaders.date ? this.mainLoaded_ = Date.parse(r.responseHeaders.date) : this.mainLoaded_ = Date.now(), this.mainPlaylistLoader_.srcUrl = hn(this.mainPlaylistLoader_.srcUrl, r), n) {
        this.handleMain_(), this.syncClientServerClock_(() => e(r, n));
        return;
      }
      return e(r, n);
    });
  }
  /**
   * Parses the main xml for UTCTiming node to sync the client clock to the server
   * clock. If the UTCTiming node requires a HEAD or GET request, that request is made.
   *
   * @param {Function} done
   *        Function to call when clock sync has completed
   */
  syncClientServerClock_(e) {
    const t = cy(this.mainPlaylistLoader_.mainXml_);
    if (t === null)
      return this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
    if (t.method === "DIRECT")
      return this.mainPlaylistLoader_.clientOffset_ = t.value - Date.now(), e();
    this.request = this.vhs_.xhr({
      uri: Ge(this.mainPlaylistLoader_.srcUrl, t.value),
      method: t.method,
      withCredentials: this.withCredentials,
      requestType: "dash-clock-sync"
    }, (s, r) => {
      if (!this.request)
        return;
      if (s) {
        const {
          requestType: a
        } = r;
        return this.error.metadata = gi({
          requestType: a,
          request: r,
          error: s
        }), this.mainPlaylistLoader_.clientOffset_ = this.mainLoaded_ - Date.now(), e();
      }
      let n;
      t.method === "HEAD" ? !r.responseHeaders || !r.responseHeaders.date ? n = this.mainLoaded_ : n = Date.parse(r.responseHeaders.date) : n = Date.parse(r.responseText), this.mainPlaylistLoader_.clientOffset_ = n - Date.now(), e();
    });
  }
  haveMain_() {
    this.state = "HAVE_MAIN_MANIFEST", this.isMain_ ? this.trigger("loadedplaylist") : this.media_ || this.media(this.childPlaylist_);
  }
  handleMain_() {
    this.mediaRequest_ = null;
    const e = this.mainPlaylistLoader_.main, t = {
      manifestInfo: {
        uri: this.mainPlaylistLoader_.srcUrl
      }
    };
    this.trigger({
      type: "manifestparsestart",
      metadata: t
    });
    let s;
    try {
      s = qv({
        mainXml: this.mainPlaylistLoader_.mainXml_,
        srcUrl: this.mainPlaylistLoader_.srcUrl,
        clientOffset: this.mainPlaylistLoader_.clientOffset_,
        sidxMapping: this.mainPlaylistLoader_.sidxMapping_,
        previousManifest: e
      });
    } catch (n) {
      this.error = n, this.error.metadata = {
        errorType: L.Error.StreamingDashManifestParserError,
        error: n
      }, this.trigger("error");
    }
    e && (s = Hv(e, s, this.mainPlaylistLoader_.sidxMapping_)), this.mainPlaylistLoader_.main = s || e;
    const r = this.mainPlaylistLoader_.main.locations && this.mainPlaylistLoader_.main.locations[0];
    if (r && r !== this.mainPlaylistLoader_.srcUrl && (this.mainPlaylistLoader_.srcUrl = r), (!e || s && s.minimumUpdatePeriod !== e.minimumUpdatePeriod) && this.updateMinimumUpdatePeriodTimeout_(), this.addEventStreamToMetadataTrack_(s), s) {
      const {
        duration: n,
        endList: a
      } = s, o = [];
      s.playlists.forEach((h) => {
        o.push({
          id: h.id,
          bandwidth: h.attributes.BANDWIDTH,
          resolution: h.attributes.RESOLUTION,
          codecs: h.attributes.CODECS
        });
      });
      const l = {
        duration: n,
        isLive: !a,
        renditions: o
      };
      t.parsedManifest = l, this.trigger({
        type: "manifestparsecomplete",
        metadata: t
      });
    }
    return !!s;
  }
  updateMinimumUpdatePeriodTimeout_() {
    const e = this.mainPlaylistLoader_;
    e.createMupOnMedia_ && (e.off("loadedmetadata", e.createMupOnMedia_), e.createMupOnMedia_ = null), e.minimumUpdatePeriodTimeout_ && (S.clearTimeout(e.minimumUpdatePeriodTimeout_), e.minimumUpdatePeriodTimeout_ = null);
    let t = e.main && e.main.minimumUpdatePeriod;
    if (t === 0 && (e.media() ? t = e.media().targetDuration * 1e3 : (e.createMupOnMedia_ = e.updateMinimumUpdatePeriodTimeout_, e.one("loadedmetadata", e.createMupOnMedia_))), typeof t != "number" || t <= 0) {
      t < 0 && this.logger_(`found invalid minimumUpdatePeriod of ${t}, not setting a timeout`);
      return;
    }
    this.createMUPTimeout_(t);
  }
  createMUPTimeout_(e) {
    const t = this.mainPlaylistLoader_;
    t.minimumUpdatePeriodTimeout_ = S.setTimeout(() => {
      t.minimumUpdatePeriodTimeout_ = null, t.trigger("minimumUpdatePeriod"), t.createMUPTimeout_(e);
    }, e);
  }
  /**
   * Sends request to refresh the main xml and updates the parsed main manifest
   */
  refreshXml_() {
    this.requestMain_((e, t) => {
      t && (this.media_ && (this.media_ = this.mainPlaylistLoader_.main.playlists[this.media_.id]), this.mainPlaylistLoader_.sidxMapping_ = zv(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.sidxMapping_), this.addSidxSegments_(this.media(), this.state, (s) => {
        this.refreshMedia_(this.media().id);
      }));
    });
  }
  /**
   * Refreshes the media playlist by re-parsing the main xml and updating playlist
   * references. If this is an alternate loader, the updated parsed manifest is retrieved
   * from the main loader.
   */
  refreshMedia_(e) {
    if (!e)
      throw new Error("refreshMedia_ must take a media id");
    this.media_ && this.isMain_ && this.handleMain_();
    const t = this.mainPlaylistLoader_.main.playlists, s = !this.media_ || this.media_ !== t[e];
    if (s ? this.media_ = t[e] : this.trigger("playlistunchanged"), !this.mediaUpdateTimeout) {
      const r = () => {
        this.media().endList || (this.mediaUpdateTimeout = S.setTimeout(() => {
          this.trigger("mediaupdatetimeout"), r();
        }, to(this.media(), !!s)));
      };
      r();
    }
    this.trigger("loadedplaylist");
  }
  /**
   * Takes eventstream data from a parsed DASH manifest and adds it to the metadata text track.
   *
   * @param {manifest} newMain the newly parsed manifest
   */
  addEventStreamToMetadataTrack_(e) {
    if (e && this.mainPlaylistLoader_.main.eventStream) {
      const t = this.mainPlaylistLoader_.main.eventStream.map((s) => ({
        cueTime: s.start,
        frames: [{
          data: s.messageData
        }]
      }));
      this.addMetadataToTextTrack("EventStream", t, this.mainPlaylistLoader_.main.duration);
    }
  }
  /**
   * Returns the key ID set from a playlist
   *
   * @param {playlist} playlist to fetch the key ID set from.
   * @return a Set of 32 digit hex strings that represent the unique keyIds for that playlist.
   */
  getKeyIdSet(e) {
    if (e.contentProtection) {
      const t = /* @__PURE__ */ new Set();
      for (const s in e.contentProtection) {
        const r = e.contentProtection[s].attributes["cenc:default_KID"];
        r && t.add(r.replace(/-/g, "").toLowerCase());
      }
      return t;
    }
  }
}
var Ae = {
  GOAL_BUFFER_LENGTH: 30,
  MAX_GOAL_BUFFER_LENGTH: 60,
  BACK_BUFFER_LENGTH: 30,
  GOAL_BUFFER_LENGTH_RATE: 1,
  // 0.5 MB/s
  INITIAL_BANDWIDTH: 4194304,
  // A fudge factor to apply to advertised playlist bitrates to account for
  // temporary flucations in client bandwidth
  BANDWIDTH_VARIANCE: 1.2,
  // How much of the buffer must be filled before we consider upswitching
  BUFFER_LOW_WATER_LINE: 0,
  MAX_BUFFER_LOW_WATER_LINE: 30,
  // TODO: Remove this when experimentalBufferBasedABR is removed
  EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
  BUFFER_LOW_WATER_LINE_RATE: 1,
  // If the buffer is greater than the high water line, we won't switch down
  BUFFER_HIGH_WATER_LINE: 30
};
const Gv = (i) => {
  const e = new Uint8Array(new ArrayBuffer(i.length));
  for (let t = 0; t < i.length; t++)
    e[t] = i.charCodeAt(t);
  return e.buffer;
}, Rf = function(i) {
  return i.on = i.addEventListener, i.off = i.removeEventListener, i;
}, Wv = function(i) {
  try {
    return URL.createObjectURL(new Blob([i], {
      type: "application/javascript"
    }));
  } catch {
    const t = new BlobBuilder();
    return t.append(i), URL.createObjectURL(t.getBlob());
  }
}, Nf = function(i) {
  return function() {
    const e = Wv(i), t = Rf(new Worker(e));
    t.objURL = e;
    const s = t.terminate;
    return t.on = t.addEventListener, t.off = t.removeEventListener, t.terminate = function() {
      return URL.revokeObjectURL(e), s.call(this);
    }, t;
  };
}, Mf = function(i) {
  return `var browserWorkerPolyFill = ${Rf.toString()};
browserWorkerPolyFill(self);
` + i;
}, Bf = function(i) {
  return i.toString().replace(/^function.+?{/, "").slice(0, -1);
}, Xv = Mf(Bf(function() {
  var i = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, e = function() {
    this.init = function() {
      var u = {};
      this.on = function(c, f) {
        u[c] || (u[c] = []), u[c] = u[c].concat(f);
      }, this.off = function(c, f) {
        var d;
        return u[c] ? (d = u[c].indexOf(f), u[c] = u[c].slice(), u[c].splice(d, 1), d > -1) : !1;
      }, this.trigger = function(c) {
        var f, d, p, g;
        if (f = u[c], !!f)
          if (arguments.length === 2)
            for (p = f.length, d = 0; d < p; ++d)
              f[d].call(this, arguments[1]);
          else {
            for (g = [], d = arguments.length, d = 1; d < arguments.length; ++d)
              g.push(arguments[d]);
            for (p = f.length, d = 0; d < p; ++d)
              f[d].apply(this, g);
          }
      }, this.dispose = function() {
        u = {};
      };
    };
  };
  e.prototype.pipe = function(u) {
    return this.on("data", function(c) {
      u.push(c);
    }), this.on("done", function(c) {
      u.flush(c);
    }), this.on("partialdone", function(c) {
      u.partialFlush(c);
    }), this.on("endedtimeline", function(c) {
      u.endTimeline(c);
    }), this.on("reset", function(c) {
      u.reset(c);
    }), u;
  }, e.prototype.push = function(u) {
    this.trigger("data", u);
  }, e.prototype.flush = function(u) {
    this.trigger("done", u);
  }, e.prototype.partialFlush = function(u) {
    this.trigger("partialdone", u);
  }, e.prototype.endTimeline = function(u) {
    this.trigger("endedtimeline", u);
  }, e.prototype.reset = function(u) {
    this.trigger("reset", u);
  };
  var t = e, s = Math.pow(2, 32), r = function(u) {
    var c = new DataView(u.buffer, u.byteOffset, u.byteLength), f;
    return c.getBigUint64 ? (f = c.getBigUint64(0), f < Number.MAX_SAFE_INTEGER ? Number(f) : f) : c.getUint32(0) * s + c.getUint32(4);
  }, n = {
    getUint64: r,
    MAX_UINT32: s
  }, a = n.MAX_UINT32, o, l, h, m, _, v, C, A, y, D, w, O, P, R, I, B, H, $, X, ue, J, ne, V, Z, Re, ee, Te, Dt, Jt, Zt, ei, ti, ar, fu, pu, mu;
  (function() {
    var u;
    if (V = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      // codingname
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      smhd: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      styp: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: []
    }, !(typeof Uint8Array > "u")) {
      for (u in V)
        V.hasOwnProperty(u) && (V[u] = [u.charCodeAt(0), u.charCodeAt(1), u.charCodeAt(2), u.charCodeAt(3)]);
      Z = new Uint8Array([105, 115, 111, 109]), ee = new Uint8Array([97, 118, 99, 49]), Re = new Uint8Array([0, 0, 0, 1]), Te = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        118,
        105,
        100,
        101,
        // handler_type: 'vide'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        86,
        105,
        100,
        101,
        111,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'VideoHandler'
      ]), Dt = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        115,
        111,
        117,
        110,
        // handler_type: 'soun'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        83,
        111,
        117,
        110,
        100,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'SoundHandler'
      ]), Jt = {
        video: Te,
        audio: Dt
      }, ti = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1,
        // entry_count
        0,
        0,
        0,
        12,
        // entry_size
        117,
        114,
        108,
        32,
        // 'url' type
        0,
        // version 0
        0,
        0,
        1
        // entry_flags
      ]), ei = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        // balance, 0 means centered
        0,
        0
        // reserved
      ]), ar = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0
        // entry_count
      ]), fu = ar, pu = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // sample_size
        0,
        0,
        0,
        0
        // sample_count
      ]), mu = ar, Zt = new Uint8Array([
        0,
        // version
        0,
        0,
        1,
        // flags
        0,
        0,
        // graphicsmode
        0,
        0,
        0,
        0,
        0,
        0
        // opcolor
      ]);
    }
  })(), o = function(u) {
    var c = [], f = 0, d, p, g;
    for (d = 1; d < arguments.length; d++)
      c.push(arguments[d]);
    for (d = c.length; d--; )
      f += c[d].byteLength;
    for (p = new Uint8Array(f + 8), g = new DataView(p.buffer, p.byteOffset, p.byteLength), g.setUint32(0, p.byteLength), p.set(u, 4), d = 0, f = 8; d < c.length; d++)
      p.set(c[d], f), f += c[d].byteLength;
    return p;
  }, l = function() {
    return o(V.dinf, o(V.dref, ti));
  }, h = function(u) {
    return o(V.esds, new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      // ES_Descriptor
      3,
      // tag, ES_DescrTag
      25,
      // length
      0,
      0,
      // ES_ID
      0,
      // streamDependenceFlag, URL_flag, reserved, streamPriority
      // DecoderConfigDescriptor
      4,
      // tag, DecoderConfigDescrTag
      17,
      // length
      64,
      // object type
      21,
      // streamType
      0,
      6,
      0,
      // bufferSizeDB
      0,
      0,
      218,
      192,
      // maxBitrate
      0,
      0,
      218,
      192,
      // avgBitrate
      // DecoderSpecificInfo
      5,
      // tag, DecoderSpecificInfoTag
      2,
      // length
      // ISO/IEC 14496-3, AudioSpecificConfig
      // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
      u.audioobjecttype << 3 | u.samplingfrequencyindex >>> 1,
      u.samplingfrequencyindex << 7 | u.channelcount << 3,
      6,
      1,
      2
      // GASpecificConfig
    ]));
  }, m = function() {
    return o(V.ftyp, Z, Re, Z, ee);
  }, B = function(u) {
    return o(V.hdlr, Jt[u]);
  }, _ = function(u) {
    return o(V.mdat, u);
  }, I = function(u) {
    var c = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      3,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      u.duration >>> 24 & 255,
      u.duration >>> 16 & 255,
      u.duration >>> 8 & 255,
      u.duration & 255,
      // duration
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]);
    return u.samplerate && (c[12] = u.samplerate >>> 24 & 255, c[13] = u.samplerate >>> 16 & 255, c[14] = u.samplerate >>> 8 & 255, c[15] = u.samplerate & 255), o(V.mdhd, c);
  }, R = function(u) {
    return o(V.mdia, I(u), B(u.type), C(u));
  }, v = function(u) {
    return o(V.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      (u & 4278190080) >> 24,
      (u & 16711680) >> 16,
      (u & 65280) >> 8,
      u & 255
      // sequence_number
    ]));
  }, C = function(u) {
    return o(V.minf, u.type === "video" ? o(V.vmhd, Zt) : o(V.smhd, ei), l(), $(u));
  }, A = function(u, c) {
    for (var f = [], d = c.length; d--; )
      f[d] = ue(c[d]);
    return o.apply(null, [V.moof, v(u)].concat(f));
  }, y = function(u) {
    for (var c = u.length, f = []; c--; )
      f[c] = O(u[c]);
    return o.apply(null, [V.moov, w(4294967295)].concat(f).concat(D(u)));
  }, D = function(u) {
    for (var c = u.length, f = []; c--; )
      f[c] = J(u[c]);
    return o.apply(null, [V.mvex].concat(f));
  }, w = function(u) {
    var c = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // creation_time
      0,
      0,
      0,
      2,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      (u & 4278190080) >> 24,
      (u & 16711680) >> 16,
      (u & 65280) >> 8,
      u & 255,
      // duration
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return o(V.mvhd, c);
  }, H = function(u) {
    var c = u.samples || [], f = new Uint8Array(4 + c.length), d, p;
    for (p = 0; p < c.length; p++)
      d = c[p].flags, f[p + 4] = d.dependsOn << 4 | d.isDependedOn << 2 | d.hasRedundancy;
    return o(V.sdtp, f);
  }, $ = function(u) {
    return o(V.stbl, X(u), o(V.stts, mu), o(V.stsc, fu), o(V.stsz, pu), o(V.stco, ar));
  }, function() {
    var u, c;
    X = function(f) {
      return o(V.stsd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1
      ]), f.type === "video" ? u(f) : c(f));
    }, u = function(f) {
      var d = f.sps || [], p = f.pps || [], g = [], T = [], b, x;
      for (b = 0; b < d.length; b++)
        g.push((d[b].byteLength & 65280) >>> 8), g.push(d[b].byteLength & 255), g = g.concat(Array.prototype.slice.call(d[b]));
      for (b = 0; b < p.length; b++)
        T.push((p[b].byteLength & 65280) >>> 8), T.push(p[b].byteLength & 255), T = T.concat(Array.prototype.slice.call(p[b]));
      if (x = [V.avc1, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        (f.width & 65280) >> 8,
        f.width & 255,
        // width
        (f.height & 65280) >> 8,
        f.height & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        19,
        118,
        105,
        100,
        101,
        111,
        106,
        115,
        45,
        99,
        111,
        110,
        116,
        114,
        105,
        98,
        45,
        104,
        108,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
        // pre_defined = -1
      ]), o(V.avcC, new Uint8Array([
        1,
        // configurationVersion
        f.profileIdc,
        // AVCProfileIndication
        f.profileCompatibility,
        // profile_compatibility
        f.levelIdc,
        // AVCLevelIndication
        255
        // lengthSizeMinusOne, hard-coded to 4 bytes
      ].concat(
        [d.length],
        // numOfSequenceParameterSets
        g,
        // "SPS"
        [p.length],
        // numOfPictureParameterSets
        T
        // "PPS"
      ))), o(V.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
        // avgBitrate
      ]))], f.sarRatio) {
        var E = f.sarRatio[0], k = f.sarRatio[1];
        x.push(o(V.pasp, new Uint8Array([(E & 4278190080) >> 24, (E & 16711680) >> 16, (E & 65280) >> 8, E & 255, (k & 4278190080) >> 24, (k & 16711680) >> 16, (k & 65280) >> 8, k & 255])));
      }
      return o.apply(null, x);
    }, c = function(f) {
      return o(V.mp4a, new Uint8Array([
        // SampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        // AudioSampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        (f.channelcount & 65280) >> 8,
        f.channelcount & 255,
        // channelcount
        (f.samplesize & 65280) >> 8,
        f.samplesize & 255,
        // samplesize
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        (f.samplerate & 65280) >> 8,
        f.samplerate & 255,
        0,
        0
        // samplerate, 16.16
        // MP4AudioSampleEntry, ISO/IEC 14496-14
      ]), h(f));
    };
  }(), P = function(u) {
    var c = new Uint8Array([
      0,
      // version 0
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      // creation_time
      0,
      0,
      0,
      0,
      // modification_time
      (u.id & 4278190080) >> 24,
      (u.id & 16711680) >> 16,
      (u.id & 65280) >> 8,
      u.id & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      (u.duration & 4278190080) >> 24,
      (u.duration & 16711680) >> 16,
      (u.duration & 65280) >> 8,
      u.duration & 255,
      // duration
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      1,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      (u.width & 65280) >> 8,
      u.width & 255,
      0,
      0,
      // width
      (u.height & 65280) >> 8,
      u.height & 255,
      0,
      0
      // height
    ]);
    return o(V.tkhd, c);
  }, ue = function(u) {
    var c, f, d, p, g, T, b;
    return c = o(V.tfhd, new Uint8Array([
      0,
      // version 0
      0,
      0,
      58,
      // flags
      (u.id & 4278190080) >> 24,
      (u.id & 16711680) >> 16,
      (u.id & 65280) >> 8,
      u.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      0,
      0,
      0
      // default_sample_flags
    ])), T = Math.floor(u.baseMediaDecodeTime / a), b = Math.floor(u.baseMediaDecodeTime % a), f = o(V.tfdt, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      // baseMediaDecodeTime
      T >>> 24 & 255,
      T >>> 16 & 255,
      T >>> 8 & 255,
      T & 255,
      b >>> 24 & 255,
      b >>> 16 & 255,
      b >>> 8 & 255,
      b & 255
    ])), g = 92, u.type === "audio" ? (d = ne(u, g), o(V.traf, c, f, d)) : (p = H(u), d = ne(u, p.length + g), o(V.traf, c, f, d, p));
  }, O = function(u) {
    return u.duration = u.duration || 4294967295, o(V.trak, P(u), R(u));
  }, J = function(u) {
    var c = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      (u.id & 4278190080) >> 24,
      (u.id & 16711680) >> 16,
      (u.id & 65280) >> 8,
      u.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]);
    return u.type !== "video" && (c[c.length - 1] = 0), o(V.trex, c);
  }, function() {
    var u, c, f;
    f = function(d, p) {
      var g = 0, T = 0, b = 0, x = 0;
      return d.length && (d[0].duration !== void 0 && (g = 1), d[0].size !== void 0 && (T = 2), d[0].flags !== void 0 && (b = 4), d[0].compositionTimeOffset !== void 0 && (x = 8)), [
        0,
        // version 0
        0,
        g | T | b | x,
        1,
        // flags
        (d.length & 4278190080) >>> 24,
        (d.length & 16711680) >>> 16,
        (d.length & 65280) >>> 8,
        d.length & 255,
        // sample_count
        (p & 4278190080) >>> 24,
        (p & 16711680) >>> 16,
        (p & 65280) >>> 8,
        p & 255
        // data_offset
      ];
    }, c = function(d, p) {
      var g, T, b, x, E, k;
      for (x = d.samples || [], p += 20 + 16 * x.length, b = f(x, p), T = new Uint8Array(b.length + x.length * 16), T.set(b), g = b.length, k = 0; k < x.length; k++)
        E = x[k], T[g++] = (E.duration & 4278190080) >>> 24, T[g++] = (E.duration & 16711680) >>> 16, T[g++] = (E.duration & 65280) >>> 8, T[g++] = E.duration & 255, T[g++] = (E.size & 4278190080) >>> 24, T[g++] = (E.size & 16711680) >>> 16, T[g++] = (E.size & 65280) >>> 8, T[g++] = E.size & 255, T[g++] = E.flags.isLeading << 2 | E.flags.dependsOn, T[g++] = E.flags.isDependedOn << 6 | E.flags.hasRedundancy << 4 | E.flags.paddingValue << 1 | E.flags.isNonSyncSample, T[g++] = E.flags.degradationPriority & 61440, T[g++] = E.flags.degradationPriority & 15, T[g++] = (E.compositionTimeOffset & 4278190080) >>> 24, T[g++] = (E.compositionTimeOffset & 16711680) >>> 16, T[g++] = (E.compositionTimeOffset & 65280) >>> 8, T[g++] = E.compositionTimeOffset & 255;
      return o(V.trun, T);
    }, u = function(d, p) {
      var g, T, b, x, E, k;
      for (x = d.samples || [], p += 20 + 8 * x.length, b = f(x, p), g = new Uint8Array(b.length + x.length * 8), g.set(b), T = b.length, k = 0; k < x.length; k++)
        E = x[k], g[T++] = (E.duration & 4278190080) >>> 24, g[T++] = (E.duration & 16711680) >>> 16, g[T++] = (E.duration & 65280) >>> 8, g[T++] = E.duration & 255, g[T++] = (E.size & 4278190080) >>> 24, g[T++] = (E.size & 16711680) >>> 16, g[T++] = (E.size & 65280) >>> 8, g[T++] = E.size & 255;
      return o(V.trun, g);
    }, ne = function(d, p) {
      return d.type === "audio" ? u(d, p) : c(d, p);
    };
  }();
  var dp = {
    ftyp: m,
    mdat: _,
    moof: A,
    moov: y,
    initSegment: function(u) {
      var c = m(), f = y(u), d;
      return d = new Uint8Array(c.byteLength + f.byteLength), d.set(c), d.set(f, c.byteLength), d;
    }
  }, hp = function(u) {
    var c, f, d = [], p = [];
    for (p.byteLength = 0, p.nalCount = 0, p.duration = 0, d.byteLength = 0, c = 0; c < u.length; c++)
      f = u[c], f.nalUnitType === "access_unit_delimiter_rbsp" ? (d.length && (d.duration = f.dts - d.dts, p.byteLength += d.byteLength, p.nalCount += d.length, p.duration += d.duration, p.push(d)), d = [f], d.byteLength = f.data.byteLength, d.pts = f.pts, d.dts = f.dts) : (f.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (d.keyFrame = !0), d.duration = f.dts - d.dts, d.byteLength += f.data.byteLength, d.push(f));
    return p.length && (!d.duration || d.duration <= 0) && (d.duration = p[p.length - 1].duration), p.byteLength += d.byteLength, p.nalCount += d.length, p.duration += d.duration, p.push(d), p;
  }, fp = function(u) {
    var c, f, d = [], p = [];
    for (d.byteLength = 0, d.nalCount = 0, d.duration = 0, d.pts = u[0].pts, d.dts = u[0].dts, p.byteLength = 0, p.nalCount = 0, p.duration = 0, p.pts = u[0].pts, p.dts = u[0].dts, c = 0; c < u.length; c++)
      f = u[c], f.keyFrame ? (d.length && (p.push(d), p.byteLength += d.byteLength, p.nalCount += d.nalCount, p.duration += d.duration), d = [f], d.nalCount = f.length, d.byteLength = f.byteLength, d.pts = f.pts, d.dts = f.dts, d.duration = f.duration) : (d.duration += f.duration, d.nalCount += f.length, d.byteLength += f.byteLength, d.push(f));
    return p.length && d.duration <= 0 && (d.duration = p[p.length - 1].duration), p.byteLength += d.byteLength, p.nalCount += d.nalCount, p.duration += d.duration, p.push(d), p;
  }, pp = function(u) {
    var c;
    return !u[0][0].keyFrame && u.length > 1 && (c = u.shift(), u.byteLength -= c.byteLength, u.nalCount -= c.nalCount, u[0][0].dts = c.dts, u[0][0].pts = c.pts, u[0][0].duration += c.duration), u;
  }, mp = function() {
    return {
      size: 0,
      flags: {
        isLeading: 0,
        dependsOn: 1,
        isDependedOn: 0,
        hasRedundancy: 0,
        degradationPriority: 0,
        isNonSyncSample: 1
      }
    };
  }, gu = function(u, c) {
    var f = mp();
    return f.dataOffset = c, f.compositionTimeOffset = u.pts - u.dts, f.duration = u.duration, f.size = 4 * u.length, f.size += u.byteLength, u.keyFrame && (f.flags.dependsOn = 2, f.flags.isNonSyncSample = 0), f;
  }, gp = function(u, c) {
    var f, d, p, g, T, b = c || 0, x = [];
    for (f = 0; f < u.length; f++)
      for (g = u[f], d = 0; d < g.length; d++)
        T = g[d], p = gu(T, b), b += p.size, x.push(p);
    return x;
  }, _p = function(u) {
    var c, f, d, p, g, T, b = 0, x = u.byteLength, E = u.nalCount, k = x + 4 * E, N = new Uint8Array(k), q = new DataView(N.buffer);
    for (c = 0; c < u.length; c++)
      for (p = u[c], f = 0; f < p.length; f++)
        for (g = p[f], d = 0; d < g.length; d++)
          T = g[d], q.setUint32(b, T.data.byteLength), b += 4, N.set(T.data, b), b += T.data.byteLength;
    return N;
  }, yp = function(u, c) {
    var f, d = c || 0, p = [];
    return f = gu(u, d), p.push(f), p;
  }, Tp = function(u) {
    var c, f, d = 0, p = u.byteLength, g = u.length, T = p + 4 * g, b = new Uint8Array(T), x = new DataView(b.buffer);
    for (c = 0; c < u.length; c++)
      f = u[c], x.setUint32(d, f.data.byteLength), d += 4, b.set(f.data, d), d += f.data.byteLength;
    return b;
  }, vp = {
    groupNalsIntoFrames: hp,
    groupFramesIntoGops: fp,
    extendFirstKeyFrame: pp,
    generateSampleTable: gp,
    concatenateNalData: _p,
    generateSampleTableForFrame: yp,
    concatenateNalDataForFrame: Tp
  }, $t = [33, 16, 5, 32, 164, 27], Hn = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252], ie = function(u) {
    for (var c = []; u--; )
      c.push(0);
    return c;
  }, bp = function(u) {
    return Object.keys(u).reduce(function(c, f) {
      return c[f] = new Uint8Array(u[f].reduce(function(d, p) {
        return d.concat(p);
      }, [])), c;
    }, {});
  }, Vn, xp = function() {
    if (!Vn) {
      var u = {
        96e3: [$t, [227, 64], ie(154), [56]],
        88200: [$t, [231], ie(170), [56]],
        64e3: [$t, [248, 192], ie(240), [56]],
        48e3: [$t, [255, 192], ie(268), [55, 148, 128], ie(54), [112]],
        44100: [$t, [255, 192], ie(268), [55, 163, 128], ie(84), [112]],
        32e3: [$t, [255, 192], ie(268), [55, 234], ie(226), [112]],
        24e3: [$t, [255, 192], ie(268), [55, 255, 128], ie(268), [111, 112], ie(126), [224]],
        16e3: [$t, [255, 192], ie(268), [55, 255, 128], ie(268), [111, 255], ie(269), [223, 108], ie(195), [1, 192]],
        12e3: [Hn, ie(268), [3, 127, 248], ie(268), [6, 255, 240], ie(268), [13, 255, 224], ie(268), [27, 253, 128], ie(259), [56]],
        11025: [Hn, ie(268), [3, 127, 248], ie(268), [6, 255, 240], ie(268), [13, 255, 224], ie(268), [27, 255, 192], ie(268), [55, 175, 128], ie(108), [112]],
        8e3: [Hn, ie(268), [3, 121, 16], ie(47), [7]]
      };
      Vn = bp(u);
    }
    return Vn;
  }, zn = 9e4, Gn, Wn, or, Xn, _u, yu, Tu;
  Gn = function(u) {
    return u * zn;
  }, Wn = function(u, c) {
    return u * c;
  }, or = function(u) {
    return u / zn;
  }, Xn = function(u, c) {
    return u / c;
  }, _u = function(u, c) {
    return Gn(Xn(u, c));
  }, yu = function(u, c) {
    return Wn(or(u), c);
  }, Tu = function(u, c, f) {
    return or(f ? u : u - c);
  };
  var ce = {
    ONE_SECOND_IN_TS: zn,
    secondsToVideoTs: Gn,
    secondsToAudioTs: Wn,
    videoTsToSeconds: or,
    audioTsToSeconds: Xn,
    audioTsToVideoTs: _u,
    videoTsToAudioTs: yu,
    metadataTsToSeconds: Tu
  }, Sp = xp, ur = ce, Ep = function(u) {
    var c, f, d = 0;
    for (c = 0; c < u.length; c++)
      f = u[c], d += f.data.byteLength;
    return d;
  }, Cp = function(u, c, f, d) {
    var p, g = 0, T = 0, b = 0, x = 0, E, k, N;
    if (c.length && (p = ur.audioTsToVideoTs(u.baseMediaDecodeTime, u.samplerate), g = Math.ceil(ur.ONE_SECOND_IN_TS / (u.samplerate / 1024)), f && d && (T = p - Math.max(f, d), b = Math.floor(T / g), x = b * g), !(b < 1 || x > ur.ONE_SECOND_IN_TS / 2))) {
      for (E = Sp()[u.samplerate], E || (E = c[0].data), k = 0; k < b; k++)
        N = c[0], c.splice(0, 0, {
          data: E,
          dts: N.dts - g,
          pts: N.pts - g
        });
      return u.baseMediaDecodeTime -= Math.floor(ur.videoTsToAudioTs(x, u.samplerate)), x;
    }
  }, Ap = function(u, c, f) {
    return c.minSegmentDts >= f ? u : (c.minSegmentDts = 1 / 0, u.filter(function(d) {
      return d.dts >= f ? (c.minSegmentDts = Math.min(c.minSegmentDts, d.dts), c.minSegmentPts = c.minSegmentDts, !0) : !1;
    }));
  }, Dp = function(u) {
    var c, f, d = [];
    for (c = 0; c < u.length; c++)
      f = u[c], d.push({
        size: f.data.byteLength,
        duration: 1024
        // For AAC audio, all samples contain 1024 samples
      });
    return d;
  }, wp = function(u) {
    var c, f, d = 0, p = new Uint8Array(Ep(u));
    for (c = 0; c < u.length; c++)
      f = u[c], p.set(f.data, d), d += f.data.byteLength;
    return p;
  }, Ip = {
    prefixWithSilence: Cp,
    trimAdtsFramesByEarliestDts: Ap,
    generateSampleTable: Dp,
    concatenateFrameData: wp
  }, kp = ce.ONE_SECOND_IN_TS, Pp = function(u, c) {
    typeof c.pts == "number" && (u.timelineStartInfo.pts === void 0 && (u.timelineStartInfo.pts = c.pts), u.minSegmentPts === void 0 ? u.minSegmentPts = c.pts : u.minSegmentPts = Math.min(u.minSegmentPts, c.pts), u.maxSegmentPts === void 0 ? u.maxSegmentPts = c.pts : u.maxSegmentPts = Math.max(u.maxSegmentPts, c.pts)), typeof c.dts == "number" && (u.timelineStartInfo.dts === void 0 && (u.timelineStartInfo.dts = c.dts), u.minSegmentDts === void 0 ? u.minSegmentDts = c.dts : u.minSegmentDts = Math.min(u.minSegmentDts, c.dts), u.maxSegmentDts === void 0 ? u.maxSegmentDts = c.dts : u.maxSegmentDts = Math.max(u.maxSegmentDts, c.dts));
  }, Op = function(u) {
    delete u.minSegmentDts, delete u.maxSegmentDts, delete u.minSegmentPts, delete u.maxSegmentPts;
  }, Lp = function(u, c) {
    var f, d, p = u.minSegmentDts;
    return c || (p -= u.timelineStartInfo.dts), f = u.timelineStartInfo.baseMediaDecodeTime, f += p, f = Math.max(0, f), u.type === "audio" && (d = u.samplerate / kp, f *= d, f = Math.floor(f)), f;
  }, Rp = {
    clearDtsInfo: Op,
    calculateTrackBaseMediaDecodeTime: Lp,
    collectDtsInfo: Pp
  }, vu = 4, Np = 128, Mp = function(u) {
    for (var c = 0, f = {
      payloadType: -1,
      payloadSize: 0
    }, d = 0, p = 0; c < u.byteLength && u[c] !== Np; ) {
      for (; u[c] === 255; )
        d += 255, c++;
      for (d += u[c++]; u[c] === 255; )
        p += 255, c++;
      if (p += u[c++], !f.payload && d === vu) {
        var g = String.fromCharCode(u[c + 3], u[c + 4], u[c + 5], u[c + 6]);
        if (g === "GA94") {
          f.payloadType = d, f.payloadSize = p, f.payload = u.subarray(c, c + p);
          break;
        } else
          f.payload = void 0;
      }
      c += p, d = 0, p = 0;
    }
    return f;
  }, Bp = function(u) {
    return u.payload[0] !== 181 || (u.payload[1] << 8 | u.payload[2]) !== 49 || String.fromCharCode(u.payload[3], u.payload[4], u.payload[5], u.payload[6]) !== "GA94" || u.payload[7] !== 3 ? null : u.payload.subarray(8, u.payload.length - 1);
  }, Fp = function(u, c) {
    var f = [], d, p, g, T;
    if (!(c[0] & 64))
      return f;
    for (p = c[0] & 31, d = 0; d < p; d++)
      g = d * 3, T = {
        type: c[g + 2] & 3,
        pts: u
      }, c[g + 2] & 4 && (T.ccData = c[g + 3] << 8 | c[g + 4], f.push(T));
    return f;
  }, Up = function(u) {
    for (var c = u.byteLength, f = [], d = 1, p, g; d < c - 2; )
      u[d] === 0 && u[d + 1] === 0 && u[d + 2] === 3 ? (f.push(d + 2), d += 2) : d++;
    if (f.length === 0)
      return u;
    p = c - f.length, g = new Uint8Array(p);
    var T = 0;
    for (d = 0; d < p; T++, d++)
      T === f[0] && (T++, f.shift()), g[d] = u[T];
    return g;
  }, bu = {
    parseSei: Mp,
    parseUserData: Bp,
    parseCaptionPackets: Fp,
    discardEmulationPreventionBytes: Up,
    USER_DATA_REGISTERED_ITU_T_T35: vu
  }, Kn = t, lr = bu, He = function(u) {
    u = u || {}, He.prototype.init.call(this), this.parse708captions_ = typeof u.parse708captions == "boolean" ? u.parse708captions : !0, this.captionPackets_ = [], this.ccStreams_ = [
      new he(0, 0),
      // eslint-disable-line no-use-before-define
      new he(0, 1),
      // eslint-disable-line no-use-before-define
      new he(1, 0),
      // eslint-disable-line no-use-before-define
      new he(1, 1)
      // eslint-disable-line no-use-before-define
    ], this.parse708captions_ && (this.cc708Stream_ = new ae({
      captionServices: u.captionServices
    })), this.reset(), this.ccStreams_.forEach(function(c) {
      c.on("data", this.trigger.bind(this, "data")), c.on("partialdone", this.trigger.bind(this, "partialdone")), c.on("done", this.trigger.bind(this, "done"));
    }, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
  };
  He.prototype = new Kn(), He.prototype.push = function(u) {
    var c, f, d;
    if (u.nalUnitType === "sei_rbsp" && (c = lr.parseSei(u.escapedRBSP), !!c.payload && c.payloadType === lr.USER_DATA_REGISTERED_ITU_T_T35 && (f = lr.parseUserData(c), !!f))) {
      if (u.dts < this.latestDts_) {
        this.ignoreNextEqualDts_ = !0;
        return;
      } else if (u.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
        this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
        return;
      }
      d = lr.parseCaptionPackets(u.pts, f), this.captionPackets_ = this.captionPackets_.concat(d), this.latestDts_ !== u.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = u.dts;
    }
  }, He.prototype.flushCCStreams = function(u) {
    this.ccStreams_.forEach(function(c) {
      return u === "flush" ? c.flush() : c.partialFlush();
    }, this);
  }, He.prototype.flushStream = function(u) {
    if (!this.captionPackets_.length) {
      this.flushCCStreams(u);
      return;
    }
    this.captionPackets_.forEach(function(c, f) {
      c.presortIndex = f;
    }), this.captionPackets_.sort(function(c, f) {
      return c.pts === f.pts ? c.presortIndex - f.presortIndex : c.pts - f.pts;
    }), this.captionPackets_.forEach(function(c) {
      c.type < 2 ? this.dispatchCea608Packet(c) : this.dispatchCea708Packet(c);
    }, this), this.captionPackets_.length = 0, this.flushCCStreams(u);
  }, He.prototype.flush = function() {
    return this.flushStream("flush");
  }, He.prototype.partialFlush = function() {
    return this.flushStream("partialFlush");
  }, He.prototype.reset = function() {
    this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(u) {
      u.reset();
    });
  }, He.prototype.dispatchCea608Packet = function(u) {
    this.setsTextOrXDSActive(u) ? this.activeCea608Channel_[u.type] = null : this.setsChannel1Active(u) ? this.activeCea608Channel_[u.type] = 0 : this.setsChannel2Active(u) && (this.activeCea608Channel_[u.type] = 1), this.activeCea608Channel_[u.type] !== null && this.ccStreams_[(u.type << 1) + this.activeCea608Channel_[u.type]].push(u);
  }, He.prototype.setsChannel1Active = function(u) {
    return (u.ccData & 30720) === 4096;
  }, He.prototype.setsChannel2Active = function(u) {
    return (u.ccData & 30720) === 6144;
  }, He.prototype.setsTextOrXDSActive = function(u) {
    return (u.ccData & 28928) === 256 || (u.ccData & 30974) === 4138 || (u.ccData & 30974) === 6186;
  }, He.prototype.dispatchCea708Packet = function(u) {
    this.parse708captions_ && this.cc708Stream_.push(u);
  };
  var $p = {
    127: 9834,
    // ♪
    4128: 32,
    // Transparent Space
    4129: 160,
    // Nob-breaking Transparent Space
    4133: 8230,
    // …
    4138: 352,
    // Š
    4140: 338,
    // Œ
    4144: 9608,
    // █
    4145: 8216,
    // ‘
    4146: 8217,
    // ’
    4147: 8220,
    // “
    4148: 8221,
    // ”
    4149: 8226,
    // •
    4153: 8482,
    // ™
    4154: 353,
    // š
    4156: 339,
    // œ
    4157: 8480,
    // ℠
    4159: 376,
    // Ÿ
    4214: 8539,
    // ⅛
    4215: 8540,
    // ⅜
    4216: 8541,
    // ⅝
    4217: 8542,
    // ⅞
    4218: 9168,
    // ⏐
    4219: 9124,
    // ⎤
    4220: 9123,
    // ⎣
    4221: 9135,
    // ⎯
    4222: 9126,
    // ⎦
    4223: 9121,
    // ⎡
    4256: 12600
    // ㄸ (CC char)
  }, qp = function(u) {
    var c = $p[u] || u;
    return u & 4096 && u === c ? "" : String.fromCharCode(c);
  }, cr = function(u) {
    return 32 <= u && u <= 127 || 160 <= u && u <= 255;
  }, wt = function(u) {
    this.windowNum = u, this.reset();
  };
  wt.prototype.reset = function() {
    this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
  }, wt.prototype.getText = function() {
    return this.rows.join(`
`);
  }, wt.prototype.clearText = function() {
    this.rows = [""], this.rowIdx = 0;
  }, wt.prototype.newLine = function(u) {
    for (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(u), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount; )
      this.rows.shift(), this.rowIdx--;
  }, wt.prototype.isEmpty = function() {
    return this.rows.length === 0 ? !0 : this.rows.length === 1 ? this.rows[0] === "" : !1;
  }, wt.prototype.addText = function(u) {
    this.rows[this.rowIdx] += u;
  }, wt.prototype.backspace = function() {
    if (!this.isEmpty()) {
      var u = this.rows[this.rowIdx];
      this.rows[this.rowIdx] = u.substr(0, u.length - 1);
    }
  };
  var dr = function(u, c, f) {
    this.serviceNum = u, this.text = "", this.currentWindow = new wt(-1), this.windows = [], this.stream = f, typeof c == "string" && this.createTextDecoder(c);
  };
  dr.prototype.init = function(u, c) {
    this.startPts = u;
    for (var f = 0; f < 8; f++)
      this.windows[f] = new wt(f), typeof c == "function" && (this.windows[f].beforeRowOverflow = c);
  }, dr.prototype.setCurrentWindow = function(u) {
    this.currentWindow = this.windows[u];
  }, dr.prototype.createTextDecoder = function(u) {
    if (typeof TextDecoder > "u")
      this.stream.trigger("log", {
        level: "warn",
        message: "The `encoding` option is unsupported without TextDecoder support"
      });
    else
      try {
        this.textDecoder_ = new TextDecoder(u);
      } catch (c) {
        this.stream.trigger("log", {
          level: "warn",
          message: "TextDecoder could not be created with " + u + " encoding. " + c
        });
      }
  };
  var ae = function(u) {
    u = u || {}, ae.prototype.init.call(this);
    var c = this, f = u.captionServices || {}, d = {}, p;
    Object.keys(f).forEach((g) => {
      p = f[g], /^SERVICE/.test(g) && (d[g] = p.encoding);
    }), this.serviceEncodings = d, this.current708Packet = null, this.services = {}, this.push = function(g) {
      g.type === 3 ? (c.new708Packet(), c.add708Bytes(g)) : (c.current708Packet === null && c.new708Packet(), c.add708Bytes(g));
    };
  };
  ae.prototype = new Kn(), ae.prototype.new708Packet = function() {
    this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
      data: [],
      ptsVals: []
    };
  }, ae.prototype.add708Bytes = function(u) {
    var c = u.ccData, f = c >>> 8, d = c & 255;
    this.current708Packet.ptsVals.push(u.pts), this.current708Packet.data.push(f), this.current708Packet.data.push(d);
  }, ae.prototype.push708Packet = function() {
    var u = this.current708Packet, c = u.data, f = null, d = null, p = 0, g = c[p++];
    for (u.seq = g >> 6, u.sizeCode = g & 63; p < c.length; p++)
      g = c[p++], f = g >> 5, d = g & 31, f === 7 && d > 0 && (g = c[p++], f = g), this.pushServiceBlock(f, p, d), d > 0 && (p += d - 1);
  }, ae.prototype.pushServiceBlock = function(u, c, f) {
    var d, p = c, g = this.current708Packet.data, T = this.services[u];
    for (T || (T = this.initService(u, p)); p < c + f && p < g.length; p++)
      d = g[p], cr(d) ? p = this.handleText(p, T) : d === 24 ? p = this.multiByteCharacter(p, T) : d === 16 ? p = this.extendedCommands(p, T) : 128 <= d && d <= 135 ? p = this.setCurrentWindow(p, T) : 152 <= d && d <= 159 ? p = this.defineWindow(p, T) : d === 136 ? p = this.clearWindows(p, T) : d === 140 ? p = this.deleteWindows(p, T) : d === 137 ? p = this.displayWindows(p, T) : d === 138 ? p = this.hideWindows(p, T) : d === 139 ? p = this.toggleWindows(p, T) : d === 151 ? p = this.setWindowAttributes(p, T) : d === 144 ? p = this.setPenAttributes(p, T) : d === 145 ? p = this.setPenColor(p, T) : d === 146 ? p = this.setPenLocation(p, T) : d === 143 ? T = this.reset(p, T) : d === 8 ? T.currentWindow.backspace() : d === 12 ? T.currentWindow.clearText() : d === 13 ? T.currentWindow.pendingNewLine = !0 : d === 14 ? T.currentWindow.clearText() : d === 141 && p++;
  }, ae.prototype.extendedCommands = function(u, c) {
    var f = this.current708Packet.data, d = f[++u];
    return cr(d) && (u = this.handleText(u, c, {
      isExtended: !0
    })), u;
  }, ae.prototype.getPts = function(u) {
    return this.current708Packet.ptsVals[Math.floor(u / 2)];
  }, ae.prototype.initService = function(u, c) {
    var d = "SERVICE" + u, f = this, d, p;
    return d in this.serviceEncodings && (p = this.serviceEncodings[d]), this.services[u] = new dr(u, p, f), this.services[u].init(this.getPts(c), function(g) {
      f.flushDisplayed(g, f.services[u]);
    }), this.services[u];
  }, ae.prototype.handleText = function(u, c, f) {
    var d = f && f.isExtended, p = f && f.isMultiByte, g = this.current708Packet.data, T = d ? 4096 : 0, b = g[u], x = g[u + 1], E = c.currentWindow, k, N;
    function q(F) {
      return F.map((G) => ("0" + (G & 255).toString(16)).slice(-2)).join("");
    }
    if (p ? (N = [b, x], u++) : N = [b], c.textDecoder_ && !d)
      k = c.textDecoder_.decode(new Uint8Array(N));
    else if (p) {
      const F = q(N);
      k = String.fromCharCode(parseInt(F, 16));
    } else
      k = qp(T | b);
    return E.pendingNewLine && !E.isEmpty() && E.newLine(this.getPts(u)), E.pendingNewLine = !1, E.addText(k), u;
  }, ae.prototype.multiByteCharacter = function(u, c) {
    var f = this.current708Packet.data, d = f[u + 1], p = f[u + 2];
    return cr(d) && cr(p) && (u = this.handleText(++u, c, {
      isMultiByte: !0
    })), u;
  }, ae.prototype.setCurrentWindow = function(u, c) {
    var f = this.current708Packet.data, d = f[u], p = d & 7;
    return c.setCurrentWindow(p), u;
  }, ae.prototype.defineWindow = function(u, c) {
    var f = this.current708Packet.data, d = f[u], p = d & 7;
    c.setCurrentWindow(p);
    var g = c.currentWindow;
    return d = f[++u], g.visible = (d & 32) >> 5, g.rowLock = (d & 16) >> 4, g.columnLock = (d & 8) >> 3, g.priority = d & 7, d = f[++u], g.relativePositioning = (d & 128) >> 7, g.anchorVertical = d & 127, d = f[++u], g.anchorHorizontal = d, d = f[++u], g.anchorPoint = (d & 240) >> 4, g.rowCount = d & 15, d = f[++u], g.columnCount = d & 63, d = f[++u], g.windowStyle = (d & 56) >> 3, g.penStyle = d & 7, g.virtualRowCount = g.rowCount + 1, u;
  }, ae.prototype.setWindowAttributes = function(u, c) {
    var f = this.current708Packet.data, d = f[u], p = c.currentWindow.winAttr;
    return d = f[++u], p.fillOpacity = (d & 192) >> 6, p.fillRed = (d & 48) >> 4, p.fillGreen = (d & 12) >> 2, p.fillBlue = d & 3, d = f[++u], p.borderType = (d & 192) >> 6, p.borderRed = (d & 48) >> 4, p.borderGreen = (d & 12) >> 2, p.borderBlue = d & 3, d = f[++u], p.borderType += (d & 128) >> 5, p.wordWrap = (d & 64) >> 6, p.printDirection = (d & 48) >> 4, p.scrollDirection = (d & 12) >> 2, p.justify = d & 3, d = f[++u], p.effectSpeed = (d & 240) >> 4, p.effectDirection = (d & 12) >> 2, p.displayEffect = d & 3, u;
  }, ae.prototype.flushDisplayed = function(u, c) {
    for (var f = [], d = 0; d < 8; d++)
      c.windows[d].visible && !c.windows[d].isEmpty() && f.push(c.windows[d].getText());
    c.endPts = u, c.text = f.join(`

`), this.pushCaption(c), c.startPts = u;
  }, ae.prototype.pushCaption = function(u) {
    u.text !== "" && (this.trigger("data", {
      startPts: u.startPts,
      endPts: u.endPts,
      text: u.text,
      stream: "cc708_" + u.serviceNum
    }), u.text = "", u.startPts = u.endPts);
  }, ae.prototype.displayWindows = function(u, c) {
    var f = this.current708Packet.data, d = f[++u], p = this.getPts(u);
    this.flushDisplayed(p, c);
    for (var g = 0; g < 8; g++)
      d & 1 << g && (c.windows[g].visible = 1);
    return u;
  }, ae.prototype.hideWindows = function(u, c) {
    var f = this.current708Packet.data, d = f[++u], p = this.getPts(u);
    this.flushDisplayed(p, c);
    for (var g = 0; g < 8; g++)
      d & 1 << g && (c.windows[g].visible = 0);
    return u;
  }, ae.prototype.toggleWindows = function(u, c) {
    var f = this.current708Packet.data, d = f[++u], p = this.getPts(u);
    this.flushDisplayed(p, c);
    for (var g = 0; g < 8; g++)
      d & 1 << g && (c.windows[g].visible ^= 1);
    return u;
  }, ae.prototype.clearWindows = function(u, c) {
    var f = this.current708Packet.data, d = f[++u], p = this.getPts(u);
    this.flushDisplayed(p, c);
    for (var g = 0; g < 8; g++)
      d & 1 << g && c.windows[g].clearText();
    return u;
  }, ae.prototype.deleteWindows = function(u, c) {
    var f = this.current708Packet.data, d = f[++u], p = this.getPts(u);
    this.flushDisplayed(p, c);
    for (var g = 0; g < 8; g++)
      d & 1 << g && c.windows[g].reset();
    return u;
  }, ae.prototype.setPenAttributes = function(u, c) {
    var f = this.current708Packet.data, d = f[u], p = c.currentWindow.penAttr;
    return d = f[++u], p.textTag = (d & 240) >> 4, p.offset = (d & 12) >> 2, p.penSize = d & 3, d = f[++u], p.italics = (d & 128) >> 7, p.underline = (d & 64) >> 6, p.edgeType = (d & 56) >> 3, p.fontStyle = d & 7, u;
  }, ae.prototype.setPenColor = function(u, c) {
    var f = this.current708Packet.data, d = f[u], p = c.currentWindow.penColor;
    return d = f[++u], p.fgOpacity = (d & 192) >> 6, p.fgRed = (d & 48) >> 4, p.fgGreen = (d & 12) >> 2, p.fgBlue = d & 3, d = f[++u], p.bgOpacity = (d & 192) >> 6, p.bgRed = (d & 48) >> 4, p.bgGreen = (d & 12) >> 2, p.bgBlue = d & 3, d = f[++u], p.edgeRed = (d & 48) >> 4, p.edgeGreen = (d & 12) >> 2, p.edgeBlue = d & 3, u;
  }, ae.prototype.setPenLocation = function(u, c) {
    var f = this.current708Packet.data, d = f[u], p = c.currentWindow.penLoc;
    return c.currentWindow.pendingNewLine = !0, d = f[++u], p.row = d & 15, d = f[++u], p.column = d & 63, u;
  }, ae.prototype.reset = function(u, c) {
    var f = this.getPts(u);
    return this.flushDisplayed(f, c), this.initService(c.serviceNum, u);
  };
  var jp = {
    42: 225,
    // á
    92: 233,
    // é
    94: 237,
    // í
    95: 243,
    // ó
    96: 250,
    // ú
    123: 231,
    // ç
    124: 247,
    // ÷
    125: 209,
    // Ñ
    126: 241,
    // ñ
    127: 9608,
    // █
    304: 174,
    // ®
    305: 176,
    // °
    306: 189,
    // ½
    307: 191,
    // ¿
    308: 8482,
    // ™
    309: 162,
    // ¢
    310: 163,
    // £
    311: 9834,
    // ♪
    312: 224,
    // à
    313: 160,
    //
    314: 232,
    // è
    315: 226,
    // â
    316: 234,
    // ê
    317: 238,
    // î
    318: 244,
    // ô
    319: 251,
    // û
    544: 193,
    // Á
    545: 201,
    // É
    546: 211,
    // Ó
    547: 218,
    // Ú
    548: 220,
    // Ü
    549: 252,
    // ü
    550: 8216,
    // ‘
    551: 161,
    // ¡
    552: 42,
    // *
    553: 39,
    // '
    554: 8212,
    // —
    555: 169,
    // ©
    556: 8480,
    // ℠
    557: 8226,
    // •
    558: 8220,
    // “
    559: 8221,
    // ”
    560: 192,
    // À
    561: 194,
    // Â
    562: 199,
    // Ç
    563: 200,
    // È
    564: 202,
    // Ê
    565: 203,
    // Ë
    566: 235,
    // ë
    567: 206,
    // Î
    568: 207,
    // Ï
    569: 239,
    // ï
    570: 212,
    // Ô
    571: 217,
    // Ù
    572: 249,
    // ù
    573: 219,
    // Û
    574: 171,
    // «
    575: 187,
    // »
    800: 195,
    // Ã
    801: 227,
    // ã
    802: 205,
    // Í
    803: 204,
    // Ì
    804: 236,
    // ì
    805: 210,
    // Ò
    806: 242,
    // ò
    807: 213,
    // Õ
    808: 245,
    // õ
    809: 123,
    // {
    810: 125,
    // }
    811: 92,
    // \
    812: 94,
    // ^
    813: 95,
    // _
    814: 124,
    // |
    815: 126,
    // ~
    816: 196,
    // Ä
    817: 228,
    // ä
    818: 214,
    // Ö
    819: 246,
    // ö
    820: 223,
    // ß
    821: 165,
    // ¥
    822: 164,
    // ¤
    823: 9474,
    // │
    824: 197,
    // Å
    825: 229,
    // å
    826: 216,
    // Ø
    827: 248,
    // ø
    828: 9484,
    // ┌
    829: 9488,
    // ┐
    830: 9492,
    // └
    831: 9496
    // ┘
  }, hr = function(u) {
    return u === null ? "" : (u = jp[u] || u, String.fromCharCode(u));
  }, fr = 14, Hp = [4352, 4384, 4608, 4640, 5376, 5408, 5632, 5664, 5888, 5920, 4096, 4864, 4896, 5120, 5152], ii = function() {
    for (var u = [], c = fr + 1; c--; )
      u.push({
        text: "",
        indent: 0,
        offset: 0
      });
    return u;
  }, he = function(u, c) {
    he.prototype.init.call(this), this.field_ = u || 0, this.dataChannel_ = c || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(f) {
      var d, p, g, T, b;
      if (d = f.ccData & 32639, d === this.lastControlCode_) {
        this.lastControlCode_ = null;
        return;
      }
      if ((d & 61440) === 4096 ? this.lastControlCode_ = d : d !== this.PADDING_ && (this.lastControlCode_ = null), g = d >>> 8, T = d & 255, d !== this.PADDING_)
        if (d === this.RESUME_CAPTION_LOADING_)
          this.mode_ = "popOn";
        else if (d === this.END_OF_CAPTION_)
          this.mode_ = "popOn", this.clearFormatting(f.pts), this.flushDisplayed(f.pts), p = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = p, this.startPts_ = f.pts;
        else if (d === this.ROLL_UP_2_ROWS_)
          this.rollUpRows_ = 2, this.setRollUp(f.pts);
        else if (d === this.ROLL_UP_3_ROWS_)
          this.rollUpRows_ = 3, this.setRollUp(f.pts);
        else if (d === this.ROLL_UP_4_ROWS_)
          this.rollUpRows_ = 4, this.setRollUp(f.pts);
        else if (d === this.CARRIAGE_RETURN_)
          this.clearFormatting(f.pts), this.flushDisplayed(f.pts), this.shiftRowsUp_(), this.startPts_ = f.pts;
        else if (d === this.BACKSPACE_)
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1);
        else if (d === this.ERASE_DISPLAYED_MEMORY_)
          this.flushDisplayed(f.pts), this.displayed_ = ii();
        else if (d === this.ERASE_NON_DISPLAYED_MEMORY_)
          this.nonDisplayed_ = ii();
        else if (d === this.RESUME_DIRECT_CAPTIONING_)
          this.mode_ !== "paintOn" && (this.flushDisplayed(f.pts), this.displayed_ = ii()), this.mode_ = "paintOn", this.startPts_ = f.pts;
        else if (this.isSpecialCharacter(g, T))
          g = (g & 3) << 8, b = hr(g | T), this[this.mode_](f.pts, b), this.column_++;
        else if (this.isExtCharacter(g, T))
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_].text = this.nonDisplayed_[this.row_].text.slice(0, -1) : this.displayed_[this.row_].text = this.displayed_[this.row_].text.slice(0, -1), g = (g & 3) << 8, b = hr(g | T), this[this.mode_](f.pts, b), this.column_++;
        else if (this.isMidRowCode(g, T))
          this.clearFormatting(f.pts), this[this.mode_](f.pts, " "), this.column_++, (T & 14) === 14 && this.addFormatting(f.pts, ["i"]), (T & 1) === 1 && this.addFormatting(f.pts, ["u"]);
        else if (this.isOffsetControlCode(g, T)) {
          const E = T & 3;
          this.nonDisplayed_[this.row_].offset = E, this.column_ += E;
        } else if (this.isPAC(g, T)) {
          var x = Hp.indexOf(d & 7968);
          if (this.mode_ === "rollUp" && (x - this.rollUpRows_ + 1 < 0 && (x = this.rollUpRows_ - 1), this.setRollUp(f.pts, x)), x !== this.row_ && x >= 0 && x <= 14 && (this.clearFormatting(f.pts), this.row_ = x), T & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(f.pts, ["u"]), (d & 16) === 16) {
            const E = (d & 14) >> 1;
            this.column_ = E * 4, this.nonDisplayed_[this.row_].indent += E;
          }
          this.isColorPAC(T) && (T & 14) === 14 && this.addFormatting(f.pts, ["i"]);
        } else this.isNormalChar(g) && (T === 0 && (T = null), b = hr(g), b += hr(T), this[this.mode_](f.pts, b), this.column_ += b.length);
    };
  };
  he.prototype = new Kn(), he.prototype.flushDisplayed = function(u) {
    const c = (d) => {
      this.trigger("log", {
        level: "warn",
        message: "Skipping a malformed 608 caption at index " + d + "."
      });
    }, f = [];
    this.displayed_.forEach((d, p) => {
      if (d && d.text && d.text.length) {
        try {
          d.text = d.text.trim();
        } catch {
          c(p);
        }
        d.text.length && f.push({
          // The text to be displayed in the caption from this specific row, with whitespace removed.
          text: d.text,
          // Value between 1 and 15 representing the PAC row used to calculate line height.
          line: p + 1,
          // A number representing the indent position by percentage (CEA-608 PAC indent code).
          // The value will be a number between 10 and 80. Offset is used to add an aditional
          // value to the position if necessary.
          position: 10 + Math.min(70, d.indent * 10) + d.offset * 2.5
        });
      } else d == null && c(p);
    }), f.length && this.trigger("data", {
      startPts: this.startPts_,
      endPts: u,
      content: f,
      stream: this.name_
    });
  }, he.prototype.reset = function() {
    this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = ii(), this.nonDisplayed_ = ii(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = fr, this.rollUpRows_ = 2, this.formatting_ = [];
  }, he.prototype.setConstants = function() {
    this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
  }, he.prototype.isSpecialCharacter = function(u, c) {
    return u === this.EXT_ && c >= 48 && c <= 63;
  }, he.prototype.isExtCharacter = function(u, c) {
    return (u === this.EXT_ + 1 || u === this.EXT_ + 2) && c >= 32 && c <= 63;
  }, he.prototype.isMidRowCode = function(u, c) {
    return u === this.EXT_ && c >= 32 && c <= 47;
  }, he.prototype.isOffsetControlCode = function(u, c) {
    return u === this.OFFSET_ && c >= 33 && c <= 35;
  }, he.prototype.isPAC = function(u, c) {
    return u >= this.BASE_ && u < this.BASE_ + 8 && c >= 64 && c <= 127;
  }, he.prototype.isColorPAC = function(u) {
    return u >= 64 && u <= 79 || u >= 96 && u <= 127;
  }, he.prototype.isNormalChar = function(u) {
    return u >= 32 && u <= 127;
  }, he.prototype.setRollUp = function(u, c) {
    if (this.mode_ !== "rollUp" && (this.row_ = fr, this.mode_ = "rollUp", this.flushDisplayed(u), this.nonDisplayed_ = ii(), this.displayed_ = ii()), c !== void 0 && c !== this.row_)
      for (var f = 0; f < this.rollUpRows_; f++)
        this.displayed_[c - f] = this.displayed_[this.row_ - f], this.displayed_[this.row_ - f] = {
          text: "",
          indent: 0,
          offset: 0
        };
    c === void 0 && (c = this.row_), this.topRow_ = c - this.rollUpRows_ + 1;
  }, he.prototype.addFormatting = function(u, c) {
    this.formatting_ = this.formatting_.concat(c);
    var f = c.reduce(function(d, p) {
      return d + "<" + p + ">";
    }, "");
    this[this.mode_](u, f);
  }, he.prototype.clearFormatting = function(u) {
    if (this.formatting_.length) {
      var c = this.formatting_.reverse().reduce(function(f, d) {
        return f + "</" + d + ">";
      }, "");
      this.formatting_ = [], this[this.mode_](u, c);
    }
  }, he.prototype.popOn = function(u, c) {
    var f = this.nonDisplayed_[this.row_].text;
    f += c, this.nonDisplayed_[this.row_].text = f;
  }, he.prototype.rollUp = function(u, c) {
    var f = this.displayed_[this.row_].text;
    f += c, this.displayed_[this.row_].text = f;
  }, he.prototype.shiftRowsUp_ = function() {
    var u;
    for (u = 0; u < this.topRow_; u++)
      this.displayed_[u] = {
        text: "",
        indent: 0,
        offset: 0
      };
    for (u = this.row_ + 1; u < fr + 1; u++)
      this.displayed_[u] = {
        text: "",
        indent: 0,
        offset: 0
      };
    for (u = this.topRow_; u < this.row_; u++)
      this.displayed_[u] = this.displayed_[u + 1];
    this.displayed_[this.row_] = {
      text: "",
      indent: 0,
      offset: 0
    };
  }, he.prototype.paintOn = function(u, c) {
    var f = this.displayed_[this.row_].text;
    f += c, this.displayed_[this.row_].text = f;
  };
  var xu = {
    CaptionStream: He,
    Cea608Stream: he,
    Cea708Stream: ae
  }, pr = {
    H264_STREAM_TYPE: 27,
    ADTS_STREAM_TYPE: 15,
    METADATA_STREAM_TYPE: 21
  }, Vp = t, zp = 8589934592, Gp = 4294967296, Su = "shared", Yn = function(u, c) {
    var f = 1;
    for (u > c && (f = -1); Math.abs(c - u) > Gp; )
      u += f * zp;
    return u;
  }, Qn = function(u) {
    var c, f;
    Qn.prototype.init.call(this), this.type_ = u || Su, this.push = function(d) {
      if (d.type === "metadata") {
        this.trigger("data", d);
        return;
      }
      this.type_ !== Su && d.type !== this.type_ || (f === void 0 && (f = d.dts), d.dts = Yn(d.dts, f), d.pts = Yn(d.pts, f), c = d.dts, this.trigger("data", d));
    }, this.flush = function() {
      f = c, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.discontinuity = function() {
      f = void 0, c = void 0;
    }, this.reset = function() {
      this.discontinuity(), this.trigger("reset");
    };
  };
  Qn.prototype = new Vp();
  var Eu = {
    TimestampRolloverStream: Qn,
    handleRollover: Yn
  }, Wp = (u, c, f) => {
    if (!u)
      return -1;
    for (var d = f; d < u.length; d++)
      if (u[d] === c)
        return d;
    return -1;
  }, Xp = {
    typedArrayIndexOf: Wp
  }, mr = Xp.typedArrayIndexOf, gr = {
    Iso88591: 0,
    // ISO-8859-1, terminated with \0.
    Utf16: 1,
    // UTF-16 encoded Unicode BOM, terminated with \0\0
    Utf16be: 2,
    // UTF-16BE encoded Unicode, without BOM, terminated with \0\0
    Utf8: 3
    // UTF-8 encoded Unicode, terminated with \0
  }, Cu = function(u, c, f) {
    var d, p = "";
    for (d = c; d < f; d++)
      p += "%" + ("00" + u[d].toString(16)).slice(-2);
    return p;
  }, ls = function(u, c, f) {
    return decodeURIComponent(Cu(u, c, f));
  }, cs = function(u, c, f) {
    return unescape(Cu(u, c, f));
  }, ds = function(u) {
    return u[0] << 21 | u[1] << 14 | u[2] << 7 | u[3];
  }, hs = {
    APIC: function(u) {
      var c = 1, f, d, p = "-->";
      u.data[0] === gr.Utf8 && (f = mr(u.data, 0, c), !(f < 0) && (u.mimeType = cs(u.data, c, f), c = f + 1, u.pictureType = u.data[c], c++, d = mr(u.data, 0, c), !(d < 0) && (u.description = ls(u.data, c, d), c = d + 1, u.mimeType === p ? u.url = cs(u.data, c, u.data.length) : u.pictureData = u.data.subarray(c, u.data.length))));
    },
    "T*": function(u) {
      u.data[0] === gr.Utf8 && (u.value = ls(u.data, 1, u.data.length).replace(/\0*$/, ""), u.values = u.value.split("\0"));
    },
    TXXX: function(u) {
      var c;
      u.data[0] === gr.Utf8 && (c = mr(u.data, 0, 1), c !== -1 && (u.description = ls(u.data, 1, c), u.value = ls(u.data, c + 1, u.data.length).replace(/\0*$/, ""), u.data = u.value));
    },
    "W*": function(u) {
      u.url = cs(u.data, 0, u.data.length).replace(/\0.*$/, "");
    },
    WXXX: function(u) {
      var c;
      u.data[0] === gr.Utf8 && (c = mr(u.data, 0, 1), c !== -1 && (u.description = ls(u.data, 1, c), u.url = cs(u.data, c + 1, u.data.length).replace(/\0.*$/, "")));
    },
    PRIV: function(u) {
      var c;
      for (c = 0; c < u.data.length; c++)
        if (u.data[c] === 0) {
          u.owner = cs(u.data, 0, c);
          break;
        }
      u.privateData = u.data.subarray(c + 1), u.data = u.privateData;
    }
  }, Kp = function(u) {
    var c, f, d = 10, p = 0, g = [];
    if (!(u.length < 10 || u[0] !== 73 || u[1] !== 68 || u[2] !== 51)) {
      p = ds(u.subarray(6, 10)), p += 10;
      var T = u[5] & 64;
      T && (d += 4, d += ds(u.subarray(10, 14)), p -= ds(u.subarray(16, 20)));
      do {
        if (c = ds(u.subarray(d + 4, d + 8)), c < 1)
          break;
        f = String.fromCharCode(u[d], u[d + 1], u[d + 2], u[d + 3]);
        var b = {
          id: f,
          data: u.subarray(d + 10, d + c + 10)
        };
        b.key = b.id, hs[b.id] ? hs[b.id](b) : b.id[0] === "T" ? hs["T*"](b) : b.id[0] === "W" && hs["W*"](b), g.push(b), d += 10, d += c;
      } while (d < p);
      return g;
    }
  }, Au = {
    parseId3Frames: Kp,
    parseSyncSafeInteger: ds,
    frameParsers: hs
  }, Yp = t, Qp = pr, qt = Au, _r;
  _r = function(u) {
    var c = {
      // the bytes of the program-level descriptor field in MP2T
      // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
      // program element descriptors"
      descriptor: u && u.descriptor
    }, f = 0, d = [], p = 0, g;
    if (_r.prototype.init.call(this), this.dispatchType = Qp.METADATA_STREAM_TYPE.toString(16), c.descriptor)
      for (g = 0; g < c.descriptor.length; g++)
        this.dispatchType += ("00" + c.descriptor[g].toString(16)).slice(-2);
    this.push = function(T) {
      var b, x, E, k, N, q;
      if (T.type === "timed-metadata") {
        if (T.dataAlignmentIndicator && (p = 0, d.length = 0), d.length === 0 && (T.data.length < 10 || T.data[0] !== 73 || T.data[1] !== 68 || T.data[2] !== 51)) {
          this.trigger("log", {
            level: "warn",
            message: "Skipping unrecognized metadata packet"
          });
          return;
        }
        if (d.push(T), p += T.data.byteLength, d.length === 1 && (f = qt.parseSyncSafeInteger(T.data.subarray(6, 10)), f += 10), !(p < f)) {
          for (b = {
            data: new Uint8Array(f),
            frames: [],
            pts: d[0].pts,
            dts: d[0].dts
          }, N = 0; N < f; )
            b.data.set(d[0].data.subarray(0, f - N), N), N += d[0].data.byteLength, p -= d[0].data.byteLength, d.shift();
          x = 10, b.data[5] & 64 && (x += 4, x += qt.parseSyncSafeInteger(b.data.subarray(10, 14)), f -= qt.parseSyncSafeInteger(b.data.subarray(16, 20)));
          do {
            if (E = qt.parseSyncSafeInteger(b.data.subarray(x + 4, x + 8)), E < 1) {
              this.trigger("log", {
                level: "warn",
                message: "Malformed ID3 frame encountered. Skipping remaining metadata parsing."
              });
              break;
            }
            if (q = String.fromCharCode(b.data[x], b.data[x + 1], b.data[x + 2], b.data[x + 3]), k = {
              id: q,
              data: b.data.subarray(x + 10, x + E + 10)
            }, k.key = k.id, qt.frameParsers[k.id] ? qt.frameParsers[k.id](k) : k.id[0] === "T" ? qt.frameParsers["T*"](k) : k.id[0] === "W" && qt.frameParsers["W*"](k), k.owner === "com.apple.streaming.transportStreamTimestamp") {
              var F = k.data, G = (F[3] & 1) << 30 | F[4] << 22 | F[5] << 14 | F[6] << 6 | F[7] >>> 2;
              G *= 4, G += F[7] & 3, k.timeStamp = G, b.pts === void 0 && b.dts === void 0 && (b.pts = k.timeStamp, b.dts = k.timeStamp), this.trigger("timestamp", k);
            }
            b.frames.push(k), x += 10, x += E;
          } while (x < f);
          this.trigger("data", b);
        }
      }
    };
  }, _r.prototype = new Yp();
  var Jp = _r, Jn = t, Zn = xu, ut = pr, Zp = Eu.TimestampRolloverStream, yr, fs, Tr, vi = 188, ea = 71;
  yr = function() {
    var u = new Uint8Array(vi), c = 0;
    yr.prototype.init.call(this), this.push = function(f) {
      var d = 0, p = vi, g;
      for (c ? (g = new Uint8Array(f.byteLength + c), g.set(u.subarray(0, c)), g.set(f, c), c = 0) : g = f; p < g.byteLength; ) {
        if (g[d] === ea && g[p] === ea) {
          this.trigger("data", g.subarray(d, p)), d += vi, p += vi;
          continue;
        }
        d++, p++;
      }
      d < g.byteLength && (u.set(g.subarray(d), 0), c = g.byteLength - d);
    }, this.flush = function() {
      c === vi && u[0] === ea && (this.trigger("data", u), c = 0), this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.reset = function() {
      c = 0, this.trigger("reset");
    };
  }, yr.prototype = new Jn(), fs = function() {
    var u, c, f, d;
    fs.prototype.init.call(this), d = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, u = function(p, g) {
      var T = 0;
      g.payloadUnitStartIndicator && (T += p[T] + 1), g.type === "pat" ? c(p.subarray(T), g) : f(p.subarray(T), g);
    }, c = function(p, g) {
      g.section_number = p[7], g.last_section_number = p[8], d.pmtPid = (p[10] & 31) << 8 | p[11], g.pmtPid = d.pmtPid;
    }, f = function(p, g) {
      var T, b, x, E;
      if (p[5] & 1) {
        for (d.programMapTable = {
          video: null,
          audio: null,
          "timed-metadata": {}
        }, T = (p[1] & 15) << 8 | p[2], b = 3 + T - 4, x = (p[10] & 15) << 8 | p[11], E = 12 + x; E < b; ) {
          var k = p[E], N = (p[E + 1] & 31) << 8 | p[E + 2];
          k === ut.H264_STREAM_TYPE && d.programMapTable.video === null ? d.programMapTable.video = N : k === ut.ADTS_STREAM_TYPE && d.programMapTable.audio === null ? d.programMapTable.audio = N : k === ut.METADATA_STREAM_TYPE && (d.programMapTable["timed-metadata"][N] = k), E += ((p[E + 3] & 15) << 8 | p[E + 4]) + 5;
        }
        g.programMapTable = d.programMapTable;
      }
    }, this.push = function(p) {
      var g = {}, T = 4;
      if (g.payloadUnitStartIndicator = !!(p[1] & 64), g.pid = p[1] & 31, g.pid <<= 8, g.pid |= p[2], (p[3] & 48) >>> 4 > 1 && (T += p[T] + 1), g.pid === 0)
        g.type = "pat", u(p.subarray(T), g), this.trigger("data", g);
      else if (g.pid === this.pmtPid)
        for (g.type = "pmt", u(p.subarray(T), g), this.trigger("data", g); this.packetsWaitingForPmt.length; )
          this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
      else this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([p, T, g]) : this.processPes_(p, T, g);
    }, this.processPes_ = function(p, g, T) {
      T.pid === this.programMapTable.video ? T.streamType = ut.H264_STREAM_TYPE : T.pid === this.programMapTable.audio ? T.streamType = ut.ADTS_STREAM_TYPE : T.streamType = this.programMapTable["timed-metadata"][T.pid], T.type = "pes", T.data = p.subarray(g), this.trigger("data", T);
    };
  }, fs.prototype = new Jn(), fs.STREAM_TYPES = {
    h264: 27,
    adts: 15
  }, Tr = function() {
    var u = this, c = !1, f = {
      data: [],
      size: 0
    }, d = {
      data: [],
      size: 0
    }, p = {
      data: [],
      size: 0
    }, g, T = function(x, E) {
      var k;
      const N = x[0] << 16 | x[1] << 8 | x[2];
      E.data = new Uint8Array(), N === 1 && (E.packetLength = 6 + (x[4] << 8 | x[5]), E.dataAlignmentIndicator = (x[6] & 4) !== 0, k = x[7], k & 192 && (E.pts = (x[9] & 14) << 27 | (x[10] & 255) << 20 | (x[11] & 254) << 12 | (x[12] & 255) << 5 | (x[13] & 254) >>> 3, E.pts *= 4, E.pts += (x[13] & 6) >>> 1, E.dts = E.pts, k & 64 && (E.dts = (x[14] & 14) << 27 | (x[15] & 255) << 20 | (x[16] & 254) << 12 | (x[17] & 255) << 5 | (x[18] & 254) >>> 3, E.dts *= 4, E.dts += (x[18] & 6) >>> 1)), E.data = x.subarray(9 + x[8]));
    }, b = function(x, E, k) {
      var N = new Uint8Array(x.size), q = {
        type: E
      }, F = 0, G = 0, K = !1, Ce;
      if (!(!x.data.length || x.size < 9)) {
        for (q.trackId = x.data[0].pid, F = 0; F < x.data.length; F++)
          Ce = x.data[F], N.set(Ce.data, G), G += Ce.data.byteLength;
        T(N, q), K = E === "video" || q.packetLength <= x.size, (k || K) && (x.size = 0, x.data.length = 0), K && u.trigger("data", q);
      }
    };
    Tr.prototype.init.call(this), this.push = function(x) {
      ({
        pat: function() {
        },
        pes: function() {
          var E, k;
          switch (x.streamType) {
            case ut.H264_STREAM_TYPE:
              E = f, k = "video";
              break;
            case ut.ADTS_STREAM_TYPE:
              E = d, k = "audio";
              break;
            case ut.METADATA_STREAM_TYPE:
              E = p, k = "timed-metadata";
              break;
            default:
              return;
          }
          x.payloadUnitStartIndicator && b(E, k, !0), E.data.push(x), E.size += x.data.byteLength;
        },
        pmt: function() {
          var E = {
            type: "metadata",
            tracks: []
          };
          g = x.programMapTable, g.video !== null && E.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +g.video,
            codec: "avc",
            type: "video"
          }), g.audio !== null && E.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +g.audio,
            codec: "adts",
            type: "audio"
          }), c = !0, u.trigger("data", E);
        }
      })[x.type]();
    }, this.reset = function() {
      f.size = 0, f.data.length = 0, d.size = 0, d.data.length = 0, this.trigger("reset");
    }, this.flushStreams_ = function() {
      b(f, "video"), b(d, "audio"), b(p, "timed-metadata");
    }, this.flush = function() {
      if (!c && g) {
        var x = {
          type: "metadata",
          tracks: []
        };
        g.video !== null && x.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +g.video,
          codec: "avc",
          type: "video"
        }), g.audio !== null && x.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +g.audio,
          codec: "adts",
          type: "audio"
        }), u.trigger("data", x);
      }
      c = !1, this.flushStreams_(), this.trigger("done");
    };
  }, Tr.prototype = new Jn();
  var Du = {
    PAT_PID: 0,
    MP2T_PACKET_LENGTH: vi,
    TransportPacketStream: yr,
    TransportParseStream: fs,
    ElementaryStream: Tr,
    TimestampRolloverStream: Zp,
    CaptionStream: Zn.CaptionStream,
    Cea608Stream: Zn.Cea608Stream,
    Cea708Stream: Zn.Cea708Stream,
    MetadataStream: Jp
  };
  for (var ta in ut)
    ut.hasOwnProperty(ta) && (Du[ta] = ut[ta]);
  var em = Du, tm = t, im = ce.ONE_SECOND_IN_TS, vr, wu = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  vr = function(u) {
    var c, f = 0;
    vr.prototype.init.call(this), this.skipWarn_ = function(d, p) {
      this.trigger("log", {
        level: "warn",
        message: `adts skiping bytes ${d} to ${p} in frame ${f} outside syncword`
      });
    }, this.push = function(d) {
      var p = 0, g, T, b, x, E;
      if (u || (f = 0), d.type === "audio") {
        c && c.length ? (b = c, c = new Uint8Array(b.byteLength + d.data.byteLength), c.set(b), c.set(d.data, b.byteLength)) : c = d.data;
        for (var k; p + 7 < c.length; ) {
          if (c[p] !== 255 || (c[p + 1] & 246) !== 240) {
            typeof k != "number" && (k = p), p++;
            continue;
          }
          if (typeof k == "number" && (this.skipWarn_(k, p), k = null), T = (~c[p + 1] & 1) * 2, g = (c[p + 3] & 3) << 11 | c[p + 4] << 3 | (c[p + 5] & 224) >> 5, x = ((c[p + 6] & 3) + 1) * 1024, E = x * im / wu[(c[p + 2] & 60) >>> 2], c.byteLength - p < g)
            break;
          this.trigger("data", {
            pts: d.pts + f * E,
            dts: d.dts + f * E,
            sampleCount: x,
            audioobjecttype: (c[p + 2] >>> 6 & 3) + 1,
            channelcount: (c[p + 2] & 1) << 2 | (c[p + 3] & 192) >>> 6,
            samplerate: wu[(c[p + 2] & 60) >>> 2],
            samplingfrequencyindex: (c[p + 2] & 60) >>> 2,
            // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
            samplesize: 16,
            // data is the frame without it's header
            data: c.subarray(p + 7 + T, p + g)
          }), f++, p += g;
        }
        typeof k == "number" && (this.skipWarn_(k, p), k = null), c = c.subarray(p);
      }
    }, this.flush = function() {
      f = 0, this.trigger("done");
    }, this.reset = function() {
      c = void 0, this.trigger("reset");
    }, this.endTimeline = function() {
      c = void 0, this.trigger("endedtimeline");
    };
  }, vr.prototype = new tm();
  var sm = vr, Iu;
  Iu = function(u) {
    var c = u.byteLength, f = 0, d = 0;
    this.length = function() {
      return 8 * c;
    }, this.bitsAvailable = function() {
      return 8 * c + d;
    }, this.loadWord = function() {
      var p = u.byteLength - c, g = new Uint8Array(4), T = Math.min(4, c);
      if (T === 0)
        throw new Error("no bytes available");
      g.set(u.subarray(p, p + T)), f = new DataView(g.buffer).getUint32(0), d = T * 8, c -= T;
    }, this.skipBits = function(p) {
      var g;
      d > p ? (f <<= p, d -= p) : (p -= d, g = Math.floor(p / 8), p -= g * 8, c -= g, this.loadWord(), f <<= p, d -= p);
    }, this.readBits = function(p) {
      var g = Math.min(d, p), T = f >>> 32 - g;
      return d -= g, d > 0 ? f <<= g : c > 0 && this.loadWord(), g = p - g, g > 0 ? T << g | this.readBits(g) : T;
    }, this.skipLeadingZeros = function() {
      var p;
      for (p = 0; p < d; ++p)
        if (f & 2147483648 >>> p)
          return f <<= p, d -= p, p;
      return this.loadWord(), p + this.skipLeadingZeros();
    }, this.skipUnsignedExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.skipExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.readUnsignedExpGolomb = function() {
      var p = this.skipLeadingZeros();
      return this.readBits(p + 1) - 1;
    }, this.readExpGolomb = function() {
      var p = this.readUnsignedExpGolomb();
      return 1 & p ? 1 + p >>> 1 : -1 * (p >>> 1);
    }, this.readBoolean = function() {
      return this.readBits(1) === 1;
    }, this.readUnsignedByte = function() {
      return this.readBits(8);
    }, this.loadWord();
  };
  var rm = Iu, ku = t, nm = rm, br, ps, Pu;
  ps = function() {
    var u = 0, c, f;
    ps.prototype.init.call(this), this.push = function(d) {
      var p;
      f ? (p = new Uint8Array(f.byteLength + d.data.byteLength), p.set(f), p.set(d.data, f.byteLength), f = p) : f = d.data;
      for (var g = f.byteLength; u < g - 3; u++)
        if (f[u + 2] === 1) {
          c = u + 5;
          break;
        }
      for (; c < g; )
        switch (f[c]) {
          case 0:
            if (f[c - 1] !== 0) {
              c += 2;
              break;
            } else if (f[c - 2] !== 0) {
              c++;
              break;
            }
            u + 3 !== c - 2 && this.trigger("data", f.subarray(u + 3, c - 2));
            do
              c++;
            while (f[c] !== 1 && c < g);
            u = c - 2, c += 3;
            break;
          case 1:
            if (f[c - 1] !== 0 || f[c - 2] !== 0) {
              c += 3;
              break;
            }
            this.trigger("data", f.subarray(u + 3, c - 2)), u = c - 2, c += 3;
            break;
          default:
            c += 3;
            break;
        }
      f = f.subarray(u), c -= u, u = 0;
    }, this.reset = function() {
      f = null, u = 0, this.trigger("reset");
    }, this.flush = function() {
      f && f.byteLength > 3 && this.trigger("data", f.subarray(u + 3)), f = null, u = 0, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    };
  }, ps.prototype = new ku(), Pu = {
    100: !0,
    110: !0,
    122: !0,
    244: !0,
    44: !0,
    83: !0,
    86: !0,
    118: !0,
    128: !0,
    // TODO: the three profiles below don't
    // appear to have sps data in the specificiation anymore?
    138: !0,
    139: !0,
    134: !0
  }, br = function() {
    var u = new ps(), c, f, d, p, g, T, b;
    br.prototype.init.call(this), c = this, this.push = function(x) {
      x.type === "video" && (f = x.trackId, d = x.pts, p = x.dts, u.push(x));
    }, u.on("data", function(x) {
      var E = {
        trackId: f,
        pts: d,
        dts: p,
        data: x,
        nalUnitTypeCode: x[0] & 31
      };
      switch (E.nalUnitTypeCode) {
        case 5:
          E.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
          break;
        case 6:
          E.nalUnitType = "sei_rbsp", E.escapedRBSP = g(x.subarray(1));
          break;
        case 7:
          E.nalUnitType = "seq_parameter_set_rbsp", E.escapedRBSP = g(x.subarray(1)), E.config = T(E.escapedRBSP);
          break;
        case 8:
          E.nalUnitType = "pic_parameter_set_rbsp";
          break;
        case 9:
          E.nalUnitType = "access_unit_delimiter_rbsp";
          break;
      }
      c.trigger("data", E);
    }), u.on("done", function() {
      c.trigger("done");
    }), u.on("partialdone", function() {
      c.trigger("partialdone");
    }), u.on("reset", function() {
      c.trigger("reset");
    }), u.on("endedtimeline", function() {
      c.trigger("endedtimeline");
    }), this.flush = function() {
      u.flush();
    }, this.partialFlush = function() {
      u.partialFlush();
    }, this.reset = function() {
      u.reset();
    }, this.endTimeline = function() {
      u.endTimeline();
    }, b = function(x, E) {
      var k = 8, N = 8, q, F;
      for (q = 0; q < x; q++)
        N !== 0 && (F = E.readExpGolomb(), N = (k + F + 256) % 256), k = N === 0 ? k : N;
    }, g = function(x) {
      for (var E = x.byteLength, k = [], N = 1, q, F; N < E - 2; )
        x[N] === 0 && x[N + 1] === 0 && x[N + 2] === 3 ? (k.push(N + 2), N += 2) : N++;
      if (k.length === 0)
        return x;
      q = E - k.length, F = new Uint8Array(q);
      var G = 0;
      for (N = 0; N < q; G++, N++)
        G === k[0] && (G++, k.shift()), F[N] = x[G];
      return F;
    }, T = function(x) {
      var E = 0, k = 0, N = 0, q = 0, F, G, K, Ce, it, ni, nl, al, ol, ha, ul, be = [1, 1], ll, ai;
      if (F = new nm(x), G = F.readUnsignedByte(), Ce = F.readUnsignedByte(), K = F.readUnsignedByte(), F.skipUnsignedExpGolomb(), Pu[G] && (it = F.readUnsignedExpGolomb(), it === 3 && F.skipBits(1), F.skipUnsignedExpGolomb(), F.skipUnsignedExpGolomb(), F.skipBits(1), F.readBoolean()))
        for (ul = it !== 3 ? 8 : 12, ai = 0; ai < ul; ai++)
          F.readBoolean() && (ai < 6 ? b(16, F) : b(64, F));
      if (F.skipUnsignedExpGolomb(), ni = F.readUnsignedExpGolomb(), ni === 0)
        F.readUnsignedExpGolomb();
      else if (ni === 1)
        for (F.skipBits(1), F.skipExpGolomb(), F.skipExpGolomb(), nl = F.readUnsignedExpGolomb(), ai = 0; ai < nl; ai++)
          F.skipExpGolomb();
      if (F.skipUnsignedExpGolomb(), F.skipBits(1), al = F.readUnsignedExpGolomb(), ol = F.readUnsignedExpGolomb(), ha = F.readBits(1), ha === 0 && F.skipBits(1), F.skipBits(1), F.readBoolean() && (E = F.readUnsignedExpGolomb(), k = F.readUnsignedExpGolomb(), N = F.readUnsignedExpGolomb(), q = F.readUnsignedExpGolomb()), F.readBoolean() && F.readBoolean()) {
        switch (ll = F.readUnsignedByte(), ll) {
          case 1:
            be = [1, 1];
            break;
          case 2:
            be = [12, 11];
            break;
          case 3:
            be = [10, 11];
            break;
          case 4:
            be = [16, 11];
            break;
          case 5:
            be = [40, 33];
            break;
          case 6:
            be = [24, 11];
            break;
          case 7:
            be = [20, 11];
            break;
          case 8:
            be = [32, 11];
            break;
          case 9:
            be = [80, 33];
            break;
          case 10:
            be = [18, 11];
            break;
          case 11:
            be = [15, 11];
            break;
          case 12:
            be = [64, 33];
            break;
          case 13:
            be = [160, 99];
            break;
          case 14:
            be = [4, 3];
            break;
          case 15:
            be = [3, 2];
            break;
          case 16:
            be = [2, 1];
            break;
          case 255: {
            be = [F.readUnsignedByte() << 8 | F.readUnsignedByte(), F.readUnsignedByte() << 8 | F.readUnsignedByte()];
            break;
          }
        }
        be && be[0] / be[1];
      }
      return {
        profileIdc: G,
        levelIdc: K,
        profileCompatibility: Ce,
        width: (al + 1) * 16 - E * 2 - k * 2,
        height: (2 - ha) * (ol + 1) * 16 - N * 2 - q * 2,
        // sar is sample aspect ratio
        sarRatio: be
      };
    };
  }, br.prototype = new ku();
  var am = {
    H264Stream: br,
    NalByteStream: ps
  }, om = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], Ou = function(u, c) {
    var f = u[c + 6] << 21 | u[c + 7] << 14 | u[c + 8] << 7 | u[c + 9], d = u[c + 5], p = (d & 16) >> 4;
    return f = f >= 0 ? f : 0, p ? f + 20 : f + 10;
  }, Lu = function(u, c) {
    return u.length - c < 10 || u[c] !== 73 || u[c + 1] !== 68 || u[c + 2] !== 51 ? c : (c += Ou(u, c), Lu(u, c));
  }, um = function(u) {
    var c = Lu(u, 0);
    return u.length >= c + 2 && (u[c] & 255) === 255 && (u[c + 1] & 240) === 240 && // verify that the 2 layer bits are 0, aka this
    // is not mp3 data but aac data.
    (u[c + 1] & 22) === 16;
  }, Ru = function(u) {
    return u[0] << 21 | u[1] << 14 | u[2] << 7 | u[3];
  }, lm = function(u, c, f) {
    var d, p = "";
    for (d = c; d < f; d++)
      p += "%" + ("00" + u[d].toString(16)).slice(-2);
    return p;
  }, cm = function(u, c, f) {
    return unescape(lm(u, c, f));
  }, dm = function(u, c) {
    var f = (u[c + 5] & 224) >> 5, d = u[c + 4] << 3, p = u[c + 3] & 6144;
    return p | d | f;
  }, hm = function(u, c) {
    return u[c] === 73 && u[c + 1] === 68 && u[c + 2] === 51 ? "timed-metadata" : u[c] & !0 && (u[c + 1] & 240) === 240 ? "audio" : null;
  }, fm = function(u) {
    for (var c = 0; c + 5 < u.length; ) {
      if (u[c] !== 255 || (u[c + 1] & 246) !== 240) {
        c++;
        continue;
      }
      return om[(u[c + 2] & 60) >>> 2];
    }
    return null;
  }, pm = function(u) {
    var c, f, d, p;
    c = 10, u[5] & 64 && (c += 4, c += Ru(u.subarray(10, 14)));
    do {
      if (f = Ru(u.subarray(c + 4, c + 8)), f < 1)
        return null;
      if (p = String.fromCharCode(u[c], u[c + 1], u[c + 2], u[c + 3]), p === "PRIV") {
        d = u.subarray(c + 10, c + f + 10);
        for (var g = 0; g < d.byteLength; g++)
          if (d[g] === 0) {
            var T = cm(d, 0, g);
            if (T === "com.apple.streaming.transportStreamTimestamp") {
              var b = d.subarray(g + 1), x = (b[3] & 1) << 30 | b[4] << 22 | b[5] << 14 | b[6] << 6 | b[7] >>> 2;
              return x *= 4, x += b[7] & 3, x;
            }
            break;
          }
      }
      c += 10, c += f;
    } while (c < u.byteLength);
    return null;
  }, ia = {
    isLikelyAacData: um,
    parseId3TagSize: Ou,
    parseAdtsSize: dm,
    parseType: hm,
    parseSampleRate: fm,
    parseAacTimestamp: pm
  }, mm = t, Nu = ia, xr;
  xr = function() {
    var u = new Uint8Array(), c = 0;
    xr.prototype.init.call(this), this.setTimestamp = function(f) {
      c = f;
    }, this.push = function(f) {
      var d = 0, p = 0, g, T, b, x;
      for (u.length ? (x = u.length, u = new Uint8Array(f.byteLength + x), u.set(u.subarray(0, x)), u.set(f, x)) : u = f; u.length - p >= 3; ) {
        if (u[p] === 73 && u[p + 1] === 68 && u[p + 2] === 51) {
          if (u.length - p < 10 || (d = Nu.parseId3TagSize(u, p), p + d > u.length))
            break;
          T = {
            type: "timed-metadata",
            data: u.subarray(p, p + d)
          }, this.trigger("data", T), p += d;
          continue;
        } else if ((u[p] & 255) === 255 && (u[p + 1] & 240) === 240) {
          if (u.length - p < 7 || (d = Nu.parseAdtsSize(u, p), p + d > u.length))
            break;
          b = {
            type: "audio",
            data: u.subarray(p, p + d),
            pts: c,
            dts: c
          }, this.trigger("data", b), p += d;
          continue;
        }
        p++;
      }
      g = u.length - p, g > 0 ? u = u.subarray(p) : u = new Uint8Array();
    }, this.reset = function() {
      u = new Uint8Array(), this.trigger("reset");
    }, this.endTimeline = function() {
      u = new Uint8Array(), this.trigger("endedtimeline");
    };
  }, xr.prototype = new mm();
  var gm = xr, _m = ["audioobjecttype", "channelcount", "samplerate", "samplingfrequencyindex", "samplesize"], ym = _m, Tm = ["width", "height", "profileIdc", "levelIdc", "profileCompatibility", "sarRatio"], vm = Tm, Sr = t, ms = dp, gs = vp, Er = Ip, lt = Rp, It = em, Cr = ce, Mu = sm, bm = am.H264Stream, xm = gm, Sm = ia.isLikelyAacData, Em = ce.ONE_SECOND_IN_TS, sa = ym, ra = vm, _s, bi, Ar, si, Cm = function(u, c) {
    c.stream = u, this.trigger("log", c);
  }, Bu = function(u, c) {
    for (var f = Object.keys(c), d = 0; d < f.length; d++) {
      var p = f[d];
      p === "headOfPipeline" || !c[p].on || c[p].on("log", Cm.bind(u, p));
    }
  }, Fu = function(u, c) {
    var f;
    if (u.length !== c.length)
      return !1;
    for (f = 0; f < u.length; f++)
      if (u[f] !== c[f])
        return !1;
    return !0;
  }, na = function(u, c, f, d, p, g) {
    var T = f - c, b = d - c, x = p - f;
    return {
      start: {
        dts: u,
        pts: u + T
      },
      end: {
        dts: u + b,
        pts: u + x
      },
      prependedContentDuration: g,
      baseMediaDecodeTime: u
    };
  };
  bi = function(u, c) {
    var f = [], d, p = 0, g = 0, T = 1 / 0;
    c = c || {}, d = c.firstSequenceNumber || 0, bi.prototype.init.call(this), this.push = function(b) {
      lt.collectDtsInfo(u, b), u && sa.forEach(function(x) {
        u[x] = b[x];
      }), f.push(b);
    }, this.setEarliestDts = function(b) {
      p = b;
    }, this.setVideoBaseMediaDecodeTime = function(b) {
      T = b;
    }, this.setAudioAppendStart = function(b) {
      g = b;
    }, this.flush = function() {
      var b, x, E, k, N, q, F;
      if (f.length === 0) {
        this.trigger("done", "AudioSegmentStream");
        return;
      }
      b = Er.trimAdtsFramesByEarliestDts(f, u, p), u.baseMediaDecodeTime = lt.calculateTrackBaseMediaDecodeTime(u, c.keepOriginalTimestamps), F = Er.prefixWithSilence(u, b, g, T), u.samples = Er.generateSampleTable(b), E = ms.mdat(Er.concatenateFrameData(b)), f = [], x = ms.moof(d, [u]), k = new Uint8Array(x.byteLength + E.byteLength), d++, k.set(x), k.set(E, x.byteLength), lt.clearDtsInfo(u), N = Math.ceil(Em * 1024 / u.samplerate), b.length && (q = b.length * N, this.trigger("segmentTimingInfo", na(
        // The audio track's baseMediaDecodeTime is in audio clock cycles, but the
        // frame info is in video clock cycles. Convert to match expectation of
        // listeners (that all timestamps will be based on video clock cycles).
        Cr.audioTsToVideoTs(u.baseMediaDecodeTime, u.samplerate),
        // frame times are already in video clock, as is segment duration
        b[0].dts,
        b[0].pts,
        b[0].dts + q,
        b[0].pts + q,
        F || 0
      )), this.trigger("timingInfo", {
        start: b[0].pts,
        end: b[0].pts + q
      })), this.trigger("data", {
        track: u,
        boxes: k
      }), this.trigger("done", "AudioSegmentStream");
    }, this.reset = function() {
      lt.clearDtsInfo(u), f = [], this.trigger("reset");
    };
  }, bi.prototype = new Sr(), _s = function(u, c) {
    var f, d = [], p = [], g, T;
    c = c || {}, f = c.firstSequenceNumber || 0, _s.prototype.init.call(this), delete u.minPTS, this.gopCache_ = [], this.push = function(b) {
      lt.collectDtsInfo(u, b), b.nalUnitType === "seq_parameter_set_rbsp" && !g && (g = b.config, u.sps = [b.data], ra.forEach(function(x) {
        u[x] = g[x];
      }, this)), b.nalUnitType === "pic_parameter_set_rbsp" && !T && (T = b.data, u.pps = [b.data]), d.push(b);
    }, this.flush = function() {
      for (var b, x, E, k, N, q, F = 0, G, K; d.length && d[0].nalUnitType !== "access_unit_delimiter_rbsp"; )
        d.shift();
      if (d.length === 0) {
        this.resetStream_(), this.trigger("done", "VideoSegmentStream");
        return;
      }
      if (b = gs.groupNalsIntoFrames(d), E = gs.groupFramesIntoGops(b), E[0][0].keyFrame || (x = this.getGopForFusion_(d[0], u), x ? (F = x.duration, E.unshift(x), E.byteLength += x.byteLength, E.nalCount += x.nalCount, E.pts = x.pts, E.dts = x.dts, E.duration += x.duration) : E = gs.extendFirstKeyFrame(E)), p.length) {
        var Ce;
        if (c.alignGopsAtEnd ? Ce = this.alignGopsAtEnd_(E) : Ce = this.alignGopsAtStart_(E), !Ce) {
          this.gopCache_.unshift({
            gop: E.pop(),
            pps: u.pps,
            sps: u.sps
          }), this.gopCache_.length = Math.min(6, this.gopCache_.length), d = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
          return;
        }
        lt.clearDtsInfo(u), E = Ce;
      }
      lt.collectDtsInfo(u, E), u.samples = gs.generateSampleTable(E), N = ms.mdat(gs.concatenateNalData(E)), u.baseMediaDecodeTime = lt.calculateTrackBaseMediaDecodeTime(u, c.keepOriginalTimestamps), this.trigger("processedGopsInfo", E.map(function(it) {
        return {
          pts: it.pts,
          dts: it.dts,
          byteLength: it.byteLength
        };
      })), G = E[0], K = E[E.length - 1], this.trigger("segmentTimingInfo", na(u.baseMediaDecodeTime, G.dts, G.pts, K.dts + K.duration, K.pts + K.duration, F)), this.trigger("timingInfo", {
        start: E[0].pts,
        end: E[E.length - 1].pts + E[E.length - 1].duration
      }), this.gopCache_.unshift({
        gop: E.pop(),
        pps: u.pps,
        sps: u.sps
      }), this.gopCache_.length = Math.min(6, this.gopCache_.length), d = [], this.trigger("baseMediaDecodeTime", u.baseMediaDecodeTime), this.trigger("timelineStartInfo", u.timelineStartInfo), k = ms.moof(f, [u]), q = new Uint8Array(k.byteLength + N.byteLength), f++, q.set(k), q.set(N, k.byteLength), this.trigger("data", {
        track: u,
        boxes: q
      }), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
    }, this.reset = function() {
      this.resetStream_(), d = [], this.gopCache_.length = 0, p.length = 0, this.trigger("reset");
    }, this.resetStream_ = function() {
      lt.clearDtsInfo(u), g = void 0, T = void 0;
    }, this.getGopForFusion_ = function(b) {
      var x = 45e3, E = 1e4, k = 1 / 0, N, q, F, G, K;
      for (K = 0; K < this.gopCache_.length; K++)
        G = this.gopCache_[K], F = G.gop, !(!(u.pps && Fu(u.pps[0], G.pps[0])) || !(u.sps && Fu(u.sps[0], G.sps[0]))) && (F.dts < u.timelineStartInfo.dts || (N = b.dts - F.dts - F.duration, N >= -E && N <= x && (!q || k > N) && (q = G, k = N)));
      return q ? q.gop : null;
    }, this.alignGopsAtStart_ = function(b) {
      var x, E, k, N, q, F, G, K;
      for (q = b.byteLength, F = b.nalCount, G = b.duration, x = E = 0; x < p.length && E < b.length && (k = p[x], N = b[E], k.pts !== N.pts); ) {
        if (N.pts > k.pts) {
          x++;
          continue;
        }
        E++, q -= N.byteLength, F -= N.nalCount, G -= N.duration;
      }
      return E === 0 ? b : E === b.length ? null : (K = b.slice(E), K.byteLength = q, K.duration = G, K.nalCount = F, K.pts = K[0].pts, K.dts = K[0].dts, K);
    }, this.alignGopsAtEnd_ = function(b) {
      var x, E, k, N, q, F;
      for (x = p.length - 1, E = b.length - 1, q = null, F = !1; x >= 0 && E >= 0; ) {
        if (k = p[x], N = b[E], k.pts === N.pts) {
          F = !0;
          break;
        }
        if (k.pts > N.pts) {
          x--;
          continue;
        }
        x === p.length - 1 && (q = E), E--;
      }
      if (!F && q === null)
        return null;
      var G;
      if (F ? G = E : G = q, G === 0)
        return b;
      var K = b.slice(G), Ce = K.reduce(function(it, ni) {
        return it.byteLength += ni.byteLength, it.duration += ni.duration, it.nalCount += ni.nalCount, it;
      }, {
        byteLength: 0,
        duration: 0,
        nalCount: 0
      });
      return K.byteLength = Ce.byteLength, K.duration = Ce.duration, K.nalCount = Ce.nalCount, K.pts = K[0].pts, K.dts = K[0].dts, K;
    }, this.alignGopsWith = function(b) {
      p = b;
    };
  }, _s.prototype = new Sr(), si = function(u, c) {
    this.numberOfTracks = 0, this.metadataStream = c, u = u || {}, typeof u.remux < "u" ? this.remuxTracks = !!u.remux : this.remuxTracks = !0, typeof u.keepOriginalTimestamps == "boolean" ? this.keepOriginalTimestamps = u.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, si.prototype.init.call(this), this.push = function(f) {
      if (f.content || f.text)
        return this.pendingCaptions.push(f);
      if (f.frames)
        return this.pendingMetadata.push(f);
      this.pendingTracks.push(f.track), this.pendingBytes += f.boxes.byteLength, f.track.type === "video" && (this.videoTrack = f.track, this.pendingBoxes.push(f.boxes)), f.track.type === "audio" && (this.audioTrack = f.track, this.pendingBoxes.unshift(f.boxes));
    };
  }, si.prototype = new Sr(), si.prototype.flush = function(u) {
    var c = 0, f = {
      captions: [],
      captionStreams: {},
      metadata: [],
      info: {}
    }, d, p, g, T = 0, b;
    if (this.pendingTracks.length < this.numberOfTracks) {
      if (u !== "VideoSegmentStream" && u !== "AudioSegmentStream")
        return;
      if (this.remuxTracks)
        return;
      if (this.pendingTracks.length === 0) {
        this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
        return;
      }
    }
    if (this.videoTrack ? (T = this.videoTrack.timelineStartInfo.pts, ra.forEach(function(x) {
      f.info[x] = this.videoTrack[x];
    }, this)) : this.audioTrack && (T = this.audioTrack.timelineStartInfo.pts, sa.forEach(function(x) {
      f.info[x] = this.audioTrack[x];
    }, this)), this.videoTrack || this.audioTrack) {
      for (this.pendingTracks.length === 1 ? f.type = this.pendingTracks[0].type : f.type = "combined", this.emittedTracks += this.pendingTracks.length, g = ms.initSegment(this.pendingTracks), f.initSegment = new Uint8Array(g.byteLength), f.initSegment.set(g), f.data = new Uint8Array(this.pendingBytes), b = 0; b < this.pendingBoxes.length; b++)
        f.data.set(this.pendingBoxes[b], c), c += this.pendingBoxes[b].byteLength;
      for (b = 0; b < this.pendingCaptions.length; b++)
        d = this.pendingCaptions[b], d.startTime = Cr.metadataTsToSeconds(d.startPts, T, this.keepOriginalTimestamps), d.endTime = Cr.metadataTsToSeconds(d.endPts, T, this.keepOriginalTimestamps), f.captionStreams[d.stream] = !0, f.captions.push(d);
      for (b = 0; b < this.pendingMetadata.length; b++)
        p = this.pendingMetadata[b], p.cueTime = Cr.metadataTsToSeconds(p.pts, T, this.keepOriginalTimestamps), f.metadata.push(p);
      for (f.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", f), b = 0; b < f.captions.length; b++)
        d = f.captions[b], this.trigger("caption", d);
      for (b = 0; b < f.metadata.length; b++)
        p = f.metadata[b], this.trigger("id3Frame", p);
    }
    this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
  }, si.prototype.setRemux = function(u) {
    this.remuxTracks = u;
  }, Ar = function(u) {
    var c = this, f = !0, d, p;
    Ar.prototype.init.call(this), u = u || {}, this.baseMediaDecodeTime = u.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
      var g = {};
      this.transmuxPipeline_ = g, g.type = "aac", g.metadataStream = new It.MetadataStream(), g.aacStream = new xm(), g.audioTimestampRolloverStream = new It.TimestampRolloverStream("audio"), g.timedMetadataTimestampRolloverStream = new It.TimestampRolloverStream("timed-metadata"), g.adtsStream = new Mu(), g.coalesceStream = new si(u, g.metadataStream), g.headOfPipeline = g.aacStream, g.aacStream.pipe(g.audioTimestampRolloverStream).pipe(g.adtsStream), g.aacStream.pipe(g.timedMetadataTimestampRolloverStream).pipe(g.metadataStream).pipe(g.coalesceStream), g.metadataStream.on("timestamp", function(T) {
        g.aacStream.setTimestamp(T.timeStamp);
      }), g.aacStream.on("data", function(T) {
        T.type !== "timed-metadata" && T.type !== "audio" || g.audioSegmentStream || (p = p || {
          timelineStartInfo: {
            baseMediaDecodeTime: c.baseMediaDecodeTime
          },
          codec: "adts",
          type: "audio"
        }, g.coalesceStream.numberOfTracks++, g.audioSegmentStream = new bi(p, u), g.audioSegmentStream.on("log", c.getLogTrigger_("audioSegmentStream")), g.audioSegmentStream.on("timingInfo", c.trigger.bind(c, "audioTimingInfo")), g.adtsStream.pipe(g.audioSegmentStream).pipe(g.coalesceStream), c.trigger("trackinfo", {
          hasAudio: !!p,
          hasVideo: !!d
        }));
      }), g.coalesceStream.on("data", this.trigger.bind(this, "data")), g.coalesceStream.on("done", this.trigger.bind(this, "done")), Bu(this, g);
    }, this.setupTsPipeline = function() {
      var g = {};
      this.transmuxPipeline_ = g, g.type = "ts", g.metadataStream = new It.MetadataStream(), g.packetStream = new It.TransportPacketStream(), g.parseStream = new It.TransportParseStream(), g.elementaryStream = new It.ElementaryStream(), g.timestampRolloverStream = new It.TimestampRolloverStream(), g.adtsStream = new Mu(), g.h264Stream = new bm(), g.captionStream = new It.CaptionStream(u), g.coalesceStream = new si(u, g.metadataStream), g.headOfPipeline = g.packetStream, g.packetStream.pipe(g.parseStream).pipe(g.elementaryStream).pipe(g.timestampRolloverStream), g.timestampRolloverStream.pipe(g.h264Stream), g.timestampRolloverStream.pipe(g.adtsStream), g.timestampRolloverStream.pipe(g.metadataStream).pipe(g.coalesceStream), g.h264Stream.pipe(g.captionStream).pipe(g.coalesceStream), g.elementaryStream.on("data", function(T) {
        var b;
        if (T.type === "metadata") {
          for (b = T.tracks.length; b--; )
            !d && T.tracks[b].type === "video" ? (d = T.tracks[b], d.timelineStartInfo.baseMediaDecodeTime = c.baseMediaDecodeTime) : !p && T.tracks[b].type === "audio" && (p = T.tracks[b], p.timelineStartInfo.baseMediaDecodeTime = c.baseMediaDecodeTime);
          d && !g.videoSegmentStream && (g.coalesceStream.numberOfTracks++, g.videoSegmentStream = new _s(d, u), g.videoSegmentStream.on("log", c.getLogTrigger_("videoSegmentStream")), g.videoSegmentStream.on("timelineStartInfo", function(x) {
            p && !u.keepOriginalTimestamps && (p.timelineStartInfo = x, g.audioSegmentStream.setEarliestDts(x.dts - c.baseMediaDecodeTime));
          }), g.videoSegmentStream.on("processedGopsInfo", c.trigger.bind(c, "gopInfo")), g.videoSegmentStream.on("segmentTimingInfo", c.trigger.bind(c, "videoSegmentTimingInfo")), g.videoSegmentStream.on("baseMediaDecodeTime", function(x) {
            p && g.audioSegmentStream.setVideoBaseMediaDecodeTime(x);
          }), g.videoSegmentStream.on("timingInfo", c.trigger.bind(c, "videoTimingInfo")), g.h264Stream.pipe(g.videoSegmentStream).pipe(g.coalesceStream)), p && !g.audioSegmentStream && (g.coalesceStream.numberOfTracks++, g.audioSegmentStream = new bi(p, u), g.audioSegmentStream.on("log", c.getLogTrigger_("audioSegmentStream")), g.audioSegmentStream.on("timingInfo", c.trigger.bind(c, "audioTimingInfo")), g.audioSegmentStream.on("segmentTimingInfo", c.trigger.bind(c, "audioSegmentTimingInfo")), g.adtsStream.pipe(g.audioSegmentStream).pipe(g.coalesceStream)), c.trigger("trackinfo", {
            hasAudio: !!p,
            hasVideo: !!d
          });
        }
      }), g.coalesceStream.on("data", this.trigger.bind(this, "data")), g.coalesceStream.on("id3Frame", function(T) {
        T.dispatchType = g.metadataStream.dispatchType, c.trigger("id3Frame", T);
      }), g.coalesceStream.on("caption", this.trigger.bind(this, "caption")), g.coalesceStream.on("done", this.trigger.bind(this, "done")), Bu(this, g);
    }, this.setBaseMediaDecodeTime = function(g) {
      var T = this.transmuxPipeline_;
      u.keepOriginalTimestamps || (this.baseMediaDecodeTime = g), p && (p.timelineStartInfo.dts = void 0, p.timelineStartInfo.pts = void 0, lt.clearDtsInfo(p), T.audioTimestampRolloverStream && T.audioTimestampRolloverStream.discontinuity()), d && (T.videoSegmentStream && (T.videoSegmentStream.gopCache_ = []), d.timelineStartInfo.dts = void 0, d.timelineStartInfo.pts = void 0, lt.clearDtsInfo(d), T.captionStream.reset()), T.timestampRolloverStream && T.timestampRolloverStream.discontinuity();
    }, this.setAudioAppendStart = function(g) {
      p && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(g);
    }, this.setRemux = function(g) {
      var T = this.transmuxPipeline_;
      u.remux = g, T && T.coalesceStream && T.coalesceStream.setRemux(g);
    }, this.alignGopsWith = function(g) {
      d && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(g);
    }, this.getLogTrigger_ = function(g) {
      var T = this;
      return function(b) {
        b.stream = g, T.trigger("log", b);
      };
    }, this.push = function(g) {
      if (f) {
        var T = Sm(g);
        T && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !T && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), f = !1;
      }
      this.transmuxPipeline_.headOfPipeline.push(g);
    }, this.flush = function() {
      f = !0, this.transmuxPipeline_.headOfPipeline.flush();
    }, this.endTimeline = function() {
      this.transmuxPipeline_.headOfPipeline.endTimeline();
    }, this.reset = function() {
      this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
    }, this.resetCaptions = function() {
      this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
    };
  }, Ar.prototype = new Sr();
  var Am = {
    Transmuxer: Ar,
    VideoSegmentStream: _s,
    AudioSegmentStream: bi,
    AUDIO_PROPERTIES: sa,
    VIDEO_PROPERTIES: ra,
    // exported for testing
    generateSegmentTimingInfo: na
  }, Dm = function(u) {
    return u >>> 0;
  }, wm = function(u) {
    return ("00" + u.toString(16)).slice(-2);
  }, Dr = {
    toUnsigned: Dm,
    toHexString: wm
  }, Im = function(u) {
    var c = "";
    return c += String.fromCharCode(u[0]), c += String.fromCharCode(u[1]), c += String.fromCharCode(u[2]), c += String.fromCharCode(u[3]), c;
  }, Uu = Im, km = Dr.toUnsigned, Pm = Uu, $u = function(u, c) {
    var f = [], d, p, g, T, b;
    if (!c.length)
      return null;
    for (d = 0; d < u.byteLength; )
      p = km(u[d] << 24 | u[d + 1] << 16 | u[d + 2] << 8 | u[d + 3]), g = Pm(u.subarray(d + 4, d + 8)), T = p > 1 ? d + p : u.byteLength, g === c[0] && (c.length === 1 ? f.push(u.subarray(d + 8, T)) : (b = $u(u.subarray(d + 8, T), c.slice(1)), b.length && (f = f.concat(b)))), d = T;
    return f;
  }, qu = $u, Om = Dr.toUnsigned, Lm = n.getUint64, Rm = function(u) {
    var c = {
      version: u[0],
      flags: new Uint8Array(u.subarray(1, 4))
    };
    return c.version === 1 ? c.baseMediaDecodeTime = Lm(u.subarray(4)) : c.baseMediaDecodeTime = Om(u[4] << 24 | u[5] << 16 | u[6] << 8 | u[7]), c;
  }, ju = Rm, Nm = function(u) {
    return {
      isLeading: (u[0] & 12) >>> 2,
      dependsOn: u[0] & 3,
      isDependedOn: (u[1] & 192) >>> 6,
      hasRedundancy: (u[1] & 48) >>> 4,
      paddingValue: (u[1] & 14) >>> 1,
      isNonSyncSample: u[1] & 1,
      degradationPriority: u[2] << 8 | u[3]
    };
  }, Mm = Nm, Hu = Mm, Bm = function(u) {
    var c = {
      version: u[0],
      flags: new Uint8Array(u.subarray(1, 4)),
      samples: []
    }, f = new DataView(u.buffer, u.byteOffset, u.byteLength), d = c.flags[2] & 1, p = c.flags[2] & 4, g = c.flags[1] & 1, T = c.flags[1] & 2, b = c.flags[1] & 4, x = c.flags[1] & 8, E = f.getUint32(4), k = 8, N;
    for (d && (c.dataOffset = f.getInt32(k), k += 4), p && E && (N = {
      flags: Hu(u.subarray(k, k + 4))
    }, k += 4, g && (N.duration = f.getUint32(k), k += 4), T && (N.size = f.getUint32(k), k += 4), x && (c.version === 1 ? N.compositionTimeOffset = f.getInt32(k) : N.compositionTimeOffset = f.getUint32(k), k += 4), c.samples.push(N), E--); E--; )
      N = {}, g && (N.duration = f.getUint32(k), k += 4), T && (N.size = f.getUint32(k), k += 4), b && (N.flags = Hu(u.subarray(k, k + 4)), k += 4), x && (c.version === 1 ? N.compositionTimeOffset = f.getInt32(k) : N.compositionTimeOffset = f.getUint32(k), k += 4), c.samples.push(N);
    return c;
  }, Vu = Bm, Fm = function(u) {
    var c = new DataView(u.buffer, u.byteOffset, u.byteLength), f = {
      version: u[0],
      flags: new Uint8Array(u.subarray(1, 4)),
      trackId: c.getUint32(4)
    }, d = f.flags[2] & 1, p = f.flags[2] & 2, g = f.flags[2] & 8, T = f.flags[2] & 16, b = f.flags[2] & 32, x = f.flags[0] & 65536, E = f.flags[0] & 131072, k;
    return k = 8, d && (k += 4, f.baseDataOffset = c.getUint32(12), k += 4), p && (f.sampleDescriptionIndex = c.getUint32(k), k += 4), g && (f.defaultSampleDuration = c.getUint32(k), k += 4), T && (f.defaultSampleSize = c.getUint32(k), k += 4), b && (f.defaultSampleFlags = c.getUint32(k)), x && (f.durationIsEmpty = !0), !d && E && (f.baseDataOffsetIsMoof = !0), f;
  }, zu = Fm, ys;
  typeof window < "u" ? ys = window : typeof i < "u" ? ys = i : typeof self < "u" ? ys = self : ys = {};
  var Gu = ys, Um = bu.discardEmulationPreventionBytes, $m = xu.CaptionStream, Ts = qu, qm = ju, jm = Vu, Hm = zu, Wu = Gu, Vm = function(u, c) {
    for (var f = u, d = 0; d < c.length; d++) {
      var p = c[d];
      if (f < p.size)
        return p;
      f -= p.size;
    }
    return null;
  }, zm = function(u, c, f) {
    var d = new DataView(u.buffer, u.byteOffset, u.byteLength), p = {
      logs: [],
      seiNals: []
    }, g, T, b, x;
    for (T = 0; T + 4 < u.length; T += b)
      if (b = d.getUint32(T), T += 4, !(b <= 0))
        switch (u[T] & 31) {
          case 6:
            var E = u.subarray(T + 1, T + 1 + b), k = Vm(T, c);
            if (g = {
              nalUnitType: "sei_rbsp",
              size: b,
              data: E,
              escapedRBSP: Um(E),
              trackId: f
            }, k)
              g.pts = k.pts, g.dts = k.dts, x = k;
            else if (x)
              g.pts = x.pts, g.dts = x.dts;
            else {
              p.logs.push({
                level: "warn",
                message: "We've encountered a nal unit without data at " + T + " for trackId " + f + ". See mux.js#223."
              });
              break;
            }
            p.seiNals.push(g);
            break;
        }
    return p;
  }, Gm = function(u, c, f) {
    var d = c, p = f.defaultSampleDuration || 0, g = f.defaultSampleSize || 0, T = f.trackId, b = [];
    return u.forEach(function(x) {
      var E = jm(x), k = E.samples;
      k.forEach(function(N) {
        N.duration === void 0 && (N.duration = p), N.size === void 0 && (N.size = g), N.trackId = T, N.dts = d, N.compositionTimeOffset === void 0 && (N.compositionTimeOffset = 0), typeof d == "bigint" ? (N.pts = d + Wu.BigInt(N.compositionTimeOffset), d += Wu.BigInt(N.duration)) : (N.pts = d + N.compositionTimeOffset, d += N.duration);
      }), b = b.concat(k);
    }), b;
  }, Wm = function(u, c) {
    var f = Ts(u, ["moof", "traf"]), d = Ts(u, ["mdat"]), p = {}, g = [];
    return d.forEach(function(T, b) {
      var x = f[b];
      g.push({
        mdat: T,
        traf: x
      });
    }), g.forEach(function(T) {
      var b = T.mdat, x = T.traf, E = Ts(x, ["tfhd"]), k = Hm(E[0]), N = k.trackId, q = Ts(x, ["tfdt"]), F = q.length > 0 ? qm(q[0]).baseMediaDecodeTime : 0, G = Ts(x, ["trun"]), K, Ce;
      c === N && G.length > 0 && (K = Gm(G, F, k), Ce = zm(b, K, N), p[N] || (p[N] = {
        seiNals: [],
        logs: []
      }), p[N].seiNals = p[N].seiNals.concat(Ce.seiNals), p[N].logs = p[N].logs.concat(Ce.logs));
    }), p;
  }, Xm = function(u, c, f) {
    var d;
    if (c === null)
      return null;
    d = Wm(u, c);
    var p = d[c] || {};
    return {
      seiNals: p.seiNals,
      logs: p.logs,
      timescale: f
    };
  }, Km = function() {
    var u = !1, c, f, d, p, g, T;
    this.isInitialized = function() {
      return u;
    }, this.init = function(b) {
      c = new $m(), u = !0, T = b ? b.isPartial : !1, c.on("data", function(x) {
        x.startTime = x.startPts / p, x.endTime = x.endPts / p, g.captions.push(x), g.captionStreams[x.stream] = !0;
      }), c.on("log", function(x) {
        g.logs.push(x);
      });
    }, this.isNewInit = function(b, x) {
      return b && b.length === 0 || x && typeof x == "object" && Object.keys(x).length === 0 ? !1 : d !== b[0] || p !== x[d];
    }, this.parse = function(b, x, E) {
      var k;
      if (this.isInitialized()) {
        if (!x || !E)
          return null;
        if (this.isNewInit(x, E))
          d = x[0], p = E[d];
        else if (d === null || !p)
          return f.push(b), null;
      } else return null;
      for (; f.length > 0; ) {
        var N = f.shift();
        this.parse(N, x, E);
      }
      return k = Xm(b, d, p), k && k.logs && (g.logs = g.logs.concat(k.logs)), k === null || !k.seiNals ? g.logs.length ? {
        logs: g.logs,
        captions: [],
        captionStreams: []
      } : null : (this.pushNals(k.seiNals), this.flushStream(), g);
    }, this.pushNals = function(b) {
      if (!this.isInitialized() || !b || b.length === 0)
        return null;
      b.forEach(function(x) {
        c.push(x);
      });
    }, this.flushStream = function() {
      if (!this.isInitialized())
        return null;
      T ? c.partialFlush() : c.flush();
    }, this.clearParsedCaptions = function() {
      g.captions = [], g.captionStreams = {}, g.logs = [];
    }, this.resetCaptionStream = function() {
      if (!this.isInitialized())
        return null;
      c.reset();
    }, this.clearAllCaptions = function() {
      this.clearParsedCaptions(), this.resetCaptionStream();
    }, this.reset = function() {
      f = [], d = null, p = null, g ? this.clearParsedCaptions() : g = {
        captions: [],
        // CC1, CC2, CC3, CC4
        captionStreams: {},
        logs: []
      }, this.resetCaptionStream();
    }, this.reset();
  }, Ym = Km, Qm = function(u) {
    for (var c = 0, f = String.fromCharCode(u[c]), d = ""; f !== "\0"; )
      d += f, c++, f = String.fromCharCode(u[c]);
    return d += f, d;
  }, Jm = {
    uint8ToCString: Qm
  }, wr = Jm.uint8ToCString, Zm = n.getUint64, eg = function(u) {
    var c = 4, f = u[0], d, p, g, T, b, x, E, k;
    if (f === 0) {
      d = wr(u.subarray(c)), c += d.length, p = wr(u.subarray(c)), c += p.length;
      var N = new DataView(u.buffer);
      g = N.getUint32(c), c += 4, b = N.getUint32(c), c += 4, x = N.getUint32(c), c += 4, E = N.getUint32(c), c += 4;
    } else if (f === 1) {
      var N = new DataView(u.buffer);
      g = N.getUint32(c), c += 4, T = Zm(u.subarray(c)), c += 8, x = N.getUint32(c), c += 4, E = N.getUint32(c), c += 4, d = wr(u.subarray(c)), c += d.length, p = wr(u.subarray(c)), c += p.length;
    }
    k = new Uint8Array(u.subarray(c, u.byteLength));
    var q = {
      scheme_id_uri: d,
      value: p,
      // if timescale is undefined or 0 set to 1 
      timescale: g || 1,
      presentation_time: T,
      presentation_time_delta: b,
      event_duration: x,
      id: E,
      message_data: k
    };
    return ig(f, q) ? q : void 0;
  }, tg = function(u, c, f, d) {
    return u || u === 0 ? u / c : d + f / c;
  }, ig = function(u, c) {
    var f = c.scheme_id_uri !== "\0", d = u === 0 && Xu(c.presentation_time_delta) && f, p = u === 1 && Xu(c.presentation_time) && f;
    return !(u > 1) && d || p;
  }, Xu = function(u) {
    return u !== void 0 || u !== null;
  }, sg = {
    parseEmsgBox: eg,
    scaleTime: tg
  }, Ir = Dr.toUnsigned, vs = Dr.toHexString, ve = qu, xi = Uu, aa = sg, rg = zu, ng = Vu, ag = ju, og = n.getUint64, Ku, Yu, Qu, Ju, Zu, oa, el, ua = Gu, ug = Au.parseId3Frames;
  Ku = function(u) {
    var c = {}, f = ve(u, ["moov", "trak"]);
    return f.reduce(function(d, p) {
      var g, T, b, x, E;
      return g = ve(p, ["tkhd"])[0], !g || (T = g[0], b = T === 0 ? 12 : 20, x = Ir(g[b] << 24 | g[b + 1] << 16 | g[b + 2] << 8 | g[b + 3]), E = ve(p, ["mdia", "mdhd"])[0], !E) ? null : (T = E[0], b = T === 0 ? 12 : 20, d[x] = Ir(E[b] << 24 | E[b + 1] << 16 | E[b + 2] << 8 | E[b + 3]), d);
    }, c);
  }, Yu = function(u, c) {
    var f;
    f = ve(c, ["moof", "traf"]);
    var d = f.reduce(function(p, g) {
      var T = ve(g, ["tfhd"])[0], b = Ir(T[4] << 24 | T[5] << 16 | T[6] << 8 | T[7]), x = u[b] || 9e4, E = ve(g, ["tfdt"])[0], k = new DataView(E.buffer, E.byteOffset, E.byteLength), N;
      E[0] === 1 ? N = og(E.subarray(4, 12)) : N = k.getUint32(4);
      let q;
      return typeof N == "bigint" ? q = N / ua.BigInt(x) : typeof N == "number" && !isNaN(N) && (q = N / x), q < Number.MAX_SAFE_INTEGER && (q = Number(q)), q < p && (p = q), p;
    }, 1 / 0);
    return typeof d == "bigint" || isFinite(d) ? d : 0;
  }, Qu = function(u, c) {
    var f = ve(c, ["moof", "traf"]), d = 0, p = 0, g;
    if (f && f.length) {
      var T = ve(f[0], ["tfhd"])[0], b = ve(f[0], ["trun"])[0], x = ve(f[0], ["tfdt"])[0];
      if (T) {
        var E = rg(T);
        g = E.trackId;
      }
      if (x) {
        var k = ag(x);
        d = k.baseMediaDecodeTime;
      }
      if (b) {
        var N = ng(b);
        N.samples && N.samples.length && (p = N.samples[0].compositionTimeOffset || 0);
      }
    }
    var q = u[g] || 9e4;
    typeof d == "bigint" && (p = ua.BigInt(p), q = ua.BigInt(q));
    var F = (d + p) / q;
    return typeof F == "bigint" && F < Number.MAX_SAFE_INTEGER && (F = Number(F)), F;
  }, Ju = function(u) {
    var c = ve(u, ["moov", "trak"]), f = [];
    return c.forEach(function(d) {
      var p = ve(d, ["mdia", "hdlr"]), g = ve(d, ["tkhd"]);
      p.forEach(function(T, b) {
        var x = xi(T.subarray(8, 12)), E = g[b], k, N, q;
        x === "vide" && (k = new DataView(E.buffer, E.byteOffset, E.byteLength), N = k.getUint8(0), q = N === 0 ? k.getUint32(12) : k.getUint32(20), f.push(q));
      });
    }), f;
  }, oa = function(u) {
    var c = u[0], f = c === 0 ? 12 : 20;
    return Ir(u[f] << 24 | u[f + 1] << 16 | u[f + 2] << 8 | u[f + 3]);
  }, Zu = function(u) {
    var c = ve(u, ["moov", "trak"]), f = [];
    return c.forEach(function(d) {
      var p = {}, g = ve(d, ["tkhd"])[0], T, b;
      g && (T = new DataView(g.buffer, g.byteOffset, g.byteLength), b = T.getUint8(0), p.id = b === 0 ? T.getUint32(12) : T.getUint32(20));
      var x = ve(d, ["mdia", "hdlr"])[0];
      if (x) {
        var E = xi(x.subarray(8, 12));
        E === "vide" ? p.type = "video" : E === "soun" ? p.type = "audio" : p.type = E;
      }
      var k = ve(d, ["mdia", "minf", "stbl", "stsd"])[0];
      if (k) {
        var N = k.subarray(8);
        p.codec = xi(N.subarray(4, 8));
        var q = ve(N, [p.codec])[0], F, G;
        q && (/^[asm]vc[1-9]$/i.test(p.codec) ? (F = q.subarray(78), G = xi(F.subarray(4, 8)), G === "avcC" && F.length > 11 ? (p.codec += ".", p.codec += vs(F[9]), p.codec += vs(F[10]), p.codec += vs(F[11])) : p.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(p.codec) ? (F = q.subarray(28), G = xi(F.subarray(4, 8)), G === "esds" && F.length > 20 && F[19] !== 0 ? (p.codec += "." + vs(F[19]), p.codec += "." + vs(F[20] >>> 2 & 63).replace(/^0/, "")) : p.codec = "mp4a.40.2") : p.codec = p.codec.toLowerCase());
      }
      var K = ve(d, ["mdia", "mdhd"])[0];
      K && (p.timescale = oa(K)), f.push(p);
    }), f;
  }, el = function(u, c = 0) {
    var f = ve(u, ["emsg"]);
    return f.map((d) => {
      var p = aa.parseEmsgBox(new Uint8Array(d)), g = ug(p.message_data);
      return {
        cueTime: aa.scaleTime(p.presentation_time, p.timescale, p.presentation_time_delta, c),
        duration: aa.scaleTime(p.event_duration, p.timescale),
        frames: g
      };
    });
  };
  var la = {
    // export mp4 inspector's findBox and parseType for backwards compatibility
    findBox: ve,
    parseType: xi,
    timescale: Ku,
    startTime: Yu,
    compositionStartTime: Qu,
    videoTrackIds: Ju,
    tracks: Zu,
    getTimescaleFromMediaHeader: oa,
    getEmsgID3: el
  }, ca = pr, tl = function(u) {
    var c = u[1] & 31;
    return c <<= 8, c |= u[2], c;
  }, kr = function(u) {
    return !!(u[1] & 64);
  }, Pr = function(u) {
    var c = 0;
    return (u[3] & 48) >>> 4 > 1 && (c += u[4] + 1), c;
  }, lg = function(u, c) {
    var f = tl(u);
    return f === 0 ? "pat" : f === c ? "pmt" : c ? "pes" : null;
  }, cg = function(u) {
    var c = kr(u), f = 4 + Pr(u);
    return c && (f += u[f] + 1), (u[f + 10] & 31) << 8 | u[f + 11];
  }, dg = function(u) {
    var c = {}, f = kr(u), d = 4 + Pr(u);
    if (f && (d += u[d] + 1), !!(u[d + 5] & 1)) {
      var p, g, T;
      p = (u[d + 1] & 15) << 8 | u[d + 2], g = 3 + p - 4, T = (u[d + 10] & 15) << 8 | u[d + 11];
      for (var b = 12 + T; b < g; ) {
        var x = d + b;
        c[(u[x + 1] & 31) << 8 | u[x + 2]] = u[x], b += ((u[x + 3] & 15) << 8 | u[x + 4]) + 5;
      }
      return c;
    }
  }, hg = function(u, c) {
    var f = tl(u), d = c[f];
    switch (d) {
      case ca.H264_STREAM_TYPE:
        return "video";
      case ca.ADTS_STREAM_TYPE:
        return "audio";
      case ca.METADATA_STREAM_TYPE:
        return "timed-metadata";
      default:
        return null;
    }
  }, fg = function(u) {
    var c = kr(u);
    if (!c)
      return null;
    var f = 4 + Pr(u);
    if (f >= u.byteLength)
      return null;
    var d = null, p;
    return p = u[f + 7], p & 192 && (d = {}, d.pts = (u[f + 9] & 14) << 27 | (u[f + 10] & 255) << 20 | (u[f + 11] & 254) << 12 | (u[f + 12] & 255) << 5 | (u[f + 13] & 254) >>> 3, d.pts *= 4, d.pts += (u[f + 13] & 6) >>> 1, d.dts = d.pts, p & 64 && (d.dts = (u[f + 14] & 14) << 27 | (u[f + 15] & 255) << 20 | (u[f + 16] & 254) << 12 | (u[f + 17] & 255) << 5 | (u[f + 18] & 254) >>> 3, d.dts *= 4, d.dts += (u[f + 18] & 6) >>> 1)), d;
  }, da = function(u) {
    switch (u) {
      case 5:
        return "slice_layer_without_partitioning_rbsp_idr";
      case 6:
        return "sei_rbsp";
      case 7:
        return "seq_parameter_set_rbsp";
      case 8:
        return "pic_parameter_set_rbsp";
      case 9:
        return "access_unit_delimiter_rbsp";
      default:
        return null;
    }
  }, pg = function(u) {
    for (var c = 4 + Pr(u), f = u.subarray(c), d = 0, p = 0, g = !1, T; p < f.byteLength - 3; p++)
      if (f[p + 2] === 1) {
        d = p + 5;
        break;
      }
    for (; d < f.byteLength; )
      switch (f[d]) {
        case 0:
          if (f[d - 1] !== 0) {
            d += 2;
            break;
          } else if (f[d - 2] !== 0) {
            d++;
            break;
          }
          p + 3 !== d - 2 && (T = da(f[p + 3] & 31), T === "slice_layer_without_partitioning_rbsp_idr" && (g = !0));
          do
            d++;
          while (f[d] !== 1 && d < f.length);
          p = d - 2, d += 3;
          break;
        case 1:
          if (f[d - 1] !== 0 || f[d - 2] !== 0) {
            d += 3;
            break;
          }
          T = da(f[p + 3] & 31), T === "slice_layer_without_partitioning_rbsp_idr" && (g = !0), p = d - 2, d += 3;
          break;
        default:
          d += 3;
          break;
      }
    return f = f.subarray(p), d -= p, p = 0, f && f.byteLength > 3 && (T = da(f[p + 3] & 31), T === "slice_layer_without_partitioning_rbsp_idr" && (g = !0)), g;
  }, mg = {
    parseType: lg,
    parsePat: cg,
    parsePmt: dg,
    parsePayloadUnitStartIndicator: kr,
    parsePesType: hg,
    parsePesTime: fg,
    videoPacketContainsKeyFrame: pg
  }, il = pr, Si = Eu.handleRollover, se = {};
  se.ts = mg, se.aac = ia;
  var ri = ce.ONE_SECOND_IN_TS, Ne = 188, ft = 71, gg = function(u, c) {
    for (var f = 0, d = Ne, p, g; d < u.byteLength; ) {
      if (u[f] === ft && u[d] === ft) {
        switch (p = u.subarray(f, d), g = se.ts.parseType(p, c.pid), g) {
          case "pat":
            c.pid = se.ts.parsePat(p);
            break;
          case "pmt":
            var T = se.ts.parsePmt(p);
            c.table = c.table || {}, Object.keys(T).forEach(function(b) {
              c.table[b] = T[b];
            });
            break;
        }
        f += Ne, d += Ne;
        continue;
      }
      f++, d++;
    }
  }, sl = function(u, c, f) {
    for (var d = 0, p = Ne, g, T, b, x, E, k = !1; p <= u.byteLength; ) {
      if (u[d] === ft && (u[p] === ft || p === u.byteLength)) {
        switch (g = u.subarray(d, p), T = se.ts.parseType(g, c.pid), T) {
          case "pes":
            b = se.ts.parsePesType(g, c.table), x = se.ts.parsePayloadUnitStartIndicator(g), b === "audio" && x && (E = se.ts.parsePesTime(g), E && (E.type = "audio", f.audio.push(E), k = !0));
            break;
        }
        if (k)
          break;
        d += Ne, p += Ne;
        continue;
      }
      d++, p++;
    }
    for (p = u.byteLength, d = p - Ne, k = !1; d >= 0; ) {
      if (u[d] === ft && (u[p] === ft || p === u.byteLength)) {
        switch (g = u.subarray(d, p), T = se.ts.parseType(g, c.pid), T) {
          case "pes":
            b = se.ts.parsePesType(g, c.table), x = se.ts.parsePayloadUnitStartIndicator(g), b === "audio" && x && (E = se.ts.parsePesTime(g), E && (E.type = "audio", f.audio.push(E), k = !0));
            break;
        }
        if (k)
          break;
        d -= Ne, p -= Ne;
        continue;
      }
      d--, p--;
    }
  }, _g = function(u, c, f) {
    for (var d = 0, p = Ne, g, T, b, x, E, k, N, q, F = !1, G = {
      data: [],
      size: 0
    }; p < u.byteLength; ) {
      if (u[d] === ft && u[p] === ft) {
        switch (g = u.subarray(d, p), T = se.ts.parseType(g, c.pid), T) {
          case "pes":
            if (b = se.ts.parsePesType(g, c.table), x = se.ts.parsePayloadUnitStartIndicator(g), b === "video" && (x && !F && (E = se.ts.parsePesTime(g), E && (E.type = "video", f.video.push(E), F = !0)), !f.firstKeyFrame)) {
              if (x && G.size !== 0) {
                for (k = new Uint8Array(G.size), N = 0; G.data.length; )
                  q = G.data.shift(), k.set(q, N), N += q.byteLength;
                if (se.ts.videoPacketContainsKeyFrame(k)) {
                  var K = se.ts.parsePesTime(k);
                  K ? (f.firstKeyFrame = K, f.firstKeyFrame.type = "video") : console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                }
                G.size = 0;
              }
              G.data.push(g), G.size += g.byteLength;
            }
            break;
        }
        if (F && f.firstKeyFrame)
          break;
        d += Ne, p += Ne;
        continue;
      }
      d++, p++;
    }
    for (p = u.byteLength, d = p - Ne, F = !1; d >= 0; ) {
      if (u[d] === ft && u[p] === ft) {
        switch (g = u.subarray(d, p), T = se.ts.parseType(g, c.pid), T) {
          case "pes":
            b = se.ts.parsePesType(g, c.table), x = se.ts.parsePayloadUnitStartIndicator(g), b === "video" && x && (E = se.ts.parsePesTime(g), E && (E.type = "video", f.video.push(E), F = !0));
            break;
        }
        if (F)
          break;
        d -= Ne, p -= Ne;
        continue;
      }
      d--, p--;
    }
  }, yg = function(u, c) {
    if (u.audio && u.audio.length) {
      var f = c;
      (typeof f > "u" || isNaN(f)) && (f = u.audio[0].dts), u.audio.forEach(function(g) {
        g.dts = Si(g.dts, f), g.pts = Si(g.pts, f), g.dtsTime = g.dts / ri, g.ptsTime = g.pts / ri;
      });
    }
    if (u.video && u.video.length) {
      var d = c;
      if ((typeof d > "u" || isNaN(d)) && (d = u.video[0].dts), u.video.forEach(function(g) {
        g.dts = Si(g.dts, d), g.pts = Si(g.pts, d), g.dtsTime = g.dts / ri, g.ptsTime = g.pts / ri;
      }), u.firstKeyFrame) {
        var p = u.firstKeyFrame;
        p.dts = Si(p.dts, d), p.pts = Si(p.pts, d), p.dtsTime = p.dts / ri, p.ptsTime = p.pts / ri;
      }
    }
  }, Tg = function(u) {
    for (var c = !1, f = 0, d = null, p = null, g = 0, T = 0, b; u.length - T >= 3; ) {
      var x = se.aac.parseType(u, T);
      switch (x) {
        case "timed-metadata":
          if (u.length - T < 10) {
            c = !0;
            break;
          }
          if (g = se.aac.parseId3TagSize(u, T), g > u.length) {
            c = !0;
            break;
          }
          p === null && (b = u.subarray(T, T + g), p = se.aac.parseAacTimestamp(b)), T += g;
          break;
        case "audio":
          if (u.length - T < 7) {
            c = !0;
            break;
          }
          if (g = se.aac.parseAdtsSize(u, T), g > u.length) {
            c = !0;
            break;
          }
          d === null && (b = u.subarray(T, T + g), d = se.aac.parseSampleRate(b)), f++, T += g;
          break;
        default:
          T++;
          break;
      }
      if (c)
        return null;
    }
    if (d === null || p === null)
      return null;
    var E = ri / d, k = {
      audio: [{
        type: "audio",
        dts: p,
        pts: p
      }, {
        type: "audio",
        dts: p + f * 1024 * E,
        pts: p + f * 1024 * E
      }]
    };
    return k;
  }, vg = function(u) {
    var c = {
      pid: null,
      table: null
    }, f = {};
    gg(u, c);
    for (var d in c.table)
      if (c.table.hasOwnProperty(d)) {
        var p = c.table[d];
        switch (p) {
          case il.H264_STREAM_TYPE:
            f.video = [], _g(u, c, f), f.video.length === 0 && delete f.video;
            break;
          case il.ADTS_STREAM_TYPE:
            f.audio = [], sl(u, c, f), f.audio.length === 0 && delete f.audio;
            break;
        }
      }
    return f;
  }, bg = function(u, c) {
    var f = se.aac.isLikelyAacData(u), d;
    return f ? d = Tg(u) : d = vg(u), !d || !d.audio && !d.video ? null : (yg(d, c), d);
  }, xg = {
    inspect: bg,
    parseAudioPes_: sl
  };
  const Sg = function(u, c) {
    c.on("data", function(f) {
      const d = f.initSegment;
      f.initSegment = {
        data: d.buffer,
        byteOffset: d.byteOffset,
        byteLength: d.byteLength
      };
      const p = f.data;
      f.data = p.buffer, u.postMessage({
        action: "data",
        segment: f,
        byteOffset: p.byteOffset,
        byteLength: p.byteLength
      }, [f.data]);
    }), c.on("done", function(f) {
      u.postMessage({
        action: "done"
      });
    }), c.on("gopInfo", function(f) {
      u.postMessage({
        action: "gopInfo",
        gopInfo: f
      });
    }), c.on("videoSegmentTimingInfo", function(f) {
      const d = {
        start: {
          decode: ce.videoTsToSeconds(f.start.dts),
          presentation: ce.videoTsToSeconds(f.start.pts)
        },
        end: {
          decode: ce.videoTsToSeconds(f.end.dts),
          presentation: ce.videoTsToSeconds(f.end.pts)
        },
        baseMediaDecodeTime: ce.videoTsToSeconds(f.baseMediaDecodeTime)
      };
      f.prependedContentDuration && (d.prependedContentDuration = ce.videoTsToSeconds(f.prependedContentDuration)), u.postMessage({
        action: "videoSegmentTimingInfo",
        videoSegmentTimingInfo: d
      });
    }), c.on("audioSegmentTimingInfo", function(f) {
      const d = {
        start: {
          decode: ce.videoTsToSeconds(f.start.dts),
          presentation: ce.videoTsToSeconds(f.start.pts)
        },
        end: {
          decode: ce.videoTsToSeconds(f.end.dts),
          presentation: ce.videoTsToSeconds(f.end.pts)
        },
        baseMediaDecodeTime: ce.videoTsToSeconds(f.baseMediaDecodeTime)
      };
      f.prependedContentDuration && (d.prependedContentDuration = ce.videoTsToSeconds(f.prependedContentDuration)), u.postMessage({
        action: "audioSegmentTimingInfo",
        audioSegmentTimingInfo: d
      });
    }), c.on("id3Frame", function(f) {
      u.postMessage({
        action: "id3Frame",
        id3Frame: f
      });
    }), c.on("caption", function(f) {
      u.postMessage({
        action: "caption",
        caption: f
      });
    }), c.on("trackinfo", function(f) {
      u.postMessage({
        action: "trackinfo",
        trackInfo: f
      });
    }), c.on("audioTimingInfo", function(f) {
      u.postMessage({
        action: "audioTimingInfo",
        audioTimingInfo: {
          start: ce.videoTsToSeconds(f.start),
          end: ce.videoTsToSeconds(f.end)
        }
      });
    }), c.on("videoTimingInfo", function(f) {
      u.postMessage({
        action: "videoTimingInfo",
        videoTimingInfo: {
          start: ce.videoTsToSeconds(f.start),
          end: ce.videoTsToSeconds(f.end)
        }
      });
    }), c.on("log", function(f) {
      u.postMessage({
        action: "log",
        log: f
      });
    });
  };
  class rl {
    constructor(c, f) {
      this.options = f || {}, this.self = c, this.init();
    }
    /**
     * initialize our web worker and wire all the events.
     */
    init() {
      this.transmuxer && this.transmuxer.dispose(), this.transmuxer = new Am.Transmuxer(this.options), Sg(this.self, this.transmuxer);
    }
    pushMp4Captions(c) {
      this.captionParser || (this.captionParser = new Ym(), this.captionParser.init());
      const f = new Uint8Array(c.data, c.byteOffset, c.byteLength), d = this.captionParser.parse(f, c.trackIds, c.timescales);
      this.self.postMessage({
        action: "mp4Captions",
        captions: d && d.captions || [],
        logs: d && d.logs || [],
        data: f.buffer
      }, [f.buffer]);
    }
    probeMp4StartTime({
      timescales: c,
      data: f
    }) {
      const d = la.startTime(c, f);
      this.self.postMessage({
        action: "probeMp4StartTime",
        startTime: d,
        data: f
      }, [f.buffer]);
    }
    probeMp4Tracks({
      data: c
    }) {
      const f = la.tracks(c);
      this.self.postMessage({
        action: "probeMp4Tracks",
        tracks: f,
        data: c
      }, [c.buffer]);
    }
    /**
     * Probes an mp4 segment for EMSG boxes containing ID3 data.
     * https://aomediacodec.github.io/id3-emsg/
     *
     * @param {Uint8Array} data segment data
     * @param {number} offset segment start time
     * @return {Object[]} an array of ID3 frames
     */
    probeEmsgID3({
      data: c,
      offset: f
    }) {
      const d = la.getEmsgID3(c, f);
      this.self.postMessage({
        action: "probeEmsgID3",
        id3Frames: d,
        emsgData: c
      }, [c.buffer]);
    }
    /**
     * Probe an mpeg2-ts segment to determine the start time of the segment in it's
     * internal "media time," as well as whether it contains video and/or audio.
     *
     * @private
     * @param {Uint8Array} bytes - segment bytes
     * @param {number} baseStartTime
     *        Relative reference timestamp used when adjusting frame timestamps for rollover.
     *        This value should be in seconds, as it's converted to a 90khz clock within the
     *        function body.
     * @return {Object} The start time of the current segment in "media time" as well as
     *                  whether it contains video and/or audio
     */
    probeTs({
      data: c,
      baseStartTime: f
    }) {
      const d = typeof f == "number" && !isNaN(f) ? f * ce.ONE_SECOND_IN_TS : void 0, p = xg.inspect(c, d);
      let g = null;
      p && (g = {
        // each type's time info comes back as an array of 2 times, start and end
        hasVideo: p.video && p.video.length === 2 || !1,
        hasAudio: p.audio && p.audio.length === 2 || !1
      }, g.hasVideo && (g.videoStart = p.video[0].ptsTime), g.hasAudio && (g.audioStart = p.audio[0].ptsTime)), this.self.postMessage({
        action: "probeTs",
        result: g,
        data: c
      }, [c.buffer]);
    }
    clearAllMp4Captions() {
      this.captionParser && this.captionParser.clearAllCaptions();
    }
    clearParsedMp4Captions() {
      this.captionParser && this.captionParser.clearParsedCaptions();
    }
    /**
     * Adds data (a ts segment) to the start of the transmuxer pipeline for
     * processing.
     *
     * @param {ArrayBuffer} data data to push into the muxer
     */
    push(c) {
      const f = new Uint8Array(c.data, c.byteOffset, c.byteLength);
      this.transmuxer.push(f);
    }
    /**
     * Recreate the transmuxer so that the next segment added via `push`
     * start with a fresh transmuxer.
     */
    reset() {
      this.transmuxer.reset();
    }
    /**
     * Set the value that will be used as the `baseMediaDecodeTime` time for the
     * next segment pushed in. Subsequent segments will have their `baseMediaDecodeTime`
     * set relative to the first based on the PTS values.
     *
     * @param {Object} data used to set the timestamp offset in the muxer
     */
    setTimestampOffset(c) {
      const f = c.timestampOffset || 0;
      this.transmuxer.setBaseMediaDecodeTime(Math.round(ce.secondsToVideoTs(f)));
    }
    setAudioAppendStart(c) {
      this.transmuxer.setAudioAppendStart(Math.ceil(ce.secondsToVideoTs(c.appendStart)));
    }
    setRemux(c) {
      this.transmuxer.setRemux(c.remux);
    }
    /**
     * Forces the pipeline to finish processing the last segment and emit it's
     * results.
     *
     * @param {Object} data event data, not really used
     */
    flush(c) {
      this.transmuxer.flush(), self.postMessage({
        action: "done",
        type: "transmuxed"
      });
    }
    endTimeline() {
      this.transmuxer.endTimeline(), self.postMessage({
        action: "endedtimeline",
        type: "transmuxed"
      });
    }
    alignGopsWith(c) {
      this.transmuxer.alignGopsWith(c.gopsToAlignWith.slice());
    }
  }
  self.onmessage = function(u) {
    if (u.data.action === "init" && u.data.options) {
      this.messageHandlers = new rl(self, u.data.options);
      return;
    }
    this.messageHandlers || (this.messageHandlers = new rl(self)), u.data && u.data.action && u.data.action !== "init" && this.messageHandlers[u.data.action] && this.messageHandlers[u.data.action](u.data);
  };
}));
var Kv = Nf(Xv);
const Yv = (i, e, t) => {
  const {
    type: s,
    initSegment: r,
    captions: n,
    captionStreams: a,
    metadata: o,
    videoFrameDtsTime: l,
    videoFramePtsTime: h
  } = i.data.segment;
  e.buffer.push({
    captions: n,
    captionStreams: a,
    metadata: o
  });
  const m = i.data.segment.boxes || {
    data: i.data.segment.data
  }, _ = {
    type: s,
    // cast ArrayBuffer to TypedArray
    data: new Uint8Array(m.data, m.data.byteOffset, m.data.byteLength),
    initSegment: new Uint8Array(r.data, r.byteOffset, r.byteLength)
  };
  typeof l < "u" && (_.videoFrameDtsTime = l), typeof h < "u" && (_.videoFramePtsTime = h), t(_);
}, Qv = ({
  transmuxedData: i,
  callback: e
}) => {
  i.buffer = [], e(i);
}, Jv = (i, e) => {
  e.gopInfo = i.data.gopInfo;
}, Ff = (i) => {
  const {
    transmuxer: e,
    bytes: t,
    audioAppendStart: s,
    gopsToAlignWith: r,
    remux: n,
    onData: a,
    onTrackInfo: o,
    onAudioTimingInfo: l,
    onVideoTimingInfo: h,
    onVideoSegmentTimingInfo: m,
    onAudioSegmentTimingInfo: _,
    onId3: v,
    onCaptions: C,
    onDone: A,
    onEndedTimeline: y,
    onTransmuxerLog: D,
    isEndOfTimeline: w,
    segment: O,
    triggerSegmentEventFn: P
  } = i, R = {
    buffer: []
  };
  let I = w;
  const B = ($) => {
    e.currentTransmux === i && ($.data.action === "data" && Yv($, R, a), $.data.action === "trackinfo" && o($.data.trackInfo), $.data.action === "gopInfo" && Jv($, R), $.data.action === "audioTimingInfo" && l($.data.audioTimingInfo), $.data.action === "videoTimingInfo" && h($.data.videoTimingInfo), $.data.action === "videoSegmentTimingInfo" && m($.data.videoSegmentTimingInfo), $.data.action === "audioSegmentTimingInfo" && _($.data.audioSegmentTimingInfo), $.data.action === "id3Frame" && v([$.data.id3Frame], $.data.id3Frame.dispatchType), $.data.action === "caption" && C($.data.caption), $.data.action === "endedtimeline" && (I = !1, y()), $.data.action === "log" && D($.data.log), $.data.type === "transmuxed" && (I || (e.onmessage = null, Qv({
      transmuxedData: R,
      callback: A
    }), Uf(e))));
  }, H = () => {
    const $ = {
      message: "Received an error message from the transmuxer worker",
      metadata: {
        errorType: L.Error.StreamingFailedToTransmuxSegment,
        segmentInfo: li({
          segment: O
        })
      }
    };
    A(null, $);
  };
  if (e.onmessage = B, e.onerror = H, s && e.postMessage({
    action: "setAudioAppendStart",
    appendStart: s
  }), Array.isArray(r) && e.postMessage({
    action: "alignGopsWith",
    gopsToAlignWith: r
  }), typeof n < "u" && e.postMessage({
    action: "setRemux",
    remux: n
  }), t.byteLength) {
    const $ = t instanceof ArrayBuffer ? t : t.buffer, X = t instanceof ArrayBuffer ? 0 : t.byteOffset;
    P({
      type: "segmenttransmuxingstart",
      segment: O
    }), e.postMessage({
      action: "push",
      // Send the typed-array of data as an ArrayBuffer so that
      // it can be sent as a "Transferable" and avoid the costly
      // memory copy
      data: $,
      // To recreate the original typed-array, we need information
      // about what portion of the ArrayBuffer it was a view into
      byteOffset: X,
      byteLength: t.byteLength
    }, [$]);
  }
  w && e.postMessage({
    action: "endTimeline"
  }), e.postMessage({
    action: "flush"
  });
}, Uf = (i) => {
  i.currentTransmux = null, i.transmuxQueue.length && (i.currentTransmux = i.transmuxQueue.shift(), typeof i.currentTransmux == "function" ? i.currentTransmux() : Ff(i.currentTransmux));
}, Ec = (i, e) => {
  i.postMessage({
    action: e
  }), Uf(i);
}, $f = (i, e) => {
  if (!e.currentTransmux) {
    e.currentTransmux = i, Ec(e, i);
    return;
  }
  e.transmuxQueue.push(Ec.bind(null, e, i));
}, Zv = (i) => {
  $f("reset", i);
}, e2 = (i) => {
  $f("endTimeline", i);
}, qf = (i) => {
  if (!i.transmuxer.currentTransmux) {
    i.transmuxer.currentTransmux = i, Ff(i);
    return;
  }
  i.transmuxer.transmuxQueue.push(i);
}, t2 = (i) => {
  const e = new Kv();
  e.currentTransmux = null, e.transmuxQueue = [];
  const t = e.terminate;
  return e.terminate = () => (e.currentTransmux = null, e.transmuxQueue.length = 0, t.call(e)), e.postMessage({
    action: "init",
    options: i
  }), e;
};
var La = {
  reset: Zv,
  endTimeline: e2,
  transmux: qf,
  createTransmuxer: t2
};
const $s = function(i) {
  const e = i.transmuxer, t = i.endAction || i.action, s = i.callback, r = ye({}, i, {
    endAction: null,
    transmuxer: null,
    callback: null
  }), n = (a) => {
    a.data.action === t && (e.removeEventListener("message", n), a.data.data && (a.data.data = new Uint8Array(a.data.data, i.byteOffset || 0, i.byteLength || a.data.data.byteLength), i.data && (i.data = a.data.data)), s(a.data));
  };
  if (e.addEventListener("message", n), i.data) {
    const a = i.data instanceof ArrayBuffer;
    r.byteOffset = a ? 0 : i.data.byteOffset, r.byteLength = i.data.byteLength;
    const o = [a ? i.data : i.data.buffer];
    e.postMessage(r, o);
  } else
    e.postMessage(r);
}, vt = {
  FAILURE: 2,
  TIMEOUT: -101,
  ABORTED: -102
}, no = (i) => {
  i.forEach((e) => {
    e.abort();
  });
}, i2 = (i) => ({
  bandwidth: i.bandwidth,
  bytesReceived: i.bytesReceived || 0,
  roundTripTime: i.roundTripTime || 0
}), s2 = (i) => {
  const e = i.target, s = {
    bandwidth: 1 / 0,
    bytesReceived: 0,
    roundTripTime: Date.now() - e.requestTime || 0
  };
  return s.bytesReceived = i.loaded, s.bandwidth = Math.floor(s.bytesReceived / s.roundTripTime * 8 * 1e3), s;
}, du = (i, e) => {
  const {
    requestType: t
  } = e, s = gi({
    requestType: t,
    request: e,
    error: i
  });
  return e.timedout ? {
    status: e.status,
    message: "HLS request timed-out at URL: " + e.uri,
    code: vt.TIMEOUT,
    xhr: e,
    metadata: s
  } : e.aborted ? {
    status: e.status,
    message: "HLS request aborted at URL: " + e.uri,
    code: vt.ABORTED,
    xhr: e,
    metadata: s
  } : i ? {
    status: e.status,
    message: "HLS request errored at URL: " + e.uri,
    code: vt.FAILURE,
    xhr: e,
    metadata: s
  } : e.responseType === "arraybuffer" && e.response.byteLength === 0 ? {
    status: e.status,
    message: "Empty HLS response at URL: " + e.uri,
    code: vt.FAILURE,
    xhr: e,
    metadata: s
  } : null;
}, Cc = (i, e, t, s) => (r, n) => {
  const a = n.response, o = du(r, n);
  if (o)
    return t(o, i);
  if (a.byteLength !== 16)
    return t({
      status: n.status,
      message: "Invalid HLS key at URL: " + n.uri,
      code: vt.FAILURE,
      xhr: n
    }, i);
  const l = new DataView(a), h = new Uint32Array([l.getUint32(0), l.getUint32(4), l.getUint32(8), l.getUint32(12)]);
  for (let _ = 0; _ < e.length; _++)
    e[_].bytes = h;
  const m = {
    uri: n.uri
  };
  return s({
    type: "segmentkeyloadcomplete",
    segment: i,
    keyInfo: m
  }), t(null, i);
}, jf = (i, e) => {
  const t = ko(i.map.bytes);
  if (t !== "mp4") {
    const s = i.map.resolvedUri || i.map.uri, r = t || "unknown";
    return e({
      internal: !0,
      message: `Found unsupported ${r} container for initialization segment at URL: ${s}`,
      code: vt.FAILURE,
      metadata: {
        mediaType: r
      }
    });
  }
  $s({
    action: "probeMp4Tracks",
    data: i.map.bytes,
    transmuxer: i.transmuxer,
    callback: ({
      tracks: s,
      data: r
    }) => (i.map.bytes = r, s.forEach(function(n) {
      i.map.tracks = i.map.tracks || {}, !i.map.tracks[n.type] && (i.map.tracks[n.type] = n, typeof n.id == "number" && n.timescale && (i.map.timescales = i.map.timescales || {}, i.map.timescales[n.id] = n.timescale));
    }), e(null))
  });
}, r2 = ({
  segment: i,
  finishProcessingFn: e,
  triggerSegmentEventFn: t
}) => (s, r) => {
  const n = du(s, r);
  if (n)
    return e(n, i);
  const a = new Uint8Array(r.response);
  if (t({
    type: "segmentloaded",
    segment: i
  }), i.map.key)
    return i.map.encryptedBytes = a, e(null, i);
  i.map.bytes = a, jf(i, function(o) {
    if (o)
      return o.xhr = r, o.status = r.status, e(o, i);
    e(null, i);
  });
}, n2 = ({
  segment: i,
  finishProcessingFn: e,
  responseType: t,
  triggerSegmentEventFn: s
}) => (r, n) => {
  const a = du(r, n);
  if (a)
    return e(a, i);
  s({
    type: "segmentloaded",
    segment: i
  });
  const o = (
    // although responseText "should" exist, this guard serves to prevent an error being
    // thrown for two primary cases:
    // 1. the mime type override stops working, or is not implemented for a specific
    //    browser
    // 2. when using mock XHR libraries like sinon that do not allow the override behavior
    t === "arraybuffer" || !n.responseText ? n.response : Gv(n.responseText.substring(i.lastReachedChar || 0))
  );
  return i.stats = i2(n), i.key ? i.encryptedBytes = new Uint8Array(o) : i.bytes = new Uint8Array(o), e(null, i);
}, a2 = ({
  segment: i,
  bytes: e,
  trackInfoFn: t,
  timingInfoFn: s,
  videoSegmentTimingInfoFn: r,
  audioSegmentTimingInfoFn: n,
  id3Fn: a,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: h,
  dataFn: m,
  doneFn: _,
  onTransmuxerLog: v,
  triggerSegmentEventFn: C
}) => {
  const A = i.map && i.map.tracks || {}, y = !!(A.audio && A.video);
  let D = s.bind(null, i, "audio", "start");
  const w = s.bind(null, i, "audio", "end");
  let O = s.bind(null, i, "video", "start");
  const P = s.bind(null, i, "video", "end"), R = () => qf({
    bytes: e,
    transmuxer: i.transmuxer,
    audioAppendStart: i.audioAppendStart,
    gopsToAlignWith: i.gopsToAlignWith,
    remux: y,
    onData: (I) => {
      I.type = I.type === "combined" ? "video" : I.type, m(i, I);
    },
    onTrackInfo: (I) => {
      t && (y && (I.isMuxed = !0), t(i, I));
    },
    onAudioTimingInfo: (I) => {
      D && typeof I.start < "u" && (D(I.start), D = null), w && typeof I.end < "u" && w(I.end);
    },
    onVideoTimingInfo: (I) => {
      O && typeof I.start < "u" && (O(I.start), O = null), P && typeof I.end < "u" && P(I.end);
    },
    onVideoSegmentTimingInfo: (I) => {
      const B = {
        pts: {
          start: I.start.presentation,
          end: I.end.presentation
        },
        dts: {
          start: I.start.decode,
          end: I.end.decode
        }
      };
      C({
        type: "segmenttransmuxingtiminginfoavailable",
        segment: i,
        timingInfo: B
      }), r(I);
    },
    onAudioSegmentTimingInfo: (I) => {
      const B = {
        pts: {
          start: I.start.pts,
          end: I.end.pts
        },
        dts: {
          start: I.start.dts,
          end: I.end.dts
        }
      };
      C({
        type: "segmenttransmuxingtiminginfoavailable",
        segment: i,
        timingInfo: B
      }), n(I);
    },
    onId3: (I, B) => {
      a(i, I, B);
    },
    onCaptions: (I) => {
      o(i, [I]);
    },
    isEndOfTimeline: l,
    onEndedTimeline: () => {
      h();
    },
    onTransmuxerLog: v,
    onDone: (I, B) => {
      _ && (I.type = I.type === "combined" ? "video" : I.type, C({
        type: "segmenttransmuxingcomplete",
        segment: i
      }), _(B, i, I));
    },
    segment: i,
    triggerSegmentEventFn: C
  });
  $s({
    action: "probeTs",
    transmuxer: i.transmuxer,
    data: e,
    baseStartTime: i.baseStartTime,
    callback: (I) => {
      i.bytes = e = I.data;
      const B = I.result;
      B && (t(i, {
        hasAudio: B.hasAudio,
        hasVideo: B.hasVideo,
        isMuxed: y
      }), t = null), R();
    }
  });
}, Hf = ({
  segment: i,
  bytes: e,
  trackInfoFn: t,
  timingInfoFn: s,
  videoSegmentTimingInfoFn: r,
  audioSegmentTimingInfoFn: n,
  id3Fn: a,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: h,
  dataFn: m,
  doneFn: _,
  onTransmuxerLog: v,
  triggerSegmentEventFn: C
}) => {
  let A = new Uint8Array(e);
  if (ky(A)) {
    i.isFmp4 = !0;
    const {
      tracks: y
    } = i.map, D = {
      isFmp4: !0,
      hasVideo: !!y.video,
      hasAudio: !!y.audio
    };
    y.audio && y.audio.codec && y.audio.codec !== "enca" && (D.audioCodec = y.audio.codec), y.video && y.video.codec && y.video.codec !== "encv" && (D.videoCodec = y.video.codec), y.video && y.audio && (D.isMuxed = !0), t(i, D);
    const w = (O, P) => {
      m(i, {
        data: A,
        type: D.hasAudio && !D.isMuxed ? "audio" : "video"
      }), P && P.length && a(i, P), O && O.length && o(i, O), _(null, i, {});
    };
    $s({
      action: "probeMp4StartTime",
      timescales: i.map.timescales,
      data: A,
      transmuxer: i.transmuxer,
      callback: ({
        data: O,
        startTime: P
      }) => {
        e = O.buffer, i.bytes = A = O, D.hasAudio && !D.isMuxed && s(i, "audio", "start", P), D.hasVideo && s(i, "video", "start", P), $s({
          action: "probeEmsgID3",
          data: A,
          transmuxer: i.transmuxer,
          offset: P,
          callback: ({
            emsgData: R,
            id3Frames: I
          }) => {
            if (e = R.buffer, i.bytes = A = R, !y.video || !R.byteLength || !i.transmuxer) {
              w(void 0, I);
              return;
            }
            $s({
              action: "pushMp4Captions",
              endAction: "mp4Captions",
              transmuxer: i.transmuxer,
              data: A,
              timescales: i.map.timescales,
              trackIds: [y.video.id],
              callback: (B) => {
                e = B.data.buffer, i.bytes = A = B.data, B.logs.forEach(function(H) {
                  v(te(H, {
                    stream: "mp4CaptionParser"
                  }));
                }), w(B.captions, I);
              }
            });
          }
        });
      }
    });
    return;
  }
  if (!i.transmuxer) {
    _(null, i, {});
    return;
  }
  if (typeof i.container > "u" && (i.container = ko(A)), i.container !== "ts" && i.container !== "aac") {
    t(i, {
      hasAudio: !1,
      hasVideo: !1
    }), _(null, i, {});
    return;
  }
  a2({
    segment: i,
    bytes: e,
    trackInfoFn: t,
    timingInfoFn: s,
    videoSegmentTimingInfoFn: r,
    audioSegmentTimingInfoFn: n,
    id3Fn: a,
    captionsFn: o,
    isEndOfTimeline: l,
    endedTimelineFn: h,
    dataFn: m,
    doneFn: _,
    onTransmuxerLog: v,
    triggerSegmentEventFn: C
  });
}, Vf = function({
  id: i,
  key: e,
  encryptedBytes: t,
  decryptionWorker: s,
  segment: r,
  doneFn: n
}, a) {
  const o = (h) => {
    if (h.data.source === i) {
      s.removeEventListener("message", o);
      const m = h.data.decrypted;
      a(new Uint8Array(m.bytes, m.byteOffset, m.byteLength));
    }
  };
  s.onerror = () => {
    const h = "An error occurred in the decryption worker", m = li({
      segment: r
    }), _ = {
      message: h,
      metadata: {
        error: new Error(h),
        errorType: L.Error.StreamingFailedToDecryptSegment,
        segmentInfo: m,
        keyInfo: {
          uri: r.key.resolvedUri || r.map.key.resolvedUri
        }
      }
    };
    n(_, r);
  }, s.addEventListener("message", o);
  let l;
  e.bytes.slice ? l = e.bytes.slice() : l = new Uint32Array(Array.prototype.slice.call(e.bytes)), s.postMessage(If({
    source: i,
    encrypted: t,
    key: l,
    iv: e.iv
  }), [t.buffer, l.buffer]);
}, o2 = ({
  decryptionWorker: i,
  segment: e,
  trackInfoFn: t,
  timingInfoFn: s,
  videoSegmentTimingInfoFn: r,
  audioSegmentTimingInfoFn: n,
  id3Fn: a,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: h,
  dataFn: m,
  doneFn: _,
  onTransmuxerLog: v,
  triggerSegmentEventFn: C
}) => {
  C({
    type: "segmentdecryptionstart"
  }), Vf({
    id: e.requestId,
    key: e.key,
    encryptedBytes: e.encryptedBytes,
    decryptionWorker: i,
    segment: e,
    doneFn: _
  }, (A) => {
    e.bytes = A, C({
      type: "segmentdecryptioncomplete",
      segment: e
    }), Hf({
      segment: e,
      bytes: e.bytes,
      trackInfoFn: t,
      timingInfoFn: s,
      videoSegmentTimingInfoFn: r,
      audioSegmentTimingInfoFn: n,
      id3Fn: a,
      captionsFn: o,
      isEndOfTimeline: l,
      endedTimelineFn: h,
      dataFn: m,
      doneFn: _,
      onTransmuxerLog: v,
      triggerSegmentEventFn: C
    });
  });
}, u2 = ({
  activeXhrs: i,
  decryptionWorker: e,
  trackInfoFn: t,
  timingInfoFn: s,
  videoSegmentTimingInfoFn: r,
  audioSegmentTimingInfoFn: n,
  id3Fn: a,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: h,
  dataFn: m,
  doneFn: _,
  onTransmuxerLog: v,
  triggerSegmentEventFn: C
}) => {
  let A = 0, y = !1;
  return (D, w) => {
    if (!y) {
      if (D)
        return y = !0, no(i), _(D, w);
      if (A += 1, A === i.length) {
        const O = function() {
          if (w.encryptedBytes)
            return o2({
              decryptionWorker: e,
              segment: w,
              trackInfoFn: t,
              timingInfoFn: s,
              videoSegmentTimingInfoFn: r,
              audioSegmentTimingInfoFn: n,
              id3Fn: a,
              captionsFn: o,
              isEndOfTimeline: l,
              endedTimelineFn: h,
              dataFn: m,
              doneFn: _,
              onTransmuxerLog: v,
              triggerSegmentEventFn: C
            });
          Hf({
            segment: w,
            bytes: w.bytes,
            trackInfoFn: t,
            timingInfoFn: s,
            videoSegmentTimingInfoFn: r,
            audioSegmentTimingInfoFn: n,
            id3Fn: a,
            captionsFn: o,
            isEndOfTimeline: l,
            endedTimelineFn: h,
            dataFn: m,
            doneFn: _,
            onTransmuxerLog: v,
            triggerSegmentEventFn: C
          });
        };
        if (w.endOfAllRequests = Date.now(), w.map && w.map.encryptedBytes && !w.map.bytes)
          return C({
            type: "segmentdecryptionstart",
            segment: w
          }), Vf({
            decryptionWorker: e,
            // add -init to the "id" to differentiate between segment
            // and init segment decryption, just in case they happen
            // at the same time at some point in the future.
            id: w.requestId + "-init",
            encryptedBytes: w.map.encryptedBytes,
            key: w.map.key,
            segment: w,
            doneFn: _
          }, (P) => {
            w.map.bytes = P, C({
              type: "segmentdecryptioncomplete",
              segment: w
            }), jf(w, (R) => {
              if (R)
                return no(i), _(R, w);
              O();
            });
          });
        O();
      }
    }
  };
}, l2 = ({
  loadendState: i,
  abortFn: e
}) => (t) => {
  t.target.aborted && e && !i.calledAbortFn && (e(), i.calledAbortFn = !0);
}, c2 = ({
  segment: i,
  progressFn: e,
  trackInfoFn: t,
  timingInfoFn: s,
  videoSegmentTimingInfoFn: r,
  audioSegmentTimingInfoFn: n,
  id3Fn: a,
  captionsFn: o,
  isEndOfTimeline: l,
  endedTimelineFn: h,
  dataFn: m
}) => (_) => {
  if (!_.target.aborted)
    return i.stats = te(i.stats, s2(_)), !i.stats.firstBytesReceivedAt && i.stats.bytesReceived && (i.stats.firstBytesReceivedAt = Date.now()), e(_, i);
}, d2 = ({
  xhr: i,
  xhrOptions: e,
  decryptionWorker: t,
  segment: s,
  abortFn: r,
  progressFn: n,
  trackInfoFn: a,
  timingInfoFn: o,
  videoSegmentTimingInfoFn: l,
  audioSegmentTimingInfoFn: h,
  id3Fn: m,
  captionsFn: _,
  isEndOfTimeline: v,
  endedTimelineFn: C,
  dataFn: A,
  doneFn: y,
  onTransmuxerLog: D,
  triggerSegmentEventFn: w
}) => {
  const O = [], P = u2({
    activeXhrs: O,
    decryptionWorker: t,
    trackInfoFn: a,
    timingInfoFn: o,
    videoSegmentTimingInfoFn: l,
    audioSegmentTimingInfoFn: h,
    id3Fn: m,
    captionsFn: _,
    isEndOfTimeline: v,
    endedTimelineFn: C,
    dataFn: A,
    doneFn: y,
    onTransmuxerLog: D,
    triggerSegmentEventFn: w
  });
  if (s.key && !s.key.bytes) {
    const $ = [s.key];
    s.map && !s.map.bytes && s.map.key && s.map.key.resolvedUri === s.key.resolvedUri && $.push(s.map.key);
    const X = te(e, {
      uri: s.key.resolvedUri,
      responseType: "arraybuffer",
      requestType: "segment-key"
    }), ue = Cc(s, $, P, w), J = {
      uri: s.key.resolvedUri
    };
    w({
      type: "segmentkeyloadstart",
      segment: s,
      keyInfo: J
    });
    const ne = i(X, ue);
    O.push(ne);
  }
  if (s.map && !s.map.bytes) {
    if (s.map.key && (!s.key || s.key.resolvedUri !== s.map.key.resolvedUri)) {
      const ne = te(e, {
        uri: s.map.key.resolvedUri,
        responseType: "arraybuffer",
        requestType: "segment-key"
      }), V = Cc(s, [s.map.key], P, w), Z = {
        uri: s.map.key.resolvedUri
      };
      w({
        type: "segmentkeyloadstart",
        segment: s,
        keyInfo: Z
      });
      const Re = i(ne, V);
      O.push(Re);
    }
    const X = te(e, {
      uri: s.map.resolvedUri,
      responseType: "arraybuffer",
      headers: so(s.map),
      requestType: "segment-media-initialization"
    }), ue = r2({
      segment: s,
      finishProcessingFn: P,
      triggerSegmentEventFn: w
    });
    w({
      type: "segmentloadstart",
      segment: s
    });
    const J = i(X, ue);
    O.push(J);
  }
  const R = te(e, {
    uri: s.part && s.part.resolvedUri || s.resolvedUri,
    responseType: "arraybuffer",
    headers: so(s),
    requestType: "segment"
  }), I = n2({
    segment: s,
    finishProcessingFn: P,
    responseType: R.responseType,
    triggerSegmentEventFn: w
  });
  w({
    type: "segmentloadstart",
    segment: s
  });
  const B = i(R, I);
  B.addEventListener("progress", c2({
    segment: s,
    progressFn: n,
    trackInfoFn: a,
    timingInfoFn: o,
    videoSegmentTimingInfoFn: l,
    audioSegmentTimingInfoFn: h,
    id3Fn: m,
    captionsFn: _,
    isEndOfTimeline: v,
    endedTimelineFn: C,
    dataFn: A
  })), O.push(B);
  const H = {};
  return O.forEach(($) => {
    $.addEventListener("loadend", l2({
      loadendState: H,
      abortFn: r
    }));
  }), () => no(O);
}, h2 = ot("CodecUtils"), f2 = function(i) {
  const e = i.attributes || {};
  if (e.CODECS)
    return mt(e.CODECS);
}, zf = (i, e) => {
  const t = e.attributes || {};
  return i && i.mediaGroups && i.mediaGroups.AUDIO && t.AUDIO && i.mediaGroups.AUDIO[t.AUDIO];
}, p2 = (i, e) => {
  if (!zf(i, e))
    return !0;
  const t = e.attributes || {}, s = i.mediaGroups.AUDIO[t.AUDIO];
  for (const r in s)
    if (!s[r].uri && !s[r].playlists)
      return !0;
  return !1;
}, pn = function(i) {
  const e = {};
  return i.forEach(({
    mediaType: t,
    type: s,
    details: r
  }) => {
    e[t] = e[t] || [], e[t].push(Jc(`${s}${r}`));
  }), Object.keys(e).forEach(function(t) {
    if (e[t].length > 1) {
      h2(`multiple ${t} codecs found as attributes: ${e[t].join(", ")}. Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.`), e[t] = null;
      return;
    }
    e[t] = e[t][0];
  }), e;
}, Ac = function(i) {
  let e = 0;
  return i.audio && e++, i.video && e++, e;
}, qs = function(i, e) {
  const t = e.attributes || {}, s = pn(f2(e) || []);
  if (zf(i, e) && !s.audio && !p2(i, e)) {
    const r = pn(O0(i, t.AUDIO) || []);
    r.audio && (s.audio = r.audio);
  }
  return s;
}, Fr = ot("PlaylistSelector"), Dc = function(i) {
  if (!i || !i.playlist)
    return;
  const e = i.playlist;
  return JSON.stringify({
    id: e.id,
    bandwidth: i.bandwidth,
    width: i.width,
    height: i.height,
    codecs: e.attributes && e.attributes.CODECS || ""
  });
}, mn = function(i, e) {
  if (!i)
    return "";
  const t = S.getComputedStyle(i);
  return t ? t[e] : "";
}, $i = function(i, e) {
  const t = i.slice();
  i.sort(function(s, r) {
    const n = e(s, r);
    return n === 0 ? t.indexOf(s) - t.indexOf(r) : n;
  });
}, hu = function(i, e) {
  let t, s;
  return i.attributes.BANDWIDTH && (t = i.attributes.BANDWIDTH), t = t || S.Number.MAX_VALUE, e.attributes.BANDWIDTH && (s = e.attributes.BANDWIDTH), s = s || S.Number.MAX_VALUE, t - s;
}, m2 = function(i, e) {
  let t, s;
  return i.attributes.RESOLUTION && i.attributes.RESOLUTION.width && (t = i.attributes.RESOLUTION.width), t = t || S.Number.MAX_VALUE, e.attributes.RESOLUTION && e.attributes.RESOLUTION.width && (s = e.attributes.RESOLUTION.width), s = s || S.Number.MAX_VALUE, t === s && i.attributes.BANDWIDTH && e.attributes.BANDWIDTH ? i.attributes.BANDWIDTH - e.attributes.BANDWIDTH : t - s;
};
let Gf = function(i, e, t, s, r, n) {
  if (!i)
    return;
  const a = {
    bandwidth: e,
    width: t,
    height: s,
    limitRenditionByPlayerDimensions: r
  };
  let o = i.playlists;
  We.isAudioOnly(i) && (o = n.getAudioTrackPlaylists_(), a.audioOnly = !0);
  let l = o.map((I) => {
    let B;
    const H = I.attributes && I.attributes.RESOLUTION && I.attributes.RESOLUTION.width, $ = I.attributes && I.attributes.RESOLUTION && I.attributes.RESOLUTION.height;
    return B = I.attributes && I.attributes.BANDWIDTH, B = B || S.Number.MAX_VALUE, {
      bandwidth: B,
      width: H,
      height: $,
      playlist: I
    };
  });
  $i(l, (I, B) => I.bandwidth - B.bandwidth), l = l.filter((I) => !We.isIncompatible(I.playlist));
  let h = l.filter((I) => We.isEnabled(I.playlist));
  h.length || (h = l.filter((I) => !We.isDisabled(I.playlist)));
  const m = h.filter((I) => I.bandwidth * Ae.BANDWIDTH_VARIANCE < e);
  let _ = m[m.length - 1];
  const v = m.filter((I) => I.bandwidth === _.bandwidth)[0];
  if (r === !1) {
    const I = v || h[0] || l[0];
    if (I && I.playlist) {
      let B = "sortedPlaylistReps";
      return v && (B = "bandwidthBestRep"), h[0] && (B = "enabledPlaylistReps"), Fr(`choosing ${Dc(I)} using ${B} with options`, a), I.playlist;
    }
    return Fr("could not choose a playlist with options", a), null;
  }
  const C = m.filter((I) => I.width && I.height);
  $i(C, (I, B) => I.width - B.width);
  const A = C.filter((I) => I.width === t && I.height === s);
  _ = A[A.length - 1];
  const y = A.filter((I) => I.bandwidth === _.bandwidth)[0];
  let D, w, O;
  y || (D = C.filter((I) => I.width > t || I.height > s), w = D.filter((I) => I.width === D[0].width && I.height === D[0].height), _ = w[w.length - 1], O = w.filter((I) => I.bandwidth === _.bandwidth)[0]);
  let P;
  if (n.leastPixelDiffSelector) {
    const I = C.map((B) => (B.pixelDiff = Math.abs(B.width - t) + Math.abs(B.height - s), B));
    $i(I, (B, H) => B.pixelDiff === H.pixelDiff ? H.bandwidth - B.bandwidth : B.pixelDiff - H.pixelDiff), P = I[0];
  }
  const R = P || O || y || v || h[0] || l[0];
  if (R && R.playlist) {
    let I = "sortedPlaylistReps";
    return P ? I = "leastPixelDiffRep" : O ? I = "resolutionPlusOneRep" : y ? I = "resolutionBestRep" : v ? I = "bandwidthBestRep" : h[0] && (I = "enabledPlaylistReps"), Fr(`choosing ${Dc(R)} using ${I} with options`, a), R.playlist;
  }
  return Fr("could not choose a playlist with options", a), null;
};
const wc = function() {
  let i = this.useDevicePixelRatio && S.devicePixelRatio || 1;
  return isNaN(this.customPixelRatio) || (i = this.customPixelRatio), Gf(this.playlists.main, this.systemBandwidth, parseInt(mn(this.tech_.el(), "width"), 10) * i, parseInt(mn(this.tech_.el(), "height"), 10) * i, this.limitRenditionByPlayerDimensions, this.playlistController_);
}, g2 = function(i) {
  let e = -1, t = -1;
  if (i < 0 || i > 1)
    throw new Error("Moving average bandwidth decay must be between 0 and 1.");
  return function() {
    let s = this.useDevicePixelRatio && S.devicePixelRatio || 1;
    return isNaN(this.customPixelRatio) || (s = this.customPixelRatio), e < 0 && (e = this.systemBandwidth, t = this.systemBandwidth), this.systemBandwidth > 0 && this.systemBandwidth !== t && (e = i * this.systemBandwidth + (1 - i) * e, t = this.systemBandwidth), Gf(this.playlists.main, e, parseInt(mn(this.tech_.el(), "width"), 10) * s, parseInt(mn(this.tech_.el(), "height"), 10) * s, this.limitRenditionByPlayerDimensions, this.playlistController_);
  };
}, _2 = function(i) {
  const {
    main: e,
    currentTime: t,
    bandwidth: s,
    duration: r,
    segmentDuration: n,
    timeUntilRebuffer: a,
    currentTimeline: o,
    syncController: l
  } = i, h = e.playlists.filter((A) => !We.isIncompatible(A));
  let m = h.filter(We.isEnabled);
  m.length || (m = h.filter((A) => !We.isDisabled(A)));
  const v = m.filter(We.hasAttribute.bind(null, "BANDWIDTH")).map((A) => {
    const D = l.getSyncPoint(A, r, o, t) ? 1 : 2, O = We.estimateSegmentRequestTime(n, s, A) * D - a;
    return {
      playlist: A,
      rebufferingImpact: O
    };
  }), C = v.filter((A) => A.rebufferingImpact <= 0);
  return $i(C, (A, y) => hu(y.playlist, A.playlist)), C.length ? C[0] : ($i(v, (A, y) => A.rebufferingImpact - y.rebufferingImpact), v[0] || null);
}, y2 = function() {
  const i = this.playlists.main.playlists.filter(We.isEnabled);
  return $i(i, (t, s) => hu(t, s)), i.filter((t) => !!qs(this.playlists.main, t).video)[0] || null;
}, T2 = (i) => {
  let e = 0, t;
  return i.bytes && (t = new Uint8Array(i.bytes), i.segments.forEach((s) => {
    t.set(s, e), e += s.byteLength;
  })), t;
};
function Wf(i) {
  try {
    return new URL(i).pathname.split("/").slice(-2).join("/");
  } catch {
    return "";
  }
}
const v2 = function(i, e, t) {
  if (!i[t]) {
    e.trigger({
      type: "usage",
      name: "vhs-608"
    });
    let s = t;
    /^cc708_/.test(t) && (s = "SERVICE" + t.split("_")[1]);
    const r = e.textTracks().getTrackById(s);
    if (r)
      i[t] = r;
    else {
      const n = e.options_.vhs && e.options_.vhs.captionServices || {};
      let a = t, o = t, l = !1;
      const h = n[s];
      h && (a = h.label, o = h.language, l = h.default), i[t] = e.addRemoteTextTrack({
        kind: "captions",
        id: s,
        // TODO: investigate why this doesn't seem to turn the caption on by default
        default: l,
        label: a,
        language: o
      }, !1).track;
    }
  }
}, b2 = function({
  inbandTextTracks: i,
  captionArray: e,
  timestampOffset: t
}) {
  if (!e)
    return;
  const s = S.WebKitDataCue || S.VTTCue;
  e.forEach((r) => {
    const n = r.stream;
    r.content ? r.content.forEach((a) => {
      const o = new s(r.startTime + t, r.endTime + t, a.text);
      o.line = a.line, o.align = "left", o.position = a.position, o.positionAlign = "line-left", i[n].addCue(o);
    }) : i[n].addCue(new s(r.startTime + t, r.endTime + t, r.text));
  });
}, x2 = function(i) {
  Object.defineProperties(i.frame, {
    id: {
      get() {
        return L.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), i.value.key;
      }
    },
    value: {
      get() {
        return L.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), i.value.data;
      }
    },
    privateData: {
      get() {
        return L.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), i.value.data;
      }
    }
  });
}, S2 = ({
  inbandTextTracks: i,
  metadataArray: e,
  timestampOffset: t,
  videoDuration: s
}) => {
  if (!e)
    return;
  const r = S.WebKitDataCue || S.VTTCue, n = i.metadataTrack_;
  if (!n || (e.forEach((m) => {
    const _ = m.cueTime + t;
    typeof _ != "number" || S.isNaN(_) || _ < 0 || !(_ < 1 / 0) || !m.frames || !m.frames.length || m.frames.forEach((v) => {
      const C = new r(_, _, v.value || v.url || v.data || "");
      C.frame = v, C.value = v, x2(C), n.addCue(C);
    });
  }), !n.cues || !n.cues.length))
    return;
  const a = n.cues, o = [];
  for (let m = 0; m < a.length; m++)
    a[m] && o.push(a[m]);
  const l = o.reduce((m, _) => {
    const v = m[_.startTime] || [];
    return v.push(_), m[_.startTime] = v, m;
  }, {}), h = Object.keys(l).sort((m, _) => Number(m) - Number(_));
  h.forEach((m, _) => {
    const v = l[m], C = isFinite(s) ? s : m, A = Number(h[_ + 1]) || C;
    v.forEach((y) => {
      y.endTime = A;
    });
  });
}, E2 = {
  id: "ID",
  class: "CLASS",
  startDate: "START-DATE",
  duration: "DURATION",
  endDate: "END-DATE",
  endOnNext: "END-ON-NEXT",
  plannedDuration: "PLANNED-DURATION",
  scte35Out: "SCTE35-OUT",
  scte35In: "SCTE35-IN"
}, C2 = /* @__PURE__ */ new Set(["id", "class", "startDate", "duration", "endDate", "endOnNext", "startTime", "endTime", "processDateRange"]), A2 = ({
  inbandTextTracks: i,
  dateRanges: e
}) => {
  const t = i.metadataTrack_;
  if (!t)
    return;
  const s = S.WebKitDataCue || S.VTTCue;
  e.forEach((r) => {
    for (const n of Object.keys(r)) {
      if (C2.has(n))
        continue;
      const a = new s(r.startTime, r.endTime, "");
      a.id = r.id, a.type = "com.apple.quicktime.HLS", a.value = {
        key: E2[n],
        data: r[n]
      }, (n === "scte35Out" || n === "scte35In") && (a.value.data = new Uint8Array(a.value.data.match(/[\da-f]{2}/gi)).buffer), t.addCue(a);
    }
    r.processDateRange();
  });
}, Ic = (i, e, t) => {
  i.metadataTrack_ || (i.metadataTrack_ = t.addRemoteTextTrack({
    kind: "metadata",
    label: "Timed Metadata"
  }, !1).track, L.browser.IS_ANY_SAFARI || (i.metadataTrack_.inBandMetadataTrackDispatchType = e));
}, Ls = function(i, e, t) {
  let s, r;
  if (t && t.cues)
    for (s = t.cues.length; s--; )
      r = t.cues[s], r.startTime >= i && r.endTime <= e && t.removeCue(r);
}, D2 = function(i) {
  const e = i.cues;
  if (!e)
    return;
  const t = {};
  for (let s = e.length - 1; s >= 0; s--) {
    const r = e[s], n = `${r.startTime}-${r.endTime}-${r.text}`;
    t[n] ? i.removeCue(r) : t[n] = r;
  }
}, w2 = (i, e, t) => {
  if (typeof e > "u" || e === null || !i.length)
    return [];
  const s = Math.ceil((e - t + 3) * ci.ONE_SECOND_IN_TS);
  let r;
  for (r = 0; r < i.length && !(i[r].pts > s); r++)
    ;
  return i.slice(r);
}, I2 = (i, e, t) => {
  if (!e.length)
    return i;
  if (t)
    return e.slice();
  const s = e[0].pts;
  let r = 0;
  for (r; r < i.length && !(i[r].pts >= s); r++)
    ;
  return i.slice(0, r).concat(e);
}, k2 = (i, e, t, s) => {
  const r = Math.ceil((e - s) * ci.ONE_SECOND_IN_TS), n = Math.ceil((t - s) * ci.ONE_SECOND_IN_TS), a = i.slice();
  let o = i.length;
  for (; o-- && !(i[o].pts <= n); )
    ;
  if (o === -1)
    return a;
  let l = o + 1;
  for (; l-- && !(i[l].pts <= r); )
    ;
  return l = Math.max(l, 0), a.splice(l, o - l + 1), a;
}, P2 = function(i, e) {
  if (!i && !e || !i && e || i && !e)
    return !1;
  if (i === e)
    return !0;
  const t = Object.keys(i).sort(), s = Object.keys(e).sort();
  if (t.length !== s.length)
    return !1;
  for (let r = 0; r < t.length; r++) {
    const n = t[r];
    if (n !== s[r] || i[n] !== e[n])
      return !1;
  }
  return !0;
}, O2 = function(i, e, t) {
  e = e || [];
  const s = [];
  let r = 0;
  for (let n = 0; n < e.length; n++) {
    const a = e[n];
    if (i === a.timeline && (s.push(n), r += a.duration, r > t))
      return n;
  }
  return s.length === 0 ? 0 : s[s.length - 1];
}, Ds = 1, L2 = 500, kc = (i) => typeof i == "number" && isFinite(i), Ur = 1 / 60, R2 = (i, e, t) => i !== "main" || !e || !t ? null : !t.hasAudio && !t.hasVideo ? "Neither audio nor video found in segment." : e.hasVideo && !t.hasVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !e.hasVideo && t.hasVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null, N2 = (i, e, t) => {
  let s = e - Ae.BACK_BUFFER_LENGTH;
  i.length && (s = Math.max(s, i.start(0)));
  const r = e - t;
  return Math.min(r, s);
}, ki = (i) => {
  const {
    startOfSegment: e,
    duration: t,
    segment: s,
    part: r,
    playlist: {
      mediaSequence: n,
      id: a,
      segments: o = []
    },
    mediaIndex: l,
    partIndex: h,
    timeline: m
  } = i, _ = o.length - 1;
  let v = "mediaIndex/partIndex increment";
  i.getMediaInfoForTime ? v = `getMediaInfoForTime (${i.getMediaInfoForTime})` : i.isSyncRequest && (v = "getSyncSegmentCandidate (isSyncRequest)"), i.independent && (v += ` with independent ${i.independent}`);
  const C = typeof h == "number", A = i.segment.uri ? "segment" : "pre-segment", y = C ? ff({
    preloadSegment: s
  }) - 1 : 0;
  return `${A} [${n + l}/${n + _}]` + (C ? ` part [${h}/${y}]` : "") + ` segment start/end [${s.start} => ${s.end}]` + (C ? ` part start/end [${r.start} => ${r.end}]` : "") + ` startOfSegment [${e}] duration [${t}] timeline [${m}] selected by [${v}] playlist [${a}]`;
}, Pc = (i) => `${i}TimingInfo`, M2 = ({
  segmentTimeline: i,
  currentTimeline: e,
  startOfSegment: t,
  buffered: s,
  overrideCheck: r
}) => !r && i === e ? null : i < e ? t : s.length ? s.end(s.length - 1) : t, ao = ({
  timelineChangeController: i,
  currentTimeline: e,
  segmentTimeline: t,
  loaderType: s,
  audioDisabled: r
}) => {
  if (e === t)
    return !1;
  if (s === "audio") {
    const n = i.lastTimelineChange({
      type: "main"
    });
    return !n || n.to !== t;
  }
  if (s === "main" && r) {
    const n = i.pendingTimelineChange({
      type: "audio"
    });
    return !(n && n.to === t);
  }
  return !1;
}, B2 = (i) => {
  if (!i)
    return !1;
  const e = i.pendingTimelineChange({
    type: "audio"
  }), t = i.pendingTimelineChange({
    type: "main"
  }), s = e && t, r = s && e.to !== t.to;
  return !!(s && e.from !== -1 && t.from !== -1 && r);
}, F2 = (i) => {
  i && (i.pause(), i.resetEverything(), i.load());
}, U2 = (i) => {
  const e = i.timelineChangeController_.pendingTimelineChange({
    type: "audio"
  }), t = i.timelineChangeController_.pendingTimelineChange({
    type: "main"
  });
  return e && t && e.to < t.to;
}, zt = (i) => {
  const e = i.pendingSegment_;
  if (!e)
    return;
  if (ao({
    timelineChangeController: i.timelineChangeController_,
    currentTimeline: i.currentTimeline_,
    segmentTimeline: e.timeline,
    loaderType: i.loaderType_,
    audioDisabled: i.audioDisabled_
  }) && B2(i.timelineChangeController_)) {
    if (U2(i)) {
      i.timelineChangeController_.trigger("audioTimelineBehind");
      return;
    }
    F2(i);
  }
}, $2 = (i) => {
  let e = 0;
  return ["video", "audio"].forEach(function(t) {
    const s = i[`${t}TimingInfo`];
    if (!s)
      return;
    const {
      start: r,
      end: n
    } = s;
    let a;
    typeof r == "bigint" || typeof n == "bigint" ? a = S.BigInt(n) - S.BigInt(r) : typeof r == "number" && typeof n == "number" && (a = n - r), typeof a < "u" && a > e && (e = a);
  }), typeof e == "bigint" && e < Number.MAX_SAFE_INTEGER && (e = Number(e)), e;
}, Oc = ({
  segmentDuration: i,
  maxDuration: e
}) => i ? Math.round(i) > e + yt : !1, q2 = (i, e) => {
  if (e !== "hls")
    return null;
  const t = $2({
    audioTimingInfo: i.audioTimingInfo,
    videoTimingInfo: i.videoTimingInfo
  });
  if (!t)
    return null;
  const s = i.playlist.targetDuration, r = Oc({
    segmentDuration: t,
    maxDuration: s * 2
  }), n = Oc({
    segmentDuration: t,
    maxDuration: s
  }), a = `Segment with index ${i.mediaIndex} from playlist ${i.playlist.id} has a duration of ${t} when the reported duration is ${i.duration} and the target duration is ${s}. For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1`;
  return r || n ? {
    severity: r ? "warn" : "info",
    message: a
  } : null;
}, li = ({
  type: i,
  segment: e
}) => {
  if (!e)
    return;
  const t = !!(e.key || e.map && e.map.ke), s = !!(e.map && !e.map.bytes), r = e.startOfSegment === void 0 ? e.start : e.startOfSegment;
  return {
    type: i || e.type,
    uri: e.resolvedUri || e.uri,
    start: r,
    duration: e.duration,
    isEncrypted: t,
    isMediaInitialization: s
  };
};
class oo extends L.EventTarget {
  constructor(e, t = {}) {
    if (super(), !e)
      throw new TypeError("Initialization settings are required");
    if (typeof e.currentTime != "function")
      throw new TypeError("No currentTime getter specified");
    if (!e.mediaSource)
      throw new TypeError("No MediaSource specified");
    this.bandwidth = e.bandwidth, this.throughput = {
      rate: 0,
      count: 0
    }, this.roundTrip = NaN, this.resetStats_(), this.mediaIndex = null, this.partIndex = null, this.hasPlayed_ = e.hasPlayed, this.currentTime_ = e.currentTime, this.seekable_ = e.seekable, this.seeking_ = e.seeking, this.duration_ = e.duration, this.mediaSource_ = e.mediaSource, this.vhs_ = e.vhs, this.loaderType_ = e.loaderType, this.currentMediaInfo_ = void 0, this.startingMediaInfo_ = void 0, this.segmentMetadataTrack_ = e.segmentMetadataTrack, this.goalBufferLength_ = e.goalBufferLength, this.sourceType_ = e.sourceType, this.sourceUpdater_ = e.sourceUpdater, this.inbandTextTracks_ = e.inbandTextTracks, this.state_ = "INIT", this.timelineChangeController_ = e.timelineChangeController, this.shouldSaveSegmentTimingInfo_ = !0, this.parse708captions_ = e.parse708captions, this.useDtsForTimestampOffset_ = e.useDtsForTimestampOffset, this.captionServices_ = e.captionServices, this.exactManifestTimings = e.exactManifestTimings, this.addMetadataToTextTrack = e.addMetadataToTextTrack, this.checkBufferTimeout_ = null, this.error_ = void 0, this.currentTimeline_ = -1, this.shouldForceTimestampOffsetAfterResync_ = !1, this.pendingSegment_ = null, this.xhrOptions_ = null, this.pendingSegments_ = [], this.audioDisabled_ = !1, this.isPendingTimestampOffset_ = !1, this.gopBuffer_ = [], this.timeMapping_ = 0, this.safeAppend_ = !1, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.playlistOfLastInitSegment_ = {
      audio: null,
      video: null
    }, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_ = {
      id3: [],
      caption: []
    }, this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = null, this.activeInitSegmentId_ = null, this.initSegments_ = {}, this.cacheEncryptionKeys_ = e.cacheEncryptionKeys, this.keyCache_ = {}, this.decrypter_ = e.decrypter, this.syncController_ = e.syncController, this.syncPoint_ = {
      segmentIndex: 0,
      time: 0
    }, this.transmuxer_ = this.createTransmuxer_(), this.triggerSyncInfoUpdate_ = () => this.trigger("syncinfoupdate"), this.syncController_.on("syncinfoupdate", this.triggerSyncInfoUpdate_), this.mediaSource_.addEventListener("sourceopen", () => {
      this.isEndOfStream_() || (this.ended_ = !1);
    }), this.fetchAtBuffer_ = !1, this.logger_ = ot(`SegmentLoader[${this.loaderType_}]`), Object.defineProperty(this, "state", {
      get() {
        return this.state_;
      },
      set(s) {
        s !== this.state_ && (this.logger_(`${this.state_} -> ${s}`), this.state_ = s, this.trigger("statechange"));
      }
    }), this.sourceUpdater_.on("ready", () => {
      this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : zt(this);
    }), this.sourceUpdater_.on("codecschange", (s) => {
      this.trigger(ye({
        type: "codecschange"
      }, s));
    }), this.loaderType_ === "main" && this.timelineChangeController_.on("pendingtimelinechange", () => {
      this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : zt(this);
    }), this.loaderType_ === "audio" && this.timelineChangeController_.on("timelinechange", (s) => {
      this.trigger(ye({
        type: "timelinechange"
      }, s)), this.hasEnoughInfoToLoad_() ? this.processLoadQueue_() : zt(this), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : zt(this);
    });
  }
  /**
   * TODO: Current sync controller consists of many hls-specific strategies
   * media sequence sync is also hls-specific, and we would like to be protocol-agnostic on this level
   * this should be a part of the sync-controller and sync controller should expect different strategy list based on the protocol.
   *
   * @return {MediaSequenceSync|null}
   * @private
   */
  get mediaSequenceSync_() {
    return this.syncController_.getMediaSequenceSync(this.loaderType_);
  }
  createTransmuxer_() {
    return La.createTransmuxer({
      remux: !1,
      alignGopsAtEnd: this.safeAppend_,
      keepOriginalTimestamps: !0,
      parse708captions: this.parse708captions_,
      captionServices: this.captionServices_
    });
  }
  /**
   * reset all of our media stats
   *
   * @private
   */
  resetStats_() {
    this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0, this.mediaAppends = 0;
  }
  /**
   * dispose of the SegmentLoader and reset to the default state
   */
  dispose() {
    this.trigger("dispose"), this.state = "DISPOSED", this.pause(), this.abort_(), this.transmuxer_ && this.transmuxer_.terminate(), this.resetStats_(), this.checkBufferTimeout_ && S.clearTimeout(this.checkBufferTimeout_), this.syncController_ && this.triggerSyncInfoUpdate_ && this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_), this.off();
  }
  setAudio(e) {
    this.audioDisabled_ = !e, e ? this.appendInitSegment_.audio = !0 : this.sourceUpdater_.removeAudio(0, this.duration_());
  }
  /**
   * abort anything that is currently doing on with the SegmentLoader
   * and reset to a default state
   */
  abort() {
    if (this.state !== "WAITING") {
      this.pendingSegment_ && (this.pendingSegment_ = null);
      return;
    }
    this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_();
  }
  /**
   * abort all pending xhr requests and null any pending segements
   *
   * @private
   */
  abort_() {
    this.pendingSegment_ && this.pendingSegment_.abortRequests && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_), this.waitingOnRemove_ = !1, S.clearTimeout(this.quotaExceededErrorRetryTimeout_), this.quotaExceededErrorRetryTimeout_ = null;
  }
  checkForAbort_(e) {
    return this.state === "APPENDING" && !this.pendingSegment_ ? (this.state = "READY", !0) : !this.pendingSegment_ || this.pendingSegment_.requestId !== e;
  }
  /**
   * set an error on the segment loader and null out any pending segements
   *
   * @param {Error} error the error to set on the SegmentLoader
   * @return {Error} the error that was set or that is currently set
   */
  error(e) {
    return typeof e < "u" && (this.logger_("error occurred:", e), this.error_ = e), this.pendingSegment_ = null, this.error_;
  }
  endOfStream() {
    this.ended_ = !0, this.transmuxer_ && La.reset(this.transmuxer_), this.gopBuffer_.length = 0, this.pause(), this.trigger("ended");
  }
  /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */
  buffered_() {
    const e = this.getMediaInfo_();
    if (!this.sourceUpdater_ || !e)
      return ke();
    if (this.loaderType_ === "main") {
      const {
        hasAudio: t,
        hasVideo: s,
        isMuxed: r
      } = e;
      if (s && t && !this.audioDisabled_ && !r)
        return this.sourceUpdater_.buffered();
      if (s)
        return this.sourceUpdater_.videoBuffered();
    }
    return this.sourceUpdater_.audioBuffered();
  }
  /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */
  initSegmentForMap(e, t = !1) {
    if (!e)
      return null;
    const s = fn(e);
    let r = this.initSegments_[s];
    return t && !r && e.bytes && (this.initSegments_[s] = r = {
      resolvedUri: e.resolvedUri,
      byterange: e.byterange,
      bytes: e.bytes,
      tracks: e.tracks,
      timescales: e.timescales
    }), r || e;
  }
  /**
   * Gets and sets key for the provided key
   *
   * @param {Object} key
   *        The key object representing the key to get or set
   * @param {boolean=} set
   *        If true, the key for the provided key should be saved
   * @return {Object}
   *         Key object for desired key
   */
  segmentKey(e, t = !1) {
    if (!e)
      return null;
    const s = kf(e);
    let r = this.keyCache_[s];
    this.cacheEncryptionKeys_ && t && !r && e.bytes && (this.keyCache_[s] = r = {
      resolvedUri: e.resolvedUri,
      bytes: e.bytes
    });
    const n = {
      resolvedUri: (r || e).resolvedUri
    };
    return r && (n.bytes = r.bytes), n;
  }
  /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */
  couldBeginLoading_() {
    return this.playlist_ && !this.paused();
  }
  /**
   * load a playlist and start to fill the buffer
   */
  load() {
    if (this.monitorBuffer_(), !!this.playlist_) {
      if (this.state === "INIT" && this.couldBeginLoading_())
        return this.init_();
      !this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT" || (this.state = "READY");
    }
  }
  /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */
  init_() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }
  /**
   * set a playlist on the segment loader
   *
   * @param {PlaylistLoader} media the playlist to set on the segment loader
   */
  playlist(e, t = {}) {
    if (!e)
      return;
    const s = this.playlist_, r = this.pendingSegment_;
    this.playlist_ = e, this.xhrOptions_ = t, this.state === "INIT" && (e.syncInfo = {
      mediaSequence: e.mediaSequence,
      time: 0
    }, this.loaderType_ === "main" && this.syncController_.setDateTimeMappingForStart(e));
    let n = null;
    if (s && (s.id ? n = s.id : s.uri && (n = s.uri)), this.logger_(`playlist update [${n} => ${e.id || e.uri}]`), this.mediaSequenceSync_ && (this.mediaSequenceSync_.update(e, this.currentTime_()), this.logger_(`Playlist update:
currentTime: ${this.currentTime_()}
bufferedEnd: ${Pa(this.buffered_())}
`, this.mediaSequenceSync_.diagnostics)), this.trigger("syncinfoupdate"), this.state === "INIT" && this.couldBeginLoading_())
      return this.init_();
    if (!s || s.uri !== e.uri) {
      this.mediaIndex !== null && (!e.endList && typeof e.partTargetDuration == "number" ? this.resetLoader() : this.resyncLoader()), this.currentMediaInfo_ = void 0, this.trigger("playlistupdate");
      return;
    }
    const a = e.mediaSequence - s.mediaSequence;
    if (this.logger_(`live window shift [${a}]`), this.mediaIndex !== null)
      if (this.mediaIndex -= a, this.mediaIndex < 0)
        this.mediaIndex = null, this.partIndex = null;
      else {
        const o = this.playlist_.segments[this.mediaIndex];
        if (this.partIndex && (!o.parts || !o.parts.length || !o.parts[this.partIndex])) {
          const l = this.mediaIndex;
          this.logger_(`currently processing part (index ${this.partIndex}) no longer exists.`), this.resetLoader(), this.mediaIndex = l;
        }
      }
    r && (r.mediaIndex -= a, r.mediaIndex < 0 ? (r.mediaIndex = null, r.partIndex = null) : (r.mediaIndex >= 0 && (r.segment = e.segments[r.mediaIndex]), r.partIndex >= 0 && r.segment.parts && (r.part = r.segment.parts[r.partIndex]))), this.syncController_.saveExpiredSegmentInfo(s, e);
  }
  /**
   * Prevent the loader from fetching additional segments. If there
   * is a segment request outstanding, it will finish processing
   * before the loader halts. A segment loader can be unpaused by
   * calling load().
   */
  pause() {
    this.checkBufferTimeout_ && (S.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = null);
  }
  /**
   * Returns whether the segment loader is fetching additional
   * segments when given the opportunity. This property can be
   * modified through calls to pause() and load().
   */
  paused() {
    return this.checkBufferTimeout_ === null;
  }
  /**
   * Delete all the buffered data and reset the SegmentLoader
   *
   * @param {Function} [done] an optional callback to be executed when the remove
   * operation is complete
   */
  resetEverything(e) {
    this.ended_ = !1, this.activeInitSegmentId_ = null, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.resetLoader(), this.remove(0, 1 / 0, e), this.transmuxer_ && (this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), this.transmuxer_.postMessage({
      action: "reset"
    }));
  }
  /**
   * Force the SegmentLoader to resync and start loading around the currentTime instead
   * of starting at the end of the buffer
   *
   * Useful for fast quality changes
   */
  resetLoader() {
    this.fetchAtBuffer_ = !1, this.mediaSequenceSync_ && this.mediaSequenceSync_.resetAppendedStatus(), this.resyncLoader();
  }
  /**
   * Force the SegmentLoader to restart synchronization and make a conservative guess
   * before returning to the simple walk-forward method
   */
  resyncLoader() {
    this.transmuxer_ && La.reset(this.transmuxer_), this.mediaIndex = null, this.partIndex = null, this.syncPoint_ = null, this.isPendingTimestampOffset_ = !1;
    const e = this.currentMediaInfo_ && this.currentMediaInfo_.isFmp4;
    this.sourceType_ === "hls" && !e && (this.shouldForceTimestampOffsetAfterResync_ = !0), this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.abort(), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }
  /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   * @param {Function} [done] - an optional callback to be executed when the remove
   * @param {boolean} force - force all remove operations to happen
   * operation is complete
   */
  remove(e, t, s = () => {
  }, r = !1) {
    if (t === 1 / 0 && (t = this.duration_()), t <= e) {
      this.logger_("skipping remove because end ${end} is <= start ${start}");
      return;
    }
    if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
      this.logger_("skipping remove because no source updater or starting media info");
      return;
    }
    let n = 1;
    const a = () => {
      n--, n === 0 && s();
    };
    (r || !this.audioDisabled_) && (n++, this.sourceUpdater_.removeAudio(e, t, a)), (r || this.loaderType_ === "main") && (this.gopBuffer_ = k2(this.gopBuffer_, e, t, this.timeMapping_), n++, this.sourceUpdater_.removeVideo(e, t, a));
    for (const o in this.inbandTextTracks_)
      Ls(e, t, this.inbandTextTracks_[o]);
    Ls(e, t, this.segmentMetadataTrack_), a();
  }
  /**
   * (re-)schedule monitorBufferTick_ to run as soon as possible
   *
   * @private
   */
  monitorBuffer_() {
    this.checkBufferTimeout_ && S.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = S.setTimeout(this.monitorBufferTick_.bind(this), 1);
  }
  /**
   * As long as the SegmentLoader is in the READY state, periodically
   * invoke fillBuffer_().
   *
   * @private
   */
  monitorBufferTick_() {
    this.state === "READY" && this.fillBuffer_(), this.checkBufferTimeout_ && S.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = S.setTimeout(this.monitorBufferTick_.bind(this), L2);
  }
  /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */
  fillBuffer_() {
    if (this.sourceUpdater_.updating())
      return;
    const e = this.chooseNextRequest_();
    if (!e)
      return;
    const t = {
      segmentInfo: li({
        type: this.loaderType_,
        segment: e
      })
    };
    this.trigger({
      type: "segmentselected",
      metadata: t
    }), typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !1, this.timelineChangeController_.pendingTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: e.timeline
    })), this.loadSegment_(e);
  }
  /**
   * Determines if we should call endOfStream on the media source based
   * on the state of the buffer or if appened segment was the final
   * segment in the playlist.
   *
   * @param {number} [mediaIndex] the media index of segment we last appended
   * @param {Object} [playlist] a media playlist object
   * @return {boolean} do we need to call endOfStream on the MediaSource
   */
  isEndOfStream_(e = this.mediaIndex, t = this.playlist_, s = this.partIndex) {
    if (!t || !this.mediaSource_)
      return !1;
    const r = typeof e == "number" && t.segments[e], n = e + 1 === t.segments.length, a = !r || !r.parts || s + 1 === r.parts.length;
    return t.endList && this.mediaSource_.readyState === "open" && n && a;
  }
  /**
   * Determines what request should be made given current segment loader state.
   *
   * @return {Object} a request object that describes the segment/part to load
   */
  chooseNextRequest_() {
    const e = this.buffered_(), t = Pa(e) || 0, s = ou(e, this.currentTime_()), r = !this.hasPlayed_() && s >= 1, n = s >= this.goalBufferLength_(), a = this.playlist_.segments;
    if (!a.length || r || n)
      return null;
    this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_(), this.loaderType_);
    const o = {
      partIndex: null,
      mediaIndex: null,
      startOfSegment: null,
      playlist: this.playlist_,
      isSyncRequest: !this.syncPoint_
    };
    if (o.isSyncRequest)
      o.mediaIndex = O2(this.currentTimeline_, a, t), this.logger_(`choose next request. Can not find sync point. Fallback to media Index: ${o.mediaIndex}`);
    else if (this.mediaIndex !== null) {
      const v = a[this.mediaIndex], C = typeof this.partIndex == "number" ? this.partIndex : -1;
      o.startOfSegment = v.end ? v.end : t, v.parts && v.parts[C + 1] ? (o.mediaIndex = this.mediaIndex, o.partIndex = C + 1) : o.mediaIndex = this.mediaIndex + 1;
    } else {
      let v, C, A;
      const y = this.fetchAtBuffer_ ? t : this.currentTime_();
      if (this.mediaSequenceSync_ && this.logger_(`chooseNextRequest_ request after Quality Switch:
For TargetTime: ${y}.
CurrentTime: ${this.currentTime_()}
BufferedEnd: ${t}
Fetch At Buffer: ${this.fetchAtBuffer_}
`, this.mediaSequenceSync_.diagnostics), this.mediaSequenceSync_ && this.mediaSequenceSync_.isReliable) {
        const D = this.getSyncInfoFromMediaSequenceSync_(y);
        if (!D) {
          const w = "No sync info found while using media sequence sync";
          return this.error({
            message: w,
            metadata: {
              errorType: L.Error.StreamingFailedToSelectNextSegment,
              error: new Error(w)
            }
          }), this.logger_("chooseNextRequest_ - no sync info found using media sequence sync"), null;
        }
        this.logger_(`chooseNextRequest_ mediaSequence syncInfo (${D.start} --> ${D.end})`), v = D.segmentIndex, C = D.partIndex, A = D.start;
      } else {
        this.logger_("chooseNextRequest_ - fallback to a regular segment selection algorithm, based on a syncPoint.");
        const D = We.getMediaInfoForTime({
          exactManifestTimings: this.exactManifestTimings,
          playlist: this.playlist_,
          currentTime: y,
          startingPartIndex: this.syncPoint_.partIndex,
          startingSegmentIndex: this.syncPoint_.segmentIndex,
          startTime: this.syncPoint_.time
        });
        v = D.segmentIndex, C = D.partIndex, A = D.startTime;
      }
      o.getMediaInfoForTime = this.fetchAtBuffer_ ? `bufferedEnd ${y}` : `currentTime ${y}`, o.mediaIndex = v, o.startOfSegment = A, o.partIndex = C, this.logger_(`choose next request. Playlist switched and we have a sync point. Media Index: ${o.mediaIndex} `);
    }
    const l = a[o.mediaIndex];
    let h = l && typeof o.partIndex == "number" && l.parts && l.parts[o.partIndex];
    if (!l || typeof o.partIndex == "number" && !h)
      return null;
    typeof o.partIndex != "number" && l.parts && (o.partIndex = 0, h = l.parts[0]);
    const m = this.vhs_.playlists && this.vhs_.playlists.main && this.vhs_.playlists.main.independentSegments || this.playlist_.independentSegments;
    if (!s && h && !m && !h.independent)
      if (o.partIndex === 0) {
        const v = a[o.mediaIndex - 1], C = v.parts && v.parts.length && v.parts[v.parts.length - 1];
        C && C.independent && (o.mediaIndex -= 1, o.partIndex = v.parts.length - 1, o.independent = "previous segment");
      } else l.parts[o.partIndex - 1].independent && (o.partIndex -= 1, o.independent = "previous part");
    const _ = this.mediaSource_ && this.mediaSource_.readyState === "ended";
    return o.mediaIndex >= a.length - 1 && _ && !this.seeking_() ? null : (this.shouldForceTimestampOffsetAfterResync_ && (this.shouldForceTimestampOffsetAfterResync_ = !1, o.forceTimestampOffset = !0, this.logger_("choose next request. Force timestamp offset after loader resync")), this.generateSegmentInfo_(o));
  }
  getSyncInfoFromMediaSequenceSync_(e) {
    if (!this.mediaSequenceSync_)
      return null;
    const t = Math.max(e, this.mediaSequenceSync_.start);
    e !== t && this.logger_(`getSyncInfoFromMediaSequenceSync_. Pulled target time from ${e} to ${t}`);
    const s = this.mediaSequenceSync_.getSyncInfoForTime(t);
    if (!s)
      return null;
    if (!s.isAppended)
      return s;
    const r = this.mediaSequenceSync_.getSyncInfoForTime(s.end);
    return r ? (r.isAppended && this.logger_("getSyncInfoFromMediaSequenceSync_: We encounter unexpected scenario where next media sequence sync info is also appended!"), r) : null;
  }
  generateSegmentInfo_(e) {
    const {
      independent: t,
      playlist: s,
      mediaIndex: r,
      startOfSegment: n,
      isSyncRequest: a,
      partIndex: o,
      forceTimestampOffset: l,
      getMediaInfoForTime: h
    } = e, m = s.segments[r], _ = typeof o == "number" && m.parts[o], v = {
      requestId: "segment-loader-" + Math.random(),
      // resolve the segment URL relative to the playlist
      uri: _ && _.resolvedUri || m.resolvedUri,
      // the segment's mediaIndex at the time it was requested
      mediaIndex: r,
      partIndex: _ ? o : null,
      // whether or not to update the SegmentLoader's state with this
      // segment's mediaIndex
      isSyncRequest: a,
      startOfSegment: n,
      // the segment's playlist
      playlist: s,
      // unencrypted bytes of the segment
      bytes: null,
      // when a key is defined for this segment, the encrypted bytes
      encryptedBytes: null,
      // The target timestampOffset for this segment when we append it
      // to the source buffer
      timestampOffset: null,
      // The timeline that the segment is in
      timeline: m.timeline,
      // The expected duration of the segment in seconds
      duration: _ && _.duration || m.duration,
      // retain the segment in case the playlist updates while doing an async process
      segment: m,
      part: _,
      byteLength: 0,
      transmuxer: this.transmuxer_,
      // type of getMediaInfoForTime that was used to get this segment
      getMediaInfoForTime: h,
      independent: t
    }, C = typeof l < "u" ? l : this.isPendingTimestampOffset_;
    v.timestampOffset = this.timestampOffsetForSegment_({
      segmentTimeline: m.timeline,
      currentTimeline: this.currentTimeline_,
      startOfSegment: n,
      buffered: this.buffered_(),
      overrideCheck: C
    });
    const A = Pa(this.sourceUpdater_.audioBuffered());
    return typeof A == "number" && (v.audioAppendStart = A - this.sourceUpdater_.audioTimestampOffset()), this.sourceUpdater_.videoBuffered().length && (v.gopsToAlignWith = w2(
      this.gopBuffer_,
      // since the transmuxer is using the actual timing values, but the time is
      // adjusted by the timestmap offset, we must adjust the value here
      this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(),
      this.timeMapping_
    )), v;
  }
  // get the timestampoffset for a segment,
  // added so that vtt segment loader can override and prevent
  // adding timestamp offsets.
  timestampOffsetForSegment_(e) {
    return M2(e);
  }
  /**
   * Determines if the network has enough bandwidth to complete the current segment
   * request in a timely manner. If not, the request will be aborted early and bandwidth
   * updated to trigger a playlist switch.
   *
   * @param {Object} stats
   *        Object containing stats about the request timing and size
   * @private
   */
  earlyAbortWhenNeeded_(e) {
    if (this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
    // TODO: Replace using timeout with a boolean indicating whether this playlist is
    //       the lowestEnabledRendition.
    !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
    !this.playlist_.attributes.BANDWIDTH || Date.now() - (e.firstBytesReceivedAt || Date.now()) < 1e3)
      return;
    const t = this.currentTime_(), s = e.bandwidth, r = this.pendingSegment_.duration, n = We.estimateSegmentRequestTime(r, s, this.playlist_, e.bytesReceived), a = nv(this.buffered_(), t, this.vhs_.tech_.playbackRate()) - 1;
    if (n <= a)
      return;
    const o = _2({
      main: this.vhs_.playlists.main,
      currentTime: t,
      bandwidth: s,
      duration: this.duration_(),
      segmentDuration: r,
      timeUntilRebuffer: a,
      currentTimeline: this.currentTimeline_,
      syncController: this.syncController_
    });
    if (!o)
      return;
    const h = n - a - o.rebufferingImpact;
    let m = 0.5;
    a <= yt && (m = 1), !(!o.playlist || o.playlist.uri === this.playlist_.uri || h < m) && (this.bandwidth = o.playlist.attributes.BANDWIDTH * Ae.BANDWIDTH_VARIANCE + 1, this.trigger("earlyabort"));
  }
  handleAbort_(e) {
    this.logger_(`Aborting ${ki(e)}`), this.mediaRequestsAborted += 1;
  }
  /**
   * XHR `progress` event handler
   *
   * @param {Event}
   *        The XHR `progress` event
   * @param {Object} simpleSegment
   *        A simplified segment object copy
   * @private
   */
  handleProgress_(e, t) {
    this.earlyAbortWhenNeeded_(t.stats), !this.checkForAbort_(t.requestId) && this.trigger("progress");
  }
  handleTrackInfo_(e, t) {
    const {
      hasAudio: s,
      hasVideo: r
    } = t, n = {
      segmentInfo: li({
        type: this.loaderType_,
        segment: e
      }),
      trackInfo: {
        hasAudio: s,
        hasVideo: r
      }
    };
    this.trigger({
      type: "segmenttransmuxingtrackinfoavailable",
      metadata: n
    }), this.earlyAbortWhenNeeded_(e.stats), !this.checkForAbort_(e.requestId) && (this.checkForIllegalMediaSwitch(t) || (t = t || {}, P2(this.currentMediaInfo_, t) || (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.startingMediaInfo_ = t, this.currentMediaInfo_ = t, this.logger_("trackinfo update", t), this.trigger("trackinfo")), !this.checkForAbort_(e.requestId) && (this.pendingSegment_.trackInfo = t, this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : zt(this))));
  }
  handleTimingInfo_(e, t, s, r) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    const n = this.pendingSegment_, a = Pc(t);
    n[a] = n[a] || {}, n[a][s] = r, this.logger_(`timinginfo: ${t} - ${s} - ${r}`), this.hasEnoughInfoToAppend_() ? this.processCallQueue_() : zt(this);
  }
  handleCaptions_(e, t) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (t.length === 0) {
      this.logger_("SegmentLoader received no captions from a caption event");
      return;
    }
    if (!this.pendingSegment_.hasAppendedData_) {
      this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, e, t));
      return;
    }
    const r = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(), n = {};
    t.forEach((a) => {
      n[a.stream] = n[a.stream] || {
        // Infinity, as any other value will be less than this
        startTime: 1 / 0,
        captions: [],
        // 0 as an other value will be more than this
        endTime: 0
      };
      const o = n[a.stream];
      o.startTime = Math.min(o.startTime, a.startTime + r), o.endTime = Math.max(o.endTime, a.endTime + r), o.captions.push(a);
    }), Object.keys(n).forEach((a) => {
      const {
        startTime: o,
        endTime: l,
        captions: h
      } = n[a], m = this.inbandTextTracks_;
      this.logger_(`adding cues from ${o} -> ${l} for ${a}`), v2(m, this.vhs_.tech_, a), Ls(o, l, m[a]), b2({
        captionArray: h,
        inbandTextTracks: m,
        timestampOffset: r
      });
    }), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }
  handleId3_(e, t, s) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (!this.pendingSegment_.hasAppendedData_) {
      this.metadataQueue_.id3.push(this.handleId3_.bind(this, e, t, s));
      return;
    }
    this.addMetadataToTextTrack(s, t, this.duration_());
  }
  processMetadataQueue_() {
    this.metadataQueue_.id3.forEach((e) => e()), this.metadataQueue_.caption.forEach((e) => e()), this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [];
  }
  processCallQueue_() {
    const e = this.callQueue_;
    this.callQueue_ = [], e.forEach((t) => t());
  }
  processLoadQueue_() {
    const e = this.loadQueue_;
    this.loadQueue_ = [], e.forEach((t) => t());
  }
  /**
   * Determines whether the loader has enough info to load the next segment.
   *
   * @return {boolean}
   *         Whether or not the loader has enough info to load the next segment
   */
  hasEnoughInfoToLoad_() {
    if (this.loaderType_ !== "audio")
      return !0;
    const e = this.pendingSegment_;
    return e ? this.getCurrentMediaInfo_() ? (
      // Technically, instead of waiting to load a segment on timeline changes, a segment
      // can be requested and downloaded and only wait before it is transmuxed or parsed.
      // But in practice, there are a few reasons why it is better to wait until a loader
      // is ready to append that segment before requesting and downloading:
      //
      // 1. Because audio and main loaders cross discontinuities together, if this loader
      //    is waiting for the other to catch up, then instead of requesting another
      //    segment and using up more bandwidth, by not yet loading, more bandwidth is
      //    allotted to the loader currently behind.
      // 2. media-segment-request doesn't have to have logic to consider whether a segment
      // is ready to be processed or not, isolating the queueing behavior to the loader.
      // 3. The audio loader bases some of its segment properties on timing information
      //    provided by the main loader, meaning that, if the logic for waiting on
      //    processing was in media-segment-request, then it would also need to know how
      //    to re-generate the segment information after the main loader caught up.
      !ao({
        timelineChangeController: this.timelineChangeController_,
        currentTimeline: this.currentTimeline_,
        segmentTimeline: e.timeline,
        loaderType: this.loaderType_,
        audioDisabled: this.audioDisabled_
      })
    ) : !0 : !1;
  }
  getCurrentMediaInfo_(e = this.pendingSegment_) {
    return e && e.trackInfo || this.currentMediaInfo_;
  }
  getMediaInfo_(e = this.pendingSegment_) {
    return this.getCurrentMediaInfo_(e) || this.startingMediaInfo_;
  }
  getPendingSegmentPlaylist() {
    return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
  }
  hasEnoughInfoToAppend_() {
    if (!this.sourceUpdater_.ready() || this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_)
      return !1;
    const e = this.pendingSegment_, t = this.getCurrentMediaInfo_();
    if (!e || !t)
      return !1;
    const {
      hasAudio: s,
      hasVideo: r,
      isMuxed: n
    } = t;
    return !(r && !e.videoTimingInfo || s && !this.audioDisabled_ && !n && !e.audioTimingInfo || ao({
      timelineChangeController: this.timelineChangeController_,
      currentTimeline: this.currentTimeline_,
      segmentTimeline: e.timeline,
      loaderType: this.loaderType_,
      audioDisabled: this.audioDisabled_
    }));
  }
  handleData_(e, t) {
    if (this.earlyAbortWhenNeeded_(e.stats), this.checkForAbort_(e.requestId))
      return;
    if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
      zt(this), this.callQueue_.push(this.handleData_.bind(this, e, t));
      return;
    }
    const s = this.pendingSegment_;
    if (this.setTimeMapping_(s.timeline), this.updateMediaSecondsLoaded_(s.part || s.segment), this.mediaSource_.readyState !== "closed") {
      if (e.map && (e.map = this.initSegmentForMap(e.map, !0), s.segment.map = e.map), e.key && this.segmentKey(e.key, !0), s.isFmp4 = e.isFmp4, s.timingInfo = s.timingInfo || {}, s.isFmp4)
        this.trigger("fmp4"), s.timingInfo.start = s[Pc(t.type)].start;
      else {
        const r = this.getCurrentMediaInfo_(), n = this.loaderType_ === "main" && r && r.hasVideo;
        let a;
        n && (a = s.videoTimingInfo.start), s.timingInfo.start = this.trueSegmentStart_({
          currentStart: s.timingInfo.start,
          playlist: s.playlist,
          mediaIndex: s.mediaIndex,
          currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
          useVideoTimingInfo: n,
          firstVideoFrameTimeForData: a,
          videoTimingInfo: s.videoTimingInfo,
          audioTimingInfo: s.audioTimingInfo
        });
      }
      if (this.updateAppendInitSegmentStatus(s, t.type), this.updateSourceBufferTimestampOffset_(s), s.isSyncRequest) {
        this.updateTimingInfoEnd_(s), this.syncController_.saveSegmentTimingInfo({
          segmentInfo: s,
          shouldSaveTimelineMapping: this.loaderType_ === "main"
        });
        const r = this.chooseNextRequest_();
        if (r.mediaIndex !== s.mediaIndex || r.partIndex !== s.partIndex) {
          this.logger_("sync segment was incorrect, not appending");
          return;
        }
        this.logger_("sync segment was correct, appending");
      }
      s.hasAppendedData_ = !0, this.processMetadataQueue_(), this.appendData_(s, t);
    }
  }
  updateAppendInitSegmentStatus(e, t) {
    this.loaderType_ === "main" && typeof e.timestampOffset == "number" && // in the case that we're handling partial data, we don't want to append an init
    // segment for each chunk
    !e.changedTimestampOffset && (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }), this.playlistOfLastInitSegment_[t] !== e.playlist && (this.appendInitSegment_[t] = !0);
  }
  getInitSegmentAndUpdateState_({
    type: e,
    initSegment: t,
    map: s,
    playlist: r
  }) {
    if (s) {
      const n = fn(s);
      if (this.activeInitSegmentId_ === n)
        return null;
      t = this.initSegmentForMap(s, !0).bytes, this.activeInitSegmentId_ = n;
    }
    return t && this.appendInitSegment_[e] ? (this.playlistOfLastInitSegment_[e] = r, this.appendInitSegment_[e] = !1, this.activeInitSegmentId_ = null, t) : null;
  }
  handleQuotaExceededError_({
    segmentInfo: e,
    type: t,
    bytes: s
  }, r) {
    const n = this.sourceUpdater_.audioBuffered(), a = this.sourceUpdater_.videoBuffered();
    n.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + di(n).join(", ")), a.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + di(a).join(", "));
    const o = n.length ? n.start(0) : 0, l = n.length ? n.end(n.length - 1) : 0, h = a.length ? a.start(0) : 0, m = a.length ? a.end(a.length - 1) : 0;
    if (l - o <= Ds && m - h <= Ds) {
      this.logger_(`On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. Appended byte length: ${s.byteLength}, audio buffer: ${di(n).join(", ")}, video buffer: ${di(a).join(", ")}, `), this.error({
        message: "Quota exceeded error with append of a single segment of content",
        excludeUntil: 1 / 0
      }), this.trigger("error");
      return;
    }
    this.waitingOnRemove_ = !0, this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
      segmentInfo: e,
      type: t,
      bytes: s
    }));
    const v = this.currentTime_() - Ds;
    this.logger_(`On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to ${v}`), this.remove(0, v, () => {
      this.logger_(`On QUOTA_EXCEEDED_ERR, retrying append in ${Ds}s`), this.waitingOnRemove_ = !1, this.quotaExceededErrorRetryTimeout_ = S.setTimeout(() => {
        this.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue"), this.quotaExceededErrorRetryTimeout_ = null, this.processCallQueue_();
      }, Ds * 1e3);
    }, !0);
  }
  handleAppendError_({
    segmentInfo: e,
    type: t,
    bytes: s
  }, r) {
    if (r) {
      if (r.code === Ef) {
        this.handleQuotaExceededError_({
          segmentInfo: e,
          type: t,
          bytes: s
        });
        return;
      }
      this.logger_("Received non QUOTA_EXCEEDED_ERR on append", r), this.error({
        message: `${t} append of ${s.length}b failed for segment #${e.mediaIndex} in playlist ${e.playlist.id}`,
        metadata: {
          errorType: L.Error.StreamingFailedToAppendSegment
        }
      }), this.trigger("appenderror");
    }
  }
  appendToSourceBuffer_({
    segmentInfo: e,
    type: t,
    initSegment: s,
    data: r,
    bytes: n
  }) {
    if (!n) {
      const o = [r];
      let l = r.byteLength;
      s && (o.unshift(s), l += s.byteLength), n = T2({
        bytes: l,
        segments: o
      });
    }
    const a = {
      segmentInfo: li({
        type: this.loaderType_,
        segment: e
      })
    };
    this.trigger({
      type: "segmentappendstart",
      metadata: a
    }), this.sourceUpdater_.appendBuffer({
      segmentInfo: e,
      type: t,
      bytes: n
    }, this.handleAppendError_.bind(this, {
      segmentInfo: e,
      type: t,
      bytes: n
    }));
  }
  handleSegmentTimingInfo_(e, t, s) {
    if (!this.pendingSegment_ || t !== this.pendingSegment_.requestId)
      return;
    const r = this.pendingSegment_.segment, n = `${e}TimingInfo`;
    r[n] || (r[n] = {}), r[n].transmuxerPrependedSeconds = s.prependedContentDuration || 0, r[n].transmuxedPresentationStart = s.start.presentation, r[n].transmuxedDecodeStart = s.start.decode, r[n].transmuxedPresentationEnd = s.end.presentation, r[n].transmuxedDecodeEnd = s.end.decode, r[n].baseMediaDecodeTime = s.baseMediaDecodeTime;
  }
  appendData_(e, t) {
    const {
      type: s,
      data: r
    } = t;
    if (!r || !r.byteLength || s === "audio" && this.audioDisabled_)
      return;
    const n = this.getInitSegmentAndUpdateState_({
      type: s,
      initSegment: t.initSegment,
      playlist: e.playlist,
      map: e.isFmp4 ? e.segment.map : null
    });
    this.appendToSourceBuffer_({
      segmentInfo: e,
      type: s,
      initSegment: n,
      data: r
    });
  }
  /**
   * load a specific segment from a request into the buffer
   *
   * @private
   */
  loadSegment_(e) {
    if (this.state = "WAITING", this.pendingSegment_ = e, this.trimBackBuffer_(e), typeof e.timestampOffset == "number" && this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), !this.hasEnoughInfoToLoad_()) {
      zt(this), this.loadQueue_.push(() => {
        const t = ye({}, e, {
          forceTimestampOffset: !0
        });
        ye(e, this.generateSegmentInfo_(t)), this.isPendingTimestampOffset_ = !1, this.updateTransmuxerAndRequestSegment_(e);
      });
      return;
    }
    this.updateTransmuxerAndRequestSegment_(e);
  }
  updateTransmuxerAndRequestSegment_(e) {
    this.shouldUpdateTransmuxerTimestampOffset_(e.timestampOffset) && (this.gopBuffer_.length = 0, e.gopsToAlignWith = [], this.timeMapping_ = 0, this.transmuxer_.postMessage({
      action: "reset"
    }), this.transmuxer_.postMessage({
      action: "setTimestampOffset",
      timestampOffset: e.timestampOffset
    }));
    const t = this.createSimplifiedSegmentObj_(e), s = this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex), r = this.mediaIndex !== null, n = e.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
    // the first timeline
    e.timeline > 0, a = s || r && n;
    this.logger_(`Requesting
${Wf(e.uri)}
${ki(e)}`), t.map && !t.map.bytes && (this.logger_("going to request init segment."), this.appendInitSegment_ = {
      video: !0,
      audio: !0
    }), e.abortRequests = d2({
      xhr: this.vhs_.xhr,
      xhrOptions: this.xhrOptions_,
      decryptionWorker: this.decrypter_,
      segment: t,
      abortFn: this.handleAbort_.bind(this, e),
      progressFn: this.handleProgress_.bind(this),
      trackInfoFn: this.handleTrackInfo_.bind(this),
      timingInfoFn: this.handleTimingInfo_.bind(this),
      videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", e.requestId),
      audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", e.requestId),
      captionsFn: this.handleCaptions_.bind(this),
      isEndOfTimeline: a,
      endedTimelineFn: () => {
        this.logger_("received endedtimeline callback");
      },
      id3Fn: this.handleId3_.bind(this),
      dataFn: this.handleData_.bind(this),
      doneFn: this.segmentRequestFinished_.bind(this),
      onTransmuxerLog: ({
        message: o,
        level: l,
        stream: h
      }) => {
        this.logger_(`${ki(e)} logged from transmuxer stream ${h} as a ${l}: ${o}`);
      },
      triggerSegmentEventFn: ({
        type: o,
        segment: l,
        keyInfo: h,
        trackInfo: m,
        timingInfo: _
      }) => {
        const C = {
          segmentInfo: li({
            segment: l
          })
        };
        h && (C.keyInfo = h), m && (C.trackInfo = m), _ && (C.timingInfo = _), this.trigger({
          type: o,
          metadata: C
        });
      }
    });
  }
  /**
   * trim the back buffer so that we don't have too much data
   * in the source buffer
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   */
  trimBackBuffer_(e) {
    const t = N2(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
    t > 0 && this.remove(0, t);
  }
  /**
   * created a simplified copy of the segment object with just the
   * information necessary to perform the XHR and decryption
   *
   * @private
   *
   * @param {Object} segmentInfo - the current segment
   * @return {Object} a simplified segment object copy
   */
  createSimplifiedSegmentObj_(e) {
    const t = e.segment, s = e.part, r = e.segment.key || e.segment.map && e.segment.map.key, n = e.segment.map && !e.segment.map.bytes, a = {
      resolvedUri: s ? s.resolvedUri : t.resolvedUri,
      byterange: s ? s.byterange : t.byterange,
      requestId: e.requestId,
      transmuxer: e.transmuxer,
      audioAppendStart: e.audioAppendStart,
      gopsToAlignWith: e.gopsToAlignWith,
      part: e.part,
      type: this.loaderType_,
      start: e.startOfSegment,
      duration: e.duration,
      isEncrypted: r,
      isMediaInitialization: n
    }, o = e.playlist.segments[e.mediaIndex - 1];
    if (o && o.timeline === t.timeline && (o.videoTimingInfo ? a.baseStartTime = o.videoTimingInfo.transmuxedDecodeEnd : o.audioTimingInfo && (a.baseStartTime = o.audioTimingInfo.transmuxedDecodeEnd)), t.key) {
      const l = t.key.iv || new Uint32Array([0, 0, 0, e.mediaIndex + e.playlist.mediaSequence]);
      a.key = this.segmentKey(t.key), a.key.iv = l;
    }
    return t.map && (a.map = this.initSegmentForMap(t.map)), a;
  }
  saveTransferStats_(e) {
    this.mediaRequests += 1, e && (this.mediaBytesTransferred += e.bytesReceived, this.mediaTransferDuration += e.roundTripTime);
  }
  saveBandwidthRelatedStats_(e, t) {
    if (this.pendingSegment_.byteLength = t.bytesReceived, e < Ur) {
      this.logger_(`Ignoring segment's bandwidth because its duration of ${e} is less than the min to record ${Ur}`);
      return;
    }
    const s = {
      bandwidthInfo: {
        from: this.bandwidth,
        to: t.bandwidth
      }
    };
    this.trigger({
      type: "bandwidthupdated",
      metadata: s
    }), this.bandwidth = t.bandwidth, this.roundTrip = t.roundTripTime;
  }
  handleTimeout_() {
    this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate"), this.trigger("timeout");
  }
  /**
   * Handle the callback from the segmentRequest function and set the
   * associated SegmentLoader state and errors if necessary
   *
   * @private
   */
  segmentRequestFinished_(e, t, s) {
    if (this.callQueue_.length) {
      this.callQueue_.push(this.segmentRequestFinished_.bind(this, e, t, s));
      return;
    }
    if (this.saveTransferStats_(t.stats), !this.pendingSegment_ || t.requestId !== this.pendingSegment_.requestId)
      return;
    if (e) {
      if (this.pendingSegment_ = null, this.state = "READY", e.code === vt.ABORTED)
        return;
      if (this.pause(), e.code === vt.TIMEOUT) {
        this.handleTimeout_();
        return;
      }
      this.mediaRequestsErrored += 1, this.error(e), this.trigger("error");
      return;
    }
    const r = this.pendingSegment_;
    this.saveBandwidthRelatedStats_(r.duration, t.stats), r.endOfAllRequests = t.endOfAllRequests, s.gopInfo && (this.gopBuffer_ = I2(this.gopBuffer_, s.gopInfo, this.safeAppend_)), this.state = "APPENDING", this.trigger("appending"), this.waitForAppendsToComplete_(r);
  }
  setTimeMapping_(e) {
    const t = this.syncController_.mappingForTimeline(e);
    t !== null && (this.timeMapping_ = t);
  }
  updateMediaSecondsLoaded_(e) {
    typeof e.start == "number" && typeof e.end == "number" ? this.mediaSecondsLoaded += e.end - e.start : this.mediaSecondsLoaded += e.duration;
  }
  shouldUpdateTransmuxerTimestampOffset_(e) {
    return e === null ? !1 : this.loaderType_ === "main" && e !== this.sourceUpdater_.videoTimestampOffset() || !this.audioDisabled_ && e !== this.sourceUpdater_.audioTimestampOffset();
  }
  trueSegmentStart_({
    currentStart: e,
    playlist: t,
    mediaIndex: s,
    firstVideoFrameTimeForData: r,
    currentVideoTimestampOffset: n,
    useVideoTimingInfo: a,
    videoTimingInfo: o,
    audioTimingInfo: l
  }) {
    if (typeof e < "u")
      return e;
    if (!a)
      return l.start;
    const h = t.segments[s - 1];
    return s === 0 || !h || typeof h.start > "u" || h.end !== r + n ? r : o.start;
  }
  waitForAppendsToComplete_(e) {
    const t = this.getCurrentMediaInfo_(e);
    if (!t) {
      this.error({
        message: "No starting media returned, likely due to an unsupported media format.",
        playlistExclusionDuration: 1 / 0
      }), this.trigger("error");
      return;
    }
    const {
      hasAudio: s,
      hasVideo: r,
      isMuxed: n
    } = t, a = this.loaderType_ === "main" && r, o = !this.audioDisabled_ && s && !n;
    if (e.waitingOnAppends = 0, !e.hasAppendedData_) {
      !e.timingInfo && typeof e.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !0), e.timingInfo = {
        start: 0
      }, e.waitingOnAppends++, this.isPendingTimestampOffset_ || (this.updateSourceBufferTimestampOffset_(e), this.processMetadataQueue_()), this.checkAppendsDone_(e);
      return;
    }
    a && e.waitingOnAppends++, o && e.waitingOnAppends++, a && this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, e)), o && this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, e));
  }
  checkAppendsDone_(e) {
    this.checkForAbort_(e.requestId) || (e.waitingOnAppends--, e.waitingOnAppends === 0 && this.handleAppendsDone_());
  }
  checkForIllegalMediaSwitch(e) {
    const t = R2(this.loaderType_, this.getCurrentMediaInfo_(), e);
    return t ? (this.error({
      message: t,
      playlistExclusionDuration: 1 / 0
    }), this.trigger("error"), !0) : !1;
  }
  updateSourceBufferTimestampOffset_(e) {
    if (e.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
    // priority, timing-wise, so we must wait
    typeof e.timingInfo.start != "number" || // already updated the timestamp offset for this segment
    e.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
    this.loaderType_ !== "main")
      return;
    let t = !1;
    e.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
      videoTimingInfo: e.segment.videoTimingInfo,
      audioTimingInfo: e.segment.audioTimingInfo,
      timingInfo: e.timingInfo
    }), e.changedTimestampOffset = !0, e.timestampOffset !== this.sourceUpdater_.videoTimestampOffset() && (this.sourceUpdater_.videoTimestampOffset(e.timestampOffset), t = !0), e.timestampOffset !== this.sourceUpdater_.audioTimestampOffset() && (this.sourceUpdater_.audioTimestampOffset(e.timestampOffset), t = !0), t && this.trigger("timestampoffset");
  }
  getSegmentStartTimeForTimestampOffsetCalculation_({
    videoTimingInfo: e,
    audioTimingInfo: t,
    timingInfo: s
  }) {
    return this.useDtsForTimestampOffset_ ? e && typeof e.transmuxedDecodeStart == "number" ? e.transmuxedDecodeStart : t && typeof t.transmuxedDecodeStart == "number" ? t.transmuxedDecodeStart : s.start : s.start;
  }
  updateTimingInfoEnd_(e) {
    e.timingInfo = e.timingInfo || {};
    const t = this.getMediaInfo_(), r = this.loaderType_ === "main" && t && t.hasVideo && e.videoTimingInfo ? e.videoTimingInfo : e.audioTimingInfo;
    r && (e.timingInfo.end = typeof r.end == "number" ? (
      // End time may not exist in a case where we aren't parsing the full segment (one
      // current example is the case of fmp4), so use the rough duration to calculate an
      // end time.
      r.end
    ) : r.start + e.duration);
  }
  /**
   * callback to run when appendBuffer is finished. detects if we are
   * in a good state to do things with the data we got, or if we need
   * to wait for more
   *
   * @private
   */
  handleAppendsDone_() {
    if (this.pendingSegment_) {
      const l = {
        segmentInfo: li({
          type: this.loaderType_,
          segment: this.pendingSegment_
        })
      };
      this.trigger({
        type: "appendsdone",
        metadata: l
      });
    }
    if (!this.pendingSegment_) {
      this.state = "READY", this.paused() || this.monitorBuffer_();
      return;
    }
    const e = this.pendingSegment_;
    e.part && e.part.syncInfo ? e.part.syncInfo.markAppended() : e.segment.syncInfo && e.segment.syncInfo.markAppended(), this.updateTimingInfoEnd_(e), this.shouldSaveSegmentTimingInfo_ && this.syncController_.saveSegmentTimingInfo({
      segmentInfo: e,
      shouldSaveTimelineMapping: this.loaderType_ === "main"
    });
    const t = q2(e, this.sourceType_);
    if (t && (t.severity === "warn" ? L.log.warn(t.message) : this.logger_(t.message)), this.recordThroughput_(e), this.pendingSegment_ = null, this.state = "READY", e.isSyncRequest && (this.trigger("syncinfoupdate"), !e.hasAppendedData_)) {
      this.logger_(`Throwing away un-appended sync request ${ki(e)}`);
      return;
    }
    this.logger_(`Appended ${ki(e)}`), this.addSegmentMetadataCue_(e), this.fetchAtBuffer_ = !0, this.currentTimeline_ !== e.timeline && (this.timelineChangeController_.lastTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: e.timeline
    }), this.loaderType_ === "main" && !this.audioDisabled_ && this.timelineChangeController_.lastTimelineChange({
      type: "audio",
      from: this.currentTimeline_,
      to: e.timeline
    })), this.currentTimeline_ = e.timeline, this.trigger("syncinfoupdate");
    const s = e.segment, r = e.part, n = s.end && this.currentTime_() - s.end > e.playlist.targetDuration * 3, a = r && r.end && this.currentTime_() - r.end > e.playlist.partTargetDuration * 3;
    if (n || a) {
      this.logger_(`bad ${n ? "segment" : "part"} ${ki(e)}`), this.resetEverything();
      return;
    }
    this.mediaIndex !== null && this.trigger("bandwidthupdate"), this.trigger("progress"), this.mediaIndex = e.mediaIndex, this.partIndex = e.partIndex, this.isEndOfStream_(e.mediaIndex, e.playlist, e.partIndex) && this.endOfStream(), this.trigger("appended"), e.hasAppendedData_ && this.mediaAppends++, this.paused() || this.monitorBuffer_();
  }
  /**
   * Records the current throughput of the decrypt, transmux, and append
   * portion of the semgment pipeline. `throughput.rate` is a the cumulative
   * moving average of the throughput. `throughput.count` is the number of
   * data points in the average.
   *
   * @private
   * @param {Object} segmentInfo the object returned by loadSegment
   */
  recordThroughput_(e) {
    if (e.duration < Ur) {
      this.logger_(`Ignoring segment's throughput because its duration of ${e.duration} is less than the min to record ${Ur}`);
      return;
    }
    const t = this.throughput.rate, s = Date.now() - e.endOfAllRequests + 1, r = Math.floor(e.byteLength / s * 8 * 1e3);
    this.throughput.rate += (r - t) / ++this.throughput.count;
  }
  /**
   * Adds a cue to the segment-metadata track with some metadata information about the
   * segment
   *
   * @private
   * @param {Object} segmentInfo
   *        the object returned by loadSegment
   * @method addSegmentMetadataCue_
   */
  addSegmentMetadataCue_(e) {
    if (!this.segmentMetadataTrack_)
      return;
    const t = e.segment, s = t.start, r = t.end;
    if (!kc(s) || !kc(r))
      return;
    Ls(s, r, this.segmentMetadataTrack_);
    const n = S.WebKitDataCue || S.VTTCue, a = {
      custom: t.custom,
      dateTimeObject: t.dateTimeObject,
      dateTimeString: t.dateTimeString,
      programDateTime: t.programDateTime,
      bandwidth: e.playlist.attributes.BANDWIDTH,
      resolution: e.playlist.attributes.RESOLUTION,
      codecs: e.playlist.attributes.CODECS,
      byteLength: e.byteLength,
      uri: e.uri,
      timeline: e.timeline,
      playlist: e.playlist.id,
      start: s,
      end: r
    }, o = JSON.stringify(a), l = new n(s, r, o);
    l.value = a, this.segmentMetadataTrack_.addCue(l);
  }
}
function Ot() {
}
const Xf = function(i) {
  return typeof i != "string" ? i : i.replace(/./, (e) => e.toUpperCase());
}, j2 = ["video", "audio"], uo = (i, e) => {
  const t = e[`${i}Buffer`];
  return t && t.updating || e.queuePending[i];
}, H2 = (i, e) => {
  for (let t = 0; t < e.length; t++) {
    const s = e[t];
    if (s.type === "mediaSource")
      return null;
    if (s.type === i)
      return t;
  }
  return null;
}, qi = (i, e) => {
  if (e.queue.length === 0)
    return;
  let t = 0, s = e.queue[t];
  if (s.type === "mediaSource") {
    !e.updating() && e.mediaSource.readyState !== "closed" && (e.queue.shift(), s.action(e), s.doneFn && s.doneFn(), qi("audio", e), qi("video", e));
    return;
  }
  if (i !== "mediaSource" && !(!e.ready() || e.mediaSource.readyState === "closed" || uo(i, e))) {
    if (s.type !== i) {
      if (t = H2(i, e.queue), t === null)
        return;
      s = e.queue[t];
    }
    if (e.queue.splice(t, 1), e.queuePending[i] = s, s.action(i, e), !s.doneFn) {
      e.queuePending[i] = null, qi(i, e);
      return;
    }
  }
}, Kf = (i, e) => {
  const t = e[`${i}Buffer`], s = Xf(i);
  t && (t.removeEventListener("updateend", e[`on${s}UpdateEnd_`]), t.removeEventListener("error", e[`on${s}Error_`]), e.codecs[i] = null, e[`${i}Buffer`] = null);
}, gt = (i, e) => i && e && Array.prototype.indexOf.call(i.sourceBuffers, e) !== -1, Qe = {
  appendBuffer: (i, e, t) => (s, r) => {
    const n = r[`${s}Buffer`];
    if (gt(r.mediaSource, n)) {
      r.logger_(`Appending segment ${e.mediaIndex}'s ${i.length} bytes to ${s}Buffer`);
      try {
        n.appendBuffer(i);
      } catch (a) {
        r.logger_(`Error with code ${a.code} ` + (a.code === Ef ? "(QUOTA_EXCEEDED_ERR) " : "") + `when appending segment ${e.mediaIndex} to ${s}Buffer`), r.queuePending[s] = null, t(a);
      }
    }
  },
  remove: (i, e) => (t, s) => {
    const r = s[`${t}Buffer`];
    if (gt(s.mediaSource, r)) {
      s.logger_(`Removing ${i} to ${e} from ${t}Buffer`);
      try {
        r.remove(i, e);
      } catch {
        s.logger_(`Remove ${i} to ${e} from ${t}Buffer failed`);
      }
    }
  },
  timestampOffset: (i) => (e, t) => {
    const s = t[`${e}Buffer`];
    gt(t.mediaSource, s) && (t.logger_(`Setting ${e}timestampOffset to ${i}`), s.timestampOffset = i);
  },
  callback: (i) => (e, t) => {
    i();
  },
  endOfStream: (i) => (e) => {
    if (e.mediaSource.readyState === "open") {
      e.logger_(`Calling mediaSource endOfStream(${i || ""})`);
      try {
        e.mediaSource.endOfStream(i);
      } catch (t) {
        L.log.warn("Failed to call media source endOfStream", t);
      }
    }
  },
  duration: (i) => (e) => {
    e.logger_(`Setting mediaSource duration to ${i}`);
    try {
      e.mediaSource.duration = i;
    } catch (t) {
      L.log.warn("Failed to set media source duration", t);
    }
  },
  abort: () => (i, e) => {
    if (e.mediaSource.readyState !== "open")
      return;
    const t = e[`${i}Buffer`];
    if (gt(e.mediaSource, t)) {
      e.logger_(`calling abort on ${i}Buffer`);
      try {
        t.abort();
      } catch (s) {
        L.log.warn(`Failed to abort on ${i}Buffer`, s);
      }
    }
  },
  addSourceBuffer: (i, e) => (t) => {
    const s = Xf(i), r = ji(e);
    t.logger_(`Adding ${i}Buffer with codec ${e} to mediaSource`);
    const n = t.mediaSource.addSourceBuffer(r);
    n.addEventListener("updateend", t[`on${s}UpdateEnd_`]), n.addEventListener("error", t[`on${s}Error_`]), t.codecs[i] = e, t[`${i}Buffer`] = n;
  },
  removeSourceBuffer: (i) => (e) => {
    const t = e[`${i}Buffer`];
    if (Kf(i, e), !!gt(e.mediaSource, t)) {
      e.logger_(`Removing ${i}Buffer with codec ${e.codecs[i]} from mediaSource`);
      try {
        e.mediaSource.removeSourceBuffer(t);
      } catch (s) {
        L.log.warn(`Failed to removeSourceBuffer ${i}Buffer`, s);
      }
    }
  },
  changeType: (i) => (e, t) => {
    const s = t[`${e}Buffer`], r = ji(i);
    if (!gt(t.mediaSource, s))
      return;
    const n = i.substring(0, i.indexOf(".")), a = t.codecs[e];
    if (a.substring(0, a.indexOf(".")) === n)
      return;
    const l = {
      codecsChangeInfo: {
        from: a,
        to: i
      }
    };
    t.trigger({
      type: "codecschange",
      metadata: l
    }), t.logger_(`changing ${e}Buffer codec from ${a} to ${i}`);
    try {
      s.changeType(r), t.codecs[e] = i;
    } catch (h) {
      l.errorType = L.Error.StreamingCodecsChangeError, l.error = h, h.metadata = l, t.error_ = h, t.trigger("error"), L.log.warn(`Failed to changeType on ${e}Buffer`, h);
    }
  }
}, Je = ({
  type: i,
  sourceUpdater: e,
  action: t,
  doneFn: s,
  name: r
}) => {
  e.queue.push({
    type: i,
    action: t,
    doneFn: s,
    name: r
  }), qi(i, e);
}, Lc = (i, e) => (t) => {
  const s = e[`${i}Buffered`](), r = iv(s);
  if (e.logger_(`received "updateend" event for ${i} Source Buffer: `, r), e.queuePending[i]) {
    const n = e.queuePending[i].doneFn;
    e.queuePending[i] = null, n && n(e[`${i}Error_`]);
  }
  qi(i, e);
};
class Yf extends L.EventTarget {
  constructor(e) {
    super(), this.mediaSource = e, this.sourceopenListener_ = () => qi("mediaSource", this), this.mediaSource.addEventListener("sourceopen", this.sourceopenListener_), this.logger_ = ot("SourceUpdater"), this.audioTimestampOffset_ = 0, this.videoTimestampOffset_ = 0, this.queue = [], this.queuePending = {
      audio: null,
      video: null
    }, this.delayedAudioAppendQueue_ = [], this.videoAppendQueued_ = !1, this.codecs = {}, this.onVideoUpdateEnd_ = Lc("video", this), this.onAudioUpdateEnd_ = Lc("audio", this), this.onVideoError_ = (t) => {
      this.videoError_ = t;
    }, this.onAudioError_ = (t) => {
      this.audioError_ = t;
    }, this.createdSourceBuffers_ = !1, this.initializedEme_ = !1, this.triggeredReady_ = !1;
  }
  initializedEme() {
    this.initializedEme_ = !0, this.triggerReady();
  }
  hasCreatedSourceBuffers() {
    return this.createdSourceBuffers_;
  }
  hasInitializedAnyEme() {
    return this.initializedEme_;
  }
  ready() {
    return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
  }
  createSourceBuffers(e) {
    this.hasCreatedSourceBuffers() || (this.addOrChangeSourceBuffers(e), this.createdSourceBuffers_ = !0, this.trigger("createdsourcebuffers"), this.triggerReady());
  }
  triggerReady() {
    this.ready() && !this.triggeredReady_ && (this.triggeredReady_ = !0, this.trigger("ready"));
  }
  /**
   * Add a type of source buffer to the media source.
   *
   * @param {string} type
   *        The type of source buffer to add.
   *
   * @param {string} codec
   *        The codec to add the source buffer with.
   */
  addSourceBuffer(e, t) {
    Je({
      type: "mediaSource",
      sourceUpdater: this,
      action: Qe.addSourceBuffer(e, t),
      name: "addSourceBuffer"
    });
  }
  /**
   * call abort on a source buffer.
   *
   * @param {string} type
   *        The type of source buffer to call abort on.
   */
  abort(e) {
    Je({
      type: e,
      sourceUpdater: this,
      action: Qe.abort(e),
      name: "abort"
    });
  }
  /**
   * Call removeSourceBuffer and remove a specific type
   * of source buffer on the mediaSource.
   *
   * @param {string} type
   *        The type of source buffer to remove.
   */
  removeSourceBuffer(e) {
    if (!this.canRemoveSourceBuffer()) {
      L.log.error("removeSourceBuffer is not supported!");
      return;
    }
    Je({
      type: "mediaSource",
      sourceUpdater: this,
      action: Qe.removeSourceBuffer(e),
      name: "removeSourceBuffer"
    });
  }
  /**
   * Whether or not the removeSourceBuffer function is supported
   * on the mediaSource.
   *
   * @return {boolean}
   *          if removeSourceBuffer can be called.
   */
  canRemoveSourceBuffer() {
    return !L.browser.IS_FIREFOX && S.MediaSource && S.MediaSource.prototype && typeof S.MediaSource.prototype.removeSourceBuffer == "function";
  }
  /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */
  static canChangeType() {
    return S.SourceBuffer && S.SourceBuffer.prototype && typeof S.SourceBuffer.prototype.changeType == "function";
  }
  /**
   * Whether or not the changeType function is supported
   * on our SourceBuffers.
   *
   * @return {boolean}
   *         if changeType can be called.
   */
  canChangeType() {
    return this.constructor.canChangeType();
  }
  /**
   * Call the changeType function on a source buffer, given the code and type.
   *
   * @param {string} type
   *        The type of source buffer to call changeType on.
   *
   * @param {string} codec
   *        The codec string to change type with on the source buffer.
   */
  changeType(e, t) {
    if (!this.canChangeType()) {
      L.log.error("changeType is not supported!");
      return;
    }
    Je({
      type: e,
      sourceUpdater: this,
      action: Qe.changeType(t),
      name: "changeType"
    });
  }
  /**
   * Add source buffers with a codec or, if they are already created,
   * call changeType on source buffers using changeType.
   *
   * @param {Object} codecs
   *        Codecs to switch to
   */
  addOrChangeSourceBuffers(e) {
    if (!e || typeof e != "object" || Object.keys(e).length === 0)
      throw new Error("Cannot addOrChangeSourceBuffers to undefined codecs");
    Object.keys(e).forEach((t) => {
      const s = e[t];
      if (!this.hasCreatedSourceBuffers())
        return this.addSourceBuffer(t, s);
      this.canChangeType() && this.changeType(t, s);
    });
  }
  /**
   * Queue an update to append an ArrayBuffer.
   *
   * @param {MediaObject} object containing audioBytes and/or videoBytes
   * @param {Function} done the function to call when done
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-appendBuffer-void-ArrayBuffer-data
   */
  appendBuffer(e, t) {
    const {
      segmentInfo: s,
      type: r,
      bytes: n
    } = e;
    if (this.processedAppend_ = !0, r === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
      this.delayedAudioAppendQueue_.push([e, t]), this.logger_(`delayed audio append of ${n.length} until video append`);
      return;
    }
    const a = t;
    if (Je({
      type: r,
      sourceUpdater: this,
      action: Qe.appendBuffer(n, s || {
        mediaIndex: -1
      }, a),
      doneFn: t,
      name: "appendBuffer"
    }), r === "video") {
      if (this.videoAppendQueued_ = !0, !this.delayedAudioAppendQueue_.length)
        return;
      const o = this.delayedAudioAppendQueue_.slice();
      this.logger_(`queuing delayed audio ${o.length} appendBuffers`), this.delayedAudioAppendQueue_.length = 0, o.forEach((l) => {
        this.appendBuffer.apply(this, l);
      });
    }
  }
  /**
   * Get the audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The audio buffer's buffered time range
   */
  audioBuffered() {
    return gt(this.mediaSource, this.audioBuffer) && this.audioBuffer.buffered ? this.audioBuffer.buffered : ke();
  }
  /**
   * Get the video buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         The video buffer's buffered time range
   */
  videoBuffered() {
    return gt(this.mediaSource, this.videoBuffer) && this.videoBuffer.buffered ? this.videoBuffer.buffered : ke();
  }
  /**
   * Get a combined video/audio buffer's buffered timerange.
   *
   * @return {TimeRange}
   *         the combined time range
   */
  buffered() {
    const e = gt(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null, t = gt(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
    return t && !e ? this.audioBuffered() : e && !t ? this.videoBuffered() : rv(this.audioBuffered(), this.videoBuffered());
  }
  /**
   * Add a callback to the queue that will set duration on the mediaSource.
   *
   * @param {number} duration
   *        The duration to set
   *
   * @param {Function} [doneFn]
   *        function to run after duration has been set.
   */
  setDuration(e, t = Ot) {
    Je({
      type: "mediaSource",
      sourceUpdater: this,
      action: Qe.duration(e),
      name: "duration",
      doneFn: t
    });
  }
  /**
   * Add a mediaSource endOfStream call to the queue
   *
   * @param {Error} [error]
   *        Call endOfStream with an error
   *
   * @param {Function} [doneFn]
   *        A function that should be called when the
   *        endOfStream call has finished.
   */
  endOfStream(e = null, t = Ot) {
    typeof e != "string" && (e = void 0), Je({
      type: "mediaSource",
      sourceUpdater: this,
      action: Qe.endOfStream(e),
      name: "endOfStream",
      doneFn: t
    });
  }
  /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */
  removeAudio(e, t, s = Ot) {
    if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
      s();
      return;
    }
    Je({
      type: "audio",
      sourceUpdater: this,
      action: Qe.remove(e, t),
      doneFn: s,
      name: "remove"
    });
  }
  /**
   * Queue an update to remove a time range from the buffer.
   *
   * @param {number} start where to start the removal
   * @param {number} end where to end the removal
   * @param {Function} [done=noop] optional callback to be executed when the remove
   * operation is complete
   * @see http://www.w3.org/TR/media-source/#widl-SourceBuffer-remove-void-double-start-unrestricted-double-end
   */
  removeVideo(e, t, s = Ot) {
    if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
      s();
      return;
    }
    Je({
      type: "video",
      sourceUpdater: this,
      action: Qe.remove(e, t),
      doneFn: s,
      name: "remove"
    });
  }
  /**
   * Whether the underlying sourceBuffer is updating or not
   *
   * @return {boolean} the updating status of the SourceBuffer
   */
  updating() {
    return !!(uo("audio", this) || uo("video", this));
  }
  /**
   * Set/get the timestampoffset on the audio SourceBuffer
   *
   * @return {number} the timestamp offset
   */
  audioTimestampOffset(e) {
    return typeof e < "u" && this.audioBuffer && // no point in updating if it's the same
    this.audioTimestampOffset_ !== e && (Je({
      type: "audio",
      sourceUpdater: this,
      action: Qe.timestampOffset(e),
      name: "timestampOffset"
    }), this.audioTimestampOffset_ = e), this.audioTimestampOffset_;
  }
  /**
   * Set/get the timestampoffset on the video SourceBuffer
   *
   * @return {number} the timestamp offset
   */
  videoTimestampOffset(e) {
    return typeof e < "u" && this.videoBuffer && // no point in updating if it's the same
    this.videoTimestampOffset_ !== e && (Je({
      type: "video",
      sourceUpdater: this,
      action: Qe.timestampOffset(e),
      name: "timestampOffset"
    }), this.videoTimestampOffset_ = e), this.videoTimestampOffset_;
  }
  /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the audio queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */
  audioQueueCallback(e) {
    this.audioBuffer && Je({
      type: "audio",
      sourceUpdater: this,
      action: Qe.callback(e),
      name: "callback"
    });
  }
  /**
   * Add a function to the queue that will be called
   * when it is its turn to run in the video queue.
   *
   * @param {Function} callback
   *        The callback to queue.
   */
  videoQueueCallback(e) {
    this.videoBuffer && Je({
      type: "video",
      sourceUpdater: this,
      action: Qe.callback(e),
      name: "callback"
    });
  }
  /**
   * dispose of the source updater and the underlying sourceBuffer
   */
  dispose() {
    this.trigger("dispose"), j2.forEach((e) => {
      this.abort(e), this.canRemoveSourceBuffer() ? this.removeSourceBuffer(e) : this[`${e}QueueCallback`](() => Kf(e, this));
    }), this.videoAppendQueued_ = !1, this.delayedAudioAppendQueue_.length = 0, this.sourceopenListener_ && this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_), this.off();
  }
}
const Rc = (i) => decodeURIComponent(escape(String.fromCharCode.apply(null, i))), V2 = (i) => {
  const e = new Uint8Array(i);
  return Array.from(e).map((t) => t.toString(16).padStart(2, "0")).join("");
}, Nc = new Uint8Array(`

`.split("").map((i) => i.charCodeAt(0)));
class z2 extends Error {
  constructor() {
    super("Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.");
  }
}
class G2 extends oo {
  constructor(e, t = {}) {
    super(e, t), this.mediaSource_ = null, this.subtitlesTrack_ = null, this.featuresNativeTextTracks_ = e.featuresNativeTextTracks, this.loadVttJs = e.loadVttJs, this.shouldSaveSegmentTimingInfo_ = !1;
  }
  createTransmuxer_() {
    return null;
  }
  /**
   * Indicates which time ranges are buffered
   *
   * @return {TimeRange}
   *         TimeRange object representing the current buffered ranges
   */
  buffered_() {
    if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length)
      return ke();
    const e = this.subtitlesTrack_.cues, t = e[0].startTime, s = e[e.length - 1].startTime;
    return ke([[t, s]]);
  }
  /**
   * Gets and sets init segment for the provided map
   *
   * @param {Object} map
   *        The map object representing the init segment to get or set
   * @param {boolean=} set
   *        If true, the init segment for the provided map should be saved
   * @return {Object}
   *         map object for desired init segment
   */
  initSegmentForMap(e, t = !1) {
    if (!e)
      return null;
    const s = fn(e);
    let r = this.initSegments_[s];
    if (t && !r && e.bytes) {
      const n = Nc.byteLength + e.bytes.byteLength, a = new Uint8Array(n);
      a.set(e.bytes), a.set(Nc, e.bytes.byteLength), this.initSegments_[s] = r = {
        resolvedUri: e.resolvedUri,
        byterange: e.byterange,
        bytes: a
      };
    }
    return r || e;
  }
  /**
   * Returns true if all configuration required for loading is present, otherwise false.
   *
   * @return {boolean} True if the all configuration is ready for loading
   * @private
   */
  couldBeginLoading_() {
    return this.playlist_ && this.subtitlesTrack_ && !this.paused();
  }
  /**
   * Once all the starting parameters have been specified, begin
   * operation. This method should only be invoked from the INIT
   * state.
   *
   * @private
   */
  init_() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }
  /**
   * Set a subtitle track on the segment loader to add subtitles to
   *
   * @param {TextTrack=} track
   *        The text track to add loaded subtitles to
   * @return {TextTrack}
   *        Returns the subtitles track
   */
  track(e) {
    return typeof e > "u" ? this.subtitlesTrack_ : (this.subtitlesTrack_ = e, this.state === "INIT" && this.couldBeginLoading_() && this.init_(), this.subtitlesTrack_);
  }
  /**
   * Remove any data in the source buffer between start and end times
   *
   * @param {number} start - the start time of the region to remove from the buffer
   * @param {number} end - the end time of the region to remove from the buffer
   */
  remove(e, t) {
    Ls(e, t, this.subtitlesTrack_);
  }
  /**
   * fill the buffer with segements unless the sourceBuffers are
   * currently updating
   *
   * Note: this function should only ever be called by monitorBuffer_
   * and never directly
   *
   * @private
   */
  fillBuffer_() {
    const e = this.chooseNextRequest_();
    if (e) {
      if (this.syncController_.timestampOffsetForTimeline(e.timeline) === null) {
        const t = () => {
          this.state = "READY", this.paused() || this.monitorBuffer_();
        };
        this.syncController_.one("timestampoffset", t), this.state = "WAITING_ON_TIMELINE";
        return;
      }
      this.loadSegment_(e);
    }
  }
  // never set a timestamp offset for vtt segments.
  timestampOffsetForSegment_() {
    return null;
  }
  chooseNextRequest_() {
    return this.skipEmptySegments_(super.chooseNextRequest_());
  }
  /**
   * Prevents the segment loader from requesting segments we know contain no subtitles
   * by walking forward until we find the next segment that we don't know whether it is
   * empty or not.
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @return {Object}
   *         a segment info object that describes the current segment
   */
  skipEmptySegments_(e) {
    for (; e && e.segment.empty; ) {
      if (e.mediaIndex + 1 >= e.playlist.segments.length) {
        e = null;
        break;
      }
      e = this.generateSegmentInfo_({
        playlist: e.playlist,
        mediaIndex: e.mediaIndex + 1,
        startOfSegment: e.startOfSegment + e.duration,
        isSyncRequest: e.isSyncRequest
      });
    }
    return e;
  }
  stopForError(e) {
    this.error(e), this.state = "READY", this.pause(), this.trigger("error");
  }
  /**
   * append a decrypted segement to the SourceBuffer through a SourceUpdater
   *
   * @private
   */
  segmentRequestFinished_(e, t, s) {
    if (!this.subtitlesTrack_) {
      this.state = "READY";
      return;
    }
    if (this.saveTransferStats_(t.stats), !this.pendingSegment_) {
      this.state = "READY", this.mediaRequestsAborted += 1;
      return;
    }
    if (e) {
      e.code === vt.TIMEOUT && this.handleTimeout_(), e.code === vt.ABORTED ? this.mediaRequestsAborted += 1 : this.mediaRequestsErrored += 1, this.stopForError(e);
      return;
    }
    const r = this.pendingSegment_;
    this.saveBandwidthRelatedStats_(r.duration, t.stats), t.key && this.segmentKey(t.key, !0), this.state = "APPENDING", this.trigger("appending");
    const n = r.segment;
    if (n.map && (n.map.bytes = t.map.bytes), r.bytes = t.bytes, typeof S.WebVTT != "function" && typeof this.loadVttJs == "function") {
      this.state = "WAITING_ON_VTTJS", this.loadVttJs().then(() => this.segmentRequestFinished_(e, t, s), () => this.stopForError({
        message: "Error loading vtt.js"
      }));
      return;
    }
    n.requested = !0;
    try {
      this.parseVTTCues_(r);
    } catch (a) {
      this.stopForError({
        message: a.message,
        metadata: {
          errorType: L.Error.StreamingVttParserError,
          error: a
        }
      });
      return;
    }
    if (this.updateTimeMapping_(r, this.syncController_.timelines[r.timeline], this.playlist_), r.cues.length ? r.timingInfo = {
      start: r.cues[0].startTime,
      end: r.cues[r.cues.length - 1].endTime
    } : r.timingInfo = {
      start: r.startOfSegment,
      end: r.startOfSegment + r.duration
    }, r.isSyncRequest) {
      this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
      return;
    }
    r.byteLength = r.bytes.byteLength, this.mediaSecondsLoaded += n.duration, r.cues.forEach((a) => {
      this.subtitlesTrack_.addCue(this.featuresNativeTextTracks_ ? new S.VTTCue(a.startTime, a.endTime, a.text) : a);
    }), D2(this.subtitlesTrack_), this.handleAppendsDone_();
  }
  handleData_() {
  }
  updateTimingInfoEnd_() {
  }
  /**
   * Uses the WebVTT parser to parse the segment response
   *
   * @throws NoVttJsError
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @private
   */
  parseVTTCues_(e) {
    let t, s = !1;
    if (typeof S.WebVTT != "function")
      throw new z2();
    typeof S.TextDecoder == "function" ? t = new S.TextDecoder("utf8") : (t = S.WebVTT.StringDecoder(), s = !0);
    const r = new S.WebVTT.Parser(S, S.vttjs, t);
    if (e.cues = [], e.timestampmap = {
      MPEGTS: 0,
      LOCAL: 0
    }, r.oncue = e.cues.push.bind(e.cues), r.ontimestampmap = (a) => {
      e.timestampmap = a;
    }, r.onparsingerror = (a) => {
      L.log.warn("Error encountered when parsing cues: " + a.message);
    }, e.segment.map) {
      let a = e.segment.map.bytes;
      s && (a = Rc(a)), r.parse(a);
    }
    let n = e.bytes;
    s && (n = Rc(n)), r.parse(n), r.flush();
  }
  /**
   * Updates the start and end times of any cues parsed by the WebVTT parser using
   * the information parsed from the X-TIMESTAMP-MAP header and a TS to media time mapping
   * from the SyncController
   *
   * @param {Object} segmentInfo
   *        a segment info object that describes the current segment
   * @param {Object} mappingObj
   *        object containing a mapping from TS to media time
   * @param {Object} playlist
   *        the playlist object containing the segment
   * @private
   */
  updateTimeMapping_(e, t, s) {
    const r = e.segment;
    if (!t)
      return;
    if (!e.cues.length) {
      r.empty = !0;
      return;
    }
    const {
      MPEGTS: n,
      LOCAL: a
    } = e.timestampmap, l = n / ci.ONE_SECOND_IN_TS - a + t.mapping;
    if (e.cues.forEach((h) => {
      const m = h.endTime - h.startTime, _ = this.handleRollover_(h.startTime + l, t.time);
      h.startTime = Math.max(_, 0), h.endTime = Math.max(_ + m, 0);
    }), !s.syncInfo) {
      const h = e.cues[0].startTime, m = e.cues[e.cues.length - 1].startTime;
      s.syncInfo = {
        mediaSequence: s.mediaSequence + e.mediaIndex,
        time: Math.min(h, m - r.duration)
      };
    }
  }
  /**
   * MPEG-TS PES timestamps are limited to 2^33.
   * Once they reach 2^33, they roll over to 0.
   * mux.js handles PES timestamp rollover for the following scenarios:
   * [forward rollover(right)] ->
   *    PES timestamps monotonically increase, and once they reach 2^33, they roll over to 0
   * [backward rollover(left)] -->
   *    we seek back to position before rollover.
   *
   * According to the HLS SPEC:
   * When synchronizing WebVTT with PES timestamps, clients SHOULD account
   * for cases where the 33-bit PES timestamps have wrapped and the WebVTT
   * cue times have not.  When the PES timestamp wraps, the WebVTT Segment
   * SHOULD have a X-TIMESTAMP-MAP header that maps the current WebVTT
   * time to the new (low valued) PES timestamp.
   *
   * So we want to handle rollover here and align VTT Cue start/end time to the player's time.
   */
  handleRollover_(e, t) {
    if (t === null)
      return e;
    let s = e * ci.ONE_SECOND_IN_TS;
    const r = t * ci.ONE_SECOND_IN_TS;
    let n;
    for (r < s ? n = -8589934592 : n = 8589934592; Math.abs(s - r) > 4294967296; )
      s += n;
    return s / ci.ONE_SECOND_IN_TS;
  }
}
const W2 = function(i, e) {
  const t = i.cues;
  for (let s = 0; s < t.length; s++) {
    const r = t[s];
    if (e >= r.adStartTime && e <= r.adEndTime)
      return r;
  }
  return null;
}, X2 = function(i, e, t = 0) {
  if (!i.segments)
    return;
  let s = t, r;
  for (let n = 0; n < i.segments.length; n++) {
    const a = i.segments[n];
    if (r || (r = W2(e, s + a.duration / 2)), r) {
      if ("cueIn" in a) {
        r.endTime = s, r.adEndTime = s, s += a.duration, r = null;
        continue;
      }
      if (s < r.endTime) {
        s += a.duration;
        continue;
      }
      r.endTime += a.duration;
    } else if ("cueOut" in a && (r = new S.VTTCue(s, s + a.duration, a.cueOut), r.adStartTime = s, r.adEndTime = s + parseFloat(a.cueOut), e.addCue(r)), "cueOutCont" in a) {
      const [o, l] = a.cueOutCont.split("/").map(parseFloat);
      r = new S.VTTCue(s, s + a.duration, ""), r.adStartTime = s - o, r.adEndTime = r.adStartTime + l, e.addCue(r);
    }
    s += a.duration;
  }
};
class Mc {
  /**
   * @param {number} start - media sequence start
   * @param {number} end - media sequence end
   * @param {number} segmentIndex - index for associated segment
   * @param {number|null} [partIndex] - index for associated part
   * @param {boolean} [appended] - appended indicator
   *
   */
  constructor({
    start: e,
    end: t,
    segmentIndex: s,
    partIndex: r = null,
    appended: n = !1
  }) {
    this.start_ = e, this.end_ = t, this.segmentIndex_ = s, this.partIndex_ = r, this.appended_ = n;
  }
  isInRange(e) {
    return e >= this.start && e < this.end;
  }
  markAppended() {
    this.appended_ = !0;
  }
  resetAppendedStatus() {
    this.appended_ = !1;
  }
  get isAppended() {
    return this.appended_;
  }
  get start() {
    return this.start_;
  }
  get end() {
    return this.end_;
  }
  get segmentIndex() {
    return this.segmentIndex_;
  }
  get partIndex() {
    return this.partIndex_;
  }
}
class K2 {
  /**
   *
   * @param {SyncInfo} segmentSyncInfo - sync info for a given segment
   * @param {Array<SyncInfo>} [partsSyncInfo] - sync infos for a list of parts for a given segment
   */
  constructor(e, t = []) {
    this.segmentSyncInfo_ = e, this.partsSyncInfo_ = t;
  }
  get segmentSyncInfo() {
    return this.segmentSyncInfo_;
  }
  get partsSyncInfo() {
    return this.partsSyncInfo_;
  }
  get hasPartsSyncInfo() {
    return this.partsSyncInfo_.length > 0;
  }
  resetAppendStatus() {
    this.segmentSyncInfo_.resetAppendedStatus(), this.partsSyncInfo_.forEach((e) => e.resetAppendedStatus());
  }
}
class Qf {
  constructor() {
    this.storage_ = /* @__PURE__ */ new Map(), this.diagnostics_ = "", this.isReliable_ = !1, this.start_ = -1 / 0, this.end_ = 1 / 0;
  }
  get start() {
    return this.start_;
  }
  get end() {
    return this.end_;
  }
  get diagnostics() {
    return this.diagnostics_;
  }
  get isReliable() {
    return this.isReliable_;
  }
  resetAppendedStatus() {
    this.storage_.forEach((e) => e.resetAppendStatus());
  }
  /**
   * update sync storage
   *
   * @param {Object} playlist
   * @param {number} currentTime
   *
   * @return {void}
   */
  update(e, t) {
    const {
      mediaSequence: s,
      segments: r
    } = e;
    if (this.isReliable_ = this.isReliablePlaylist_(s, r), !!this.isReliable_)
      return this.updateStorage_(r, s, this.calculateBaseTime_(s, t));
  }
  /**
   * @param {number} targetTime
   * @return {SyncInfo|null}
   */
  getSyncInfoForTime(e) {
    for (const {
      segmentSyncInfo: t,
      partsSyncInfo: s
    } of this.storage_.values())
      if (s.length) {
        for (const r of s)
          if (r.isInRange(e))
            return r;
      } else if (t.isInRange(e))
        return t;
    return null;
  }
  getSyncInfoForMediaSequence(e) {
    return this.storage_.get(e);
  }
  updateStorage_(e, t, s) {
    const r = /* @__PURE__ */ new Map();
    let n = `
`, a = s, o = t;
    this.start_ = a, e.forEach((l, h) => {
      const m = this.storage_.get(o), _ = a, v = _ + l.duration, C = !!(m && m.segmentSyncInfo && m.segmentSyncInfo.isAppended), A = new Mc({
        start: _,
        end: v,
        appended: C,
        segmentIndex: h
      });
      l.syncInfo = A;
      let y = a;
      const D = (l.parts || []).map((w, O) => {
        const P = y, R = y + w.duration, I = !!(m && m.partsSyncInfo && m.partsSyncInfo[O] && m.partsSyncInfo[O].isAppended), B = new Mc({
          start: P,
          end: R,
          appended: I,
          segmentIndex: h,
          partIndex: O
        });
        return y = R, n += `Media Sequence: ${o}.${O} | Range: ${P} --> ${R} | Appended: ${I}
`, w.syncInfo = B, B;
      });
      r.set(o, new K2(A, D)), n += `${Wf(l.resolvedUri)} | Media Sequence: ${o} | Range: ${_} --> ${v} | Appended: ${C}
`, o++, a = v;
    }), this.end_ = a, this.storage_ = r, this.diagnostics_ = n;
  }
  calculateBaseTime_(e, t) {
    return this.storage_.size ? this.storage_.has(e) ? this.storage_.get(e).segmentSyncInfo.start : t : 0;
  }
  isReliablePlaylist_(e, t) {
    return e != null && Array.isArray(t) && t.length;
  }
}
class Bc extends Qf {
  constructor(e) {
    super(), this.parent_ = e;
  }
  calculateBaseTime_(e, t) {
    if (!this.storage_.size) {
      const s = this.parent_.getSyncInfoForMediaSequence(e);
      return s ? s.segmentSyncInfo.start : 0;
    }
    return super.calculateBaseTime_(e, t);
  }
}
const Y2 = 86400, Ra = [
  // Stategy "VOD": Handle the VOD-case where the sync-point is *always*
  //                the equivalence display-time 0 === segment-index 0
  {
    name: "VOD",
    run: (i, e, t, s, r) => t !== 1 / 0 ? {
      time: 0,
      segmentIndex: 0,
      partIndex: null
    } : null
  },
  {
    name: "MediaSequence",
    /**
     * run media sequence strategy
     *
     * @param {SyncController} syncController
     * @param {Object} playlist
     * @param {number} duration
     * @param {number} currentTimeline
     * @param {number} currentTime
     * @param {string} type
     */
    run: (i, e, t, s, r, n) => {
      const a = i.getMediaSequenceSync(n);
      if (!a || !a.isReliable)
        return null;
      const o = a.getSyncInfoForTime(r);
      return o ? {
        time: o.start,
        partIndex: o.partIndex,
        segmentIndex: o.segmentIndex
      } : null;
    }
  },
  // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
  {
    name: "ProgramDateTime",
    run: (i, e, t, s, r) => {
      if (!Object.keys(i.timelineToDatetimeMappings).length)
        return null;
      let n = null, a = null;
      const o = Ja(e);
      r = r || 0;
      for (let l = 0; l < o.length; l++) {
        const h = e.endList || r === 0 ? l : o.length - (l + 1), m = o[h], _ = m.segment, v = i.timelineToDatetimeMappings[_.timeline];
        if (!v || !_.dateTimeObject)
          continue;
        let A = _.dateTimeObject.getTime() / 1e3 + v;
        if (_.parts && typeof m.partIndex == "number")
          for (let D = 0; D < m.partIndex; D++)
            A += _.parts[D].duration;
        const y = Math.abs(r - A);
        if (a !== null && (y === 0 || a < y))
          break;
        a = y, n = {
          time: A,
          segmentIndex: m.segmentIndex,
          partIndex: m.partIndex
        };
      }
      return n;
    }
  },
  // Stategy "Segment": We have a known time mapping for a timeline and a
  //                    segment in the current timeline with timing data
  {
    name: "Segment",
    run: (i, e, t, s, r) => {
      let n = null, a = null;
      r = r || 0;
      const o = Ja(e);
      for (let l = 0; l < o.length; l++) {
        const h = e.endList || r === 0 ? l : o.length - (l + 1), m = o[h], _ = m.segment, v = m.part && m.part.start || _ && _.start;
        if (_.timeline === s && typeof v < "u") {
          const C = Math.abs(r - v);
          if (a !== null && a < C)
            break;
          (!n || a === null || a >= C) && (a = C, n = {
            time: v,
            segmentIndex: m.segmentIndex,
            partIndex: m.partIndex
          });
        }
      }
      return n;
    }
  },
  // Stategy "Discontinuity": We have a discontinuity with a known
  //                          display-time
  {
    name: "Discontinuity",
    run: (i, e, t, s, r) => {
      let n = null;
      if (r = r || 0, e.discontinuityStarts && e.discontinuityStarts.length) {
        let a = null;
        for (let o = 0; o < e.discontinuityStarts.length; o++) {
          const l = e.discontinuityStarts[o], h = e.discontinuitySequence + o + 1, m = i.discontinuities[h];
          if (m) {
            const _ = Math.abs(r - m.time);
            if (a !== null && a < _)
              break;
            (!n || a === null || a >= _) && (a = _, n = {
              time: m.time,
              segmentIndex: l,
              partIndex: null
            });
          }
        }
      }
      return n;
    }
  },
  // Stategy "Playlist": We have a playlist with a known mapping of
  //                     segment index to display time
  {
    name: "Playlist",
    run: (i, e, t, s, r) => e.syncInfo ? {
      time: e.syncInfo.time,
      segmentIndex: e.syncInfo.mediaSequence - e.mediaSequence,
      partIndex: null
    } : null
  }
];
class Q2 extends L.EventTarget {
  constructor(e = {}) {
    super(), this.timelines = [], this.discontinuities = [], this.timelineToDatetimeMappings = {};
    const t = new Qf(), s = new Bc(t), r = new Bc(t);
    this.mediaSequenceStorage_ = {
      main: t,
      audio: s,
      vtt: r
    }, this.logger_ = ot("SyncController");
  }
  /**
   *
   * @param {string} loaderType
   * @return {MediaSequenceSync|null}
   */
  getMediaSequenceSync(e) {
    return this.mediaSequenceStorage_[e] || null;
  }
  /**
   * Find a sync-point for the playlist specified
   *
   * A sync-point is defined as a known mapping from display-time to
   * a segment-index in the current playlist.
   *
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinite if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Object}
   *          A sync-point object
   */
  getSyncPoint(e, t, s, r, n) {
    if (t !== 1 / 0)
      return Ra.find(({
        name: l
      }) => l === "VOD").run(this, e, t);
    const a = this.runStrategies_(e, t, s, r, n);
    if (!a.length)
      return null;
    for (const o of a) {
      const {
        syncPoint: l,
        strategy: h
      } = o, {
        segmentIndex: m,
        time: _
      } = l;
      if (m < 0)
        continue;
      const v = e.segments[m], C = _, A = C + v.duration;
      if (this.logger_(`Strategy: ${h}. Current time: ${r}. selected segment: ${m}. Time: [${C} -> ${A}]}`), r >= C && r < A)
        return this.logger_("Found sync point with exact match: ", l), l;
    }
    return this.selectSyncPoint_(a, {
      key: "time",
      value: r
    });
  }
  /**
   * Calculate the amount of time that has expired off the playlist during playback
   *
   * @param {Playlist} playlist
   *        Playlist object to calculate expired from
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playling a live source)
   * @return {number|null}
   *          The amount of time that has expired off the playlist during playback. Null
   *          if no sync-points for the playlist can be found.
   */
  getExpiredTime(e, t) {
    if (!e || !e.segments)
      return null;
    const s = this.runStrategies_(e, t, e.discontinuitySequence, 0);
    if (!s.length)
      return null;
    const r = this.selectSyncPoint_(s, {
      key: "segmentIndex",
      value: 0
    });
    return r.segmentIndex > 0 && (r.time *= -1), Math.abs(r.time + Us({
      defaultDuration: e.targetDuration,
      durationList: e.segments,
      startIndex: r.segmentIndex,
      endIndex: 0
    }));
  }
  /**
   * Runs each sync-point strategy and returns a list of sync-points returned by the
   * strategies
   *
   * @private
   * @param {Playlist} playlist
   *        The playlist that needs a sync-point
   * @param {number} duration
   *        Duration of the MediaSource (Infinity if playing a live source)
   * @param {number} currentTimeline
   *        The last timeline from which a segment was loaded
   * @param {number} currentTime
   *        Current player's time
   * @param {string} type
   *        Segment loader type
   * @return {Array}
   *          A list of sync-point objects
   */
  runStrategies_(e, t, s, r, n) {
    const a = [];
    for (let o = 0; o < Ra.length; o++) {
      const l = Ra[o], h = l.run(this, e, t, s, r, n);
      h && (h.strategy = l.name, a.push({
        strategy: l.name,
        syncPoint: h
      }));
    }
    return a;
  }
  /**
   * Selects the sync-point nearest the specified target
   *
   * @private
   * @param {Array} syncPoints
   *        List of sync-points to select from
   * @param {Object} target
   *        Object specifying the property and value we are targeting
   * @param {string} target.key
   *        Specifies the property to target. Must be either 'time' or 'segmentIndex'
   * @param {number} target.value
   *        The value to target for the specified key.
   * @return {Object}
   *          The sync-point nearest the target
   */
  selectSyncPoint_(e, t) {
    let s = e[0].syncPoint, r = Math.abs(e[0].syncPoint[t.key] - t.value), n = e[0].strategy;
    for (let a = 1; a < e.length; a++) {
      const o = Math.abs(e[a].syncPoint[t.key] - t.value);
      o < r && (r = o, s = e[a].syncPoint, n = e[a].strategy);
    }
    return this.logger_(`syncPoint for [${t.key}: ${t.value}] chosen with strategy [${n}]: [time:${s.time}, segmentIndex:${s.segmentIndex}` + (typeof s.partIndex == "number" ? `,partIndex:${s.partIndex}` : "") + "]"), s;
  }
  /**
   * Save any meta-data present on the segments when segments leave
   * the live window to the playlist to allow for synchronization at the
   * playlist level later.
   *
   * @param {Playlist} oldPlaylist - The previous active playlist
   * @param {Playlist} newPlaylist - The updated and most current playlist
   */
  saveExpiredSegmentInfo(e, t) {
    const s = t.mediaSequence - e.mediaSequence;
    if (s > Y2) {
      L.log.warn(`Not saving expired segment info. Media sequence gap ${s} is too large.`);
      return;
    }
    for (let r = s - 1; r >= 0; r--) {
      const n = e.segments[r];
      if (n && typeof n.start < "u") {
        t.syncInfo = {
          mediaSequence: e.mediaSequence + r,
          time: n.start
        }, this.logger_(`playlist refresh sync: [time:${t.syncInfo.time}, mediaSequence: ${t.syncInfo.mediaSequence}]`), this.trigger("syncinfoupdate");
        break;
      }
    }
  }
  /**
   * Save the mapping from playlist's ProgramDateTime to display. This should only happen
   * before segments start to load.
   *
   * @param {Playlist} playlist - The currently active playlist
   */
  setDateTimeMappingForStart(e) {
    if (this.timelineToDatetimeMappings = {}, e.segments && e.segments.length && e.segments[0].dateTimeObject) {
      const t = e.segments[0], s = t.dateTimeObject.getTime() / 1e3;
      this.timelineToDatetimeMappings[t.timeline] = -s;
    }
  }
  /**
   * Calculates and saves timeline mappings, playlist sync info, and segment timing values
   * based on the latest timing information.
   *
   * @param {Object} options
   *        Options object
   * @param {SegmentInfo} options.segmentInfo
   *        The current active request information
   * @param {boolean} options.shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved for timeline mapping and program date time mappings.
   */
  saveSegmentTimingInfo({
    segmentInfo: e,
    shouldSaveTimelineMapping: t
  }) {
    const s = this.calculateSegmentTimeMapping_(e, e.timingInfo, t), r = e.segment;
    s && (this.saveDiscontinuitySyncInfo_(e), e.playlist.syncInfo || (e.playlist.syncInfo = {
      mediaSequence: e.playlist.mediaSequence + e.mediaIndex,
      time: r.start
    }));
    const n = r.dateTimeObject;
    r.discontinuity && t && n && (this.timelineToDatetimeMappings[r.timeline] = -(n.getTime() / 1e3));
  }
  timestampOffsetForTimeline(e) {
    return typeof this.timelines[e] > "u" ? null : this.timelines[e].time;
  }
  mappingForTimeline(e) {
    return typeof this.timelines[e] > "u" ? null : this.timelines[e].mapping;
  }
  /**
   * Use the "media time" for a segment to generate a mapping to "display time" and
   * save that display time to the segment.
   *
   * @private
   * @param {SegmentInfo} segmentInfo
   *        The current active request information
   * @param {Object} timingInfo
   *        The start and end time of the current segment in "media time"
   * @param {boolean} shouldSaveTimelineMapping
   *        If there's a timeline change, determines if the timeline mapping should be
   *        saved in timelines.
   * @return {boolean}
   *          Returns false if segment time mapping could not be calculated
   */
  calculateSegmentTimeMapping_(e, t, s) {
    const r = e.segment, n = e.part;
    let a = this.timelines[e.timeline], o, l;
    if (typeof e.timestampOffset == "number")
      a = {
        time: e.startOfSegment,
        mapping: e.startOfSegment - t.start
      }, s && (this.timelines[e.timeline] = a, this.trigger("timestampoffset"), this.logger_(`time mapping for timeline ${e.timeline}: [time: ${a.time}] [mapping: ${a.mapping}]`)), o = e.startOfSegment, l = t.end + a.mapping;
    else if (a)
      o = t.start + a.mapping, l = t.end + a.mapping;
    else
      return !1;
    return n && (n.start = o, n.end = l), (!r.start || o < r.start) && (r.start = o), r.end = l, !0;
  }
  /**
   * Each time we have discontinuity in the playlist, attempt to calculate the location
   * in display of the start of the discontinuity and save that. We also save an accuracy
   * value so that we save values with the most accuracy (closest to 0.)
   *
   * @private
   * @param {SegmentInfo} segmentInfo - The current active request information
   */
  saveDiscontinuitySyncInfo_(e) {
    const t = e.playlist, s = e.segment;
    if (s.discontinuity)
      this.discontinuities[s.timeline] = {
        time: s.start,
        accuracy: 0
      };
    else if (t.discontinuityStarts && t.discontinuityStarts.length)
      for (let r = 0; r < t.discontinuityStarts.length; r++) {
        const n = t.discontinuityStarts[r], a = t.discontinuitySequence + r + 1, o = n - e.mediaIndex, l = Math.abs(o);
        if (!this.discontinuities[a] || this.discontinuities[a].accuracy > l) {
          let h;
          o < 0 ? h = s.start - Us({
            defaultDuration: t.targetDuration,
            durationList: t.segments,
            startIndex: e.mediaIndex,
            endIndex: n
          }) : h = s.end + Us({
            defaultDuration: t.targetDuration,
            durationList: t.segments,
            startIndex: e.mediaIndex + 1,
            endIndex: n
          }), this.discontinuities[a] = {
            time: h,
            accuracy: l
          };
        }
      }
  }
  dispose() {
    this.trigger("dispose"), this.off();
  }
}
class J2 extends L.EventTarget {
  constructor() {
    super(), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {};
  }
  clearPendingTimelineChange(e) {
    this.pendingTimelineChanges_[e] = null, this.trigger("pendingtimelinechange");
  }
  pendingTimelineChange({
    type: e,
    from: t,
    to: s
  }) {
    return typeof t == "number" && typeof s == "number" && (this.pendingTimelineChanges_[e] = {
      type: e,
      from: t,
      to: s
    }, this.trigger("pendingtimelinechange")), this.pendingTimelineChanges_[e];
  }
  lastTimelineChange({
    type: e,
    from: t,
    to: s
  }) {
    if (typeof t == "number" && typeof s == "number") {
      this.lastTimelineChanges_[e] = {
        type: e,
        from: t,
        to: s
      }, delete this.pendingTimelineChanges_[e];
      const r = {
        timelineChangeInfo: {
          from: t,
          to: s
        }
      };
      this.trigger({
        type: "timelinechange",
        metadata: r
      });
    }
    return this.lastTimelineChanges_[e];
  }
  dispose() {
    this.trigger("dispose"), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {}, this.off();
  }
}
const Z2 = Mf(Bf(function() {
  var i = /* @__PURE__ */ function() {
    function y() {
      this.listeners = {};
    }
    var D = y.prototype;
    return D.on = function(O, P) {
      this.listeners[O] || (this.listeners[O] = []), this.listeners[O].push(P);
    }, D.off = function(O, P) {
      if (!this.listeners[O])
        return !1;
      var R = this.listeners[O].indexOf(P);
      return this.listeners[O] = this.listeners[O].slice(0), this.listeners[O].splice(R, 1), R > -1;
    }, D.trigger = function(O) {
      var P = this.listeners[O];
      if (P)
        if (arguments.length === 2)
          for (var R = P.length, I = 0; I < R; ++I)
            P[I].call(this, arguments[1]);
        else
          for (var B = Array.prototype.slice.call(arguments, 1), H = P.length, $ = 0; $ < H; ++$)
            P[$].apply(this, B);
    }, D.dispose = function() {
      this.listeners = {};
    }, D.pipe = function(O) {
      this.on("data", function(P) {
        O.push(P);
      });
    }, y;
  }();
  /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
  function e(y) {
    return y.subarray(0, y.byteLength - y[y.byteLength - 1]);
  }
  /*! @name aes-decrypter @version 4.0.2 @license Apache-2.0 */
  const t = function() {
    const y = [[[], [], [], [], []], [[], [], [], [], []]], D = y[0], w = y[1], O = D[4], P = w[4];
    let R, I, B;
    const H = [], $ = [];
    let X, ue, J, ne, V, Z;
    for (R = 0; R < 256; R++)
      $[(H[R] = R << 1 ^ (R >> 7) * 283) ^ R] = R;
    for (I = B = 0; !O[I]; I ^= X || 1, B = $[B] || 1)
      for (ne = B ^ B << 1 ^ B << 2 ^ B << 3 ^ B << 4, ne = ne >> 8 ^ ne & 255 ^ 99, O[I] = ne, P[ne] = I, J = H[ue = H[X = H[I]]], Z = J * 16843009 ^ ue * 65537 ^ X * 257 ^ I * 16843008, V = H[ne] * 257 ^ ne * 16843008, R = 0; R < 4; R++)
        D[R][I] = V = V << 24 ^ V >>> 8, w[R][ne] = Z = Z << 24 ^ Z >>> 8;
    for (R = 0; R < 5; R++)
      D[R] = D[R].slice(0), w[R] = w[R].slice(0);
    return y;
  };
  let s = null;
  class r {
    constructor(D) {
      s || (s = t()), this._tables = [[s[0][0].slice(), s[0][1].slice(), s[0][2].slice(), s[0][3].slice(), s[0][4].slice()], [s[1][0].slice(), s[1][1].slice(), s[1][2].slice(), s[1][3].slice(), s[1][4].slice()]];
      let w, O, P;
      const R = this._tables[0][4], I = this._tables[1], B = D.length;
      let H = 1;
      if (B !== 4 && B !== 6 && B !== 8)
        throw new Error("Invalid aes key size");
      const $ = D.slice(0), X = [];
      for (this._key = [$, X], w = B; w < 4 * B + 28; w++)
        P = $[w - 1], (w % B === 0 || B === 8 && w % B === 4) && (P = R[P >>> 24] << 24 ^ R[P >> 16 & 255] << 16 ^ R[P >> 8 & 255] << 8 ^ R[P & 255], w % B === 0 && (P = P << 8 ^ P >>> 24 ^ H << 24, H = H << 1 ^ (H >> 7) * 283)), $[w] = $[w - B] ^ P;
      for (O = 0; w; O++, w--)
        P = $[O & 3 ? w : w - 4], w <= 4 || O < 4 ? X[O] = P : X[O] = I[0][R[P >>> 24]] ^ I[1][R[P >> 16 & 255]] ^ I[2][R[P >> 8 & 255]] ^ I[3][R[P & 255]];
    }
    /**
     * Decrypt 16 bytes, specified as four 32-bit words.
     *
     * @param {number} encrypted0 the first word to decrypt
     * @param {number} encrypted1 the second word to decrypt
     * @param {number} encrypted2 the third word to decrypt
     * @param {number} encrypted3 the fourth word to decrypt
     * @param {Int32Array} out the array to write the decrypted words
     * into
     * @param {number} offset the offset into the output array to start
     * writing results
     * @return {Array} The plaintext.
     */
    decrypt(D, w, O, P, R, I) {
      const B = this._key[1];
      let H = D ^ B[0], $ = P ^ B[1], X = O ^ B[2], ue = w ^ B[3], J, ne, V;
      const Z = B.length / 4 - 2;
      let Re, ee = 4;
      const Te = this._tables[1], Dt = Te[0], Jt = Te[1], Zt = Te[2], ei = Te[3], ti = Te[4];
      for (Re = 0; Re < Z; Re++)
        J = Dt[H >>> 24] ^ Jt[$ >> 16 & 255] ^ Zt[X >> 8 & 255] ^ ei[ue & 255] ^ B[ee], ne = Dt[$ >>> 24] ^ Jt[X >> 16 & 255] ^ Zt[ue >> 8 & 255] ^ ei[H & 255] ^ B[ee + 1], V = Dt[X >>> 24] ^ Jt[ue >> 16 & 255] ^ Zt[H >> 8 & 255] ^ ei[$ & 255] ^ B[ee + 2], ue = Dt[ue >>> 24] ^ Jt[H >> 16 & 255] ^ Zt[$ >> 8 & 255] ^ ei[X & 255] ^ B[ee + 3], ee += 4, H = J, $ = ne, X = V;
      for (Re = 0; Re < 4; Re++)
        R[(3 & -Re) + I] = ti[H >>> 24] << 24 ^ ti[$ >> 16 & 255] << 16 ^ ti[X >> 8 & 255] << 8 ^ ti[ue & 255] ^ B[ee++], J = H, H = $, $ = X, X = ue, ue = J;
    }
  }
  class n extends i {
    constructor() {
      super(i), this.jobs = [], this.delay = 1, this.timeout_ = null;
    }
    /**
     * process an async job
     *
     * @private
     */
    processJob_() {
      this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null;
    }
    /**
     * push a job into the stream
     *
     * @param {Function} job the job to push into the stream
     */
    push(D) {
      this.jobs.push(D), this.timeout_ || (this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay));
    }
  }
  const a = function(y) {
    return y << 24 | (y & 65280) << 8 | (y & 16711680) >> 8 | y >>> 24;
  }, o = function(y, D, w) {
    const O = new Int32Array(y.buffer, y.byteOffset, y.byteLength >> 2), P = new r(Array.prototype.slice.call(D)), R = new Uint8Array(y.byteLength), I = new Int32Array(R.buffer);
    let B, H, $, X, ue, J, ne, V, Z;
    for (B = w[0], H = w[1], $ = w[2], X = w[3], Z = 0; Z < O.length; Z += 4)
      ue = a(O[Z]), J = a(O[Z + 1]), ne = a(O[Z + 2]), V = a(O[Z + 3]), P.decrypt(ue, J, ne, V, I, Z), I[Z] = a(I[Z] ^ B), I[Z + 1] = a(I[Z + 1] ^ H), I[Z + 2] = a(I[Z + 2] ^ $), I[Z + 3] = a(I[Z + 3] ^ X), B = ue, H = J, $ = ne, X = V;
    return R;
  };
  class l {
    constructor(D, w, O, P) {
      const R = l.STEP, I = new Int32Array(D.buffer), B = new Uint8Array(D.byteLength);
      let H = 0;
      for (this.asyncStream_ = new n(), this.asyncStream_.push(this.decryptChunk_(I.subarray(H, H + R), w, O, B)), H = R; H < I.length; H += R)
        O = new Uint32Array([a(I[H - 4]), a(I[H - 3]), a(I[H - 2]), a(I[H - 1])]), this.asyncStream_.push(this.decryptChunk_(I.subarray(H, H + R), w, O, B));
      this.asyncStream_.push(function() {
        P(null, e(B));
      });
    }
    /**
     * a getter for step the maximum number of bytes to process at one time
     *
     * @return {number} the value of step 32000
     */
    static get STEP() {
      return 32e3;
    }
    /**
     * @private
     */
    decryptChunk_(D, w, O, P) {
      return function() {
        const R = o(D, w, O);
        P.set(R, D.byteOffset);
      };
    }
  }
  var h = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, m;
  typeof window < "u" ? m = window : typeof h < "u" ? m = h : typeof self < "u" ? m = self : m = {};
  var _ = m, v = function(D) {
    return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(D) : D && D.buffer instanceof ArrayBuffer;
  }, C = _.BigInt || Number;
  C("0x1"), C("0x100"), C("0x10000"), C("0x1000000"), C("0x100000000"), C("0x10000000000"), C("0x1000000000000"), C("0x100000000000000"), C("0x10000000000000000"), function() {
    var y = new Uint16Array([65484]), D = new Uint8Array(y.buffer, y.byteOffset, y.byteLength);
    return D[0] === 255 ? "big" : D[0] === 204 ? "little" : "unknown";
  }();
  const A = function(y) {
    const D = {};
    return Object.keys(y).forEach((w) => {
      const O = y[w];
      v(O) ? D[w] = {
        bytes: O.buffer,
        byteOffset: O.byteOffset,
        byteLength: O.byteLength
      } : D[w] = O;
    }), D;
  };
  self.onmessage = function(y) {
    const D = y.data, w = new Uint8Array(D.encrypted.bytes, D.encrypted.byteOffset, D.encrypted.byteLength), O = new Uint32Array(D.key.bytes, D.key.byteOffset, D.key.byteLength / 4), P = new Uint32Array(D.iv.bytes, D.iv.byteOffset, D.iv.byteLength / 4);
    new l(w, O, P, function(R, I) {
      self.postMessage(A({
        source: D.source,
        decrypted: I
      }), [I.buffer]);
    });
  };
}));
var eb = Nf(Z2);
const tb = (i) => {
  let e = i.default ? "main" : "alternative";
  return i.characteristics && i.characteristics.indexOf("public.accessibility.describes-video") >= 0 && (e = "main-desc"), e;
}, Jf = (i, e) => {
  i.abort(), i.pause(), e && e.activePlaylistLoader && (e.activePlaylistLoader.pause(), e.activePlaylistLoader = null);
}, lo = (i, e) => {
  e.activePlaylistLoader = i, i.load();
}, ib = (i, e) => () => {
  const {
    segmentLoaders: {
      [i]: t,
      main: s
    },
    mediaTypes: {
      [i]: r
    }
  } = e, n = r.activeTrack(), a = r.getActiveGroup(), o = r.activePlaylistLoader, l = r.lastGroup_;
  if (!(a && l && a.id === l.id) && (r.lastGroup_ = a, r.lastTrack_ = n, Jf(t, r), !(!a || a.isMainPlaylist))) {
    if (!a.playlistLoader) {
      o && s.resetEverything();
      return;
    }
    t.resyncLoader(), lo(a.playlistLoader, r);
  }
}, sb = (i, e) => () => {
  const {
    segmentLoaders: {
      [i]: t
    },
    mediaTypes: {
      [i]: s
    }
  } = e;
  s.lastGroup_ = null, t.abort(), t.pause();
}, rb = (i, e) => () => {
  const {
    mainPlaylistLoader: t,
    segmentLoaders: {
      [i]: s,
      main: r
    },
    mediaTypes: {
      [i]: n
    }
  } = e, a = n.activeTrack(), o = n.getActiveGroup(), l = n.activePlaylistLoader, h = n.lastTrack_;
  if (!(h && a && h.id === a.id) && (n.lastGroup_ = o, n.lastTrack_ = a, Jf(s, n), !!o)) {
    if (o.isMainPlaylist) {
      if (!a || !h || a.id === h.id)
        return;
      const m = e.vhs.playlistController_, _ = m.selectPlaylist();
      if (m.media() === _)
        return;
      n.logger_(`track change. Switching main audio from ${h.id} to ${a.id}`), t.pause(), r.resetEverything(), m.fastQualityChange_(_);
      return;
    }
    if (i === "AUDIO") {
      if (!o.playlistLoader) {
        r.setAudio(!0), r.resetEverything();
        return;
      }
      s.setAudio(!0), r.setAudio(!1);
    }
    if (l === o.playlistLoader) {
      lo(o.playlistLoader, n);
      return;
    }
    s.track && s.track(a), s.resetEverything(), lo(o.playlistLoader, n);
  }
}, gn = {
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning (or error if the playlist is excluded) to
   *         console and switches back to default audio track.
   * @function onError.AUDIO
   */
  AUDIO: (i, e) => () => {
    const {
      mediaTypes: {
        [i]: t
      },
      excludePlaylist: s
    } = e, r = t.activeTrack(), n = t.activeGroup(), a = (n.filter((l) => l.default)[0] || n[0]).id, o = t.tracks[a];
    if (r === o) {
      s({
        error: {
          message: "Problem encountered loading the default audio track."
        }
      });
      return;
    }
    L.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
    for (const l in t.tracks)
      t.tracks[l].enabled = t.tracks[l] === o;
    t.onTrackChanged();
  },
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning to console and disables the active subtitle track
   * @function onError.SUBTITLES
   */
  SUBTITLES: (i, e) => () => {
    const {
      mediaTypes: {
        [i]: t
      }
    } = e;
    L.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track.");
    const s = t.activeTrack();
    s && (s.mode = "disabled"), t.onTrackChanged();
  }
}, Fc = {
  /**
   * Setup event listeners for audio playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.AUDIO
   */
  AUDIO: (i, e, t) => {
    if (!e)
      return;
    const {
      tech: s,
      requestOptions: r,
      segmentLoaders: {
        [i]: n
      }
    } = t;
    e.on("loadedmetadata", () => {
      const a = e.media();
      n.playlist(a, r), (!s.paused() || a.endList && s.preload() !== "none") && n.load();
    }), e.on("loadedplaylist", () => {
      n.playlist(e.media(), r), s.paused() || n.load();
    }), e.on("error", gn[i](i, t));
  },
  /**
   * Setup event listeners for subtitle playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.SUBTITLES
   */
  SUBTITLES: (i, e, t) => {
    const {
      tech: s,
      requestOptions: r,
      segmentLoaders: {
        [i]: n
      },
      mediaTypes: {
        [i]: a
      }
    } = t;
    e.on("loadedmetadata", () => {
      const o = e.media();
      n.playlist(o, r), n.track(a.activeTrack()), (!s.paused() || o.endList && s.preload() !== "none") && n.load();
    }), e.on("loadedplaylist", () => {
      n.playlist(e.media(), r), s.paused() || n.load();
    }), e.on("error", gn[i](i, t));
  }
}, nb = {
  /**
   * Setup PlaylistLoaders and AudioTracks for the audio groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.AUDIO
   */
  AUDIO: (i, e) => {
    const {
      vhs: t,
      sourceType: s,
      segmentLoaders: {
        [i]: r
      },
      requestOptions: n,
      main: {
        mediaGroups: a
      },
      mediaTypes: {
        [i]: {
          groups: o,
          tracks: l,
          logger_: h
        }
      },
      mainPlaylistLoader: m
    } = e, _ = nr(m.main);
    (!a[i] || Object.keys(a[i]).length === 0) && (a[i] = {
      main: {
        default: {
          default: !0
        }
      }
    }, _ && (a[i].main.default.playlists = m.main.playlists));
    for (const v in a[i]) {
      o[v] || (o[v] = []);
      for (const C in a[i][v]) {
        let A = a[i][v][C], y;
        if (_ ? (h(`AUDIO group '${v}' label '${C}' is a main playlist`), A.isMainPlaylist = !0, y = null) : s === "vhs-json" && A.playlists ? y = new Ri(A.playlists[0], t, n) : A.resolvedUri ? y = new Ri(A.resolvedUri, t, n) : A.playlists && s === "dash" ? y = new ro(A.playlists[0], t, n, m) : y = null, A = te({
          id: C,
          playlistLoader: y
        }, A), Fc[i](i, A.playlistLoader, e), o[v].push(A), typeof l[C] > "u") {
          const D = new L.AudioTrack({
            id: C,
            kind: tb(A),
            enabled: !1,
            language: A.language,
            default: A.default,
            label: C
          });
          l[C] = D;
        }
      }
    }
    r.on("error", gn[i](i, e));
  },
  /**
   * Setup PlaylistLoaders and TextTracks for the subtitle groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.SUBTITLES
   */
  SUBTITLES: (i, e) => {
    const {
      tech: t,
      vhs: s,
      sourceType: r,
      segmentLoaders: {
        [i]: n
      },
      requestOptions: a,
      main: {
        mediaGroups: o
      },
      mediaTypes: {
        [i]: {
          groups: l,
          tracks: h
        }
      },
      mainPlaylistLoader: m
    } = e;
    for (const _ in o[i]) {
      l[_] || (l[_] = []);
      for (const v in o[i][_]) {
        if (!s.options_.useForcedSubtitles && o[i][_][v].forced)
          continue;
        let C = o[i][_][v], A;
        if (r === "hls")
          A = new Ri(C.resolvedUri, s, a);
        else if (r === "dash") {
          if (!C.playlists.filter((D) => D.excludeUntil !== 1 / 0).length)
            return;
          A = new ro(C.playlists[0], s, a, m);
        } else r === "vhs-json" && (A = new Ri(
          // if the vhs-json object included the media playlist, use the media playlist
          // as provided, otherwise use the resolved URI to load the playlist
          C.playlists ? C.playlists[0] : C.resolvedUri,
          s,
          a
        ));
        if (C = te({
          id: v,
          playlistLoader: A
        }, C), Fc[i](i, C.playlistLoader, e), l[_].push(C), typeof h[v] > "u") {
          const y = t.addRemoteTextTrack({
            id: v,
            kind: "subtitles",
            default: C.default && C.autoselect,
            language: C.language,
            label: v
          }, !1).track;
          h[v] = y;
        }
      }
    }
    n.on("error", gn[i](i, e));
  },
  /**
   * Setup TextTracks for the closed-caption groups
   *
   * @param {String} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize['CLOSED-CAPTIONS']
   */
  "CLOSED-CAPTIONS": (i, e) => {
    const {
      tech: t,
      main: {
        mediaGroups: s
      },
      mediaTypes: {
        [i]: {
          groups: r,
          tracks: n
        }
      }
    } = e;
    for (const a in s[i]) {
      r[a] || (r[a] = []);
      for (const o in s[i][a]) {
        const l = s[i][a][o];
        if (!/^(?:CC|SERVICE)/.test(l.instreamId))
          continue;
        const h = t.options_.vhs && t.options_.vhs.captionServices || {};
        let m = {
          label: o,
          language: l.language,
          instreamId: l.instreamId,
          default: l.default && l.autoselect
        };
        if (h[m.instreamId] && (m = te(m, h[m.instreamId])), m.default === void 0 && delete m.default, r[a].push(te({
          id: o
        }, l)), typeof n[o] > "u") {
          const _ = t.addRemoteTextTrack({
            id: m.instreamId,
            kind: "captions",
            default: m.default,
            language: m.language,
            label: m.label
          }, !1).track;
          n[o] = _;
        }
      }
    }
  }
}, Zf = (i, e) => {
  for (let t = 0; t < i.length; t++)
    if (cu(e, i[t]) || i[t].playlists && Zf(i[t].playlists, e))
      return !0;
  return !1;
}, ab = (i, e) => (t) => {
  const {
    mainPlaylistLoader: s,
    mediaTypes: {
      [i]: {
        groups: r
      }
    }
  } = e, n = s.media();
  if (!n)
    return null;
  let a = null;
  n.attributes[i] && (a = r[n.attributes[i]]);
  const o = Object.keys(r);
  if (!a)
    if (i === "AUDIO" && o.length > 1 && nr(e.main))
      for (let l = 0; l < o.length; l++) {
        const h = r[o[l]];
        if (Zf(h, n)) {
          a = h;
          break;
        }
      }
    else r.main ? a = r.main : o.length === 1 && (a = r[o[0]]);
  return typeof t > "u" ? a : t === null || !a ? null : a.filter((l) => l.id === t.id)[0] || null;
}, ob = {
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.AUDIO
   */
  AUDIO: (i, e) => () => {
    const {
      mediaTypes: {
        [i]: {
          tracks: t
        }
      }
    } = e;
    for (const s in t)
      if (t[s].enabled)
        return t[s];
    return null;
  },
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.SUBTITLES
   */
  SUBTITLES: (i, e) => () => {
    const {
      mediaTypes: {
        [i]: {
          tracks: t
        }
      }
    } = e;
    for (const s in t)
      if (t[s].mode === "showing" || t[s].mode === "hidden")
        return t[s];
    return null;
  }
}, ub = (i, {
  mediaTypes: e
}) => () => {
  const t = e[i].activeTrack();
  return t ? e[i].activeGroup(t) : null;
}, lb = (i) => {
  ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((h) => {
    nb[h](h, i);
  });
  const {
    mediaTypes: e,
    mainPlaylistLoader: t,
    tech: s,
    vhs: r,
    segmentLoaders: {
      ["AUDIO"]: n,
      main: a
    }
  } = i;
  ["AUDIO", "SUBTITLES"].forEach((h) => {
    e[h].activeGroup = ab(h, i), e[h].activeTrack = ob[h](h, i), e[h].onGroupChanged = ib(h, i), e[h].onGroupChanging = sb(h, i), e[h].onTrackChanged = rb(h, i), e[h].getActiveGroup = ub(h, i);
  });
  const o = e.AUDIO.activeGroup();
  if (o) {
    const h = (o.filter((_) => _.default)[0] || o[0]).id;
    e.AUDIO.tracks[h].enabled = !0, e.AUDIO.onGroupChanged(), e.AUDIO.onTrackChanged(), e.AUDIO.getActiveGroup().playlistLoader ? (a.setAudio(!1), n.setAudio(!0)) : a.setAudio(!0);
  }
  t.on("mediachange", () => {
    ["AUDIO", "SUBTITLES"].forEach((h) => e[h].onGroupChanged());
  }), t.on("mediachanging", () => {
    ["AUDIO", "SUBTITLES"].forEach((h) => e[h].onGroupChanging());
  });
  const l = () => {
    e.AUDIO.onTrackChanged(), s.trigger({
      type: "usage",
      name: "vhs-audio-change"
    });
  };
  s.audioTracks().addEventListener("change", l), s.remoteTextTracks().addEventListener("change", e.SUBTITLES.onTrackChanged), r.on("dispose", () => {
    s.audioTracks().removeEventListener("change", l), s.remoteTextTracks().removeEventListener("change", e.SUBTITLES.onTrackChanged);
  }), s.clearTracks("audio");
  for (const h in e.AUDIO.tracks)
    s.audioTracks().addTrack(e.AUDIO.tracks[h]);
}, cb = () => {
  const i = {};
  return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((e) => {
    i[e] = {
      groups: {},
      tracks: {},
      activePlaylistLoader: null,
      activeGroup: Ot,
      activeTrack: Ot,
      getActiveGroup: Ot,
      onGroupChanged: Ot,
      onTrackChanged: Ot,
      lastTrack_: null,
      logger_: ot(`MediaGroups[${e}]`)
    };
  }), i;
};
class Uc {
  constructor() {
    this.priority_ = [], this.pathwayClones_ = /* @__PURE__ */ new Map();
  }
  set version(e) {
    e === 1 && (this.version_ = e);
  }
  set ttl(e) {
    this.ttl_ = e || 300;
  }
  set reloadUri(e) {
    e && (this.reloadUri_ = Ge(this.reloadUri_, e));
  }
  set priority(e) {
    e && e.length && (this.priority_ = e);
  }
  set pathwayClones(e) {
    e && e.length && (this.pathwayClones_ = new Map(e.map((t) => [t.ID, t])));
  }
  get version() {
    return this.version_;
  }
  get ttl() {
    return this.ttl_;
  }
  get reloadUri() {
    return this.reloadUri_;
  }
  get priority() {
    return this.priority_;
  }
  get pathwayClones() {
    return this.pathwayClones_;
  }
}
class db extends L.EventTarget {
  constructor(e, t) {
    super(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = !1, this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new Uc(), this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.currentPathwayClones = /* @__PURE__ */ new Map(), this.nextPathwayClones = /* @__PURE__ */ new Map(), this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.logger_ = ot("Content Steering"), this.xhr_ = e, this.getBandwidth_ = t;
  }
  /**
   * Assigns the content steering tag properties to the steering controller
   *
   * @param {string} baseUrl the baseURL from the main manifest for resolving the steering manifest url
   * @param {Object} steeringTag the content steering tag from the main manifest
   */
  assignTagProperties(e, t) {
    this.manifestType_ = t.serverUri ? "HLS" : "DASH";
    const s = t.serverUri || t.serverURL;
    if (!s) {
      this.logger_(`steering manifest URL is ${s}, cannot request steering manifest.`), this.trigger("error");
      return;
    }
    if (s.startsWith("data:")) {
      this.decodeDataUriManifest_(s.substring(s.indexOf(",") + 1));
      return;
    }
    this.steeringManifest.reloadUri = Ge(e, s), this.defaultPathway = t.pathwayId || t.defaultServiceLocation, this.queryBeforeStart = t.queryBeforeStart, this.proxyServerUrl_ = t.proxyServerURL, this.defaultPathway && !this.queryBeforeStart && this.trigger("content-steering");
  }
  /**
   * Requests the content steering manifest and parse the response. This should only be called after
   * assignTagProperties was called with a content steering tag.
   *
   * @param {string} initialUri The optional uri to make the request with.
   *    If set, the request should be made with exactly what is passed in this variable.
   *    This scenario should only happen once on initalization.
   */
  requestSteeringManifest(e) {
    const t = this.steeringManifest.reloadUri;
    if (!t)
      return;
    const s = e ? t : this.getRequestURI(t);
    if (!s) {
      this.logger_("No valid content steering manifest URIs. Stopping content steering."), this.trigger("error"), this.dispose();
      return;
    }
    const r = {
      contentSteeringInfo: {
        uri: s
      }
    };
    this.trigger({
      type: "contentsteeringloadstart",
      metadata: r
    }), this.request_ = this.xhr_({
      uri: s,
      requestType: "content-steering-manifest"
    }, (n, a) => {
      if (n) {
        if (a.status === 410) {
          this.logger_(`manifest request 410 ${n}.`), this.logger_(`There will be no more content steering requests to ${s} this session.`), this.excludedSteeringManifestURLs.add(s);
          return;
        }
        if (a.status === 429) {
          const h = a.responseHeaders["retry-after"];
          this.logger_(`manifest request 429 ${n}.`), this.logger_(`content steering will retry in ${h} seconds.`), this.startTTLTimeout_(parseInt(h, 10));
          return;
        }
        this.logger_(`manifest failed to load ${n}.`), this.startTTLTimeout_();
        return;
      }
      this.trigger({
        type: "contentsteeringloadcomplete",
        metadata: r
      });
      let o;
      try {
        o = JSON.parse(this.request_.responseText);
      } catch (h) {
        const m = {
          errorType: L.Error.StreamingContentSteeringParserError,
          error: h
        };
        this.trigger({
          type: "error",
          metadata: m
        });
      }
      this.assignSteeringProperties_(o);
      const l = {
        contentSteeringInfo: r.contentSteeringInfo,
        contentSteeringManifest: {
          version: this.steeringManifest.version,
          reloadUri: this.steeringManifest.reloadUri,
          priority: this.steeringManifest.priority
        }
      };
      this.trigger({
        type: "contentsteeringparsed",
        metadata: l
      }), this.startTTLTimeout_();
    });
  }
  /**
   * Set the proxy server URL and add the steering manifest url as a URI encoded parameter.
   *
   * @param {string} steeringUrl the steering manifest url
   * @return the steering manifest url to a proxy server with all parameters set
   */
  setProxyServerUrl_(e) {
    const t = new S.URL(e), s = new S.URL(this.proxyServerUrl_);
    return s.searchParams.set("url", encodeURI(t.toString())), this.setSteeringParams_(s.toString());
  }
  /**
   * Decodes and parses the data uri encoded steering manifest
   *
   * @param {string} dataUri the data uri to be decoded and parsed.
   */
  decodeDataUriManifest_(e) {
    const t = JSON.parse(S.atob(e));
    this.assignSteeringProperties_(t);
  }
  /**
   * Set the HLS or DASH content steering manifest request query parameters. For example:
   * _HLS_pathway="<CURRENT-PATHWAY-ID>" and _HLS_throughput=<THROUGHPUT>
   * _DASH_pathway and _DASH_throughput
   *
   * @param {string} uri to add content steering server parameters to.
   * @return a new uri as a string with the added steering query parameters.
   */
  setSteeringParams_(e) {
    const t = new S.URL(e), s = this.getPathway(), r = this.getBandwidth_();
    if (s) {
      const n = `_${this.manifestType_}_pathway`;
      t.searchParams.set(n, s);
    }
    if (r) {
      const n = `_${this.manifestType_}_throughput`;
      t.searchParams.set(n, r);
    }
    return t.toString();
  }
  /**
   * Assigns the current steering manifest properties and to the SteeringManifest object
   *
   * @param {Object} steeringJson the raw JSON steering manifest
   */
  assignSteeringProperties_(e) {
    if (this.steeringManifest.version = e.VERSION, !this.steeringManifest.version) {
      this.logger_(`manifest version is ${e.VERSION}, which is not supported.`), this.trigger("error");
      return;
    }
    this.steeringManifest.ttl = e.TTL, this.steeringManifest.reloadUri = e["RELOAD-URI"], this.steeringManifest.priority = e["PATHWAY-PRIORITY"] || e["SERVICE-LOCATION-PRIORITY"], this.steeringManifest.pathwayClones = e["PATHWAY-CLONES"], this.nextPathwayClones = this.steeringManifest.pathwayClones, this.availablePathways_.size || (this.logger_("There are no available pathways for content steering. Ending content steering."), this.trigger("error"), this.dispose());
    const s = ((r) => {
      for (const n of r)
        if (this.availablePathways_.has(n))
          return n;
      return [...this.availablePathways_][0];
    })(this.steeringManifest.priority);
    this.currentPathway !== s && (this.currentPathway = s, this.trigger("content-steering"));
  }
  /**
   * Returns the pathway to use for steering decisions
   *
   * @return {string} returns the current pathway or the default
   */
  getPathway() {
    return this.currentPathway || this.defaultPathway;
  }
  /**
   * Chooses the manifest request URI based on proxy URIs and server URLs.
   * Also accounts for exclusion on certain manifest URIs.
   *
   * @param {string} reloadUri the base uri before parameters
   *
   * @return {string} the final URI for the request to the manifest server.
   */
  getRequestURI(e) {
    if (!e)
      return null;
    const t = (r) => this.excludedSteeringManifestURLs.has(r);
    if (this.proxyServerUrl_) {
      const r = this.setProxyServerUrl_(e);
      if (!t(r))
        return r;
    }
    const s = this.setSteeringParams_(e);
    return t(s) ? null : s;
  }
  /**
   * Start the timeout for re-requesting the steering manifest at the TTL interval.
   *
   * @param {number} ttl time in seconds of the timeout. Defaults to the
   *        ttl interval in the steering manifest
   */
  startTTLTimeout_(e = this.steeringManifest.ttl) {
    const t = e * 1e3;
    this.ttlTimeout_ = S.setTimeout(() => {
      this.requestSteeringManifest();
    }, t);
  }
  /**
   * Clear the TTL timeout if necessary.
   */
  clearTTLTimeout_() {
    S.clearTimeout(this.ttlTimeout_), this.ttlTimeout_ = null;
  }
  /**
   * aborts any current steering xhr and sets the current request object to null
   */
  abort() {
    this.request_ && this.request_.abort(), this.request_ = null;
  }
  /**
   * aborts steering requests clears the ttl timeout and resets all properties.
   */
  dispose() {
    this.off("content-steering"), this.off("error"), this.abort(), this.clearTTLTimeout_(), this.currentPathway = null, this.defaultPathway = null, this.queryBeforeStart = null, this.proxyServerUrl_ = null, this.manifestType_ = null, this.ttlTimeout_ = null, this.request_ = null, this.excludedSteeringManifestURLs = /* @__PURE__ */ new Set(), this.availablePathways_ = /* @__PURE__ */ new Set(), this.steeringManifest = new Uc();
  }
  /**
   * adds a pathway to the available pathways set
   *
   * @param {string} pathway the pathway string to add
   */
  addAvailablePathway(e) {
    e && this.availablePathways_.add(e);
  }
  /**
   * Clears all pathways from the available pathways set
   */
  clearAvailablePathways() {
    this.availablePathways_.clear();
  }
  /**
   * Removes a pathway from the available pathways set.
   */
  excludePathway(e) {
    return this.availablePathways_.delete(e);
  }
  /**
   * Checks the refreshed DASH manifest content steering tag for changes.
   *
   * @param {string} baseURL new steering tag on DASH manifest refresh
   * @param {Object} newTag the new tag to check for changes
   * @return a true or false whether the new tag has different values
   */
  didDASHTagChange(e, t) {
    return !t && this.steeringManifest.reloadUri || t && (Ge(e, t.serverURL) !== this.steeringManifest.reloadUri || t.defaultServiceLocation !== this.defaultPathway || t.queryBeforeStart !== this.queryBeforeStart || t.proxyServerURL !== this.proxyServerUrl_);
  }
  getAvailablePathways() {
    return this.availablePathways_;
  }
}
const hb = 10;
let kt;
const fb = ["mediaRequests", "mediaRequestsAborted", "mediaRequestsTimedout", "mediaRequestsErrored", "mediaTransferDuration", "mediaBytesTransferred", "mediaAppends"], pb = function(i) {
  return this.audioSegmentLoader_[i] + this.mainSegmentLoader_[i];
}, mb = function({
  currentPlaylist: i,
  buffered: e,
  currentTime: t,
  nextPlaylist: s,
  bufferLowWaterLine: r,
  bufferHighWaterLine: n,
  duration: a,
  bufferBasedABR: o,
  log: l
}) {
  if (!s)
    return L.log.warn("We received no playlist to switch to. Please check your stream."), !1;
  const h = `allowing switch ${i && i.id || "null"} -> ${s.id}`;
  if (!i)
    return l(`${h} as current playlist is not set`), !0;
  if (s.id === i.id)
    return !1;
  const m = !!Li(e, t).length;
  if (!i.endList)
    return !m && typeof i.partTargetDuration == "number" ? (l(`not ${h} as current playlist is live llhls, but currentTime isn't in buffered.`), !1) : (l(`${h} as current playlist is live`), !0);
  const _ = ou(e, t), v = o ? Ae.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : Ae.MAX_BUFFER_LOW_WATER_LINE;
  if (a < v)
    return l(`${h} as duration < max low water line (${a} < ${v})`), !0;
  const C = s.attributes.BANDWIDTH, A = i.attributes.BANDWIDTH;
  if (C < A && (!o || _ < n)) {
    let y = `${h} as next bandwidth < current bandwidth (${C} < ${A})`;
    return o && (y += ` and forwardBuffer < bufferHighWaterLine (${_} < ${n})`), l(y), !0;
  }
  if ((!o || C > A) && _ >= r) {
    let y = `${h} as forwardBuffer >= bufferLowWaterLine (${_} >= ${r})`;
    return o && (y += ` and next bandwidth > current bandwidth (${C} > ${A})`), l(y), !0;
  }
  return l(`not ${h} as no switching criteria met`), !1;
};
class gb extends L.EventTarget {
  constructor(e) {
    super();
    const {
      src: t,
      withCredentials: s,
      tech: r,
      bandwidth: n,
      externVhs: a,
      useCueTags: o,
      playlistExclusionDuration: l,
      enableLowInitialPlaylist: h,
      sourceType: m,
      cacheEncryptionKeys: _,
      bufferBasedABR: v,
      leastPixelDiffSelector: C,
      captionServices: A,
      experimentalUseMMS: y
    } = e;
    if (!t)
      throw new Error("A non-empty playlist URL or JSON manifest string is required");
    let {
      maxPlaylistRetries: D
    } = e;
    (D === null || typeof D > "u") && (D = 1 / 0), kt = a, this.bufferBasedABR = !!v, this.leastPixelDiffSelector = !!C, this.withCredentials = s, this.tech_ = r, this.vhs_ = r.vhs, this.player_ = e.player_, this.sourceType_ = m, this.useCueTags_ = o, this.playlistExclusionDuration = l, this.maxPlaylistRetries = D, this.enableLowInitialPlaylist = h, this.useCueTags_ && (this.cueTagsTrack_ = this.tech_.addTextTrack("metadata", "ad-cues"), this.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), this.requestOptions_ = {
      withCredentials: s,
      maxPlaylistRetries: D,
      timeout: null
    }, this.on("error", this.pauseLoading), this.mediaTypes_ = cb(), y && S.ManagedMediaSource ? (this.tech_.el_.disableRemotePlayback = !0, this.mediaSource = new S.ManagedMediaSource(), L.log("Using ManagedMediaSource")) : S.MediaSource && (this.mediaSource = new S.MediaSource()), this.handleDurationChange_ = this.handleDurationChange_.bind(this), this.handleSourceOpen_ = this.handleSourceOpen_.bind(this), this.handleSourceEnded_ = this.handleSourceEnded_.bind(this), this.load = this.load.bind(this), this.pause = this.pause.bind(this), this.mediaSource.addEventListener("durationchange", this.handleDurationChange_), this.mediaSource.addEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.addEventListener("sourceended", this.handleSourceEnded_), this.mediaSource.addEventListener("startstreaming", this.load), this.mediaSource.addEventListener("endstreaming", this.pause), this.seekable_ = ke(), this.hasPlayed_ = !1, this.syncController_ = new Q2(e), this.segmentMetadataTrack_ = r.addRemoteTextTrack({
      kind: "metadata",
      label: "segment-metadata"
    }, !1).track, this.decrypter_ = new eb(), this.sourceUpdater_ = new Yf(this.mediaSource), this.inbandTextTracks_ = {}, this.timelineChangeController_ = new J2(), this.keyStatusMap_ = /* @__PURE__ */ new Map();
    const w = {
      vhs: this.vhs_,
      parse708captions: e.parse708captions,
      useDtsForTimestampOffset: e.useDtsForTimestampOffset,
      captionServices: A,
      mediaSource: this.mediaSource,
      currentTime: this.tech_.currentTime.bind(this.tech_),
      seekable: () => this.seekable(),
      seeking: () => this.tech_.seeking(),
      duration: () => this.duration(),
      hasPlayed: () => this.hasPlayed_,
      goalBufferLength: () => this.goalBufferLength(),
      bandwidth: n,
      syncController: this.syncController_,
      decrypter: this.decrypter_,
      sourceType: this.sourceType_,
      inbandTextTracks: this.inbandTextTracks_,
      cacheEncryptionKeys: _,
      sourceUpdater: this.sourceUpdater_,
      timelineChangeController: this.timelineChangeController_,
      exactManifestTimings: e.exactManifestTimings,
      addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
    };
    this.mainPlaylistLoader_ = this.sourceType_ === "dash" ? new ro(t, this.vhs_, te(this.requestOptions_, {
      addMetadataToTextTrack: this.addMetadataToTextTrack.bind(this)
    })) : new Ri(t, this.vhs_, te(this.requestOptions_, {
      addDateRangesToTextTrack: this.addDateRangesToTextTrack_.bind(this)
    })), this.setupMainPlaylistLoaderListeners_(), this.mainSegmentLoader_ = new oo(te(w, {
      segmentMetadataTrack: this.segmentMetadataTrack_,
      loaderType: "main"
    }), e), this.audioSegmentLoader_ = new oo(te(w, {
      loaderType: "audio"
    }), e), this.subtitleSegmentLoader_ = new G2(te(w, {
      loaderType: "vtt",
      featuresNativeTextTracks: this.tech_.featuresNativeTextTracks,
      loadVttJs: () => new Promise((R, I) => {
        function B() {
          r.off("vttjserror", H), R();
        }
        function H() {
          r.off("vttjsloaded", B), I();
        }
        r.one("vttjsloaded", B), r.one("vttjserror", H), r.addWebVttScript_();
      })
    }), e);
    const O = () => this.mainSegmentLoader_.bandwidth;
    this.contentSteeringController_ = new db(this.vhs_.xhr, O), this.setupSegmentLoaderListeners_(), this.bufferBasedABR && (this.mainPlaylistLoader_.one("loadedplaylist", () => this.startABRTimer_()), this.tech_.on("pause", () => this.stopABRTimer_()), this.tech_.on("play", () => this.startABRTimer_())), fb.forEach((R) => {
      this[R + "_"] = pb.bind(this, R);
    }), this.logger_ = ot("pc"), this.triggeredFmp4Usage = !1, this.tech_.preload() === "none" ? (this.loadOnPlay_ = () => {
      this.loadOnPlay_ = null, this.mainPlaylistLoader_.load();
    }, this.tech_.one("play", this.loadOnPlay_)) : this.mainPlaylistLoader_.load(), this.timeToLoadedData__ = -1, this.mainAppendsToLoadedData__ = -1, this.audioAppendsToLoadedData__ = -1;
    const P = this.tech_.preload() === "none" ? "play" : "loadstart";
    this.tech_.one(P, () => {
      const R = Date.now();
      this.tech_.one("loadeddata", () => {
        this.timeToLoadedData__ = Date.now() - R, this.mainAppendsToLoadedData__ = this.mainSegmentLoader_.mediaAppends, this.audioAppendsToLoadedData__ = this.audioSegmentLoader_.mediaAppends;
      });
    });
  }
  mainAppendsToLoadedData_() {
    return this.mainAppendsToLoadedData__;
  }
  audioAppendsToLoadedData_() {
    return this.audioAppendsToLoadedData__;
  }
  appendsToLoadedData_() {
    const e = this.mainAppendsToLoadedData_(), t = this.audioAppendsToLoadedData_();
    return e === -1 || t === -1 ? -1 : e + t;
  }
  timeToLoadedData_() {
    return this.timeToLoadedData__;
  }
  /**
   * Run selectPlaylist and switch to the new playlist if we should
   *
   * @param {string} [reason=abr] a reason for why the ABR check is made
   * @private
   */
  checkABR_(e = "abr") {
    const t = this.selectPlaylist();
    t && this.shouldSwitchToMedia_(t) && this.switchMedia_(t, e);
  }
  switchMedia_(e, t, s) {
    const r = this.media(), n = r && (r.id || r.uri), a = e && (e.id || e.uri);
    if (n && n !== a) {
      this.logger_(`switch media ${n} -> ${a} from ${t}`);
      const o = {
        renditionInfo: {
          id: a,
          bandwidth: e.attributes.BANDWIDTH,
          resolution: e.attributes.RESOLUTION,
          codecs: e.attributes.CODECS
        },
        cause: t
      };
      this.trigger({
        type: "renditionselected",
        metadata: o
      }), this.tech_.trigger({
        type: "usage",
        name: `vhs-rendition-change-${t}`
      });
    }
    this.mainPlaylistLoader_.media(e, s);
  }
  /**
   * A function that ensures we switch our playlists inside of `mediaTypes`
   * to match the current `serviceLocation` provided by the contentSteering controller.
   * We want to check media types of `AUDIO`, `SUBTITLES`, and `CLOSED-CAPTIONS`.
   *
   * This should only be called on a DASH playback scenario while using content steering.
   * This is necessary due to differences in how media in HLS manifests are generally tied to
   * a video playlist, where in DASH that is not always the case.
   */
  switchMediaForDASHContentSteering_() {
    ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach((e) => {
      const t = this.mediaTypes_[e], s = t ? t.activeGroup() : null, r = this.contentSteeringController_.getPathway();
      if (s && r) {
        const a = (s.length ? s[0].playlists : s.playlists).filter((o) => o.attributes.serviceLocation === r);
        a.length && this.mediaTypes_[e].activePlaylistLoader.media(a[0]);
      }
    });
  }
  /**
   * Start a timer that periodically calls checkABR_
   *
   * @private
   */
  startABRTimer_() {
    this.stopABRTimer_(), this.abrTimer_ = S.setInterval(() => this.checkABR_(), 250);
  }
  /**
   * Stop the timer that periodically calls checkABR_
   *
   * @private
   */
  stopABRTimer_() {
    this.tech_.scrubbing && this.tech_.scrubbing() || (S.clearInterval(this.abrTimer_), this.abrTimer_ = null);
  }
  /**
   * Get a list of playlists for the currently selected audio playlist
   *
   * @return {Array} the array of audio playlists
   */
  getAudioTrackPlaylists_() {
    const e = this.main(), t = e && e.playlists || [];
    if (!e || !e.mediaGroups || !e.mediaGroups.AUDIO)
      return t;
    const s = e.mediaGroups.AUDIO, r = Object.keys(s);
    let n;
    if (Object.keys(this.mediaTypes_.AUDIO.groups).length)
      n = this.mediaTypes_.AUDIO.activeTrack();
    else {
      const o = s.main || r.length && s[r[0]];
      for (const l in o)
        if (o[l].default) {
          n = {
            label: l
          };
          break;
        }
    }
    if (!n)
      return t;
    const a = [];
    for (const o in s)
      if (s[o][n.label]) {
        const l = s[o][n.label];
        if (l.playlists && l.playlists.length)
          a.push.apply(a, l.playlists);
        else if (l.uri)
          a.push(l);
        else if (e.playlists.length)
          for (let h = 0; h < e.playlists.length; h++) {
            const m = e.playlists[h];
            m.attributes && m.attributes.AUDIO && m.attributes.AUDIO === o && a.push(m);
          }
      }
    return a.length ? a : t;
  }
  /**
   * Register event handlers on the main playlist loader. A helper
   * function for construction time.
   *
   * @private
   */
  setupMainPlaylistLoaderListeners_() {
    this.mainPlaylistLoader_.on("loadedmetadata", () => {
      const t = this.mainPlaylistLoader_.media(), s = t.targetDuration * 1.5 * 1e3;
      Za(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = s, t.endList && this.tech_.preload() !== "none" && (this.mainSegmentLoader_.playlist(t, this.requestOptions_), this.mainSegmentLoader_.load()), lb({
        sourceType: this.sourceType_,
        segmentLoaders: {
          AUDIO: this.audioSegmentLoader_,
          SUBTITLES: this.subtitleSegmentLoader_,
          main: this.mainSegmentLoader_
        },
        tech: this.tech_,
        requestOptions: this.requestOptions_,
        mainPlaylistLoader: this.mainPlaylistLoader_,
        vhs: this.vhs_,
        main: this.main(),
        mediaTypes: this.mediaTypes_,
        excludePlaylist: this.excludePlaylist.bind(this)
      }), this.triggerPresenceUsage_(this.main(), t), this.setupFirstPlay(), !this.mediaTypes_.AUDIO.activePlaylistLoader || this.mediaTypes_.AUDIO.activePlaylistLoader.media() ? this.trigger("selectedinitialmedia") : this.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", () => {
        this.trigger("selectedinitialmedia");
      });
    }), this.mainPlaylistLoader_.on("loadedplaylist", () => {
      this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_);
      let t = this.mainPlaylistLoader_.media();
      if (!t) {
        this.attachContentSteeringListeners_(), this.initContentSteeringController_(), this.excludeUnsupportedVariants_();
        let s;
        if (this.enableLowInitialPlaylist && (s = this.selectInitialPlaylist()), s || (s = this.selectPlaylist()), !s || !this.shouldSwitchToMedia_(s) || (this.initialMedia_ = s, this.switchMedia_(this.initialMedia_, "initial"), !(this.sourceType_ === "vhs-json" && this.initialMedia_.segments)))
          return;
        t = this.initialMedia_;
      }
      this.handleUpdatedMediaPlaylist(t);
    }), this.mainPlaylistLoader_.on("error", () => {
      const t = this.mainPlaylistLoader_.error;
      this.excludePlaylist({
        playlistToExclude: t.playlist,
        error: t
      });
    }), this.mainPlaylistLoader_.on("mediachanging", () => {
      this.mainSegmentLoader_.abort(), this.mainSegmentLoader_.pause();
    }), this.mainPlaylistLoader_.on("mediachange", () => {
      const t = this.mainPlaylistLoader_.media(), s = t.targetDuration * 1.5 * 1e3;
      Za(this.mainPlaylistLoader_.main, this.mainPlaylistLoader_.media()) ? this.requestOptions_.timeout = 0 : this.requestOptions_.timeout = s, this.sourceType_ === "dash" && this.mainPlaylistLoader_.load(), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(t, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ ? this.runFastQualitySwitch_() : this.mainSegmentLoader_.load(), this.tech_.trigger({
        type: "mediachange",
        bubbles: !0
      });
    }), this.mainPlaylistLoader_.on("playlistunchanged", () => {
      const t = this.mainPlaylistLoader_.media();
      if (t.lastExcludeReason_ === "playlist-unchanged")
        return;
      this.stuckAtPlaylistEnd_(t) && (this.excludePlaylist({
        error: {
          message: "Playlist no longer updating.",
          reason: "playlist-unchanged"
        }
      }), this.tech_.trigger("playliststuck"));
    }), this.mainPlaylistLoader_.on("renditiondisabled", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-disabled"
      });
    }), this.mainPlaylistLoader_.on("renditionenabled", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-enabled"
      });
    }), ["manifestrequeststart", "manifestrequestcomplete", "manifestparsestart", "manifestparsecomplete", "playlistrequeststart", "playlistrequestcomplete", "playlistparsestart", "playlistparsecomplete", "renditiondisabled", "renditionenabled"].forEach((t) => {
      this.mainPlaylistLoader_.on(t, (s) => {
        this.player_.trigger(ye({}, s));
      });
    });
  }
  /**
   * Given an updated media playlist (whether it was loaded for the first time, or
   * refreshed for live playlists), update any relevant properties and state to reflect
   * changes in the media that should be accounted for (e.g., cues and duration).
   *
   * @param {Object} updatedPlaylist the updated media playlist object
   *
   * @private
   */
  handleUpdatedMediaPlaylist(e) {
    this.useCueTags_ && this.updateAdCues_(e), this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.playlist(e, this.requestOptions_), this.waitingForFastQualityPlaylistReceived_ && this.runFastQualitySwitch_(), this.updateDuration(!e.endList), this.tech_.paused() || (this.mainSegmentLoader_.load(), this.audioSegmentLoader_ && this.audioSegmentLoader_.load());
  }
  /**
   * A helper function for triggerring presence usage events once per source
   *
   * @private
   */
  triggerPresenceUsage_(e, t) {
    const s = e.mediaGroups || {};
    let r = !0;
    const n = Object.keys(s.AUDIO);
    for (const a in s.AUDIO)
      for (const o in s.AUDIO[a])
        s.AUDIO[a][o].uri || (r = !1);
    r && this.tech_.trigger({
      type: "usage",
      name: "vhs-demuxed"
    }), Object.keys(s.SUBTITLES).length && this.tech_.trigger({
      type: "usage",
      name: "vhs-webvtt"
    }), kt.Playlist.isAes(t) && this.tech_.trigger({
      type: "usage",
      name: "vhs-aes"
    }), n.length && Object.keys(s.AUDIO[n[0]]).length > 1 && this.tech_.trigger({
      type: "usage",
      name: "vhs-alternate-audio"
    }), this.useCueTags_ && this.tech_.trigger({
      type: "usage",
      name: "vhs-playlist-cue-tags"
    });
  }
  shouldSwitchToMedia_(e) {
    const t = this.mainPlaylistLoader_.media() || this.mainPlaylistLoader_.pendingMedia_, s = this.tech_.currentTime(), r = this.bufferLowWaterLine(), n = this.bufferHighWaterLine(), a = this.tech_.buffered();
    return mb({
      buffered: a,
      currentTime: s,
      currentPlaylist: t,
      nextPlaylist: e,
      bufferLowWaterLine: r,
      bufferHighWaterLine: n,
      duration: this.duration(),
      bufferBasedABR: this.bufferBasedABR,
      log: this.logger_
    });
  }
  /**
   * Register event handlers on the segment loaders. A helper function
   * for construction time.
   *
   * @private
   */
  setupSegmentLoaderListeners_() {
    this.mainSegmentLoader_.on("bandwidthupdate", () => {
      this.checkABR_("bandwidthupdate"), this.tech_.trigger("bandwidthupdate");
    }), this.mainSegmentLoader_.on("timeout", () => {
      this.bufferBasedABR && this.mainSegmentLoader_.load();
    }), this.bufferBasedABR || this.mainSegmentLoader_.on("progress", () => {
      this.trigger("progress");
    }), this.mainSegmentLoader_.on("error", () => {
      const s = this.mainSegmentLoader_.error();
      this.excludePlaylist({
        playlistToExclude: s.playlist,
        error: s
      });
    }), this.mainSegmentLoader_.on("appenderror", () => {
      this.error = this.mainSegmentLoader_.error_, this.trigger("error");
    }), this.mainSegmentLoader_.on("syncinfoupdate", () => {
      this.onSyncInfoUpdate_();
    }), this.mainSegmentLoader_.on("timestampoffset", () => {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-timestamp-offset"
      });
    }), this.audioSegmentLoader_.on("syncinfoupdate", () => {
      this.onSyncInfoUpdate_();
    }), this.audioSegmentLoader_.on("appenderror", () => {
      this.error = this.audioSegmentLoader_.error_, this.trigger("error");
    }), this.mainSegmentLoader_.on("ended", () => {
      this.logger_("main segment loader ended"), this.onEndOfStream();
    }), this.timelineChangeController_.on("audioTimelineBehind", () => {
      const s = this.audioSegmentLoader_.pendingSegment_;
      if (!s || !s.segment || !s.segment.syncInfo)
        return;
      const r = s.segment.syncInfo.end + 0.01;
      this.tech_.setCurrentTime(r);
    }), this.mainSegmentLoader_.on("earlyabort", (s) => {
      this.bufferBasedABR || (this.delegateLoaders_("all", ["abort"]), this.excludePlaylist({
        error: {
          message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
        },
        playlistExclusionDuration: hb
      }));
    });
    const e = () => {
      if (!this.sourceUpdater_.hasCreatedSourceBuffers())
        return this.tryToCreateSourceBuffers_();
      const s = this.getCodecsOrExclude_();
      s && this.sourceUpdater_.addOrChangeSourceBuffers(s);
    };
    this.mainSegmentLoader_.on("trackinfo", e), this.audioSegmentLoader_.on("trackinfo", e), this.mainSegmentLoader_.on("fmp4", () => {
      this.triggeredFmp4Usage || (this.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), this.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("fmp4", () => {
      this.triggeredFmp4Usage || (this.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), this.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("ended", () => {
      this.logger_("audioSegmentLoader ended"), this.onEndOfStream();
    }), ["segmentselected", "segmentloadstart", "segmentloaded", "segmentkeyloadstart", "segmentkeyloadcomplete", "segmentdecryptionstart", "segmentdecryptioncomplete", "segmenttransmuxingstart", "segmenttransmuxingcomplete", "segmenttransmuxingtrackinfoavailable", "segmenttransmuxingtiminginfoavailable", "segmentappendstart", "appendsdone", "bandwidthupdated", "timelinechange", "codecschange"].forEach((s) => {
      this.mainSegmentLoader_.on(s, (r) => {
        this.player_.trigger(ye({}, r));
      }), this.audioSegmentLoader_.on(s, (r) => {
        this.player_.trigger(ye({}, r));
      }), this.subtitleSegmentLoader_.on(s, (r) => {
        this.player_.trigger(ye({}, r));
      });
    });
  }
  mediaSecondsLoaded_() {
    return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
  }
  /**
   * Call load on our SegmentLoaders
   */
  load() {
    this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load();
  }
  /**
   * Call pause on our SegmentLoaders
   */
  pause() {
    this.mainSegmentLoader_.pause(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.pause(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.pause();
  }
  /**
   * Re-tune playback quality level for the current player
   * conditions. This method will perform destructive actions like removing
   * already buffered content in order to readjust the currently active
   * playlist quickly. This is good for manual quality changes
   *
   * @private
   */
  fastQualityChange_(e = this.selectPlaylist()) {
    if (e && e === this.mainPlaylistLoader_.media()) {
      this.logger_("skipping fastQualityChange because new media is same as old");
      return;
    }
    this.switchMedia_(e, "fast-quality"), this.waitingForFastQualityPlaylistReceived_ = !0;
  }
  runFastQualitySwitch_() {
    this.waitingForFastQualityPlaylistReceived_ = !1, this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(() => {
      this.mainSegmentLoader_.load();
    });
  }
  /**
   * Begin playback.
   */
  play() {
    if (this.setupFirstPlay())
      return;
    this.tech_.ended() && this.tech_.setCurrentTime(0), this.hasPlayed_ && this.load();
    const e = this.tech_.seekable();
    if (this.tech_.duration() === 1 / 0 && this.tech_.currentTime() < e.start(0))
      return this.tech_.setCurrentTime(e.end(e.length - 1));
  }
  /**
   * Seek to the latest media position if this is a live video and the
   * player and video are loaded and initialized.
   */
  setupFirstPlay() {
    const e = this.mainPlaylistLoader_.media();
    if (!e || this.tech_.paused() || this.hasPlayed_)
      return !1;
    if (!e.endList || e.start) {
      const t = this.seekable();
      if (!t.length)
        return !1;
      const s = t.end(0);
      let r = s;
      if (e.start) {
        const n = e.start.timeOffset;
        n < 0 ? r = Math.max(s + n, t.start(0)) : r = Math.min(s, n);
      }
      this.trigger("firstplay"), this.tech_.setCurrentTime(r);
    }
    return this.hasPlayed_ = !0, this.load(), !0;
  }
  /**
   * handle the sourceopen event on the MediaSource
   *
   * @private
   */
  handleSourceOpen_() {
    if (this.tryToCreateSourceBuffers_(), this.tech_.autoplay()) {
      const e = this.tech_.play();
      typeof e < "u" && typeof e.then == "function" && e.then(null, (t) => {
      });
    }
    this.trigger("sourceopen");
  }
  /**
   * handle the sourceended event on the MediaSource
   *
   * @private
   */
  handleSourceEnded_() {
    if (!this.inbandTextTracks_.metadataTrack_)
      return;
    const e = this.inbandTextTracks_.metadataTrack_.cues;
    if (!e || !e.length)
      return;
    const t = this.duration();
    e[e.length - 1].endTime = isNaN(t) || Math.abs(t) === 1 / 0 ? Number.MAX_VALUE : t;
  }
  /**
   * handle the durationchange event on the MediaSource
   *
   * @private
   */
  handleDurationChange_() {
    this.tech_.trigger("durationchange");
  }
  /**
   * Calls endOfStream on the media source when all active stream types have called
   * endOfStream
   *
   * @param {string} streamType
   *        Stream type of the segment loader that called endOfStream
   * @private
   */
  onEndOfStream() {
    let e = this.mainSegmentLoader_.ended_;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
      const t = this.mainSegmentLoader_.getCurrentMediaInfo_();
      !t || t.hasVideo ? e = e && this.audioSegmentLoader_.ended_ : e = this.audioSegmentLoader_.ended_;
    }
    e && (this.stopABRTimer_(), this.sourceUpdater_.endOfStream());
  }
  /**
   * Check if a playlist has stopped being updated
   *
   * @param {Object} playlist the media playlist object
   * @return {boolean} whether the playlist has stopped being updated or not
   */
  stuckAtPlaylistEnd_(e) {
    if (!this.seekable().length)
      return !1;
    const s = this.syncController_.getExpiredTime(e, this.duration());
    if (s === null)
      return !1;
    const r = kt.Playlist.playlistEnd(e, s), n = this.tech_.currentTime(), a = this.tech_.buffered();
    if (!a.length)
      return r - n <= Tt;
    const o = a.end(a.length - 1);
    return o - n <= Tt && r - o <= Tt;
  }
  /**
   * Exclude a playlist for a set amount of time, making it unavailable for selection by
   * the rendition selection algorithm, then force a new playlist (rendition) selection.
   *
   * @param {Object=} playlistToExclude
   *                  the playlist to exclude, defaults to the currently selected playlist
   * @param {Object=} error
   *                  an optional error
   * @param {number=} playlistExclusionDuration
   *                  an optional number of seconds to exclude the playlist
   */
  excludePlaylist({
    playlistToExclude: e = this.mainPlaylistLoader_.media(),
    error: t = {},
    playlistExclusionDuration: s
  }) {
    if (e = e || this.mainPlaylistLoader_.media(), s = s || t.playlistExclusionDuration || this.playlistExclusionDuration, !e) {
      this.error = t, this.mediaSource.readyState !== "open" ? this.trigger("error") : this.sourceUpdater_.endOfStream("network");
      return;
    }
    e.playlistErrors_++;
    const r = this.mainPlaylistLoader_.main.playlists, n = r.filter(jn), a = n.length === 1 && n[0] === e;
    if (r.length === 1 && s !== 1 / 0)
      return L.log.warn(`Problem encountered with playlist ${e.id}. Trying again since it is the only playlist.`), this.tech_.trigger("retryplaylist"), this.mainPlaylistLoader_.load(a);
    if (a) {
      if (this.main().contentSteering) {
        const A = this.pathwayAttribute_(e), y = this.contentSteeringController_.steeringManifest.ttl * 1e3;
        this.contentSteeringController_.excludePathway(A), this.excludeThenChangePathway_(), setTimeout(() => {
          this.contentSteeringController_.addAvailablePathway(A);
        }, y);
        return;
      }
      let C = !1;
      r.forEach((A) => {
        if (A === e)
          return;
        const y = A.excludeUntil;
        typeof y < "u" && y !== 1 / 0 && (C = !0, delete A.excludeUntil);
      }), C && (L.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."), this.tech_.trigger("retryplaylist"));
    }
    let o;
    e.playlistErrors_ > this.maxPlaylistRetries ? o = 1 / 0 : o = Date.now() + s * 1e3, e.excludeUntil = o, t.reason && (e.lastExcludeReason_ = t.reason), this.tech_.trigger("excludeplaylist"), this.tech_.trigger({
      type: "usage",
      name: "vhs-rendition-excluded"
    });
    const l = this.selectPlaylist();
    if (!l) {
      this.error = "Playback cannot continue. No available working or supported playlists.", this.trigger("error");
      return;
    }
    const h = t.internal ? this.logger_ : L.log.warn, m = t.message ? " " + t.message : "";
    h(`${t.internal ? "Internal problem" : "Problem"} encountered with playlist ${e.id}.${m} Switching to playlist ${l.id}.`), l.attributes.AUDIO !== e.attributes.AUDIO && this.delegateLoaders_("audio", ["abort", "pause"]), l.attributes.SUBTITLES !== e.attributes.SUBTITLES && this.delegateLoaders_("subtitle", ["abort", "pause"]), this.delegateLoaders_("main", ["abort", "pause"]);
    const _ = l.targetDuration / 2 * 1e3 || 5 * 1e3, v = typeof l.lastRequest == "number" && Date.now() - l.lastRequest <= _;
    return this.switchMedia_(l, "exclude", a || v);
  }
  /**
   * Pause all segment/playlist loaders
   */
  pauseLoading() {
    this.delegateLoaders_("all", ["abort", "pause"]), this.stopABRTimer_();
  }
  /**
   * Call a set of functions in order on playlist loaders, segment loaders,
   * or both types of loaders.
   *
   * @param {string} filter
   *        Filter loaders that should call fnNames using a string. Can be:
   *        * all - run on all loaders
   *        * audio - run on all audio loaders
   *        * subtitle - run on all subtitle loaders
   *        * main - run on the main loaders
   *
   * @param {Array|string} fnNames
   *        A string or array of function names to call.
   */
  delegateLoaders_(e, t) {
    const s = [], r = e === "all";
    (r || e === "main") && s.push(this.mainPlaylistLoader_);
    const n = [];
    (r || e === "audio") && n.push("AUDIO"), (r || e === "subtitle") && (n.push("CLOSED-CAPTIONS"), n.push("SUBTITLES")), n.forEach((a) => {
      const o = this.mediaTypes_[a] && this.mediaTypes_[a].activePlaylistLoader;
      o && s.push(o);
    }), ["main", "audio", "subtitle"].forEach((a) => {
      const o = this[`${a}SegmentLoader_`];
      o && (e === a || e === "all") && s.push(o);
    }), s.forEach((a) => t.forEach((o) => {
      typeof a[o] == "function" && a[o]();
    }));
  }
  /**
   * set the current time on all segment loaders
   *
   * @param {TimeRange} currentTime the current time to set
   * @return {TimeRange} the current time
   */
  setCurrentTime(e) {
    const t = Li(this.tech_.buffered(), e);
    if (!(this.mainPlaylistLoader_ && this.mainPlaylistLoader_.media()) || !this.mainPlaylistLoader_.media().segments)
      return 0;
    if (t && t.length)
      return e;
    this.mainSegmentLoader_.pause(), this.mainSegmentLoader_.resetEverything(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.pause(), this.audioSegmentLoader_.resetEverything()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.pause(), this.subtitleSegmentLoader_.resetEverything()), this.load();
  }
  /**
   * get the current duration
   *
   * @return {TimeRange} the duration
   */
  duration() {
    if (!this.mainPlaylistLoader_)
      return 0;
    const e = this.mainPlaylistLoader_.media();
    return e ? e.endList ? this.mediaSource ? this.mediaSource.duration : kt.Playlist.duration(e) : 1 / 0 : 0;
  }
  /**
   * check the seekable range
   *
   * @return {TimeRange} the seekable range
   */
  seekable() {
    return this.seekable_;
  }
  onSyncInfoUpdate_() {
    let e;
    if (!this.mainPlaylistLoader_)
      return;
    let t = this.mainPlaylistLoader_.media();
    if (!t)
      return;
    let s = this.syncController_.getExpiredTime(t, this.duration());
    if (s === null)
      return;
    const r = this.mainPlaylistLoader_.main, n = kt.Playlist.seekable(t, s, kt.Playlist.liveEdgeDelay(r, t));
    if (n.length === 0 || this.mediaTypes_.AUDIO.activePlaylistLoader && (t = this.mediaTypes_.AUDIO.activePlaylistLoader.media(), s = this.syncController_.getExpiredTime(t, this.duration()), s === null || (e = kt.Playlist.seekable(t, s, kt.Playlist.liveEdgeDelay(r, t)), e.length === 0)))
      return;
    let a, o;
    if (this.seekable_ && this.seekable_.length && (a = this.seekable_.end(0), o = this.seekable_.start(0)), e ? e.start(0) > n.end(0) || n.start(0) > e.end(0) ? this.seekable_ = n : this.seekable_ = ke([[e.start(0) > n.start(0) ? e.start(0) : n.start(0), e.end(0) < n.end(0) ? e.end(0) : n.end(0)]]) : this.seekable_ = n, this.seekable_ && this.seekable_.length && this.seekable_.end(0) === a && this.seekable_.start(0) === o)
      return;
    this.logger_(`seekable updated [${df(this.seekable_)}]`);
    const l = {
      seekableRanges: this.seekable_
    };
    this.trigger({
      type: "seekablerangeschanged",
      metadata: l
    }), this.tech_.trigger("seekablechanged");
  }
  /**
   * Update the player duration
   */
  updateDuration(e) {
    if (this.updateDuration_ && (this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.updateDuration_ = null), this.mediaSource.readyState !== "open") {
      this.updateDuration_ = this.updateDuration.bind(this, e), this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
      return;
    }
    if (e) {
      const r = this.seekable();
      if (!r.length)
        return;
      (isNaN(this.mediaSource.duration) || this.mediaSource.duration < r.end(r.length - 1)) && this.sourceUpdater_.setDuration(r.end(r.length - 1));
      return;
    }
    const t = this.tech_.buffered();
    let s = kt.Playlist.duration(this.mainPlaylistLoader_.media());
    t.length > 0 && (s = Math.max(s, t.end(t.length - 1))), this.mediaSource.duration !== s && this.sourceUpdater_.setDuration(s);
  }
  /**
   * dispose of the PlaylistController and everything
   * that it controls
   */
  dispose() {
    this.trigger("dispose"), this.decrypter_.terminate(), this.mainPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), this.contentSteeringController_.dispose(), this.keyStatusMap_.clear(), this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_), ["AUDIO", "SUBTITLES"].forEach((e) => {
      const t = this.mediaTypes_[e].groups;
      for (const s in t)
        t[s].forEach((r) => {
          r.playlistLoader && r.playlistLoader.dispose();
        });
    }), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose(), this.sourceUpdater_.dispose(), this.timelineChangeController_.dispose(), this.stopABRTimer_(), this.updateDuration_ && this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_), this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_), this.off();
  }
  /**
   * return the main playlist object if we have one
   *
   * @return {Object} the main playlist object that we parsed
   */
  main() {
    return this.mainPlaylistLoader_.main;
  }
  /**
   * return the currently selected playlist
   *
   * @return {Object} the currently selected playlist object that we parsed
   */
  media() {
    return this.mainPlaylistLoader_.media() || this.initialMedia_;
  }
  areMediaTypesKnown_() {
    const e = !!this.mediaTypes_.AUDIO.activePlaylistLoader, t = !!this.mainSegmentLoader_.getCurrentMediaInfo_(), s = e ? !!this.audioSegmentLoader_.getCurrentMediaInfo_() : !0;
    return !(!t || !s);
  }
  // find from and to for codec switch event
  getCodecsOrExclude_() {
    const e = {
      main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
      audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
    }, t = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media();
    e.video = e.main;
    const s = qs(this.main(), t), r = {}, n = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
    if (e.main.hasVideo && (r.video = s.video || e.main.videoCodec || R0), e.main.isMuxed && (r.video += `,${s.audio || e.main.audioCodec || vl}`), (e.main.hasAudio && !e.main.isMuxed || e.audio.hasAudio || n) && (r.audio = s.audio || e.main.audioCodec || e.audio.audioCodec || vl, e.audio.isFmp4 = e.main.hasAudio && !e.main.isMuxed ? e.main.isFmp4 : e.audio.isFmp4), !r.audio && !r.video) {
      this.excludePlaylist({
        playlistToExclude: t,
        error: {
          message: "Could not determine codecs for playlist."
        },
        playlistExclusionDuration: 1 / 0
      });
      return;
    }
    const a = (h, m) => h ? Ns(m) : _a(m), o = {};
    let l;
    if (["video", "audio"].forEach(function(h) {
      if (r.hasOwnProperty(h) && !a(e[h].isFmp4, r[h])) {
        const m = e[h].isFmp4 ? "browser" : "muxer";
        o[m] = o[m] || [], o[m].push(r[h]), h === "audio" && (l = m);
      }
    }), n && l && t.attributes.AUDIO) {
      const h = t.attributes.AUDIO;
      this.main().playlists.forEach((m) => {
        (m.attributes && m.attributes.AUDIO) === h && m !== t && (m.excludeUntil = 1 / 0);
      }), this.logger_(`excluding audio group ${h} as ${l} does not support codec(s): "${r.audio}"`);
    }
    if (Object.keys(o).length) {
      const h = Object.keys(o).reduce((m, _) => (m && (m += ", "), m += `${_} does not support codec(s): "${o[_].join(",")}"`, m), "") + ".";
      this.excludePlaylist({
        playlistToExclude: t,
        error: {
          internal: !0,
          message: h
        },
        playlistExclusionDuration: 1 / 0
      });
      return;
    }
    if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
      const h = [];
      if (["video", "audio"].forEach((m) => {
        const _ = (mt(this.sourceUpdater_.codecs[m] || "")[0] || {}).type, v = (mt(r[m] || "")[0] || {}).type;
        _ && v && _.toLowerCase() !== v.toLowerCase() && h.push(`"${this.sourceUpdater_.codecs[m]}" -> "${r[m]}"`);
      }), h.length) {
        this.excludePlaylist({
          playlistToExclude: t,
          error: {
            message: `Codec switching not supported: ${h.join(", ")}.`,
            internal: !0
          },
          playlistExclusionDuration: 1 / 0
        });
        return;
      }
    }
    return r;
  }
  /**
   * Create source buffers and exlude any incompatible renditions.
   *
   * @private
   */
  tryToCreateSourceBuffers_() {
    if (this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers() || !this.areMediaTypesKnown_())
      return;
    const e = this.getCodecsOrExclude_();
    if (!e)
      return;
    this.sourceUpdater_.createSourceBuffers(e);
    const t = [e.video, e.audio].filter(Boolean).join(",");
    this.excludeIncompatibleVariants_(t);
  }
  /**
   * Excludes playlists with codecs that are unsupported by the muxer and browser.
   */
  excludeUnsupportedVariants_() {
    const e = this.main().playlists, t = [];
    Object.keys(e).forEach((s) => {
      const r = e[s];
      if (t.indexOf(r.id) !== -1)
        return;
      t.push(r.id);
      const n = qs(this.main, r), a = [];
      n.audio && !_a(n.audio) && !Ns(n.audio) && a.push(`audio codec ${n.audio}`), n.video && !_a(n.video) && !Ns(n.video) && a.push(`video codec ${n.video}`), n.text && n.text === "stpp.ttml.im1t" && a.push(`text codec ${n.text}`), a.length && (r.excludeUntil = 1 / 0, this.logger_(`excluding ${r.id} for unsupported: ${a.join(", ")}`));
    });
  }
  /**
   * Exclude playlists that are known to be codec or
   * stream-incompatible with the SourceBuffer configuration. For
   * instance, Media Source Extensions would cause the video element to
   * stall waiting for video data if you switched from a variant with
   * video and audio to an audio-only one.
   *
   * @param {Object} media a media playlist compatible with the current
   * set of SourceBuffers. Variants in the current main playlist that
   * do not appear to have compatible codec or stream configurations
   * will be excluded from the default playlist selection algorithm
   * indefinitely.
   * @private
   */
  excludeIncompatibleVariants_(e) {
    const t = [], s = this.main().playlists, r = pn(mt(e)), n = Ac(r), a = r.video && mt(r.video)[0] || null, o = r.audio && mt(r.audio)[0] || null;
    Object.keys(s).forEach((l) => {
      const h = s[l];
      if (t.indexOf(h.id) !== -1 || h.excludeUntil === 1 / 0)
        return;
      t.push(h.id);
      const m = [], _ = qs(this.mainPlaylistLoader_.main, h), v = Ac(_);
      if (!(!_.audio && !_.video)) {
        if (v !== n && m.push(`codec count "${v}" !== "${n}"`), !this.sourceUpdater_.canChangeType()) {
          const C = _.video && mt(_.video)[0] || null, A = _.audio && mt(_.audio)[0] || null;
          C && a && C.type.toLowerCase() !== a.type.toLowerCase() && m.push(`video codec "${C.type}" !== "${a.type}"`), A && o && A.type.toLowerCase() !== o.type.toLowerCase() && m.push(`audio codec "${A.type}" !== "${o.type}"`);
        }
        m.length && (h.excludeUntil = 1 / 0, this.logger_(`excluding ${h.id}: ${m.join(" && ")}`));
      }
    });
  }
  updateAdCues_(e) {
    let t = 0;
    const s = this.seekable();
    s.length && (t = s.start(0)), X2(e, this.cueTagsTrack_, t);
  }
  /**
   * Calculates the desired forward buffer length based on current time
   *
   * @return {number} Desired forward buffer length in seconds
   */
  goalBufferLength() {
    const e = this.tech_.currentTime(), t = Ae.GOAL_BUFFER_LENGTH, s = Ae.GOAL_BUFFER_LENGTH_RATE, r = Math.max(t, Ae.MAX_GOAL_BUFFER_LENGTH);
    return Math.min(t + e * s, r);
  }
  /**
   * Calculates the desired buffer low water line based on current time
   *
   * @return {number} Desired buffer low water line in seconds
   */
  bufferLowWaterLine() {
    const e = this.tech_.currentTime(), t = Ae.BUFFER_LOW_WATER_LINE, s = Ae.BUFFER_LOW_WATER_LINE_RATE, r = Math.max(t, Ae.MAX_BUFFER_LOW_WATER_LINE), n = Math.max(t, Ae.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
    return Math.min(t + e * s, this.bufferBasedABR ? n : r);
  }
  bufferHighWaterLine() {
    return Ae.BUFFER_HIGH_WATER_LINE;
  }
  addDateRangesToTextTrack_(e) {
    Ic(this.inbandTextTracks_, "com.apple.streaming", this.tech_), A2({
      inbandTextTracks: this.inbandTextTracks_,
      dateRanges: e
    });
  }
  addMetadataToTextTrack(e, t, s) {
    const r = this.sourceUpdater_.videoBuffer ? this.sourceUpdater_.videoTimestampOffset() : this.sourceUpdater_.audioTimestampOffset();
    Ic(this.inbandTextTracks_, e, this.tech_), S2({
      inbandTextTracks: this.inbandTextTracks_,
      metadataArray: t,
      timestampOffset: r,
      videoDuration: s
    });
  }
  /**
   * Utility for getting the pathway or service location from an HLS or DASH playlist.
   *
   * @param {Object} playlist for getting pathway from.
   * @return the pathway attribute of a playlist
   */
  pathwayAttribute_(e) {
    return e.attributes["PATHWAY-ID"] || e.attributes.serviceLocation;
  }
  /**
   * Initialize available pathways and apply the tag properties.
   */
  initContentSteeringController_() {
    const e = this.main();
    if (e.contentSteering) {
      for (const t of e.playlists)
        this.contentSteeringController_.addAvailablePathway(this.pathwayAttribute_(t));
      if (this.contentSteeringController_.assignTagProperties(e.uri, e.contentSteering), this.contentSteeringController_.queryBeforeStart) {
        this.contentSteeringController_.requestSteeringManifest(!0);
        return;
      }
      this.tech_.one("canplay", () => {
        this.contentSteeringController_.requestSteeringManifest();
      });
    }
  }
  /**
   * Reset the content steering controller and re-init.
   */
  resetContentSteeringController_() {
    this.contentSteeringController_.clearAvailablePathways(), this.contentSteeringController_.dispose(), this.initContentSteeringController_();
  }
  /**
   * Attaches the listeners for content steering.
   */
  attachContentSteeringListeners_() {
    this.contentSteeringController_.on("content-steering", this.excludeThenChangePathway_.bind(this)), ["contentsteeringloadstart", "contentsteeringloadcomplete", "contentsteeringparsed"].forEach((t) => {
      this.contentSteeringController_.on(t, (s) => {
        this.trigger(ye({}, s));
      });
    }), this.sourceType_ === "dash" && this.mainPlaylistLoader_.on("loadedplaylist", () => {
      const t = this.main();
      (this.contentSteeringController_.didDASHTagChange(t.uri, t.contentSteering) || (() => {
        const n = this.contentSteeringController_.getAvailablePathways(), a = [];
        for (const o of t.playlists) {
          const l = o.attributes.serviceLocation;
          if (l && (a.push(l), !n.has(l)))
            return !0;
        }
        return !!(!a.length && n.size);
      })()) && this.resetContentSteeringController_();
    });
  }
  /**
   * Simple exclude and change playlist logic for content steering.
   */
  excludeThenChangePathway_() {
    const e = this.contentSteeringController_.getPathway();
    if (!e)
      return;
    this.handlePathwayClones_();
    const s = this.main().playlists, r = /* @__PURE__ */ new Set();
    let n = !1;
    Object.keys(s).forEach((a) => {
      const o = s[a], l = this.pathwayAttribute_(o), h = l && e !== l;
      o.excludeUntil === 1 / 0 && o.lastExcludeReason_ === "content-steering" && !h && (delete o.excludeUntil, delete o.lastExcludeReason_, n = !0);
      const _ = !o.excludeUntil && o.excludeUntil !== 1 / 0;
      !r.has(o.id) && h && _ && (r.add(o.id), o.excludeUntil = 1 / 0, o.lastExcludeReason_ = "content-steering", this.logger_(`excluding ${o.id} for ${o.lastExcludeReason_}`));
    }), this.contentSteeringController_.manifestType_ === "DASH" && Object.keys(this.mediaTypes_).forEach((a) => {
      const o = this.mediaTypes_[a];
      if (o.activePlaylistLoader) {
        const l = o.activePlaylistLoader.media_;
        l && l.attributes.serviceLocation !== e && (n = !0);
      }
    }), n && this.changeSegmentPathway_();
  }
  /**
   * Add, update, or delete playlists and media groups for
   * the pathway clones for HLS Content Steering.
   *
   * See https://datatracker.ietf.org/doc/draft-pantos-hls-rfc8216bis/
   *
   * NOTE: Pathway cloning does not currently support the `PER_VARIANT_URIS` and
   * `PER_RENDITION_URIS` as we do not handle `STABLE-VARIANT-ID` or
   * `STABLE-RENDITION-ID` values.
   */
  handlePathwayClones_() {
    const t = this.main().playlists, s = this.contentSteeringController_.currentPathwayClones, r = this.contentSteeringController_.nextPathwayClones;
    if (s && s.size || r && r.size) {
      for (const [a, o] of s.entries())
        r.get(a) || (this.mainPlaylistLoader_.updateOrDeleteClone(o), this.contentSteeringController_.excludePathway(a));
      for (const [a, o] of r.entries()) {
        const l = s.get(a);
        if (!l) {
          t.filter((m) => m.attributes["PATHWAY-ID"] === o["BASE-ID"]).forEach((m) => {
            this.mainPlaylistLoader_.addClonePathway(o, m);
          }), this.contentSteeringController_.addAvailablePathway(a);
          continue;
        }
        this.equalPathwayClones_(l, o) || (this.mainPlaylistLoader_.updateOrDeleteClone(o, !0), this.contentSteeringController_.addAvailablePathway(a));
      }
      this.contentSteeringController_.currentPathwayClones = new Map(JSON.parse(JSON.stringify([...r])));
    }
  }
  /**
   * Determines whether two pathway clone objects are equivalent.
   *
   * @param {Object} a The first pathway clone object.
   * @param {Object} b The second pathway clone object.
   * @return {boolean} True if the pathway clone objects are equal, false otherwise.
   */
  equalPathwayClones_(e, t) {
    if (e["BASE-ID"] !== t["BASE-ID"] || e.ID !== t.ID || e["URI-REPLACEMENT"].HOST !== t["URI-REPLACEMENT"].HOST)
      return !1;
    const s = e["URI-REPLACEMENT"].PARAMS, r = t["URI-REPLACEMENT"].PARAMS;
    for (const n in s)
      if (s[n] !== r[n])
        return !1;
    for (const n in r)
      if (s[n] !== r[n])
        return !1;
    return !0;
  }
  /**
   * Changes the current playlists for audio, video and subtitles after a new pathway
   * is chosen from content steering.
   */
  changeSegmentPathway_() {
    const e = this.selectPlaylist();
    this.pauseLoading(), this.contentSteeringController_.manifestType_ === "DASH" && this.switchMediaForDASHContentSteering_(), this.switchMedia_(e, "content-steering");
  }
  /**
   * Iterates through playlists and check their keyId set and compare with the
   * keyStatusMap, only enable playlists that have a usable key. If the playlist
   * has no keyId leave it enabled by default.
   */
  excludeNonUsablePlaylistsByKeyId_() {
    if (!this.mainPlaylistLoader_ || !this.mainPlaylistLoader_.main)
      return;
    let e = 0;
    const t = "non-usable";
    this.mainPlaylistLoader_.main.playlists.forEach((s) => {
      const r = this.mainPlaylistLoader_.getKeyIdSet(s);
      !r || !r.size || r.forEach((n) => {
        const a = "usable", o = this.keyStatusMap_.has(n) && this.keyStatusMap_.get(n) === a, l = s.lastExcludeReason_ === t && s.excludeUntil === 1 / 0;
        o ? o && l && (delete s.excludeUntil, delete s.lastExcludeReason_, this.logger_(`enabling playlist ${s.id} because key ID ${n} is ${a}`)) : (s.excludeUntil !== 1 / 0 && s.lastExcludeReason_ !== t && (s.excludeUntil = 1 / 0, s.lastExcludeReason_ = t, this.logger_(`excluding playlist ${s.id} because the key ID ${n} doesn't exist in the keyStatusMap or is not ${a}`)), e++);
      });
    }), e >= this.mainPlaylistLoader_.main.playlists.length && this.mainPlaylistLoader_.main.playlists.forEach((s) => {
      const r = s && s.attributes && s.attributes.RESOLUTION && s.attributes.RESOLUTION.height < 720, n = s.excludeUntil === 1 / 0 && s.lastExcludeReason_ === t;
      r && n && (delete s.excludeUntil, L.log.warn(`enabling non-HD playlist ${s.id} because all playlists were excluded due to ${t} key IDs`));
    });
  }
  /**
   * Adds a keystatus to the keystatus map, tries to convert to string if necessary.
   *
   * @param {any} keyId the keyId to add a status for
   * @param {string} status the status of the keyId
   */
  addKeyStatus_(e, t) {
    const n = (typeof e == "string" ? e : V2(e)).slice(0, 32).toLowerCase();
    this.logger_(`KeyStatus '${t}' with key ID ${n} added to the keyStatusMap`), this.keyStatusMap_.set(n, t);
  }
  /**
   * Utility function for adding key status to the keyStatusMap and filtering usable encrypted playlists.
   *
   * @param {any} keyId the keyId from the keystatuschange event
   * @param {string} status the key status string
   */
  updatePlaylistByKeyStatus(e, t) {
    this.addKeyStatus_(e, t), this.waitingForFastQualityPlaylistReceived_ || this.excludeNonUsableThenChangePlaylist_(), this.mainPlaylistLoader_.off("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this)), this.mainPlaylistLoader_.on("loadedplaylist", this.excludeNonUsableThenChangePlaylist_.bind(this));
  }
  excludeNonUsableThenChangePlaylist_() {
    this.excludeNonUsablePlaylistsByKeyId_(), this.fastQualityChange_();
  }
}
const _b = (i, e, t) => (s) => {
  const r = i.main.playlists[e], n = lu(r), a = jn(r);
  if (typeof s > "u")
    return a;
  s ? delete r.disabled : r.disabled = !0;
  const o = {
    renditionInfo: {
      id: e,
      bandwidth: r.attributes.BANDWIDTH,
      resolution: r.attributes.RESOLUTION,
      codecs: r.attributes.CODECS
    },
    cause: "fast-quality"
  };
  return s !== a && !n && (t(r), s ? i.trigger({
    type: "renditionenabled",
    metadata: o
  }) : i.trigger({
    type: "renditiondisabled",
    metadata: o
  })), s;
};
class yb {
  constructor(e, t, s) {
    const {
      playlistController_: r
    } = e, n = r.fastQualityChange_.bind(r);
    if (t.attributes) {
      const a = t.attributes.RESOLUTION;
      this.width = a && a.width, this.height = a && a.height, this.bandwidth = t.attributes.BANDWIDTH, this.frameRate = t.attributes["FRAME-RATE"];
    }
    this.codecs = qs(r.main(), t), this.playlist = t, this.id = s, this.enabled = _b(e.playlists, t.id, n);
  }
}
const Tb = function(i) {
  i.representations = () => {
    const e = i.playlistController_.main(), t = nr(e) ? i.playlistController_.getAudioTrackPlaylists_() : e.playlists;
    return t ? t.filter((s) => !lu(s)).map((s, r) => new yb(i, s, s.id)) : [];
  };
}, $c = ["seeking", "seeked", "pause", "playing", "error"];
class vb extends L.EventTarget {
  /**
   * Represents an PlaybackWatcher object.
   *
   * @class
   * @param {Object} options an object that includes the tech and settings
   */
  constructor(e) {
    super(), this.playlistController_ = e.playlistController, this.tech_ = e.tech, this.seekable = e.seekable, this.allowSeeksWithinUnsafeLiveWindow = e.allowSeeksWithinUnsafeLiveWindow, this.liveRangeSafeTimeDelta = e.liveRangeSafeTimeDelta, this.media = e.media, this.playedRanges_ = [], this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = ot("PlaybackWatcher"), this.logger_("initialize");
    const t = () => this.monitorCurrentTime_(), s = () => this.monitorCurrentTime_(), r = () => this.techWaiting_(), n = () => this.resetTimeUpdate_(), a = this.playlistController_, o = ["main", "subtitle", "audio"], l = {};
    o.forEach((m) => {
      l[m] = {
        reset: () => this.resetSegmentDownloads_(m),
        updateend: () => this.checkSegmentDownloads_(m)
      }, a[`${m}SegmentLoader_`].on("appendsdone", l[m].updateend), a[`${m}SegmentLoader_`].on("playlistupdate", l[m].reset), this.tech_.on(["seeked", "seeking"], l[m].reset);
    });
    const h = (m) => {
      ["main", "audio"].forEach((_) => {
        a[`${_}SegmentLoader_`][m]("appended", this.seekingAppendCheck_);
      });
    };
    this.seekingAppendCheck_ = () => {
      this.fixesBadSeeks_() && (this.consecutiveUpdates = 0, this.lastRecordedTime = this.tech_.currentTime(), h("off"));
    }, this.clearSeekingAppendCheck_ = () => h("off"), this.watchForBadSeeking_ = () => {
      this.clearSeekingAppendCheck_(), h("on");
    }, this.tech_.on("seeked", this.clearSeekingAppendCheck_), this.tech_.on("seeking", this.watchForBadSeeking_), this.tech_.on("waiting", r), this.tech_.on($c, n), this.tech_.on("canplay", s), this.tech_.one("play", t), this.dispose = () => {
      this.clearSeekingAppendCheck_(), this.logger_("dispose"), this.tech_.off("waiting", r), this.tech_.off($c, n), this.tech_.off("canplay", s), this.tech_.off("play", t), this.tech_.off("seeking", this.watchForBadSeeking_), this.tech_.off("seeked", this.clearSeekingAppendCheck_), o.forEach((m) => {
        a[`${m}SegmentLoader_`].off("appendsdone", l[m].updateend), a[`${m}SegmentLoader_`].off("playlistupdate", l[m].reset), this.tech_.off(["seeked", "seeking"], l[m].reset);
      }), this.checkCurrentTimeTimeout_ && S.clearTimeout(this.checkCurrentTimeTimeout_), this.resetTimeUpdate_();
    };
  }
  /**
   * Periodically check current time to see if playback stopped
   *
   * @private
   */
  monitorCurrentTime_() {
    this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && S.clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = S.setTimeout(this.monitorCurrentTime_.bind(this), 250);
  }
  /**
   * Reset stalled download stats for a specific type of loader
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#playlistupdate
   * @listens Tech#seeking
   * @listens Tech#seeked
   */
  resetSegmentDownloads_(e) {
    const t = this.playlistController_[`${e}SegmentLoader_`];
    this[`${e}StalledDownloads_`] > 0 && this.logger_(`resetting possible stalled download count for ${e} loader`), this[`${e}StalledDownloads_`] = 0, this[`${e}Buffered_`] = t.buffered_();
  }
  /**
   * Checks on every segment `appendsdone` to see
   * if segment appends are making progress. If they are not
   * and we are still downloading bytes. We exclude the playlist.
   *
   * @param {string} type
   *        The segment loader type to check.
   *
   * @listens SegmentLoader#appendsdone
   */
  checkSegmentDownloads_(e) {
    const t = this.playlistController_, s = t[`${e}SegmentLoader_`], r = s.buffered_(), n = av(this[`${e}Buffered_`], r);
    if (this[`${e}Buffered_`] = r, n) {
      const a = {
        bufferedRanges: r
      };
      t.trigger({
        type: "bufferedrangeschanged",
        metadata: a
      }), this.resetSegmentDownloads_(e);
      return;
    }
    this[`${e}StalledDownloads_`]++, this.logger_(`found #${this[`${e}StalledDownloads_`]} ${e} appends that did not increase buffer (possible stalled download)`, {
      playlistId: s.playlist_ && s.playlist_.id,
      buffered: di(r)
    }), !(this[`${e}StalledDownloads_`] < 10) && (this.logger_(`${e} loader stalled download exclusion`), this.resetSegmentDownloads_(e), this.tech_.trigger({
      type: "usage",
      name: `vhs-${e}-download-exclusion`
    }), e !== "subtitle" && t.excludePlaylist({
      error: {
        message: `Excessive ${e} segment downloading detected.`
      },
      playlistExclusionDuration: 1 / 0
    }));
  }
  /**
   * The purpose of this function is to emulate the "waiting" event on
   * browsers that do not emit it when they are waiting for more
   * data to continue playback
   *
   * @private
   */
  checkCurrentTime_() {
    if (this.tech_.paused() || this.tech_.seeking())
      return;
    const e = this.tech_.currentTime(), t = this.tech_.buffered();
    if (this.lastRecordedTime === e && (!t.length || e + Tt >= t.end(t.length - 1)))
      return this.techWaiting_();
    if (this.consecutiveUpdates >= 5 && e === this.lastRecordedTime)
      this.consecutiveUpdates++, this.waiting_();
    else if (e === this.lastRecordedTime)
      this.consecutiveUpdates++;
    else {
      this.playedRanges_.push(ke([this.lastRecordedTime, e]));
      const s = {
        playedRanges: this.playedRanges_
      };
      this.playlistController_.trigger({
        type: "playedrangeschanged",
        metadata: s
      }), this.consecutiveUpdates = 0, this.lastRecordedTime = e;
    }
  }
  /**
   * Resets the 'timeupdate' mechanism designed to detect that we are stalled
   *
   * @private
   */
  resetTimeUpdate_() {
    this.consecutiveUpdates = 0;
  }
  /**
   * Fixes situations where there's a bad seek
   *
   * @return {boolean} whether an action was taken to fix the seek
   * @private
   */
  fixesBadSeeks_() {
    if (!this.tech_.seeking())
      return !1;
    const t = this.seekable(), s = this.tech_.currentTime(), r = this.afterSeekableWindow_(t, s, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
    let n;
    if (r && (n = t.end(t.length - 1)), this.beforeSeekableWindow_(t, s)) {
      const A = t.start(0);
      n = A + // if the playlist is too short and the seekable range is an exact time (can
      // happen in live with a 3 segment playlist), then don't use a time delta
      (A === t.end(0) ? 0 : Tt);
    }
    if (typeof n < "u")
      return this.logger_(`Trying to seek outside of seekable at time ${s} with seekable range ${df(t)}. Seeking to ${n}.`), this.tech_.setCurrentTime(n), !0;
    const a = this.playlistController_.sourceUpdater_, o = this.tech_.buffered(), l = a.audioBuffer ? a.audioBuffered() : null, h = a.videoBuffer ? a.videoBuffered() : null, m = this.media(), _ = m.partTargetDuration ? m.partTargetDuration : (m.targetDuration - yt) * 2, v = [l, h];
    for (let A = 0; A < v.length; A++) {
      if (!v[A])
        continue;
      if (ou(v[A], s) < _)
        return !1;
    }
    const C = Br(o, s);
    return C.length === 0 ? !1 : (n = C.start(0) + Tt, this.logger_(`Buffered region starts (${C.start(0)})  just beyond seek point (${s}). Seeking to ${n}.`), this.tech_.setCurrentTime(n), !0);
  }
  /**
   * Handler for situations when we determine the player is waiting.
   *
   * @private
   */
  waiting_() {
    if (this.techWaiting_())
      return;
    const e = this.tech_.currentTime(), t = this.tech_.buffered(), s = Li(t, e);
    if (s.length && e + 3 <= s.end(0)) {
      this.resetTimeUpdate_(), this.tech_.setCurrentTime(e), this.logger_(`Stopped at ${e} while inside a buffered region [${s.start(0)} -> ${s.end(0)}]. Attempting to resume playback by seeking to the current time.`), this.tech_.trigger({
        type: "usage",
        name: "vhs-unknown-waiting"
      });
      return;
    }
  }
  /**
   * Handler for situations when the tech fires a `waiting` event
   *
   * @return {boolean}
   *         True if an action (or none) was needed to correct the waiting. False if no
   *         checks passed
   * @private
   */
  techWaiting_() {
    const e = this.seekable(), t = this.tech_.currentTime();
    if (this.tech_.seeking())
      return !0;
    if (this.beforeSeekableWindow_(e, t)) {
      const o = e.end(e.length - 1);
      return this.logger_(`Fell out of live window at time ${t}. Seeking to live point (seekable end) ${o}`), this.resetTimeUpdate_(), this.tech_.setCurrentTime(o), this.tech_.trigger({
        type: "usage",
        name: "vhs-live-resync"
      }), !0;
    }
    const s = this.tech_.vhs.playlistController_.sourceUpdater_, r = this.tech_.buffered();
    if (this.videoUnderflow_({
      audioBuffered: s.audioBuffered(),
      videoBuffered: s.videoBuffered(),
      currentTime: t
    }))
      return this.resetTimeUpdate_(), this.tech_.setCurrentTime(t), this.tech_.trigger({
        type: "usage",
        name: "vhs-video-underflow"
      }), !0;
    const a = Br(r, t);
    return a.length > 0 ? (this.logger_(`Stopped at ${t} and seeking to ${a.start(0)}`), this.resetTimeUpdate_(), this.skipTheGap_(t), !0) : !1;
  }
  afterSeekableWindow_(e, t, s, r = !1) {
    if (!e.length)
      return !1;
    let n = e.end(e.length - 1) + Tt;
    const a = !s.endList, o = typeof s.partTargetDuration == "number";
    return a && (o || r) && (n = e.end(e.length - 1) + s.targetDuration * 3), t > n;
  }
  beforeSeekableWindow_(e, t) {
    return !!(e.length && // can't fall before 0 and 0 seekable start identifies VOD stream
    e.start(0) > 0 && t < e.start(0) - this.liveRangeSafeTimeDelta);
  }
  videoUnderflow_({
    videoBuffered: e,
    audioBuffered: t,
    currentTime: s
  }) {
    if (!e)
      return;
    let r;
    if (e.length && t.length) {
      const n = Li(e, s - 3), a = Li(e, s), o = Li(t, s);
      o.length && !a.length && n.length && (r = {
        start: n.end(0),
        end: o.end(0)
      });
    } else
      Br(e, s).length || (r = this.gapFromVideoUnderflow_(e, s));
    return r ? (this.logger_(`Encountered a gap in video from ${r.start} to ${r.end}. Seeking to current time ${s}`), !0) : !1;
  }
  /**
   * Timer callback. If playback still has not proceeded, then we seek
   * to the start of the next buffered region.
   *
   * @private
   */
  skipTheGap_(e) {
    const t = this.tech_.buffered(), s = this.tech_.currentTime(), r = Br(t, s);
    if (this.resetTimeUpdate_(), r.length === 0 || s !== e)
      return;
    this.logger_("skipTheGap_:", "currentTime:", s, "scheduled currentTime:", e, "nextRange start:", r.start(0)), this.tech_.setCurrentTime(r.start(0) + yt);
    const n = {
      gapInfo: {
        from: s,
        to: r.start(0)
      }
    };
    this.playlistController_.trigger({
      type: "gapjumped",
      metadata: n
    }), this.tech_.trigger({
      type: "usage",
      name: "vhs-gap-skip"
    });
  }
  gapFromVideoUnderflow_(e, t) {
    const s = sv(e);
    for (let r = 0; r < s.length; r++) {
      const n = s.start(r), a = s.end(r);
      if (t - n < 4 && t - n > 2)
        return {
          start: n,
          end: a
        };
    }
    return null;
  }
}
const bb = {
  errorInterval: 30,
  getSource(i) {
    const t = this.tech({
      IWillNotUseThisInPlugins: !0
    }).currentSource_ || this.currentSource();
    return i(t);
  }
}, ep = function(i, e) {
  let t = 0, s = 0;
  const r = te(bb, e);
  i.ready(() => {
    i.trigger({
      type: "usage",
      name: "vhs-error-reload-initialized"
    });
  });
  const n = function() {
    s && i.currentTime(s);
  }, a = function(m) {
    m != null && (s = i.duration() !== 1 / 0 && i.currentTime() || 0, i.one("loadedmetadata", n), i.src(m), i.trigger({
      type: "usage",
      name: "vhs-error-reload"
    }), i.play());
  }, o = function() {
    if (Date.now() - t < r.errorInterval * 1e3) {
      i.trigger({
        type: "usage",
        name: "vhs-error-reload-canceled"
      });
      return;
    }
    if (!r.getSource || typeof r.getSource != "function") {
      L.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
      return;
    }
    return t = Date.now(), r.getSource.call(i, a);
  }, l = function() {
    i.off("loadedmetadata", n), i.off("error", o), i.off("dispose", l);
  }, h = function(m) {
    l(), ep(i, m);
  };
  i.on("error", o), i.on("dispose", l), i.reloadSourceOnError = h;
}, xb = function(i) {
  ep(this, i);
};
var tp = "3.15.0", Sb = "7.0.3", Eb = "1.3.1", Cb = "7.2.0", Ab = "4.0.2";
const me = {
  PlaylistLoader: Ri,
  Playlist: We,
  utils: kv,
  STANDARD_PLAYLIST_SELECTOR: wc,
  INITIAL_PLAYLIST_SELECTOR: y2,
  lastBandwidthSelector: wc,
  movingAverageBandwidthSelector: g2,
  comparePlaylistBandwidth: hu,
  comparePlaylistResolution: m2,
  xhr: wf()
};
Object.keys(Ae).forEach((i) => {
  Object.defineProperty(me, i, {
    get() {
      return L.log.warn(`using Vhs.${i} is UNSAFE be sure you know what you are doing`), Ae[i];
    },
    set(e) {
      if (L.log.warn(`using Vhs.${i} is UNSAFE be sure you know what you are doing`), typeof e != "number" || e < 0) {
        L.log.warn(`value of Vhs.${i} must be greater than or equal to 0`);
        return;
      }
      Ae[i] = e;
    }
  });
});
const ip = "videojs-vhs", sp = function(i, e) {
  const t = e.media();
  let s = -1;
  for (let r = 0; r < i.length; r++)
    if (i[r].id === t.id) {
      s = r;
      break;
    }
  i.selectedIndex_ = s, i.trigger({
    selectedIndex: s,
    type: "change"
  });
}, Db = function(i, e) {
  e.representations().forEach((t) => {
    i.addQualityLevel(t);
  }), sp(i, e.playlists);
};
me.canPlaySource = function() {
  return L.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
const wb = (i, e, t) => {
  if (!i)
    return i;
  let s = {};
  e && e.attributes && e.attributes.CODECS && (s = pn(mt(e.attributes.CODECS))), t && t.attributes && t.attributes.CODECS && (s.audio = t.attributes.CODECS);
  const r = ji(s.video), n = ji(s.audio), a = {};
  for (const o in i)
    a[o] = {}, n && (a[o].audioContentType = n), r && (a[o].videoContentType = r), e.contentProtection && e.contentProtection[o] && e.contentProtection[o].pssh && (a[o].pssh = e.contentProtection[o].pssh), typeof i[o] == "string" && (a[o].url = i[o]);
  return te(i, a);
}, Ib = (i, e) => i.reduce((t, s) => {
  if (!s.contentProtection)
    return t;
  const r = e.reduce((n, a) => {
    const o = s.contentProtection[a];
    return o && o.pssh && (n[a] = {
      pssh: o.pssh
    }), n;
  }, {});
  return Object.keys(r).length && t.push(r), t;
}, []), kb = ({
  player: i,
  sourceKeySystems: e,
  audioMedia: t,
  mainPlaylists: s
}) => {
  if (!i.eme.initializeMediaKeys)
    return Promise.resolve();
  const r = t ? s.concat([t]) : s, n = Ib(r, Object.keys(e)), a = [], o = [];
  return n.forEach((l) => {
    o.push(new Promise((h, m) => {
      i.tech_.one("keysessioncreated", h);
    })), a.push(new Promise((h, m) => {
      i.eme.initializeMediaKeys({
        keySystems: l
      }, (_) => {
        if (_) {
          m(_);
          return;
        }
        h();
      });
    }));
  }), Promise.race([
    // If a session was previously created, these will all finish resolving without
    // creating a new session, otherwise it will take until the end of all license
    // requests, which is why the key session check is used (to make setup much faster).
    Promise.all(a),
    // Once a single session is created, the browser knows DRM will be used.
    Promise.race(o)
  ]);
}, Pb = ({
  player: i,
  sourceKeySystems: e,
  media: t,
  audioMedia: s
}) => {
  const r = wb(e, t, s);
  return r ? (i.currentSource().keySystems = r, r && !i.eme ? (L.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin"), !1) : !0) : !1;
}, rp = () => {
  if (!S.localStorage)
    return null;
  const i = S.localStorage.getItem(ip);
  if (!i)
    return null;
  try {
    return JSON.parse(i);
  } catch {
    return null;
  }
}, Ob = (i) => {
  if (!S.localStorage)
    return !1;
  let e = rp();
  e = e ? te(e, i) : i;
  try {
    S.localStorage.setItem(ip, JSON.stringify(e));
  } catch {
    return !1;
  }
  return e;
}, Lb = (i) => i.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0 ? JSON.parse(i.substring(i.indexOf(",") + 1)) : i, np = (i, e) => {
  i._requestCallbackSet || (i._requestCallbackSet = /* @__PURE__ */ new Set()), i._requestCallbackSet.add(e);
}, ap = (i, e) => {
  i._responseCallbackSet || (i._responseCallbackSet = /* @__PURE__ */ new Set()), i._responseCallbackSet.add(e);
}, op = (i, e) => {
  i._requestCallbackSet && (i._requestCallbackSet.delete(e), i._requestCallbackSet.size || delete i._requestCallbackSet);
}, up = (i, e) => {
  i._responseCallbackSet && (i._responseCallbackSet.delete(e), i._responseCallbackSet.size || delete i._responseCallbackSet);
};
me.supportsNativeHls = function() {
  if (!U || !U.createElement)
    return !1;
  const i = U.createElement("video");
  return L.getTech("Html5").isSupported() ? [
    // Apple santioned
    "application/vnd.apple.mpegurl",
    // Apple sanctioned for backwards compatibility
    "audio/mpegurl",
    // Very common
    "audio/x-mpegurl",
    // Very common
    "application/x-mpegurl",
    // Included for completeness
    "video/x-mpegurl",
    "video/mpegurl",
    "application/mpegurl"
  ].some(function(t) {
    return /maybe|probably/i.test(i.canPlayType(t));
  }) : !1;
}();
me.supportsNativeDash = function() {
  return !U || !U.createElement || !L.getTech("Html5").isSupported() ? !1 : /maybe|probably/i.test(U.createElement("video").canPlayType("application/dash+xml"));
}();
me.supportsTypeNatively = (i) => i === "hls" ? me.supportsNativeHls : i === "dash" ? me.supportsNativeDash : !1;
me.isSupported = function() {
  return L.log.warn("VHS is no longer a tech. Please remove it from your player's techOrder.");
};
me.xhr.onRequest = function(i) {
  np(me.xhr, i);
};
me.xhr.onResponse = function(i) {
  ap(me.xhr, i);
};
me.xhr.offRequest = function(i) {
  op(me.xhr, i);
};
me.xhr.offResponse = function(i) {
  up(me.xhr, i);
};
const Rb = L.getComponent("Component");
class lp extends Rb {
  constructor(e, t, s) {
    if (super(t, s.vhs), typeof s.initialBandwidth == "number" && (this.options_.bandwidth = s.initialBandwidth), this.logger_ = ot("VhsHandler"), t.options_ && t.options_.playerId) {
      const r = L.getPlayer(t.options_.playerId);
      this.player_ = r;
    }
    if (this.tech_ = t, this.source_ = e, this.stats = {}, this.ignoreNextSeekingEvent_ = !1, this.setOptions_(), this.options_.overrideNative && t.overrideNativeAudioTracks && t.overrideNativeVideoTracks)
      t.overrideNativeAudioTracks(!0), t.overrideNativeVideoTracks(!0);
    else if (this.options_.overrideNative && (t.featuresNativeVideoTracks || t.featuresNativeAudioTracks))
      throw new Error("Overriding native VHS requires emulated tracks. See https://git.io/vMpjB");
    this.on(U, ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"], (r) => {
      const n = U.fullscreenElement || U.webkitFullscreenElement || U.mozFullScreenElement || U.msFullscreenElement;
      n && n.contains(this.tech_.el()) ? this.playlistController_.fastQualityChange_() : this.playlistController_.checkABR_();
    }), this.on(this.tech_, "seeking", function() {
      if (this.ignoreNextSeekingEvent_) {
        this.ignoreNextSeekingEvent_ = !1;
        return;
      }
      this.setCurrentTime(this.tech_.currentTime());
    }), this.on(this.tech_, "error", function() {
      this.tech_.error() && this.playlistController_ && this.playlistController_.pauseLoading();
    }), this.on(this.tech_, "play", this.play);
  }
  /**
   * Set VHS options based on options from configuration, as well as partial
   * options to be passed at a later time.
   *
   * @param {Object} options A partial chunk of config options
   */
  setOptions_(e = {}) {
    if (this.options_ = te(this.options_, e), this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions !== !1, this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || !1, this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage < "u" ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || !1, this.options_.useForcedSubtitles = this.options_.useForcedSubtitles || !1, this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi || !1, this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, this.options_.llhls = this.options_.llhls !== !1, this.options_.bufferBasedABR = this.options_.bufferBasedABR || !1, typeof this.options_.playlistExclusionDuration != "number" && (this.options_.playlistExclusionDuration = 60), typeof this.options_.bandwidth != "number" && this.options_.useBandwidthFromLocalStorage) {
      const s = rp();
      s && s.bandwidth && (this.options_.bandwidth = s.bandwidth, this.tech_.trigger({
        type: "usage",
        name: "vhs-bandwidth-from-local-storage"
      })), s && s.throughput && (this.options_.throughput = s.throughput, this.tech_.trigger({
        type: "usage",
        name: "vhs-throughput-from-local-storage"
      }));
    }
    typeof this.options_.bandwidth != "number" && (this.options_.bandwidth = Ae.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === Ae.INITIAL_BANDWIDTH, ["withCredentials", "useDevicePixelRatio", "customPixelRatio", "limitRenditionByPlayerDimensions", "bandwidth", "customTagParsers", "customTagMappers", "cacheEncryptionKeys", "playlistSelector", "initialPlaylistSelector", "bufferBasedABR", "liveRangeSafeTimeDelta", "llhls", "useForcedSubtitles", "useNetworkInformationApi", "useDtsForTimestampOffset", "exactManifestTimings", "leastPixelDiffSelector"].forEach((s) => {
      typeof this.source_[s] < "u" && (this.options_[s] = this.source_[s]);
    }), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions, this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
    const t = this.options_.customPixelRatio;
    typeof t == "number" && t >= 0 && (this.customPixelRatio = t);
  }
  // alias for public method to set options
  setOptions(e = {}) {
    this.setOptions_(e);
  }
  /**
   * called when player.src gets called, handle a new source
   *
   * @param {Object} src the source object to handle
   */
  src(e, t) {
    if (!e)
      return;
    this.setOptions_(), this.options_.src = Lb(this.source_.src), this.options_.tech = this.tech_, this.options_.externVhs = me, this.options_.sourceType = ed(t), this.options_.seekTo = (n) => {
      this.tech_.setCurrentTime(n);
    }, this.options_.player_ = this.player_, this.playlistController_ = new gb(this.options_);
    const s = te({
      liveRangeSafeTimeDelta: Tt
    }, this.options_, {
      seekable: () => this.seekable(),
      media: () => this.playlistController_.media(),
      playlistController: this.playlistController_
    });
    this.playbackWatcher_ = new vb(s), this.attachStreamingEventListeners_(), this.playlistController_.on("error", () => {
      const n = L.players[this.tech_.options_.playerId];
      let a = this.playlistController_.error;
      typeof a == "object" && !a.code ? a.code = 3 : typeof a == "string" && (a = {
        message: a,
        code: 3
      }), n.error(a);
    });
    const r = this.options_.bufferBasedABR ? me.movingAverageBandwidthSelector(0.55) : me.STANDARD_PLAYLIST_SELECTOR;
    this.playlistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : r.bind(this), this.playlistController_.selectInitialPlaylist = me.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.playlistController_.mainPlaylistLoader_, this.mediaSource = this.playlistController_.mediaSource, Object.defineProperties(this, {
      selectPlaylist: {
        get() {
          return this.playlistController_.selectPlaylist;
        },
        set(n) {
          this.playlistController_.selectPlaylist = n.bind(this);
        }
      },
      throughput: {
        get() {
          return this.playlistController_.mainSegmentLoader_.throughput.rate;
        },
        set(n) {
          this.playlistController_.mainSegmentLoader_.throughput.rate = n, this.playlistController_.mainSegmentLoader_.throughput.count = 1;
        }
      },
      bandwidth: {
        get() {
          let n = this.playlistController_.mainSegmentLoader_.bandwidth;
          const a = S.navigator.connection || S.navigator.mozConnection || S.navigator.webkitConnection, o = 1e7;
          if (this.options_.useNetworkInformationApi && a) {
            const l = a.downlink * 1e3 * 1e3;
            l >= o && n >= o ? n = Math.max(n, l) : n = l;
          }
          return n;
        },
        set(n) {
          this.playlistController_.mainSegmentLoader_.bandwidth = n, this.playlistController_.mainSegmentLoader_.throughput = {
            rate: 0,
            count: 0
          };
        }
      },
      /**
       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
       * the entire process after that - decryption, transmuxing, and appending - provided
       * by `throughput`.
       *
       * Since the two process are serial, the overall system bandwidth is given by:
       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
       */
      systemBandwidth: {
        get() {
          const n = 1 / (this.bandwidth || 1);
          let a;
          return this.throughput > 0 ? a = 1 / this.throughput : a = 0, Math.floor(1 / (n + a));
        },
        set() {
          L.log.error('The "systemBandwidth" property is read-only');
        }
      }
    }), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
      bandwidth: {
        get: () => this.bandwidth || 0,
        enumerable: !0
      },
      mediaRequests: {
        get: () => this.playlistController_.mediaRequests_() || 0,
        enumerable: !0
      },
      mediaRequestsAborted: {
        get: () => this.playlistController_.mediaRequestsAborted_() || 0,
        enumerable: !0
      },
      mediaRequestsTimedout: {
        get: () => this.playlistController_.mediaRequestsTimedout_() || 0,
        enumerable: !0
      },
      mediaRequestsErrored: {
        get: () => this.playlistController_.mediaRequestsErrored_() || 0,
        enumerable: !0
      },
      mediaTransferDuration: {
        get: () => this.playlistController_.mediaTransferDuration_() || 0,
        enumerable: !0
      },
      mediaBytesTransferred: {
        get: () => this.playlistController_.mediaBytesTransferred_() || 0,
        enumerable: !0
      },
      mediaSecondsLoaded: {
        get: () => this.playlistController_.mediaSecondsLoaded_() || 0,
        enumerable: !0
      },
      mediaAppends: {
        get: () => this.playlistController_.mediaAppends_() || 0,
        enumerable: !0
      },
      mainAppendsToLoadedData: {
        get: () => this.playlistController_.mainAppendsToLoadedData_() || 0,
        enumerable: !0
      },
      audioAppendsToLoadedData: {
        get: () => this.playlistController_.audioAppendsToLoadedData_() || 0,
        enumerable: !0
      },
      appendsToLoadedData: {
        get: () => this.playlistController_.appendsToLoadedData_() || 0,
        enumerable: !0
      },
      timeToLoadedData: {
        get: () => this.playlistController_.timeToLoadedData_() || 0,
        enumerable: !0
      },
      buffered: {
        get: () => di(this.tech_.buffered()),
        enumerable: !0
      },
      currentTime: {
        get: () => this.tech_.currentTime(),
        enumerable: !0
      },
      currentSource: {
        get: () => this.tech_.currentSource_,
        enumerable: !0
      },
      currentTech: {
        get: () => this.tech_.name_,
        enumerable: !0
      },
      duration: {
        get: () => this.tech_.duration(),
        enumerable: !0
      },
      main: {
        get: () => this.playlists.main,
        enumerable: !0
      },
      playerDimensions: {
        get: () => this.tech_.currentDimensions(),
        enumerable: !0
      },
      seekable: {
        get: () => di(this.tech_.seekable()),
        enumerable: !0
      },
      timestamp: {
        get: () => Date.now(),
        enumerable: !0
      },
      videoPlaybackQuality: {
        get: () => this.tech_.getVideoPlaybackQuality(),
        enumerable: !0
      }
    }), this.tech_.one("canplay", this.playlistController_.setupFirstPlay.bind(this.playlistController_)), this.tech_.on("bandwidthupdate", () => {
      this.options_.useBandwidthFromLocalStorage && Ob({
        bandwidth: this.bandwidth,
        throughput: Math.round(this.throughput)
      });
    }), this.playlistController_.on("selectedinitialmedia", () => {
      Tb(this);
    }), this.playlistController_.sourceUpdater_.on("createdsourcebuffers", () => {
      this.setupEme_();
    }), this.on(this.playlistController_, "progress", function() {
      this.tech_.trigger("progress");
    }), this.on(this.playlistController_, "firstplay", function() {
      this.ignoreNextSeekingEvent_ = !0;
    }), this.setupQualityLevels_(), this.tech_.el() && (this.mediaSourceUrl_ = S.URL.createObjectURL(this.playlistController_.mediaSource), (L.browser.IS_ANY_SAFARI || L.browser.IS_IOS) && this.options_.overrideNative && this.options_.sourceType === "hls" && typeof this.tech_.addSourceElement == "function" ? (this.tech_.addSourceElement(this.mediaSourceUrl_), this.tech_.addSourceElement(this.source_.src)) : this.tech_.src(this.mediaSourceUrl_));
  }
  createKeySessions_() {
    const e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader;
    this.logger_("waiting for EME key session creation"), kb({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      audioMedia: e && e.media(),
      mainPlaylists: this.playlists.main.playlists
    }).then(() => {
      this.logger_("created EME key session"), this.playlistController_.sourceUpdater_.initializedEme();
    }).catch((t) => {
      this.logger_("error while creating EME key session", t), this.player_.error({
        message: "Failed to initialize media keys for EME",
        code: 3
      });
    });
  }
  handleWaitingForKey_() {
    this.logger_("waitingforkey fired, attempting to create any new key sessions"), this.createKeySessions_();
  }
  /**
   * If necessary and EME is available, sets up EME options and waits for key session
   * creation.
   *
   * This function also updates the source updater so taht it can be used, as for some
   * browsers, EME must be configured before content is appended (if appending unencrypted
   * content before encrypted content).
   */
  setupEme_() {
    const e = this.playlistController_.mediaTypes_.AUDIO.activePlaylistLoader, t = Pb({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      media: this.playlists.media(),
      audioMedia: e && e.media()
    });
    if (this.player_.tech_.on("keystatuschange", (s) => {
      this.playlistController_.updatePlaylistByKeyStatus(s.keyId, s.status);
    }), this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this), this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_), !t) {
      this.playlistController_.sourceUpdater_.initializedEme();
      return;
    }
    this.createKeySessions_();
  }
  /**
   * Initializes the quality levels and sets listeners to update them.
   *
   * @method setupQualityLevels_
   * @private
   */
  setupQualityLevels_() {
    const e = L.players[this.tech_.options_.playerId];
    !e || !e.qualityLevels || this.qualityLevels_ || (this.qualityLevels_ = e.qualityLevels(), this.playlistController_.on("selectedinitialmedia", () => {
      Db(this.qualityLevels_, this);
    }), this.playlists.on("mediachange", () => {
      sp(this.qualityLevels_, this.playlists);
    }));
  }
  /**
   * return the version
   */
  static version() {
    return {
      "@videojs/http-streaming": tp,
      "mux.js": Sb,
      "mpd-parser": Eb,
      "m3u8-parser": Cb,
      "aes-decrypter": Ab
    };
  }
  /**
   * return the version
   */
  version() {
    return this.constructor.version();
  }
  canChangeType() {
    return Yf.canChangeType();
  }
  /**
   * Begin playing the video.
   */
  play() {
    this.playlistController_.play();
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  setCurrentTime(e) {
    this.playlistController_.setCurrentTime(e);
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  duration() {
    return this.playlistController_.duration();
  }
  /**
   * a wrapper around the function in PlaylistController
   */
  seekable() {
    return this.playlistController_.seekable();
  }
  /**
   * Abort all outstanding work and cleanup.
   */
  dispose() {
    this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.playlistController_ && this.playlistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.tech_ && this.tech_.vhs && delete this.tech_.vhs, this.mediaSourceUrl_ && S.URL.revokeObjectURL && (S.URL.revokeObjectURL(this.mediaSourceUrl_), this.mediaSourceUrl_ = null), this.tech_ && this.tech_.off("waitingforkey", this.handleWaitingForKey_), super.dispose();
  }
  convertToProgramTime(e, t) {
    return Bv({
      playlist: this.playlistController_.media(),
      time: e,
      callback: t
    });
  }
  // the player must be playing before calling this
  seekToProgramTime(e, t, s = !0, r = 2) {
    return Lf({
      programTime: e,
      playlist: this.playlistController_.media(),
      retryCount: r,
      pauseAfterSeek: s,
      seekTo: this.options_.seekTo,
      tech: this.options_.tech,
      callback: t
    });
  }
  /**
   * Adds the onRequest, onResponse, offRequest and offResponse functions
   * to the VhsHandler xhr Object.
   */
  setupXhrHooks_() {
    this.xhr.onRequest = (e) => {
      np(this.xhr, e);
    }, this.xhr.onResponse = (e) => {
      ap(this.xhr, e);
    }, this.xhr.offRequest = (e) => {
      op(this.xhr, e);
    }, this.xhr.offResponse = (e) => {
      up(this.xhr, e);
    }, this.player_.trigger("xhr-hooks-ready");
  }
  attachStreamingEventListeners_() {
    const e = ["seekablerangeschanged", "bufferedrangeschanged", "contentsteeringloadstart", "contentsteeringloadcomplete", "contentsteeringparsed"], t = ["gapjumped", "playedrangeschanged"];
    e.forEach((s) => {
      this.playlistController_.on(s, (r) => {
        this.player_.trigger(ye({}, r));
      });
    }), t.forEach((s) => {
      this.playbackWatcher_.on(s, (r) => {
        this.player_.trigger(ye({}, r));
      });
    });
  }
}
const _n = {
  name: "videojs-http-streaming",
  VERSION: tp,
  canHandleSource(i, e = {}) {
    const t = te(L.options, e);
    return !t.vhs.experimentalUseMMS && !Ns("avc1.4d400d,mp4a.40.2", !1) ? !1 : _n.canPlayType(i.type, t);
  },
  handleSource(i, e, t = {}) {
    const s = te(L.options, t);
    return e.vhs = new lp(i, e, s), e.vhs.xhr = wf(), e.vhs.setupXhrHooks_(), e.vhs.src(i.src, i.type), e.vhs;
  },
  canPlayType(i, e) {
    const t = ed(i);
    if (!t)
      return "";
    const s = _n.getOverrideNative(e);
    return !me.supportsTypeNatively(t) || s ? "maybe" : "";
  },
  getOverrideNative(i = {}) {
    const {
      vhs: e = {}
    } = i, t = !(L.browser.IS_ANY_SAFARI || L.browser.IS_IOS), {
      overrideNative: s = t
    } = e;
    return s;
  }
}, Nb = () => Ns("avc1.4d400d,mp4a.40.2", !0);
Nb() && L.getTech("Html5").registerSourceHandler(_n, 0);
L.VhsHandler = lp;
L.VhsSourceHandler = _n;
L.Vhs = me;
L.use || L.registerComponent("Vhs", me);
L.options.vhs = L.options.vhs || {};
(!L.getPlugin || !L.getPlugin("reloadSourceOnError")) && L.registerPlugin("reloadSourceOnError", xb);
function Mb(i) {
  const e = document.createElement("link");
  e.rel = "stylesheet", e.href = i, document.head.appendChild(e);
}
function Fe(i, e, t, s) {
  const r = document.createElement(i);
  e.appendChild(r);
  for (let n = 0; n < t.length; n = n + 1)
    r.classList.add(t[n]);
  return s !== void 0 && (r.innerHTML = s), r;
}
const Bb = (i) => new RegExp(i, "i").test(navigator.userAgent);
function Fb(i) {
  const e = Math.floor(i % 3600 / 60), t = Math.floor(i % 60);
  return `${qc(e)}:${qc(t)}`;
}
const qc = (i) => i < 10 ? "0" + i : i, cp = 100;
function Ub(i, e, t) {
  let s = Object.keys(e);
  i.on("play", () => {
    $b(i, s, e, t);
  }), i.on("seeked", () => {
    s = Object.keys(e);
  });
}
function $b(i, e, t, s) {
  let r = setInterval(() => {
    let n = i.currentTime();
    if (n) {
      let a = Math.trunc(n * 1e3);
      for (let o = 0; o < e.length; o = o + 1)
        if (parseInt(e[o]) < a) {
          let l = t[e[o]];
          for (let h = 0; h < l.length; h = h + 1)
            parseInt(e[o]) + l[h].duration > a && qb(
              l[h].x,
              l[h].y,
              parseInt(e[o]),
              parseInt(e[o]) + l[h].duration,
              l[h].object_name,
              l[h].object_duration,
              l[h].saliency_score,
              s,
              i,
              l[h].selected,
              l[h].id
            );
          e.splice(o, 1);
          break;
        }
    }
    (i.paused() || e.length === 0) && clearInterval(r);
  }, cp);
}
function qb(i, e, t, s, r, n, a, o, l, h, m) {
  const _ = document.getElementById(l.id());
  if (_) {
    const v = Fe(
      "div",
      _,
      ["salience_dot_ring"],
      ""
    ), C = Fe("div", v, ["salience_dot"], ""), A = Fe("div", v, ["salience_tooltip"], ""), y = Fe("div", A, ["salience_tooltip_chevron"], ""), D = Fe(
      "div",
      A,
      ["salience_tooltip_title_container"],
      ""
    ), w = Fe("p", D, ["salience_tooltip_title"], r);
    w.title = r;
    const O = Fe(
      "div",
      D,
      [h ? "salience_tooltip_star_selected" : "salience_tooltip_star"],
      ""
    ), P = Fe(
      "div",
      A,
      ["salience_tooltip_display"],
      ""
    );
    Fe(
      "p",
      P,
      ["salience_tooltip_display_label"],
      "Présence"
    ), Fe(
      "p",
      P,
      ["salience_tooltip_display_text"],
      `${n} sec`
    );
    const R = Fe(
      "div",
      A,
      ["salience_tooltip_score"],
      ""
    );
    Fe(
      "p",
      R,
      ["salience_tooltip_score_label"],
      "Saillance"
    ), Fe(
      "p",
      R,
      ["salience_tooltip_score_text"],
      `${a} / 100`
    ), v.style.left = `${i * 100}%`, v.style.top = `${e * 100}%`;
    const I = parseInt(a), B = I >= 76 ? 1 : I >= 51 ? 2 : I >= 26 ? 3 : I >= 0 ? 4 : 0;
    v.classList.add(`salience_color_${B}`), C.classList.add(`salience_color_${B}`), y.classList.add(`salience_color_${B}`), A.classList.add(`salience_color_${B}`), w.classList.add(`salience_color_${B}`), i > 0.7 && (A.style.left = "-192px", A.classList.add("salience_tooltip_left"), y.style.marginLeft = "164px"), e > 0.7 && (A.style.bottom = "-5px", y.style.marginTop = "65px"), C.addEventListener("click", () => {
      if (l.pause(), A.style.display === "flex") {
        A.style.display = "none";
        return;
      }
      A.style.display = "flex";
    }), O.addEventListener("click", () => {
      if (O.classList.contains("salience_tooltip_star")) {
        try {
          o(t, !0, m), O.classList.remove("salience_tooltip_star"), O.classList.add("salience_tooltip_star_selected");
        } catch ($) {
          console.error($);
        }
        return;
      }
      try {
        o(t, !1, m), O.classList.remove("salience_tooltip_star_selected"), O.classList.add("salience_tooltip_star");
      } catch ($) {
        console.error($);
      }
    });
    let H = setInterval(() => {
      let $ = l.currentTime();
      if ($) {
        let X = Math.trunc($ * 1e3);
        (s < X || t > X) && jb(_, v, H);
      }
    }, cp);
  }
}
function jb(i, e, t) {
  i.removeChild(e), clearInterval(t);
}
function Hb(i, e) {
  const t = i.duration() ?? 0, s = i.controlBar.progressControl.seekBar;
  e.forEach(({ label: r, time: n }) => {
    const a = n / 1e3 / t * 100 + "%", o = document.createElement("div");
    o.className = "vjs-chapter", o.style.left = a, o.setAttribute("data-time", n.toString()), o.innerHTML = "<span>" + r + "</span>", s.el().appendChild(o);
  });
}
function Vb() {
  if (document.querySelector(".header-control-bar")) {
    console.error(".header-control-bar already exists");
    return;
  }
  const e = document.querySelector(".video-js");
  Fe("div", e, [
    "header-control-bar",
    "vjs-control-bar"
  ]);
  const t = document.querySelector(".header-control-bar"), s = document.querySelector(".vjs-progress-control");
  t && s && t.appendChild(s);
}
function zb(i) {
  const e = i.duration(), t = `/ ${Fb(e ?? 0)}`, s = document.querySelector(
    ".vjs-control-bar:not(.header-control-bar)"
  );
  Fe(
    "div",
    s,
    ["duration", "vjs-time-control", "vjs-control"],
    t
  );
}
const Gb = "https://vjs.zencdn.net/8.6.1/video-js.css";
function Wb({
  id: i,
  chapters: e,
  saliencyData: t,
  starCallback: s,
  errorCallback: r,
  ...n
}) {
  const a = L(i, {
    controls: !0,
    preload: "auto",
    debug: !0,
    disablePictureInPicture: !0,
    controlBar: {
      skipButtons: {
        forward: 10,
        backward: 10
      }
    },
    ...n
  });
  a.on("error", (o) => {
    console.error(o), o.stopImmediatePropagation();
    const l = a.error();
    r(i, { code: l == null ? void 0 : l.code, status: l == null ? void 0 : l.status, message: l == null ? void 0 : l.message, metadata: l == null ? void 0 : l.metadata });
  }), a.on("loadedmetadata", () => {
    Hb(a, e), Ub(a, t, s), Vb(), zb(a);
  }), Bb("iPhone") && a.controlBar.fullscreenToggle.hide();
}
window.initPlayer = Wb;
document.addEventListener("DOMContentLoaded", () => {
  window.HELP_IMPROVE_VIDEOJS = !1, Mb(Gb);
});
export {
  Wb as default
};
